var th = Object.defineProperty;
var sh = (r, e, t) => e in r ? th(r, e, { enumerable: !0, configurable: !0, writable: !0, value: t }) : r[e] = t;
var h = (r, e, t) => (sh(r, typeof e != "symbol" ? e + "" : e, t), t), Ro = (r, e, t) => {
  if (!e.has(r))
    throw TypeError("Cannot " + t);
};
var c = (r, e, t) => (Ro(r, e, "read from private field"), t ? t.call(r) : e.get(r)), b = (r, e, t) => {
  if (e.has(r))
    throw TypeError("Cannot add the same private member more than once");
  e instanceof WeakSet ? e.add(r) : e.set(r, t);
}, P = (r, e, t, s) => (Ro(r, e, "write to private field"), s ? s.call(r, t) : e.set(r, t), t);
var ca = (r, e, t) => (Ro(r, e, "access private method"), t);
import { validate as eu, v4 as so } from "uuid";
import Pa from "axios";
import Sc from "bowser";
import * as O from "sdp-transform";
import { WebTracerProvider as rh, StackContextManager as ih } from "@opentelemetry/sdk-trace-web";
import { OTLPTraceExporter as nh } from "@opentelemetry/exporter-trace-otlp-http";
import { BatchSpanProcessor as ah } from "@opentelemetry/sdk-trace-base";
import { ZoneContextManager as oh } from "@opentelemetry/context-zone-peer-dep";
import da, { ROOT_CONTEXT as bo, propagation as ch } from "@opentelemetry/api";
import { Resource as dh } from "@opentelemetry/resources";
import { MessageType as w, PbLong as on, typeofJsonValue as lh } from "@protobuf-ts/runtime";
import { AwaitQueue as uh } from "awaitqueue";
import { io as ph } from "socket.io-client";
import * as Ca from "worker-timers";
var j;
(function(r) {
  r[r.MAJOR_EVENT = 0] = "MAJOR_EVENT", r[r.MINOR_EVENT = 1] = "MINOR_EVENT";
})(j || (j = {}));
var k;
(function(r) {
  r.PRECALL_TEST_BEGIN = "precall_begin", r.PRECALL_TEST_COMPLETE = "precall_end", r.CALL_JOIN_BEGIN = "call_join", r.NET_QUALITY_TEST_BEGIN = "net_quality_test_begin", r.NET_QUALITY_TEST_END = "net_quality_test_end", r.WEBSOCKET_CONNECTED = "websocket_connected", r.TRANSPORT_CONNECTED = "transport_connected", r.AUDIO_ON = "audio_on", r.AUDIO_OFF = "audio_off", r.VIDEO_ON = "video_on", r.VIDEO_OFF = "video_off", r.PARTICIPANT_ROLE = "participant_role", r.PING_STAT = "ping_stat", r.DISCONNECT = "disconnect", r.RECONNECT_ATTEMPT = "reconnect_attempt", r.SCREENSHARE_START_REQUESTED = "screenshare_start_requested", r.SCREENSHARE_STARTED = "screenshare_started", r.SCREENSHARE_STOPPED = "screenshare_stopped", r.TAB_CHANGE = "tab_change", r.BROWSER_BACKGROUNDED = "browser_backgrounded", r.BROWSER_FOREGROUNDED = "browser_foregrounded", r.DOMINANT_SPEAKER = "dominant_speaker", r.AUDIO_DEVICES_UPDATES = "audio_devices_updates", r.VIDEO_DEVICES_UPDATES = "video_devices_updates", r.SPEAKER_DEVICES_UPDATES = "speaker_devices_updates", r.SELECTED_MICROHPONE_UPDATE = "selected_microphone_update", r.SELECTED_CAMERA_UPDATE = "selected_camera_update", r.SELECTED_SPEAKER_UPDATE = "selected_speaker_update", r.MEDIA_PERMISSION = "camera_permission", r.LEGACY_SWITCH = "legacy_switch", r.AUDIO_PLAY_FAILED = "audio_play_failed", r.VIDEO_PLAY_FAILED = "video_play_failed", r.AUDIO_TRACK_MUTED = "audio_track_muted", r.VIDEO_TRACK_MUTED = "video_track_muted", r.IVS_PLAYER_REBUFFERING = "ivs_player_rebuffering", r.IVS_PLAYER_AUDIO_BLOCKED = "ivs_player_audio_blocked", r.IVS_PLAYER_PLAYBACK_BLOCKED = "ivs_player_playback_blocked", r.IVS_PLAYER_ERROR = "ivs_player_error", r.IVS_PLAYER_RECOVERABLE_ERROR = "ivs_player_recoverable_error", r.IVS_PLAYER_WORKER_ERROR = "ivs_player_worker_error", r.IVS_PLAYER_NETWORK_UNAVAILABLE = "ivs_player_network_unavailable", r.LIVESTREAM_LATENCY = "livestream_latency", r.IVS_PLAYER_ANALYTICS_EVENT = "ivs_player_analytics_event", r.IVS_PLAYER_PLAYBACK_RATE_CHANGED = "ivs_player_playback_rate_changed", r.IVS_PLAYER_QUALITY_CHANGED = "ivs_player_quality_changed", r.IVS_PLAYER_INITIALIZED = "ivs_player_initialized";
})(k || (k = {}));
const hh = /* @__PURE__ */ new Map([
  [k.PRECALL_TEST_BEGIN, j.MINOR_EVENT],
  [k.PRECALL_TEST_COMPLETE, j.MINOR_EVENT],
  [k.CALL_JOIN_BEGIN, j.MAJOR_EVENT],
  [k.NET_QUALITY_TEST_BEGIN, j.MINOR_EVENT],
  [k.NET_QUALITY_TEST_END, j.MINOR_EVENT],
  [k.WEBSOCKET_CONNECTED, j.MINOR_EVENT],
  [k.TRANSPORT_CONNECTED, j.MAJOR_EVENT],
  [k.AUDIO_ON, j.MINOR_EVENT],
  [k.AUDIO_OFF, j.MINOR_EVENT],
  [k.VIDEO_ON, j.MINOR_EVENT],
  [k.VIDEO_OFF, j.MINOR_EVENT],
  [k.PARTICIPANT_ROLE, j.MINOR_EVENT],
  [k.PING_STAT, j.MAJOR_EVENT],
  [k.DISCONNECT, j.MAJOR_EVENT],
  [k.RECONNECT_ATTEMPT, j.MAJOR_EVENT],
  [k.SCREENSHARE_START_REQUESTED, j.MINOR_EVENT],
  [k.SCREENSHARE_STARTED, j.MINOR_EVENT],
  [k.SCREENSHARE_STOPPED, j.MINOR_EVENT],
  [k.TAB_CHANGE, j.MINOR_EVENT],
  [k.BROWSER_BACKGROUNDED, j.MINOR_EVENT],
  [k.BROWSER_FOREGROUNDED, j.MINOR_EVENT],
  [k.DOMINANT_SPEAKER, j.MINOR_EVENT],
  [k.AUDIO_DEVICES_UPDATES, j.MINOR_EVENT],
  [k.VIDEO_DEVICES_UPDATES, j.MINOR_EVENT],
  [k.SPEAKER_DEVICES_UPDATES, j.MINOR_EVENT],
  [k.SELECTED_MICROHPONE_UPDATE, j.MINOR_EVENT],
  [k.SELECTED_CAMERA_UPDATE, j.MINOR_EVENT],
  [k.SELECTED_SPEAKER_UPDATE, j.MINOR_EVENT],
  [k.MEDIA_PERMISSION, j.MINOR_EVENT],
  [k.LEGACY_SWITCH, j.MINOR_EVENT],
  [k.AUDIO_PLAY_FAILED, j.MINOR_EVENT],
  [k.VIDEO_PLAY_FAILED, j.MINOR_EVENT],
  [k.AUDIO_TRACK_MUTED, j.MINOR_EVENT],
  [k.VIDEO_TRACK_MUTED, j.MINOR_EVENT],
  // IVS Player Events
  [k.IVS_PLAYER_REBUFFERING, j.MAJOR_EVENT],
  [k.IVS_PLAYER_AUDIO_BLOCKED, j.MAJOR_EVENT],
  [k.IVS_PLAYER_PLAYBACK_BLOCKED, j.MAJOR_EVENT],
  [k.IVS_PLAYER_ERROR, j.MAJOR_EVENT],
  [k.IVS_PLAYER_RECOVERABLE_ERROR, j.MAJOR_EVENT],
  [k.IVS_PLAYER_WORKER_ERROR, j.MAJOR_EVENT],
  [k.IVS_PLAYER_NETWORK_UNAVAILABLE, j.MAJOR_EVENT],
  // We are keeping live latency as major, so that it
  // acts as a ping alternative for livestream viewer
  [k.LIVESTREAM_LATENCY, j.MAJOR_EVENT],
  [k.IVS_PLAYER_ANALYTICS_EVENT, j.MINOR_EVENT],
  [k.IVS_PLAYER_PLAYBACK_RATE_CHANGED, j.MINOR_EVENT],
  [k.IVS_PLAYER_QUALITY_CHANGED, j.MINOR_EVENT],
  [k.IVS_PLAYER_INITIALIZED, j.MINOR_EVENT]
]);
var Go = typeof globalThis != "undefined" ? globalThis : typeof window != "undefined" ? window : typeof global != "undefined" ? global : typeof self != "undefined" ? self : {}, bt = {}, mh = {
  get exports() {
    return bt;
  },
  set exports(r) {
    bt = r;
  }
}, mi = typeof Reflect == "object" ? Reflect : null, Ed = mi && typeof mi.apply == "function" ? mi.apply : function(e, t, s) {
  return Function.prototype.apply.call(e, t, s);
}, ma;
mi && typeof mi.ownKeys == "function" ? ma = mi.ownKeys : Object.getOwnPropertySymbols ? ma = function(e) {
  return Object.getOwnPropertyNames(e).concat(Object.getOwnPropertySymbols(e));
} : ma = function(e) {
  return Object.getOwnPropertyNames(e);
};
function fh(r) {
  console && console.warn && console.warn(r);
}
var tu = Number.isNaN || function(e) {
  return e !== e;
};
function ye() {
  ye.init.call(this);
}
mh.exports = ye;
bt.once = Th;
ye.EventEmitter = ye;
ye.prototype._events = void 0;
ye.prototype._eventsCount = 0;
ye.prototype._maxListeners = void 0;
var Sd = 10;
function ro(r) {
  if (typeof r != "function")
    throw new TypeError('The "listener" argument must be of type Function. Received type ' + typeof r);
}
Object.defineProperty(ye, "defaultMaxListeners", {
  enumerable: !0,
  get: function() {
    return Sd;
  },
  set: function(r) {
    if (typeof r != "number" || r < 0 || tu(r))
      throw new RangeError('The value of "defaultMaxListeners" is out of range. It must be a non-negative number. Received ' + r + ".");
    Sd = r;
  }
});
ye.init = function() {
  (this._events === void 0 || this._events === Object.getPrototypeOf(this)._events) && (this._events = /* @__PURE__ */ Object.create(null), this._eventsCount = 0), this._maxListeners = this._maxListeners || void 0;
};
ye.prototype.setMaxListeners = function(e) {
  if (typeof e != "number" || e < 0 || tu(e))
    throw new RangeError('The value of "n" is out of range. It must be a non-negative number. Received ' + e + ".");
  return this._maxListeners = e, this;
};
function su(r) {
  return r._maxListeners === void 0 ? ye.defaultMaxListeners : r._maxListeners;
}
ye.prototype.getMaxListeners = function() {
  return su(this);
};
ye.prototype.emit = function(e) {
  for (var t = [], s = 1; s < arguments.length; s++)
    t.push(arguments[s]);
  var i = e === "error", n = this._events;
  if (n !== void 0)
    i = i && n.error === void 0;
  else if (!i)
    return !1;
  if (i) {
    var a;
    if (t.length > 0 && (a = t[0]), a instanceof Error)
      throw a;
    var o = new Error("Unhandled error." + (a ? " (" + a.message + ")" : ""));
    throw o.context = a, o;
  }
  var d = n[e];
  if (d === void 0)
    return !1;
  if (typeof d == "function")
    Ed(d, this, t);
  else
    for (var p = d.length, l = ou(d, p), s = 0; s < p; ++s)
      Ed(l[s], this, t);
  return !0;
};
function ru(r, e, t, s) {
  var i, n, a;
  if (ro(t), n = r._events, n === void 0 ? (n = r._events = /* @__PURE__ */ Object.create(null), r._eventsCount = 0) : (n.newListener !== void 0 && (r.emit(
    "newListener",
    e,
    t.listener ? t.listener : t
  ), n = r._events), a = n[e]), a === void 0)
    a = n[e] = t, ++r._eventsCount;
  else if (typeof a == "function" ? a = n[e] = s ? [t, a] : [a, t] : s ? a.unshift(t) : a.push(t), i = su(r), i > 0 && a.length > i && !a.warned) {
    a.warned = !0;
    var o = new Error("Possible EventEmitter memory leak detected. " + a.length + " " + String(e) + " listeners added. Use emitter.setMaxListeners() to increase limit");
    o.name = "MaxListenersExceededWarning", o.emitter = r, o.type = e, o.count = a.length, fh(o);
  }
  return r;
}
ye.prototype.addListener = function(e, t) {
  return ru(this, e, t, !1);
};
ye.prototype.on = ye.prototype.addListener;
ye.prototype.prependListener = function(e, t) {
  return ru(this, e, t, !0);
};
function gh() {
  if (!this.fired)
    return this.target.removeListener(this.type, this.wrapFn), this.fired = !0, arguments.length === 0 ? this.listener.call(this.target) : this.listener.apply(this.target, arguments);
}
function iu(r, e, t) {
  var s = { fired: !1, wrapFn: void 0, target: r, type: e, listener: t }, i = gh.bind(s);
  return i.listener = t, s.wrapFn = i, i;
}
ye.prototype.once = function(e, t) {
  return ro(t), this.on(e, iu(this, e, t)), this;
};
ye.prototype.prependOnceListener = function(e, t) {
  return ro(t), this.prependListener(e, iu(this, e, t)), this;
};
ye.prototype.removeListener = function(e, t) {
  var s, i, n, a, o;
  if (ro(t), i = this._events, i === void 0)
    return this;
  if (s = i[e], s === void 0)
    return this;
  if (s === t || s.listener === t)
    --this._eventsCount === 0 ? this._events = /* @__PURE__ */ Object.create(null) : (delete i[e], i.removeListener && this.emit("removeListener", e, s.listener || t));
  else if (typeof s != "function") {
    for (n = -1, a = s.length - 1; a >= 0; a--)
      if (s[a] === t || s[a].listener === t) {
        o = s[a].listener, n = a;
        break;
      }
    if (n < 0)
      return this;
    n === 0 ? s.shift() : _h(s, n), s.length === 1 && (i[e] = s[0]), i.removeListener !== void 0 && this.emit("removeListener", e, o || t);
  }
  return this;
};
ye.prototype.off = ye.prototype.removeListener;
ye.prototype.removeAllListeners = function(e) {
  var t, s, i;
  if (s = this._events, s === void 0)
    return this;
  if (s.removeListener === void 0)
    return arguments.length === 0 ? (this._events = /* @__PURE__ */ Object.create(null), this._eventsCount = 0) : s[e] !== void 0 && (--this._eventsCount === 0 ? this._events = /* @__PURE__ */ Object.create(null) : delete s[e]), this;
  if (arguments.length === 0) {
    var n = Object.keys(s), a;
    for (i = 0; i < n.length; ++i)
      a = n[i], a !== "removeListener" && this.removeAllListeners(a);
    return this.removeAllListeners("removeListener"), this._events = /* @__PURE__ */ Object.create(null), this._eventsCount = 0, this;
  }
  if (t = s[e], typeof t == "function")
    this.removeListener(e, t);
  else if (t !== void 0)
    for (i = t.length - 1; i >= 0; i--)
      this.removeListener(e, t[i]);
  return this;
};
function nu(r, e, t) {
  var s = r._events;
  if (s === void 0)
    return [];
  var i = s[e];
  return i === void 0 ? [] : typeof i == "function" ? t ? [i.listener || i] : [i] : t ? vh(i) : ou(i, i.length);
}
ye.prototype.listeners = function(e) {
  return nu(this, e, !0);
};
ye.prototype.rawListeners = function(e) {
  return nu(this, e, !1);
};
ye.listenerCount = function(r, e) {
  return typeof r.listenerCount == "function" ? r.listenerCount(e) : au.call(r, e);
};
ye.prototype.listenerCount = au;
function au(r) {
  var e = this._events;
  if (e !== void 0) {
    var t = e[r];
    if (typeof t == "function")
      return 1;
    if (t !== void 0)
      return t.length;
  }
  return 0;
}
ye.prototype.eventNames = function() {
  return this._eventsCount > 0 ? ma(this._events) : [];
};
function ou(r, e) {
  for (var t = new Array(e), s = 0; s < e; ++s)
    t[s] = r[s];
  return t;
}
function _h(r, e) {
  for (; e + 1 < r.length; e++)
    r[e] = r[e + 1];
  r.pop();
}
function vh(r) {
  for (var e = new Array(r.length), t = 0; t < e.length; ++t)
    e[t] = r[t].listener || r[t];
  return e;
}
function Th(r, e) {
  return new Promise(function(t, s) {
    function i(a) {
      r.removeListener(e, n), s(a);
    }
    function n() {
      typeof r.removeListener == "function" && r.removeListener("error", i), t([].slice.call(arguments));
    }
    cu(r, e, n, { once: !0 }), e !== "error" && yh(r, i, { once: !0 });
  });
}
function yh(r, e, t) {
  typeof r.on == "function" && cu(r, "error", e, t);
}
function cu(r, e, t, s) {
  if (typeof r.on == "function")
    s.once ? r.once(e, t) : r.on(e, t);
  else if (typeof r.addEventListener == "function")
    r.addEventListener(e, function i(n) {
      s.once && r.removeEventListener(e, i), t(n);
    });
  else
    throw new TypeError('The "emitter" argument must be of type EventEmitter. Received type ' + typeof r);
}
var wd;
(function(r) {
  r.CHROMIUM = "chromum", r.FIREFOX = "firefox", r.SAFARI = "safari";
})(wd || (wd = {}));
var gn;
(function(r) {
  r.DEV = "dev", r.STAGING = "staging", r.PRODUCTION = "production";
})(gn || (gn = {}));
var jt;
(function(r) {
  r.AUDIO = "AUDIO", r.VIDEO = "VIDEO", r.SPEAKER = "SPEAKER";
})(jt || (jt = {}));
var ur;
(function(r) {
  r[r.INIT = 0] = "INIT", r[r.ACCEPTED = 1] = "ACCEPTED", r[r.DENIED = 2] = "DENIED", r[r.SYS_DENIED = 3] = "SYS_DENIED", r[r.FAILED = 4] = "FAILED", r[r.NOTFOUND = 5] = "NOTFOUND", r[r.NOT_APPLICABLE = 6] = "NOT_APPLICABLE";
})(ur || (ur = {}));
class Eh {
  constructor() {
    h(this, "currentChunk");
    h(this, "flushedChunks");
    this.currentChunk = {
      entries: []
    }, this.flushedChunks = [];
  }
  add(e) {
    this.currentChunk.entries.push(e);
  }
  flush() {
    const e = this.currentChunk;
    return this.currentChunk = {
      entries: []
    }, this.flushedChunks.push(e), e;
  }
}
class Sh extends bt {
  constructor({ logger: t, peerId: s, env: i }) {
    super();
    h(this, "logger");
    h(this, "peerId");
    h(this, "eventStore");
    h(this, "apiEndpoint");
    this.logger = t, this.peerId = s, i === gn.PRODUCTION ? this.apiEndpoint = "https://collector.prod.da.dyte.io/api/v1/message" : this.apiEndpoint = "https://collector.non-prod.da.dyte.io/api/v1/message", this.eventStore = new Eh();
  }
  async sendEventsChunkToServer(t) {
    const s = {
      payload: t,
      peerId: this.peerId
    };
    try {
      return await fetch(this.apiEndpoint, {
        method: "POST",
        body: JSON.stringify(s)
      }), !0;
    } catch (i) {
      return this.logger.error("callStats::sendEventsChunkToServer::catch", { error: i }), !1;
    }
  }
  callEvent(t) {
    t.timestamp = new Date(), this.eventStore.add(t), this.emit(t.event, t.metaData), hh.get(t.event) === j.MAJOR_EVENT && this.flush();
  }
  async flush() {
    var s;
    const t = this.eventStore.flush();
    return (s = t == null ? void 0 : t.entries) != null && s.length ? (await this.sendEventsChunkToServer(t), !0) : !1;
  }
}
class Us {
  constructor(e) {
    h(this, "pc1");
    h(this, "pc2");
    h(this, "constrainVideoBitrateKbps");
    h(this, "constrainOfferToRemoveVideoFec", !1);
    h(this, "iceCandidateFilter");
    const t = new RTCPeerConnection(e), s = new RTCPeerConnection(e);
    this.pc1 = t, this.pc2 = s, this.iceCandidateFilter = Us.noFilter, this.pc1.addEventListener("icecandidate", this.onIceCandidate.bind(this, this.pc2)), this.pc2.addEventListener("icecandidate", this.onIceCandidate.bind(this, this.pc1));
  }
  static parseCandidate(e) {
    const t = "candidate:", s = e.indexOf(t) + t.length, i = e.substr(s).split(" ");
    return {
      type: i[7],
      protocol: i[2],
      address: i[4]
    };
  }
  static isNotHostCandidate(e) {
    return e.type !== "host";
  }
  static isHost(e) {
    return e.type === "host";
  }
  static isRelay(e) {
    return e.type === "relay";
  }
  static isReflexive(e) {
    return e.type === "srflx";
  }
  static noFilter(e) {
    return !0;
  }
  onIceCandidate(e, t) {
    if (t.candidate) {
      const s = Us.parseCandidate(t.candidate.candidate);
      this.iceCandidateFilter(s) && e.addIceCandidate(t.candidate);
    }
  }
  setIceCandidateFilter(e) {
    this.iceCandidateFilter = e;
  }
  // Constraint max video bitrate by modifying the SDP when creating an answer.
  constrainVideoBitrate(e) {
    this.constrainVideoBitrateKbps = e;
  }
  // Remove video FEC if available on the offer.
  disableVideoFec() {
    this.constrainOfferToRemoveVideoFec = !0;
  }
  gotOffer(e) {
    this.constrainOfferToRemoveVideoFec && (e.sdp = e.sdp.replace(/(m=video 1 [^\r]+)(116 117)(\r\n)/g, `$1\r
`), e.sdp = e.sdp.replace(/a=rtpmap:116 red\/90000\r\n/g, ""), e.sdp = e.sdp.replace(/a=rtpmap:117 ulpfec\/90000\r\n/g, ""), e.sdp = e.sdp.replace(/a=rtpmap:98 rtx\/90000\r\n/g, ""), e.sdp = e.sdp.replace(/a=fmtp:98 apt=116\r\n/g, "")), this.pc1.setLocalDescription(e), this.pc2.setRemoteDescription(e), this.pc2.createAnswer().then(this.gotAnswer.bind(this), this.reportFatal.bind(this));
  }
  gotAnswer(e) {
    this.constrainVideoBitrateKbps && (e.sdp = e.sdp.replace(/a=mid:video\r\n/g, `a=mid:video\r
b=AS:${this.constrainVideoBitrateKbps}\r
`)), this.pc2.setLocalDescription(e), this.pc1.setRemoteDescription(e);
  }
  establishConnection() {
    this.pc1.createOffer().then(this.gotOffer.bind(this), this.reportFatal.bind(this));
  }
  // eslint-disable-next-line class-methods-use-this
  reportFatal(e) {
    console.error("Error:", e);
  }
  async getRoundTripTime() {
    const [e, t] = await Promise.all([this.pc1.getStats(), this.pc2.getStats()]);
    let s, i;
    if (e.forEach((n) => {
      n.type === "candidate-pair" && n.nominated === !0 && n.bytesSent > 0 && (s = n);
    }), t.forEach((n) => {
      n.type === "candidate-pair" && n.nominated === !0 && n.bytesReceived > 0 && (i = n);
    }), s && i)
      try {
        if (s.currentRoundTripTime && i.currentRoundTripTime)
          return {
            rtt: s.currentRoundTripTime,
            backendRTT: i.currentRoundTripTime
          };
        const n = (i.lastPacketReceivedTimestamp - s.lastPacketSentTimestamp) / 1e3;
        return {
          rtt: n,
          backendRTT: n
        };
      } catch (n) {
        return;
      }
  }
  close() {
    this.pc1.close(), this.pc2.close();
  }
}
class du extends bt {
  constructor(t) {
    super();
    h(this, "call");
    h(this, "timeOut");
    this.call = new Us(t);
  }
  start(t = 1e4) {
    this.call.establishConnection(), this.timeOut = setTimeout(this.testFailed.bind(this), t);
  }
  testComplete(t) {
    clearTimeout(this.timeOut), this.call.close(), this.emit("done", t);
  }
  testFailed(t) {
    console.warn("Test failed, ", t), this.call.close(), this.emit("failed", t);
  }
}
const wh = 8, Rh = 1 / 1e3;
class bh extends du {
  constructor(t) {
    super(t);
    h(this, "senderChannel");
    h(this, "recieveChannel");
    h(this, "startTime");
    h(this, "lastBitrateMeasureTime");
    h(this, "sentPayloadBytes", 0);
    h(this, "recievedPayloadBytes", 0);
    h(this, "lastReceivedPayloadBytes", 0);
    h(this, "stopSending", !1);
    h(this, "testProgress", 0);
    h(this, "samplePacket", "");
    h(this, "finalBitrateSum", 0);
    h(this, "bitRateSampels", 0);
    h(this, "maxNumberOfPacketsToSend", 0);
    h(this, "bytesToKeepBuffered", 0);
    h(this, "testDurationSeconds", 5);
    this.call.setIceCandidateFilter(Us.isNotHostCandidate), this.senderChannel = this.call.pc1.createDataChannel(null);
    for (let s = 0; s < 1024 * 256; s += 1)
      this.samplePacket += "h";
    this.maxNumberOfPacketsToSend = 1, this.bytesToKeepBuffered = 1024 * this.maxNumberOfPacketsToSend, this.testDurationSeconds = 4, this.senderChannel.addEventListener("open", this.sendingStep.bind(this)), this.call.pc2.addEventListener("datachannel", this.onRecieverChannel.bind(this));
  }
  sendingStep() {
    const t = new Date();
    this.startTime || (this.startTime = t, this.lastBitrateMeasureTime = t);
    for (let i = 0; i !== this.maxNumberOfPacketsToSend && !(this.senderChannel.bufferedAmount >= this.bytesToKeepBuffered); i += 1) {
      this.sentPayloadBytes += this.samplePacket.length;
      try {
        this.senderChannel.send(this.samplePacket);
      } catch (n) {
      }
    }
    const s = t.getTime() - this.startTime.getTime();
    s >= 1e3 * this.testDurationSeconds ? (this.stopSending = !0, this.testProgress = 100) : (this.testProgress = s / (10 * this.testDurationSeconds), setTimeout(this.sendingStep.bind(this), 1));
  }
  onMessageRecieved(t) {
    this.recievedPayloadBytes += t.data.length;
    const s = new Date(), i = s.getTime() - this.lastBitrateMeasureTime.getTime();
    if (i >= 1e3) {
      const a = (this.recievedPayloadBytes - this.lastReceivedPayloadBytes) * wh / (i / 1e3);
      this.finalBitrateSum += a, this.bitRateSampels += 1, this.lastReceivedPayloadBytes = this.recievedPayloadBytes, this.lastBitrateMeasureTime = s;
    }
    if (this.stopSending && this.sentPayloadBytes === this.recievedPayloadBytes) {
      const n = this.finalBitrateSum / this.bitRateSampels;
      this.testComplete({
        throughput: Math.round(n * Rh)
      });
    }
  }
  testComplete(t) {
    this.call.getRoundTripTime().then(({ rtt: s, backendRTT: i }) => super.testComplete({
      RTT: s,
      backendRTT: i,
      throughput: t.throughput
    }));
  }
  onRecieverChannel(t) {
    this.recieveChannel = t.channel, this.recieveChannel.addEventListener("message", this.onMessageRecieved.bind(this));
  }
}
class wc extends du {
  constructor(t, s = Us.noFilter) {
    super(t);
    h(this, "ch1");
    h(this, "ch2");
    this.call.setIceCandidateFilter(s);
    const i = this.call.pc1.createDataChannel(null);
    this.ch1 = i, i.addEventListener("open", () => {
      i.send("hello");
    }), i.addEventListener("message", this.onCh1Recieve.bind(this)), this.call.pc2.addEventListener("datachannel", this.dataChannelHandler.bind(this));
  }
  onCh1Recieve(t) {
    t.data !== "world" ? this.hangup("Invalid data transmitted.") : this.testComplete({
      connectivity: !0
    });
  }
  onCh2Recieve(t) {
    if (t.data !== "hello")
      this.hangup("Invalid data transmitted.");
    else
      try {
        this.ch2.send("world");
      } catch (s) {
      }
  }
  dataChannelHandler(t) {
    const s = t.channel;
    this.ch2 = s, s.addEventListener("message", this.onCh2Recieve.bind(this));
  }
  hangup(t) {
    this.testFailed(t);
  }
}
class Ph extends wc {
  constructor(e) {
    super(e, Us.isHost);
  }
}
class Ch extends wc {
  constructor(e) {
    super(e, Us.isRelay);
  }
}
class kh extends wc {
  constructor(e) {
    super(e, Us.isReflexive);
  }
}
class Dh {
  constructor() {
    h(this, "ipInformation", null);
  }
  async getIPDetails({ peerId: e }) {
    var t;
    if (!this.ipInformation) {
      try {
        const n = await (await fetch("https://media-location.dyte.io")).json();
        if (((t = n.loc) == null ? void 0 : t.length) > 5)
          return this.ipInformation = n, n;
        throw Error("Insufficient data");
      } catch (i) {
      }
      const s = await fetch(`https://location-service.dyte.io/?token=3c493932b0624c&peerId=${e}`, {
        method: "POST"
      });
      this.ipInformation = await s.json();
    }
    return this.ipInformation;
  }
}
const Rc = new Dh(), Rd = [
  {
    urls: "turn:turn.dyte.in:443?transport=tcp",
    username: "dyte",
    credential: "dytein",
    credentialType: "password"
  },
  {
    urls: "turn:turn.dyte.in:3478?transport=udp",
    username: "dyte",
    credential: "dytein",
    credentialType: "password"
  }
];
function Ih(r) {
  const [e, t] = r.split(",");
  return {
    coords: {
      latitude: Number(e),
      longitude: Number(t)
    }
  };
}
class lu {
  constructor() {
    h(this, "transport");
    h(this, "candidatePair");
    h(this, "outboundVideoRtp", /* @__PURE__ */ new Map());
    h(this, "inboundVideoRtp", /* @__PURE__ */ new Map());
    h(this, "outboundAudioRtp", /* @__PURE__ */ new Map());
    h(this, "inboundAudioRtp", /* @__PURE__ */ new Map());
    h(this, "remoteInboundRtp", /* @__PURE__ */ new Map());
    h(this, "producerStreamMap", /* @__PURE__ */ new Map());
    h(this, "consumerStreamMap", /* @__PURE__ */ new Map());
    h(this, "staleProducerStreamMap", !1);
    h(this, "staleConsumerStreamMap", !1);
  }
}
class uu {
  constructor() {
    h(this, "outboundProducerMap", /* @__PURE__ */ new Map());
    h(this, "inboundConsumerMap", /* @__PURE__ */ new Map());
    h(this, "consumerPeerIdMap", /* @__PURE__ */ new Map());
    h(this, "overallProducingTransportsStatsMap", {});
    h(this, "overallConsumingTransportsStatsMap", {});
    h(this, "overallConsumersStatsMap", {});
    h(this, "overallProducersStatsMap", {});
    h(this, "consumerIdsWithFreezedVideo", /* @__PURE__ */ new Set());
    h(this, "consumerIdsWithFreezedAudio", /* @__PURE__ */ new Set());
    h(this, "producerIdsWithFreezedVideo", /* @__PURE__ */ new Set());
    h(this, "producerIdsWithFreezedAudio", /* @__PURE__ */ new Set());
    h(this, "freezedProducingTransportIds", /* @__PURE__ */ new Set());
    h(this, "freezedConsumingTransportIds", /* @__PURE__ */ new Set());
    h(this, "ipDetails");
    h(this, "callStatsInstance");
  }
  async registerProducer(e) {
    await this.generateProducerStreamMap(e), e.observer.on("close", this.deregisterProducer.bind(this, e));
  }
  processInboundConsumerVideoStats(e, t, s) {
    var n, a;
    const i = ((a = (n = this == null ? void 0 : this.callStatsInstance) == null ? void 0 : n.consumerSharedMediaStatesMap) == null ? void 0 : a.get(e)) || {};
    t.totalVideoPacketsReceived === s.packetsReceived ? (this.consumerIdsWithFreezedVideo.add(e), this.callStatsInstance && i.video && (this.callStatsInstance.logger.debug("callstats::measurements::consumerVideoFreezed", { consumerId: e }), this.callStatsInstance.eventHandler.emit("consumer_video_status", "pause", e))) : (t.totalVideoPacketsReceived = s.packetsReceived, this.consumerIdsWithFreezedVideo.has(e) && (this.consumerIdsWithFreezedVideo.delete(e), this.callStatsInstance && i.video && (this.callStatsInstance.logger.debug("callstats::measurements::consumerVideoDefreezed", { consumerId: e }), this.callStatsInstance.eventHandler.emit("consumer_video_status", "resume", e))));
  }
  processInboundConsumerAudioStats(e, t, s) {
    var n, a;
    const i = ((a = (n = this == null ? void 0 : this.callStatsInstance) == null ? void 0 : n.consumerSharedMediaStatesMap) == null ? void 0 : a.get(e)) || {};
    t.totalAudioPacketsReceived === s.packetsReceived ? (this.consumerIdsWithFreezedAudio.add(e), this.callStatsInstance && i.audio && (this.callStatsInstance.logger.debug("callStats::measurements::consumerAudioFreezed", { consumerId: e }), this.callStatsInstance.eventHandler.emit("consumer_audio_status", "pause", e))) : (t.totalAudioPacketsReceived = s.packetsReceived, this.consumerIdsWithFreezedAudio.has(e) && (this.consumerIdsWithFreezedAudio.delete(e), this.callStatsInstance && i.audio && (this.callStatsInstance.logger.debug("callStats::measurements::consumerAudioDefreezed", { consumerId: e }), this.callStatsInstance.eventHandler.emit("consumer_audio_status", "resume", e))));
  }
  processOutboundProducerVideoStats(e, t, s) {
    var n;
    const i = ((n = this == null ? void 0 : this.callStatsInstance) == null ? void 0 : n.currentUserMediaStates) || {};
    t.totalVideoPacketsSent === s.packetsSent ? (this.producerIdsWithFreezedVideo.add(e), this.callStatsInstance && i.video && (this.callStatsInstance.logger.debug("callStats::measurements::producerVideoFreezed", { producerId: e }), this.callStatsInstance.eventHandler.emit("producer_video_status", "pause", e))) : (t.totalVideoPacketsSent = s.packetsSent, this.producerIdsWithFreezedVideo.has(e) && (this.producerIdsWithFreezedVideo.delete(e), this.callStatsInstance && i.video && (this.callStatsInstance.logger.debug("callStats::measurements::producerVideoDefreezed", { producerId: e }), this.callStatsInstance.eventHandler.emit("producer_video_status", "resume", e))));
  }
  processOutboundProducerAudioStats(e, t, s) {
    var n;
    const i = ((n = this == null ? void 0 : this.callStatsInstance) == null ? void 0 : n.currentUserMediaStates) || {};
    t.totalAudioPacketsSent === s.packetsSent ? (this.producerIdsWithFreezedAudio.add(e), this.callStatsInstance && i.audio && (this.callStatsInstance.logger.debug("callStats::measurements::producerAudioFreezed", { producerId: e }), this.callStatsInstance.eventHandler.emit("producer_audio_status", "pause", e))) : (t.totalAudioPacketsSent = s.packetsSent, this.producerIdsWithFreezedAudio.has(e) && (this.producerIdsWithFreezedAudio.delete(e), this.callStatsInstance && i.audio && (this.callStatsInstance.logger.debug("callStats::measurements::producerAudioDefreezed", { producerId: e }), this.callStatsInstance.eventHandler.emit("producer_audio_status", "resume", e))));
  }
  processProducingTransportStats(e, t, s) {
    var p;
    const i = ((p = this == null ? void 0 : this.callStatsInstance) == null ? void 0 : p.currentUserMediaStates) || {}, { audio: n, video: a, screen: o } = i, d = n || a || o;
    t.totalPacketsSent === s.packetsSent ? (this.freezedProducingTransportIds.add(e), this.callStatsInstance && d && (this.callStatsInstance.logger.debug("callStats::measurements::producingTransportFreezed", { transportId: e }), this.callStatsInstance.eventHandler.emit("producing_transport_status", "pause", e))) : (t.totalPacketsSent = s.packetsSent, this.freezedProducingTransportIds.has(e) && (this.freezedProducingTransportIds.delete(e), this.callStatsInstance && d && (this.callStatsInstance.logger.debug("callStats::measurements::producingTransportDefreezed", { transportId: e }), this.callStatsInstance.eventHandler.emit("producing_transport_status", "resume", e))));
  }
  processConsumingTransportStats(e, t, s) {
    var a, o;
    const n = !!Array.from(((o = (a = this == null ? void 0 : this.callStatsInstance) == null ? void 0 : a.consumerSharedMediaStatesMap) == null ? void 0 : o.values()) || []).reduce((d, p) => d || p.audio || p.video || p.screen, !1);
    t.totalPacketsReceived === s.packetsSent ? (this.freezedConsumingTransportIds.add(e), this.callStatsInstance && n && (this.callStatsInstance.logger.debug("callStats::measurements::consumingTransportFreezed", { transportId: e }), this.callStatsInstance.eventHandler.emit("consuming_transport_status", "pause", e))) : (t.totalPacketsReceived = s.packetsSent, this.freezedConsumingTransportIds.has(e) && (this.freezedConsumingTransportIds.delete(e), this.callStatsInstance && n && (this.callStatsInstance.logger.debug("callStats::measurements::consumingTransportDefreezed", { transportId: e }), this.callStatsInstance.eventHandler.emit("consuming_transport_status", "resume", e))));
  }
  async registerConsumer(e) {
    await this.generateConsumerStreamMap(e), this.consumerPeerIdMap.set(e.id, {
      producerId: e.producerId,
      peerId: e.appData.peerId
    }), e.observer.on("close", this.deregisterConsumer.bind(this, e));
  }
  async generateProducerStreamMap(e, t = !1) {
    const s = await e.getStats(), i = t ? this.getProducerStatsFromReport(this.parseRTCReport(s, ["outbound-rtp", "remote-inbound-rtp"], !1, e.id))[0] : void 0;
    for (const n of s.values())
      switch (n.type) {
        case "outbound-rtp": {
          this.outboundProducerMap.set(n.id, e.id);
          break;
        }
      }
    return i;
  }
  async generateConsumerStreamMap(e, t = !1) {
    const s = await e.getStats(), i = t ? this.getConsumerStatsFromReport(this.parseRTCReport(s, ["inbound-rtp"], !1, e.id))[0] : void 0;
    for (const n of s.values())
      switch (n.type) {
        case "inbound-rtp": {
          this.inboundConsumerMap.set(n.id, e.id);
          break;
        }
      }
    return i;
  }
  deregisterProducer(e) {
    this.outboundProducerMap.forEach((t, s) => {
      t === e.id && this.outboundProducerMap.delete(s);
    });
  }
  deregisterConsumer(e) {
    this.inboundConsumerMap.forEach((t, s) => {
      t === e.id && this.inboundConsumerMap.delete(s);
    }), this.consumerPeerIdMap.delete(e.id);
  }
  parseRTCReport(e, t = [], s = !1, i = void 0, n = void 0) {
    const a = e, o = new lu(), d = t.length ? new Set(t) : void 0;
    for (const p of a.values()) {
      if (d) {
        if (d.size === 0)
          break;
        if (d.has(p.type))
          s && d.delete(p.type);
        else
          continue;
      }
      switch (p.type) {
        case "candidate-pair": {
          if (p.nominated === !0 || p.selected === !0) {
            const l = p, u = {
              bytesReceived: l.bytesReceived,
              bytesSent: l.bytesSent,
              currentRoundTripTime: l.currentRoundTripTime,
              totalRoundTripTime: l.totalRoundTripTime,
              availableOutgoingBitrate: l.availableOutgoingBitrate
            };
            o.candidatePair = u;
            break;
          }
          break;
        }
        case "transport": {
          const l = p;
          n && (n.producing && (this.overallProducingTransportsStatsMap[n.id] || (this.overallProducingTransportsStatsMap[n.id] = {
            totalPacketsSent: 0
          })), n.consuming && (this.overallConsumingTransportsStatsMap[n.id] || (this.overallConsumingTransportsStatsMap[n.id] = {
            totalPacketsReceived: 0
          })));
          const u = {
            bytesReceived: l.bytesReceived,
            bytesSent: l.bytesSent,
            packetsSent: l.packetsSent,
            packetsReceived: l.packetsReceived,
            dtlsCipher: l.dtlsCipher,
            dtlsState: l.dtlsState,
            iceRole: l.iceRole
          };
          if (o.transport = u, n) {
            if (n.producing) {
              const m = this.overallProducingTransportsStatsMap[n.id];
              this.processProducingTransportStats(n.id, m, u);
            }
            if (n.consuming) {
              const m = this.overallConsumingTransportsStatsMap[n.id];
              this.processConsumingTransportStats(n.id, m, u);
            }
          }
          break;
        }
        case "remote-inbound-rtp": {
          const l = p, u = {
            jitter: l.jitter,
            fractionLost: l.fractionLost,
            roundTripTime: l.roundTripTime,
            roundTripTimeMeasurements: l.roundTripTimeMeasurements,
            totalRoundTripTime: l.totalRoundTripTime,
            packetsLost: l.packetsLost
          };
          o.remoteInboundRtp.set(l.localId, u);
          break;
        }
        case "outbound-rtp": {
          const l = p, u = i || this.outboundProducerMap.get(p.id);
          this.overallProducersStatsMap[u] || (this.overallProducersStatsMap[u] = {
            totalVideoPacketsSent: 0,
            totalAudioPacketsSent: 0
          });
          const m = this.overallProducersStatsMap[u];
          if (["video", "audio"].includes(l.mediaType)) {
            if (!this.outboundProducerMap.has(p.id)) {
              o.staleProducerStreamMap = !0, d && d.delete("outbound-rtp");
              break;
            }
            o.producerStreamMap.has(u) || o.producerStreamMap.set(u, {
              outboundVideoRtpId: [],
              outboundAudioRtpId: []
            });
            const g = {
              bytesSent: l.bytesSent,
              packetsSent: l.packetsSent,
              nackCount: l.nackCount
            };
            if (l.mediaType === "video") {
              if (l.decoderImplementation === "unknown")
                break;
              const T = l, S = {
                frameHeight: T.frameHeight,
                frameWidth: T.frameWidth,
                framesEncoded: T.framesEncoded,
                framesDropped: T.framesDropped,
                framesPerSecond: T.framesPerSecond,
                framesSent: T.framesSent,
                keyFramesEncoded: T.keyFramesEncoded,
                firCount: T.firCount,
                encoderImplementation: T.encoderImplementation,
                hugeFramesSent: T.hugeFramesSent,
                pliCount: T.pliCount,
                qpSum: T.qpSum,
                qualityLimitationDurations: T.qualityLimitationDurations,
                qualityLimitationReason: T.qualityLimitationReason,
                qualityLimitationResolutionChanges: T.qualityLimitationResolutionChanges,
                // temp sending target bitrate in total encode time
                // to avoid the delay with making the backend changes
                totalEncodeTime: T.targetBitrate,
                totalPacketSendDelay: T.totalPacketSendDelay,
                retransmittedBytesSent: T.retransmittedBytesSent,
                retransmittedPacketsSent: T.retransmittedPacketsSent,
                ...g
              };
              o.outboundVideoRtp.set(p.id, S), o.producerStreamMap.get(u).outboundVideoRtpId.push(p.id), this.processOutboundProducerVideoStats(u, m, S);
            } else if (l.mediaType === "audio") {
              const T = l, S = {
                retransmittedBytesSent: T.retransmittedBytesSent,
                retransmittedPacketsSent: T.retransmittedPacketsSent,
                ...g
              };
              o.outboundAudioRtp.set(p.id, S), o.producerStreamMap.get(u).outboundAudioRtpId.push(p.id), this.processOutboundProducerAudioStats(u, m, S);
            }
          }
          break;
        }
        case "inbound-rtp": {
          const l = p, u = i || this.inboundConsumerMap.get(p.id);
          if (l.ssrc === 1234)
            break;
          this.overallConsumersStatsMap[u] || (this.overallConsumersStatsMap[u] = {
            totalVideoPacketsReceived: 0,
            totalAudioPacketsReceived: 0
          });
          const m = this.overallConsumersStatsMap[u];
          if (["video", "audio"].includes(l.mediaType)) {
            if (!this.inboundConsumerMap.has(p.id)) {
              o.staleConsumerStreamMap = !0, d && d.delete("inbound-rtp");
              break;
            }
            o.consumerStreamMap.has(u) || o.consumerStreamMap.set(u, {
              inboundVideoRtpId: [],
              inboundAudioRtpId: []
            });
            const g = {
              bytesReceived: l.bytesReceived,
              packetsReceived: l.packetsReceived,
              packetsLost: l.packetsLost,
              jitter: l.jitter,
              nackCount: l.nackCount
            };
            if (l.mediaType === "video") {
              if (l.decoderImplementation === "unknown")
                break;
              const T = l, S = {
                frameHeight: T.frameHeight,
                frameWidth: T.frameWidth,
                framesDecoded: T.framesDecoded,
                framesDropped: T.framesDropped,
                framesPerSecond: T.framesPerSecond,
                framesReceived: T.framesReceived,
                keyFramesDecoded: T.keyFramesDecoded,
                firCount: T.firCount,
                decoderImplementation: T.decoderImplementation,
                ...g
              };
              o.inboundVideoRtp.set(p.id, S), o.consumerStreamMap.get(u).inboundVideoRtpId.push(p.id), this.processInboundConsumerVideoStats(u, m, S);
            } else if (l.mediaType === "audio") {
              const T = l, S = {
                audioLevel: T.audioLevel,
                concealedSampels: T.concealedSampels,
                concealmentEvents: T.concealmentEvents,
                jitterBufferDelay: T.jitterBufferDelay,
                jitterBufferEmittedCount: T.jitterBufferEmittedCount,
                totalAudioEnergy: T.totalAudioEnergy,
                totalSamplesDuration: T.totalSamplesDuration,
                totalSamplesReceived: T.totalSamplesReceived,
                ...g
              };
              o.inboundAudioRtp.set(p.id, S), o.consumerStreamMap.get(u).inboundAudioRtpId.push(p.id), this.processInboundConsumerAudioStats(u, m, S);
            }
          }
          break;
        }
      }
    }
    if (o.outboundVideoRtp.forEach((p, l) => {
      p.remoteData = o.remoteInboundRtp.get(l);
    }), o.outboundAudioRtp.forEach((p, l) => {
      p.remoteData = o.remoteInboundRtp.get(l);
    }), o.candidatePair && (o.transport ? (o.transport.totalRoundTripTime = o.candidatePair.totalRoundTripTime, o.transport.availableOutgoingBitrate = o.candidatePair.availableOutgoingBitrate, o.transport.roundTripTime = o.candidatePair.currentRoundTripTime) : o.transport = {
      // candidateStats: result.candidatePair,
      bytesReceived: o.candidatePair.bytesReceived,
      bytesSent: o.candidatePair.bytesSent,
      totalRoundTripTime: o.candidatePair.totalRoundTripTime,
      availableOutgoingBitrate: o.candidatePair.availableOutgoingBitrate,
      roundTripTime: o.candidatePair.currentRoundTripTime
    }), o.transport && !o.transport.roundTripTime) {
      let p = 0, l = 0;
      o.remoteInboundRtp.forEach((u, m) => {
        u.roundTripTime && u.roundTripTime > p && (p = u.roundTripTime, l = u.totalRoundTripTime);
      }), o.transport.roundTripTime = p, o.transport.totalRoundTripTime = l;
    }
    return o;
  }
  async getProducersReport(e) {
    const t = e.map((s) => this.generateProducerStreamMap(s, !0));
    return t.length > 0 ? Promise.all(t) : void 0;
  }
  async getConsumersReport(e) {
    const t = e.map((s) => this.generateConsumerStreamMap(s, !0));
    return t.length > 0 ? Promise.all(t) : void 0;
  }
  // eslint-disable-next-line class-methods-use-this
  async getTransportReport(e) {
    return e.getStats();
  }
  async getProcessedStats(e, t, s) {
    const i = await this.getTransportReport(e), n = { producing: s, consuming: t, id: e.id }, a = i, o = this.parseRTCReport(a, ["transport", "candidate-pair", "inbound-rtp", "outbound-rtp", "remote-inbound-rtp"], !1, void 0, n);
    if (!o)
      return;
    const d = {
      stats: o.transport,
      transportId: e.id,
      consuming: t,
      producing: s
    }, p = o.staleProducerStreamMap ? void 0 : this.getProducerStatsFromReport(o), l = o.staleConsumerStreamMap ? void 0 : this.getConsumerStatsFromReport(o);
    return {
      transportReport: d,
      producerReport: p,
      consumerReport: l
    };
  }
  // eslint-disable-next-line class-methods-use-this
  getProducerStatsFromReport(e) {
    const t = [];
    try {
      e.producerStreamMap.forEach((s, i) => {
        var n, a;
        t.push({
          producerId: i,
          videoStats: s.outboundVideoRtpId.map((o) => e.outboundVideoRtp.get(o)),
          audioStats: s.outboundAudioRtpId.map((o) => e.outboundAudioRtp.get(o)),
          appData: ((a = (n = this.callStatsInstance.producers) == null ? void 0 : n.get(i)) == null ? void 0 : a.appData) || null
        });
      });
    } catch (s) {
      this.callStatsInstance.logger.error("callStats::measurements::getProducerStatsFromReport", {
        error: { reason: s.reason, message: s.message }
      });
    }
    return t;
  }
  getConsumerStatsFromReport(e) {
    const t = [];
    try {
      e.consumerStreamMap.forEach((s, i) => {
        const { peerId: n, producerId: a } = this.consumerPeerIdMap.get(i);
        t.push({
          consumerId: i,
          peerId: n,
          producerId: a,
          videoStats: s.inboundVideoRtpId.map((o) => e.inboundVideoRtp.get(o)),
          audioStats: s.inboundAudioRtpId.map((o) => e.inboundAudioRtp.get(o))
        });
      });
    } catch (s) {
      console.error("getConsumersReport: ", s, e);
    }
    return t;
  }
  // eslint-disable-next-line class-methods-use-this
  async getUserLocation() {
    return new Promise((t, s) => {
      try {
        navigator.geolocation ? navigator.geolocation.getCurrentPosition((i) => {
          t(i);
        }) : s();
      } catch (i) {
        s(i);
      }
    });
  }
  // eslint-disable-next-line class-methods-use-this
  async getConnectivity(e) {
    try {
      const t = {
        iceServers: e || Rd
      }, s = new Promise((p, l) => {
        try {
          const u = new Ph(t);
          u.addListener("done", p), u.addListener("failed", () => {
            p({ connectivity: !1 });
          }), u.start(2e3);
        } catch (u) {
          l(u);
        }
      }), i = new Promise((p, l) => {
        try {
          const u = new Ch(t);
          u.addListener("done", p), u.addListener("failed", () => {
            p({ connectivity: !1 });
          }), u.start(2e3);
        } catch (u) {
          l(u);
        }
      }), n = new Promise((p, l) => {
        try {
          const u = new kh(t);
          u.addListener("done", p), u.addListener("failed", () => {
            p({ connectivity: !1 });
          }), u.start(2e3);
        } catch (u) {
          l(u);
        }
      }), [a, o, d] = await Promise.all([s, i, n]);
      return {
        host: a == null ? void 0 : a.connectivity,
        relay: o == null ? void 0 : o.connectivity,
        reflexive: d == null ? void 0 : d.connectivity
      };
    } catch (t) {
      return {
        host: !1,
        relay: !1,
        reflexive: !1
      };
    }
  }
  // eslint-disable-next-line class-methods-use-this
  async getThroughput(e) {
    try {
      const s = await new Promise((i, n) => {
        try {
          const a = {
            iceServers: e || Rd
          }, o = new bh(a);
          o.addListener("done", i), o.addListener("failed", n), o.start(1e4);
        } catch (a) {
          n(a);
        }
      });
      return {
        throughput: s.throughput,
        fractionalLoss: 0,
        RTT: s.RTT,
        jitter: 0,
        backendRTT: s.backendRTT
      };
    } catch (t) {
      return;
    }
  }
  async getIPDetails() {
    var e;
    try {
      return this.ipDetails || (this.ipDetails = await Rc.getIPDetails({ peerId: (e = this.callStatsInstance) == null ? void 0 : e.peerId })), this.ipDetails;
    } catch (t) {
      return;
    }
  }
  async getNetworkQuality(e) {
    const [t, s] = await Promise.all([
      this.getConnectivity(e),
      this.getThroughput(e)
    ]);
    return {
      connectivity: t,
      throughput: s == null ? void 0 : s.throughput,
      fractionalLoss: s == null ? void 0 : s.fractionalLoss,
      RTT: s == null ? void 0 : s.RTT,
      jitter: s == null ? void 0 : s.jitter,
      backendRTT: s == null ? void 0 : s.backendRTT
    };
  }
  async getNetworkInfo(e) {
    var a;
    const [t, s, i] = await Promise.all([
      this.getConnectivity(e),
      this.getThroughput(e),
      this.getIPDetails()
    ]);
    return {
      ipDetails: i,
      effectiveNetworkType: (a = navigator.connection) == null ? void 0 : a.effectiveType,
      location: i.loc ? Ih(i.loc) : void 0,
      turnConnectivity: t ? t.host || t.relay || t.reflexive : !1,
      connectivity: t,
      throughput: s == null ? void 0 : s.throughput,
      fractionalLoss: s == null ? void 0 : s.fractionalLoss,
      RTT: s == null ? void 0 : s.RTT,
      jitter: s == null ? void 0 : s.jitter,
      backendRTT: s == null ? void 0 : s.backendRTT
    };
  }
}
class Ah extends uu {
}
class pu extends uu {
  constructor() {
    super(...arguments);
    h(this, "producerMap", /* @__PURE__ */ new Map());
    h(this, "consumerMap", /* @__PURE__ */ new Map());
  }
  async registerProducer(t) {
    this.producerMap.set(t.id, t), await this.generateProducerStreamMap(t), t.observer.on("close", this.deregisterProducer.bind(this, t));
  }
  async registerConsumer(t) {
    this.consumerMap.set(t.id, t), await this.generateConsumerStreamMap(t), this.consumerPeerIdMap.set(t.id, {
      producerId: t.producerId,
      peerId: t.appData.peerId
    }), t.observer.on("close", this.deregisterConsumer.bind(this, t));
  }
  async generateConsumerStreamMap(t, s = !1) {
    const i = await t.getStats(), n = this.parseRTCReport(i, ["inbound-rtp"], !1, t.id), a = [...n.consumerStreamMap.values()][0], o = s ? this.getConsumerStatsFromParsedConsumerStats(n, a, t.id) : void 0;
    for (const d of i.values())
      switch (d.type) {
        case "inbound-rtp": {
          this.inboundConsumerMap.set(d.id, t.id);
          break;
        }
      }
    return o;
  }
  deregisterProducer(t) {
    this.producerMap.delete(t.id), this.outboundProducerMap.forEach((s, i) => {
      s === t.id && this.outboundProducerMap.delete(i);
    });
  }
  deregisterConsumer(t) {
    this.consumerMap.delete(t.id), this.inboundConsumerMap.forEach((s, i) => {
      s === t.id && this.inboundConsumerMap.delete(i);
    }), this.consumerPeerIdMap.delete(t.id);
  }
  parseRTCReport(t, s = [], i = !1, n = void 0, a = void 0) {
    const o = t, d = new lu(), p = s.length ? new Set(s) : void 0;
    for (const l of o.values()) {
      if (p) {
        if (p.size === 0)
          break;
        if (p.has(l.type))
          i && p.delete(l.type);
        else
          continue;
      }
      switch (l.type) {
        case "candidate-pair": {
          if (l.nominated === !0 || l.selected === !0) {
            const u = l, m = {
              bytesReceived: u.bytesReceived,
              bytesSent: u.bytesSent,
              currentRoundTripTime: u.currentRoundTripTime,
              totalRoundTripTime: u.totalRoundTripTime,
              availableOutgoingBitrate: u.availableOutgoingBitrate
            };
            d.candidatePair = m;
            break;
          }
          break;
        }
        case "transport": {
          const u = l;
          a && (a.producing && (this.overallProducingTransportsStatsMap[a.id] || (this.overallProducingTransportsStatsMap[a.id] = {
            totalPacketsSent: 0
          })), a.consuming && (this.overallConsumingTransportsStatsMap[a.id] || (this.overallConsumingTransportsStatsMap[a.id] = {
            totalPacketsReceived: 0
          })));
          const m = {
            bytesReceived: u.bytesReceived,
            bytesSent: u.bytesSent,
            packetsSent: u.packetsSent,
            packetsReceived: u.packetsReceived,
            dtlsCipher: u.dtlsCipher,
            dtlsState: u.dtlsState,
            iceRole: u.iceRole
          };
          if (d.transport = m, a) {
            if (a.producing) {
              const g = this.overallProducingTransportsStatsMap[a.id];
              this.processProducingTransportStats(a.id, g, m);
            }
            if (a.consuming) {
              const g = this.overallConsumingTransportsStatsMap[a.id];
              this.processConsumingTransportStats(a.id, g, m);
            }
          }
          break;
        }
        case "remote-inbound-rtp": {
          const u = l, m = {
            jitter: u.jitter,
            fractionLost: u.fractionLost,
            roundTripTime: u.roundTripTime,
            roundTripTimeMeasurements: u.roundTripTimeMeasurements,
            totalRoundTripTime: u.totalRoundTripTime,
            packetsLost: u.packetsLost
          };
          d.remoteInboundRtp.set(u.localId, m);
          break;
        }
        case "outbound-rtp": {
          const u = l, m = n || this.outboundProducerMap.get(l.id);
          this.overallProducersStatsMap[m] || (this.overallProducersStatsMap[m] = {
            totalVideoPacketsSent: 0,
            totalAudioPacketsSent: 0
          });
          const g = this.overallProducersStatsMap[m];
          if (["video", "audio"].includes(u.mediaType)) {
            if (!this.outboundProducerMap.has(l.id)) {
              d.staleProducerStreamMap = !0, p && p.delete("outbound-rtp");
              break;
            }
            d.producerStreamMap.has(m) || d.producerStreamMap.set(m, {
              outboundVideoRtpId: [],
              outboundAudioRtpId: []
            });
            const T = {
              bytesSent: u.bytesSent,
              packetsSent: u.packetsSent,
              nackCount: u.nackCount
            };
            if (u.mediaType === "video") {
              if (u.decoderImplementation === "unknown")
                break;
              const S = u, R = {
                frameHeight: S.frameHeight,
                frameWidth: S.frameWidth,
                framesEncoded: S.framesEncoded,
                framesDropped: S.framesDropped ? S.framesDropped : S.droppedFrames,
                framesPerSecond: S.framesPerSecond ? S.framesPerSecond : S.framerateMean,
                framesSent: S.framesSent,
                keyFramesEncoded: S.keyFramesEncoded,
                firCount: S.firCount,
                encoderImplementation: S.encoderImplementation,
                hugeFramesSent: S.hugeFramesSent,
                pliCount: S.pliCount,
                qpSum: S.qpSum,
                qualityLimitationReason: S.qualityLimitationReason,
                qualityLimitationDurations: S.qualityLimitationDurations,
                qualityLimitationResolutionChanges: S.qualityLimitationResolutionChanges,
                totalEncodeTime: S.totalEncodeTime,
                totalPacketSendDelay: S.totalEncodeTime,
                retransmittedBytesSent: S.retransmittedBytesSent,
                retransmittedPacketsSent: S.retransmittedPacketsSent,
                ...T
              };
              d.outboundVideoRtp.set(l.id, R), d.producerStreamMap.get(m).outboundVideoRtpId.push(l.id), this.processOutboundProducerVideoStats(m, g, R);
            } else if (u.mediaType === "audio") {
              const S = u, R = {
                retransmittedBytesSent: S.retransmittedBytesSent,
                retransmittedPacketsSent: S.retransmittedPacketsSent,
                ...T
              };
              d.outboundAudioRtp.set(l.id, R), d.producerStreamMap.get(m).outboundAudioRtpId.push(l.id), this.processOutboundProducerAudioStats(m, g, R);
            }
          }
          break;
        }
        case "inbound-rtp": {
          const u = l, m = n || this.inboundConsumerMap.get(l.id);
          this.overallConsumersStatsMap[m] || (this.overallConsumersStatsMap[m] = {
            totalVideoPacketsReceived: 0,
            totalAudioPacketsReceived: 0
          });
          const g = this.overallConsumersStatsMap[m];
          if (["video", "audio"].includes(u.mediaType)) {
            if (!this.inboundConsumerMap.has(l.id)) {
              d.staleConsumerStreamMap = !0, p && p.delete("inbound-rtp");
              break;
            }
            d.consumerStreamMap.has(m) || d.consumerStreamMap.set(m, {
              inboundVideoRtpId: [],
              inboundAudioRtpId: []
            });
            const T = {
              bytesReceived: u.bytesReceived,
              packetsReceived: u.packetsReceived,
              packetsLost: u.packetsLost,
              jitter: u.jitter,
              nackCount: u.nackCount
            };
            if (u.mediaType === "video") {
              if (u.decoderImplementation === "unknown")
                break;
              const S = u, R = {
                frameHeight: S.frameHeight,
                frameWidth: S.frameWidth,
                framesDecoded: S.framesDecoded,
                framesDropped: S.framesDropped ? S.framesDropped : S.droppedFrames,
                framesPerSecond: S.framesPerSecond ? S.framesPerSecond : S.framerateMean,
                framesReceived: S.framesReceived,
                keyFramesDecoded: S.keyFramesDecoded,
                firCount: S.firCount,
                decoderImplementation: S.decoderImplementation,
                ...T
              };
              d.inboundVideoRtp.set(l.id, R), d.consumerStreamMap.get(m).inboundVideoRtpId.push(l.id), this.processInboundConsumerVideoStats(m, g, R);
            } else if (u.mediaType === "audio") {
              const S = u, R = {
                audioLevel: S.audioLevel,
                concealedSampels: S.concealedSampels,
                concealmentEvents: S.concealmentEvents,
                jitterBufferDelay: S.jitterBufferDelay,
                jitterBufferEmittedCount: S.jitterBufferEmittedCount,
                totalAudioEnergy: S.totalAudioEnergy,
                totalSamplesDuration: S.totalSamplesDuration,
                totalSamplesReceived: S.totalSamplesReceived,
                ...T
              };
              d.inboundAudioRtp.set(l.id, R), d.consumerStreamMap.get(m).inboundAudioRtpId.push(l.id), this.processInboundConsumerAudioStats(m, g, R);
            }
          }
          break;
        }
      }
    }
    if (d.outboundVideoRtp.forEach((l, u) => {
      l.remoteData = d.remoteInboundRtp.get(u);
    }), d.outboundAudioRtp.forEach((l, u) => {
      l.remoteData = d.remoteInboundRtp.get(u);
    }), d.candidatePair && (d.transport ? (d.transport.bytesReceived = d.candidatePair.bytesReceived, d.transport.bytesSent = d.candidatePair.bytesSent, d.transport.totalRoundTripTime = d.candidatePair.totalRoundTripTime, d.transport.availableOutgoingBitrate = d.candidatePair.availableOutgoingBitrate, d.transport.roundTripTime = d.candidatePair.currentRoundTripTime) : d.transport = {
      // candidateStats: result.candidatePair,
      bytesReceived: d.candidatePair.bytesReceived,
      bytesSent: d.candidatePair.bytesSent,
      totalRoundTripTime: d.candidatePair.totalRoundTripTime,
      availableOutgoingBitrate: d.candidatePair.availableOutgoingBitrate,
      roundTripTime: d.candidatePair.currentRoundTripTime
    }), d.transport && !d.transport.roundTripTime) {
      let l = 0, u = 0;
      d.remoteInboundRtp.forEach((m, g) => {
        m.roundTripTime && m.roundTripTime > l && (l = m.roundTripTime, u = m.totalRoundTripTime);
      }), d.transport.roundTripTime = l, d.transport.totalRoundTripTime = u;
    }
    return d;
  }
  getProducerStatsFromReport(t) {
    const s = [];
    try {
      t.producerStreamMap.forEach((i, n) => {
        const o = this.producerMap.get(n).track.getSettings(), d = i.outboundVideoRtpId.map((l) => {
          const u = t.outboundVideoRtp.get(l);
          return u.frameHeight || (u.frameHeight = o.height, u.frameWidth = o.width, u.framesPerSecond = o.frameRate), u;
        }), p = {
          producerId: n,
          videoStats: d,
          audioStats: i.outboundAudioRtpId.map((l) => t.outboundAudioRtp.get(l))
        };
        s.push(p);
      });
    } catch (i) {
      console.error("getProducersReport: ", i, t);
    }
    return s;
  }
  getConsumerStatsFromParsedConsumerStats(t, s, i) {
    let n;
    try {
      const { peerId: a, producerId: o } = this.consumerPeerIdMap.get(i), d = s == null ? void 0 : s.inboundVideoRtpId.map((p) => {
        const u = this.consumerMap.get(i).track.getSettings(), m = t.inboundVideoRtp.get(p);
        return m.frameHeight || (m.frameHeight = u.height, m.frameWidth = u.width, m.framesPerSecond = u.frameRate), m;
      });
      n = {
        consumerId: i,
        peerId: a,
        producerId: o,
        videoStats: d,
        audioStats: s == null ? void 0 : s.inboundAudioRtpId.map((p) => t.inboundAudioRtp.get(p))
      };
    } catch (a) {
      console.error("getConsumerStatsFromParsedConsumerStats: ", a, t);
    }
    return n;
  }
  getConsumerStatsFromReport(t) {
    const s = [];
    try {
      t.consumerStreamMap.forEach((i, n) => {
        s.push(this.getConsumerStatsFromParsedConsumerStats(t, i, n));
      });
    } catch (i) {
      console.error("getConsumerStatsFromReport: ", i, t);
    }
    return s;
  }
}
class Mh extends pu {
}
function ka(r, e, t, s) {
  if (typeof t == "function" && s instanceof e)
    t.call(null, s, r);
  else
    throw s;
}
function bd(r, e, t) {
  const s = r.value;
  return r.value = function(...i) {
    try {
      const n = s.apply(this, i);
      return n && n instanceof Promise ? n.catch((a) => {
        ka(this, e, t, a);
      }) : n;
    } catch (n) {
      ka(this, e, t, n);
    }
    return null;
  }, r;
}
const J = (r, e) => (t, s, i) => {
  const n = i.value;
  return i.value = function(...a) {
    try {
      const o = n.apply(this, a);
      return o && o instanceof Promise ? o.catch((d) => {
        ka(this, r, e, d);
      }) : o;
    } catch (o) {
      ka(this, r, e, o);
    }
    return null;
  }, i;
}, Oh = (r, e) => (t, s, i) => {
  if (i)
    return bd(i, r, e);
  for (const n of Reflect.ownKeys(t.prototype).filter((a) => a !== "constructor")) {
    const a = Object.getOwnPropertyDescriptor(t.prototype, n);
    a.value instanceof Function && Object.defineProperty(t.prototype, n, bd(a, r, e));
  }
};
var q = globalThis && globalThis.__decorate || function(r, e, t, s) {
  var i = arguments.length, n = i < 3 ? e : s === null ? s = Object.getOwnPropertyDescriptor(e, t) : s, a;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function")
    n = Reflect.decorate(r, e, t, s);
  else
    for (var o = r.length - 1; o >= 0; o--)
      (a = r[o]) && (n = (i < 3 ? a(n) : i > 3 ? a(e, t, n) : a(e, t)) || n);
  return i > 3 && n && Object.defineProperty(e, t, n), n;
};
const G = console;
let H = class {
  constructor(e = "https://api.testingv3.dyte.in", t = "Blink", s = gn.PRODUCTION, i, n, a) {
    h(this, "eventHandler");
    h(this, "measurements");
    h(this, "producingTransport");
    h(this, "consumingTransport");
    h(this, "producers", /* @__PURE__ */ new Map());
    h(this, "consumers", /* @__PURE__ */ new Map());
    h(this, "iceServers");
    h(this, "connectionInfoPromise");
    h(this, "pingStatsTimeout");
    h(this, "logger");
    h(this, "env");
    h(this, "peerId");
    h(this, "consumerSharedMediaStatesMap", /* @__PURE__ */ new Map());
    h(this, "currentUserMediaStates", {});
    switch (this.env = s, this.logger = n, this.peerId = a, this.eventHandler = new Sh({ logger: n, peerId: a, env: s }), this.logger.debug("callStats::engineName: ", { engineName: t }), t) {
      case "Blink":
        this.measurements = new Ah();
        break;
      case "Gecko":
        this.measurements = new pu();
        break;
      case "WebKit":
        this.measurements = new Mh();
        break;
      default:
        throw Error(`Unknown engineName! ${t}`);
    }
    this.measurements.callStatsInstance = this, this.registerProducer = this.registerProducer.bind(this), this.registerConsumer = this.registerConsumer.bind(this);
  }
  registerIceServers(e) {
    this.iceServers = e;
  }
  registerConsumer(e) {
    var t;
    this.consumerSharedMediaStatesMap.has(e.id) || this.consumerSharedMediaStatesMap.set(e.id, {}), this.consumers.set(e.id, e), this.measurements.registerConsumer(e), this.logger.debug("callStats::registerConsumer", { consumerId: e.id, consumerkind: e.kind, isScreenShare: !!((t = e.appData) != null && t.screenShare) }), e.observer.on("close", this.deRegisterConsumer.bind(this, e));
  }
  registerProducer(e) {
    var t;
    this.producers.set(e.id, e), this.measurements.registerProducer(e), this.logger.debug("callStats::registerProducer", { producerId: e.id, producerKind: e.kind, isScreenShare: !!((t = e.appData) != null && t.screenShare) }), e.observer.on("close", this.deRegisterProducer.bind(this, e));
  }
  sendConsumerSharedMediaStateEvent(e, t) {
    this.consumerSharedMediaStatesMap.has(e) || this.consumerSharedMediaStatesMap.set(e, {});
    const s = this.consumerSharedMediaStatesMap.get(e);
    this.consumerSharedMediaStatesMap.set(e, Object.assign(s, t));
  }
  registerProducingTransport(e) {
    var s;
    this.producingTransport = e, e.observer.on("close", this.disconnectProducingTransport.bind(this, e)), e.observer.on("disconnect", this.disconnectProducingTransport.bind(this, e)), Array.from(
      // eslint-disable-next-line no-underscore-dangle
      ((s = e._producers) == null ? void 0 : s.values()) || []
    ).forEach((i) => {
      this.registerProducer(i);
    }), e.observer.on("newproducer", this.registerProducer);
  }
  registerConsumingTransport(e) {
    var s;
    this.consumingTransport = e, e.observer.on("close", this.disconnectConsumingTransport.bind(this, e)), e.observer.on("disconnect", this.disconnectConsumingTransport.bind(this, e)), Array.from(
      // eslint-disable-next-line no-underscore-dangle
      ((s = e._consumers) == null ? void 0 : s.values()) || []
    ).forEach((i) => {
      this.registerConsumer(i);
    }), e.observer.on("newconsumer", this.registerConsumer);
  }
  deRegisterConsumer(e) {
    this.consumers.delete(e.id);
  }
  deRegisterProducer(e) {
    this.producers.delete(e.id);
  }
  disconnectConsumingTransport() {
    this.consumingTransport = void 0;
  }
  disconnectProducingTransport() {
    this.producingTransport = void 0;
  }
  callEvent(e) {
    this.eventHandler.callEvent(e);
  }
  sendPreCallTestBeginEvent() {
    this.connectionInfoPromise = this.measurements.getNetworkInfo(this.iceServers), this.eventHandler.callEvent({
      event: k.PRECALL_TEST_BEGIN,
      timestamp: new Date()
    }), this.connectionInfoPromise && this.connectionInfoPromise.then((e) => {
      this.eventHandler.callEvent({
        event: k.PRECALL_TEST_COMPLETE,
        metaData: {
          connectionInfo: e
        },
        timestamp: new Date()
      });
    });
  }
  sendScreenShareToggleEvent(e, t) {
    this.currentUserMediaStates.screen = e, this.eventHandler.callEvent({
      event: e ? k.SCREENSHARE_STARTED : k.SCREENSHARE_STOPPED,
      metaData: {
        ssrc: t
      },
      timestamp: new Date()
    });
  }
  sendScreenShareRequestedEvent() {
    this.eventHandler.callEvent({
      event: k.SCREENSHARE_START_REQUESTED,
      timestamp: new Date()
    });
  }
  sendActiveSpeakerEvent(e) {
    this.eventHandler.callEvent({
      event: k.DOMINANT_SPEAKER,
      metaData: {
        peerId: e
      },
      timestamp: new Date()
    });
  }
  devices(e, t) {
    this.eventHandler.callEvent({
      event: e === jt.AUDIO && k.AUDIO_DEVICES_UPDATES || e === jt.VIDEO && k.VIDEO_DEVICES_UPDATES || e === jt.SPEAKER && k.SPEAKER_DEVICES_UPDATES,
      metaData: {
        deviceList: t
      },
      timestamp: new Date()
    });
  }
  selectedDevice(e, t) {
    this.eventHandler.callEvent({
      event: e === jt.AUDIO && k.SELECTED_MICROHPONE_UPDATE || e === jt.VIDEO && k.SELECTED_CAMERA_UPDATE || e === jt.SPEAKER && k.SELECTED_SPEAKER_UPDATE,
      metaData: {
        device: t
      },
      timestamp: new Date()
    });
  }
  mediaPermission(e, t) {
    this.eventHandler.callEvent({
      event: k.MEDIA_PERMISSION,
      metaData: {
        deviceType: e,
        permission: t
      },
      timestamp: new Date()
    });
  }
  mediaPlaybackFailed(e) {
    this.eventHandler.callEvent({
      event: e === jt.AUDIO && k.AUDIO_PLAY_FAILED || e === jt.VIDEO && k.VIDEO_PLAY_FAILED,
      metaData: {
        deviceType: e
      },
      timestamp: new Date()
    });
  }
  mediaTrackMuted(e) {
    this.eventHandler.callEvent({
      event: e === jt.AUDIO && k.AUDIO_TRACK_MUTED || e === jt.VIDEO && k.VIDEO_TRACK_MUTED,
      metaData: {
        deviceType: e
      },
      timestamp: new Date()
    });
  }
  tabChanged(e) {
    this.eventHandler.callEvent({
      event: k.TAB_CHANGE,
      metaData: { isMeetingsTabActive: e },
      timestamp: new Date()
    });
  }
  browserBackgrounded() {
    this.eventHandler.callEvent({
      event: k.BROWSER_BACKGROUNDED,
      timestamp: new Date()
    });
  }
  browserForegrounded() {
    this.eventHandler.callEvent({
      event: k.BROWSER_FOREGROUNDED,
      timestamp: new Date()
    });
  }
  legacySwitch(e) {
    this.eventHandler.callEvent({
      event: k.LEGACY_SWITCH,
      metadata: { on: e },
      timestamp: new Date()
    });
  }
  async getPreCallTestResults() {
    return this.connectionInfoPromise;
  }
  sendCallJoinBeginEvent(e) {
    e = {
      ...e,
      meetingEnv: this.env
    }, e.deviceInfo = {
      ...e.deviceInfo,
      userAgent: navigator.userAgent,
      cpus: navigator.hardwareConcurrency,
      memory: navigator.deviceMemory
    }, this.eventHandler.callEvent({
      event: k.CALL_JOIN_BEGIN,
      metaData: {
        peerMetaData: e
      },
      timestamp: new Date()
    });
  }
  sendNetworkQualityTestBeginEvent(e) {
    this.eventHandler.callEvent({
      event: k.NET_QUALITY_TEST_BEGIN,
      timestamp: new Date()
    }), new Promise(async (s, i) => {
      const n = [];
      try {
        for (const a of e)
          try {
            if (a.iceServers && a.iceServers.length > 0) {
              const o = await this.measurements.getNetworkQuality(a.iceServers);
              n.push({
                ...a,
                networkResults: o
              });
            }
          } catch (o) {
            console.warn("Error handling ", o);
          }
        s({
          regionData: n
        });
      } catch (a) {
        console.warn("Error in callstats, ", a), i(a);
      }
    }).then((s) => {
      this.eventHandler.callEvent({
        event: k.NET_QUALITY_TEST_END,
        timestamp: new Date(),
        metaData: s
      });
    });
  }
  sendWebSocketConnectedEvent() {
    this.eventHandler.callEvent({
      event: k.WEBSOCKET_CONNECTED,
      timestamp: new Date()
    });
  }
  sendTransportConnectedEvent() {
    this.eventHandler.callEvent({
      event: k.TRANSPORT_CONNECTED,
      timestamp: new Date()
    });
  }
  sendAudioToggleEvent(e) {
    this.currentUserMediaStates.audio = e;
    let t;
    e ? t = k.AUDIO_ON : t = k.AUDIO_OFF, this.eventHandler.callEvent({
      event: t,
      timestamp: new Date()
    });
  }
  sendVideoToggleEvent(e) {
    this.currentUserMediaStates.video = e;
    let t;
    e ? t = k.VIDEO_ON : t = k.VIDEO_OFF, this.eventHandler.callEvent({
      event: t,
      timestamp: new Date()
    });
  }
  sendParticipantRoleToggleEvent(e) {
    this.eventHandler.callEvent({
      event: k.PARTICIPANT_ROLE,
      timestamp: new Date(),
      metaData: e
    });
  }
  startPingStats(e = 7e3) {
    this.sendPingStatsEvent(!1), this.pingStatsTimeout = setInterval(this.sendPingStatsEvent.bind(this), e);
  }
  stopPingStats() {
    clearInterval(this.pingStatsTimeout);
  }
  async sendPingStatsEvent(e = !0) {
    let t, s;
    if (this.producingTransport && (t = await this.measurements.getProcessedStats(this.producingTransport, !1, !0), !t || !(t != null && t.producerReport))) {
      this.logger.debug("callStats::sendPingStatsEvent::staleProducingTransport", { disclaimer: "Stale producer? Regenerating Stream Maps!" });
      const n = await this.measurements.getProducersReport([...this.producers.values()]);
      t && n ? t.producerReport = n : (t = await this.measurements.getProcessedStats(this.producingTransport, !1, !0), (!t || !(t != null && t.producerReport)) && this.logger.debug("callStats::sendPingStatsEvent::noProducingTransportReport", { disclaimer: "Stream maps invalid despite regenerating!" }));
    }
    if (this.consumingTransport && (s = await this.measurements.getProcessedStats(this.consumingTransport, !0, !1), !s || !s.consumerReport)) {
      this.logger.debug("callStats::sendPingStatsEvent::staleConsumingTransport", { disclaimer: "Stale consumer? Regenerating Stream Maps!" });
      const n = await this.measurements.getConsumersReport([...this.consumers.values()]);
      s && n ? s.consumerReport = n : (s = await this.measurements.getProcessedStats(this.consumingTransport, !0, !1), (!s || !s.consumerReport) && this.logger.debug("callStats::sendPingStatsEvent::noConsumingTransportReport", { disclaimer: "Stream maps invalid despite regenerating!" }));
    }
    const i = {
      producingTransportStats: t ? t == null ? void 0 : t.transportReport : void 0,
      consumingTransportStats: s ? s == null ? void 0 : s.transportReport : void 0,
      producerStats: [].concat((t == null ? void 0 : t.producerReport) || []).concat((s == null ? void 0 : s.producerReport) || []),
      consumerStats: [].concat((s == null ? void 0 : s.consumerReport) || []).concat((t == null ? void 0 : t.consumerReport) || [])
    };
    if (e && i.producerStats.length === 0 && i.consumerStats.length === 0) {
      await this.eventHandler.flush();
      return;
    }
    this.eventHandler.callEvent({
      event: k.PING_STAT,
      metaData: i,
      timestamp: new Date()
    });
  }
  sendIVSPlayerRebufferEvent() {
    this.eventHandler.callEvent({
      event: k.IVS_PLAYER_REBUFFERING,
      timestamp: new Date()
    });
  }
  sendIVSPlayerAudioBlockEvent() {
    this.eventHandler.callEvent({
      event: k.IVS_PLAYER_AUDIO_BLOCKED,
      timestamp: new Date()
    });
  }
  sendIVSPlayerPlaybackBlockedEvent() {
    this.eventHandler.callEvent({
      event: k.IVS_PLAYER_PLAYBACK_BLOCKED,
      timestamp: new Date()
    });
  }
  sendIVSPlayerNetworkUnavailableEvent() {
    this.eventHandler.callEvent({
      event: k.IVS_PLAYER_NETWORK_UNAVAILABLE,
      timestamp: new Date()
    });
  }
  sendIVSPlayerInitializedEvent() {
    this.eventHandler.callEvent({
      event: k.IVS_PLAYER_INITIALIZED,
      timestamp: new Date()
    });
  }
  sendIVSPlayerWorkerErrorEvent() {
    this.eventHandler.callEvent({
      event: k.IVS_PLAYER_WORKER_ERROR,
      timestamp: new Date()
    });
  }
  sendIVSPlayerErrorEvent(e) {
    this.eventHandler.callEvent({
      event: k.IVS_PLAYER_ERROR,
      timestamp: new Date(),
      metaData: e
    });
  }
  sendIVSPlayerRecoverableErrorEvent(e) {
    this.eventHandler.callEvent({
      event: k.IVS_PLAYER_RECOVERABLE_ERROR,
      timestamp: new Date(),
      metaData: e
    });
  }
  sendIVSPlayerAnalyticsEvent(e) {
    this.eventHandler.callEvent({
      event: k.IVS_PLAYER_ANALYTICS_EVENT,
      timestamp: new Date(),
      metaData: e
    });
  }
  sendIVSPlayerPlaybackRateChangedEvent(e) {
    this.eventHandler.callEvent({
      event: k.IVS_PLAYER_PLAYBACK_RATE_CHANGED,
      timestamp: new Date(),
      metaData: {
        updatedPlaybackRate: e
      }
    });
  }
  sendIVSPlayerQualityChanged(e) {
    this.eventHandler.callEvent({
      event: k.IVS_PLAYER_QUALITY_CHANGED,
      timestamp: new Date(),
      metaData: e
    });
  }
  sendPlayerLiveLatency(e) {
    this.eventHandler.callEvent({
      event: k.LIVESTREAM_LATENCY,
      timestamp: new Date(),
      metaData: {
        latency: e
      }
    });
  }
  sendDisconnectEvent() {
    this.eventHandler.callEvent({
      event: k.DISCONNECT,
      timestamp: new Date()
    });
  }
  sendReconnectEvent() {
    this.eventHandler.callEvent({
      event: k.RECONNECT_ATTEMPT,
      timestamp: new Date()
    });
  }
};
q([
  J(TypeError, (r, e) => G.error(e, r))
], H.prototype, "registerIceServers", null);
q([
  J(TypeError, (r, e) => G.error(e, r))
], H.prototype, "registerConsumer", null);
q([
  J(TypeError, (r, e) => G.error(e, r))
], H.prototype, "registerProducer", null);
q([
  J(TypeError, (r, e) => G.error(e, r))
], H.prototype, "sendConsumerSharedMediaStateEvent", null);
q([
  J(TypeError, (r, e) => G.error(e, r))
], H.prototype, "registerProducingTransport", null);
q([
  J(TypeError, (r, e) => G.error(e, r))
], H.prototype, "registerConsumingTransport", null);
q([
  J(TypeError, (r, e) => G.error(e, r))
], H.prototype, "deRegisterConsumer", null);
q([
  J(TypeError, (r, e) => G.error(e, r))
], H.prototype, "deRegisterProducer", null);
q([
  J(TypeError, (r, e) => G.error(e, r))
], H.prototype, "disconnectConsumingTransport", null);
q([
  J(TypeError, (r, e) => G.error(e, r))
], H.prototype, "disconnectProducingTransport", null);
q([
  J(TypeError, (r, e) => G.error(e, r))
], H.prototype, "sendPreCallTestBeginEvent", null);
q([
  J(TypeError, (r, e) => G.error(e, r))
], H.prototype, "sendScreenShareToggleEvent", null);
q([
  J(TypeError, (r, e) => G.error(e, r))
], H.prototype, "sendScreenShareRequestedEvent", null);
q([
  J(TypeError, (r, e) => G.error(e, r))
], H.prototype, "sendActiveSpeakerEvent", null);
q([
  J(TypeError, (r, e) => G.error(e, r))
], H.prototype, "devices", null);
q([
  J(TypeError, (r, e) => G.error(e, r))
], H.prototype, "selectedDevice", null);
q([
  J(TypeError, (r, e) => G.error(e, r))
], H.prototype, "mediaPermission", null);
q([
  J(TypeError, (r, e) => G.error(e, r))
], H.prototype, "mediaPlaybackFailed", null);
q([
  J(TypeError, (r, e) => G.error(e, r))
], H.prototype, "mediaTrackMuted", null);
q([
  J(TypeError, (r, e) => G.error(e, r))
], H.prototype, "tabChanged", null);
q([
  J(TypeError, (r, e) => G.error(e, r))
], H.prototype, "browserBackgrounded", null);
q([
  J(TypeError, (r, e) => G.error(e, r))
], H.prototype, "browserForegrounded", null);
q([
  J(TypeError, (r, e) => G.error(e, r))
], H.prototype, "legacySwitch", null);
q([
  J(TypeError, (r, e) => G.error(e, r))
], H.prototype, "getPreCallTestResults", null);
q([
  J(TypeError, (r, e) => G.error(e, r))
], H.prototype, "sendCallJoinBeginEvent", null);
q([
  J(TypeError, (r, e) => G.error(e, r))
], H.prototype, "sendNetworkQualityTestBeginEvent", null);
q([
  J(TypeError, (r, e) => G.error(e, r))
], H.prototype, "sendWebSocketConnectedEvent", null);
q([
  J(TypeError, (r, e) => G.error(e, r))
], H.prototype, "sendTransportConnectedEvent", null);
q([
  J(TypeError, (r, e) => G.error(e, r))
], H.prototype, "sendAudioToggleEvent", null);
q([
  J(TypeError, (r, e) => G.error(e, r))
], H.prototype, "sendVideoToggleEvent", null);
q([
  J(TypeError, (r, e) => G.error(e, r))
], H.prototype, "sendParticipantRoleToggleEvent", null);
q([
  J(TypeError, (r, e) => G.error(e, r))
], H.prototype, "startPingStats", null);
q([
  J(TypeError, (r, e) => G.error(e, r))
], H.prototype, "stopPingStats", null);
q([
  J(TypeError, (r, e) => G.error(e, r))
], H.prototype, "sendPingStatsEvent", null);
q([
  J(TypeError, (r, e) => G.error(e, r))
], H.prototype, "sendIVSPlayerRebufferEvent", null);
q([
  J(TypeError, (r, e) => G.error(e, r))
], H.prototype, "sendIVSPlayerAudioBlockEvent", null);
q([
  J(TypeError, (r, e) => G.error(e, r))
], H.prototype, "sendIVSPlayerPlaybackBlockedEvent", null);
q([
  J(TypeError, (r, e) => G.error(e, r))
], H.prototype, "sendIVSPlayerNetworkUnavailableEvent", null);
q([
  J(TypeError, (r, e) => G.error(e, r))
], H.prototype, "sendIVSPlayerInitializedEvent", null);
q([
  J(TypeError, (r, e) => G.error(e, r))
], H.prototype, "sendIVSPlayerWorkerErrorEvent", null);
q([
  J(TypeError, (r, e) => G.error(e, r))
], H.prototype, "sendIVSPlayerErrorEvent", null);
q([
  J(TypeError, (r, e) => G.error(e, r))
], H.prototype, "sendIVSPlayerRecoverableErrorEvent", null);
q([
  J(TypeError, (r, e) => G.error(e, r))
], H.prototype, "sendIVSPlayerAnalyticsEvent", null);
q([
  J(TypeError, (r, e) => G.error(e, r))
], H.prototype, "sendIVSPlayerPlaybackRateChangedEvent", null);
q([
  J(TypeError, (r, e) => G.error(e, r))
], H.prototype, "sendIVSPlayerQualityChanged", null);
q([
  J(TypeError, (r, e) => G.error(e, r))
], H.prototype, "sendPlayerLiveLatency", null);
H = q([
  Oh(TypeError, (r, e) => G.error(e, r))
], H);
const Nh = H;
class Lh extends bt {
  constructor() {
    super(...arguments);
    h(this, "stats");
    h(this, "roomURL");
    h(this, "peerId");
    h(this, "backend");
    h(this, "iceServers");
    h(this, "initialized", !1);
    h(this, "stalled", !1);
    // Initialization will never occur
    h(this, "ipInformation");
    h(this, "logger");
  }
  async initialize({ peerId: t, engineName: s, env: i = gn.PRODUCTION, iceServers: n, apiBase: a = "https://api.cluster.dyte.in", flags: o, logger: d = console }) {
    var p, l, u;
    try {
      this.peerId = t, this.logger = d, this.ipInformation = await Rc.getIPDetails({ peerId: t }), this.backend = new Nh(a, s, i, o, d, t), this.iceServers = n, (p = this.backend) == null || p.registerIceServers(this.iceServers), this.initialized = !0, (u = (l = this.backend) == null ? void 0 : l.eventHandler) == null || u.emit("initialized", this.ipInformation), this.emit("initialized", this.ipInformation), this.startPreCallTest();
    } catch (m) {
      this.logger.error("callStats::CallStatsIntegration: ", { error: { reason: m.reason } }), this.stallCallStats();
    }
  }
  setRoomName(t) {
    this.roomURL = t;
  }
  configureSendTransport(t) {
    var s;
    (s = this.backend) == null || s.registerProducingTransport(t);
  }
  configureRecvTransport(t) {
    var s;
    (s = this.backend) == null || s.registerConsumingTransport(t);
  }
  async candidateRegionalNetworkQualityTest(t) {
    var s;
    try {
      (s = this.backend) == null || s.sendNetworkQualityTestBeginEvent(t);
    } catch (i) {
      this.logger.error("callStats::sendNetworkQualityTestBeginEvent", { error: { reason: i.reason } });
    }
  }
  async roomJoined(t) {
    var s, i;
    (s = this.backend) == null || s.sendCallJoinBeginEvent(t), this.backend, (i = this.backend) == null || i.startPingStats();
  }
  audioOff() {
    var t;
    (t = this.backend) == null || t.sendAudioToggleEvent(!1);
  }
  audioOn() {
    var t;
    (t = this.backend) == null || t.sendAudioToggleEvent(!0);
  }
  videoOff() {
    var t;
    (t = this.backend) == null || t.sendVideoToggleEvent(!1);
  }
  videoOn() {
    var t;
    (t = this.backend) == null || t.sendVideoToggleEvent(!0);
  }
  callEnded() {
    var t, s;
    (t = this.backend) == null || t.stopPingStats(), (s = this.backend) == null || s.sendDisconnectEvent();
  }
  screenShareStart(t) {
    var s;
    (s = this.backend) == null || s.sendScreenShareToggleEvent(!0, t);
  }
  consumerSharedMediaState(t, s) {
    var i;
    (i = this.backend) == null || i.sendConsumerSharedMediaStateEvent(t, s);
  }
  screenShareStop(t) {
    var s;
    (s = this.backend) == null || s.sendScreenShareToggleEvent(!1, t);
  }
  screenShareRequested() {
    var t;
    (t = this.backend) == null || t.sendScreenShareRequestedEvent();
  }
  activeSpeaker(t) {
    var s;
    t === this.peerId && ((s = this.backend) == null || s.sendActiveSpeakerEvent(t));
  }
  devices(t, s) {
    var i;
    (i = this.backend) == null || i.devices(t, s);
  }
  selectedDevice(t, s) {
    var i;
    (i = this.backend) == null || i.selectedDevice(t, s);
  }
  mediaPermission(t, s) {
    var i;
    (i = this.backend) == null || i.mediaPermission(t, s);
  }
  mediaPlaybackFailed(t) {
    var s;
    (s = this.backend) == null || s.mediaPlaybackFailed(t);
  }
  mediaTrackMuted(t) {
    var s;
    (s = this.backend) == null || s.mediaTrackMuted(t);
  }
  tabChanged(t = !1) {
    var s;
    (s = this.backend) == null || s.tabChanged(t);
  }
  browserBackgrounded() {
    var t;
    (t = this.backend) == null || t.browserBackgrounded();
  }
  browserForegrounded() {
    var t;
    (t = this.backend) == null || t.browserForegrounded();
  }
  legacySwitch(t) {
    var s;
    (s = this.backend) == null || s.legacySwitch(t);
  }
  async startPreCallTest() {
    var t;
    (t = this.backend) == null || t.sendPreCallTestBeginEvent();
  }
  onPreCallTestResults(t) {
    var s;
    return (s = this.backend) == null || s.eventHandler.once("precall_end", t), t;
  }
  onReceivingConsumerAudioStatus(t) {
    var s;
    (s = this.backend) == null || s.eventHandler.on("consumer_audio_status", t);
  }
  onReceivingConsumerVideoStatus(t) {
    var s;
    (s = this.backend) == null || s.eventHandler.on("consumer_video_status", t);
  }
  onReceivingProducerAudioStatus(t) {
    var s;
    (s = this.backend) == null || s.eventHandler.on("producer_audio_status", t);
  }
  onReceivingProducerVideoStatus(t) {
    var s;
    (s = this.backend) == null || s.eventHandler.on("producer_video_status", t);
  }
  onReceivingProducingTransportStatus(t) {
    var s;
    (s = this.backend) == null || s.eventHandler.on("producing_transport_status", t);
  }
  onReceivingConsumingTransportStatus(t) {
    var s;
    (s = this.backend) == null || s.eventHandler.on("consuming_transport_status", t);
  }
  onSafeInitialization(t) {
    if (this.initialized)
      t(this.ipInformation, !1);
    else if (!this.stalled) {
      const s = (i) => {
        t(i, !0);
      };
      return this.once("initialized", s), s;
    }
    return () => {
    };
  }
  removeInitializationListener(t) {
    this.removeListener("initialized", t);
  }
  stallCallStats() {
    this.stalled = !0, this.removeAllListeners("initialized");
  }
  ivsPlayerEvent(t, s) {
    var i, n, a, o, d, p, l, u, m, g, T;
    switch (t) {
      case "PlayerRebuffering":
        (i = this.backend) == null || i.sendIVSPlayerRebufferEvent();
        break;
      case "PlayerAudioBlocked":
        (n = this.backend) == null || n.sendIVSPlayerAudioBlockEvent();
        break;
      case "PlayerPlaybackBlocked":
        (a = this.backend) == null || a.sendIVSPlayerPlaybackBlockedEvent();
        break;
      case "PlayerNetworkUnavailable":
        (o = this.backend) == null || o.sendIVSPlayerNetworkUnavailableEvent();
        break;
      case "PlayerInitialized":
        (d = this.backend) == null || d.sendIVSPlayerInitializedEvent();
        break;
      case "PlayerWorkerError":
        (p = this.backend) == null || p.sendIVSPlayerWorkerErrorEvent();
        break;
      case "PlayerError":
        (l = this.backend) == null || l.sendIVSPlayerErrorEvent(s);
        break;
      case "PlayerRecoverableError":
        (u = this.backend) == null || u.sendIVSPlayerRecoverableErrorEvent(s);
        break;
      case "PlayerAnalyticsEvent":
        (m = this.backend) == null || m.sendIVSPlayerAnalyticsEvent(s);
        break;
      case "PlayerPlaybackRateChanged":
        (g = this.backend) == null || g.sendIVSPlayerPlaybackRateChangedEvent(s);
        break;
      case "PlayerQualityChanged":
        (T = this.backend) == null || T.sendIVSPlayerQualityChanged(s);
        break;
    }
  }
  livestreamLatency(t) {
    var s;
    (s = this.backend) == null || s.sendPlayerLiveLatency(t);
  }
}
const A = new Lh();
A.setMaxListeners(30);
function xh(r) {
  const { length: e } = this, t = r >= 0 ? r : e + r;
  return t < 0 || t >= e ? void 0 : this[t];
}
Array.prototype.at || Object.assign(Array.prototype, { at: xh });
function Uh(r) {
  const { length: e } = this, t = r >= 0 ? r : e + r;
  return t < 0 || t >= e ? void 0 : this[t];
}
String.prototype.at || Object.assign(String.prototype, { at: Uh });
var _n;
(function(r) {
  r.skip = "SKIP", r.onAccept = "ON_ACCEPT", r.skipOnPrivilegedUserEntry = "SKIP_ON_PRIVILEGED_USER_ENTRY", r.skipOnAccept = "SKIP_ON_ACCEPT";
})(_n || (_n = {}));
var Jr;
(function(r) {
  r.none = "NONE", r.recorder = "RECORDER", r.livestreamer = "LIVESTREAMER";
})(Jr || (Jr = {}));
var Da;
(function(r) {
  r.groupCall = "GROUP_CALL", r.webinar = "WEBINAR", r.audioRoom = "AUDIO_ROOM", r.livestream = "LIVESTREAM";
})(Da || (Da = {}));
var Pd;
(function(r) {
  r.SKIP = "skip", r.SKIP_ON_PRIVILEGED_USER_ENTRY = "skipOnPrivilegedUserEntry", r.ON_ACCEPT = "skipOnAccept", r.SKIP_ON_ACCEPT = "skipOnAccept";
})(Pd || (Pd = {}));
Da.groupCall, _n.skipOnAccept, Jr.none;
Da.groupCall, Jr.none, _n.skipOnAccept;
let hu = "hXgU8Wc8pwuGNq9ms5q9Hh";
var Nl;
typeof process != "undefined" && (Nl = process == null ? void 0 : process.env) != null && Nl.FLAGSMITH_ENVIRONMENT_KEY && (hu = process.env.FLAGSMITH_ENVIRONMENT_KEY);
function Vh(r = []) {
  const e = {};
  return r.forEach((t) => {
    e[t.feature.name] = {
      enabled: t.enabled,
      value: t.feature_state_value
    };
  }), e;
}
class Fh {
  constructor(e = hu) {
    h(this, "flags", {});
    h(this, "environmentKey", null);
    this.environmentKey = e, this.identify = this.identify.bind(this), this.getValue = this.getValue.bind(this), this.hasFeature = this.hasFeature.bind(this), this.getAllFlags = this.getAllFlags.bind(this);
  }
  async identify(e, t = {}, s = !1, i = 5e3) {
    const n = JSON.parse(JSON.stringify(t)), a = Object.entries(n).map((o) => ({
      trait_key: o[0],
      trait_value: o[1]
    }));
    try {
      const o = "_" + (Math.random() + 1).toString(36).substring(2), d = await Pa.post("https://edge.api.flagsmith.com/api/v1/identities/", {
        identifier: e + (s ? o : ""),
        traits: a
      }, {
        headers: {
          "Content-Type": "application/json",
          "X-Environment-Key": this.environmentKey
        },
        timeout: i
      });
      this.flags = Vh(d.data.flags || []);
    } catch (o) {
    }
    return this.flags;
  }
  getValue(e) {
    return this.flags && this.flags[e] && this.flags[e].value;
  }
  hasFeature(e) {
    return this.flags && this.flags[e] && this.flags[e].enabled;
  }
  getAllFlags() {
    return this.flags;
  }
}
const M = new Fh(), mu = [-2, -1, 0, 1, 2], jh = [0, 1, 2, 3, 4];
function $h(r) {
  let e = "0", t = "0", s = "0";
  if (r.length == 4)
    e = "0x" + r[1] + r[1], t = "0x" + r[2] + r[2], s = "0x" + r[3] + r[3];
  else if (r.length == 7)
    e = "0x" + r[1] + r[2], t = "0x" + r[3] + r[4], s = "0x" + r[5] + r[6];
  else
    throw new Error("[dyte] Invalid hex color code provided");
  return [+e, +t, +s];
}
const Hh = (r, e, t) => {
  let s, i, n;
  if (e == 0)
    s = i = n = t;
  else {
    const a = (p, l, u) => (u < 0 && (u += 1), u > 1 && (u -= 1), u < 0.16666666666666666 ? p + (l - p) * 6 * u : u < 0.5 ? l : u < 0.6666666666666666 ? p + (l - p) * (0.6666666666666666 - u) * 6 : p), o = t < 0.5 ? t * (1 + e) : t + e - t * e, d = 2 * t - o;
    s = a(d, o, r + 1 / 3), i = a(d, o, r), n = a(d, o, r - 1 / 3);
  }
  return [Math.round(s * 255), Math.round(i * 255), Math.round(n * 255)];
}, Bh = (r, e, t) => {
  r /= 255, e /= 255, t /= 255;
  const s = Math.max(r, e, t), i = Math.min(r, e, t);
  let n, a;
  const o = (s + i) / 2;
  if (s == i)
    n = a = 0;
  else {
    const d = s - i;
    switch (a = o > 0.5 ? d / (2 - s - i) : d / (s + i), s) {
      case r:
        n = (e - t) / d + (e < t ? 6 : 0);
        break;
      case e:
        n = (t - r) / d + 2;
        break;
      case t:
        n = (r - e) / d + 4;
        break;
    }
    n /= 6;
  }
  return [n, a, o];
}, qh = (r, e, t) => {
  const s = (i) => i.toString(16).padStart(2, "0");
  return `#${s(r)}${s(e)}${s(t)}`;
}, fu = (r, e = mu, t = 0.4) => {
  const s = [], [i, n, a] = $h(r), [o, d, p] = Bh(i, n, a), l = Math.round(p * 100);
  l > 70 ? t = 0.8 : l > 60 ? t = 0.9 : l < 10 ? t = 0.075 : l < 42 && (t = 0.3);
  const u = e.findIndex((R) => R === 0);
  if (u === -1)
    throw new Error("Invalid reducer provided, it must contain atleast one zero");
  const m = 5 - u, g = u + 1, T = (100 - l) / m, S = l / g;
  for (const R of e) {
    let D;
    R < 0 ? D = l + R * S * t : R > 0 ? D = l + R * T * t : D = l;
    const [I, re, ge] = Hh(o, d, D / 100);
    s.push(qh(I, re, ge));
  }
  return s;
}, Gh = (r) => {
  const [e, t, s, i, n] = fu(r, mu);
  return { 300: e, 400: t, 500: s, 600: i, 700: n };
}, Wh = (r) => {
  const [e, t, s, i, n] = fu(r, jh);
  return { 1e3: e, 900: t, 800: s, 700: i, 600: n };
};
function Jh() {
  this.__data__ = [], this.size = 0;
}
function gu(r, e) {
  return r === e || r !== r && e !== e;
}
function io(r, e) {
  for (var t = r.length; t--; )
    if (gu(r[t][0], e))
      return t;
  return -1;
}
var Kh = Array.prototype, zh = Kh.splice;
function Qh(r) {
  var e = this.__data__, t = io(e, r);
  if (t < 0)
    return !1;
  var s = e.length - 1;
  return t == s ? e.pop() : zh.call(e, t, 1), --this.size, !0;
}
function Yh(r) {
  var e = this.__data__, t = io(e, r);
  return t < 0 ? void 0 : e[t][1];
}
function Zh(r) {
  return io(this.__data__, r) > -1;
}
function Xh(r, e) {
  var t = this.__data__, s = io(t, r);
  return s < 0 ? (++this.size, t.push([r, e])) : t[s][1] = e, this;
}
function Vs(r) {
  var e = -1, t = r == null ? 0 : r.length;
  for (this.clear(); ++e < t; ) {
    var s = r[e];
    this.set(s[0], s[1]);
  }
}
Vs.prototype.clear = Jh;
Vs.prototype.delete = Qh;
Vs.prototype.get = Yh;
Vs.prototype.has = Zh;
Vs.prototype.set = Xh;
function em() {
  this.__data__ = new Vs(), this.size = 0;
}
function tm(r) {
  var e = this.__data__, t = e.delete(r);
  return this.size = e.size, t;
}
function sm(r) {
  return this.__data__.get(r);
}
function rm(r) {
  return this.__data__.has(r);
}
var im = typeof global == "object" && global && global.Object === Object && global;
const _u = im;
var nm = typeof self == "object" && self && self.Object === Object && self, am = _u || nm || Function("return this")();
const as = am;
var om = as.Symbol;
const Wi = om;
var vu = Object.prototype, cm = vu.hasOwnProperty, dm = vu.toString, cn = Wi ? Wi.toStringTag : void 0;
function lm(r) {
  var e = cm.call(r, cn), t = r[cn];
  try {
    r[cn] = void 0;
    var s = !0;
  } catch (n) {
  }
  var i = dm.call(r);
  return s && (e ? r[cn] = t : delete r[cn]), i;
}
var um = Object.prototype, pm = um.toString;
function hm(r) {
  return pm.call(r);
}
var mm = "[object Null]", fm = "[object Undefined]", Cd = Wi ? Wi.toStringTag : void 0;
function zi(r) {
  return r == null ? r === void 0 ? fm : mm : Cd && Cd in Object(r) ? lm(r) : hm(r);
}
function pr(r) {
  var e = typeof r;
  return r != null && (e == "object" || e == "function");
}
var gm = "[object AsyncFunction]", _m = "[object Function]", vm = "[object GeneratorFunction]", Tm = "[object Proxy]";
function Tu(r) {
  if (!pr(r))
    return !1;
  var e = zi(r);
  return e == _m || e == vm || e == gm || e == Tm;
}
var ym = as["__core-js_shared__"];
const Po = ym;
var kd = function() {
  var r = /[^.]+$/.exec(Po && Po.keys && Po.keys.IE_PROTO || "");
  return r ? "Symbol(src)_1." + r : "";
}();
function Em(r) {
  return !!kd && kd in r;
}
var Sm = Function.prototype, wm = Sm.toString;
function Yr(r) {
  if (r != null) {
    try {
      return wm.call(r);
    } catch (e) {
    }
    try {
      return r + "";
    } catch (e) {
    }
  }
  return "";
}
var Rm = /[\\^$.*+?()[\]{}|]/g, bm = /^\[object .+?Constructor\]$/, Pm = Function.prototype, Cm = Object.prototype, km = Pm.toString, Dm = Cm.hasOwnProperty, Im = RegExp(
  "^" + km.call(Dm).replace(Rm, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
);
function Am(r) {
  if (!pr(r) || Em(r))
    return !1;
  var e = Tu(r) ? Im : bm;
  return e.test(Yr(r));
}
function Mm(r, e) {
  return r == null ? void 0 : r[e];
}
function Zr(r, e) {
  var t = Mm(r, e);
  return Am(t) ? t : void 0;
}
var Om = Zr(as, "Map");
const vn = Om;
var Nm = Zr(Object, "create");
const Tn = Nm;
function Lm() {
  this.__data__ = Tn ? Tn(null) : {}, this.size = 0;
}
function xm(r) {
  var e = this.has(r) && delete this.__data__[r];
  return this.size -= e ? 1 : 0, e;
}
var Um = "__lodash_hash_undefined__", Vm = Object.prototype, Fm = Vm.hasOwnProperty;
function jm(r) {
  var e = this.__data__;
  if (Tn) {
    var t = e[r];
    return t === Um ? void 0 : t;
  }
  return Fm.call(e, r) ? e[r] : void 0;
}
var $m = Object.prototype, Hm = $m.hasOwnProperty;
function Bm(r) {
  var e = this.__data__;
  return Tn ? e[r] !== void 0 : Hm.call(e, r);
}
var qm = "__lodash_hash_undefined__";
function Gm(r, e) {
  var t = this.__data__;
  return this.size += this.has(r) ? 0 : 1, t[r] = Tn && e === void 0 ? qm : e, this;
}
function Kr(r) {
  var e = -1, t = r == null ? 0 : r.length;
  for (this.clear(); ++e < t; ) {
    var s = r[e];
    this.set(s[0], s[1]);
  }
}
Kr.prototype.clear = Lm;
Kr.prototype.delete = xm;
Kr.prototype.get = jm;
Kr.prototype.has = Bm;
Kr.prototype.set = Gm;
function Wm() {
  this.size = 0, this.__data__ = {
    hash: new Kr(),
    map: new (vn || Vs)(),
    string: new Kr()
  };
}
function Jm(r) {
  var e = typeof r;
  return e == "string" || e == "number" || e == "symbol" || e == "boolean" ? r !== "__proto__" : r === null;
}
function no(r, e) {
  var t = r.__data__;
  return Jm(e) ? t[typeof e == "string" ? "string" : "hash"] : t.map;
}
function Km(r) {
  var e = no(this, r).delete(r);
  return this.size -= e ? 1 : 0, e;
}
function zm(r) {
  return no(this, r).get(r);
}
function Qm(r) {
  return no(this, r).has(r);
}
function Ym(r, e) {
  var t = no(this, r), s = t.size;
  return t.set(r, e), this.size += t.size == s ? 0 : 1, this;
}
function mr(r) {
  var e = -1, t = r == null ? 0 : r.length;
  for (this.clear(); ++e < t; ) {
    var s = r[e];
    this.set(s[0], s[1]);
  }
}
mr.prototype.clear = Wm;
mr.prototype.delete = Km;
mr.prototype.get = zm;
mr.prototype.has = Qm;
mr.prototype.set = Ym;
var Zm = 200;
function Xm(r, e) {
  var t = this.__data__;
  if (t instanceof Vs) {
    var s = t.__data__;
    if (!vn || s.length < Zm - 1)
      return s.push([r, e]), this.size = ++t.size, this;
    t = this.__data__ = new mr(s);
  }
  return t.set(r, e), this.size = t.size, this;
}
function Qi(r) {
  var e = this.__data__ = new Vs(r);
  this.size = e.size;
}
Qi.prototype.clear = em;
Qi.prototype.delete = tm;
Qi.prototype.get = sm;
Qi.prototype.has = rm;
Qi.prototype.set = Xm;
function ef(r, e) {
  for (var t = -1, s = r == null ? 0 : r.length; ++t < s && e(r[t], t, r) !== !1; )
    ;
  return r;
}
var tf = function() {
  try {
    var r = Zr(Object, "defineProperty");
    return r({}, "", {}), r;
  } catch (e) {
  }
}();
const Dd = tf;
function yu(r, e, t) {
  e == "__proto__" && Dd ? Dd(r, e, {
    configurable: !0,
    enumerable: !0,
    value: t,
    writable: !0
  }) : r[e] = t;
}
var sf = Object.prototype, rf = sf.hasOwnProperty;
function Eu(r, e, t) {
  var s = r[e];
  (!(rf.call(r, e) && gu(s, t)) || t === void 0 && !(e in r)) && yu(r, e, t);
}
function ao(r, e, t, s) {
  var i = !t;
  t || (t = {});
  for (var n = -1, a = e.length; ++n < a; ) {
    var o = e[n], d = s ? s(t[o], r[o], o, t, r) : void 0;
    d === void 0 && (d = r[o]), i ? yu(t, o, d) : Eu(t, o, d);
  }
  return t;
}
function nf(r, e) {
  for (var t = -1, s = Array(r); ++t < r; )
    s[t] = e(t);
  return s;
}
function Yi(r) {
  return r != null && typeof r == "object";
}
var af = "[object Arguments]";
function Id(r) {
  return Yi(r) && zi(r) == af;
}
var Su = Object.prototype, of = Su.hasOwnProperty, cf = Su.propertyIsEnumerable, df = Id(function() {
  return arguments;
}()) ? Id : function(r) {
  return Yi(r) && of.call(r, "callee") && !cf.call(r, "callee");
};
const wu = df;
var lf = Array.isArray;
const oo = lf;
function uf() {
  return !1;
}
var Ru = typeof exports == "object" && exports && !exports.nodeType && exports, Ad = Ru && typeof module == "object" && module && !module.nodeType && module, pf = Ad && Ad.exports === Ru, Md = pf ? as.Buffer : void 0, hf = Md ? Md.isBuffer : void 0, mf = hf || uf;
const bc = mf;
var ff = 9007199254740991, gf = /^(?:0|[1-9]\d*)$/;
function _f(r, e) {
  var t = typeof r;
  return e = e == null ? ff : e, !!e && (t == "number" || t != "symbol" && gf.test(r)) && r > -1 && r % 1 == 0 && r < e;
}
var vf = 9007199254740991;
function bu(r) {
  return typeof r == "number" && r > -1 && r % 1 == 0 && r <= vf;
}
var Tf = "[object Arguments]", yf = "[object Array]", Ef = "[object Boolean]", Sf = "[object Date]", wf = "[object Error]", Rf = "[object Function]", bf = "[object Map]", Pf = "[object Number]", Cf = "[object Object]", kf = "[object RegExp]", Df = "[object Set]", If = "[object String]", Af = "[object WeakMap]", Mf = "[object ArrayBuffer]", Of = "[object DataView]", Nf = "[object Float32Array]", Lf = "[object Float64Array]", xf = "[object Int8Array]", Uf = "[object Int16Array]", Vf = "[object Int32Array]", Ff = "[object Uint8Array]", jf = "[object Uint8ClampedArray]", $f = "[object Uint16Array]", Hf = "[object Uint32Array]", Ce = {};
Ce[Nf] = Ce[Lf] = Ce[xf] = Ce[Uf] = Ce[Vf] = Ce[Ff] = Ce[jf] = Ce[$f] = Ce[Hf] = !0;
Ce[Tf] = Ce[yf] = Ce[Mf] = Ce[Ef] = Ce[Of] = Ce[Sf] = Ce[wf] = Ce[Rf] = Ce[bf] = Ce[Pf] = Ce[Cf] = Ce[kf] = Ce[Df] = Ce[If] = Ce[Af] = !1;
function Bf(r) {
  return Yi(r) && bu(r.length) && !!Ce[zi(r)];
}
function Pc(r) {
  return function(e) {
    return r(e);
  };
}
var Pu = typeof exports == "object" && exports && !exports.nodeType && exports, hn = Pu && typeof module == "object" && module && !module.nodeType && module, qf = hn && hn.exports === Pu, Co = qf && _u.process, Gf = function() {
  try {
    var r = hn && hn.require && hn.require("util").types;
    return r || Co && Co.binding && Co.binding("util");
  } catch (e) {
  }
}();
const Ji = Gf;
var Od = Ji && Ji.isTypedArray, Wf = Od ? Pc(Od) : Bf;
const Cu = Wf;
var Jf = Object.prototype, Kf = Jf.hasOwnProperty;
function ku(r, e) {
  var t = oo(r), s = !t && wu(r), i = !t && !s && bc(r), n = !t && !s && !i && Cu(r), a = t || s || i || n, o = a ? nf(r.length, String) : [], d = o.length;
  for (var p in r)
    (e || Kf.call(r, p)) && !(a && // Safari 9 has enumerable `arguments.length` in strict mode.
    (p == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
    i && (p == "offset" || p == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
    n && (p == "buffer" || p == "byteLength" || p == "byteOffset") || // Skip index properties.
    _f(p, d))) && o.push(p);
  return o;
}
var zf = Object.prototype;
function co(r) {
  var e = r && r.constructor, t = typeof e == "function" && e.prototype || zf;
  return r === t;
}
function Du(r, e) {
  return function(t) {
    return r(e(t));
  };
}
var Qf = Du(Object.keys, Object);
const Yf = Qf;
var Zf = Object.prototype, Xf = Zf.hasOwnProperty;
function Iu(r) {
  if (!co(r))
    return Yf(r);
  var e = [];
  for (var t in Object(r))
    Xf.call(r, t) && t != "constructor" && e.push(t);
  return e;
}
function Cc(r) {
  return r != null && bu(r.length) && !Tu(r);
}
function kc(r) {
  return Cc(r) ? ku(r) : Iu(r);
}
function eg(r, e) {
  return r && ao(e, kc(e), r);
}
function tg(r) {
  var e = [];
  if (r != null)
    for (var t in Object(r))
      e.push(t);
  return e;
}
var sg = Object.prototype, rg = sg.hasOwnProperty;
function ig(r) {
  if (!pr(r))
    return tg(r);
  var e = co(r), t = [];
  for (var s in r)
    s == "constructor" && (e || !rg.call(r, s)) || t.push(s);
  return t;
}
function Dc(r) {
  return Cc(r) ? ku(r, !0) : ig(r);
}
function ng(r, e) {
  return r && ao(e, Dc(e), r);
}
var Au = typeof exports == "object" && exports && !exports.nodeType && exports, Nd = Au && typeof module == "object" && module && !module.nodeType && module, ag = Nd && Nd.exports === Au, Ld = ag ? as.Buffer : void 0, xd = Ld ? Ld.allocUnsafe : void 0;
function og(r, e) {
  if (e)
    return r.slice();
  var t = r.length, s = xd ? xd(t) : new r.constructor(t);
  return r.copy(s), s;
}
function cg(r, e) {
  var t = -1, s = r.length;
  for (e || (e = Array(s)); ++t < s; )
    e[t] = r[t];
  return e;
}
function dg(r, e) {
  for (var t = -1, s = r == null ? 0 : r.length, i = 0, n = []; ++t < s; ) {
    var a = r[t];
    e(a, t, r) && (n[i++] = a);
  }
  return n;
}
function Mu() {
  return [];
}
var lg = Object.prototype, ug = lg.propertyIsEnumerable, Ud = Object.getOwnPropertySymbols, pg = Ud ? function(r) {
  return r == null ? [] : (r = Object(r), dg(Ud(r), function(e) {
    return ug.call(r, e);
  }));
} : Mu;
const Ic = pg;
function hg(r, e) {
  return ao(r, Ic(r), e);
}
function Ou(r, e) {
  for (var t = -1, s = e.length, i = r.length; ++t < s; )
    r[i + t] = e[t];
  return r;
}
var mg = Du(Object.getPrototypeOf, Object);
const Nu = mg;
var fg = Object.getOwnPropertySymbols, gg = fg ? function(r) {
  for (var e = []; r; )
    Ou(e, Ic(r)), r = Nu(r);
  return e;
} : Mu;
const Lu = gg;
function _g(r, e) {
  return ao(r, Lu(r), e);
}
function xu(r, e, t) {
  var s = e(r);
  return oo(r) ? s : Ou(s, t(r));
}
function vg(r) {
  return xu(r, kc, Ic);
}
function Tg(r) {
  return xu(r, Dc, Lu);
}
var yg = Zr(as, "DataView");
const Wo = yg;
var Eg = Zr(as, "Promise");
const Jo = Eg;
var Sg = Zr(as, "Set");
const Ko = Sg;
var wg = Zr(as, "WeakMap");
const zo = wg;
var Vd = "[object Map]", Rg = "[object Object]", Fd = "[object Promise]", jd = "[object Set]", $d = "[object WeakMap]", Hd = "[object DataView]", bg = Yr(Wo), Pg = Yr(vn), Cg = Yr(Jo), kg = Yr(Ko), Dg = Yr(zo), Sr = zi;
(Wo && Sr(new Wo(new ArrayBuffer(1))) != Hd || vn && Sr(new vn()) != Vd || Jo && Sr(Jo.resolve()) != Fd || Ko && Sr(new Ko()) != jd || zo && Sr(new zo()) != $d) && (Sr = function(r) {
  var e = zi(r), t = e == Rg ? r.constructor : void 0, s = t ? Yr(t) : "";
  if (s)
    switch (s) {
      case bg:
        return Hd;
      case Pg:
        return Vd;
      case Cg:
        return Fd;
      case kg:
        return jd;
      case Dg:
        return $d;
    }
  return e;
});
const lo = Sr;
var Ig = Object.prototype, Ag = Ig.hasOwnProperty;
function Mg(r) {
  var e = r.length, t = new r.constructor(e);
  return e && typeof r[0] == "string" && Ag.call(r, "index") && (t.index = r.index, t.input = r.input), t;
}
var Og = as.Uint8Array;
const Bd = Og;
function Ac(r) {
  var e = new r.constructor(r.byteLength);
  return new Bd(e).set(new Bd(r)), e;
}
function Ng(r, e) {
  var t = e ? Ac(r.buffer) : r.buffer;
  return new r.constructor(t, r.byteOffset, r.byteLength);
}
var Lg = /\w*$/;
function xg(r) {
  var e = new r.constructor(r.source, Lg.exec(r));
  return e.lastIndex = r.lastIndex, e;
}
var qd = Wi ? Wi.prototype : void 0, Gd = qd ? qd.valueOf : void 0;
function Ug(r) {
  return Gd ? Object(Gd.call(r)) : {};
}
function Vg(r, e) {
  var t = e ? Ac(r.buffer) : r.buffer;
  return new r.constructor(t, r.byteOffset, r.length);
}
var Fg = "[object Boolean]", jg = "[object Date]", $g = "[object Map]", Hg = "[object Number]", Bg = "[object RegExp]", qg = "[object Set]", Gg = "[object String]", Wg = "[object Symbol]", Jg = "[object ArrayBuffer]", Kg = "[object DataView]", zg = "[object Float32Array]", Qg = "[object Float64Array]", Yg = "[object Int8Array]", Zg = "[object Int16Array]", Xg = "[object Int32Array]", e_ = "[object Uint8Array]", t_ = "[object Uint8ClampedArray]", s_ = "[object Uint16Array]", r_ = "[object Uint32Array]";
function i_(r, e, t) {
  var s = r.constructor;
  switch (e) {
    case Jg:
      return Ac(r);
    case Fg:
    case jg:
      return new s(+r);
    case Kg:
      return Ng(r, t);
    case zg:
    case Qg:
    case Yg:
    case Zg:
    case Xg:
    case e_:
    case t_:
    case s_:
    case r_:
      return Vg(r, t);
    case $g:
      return new s();
    case Hg:
    case Gg:
      return new s(r);
    case Bg:
      return xg(r);
    case qg:
      return new s();
    case Wg:
      return Ug(r);
  }
}
var Wd = Object.create, n_ = function() {
  function r() {
  }
  return function(e) {
    if (!pr(e))
      return {};
    if (Wd)
      return Wd(e);
    r.prototype = e;
    var t = new r();
    return r.prototype = void 0, t;
  };
}();
const a_ = n_;
function o_(r) {
  return typeof r.constructor == "function" && !co(r) ? a_(Nu(r)) : {};
}
var c_ = "[object Map]";
function d_(r) {
  return Yi(r) && lo(r) == c_;
}
var Jd = Ji && Ji.isMap, l_ = Jd ? Pc(Jd) : d_;
const u_ = l_;
var p_ = "[object Set]";
function h_(r) {
  return Yi(r) && lo(r) == p_;
}
var Kd = Ji && Ji.isSet, m_ = Kd ? Pc(Kd) : h_;
const f_ = m_;
var g_ = 1, __ = 2, v_ = 4, Uu = "[object Arguments]", T_ = "[object Array]", y_ = "[object Boolean]", E_ = "[object Date]", S_ = "[object Error]", Vu = "[object Function]", w_ = "[object GeneratorFunction]", R_ = "[object Map]", b_ = "[object Number]", Fu = "[object Object]", P_ = "[object RegExp]", C_ = "[object Set]", k_ = "[object String]", D_ = "[object Symbol]", I_ = "[object WeakMap]", A_ = "[object ArrayBuffer]", M_ = "[object DataView]", O_ = "[object Float32Array]", N_ = "[object Float64Array]", L_ = "[object Int8Array]", x_ = "[object Int16Array]", U_ = "[object Int32Array]", V_ = "[object Uint8Array]", F_ = "[object Uint8ClampedArray]", j_ = "[object Uint16Array]", $_ = "[object Uint32Array]", Re = {};
Re[Uu] = Re[T_] = Re[A_] = Re[M_] = Re[y_] = Re[E_] = Re[O_] = Re[N_] = Re[L_] = Re[x_] = Re[U_] = Re[R_] = Re[b_] = Re[Fu] = Re[P_] = Re[C_] = Re[k_] = Re[D_] = Re[V_] = Re[F_] = Re[j_] = Re[$_] = !0;
Re[S_] = Re[Vu] = Re[I_] = !1;
function fa(r, e, t, s, i, n) {
  var a, o = e & g_, d = e & __, p = e & v_;
  if (t && (a = i ? t(r, s, i, n) : t(r)), a !== void 0)
    return a;
  if (!pr(r))
    return r;
  var l = oo(r);
  if (l) {
    if (a = Mg(r), !o)
      return cg(r, a);
  } else {
    var u = lo(r), m = u == Vu || u == w_;
    if (bc(r))
      return og(r, o);
    if (u == Fu || u == Uu || m && !i) {
      if (a = d || m ? {} : o_(r), !o)
        return d ? _g(r, ng(a, r)) : hg(r, eg(a, r));
    } else {
      if (!Re[u])
        return i ? r : {};
      a = i_(r, u, o);
    }
  }
  n || (n = new Qi());
  var g = n.get(r);
  if (g)
    return g;
  n.set(r, a), f_(r) ? r.forEach(function(R) {
    a.add(fa(R, e, t, R, r, n));
  }) : u_(r) && r.forEach(function(R, D) {
    a.set(D, fa(R, e, t, D, r, n));
  });
  var T = p ? d ? Tg : vg : d ? Dc : kc, S = l ? void 0 : T(r);
  return ef(S || r, function(R, D) {
    S && (D = R, R = r[D]), Eu(a, D, fa(R, e, t, D, r, n));
  }), a;
}
var H_ = 1, B_ = 4;
function Mc(r) {
  return fa(r, H_ | B_);
}
var q_ = "[object Symbol]";
function G_(r) {
  return typeof r == "symbol" || Yi(r) && zi(r) == q_;
}
var W_ = "Expected a function";
function Ia(r, e) {
  if (typeof r != "function" || e != null && typeof e != "function")
    throw new TypeError(W_);
  var t = function() {
    var s = arguments, i = e ? e.apply(this, s) : s[0], n = t.cache;
    if (n.has(i))
      return n.get(i);
    var a = r.apply(this, s);
    return t.cache = n.set(i, a) || n, a;
  };
  return t.cache = new (Ia.Cache || mr)(), t;
}
Ia.Cache = mr;
var is;
(function(r) {
  r.GroupCall = "GROUP_CALL", r.Webinar = "WEBINAR", r.AudioRoom = "AUDIO_ROOM", r.Livestream = "LIVESTREAM";
})(is || (is = {}));
var Aa;
(function(r) {
  r.Skip = "SKIP", r.OnPrivilegedUserEntry = "ON_PRIVILEGED_USER_ENTRY", r.SkipOnAccept = "SKIP_ON_ACCEPT";
})(Aa || (Aa = {}));
var ot;
(function(r) {
  r.Allowed = "ALLOWED", r.NotAllowed = "NOT_ALLOWED", r.CanRequest = "CAN_REQUEST";
})(ot || (ot = {}));
var Ma;
(function(r) {
  r.Allowed = "ALLOWED", r.NotAllowed = "NOT_ALLOWED";
})(Ma || (Ma = {}));
var zd;
(function(r) {
  r.FULL_ACCESS = "FULL_ACCESS", r.VIEW_ONLY = "VIEW_ONLY";
})(zd || (zd = {}));
const J_ = {
  border_radius: "rounded",
  border_width: "thin",
  spacing_base: 4,
  theme: "dark",
  colors: {
    brand: Gh("#2160FD"),
    background: Wh("#141414"),
    danger: "#FF2D2D",
    text: "#EEEEEE",
    text_on_brand: "#EEEEEE",
    success: "#62A504",
    video_bg: "#191919",
    warning: "#FFCD07"
  }
};
function ju() {
  return Mc(J_);
}
const K_ = {
  permissions: {
    // webinar
    can_accept_production_requests: !1,
    can_edit_display_name: !0,
    accept_waiting_requests: !1,
    disable_participant_audio: !1,
    disable_participant_screensharing: !1,
    disable_participant_video: !1,
    can_spotlight: !1,
    kick_participant: !1,
    pin_participant: !1,
    can_record: !1,
    can_livestream: !1,
    waiting_room_type: Aa.Skip,
    plugins: {
      can_close: !0,
      can_start: !0,
      can_edit_config: !1,
      config: {}
    },
    polls: {
      can_create: !0,
      can_vote: !0,
      can_view: !0
    },
    media: {
      video: {
        can_produce: ot.Allowed,
        can_consume: Ma.Allowed
      },
      audio: {
        can_produce: ot.Allowed
      },
      screenshare: {
        can_produce: ot.Allowed,
        can_consume: Ma.Allowed
      }
    },
    chat: {
      public: {
        can_send: !0,
        text: !0,
        files: !0
      },
      private: {
        can_send: !1,
        can_receive: !1,
        text: !1,
        files: !1
      }
    },
    hidden_participant: !1,
    is_recorder: !1,
    recorder_type: Jr.none,
    show_participant_list: !0,
    can_change_participant_permissions: !1,
    connected_meetings: {
      can_alter_connected_meetings: !1,
      can_switch_connected_meetings: !1,
      can_switch_to_parent_meeting: !1
    }
  },
  ui: {
    oldTheme: {
      setup_screen: {
        is_enabled: !1
      },
      alone_here: {
        is_enabled: !1
      },
      waiting_room: {
        is_enabled: !1,
        enable_preview: !0
      },
      control_bar: {
        is_enabled: !0,
        elements: {
          plugins: !0,
          screenshare: !0,
          invite: !1,
          participants: !0,
          chat: !0,
          reactions: !1,
          polls: !0,
          fullscreen: !0,
          layout: !0
        }
      },
      header: {
        is_enabled: !0,
        elements: {
          timer: !0,
          title: !0,
          participant_count: !0,
          change_layout: !0
        }
      },
      pip_mode: !0,
      auto_tune: !0,
      colors: {
        primary: "#2160FD",
        secondary: "#1A1A1A",
        text: "#EEEEEE",
        background: "#1A1A1A",
        textPrimary: "#EEEEEE",
        videoBackground: "#1A1A1A"
      },
      dimensions: {
        mode: "fillParent"
      },
      grid: {
        multi: {
          maxVideoCount: 6,
          videoFit: "cover"
        },
        single: {
          maxVideoCount: 6,
          videoFit: "cover"
        },
        defaultView: "MULTI"
      },
      controls: {
        pip_toggle: !1
      },
      plugins: []
    },
    design_tokens: ju(),
    config_diff: {}
  },
  config: {
    view_type: is.GroupCall,
    media: {
      video: {
        quality: "vga",
        frame_rate: 24
      },
      screenshare: {
        quality: "hd",
        frame_rate: 5
      }
    },
    max_video_streams: {
      mobile: 6,
      desktop: 6
    },
    max_screenshare_count: 1
  },
  version: "hybrid"
};
function z_() {
  return Mc(K_);
}
Jr.none, _n.skip;
const Q_ = {
  permissions: {
    // webinar
    can_accept_production_requests: !1,
    can_edit_display_name: !0,
    accept_waiting_requests: !1,
    disable_participant_audio: !1,
    disable_participant_screensharing: !1,
    disable_participant_video: !1,
    can_spotlight: !1,
    kick_participant: !1,
    pin_participant: !1,
    can_record: !1,
    can_livestream: !1,
    waiting_room_type: Aa.Skip,
    plugins: {
      can_close: !0,
      can_start: !0,
      can_edit_config: !1,
      config: {}
    },
    polls: {
      can_create: !0,
      can_vote: !0,
      can_view: !0
    },
    media: {
      video: {
        can_produce: ot.Allowed
      },
      audio: {
        can_produce: ot.Allowed
      },
      screenshare: {
        can_produce: ot.Allowed
      }
    },
    chat: {
      public: {
        can_send: !0,
        text: !0,
        files: !0
      },
      private: {
        can_send: !1,
        can_receive: !1,
        text: !1,
        files: !1
      }
    },
    hidden_participant: !1,
    is_recorder: !1,
    recorder_type: Jr.none,
    show_participant_list: !0,
    can_change_participant_permissions: !1,
    connected_meetings: {
      can_alter_connected_meetings: !1,
      can_switch_connected_meetings: !1,
      can_switch_to_parent_meeting: !1
    }
  },
  ui: {
    design_tokens: ju(),
    config_diff: {}
  },
  config: {
    view_type: is.GroupCall,
    media: {
      video: {
        quality: "vga",
        frame_rate: 24
      },
      screenshare: {
        quality: "hd",
        frame_rate: 5
      }
    },
    max_video_streams: {
      mobile: 6,
      desktop: 6
    },
    max_screenshare_count: 1
  },
  version: "2.0.0"
};
function Oc() {
  return Mc(Q_);
}
var ss = {}, Y_ = {
  get exports() {
    return ss;
  },
  set exports(r) {
    ss = r;
  }
}, ko, Qd;
function Z_() {
  if (Qd)
    return ko;
  Qd = 1;
  var r = 1e3, e = r * 60, t = e * 60, s = t * 24, i = s * 7, n = s * 365.25;
  ko = function(l, u) {
    u = u || {};
    var m = typeof l;
    if (m === "string" && l.length > 0)
      return a(l);
    if (m === "number" && isFinite(l))
      return u.long ? d(l) : o(l);
    throw new Error(
      "val is not a non-empty string or a valid number. val=" + JSON.stringify(l)
    );
  };
  function a(l) {
    if (l = String(l), !(l.length > 100)) {
      var u = /^(-?(?:\d+)?\.?\d+) *(milliseconds?|msecs?|ms|seconds?|secs?|s|minutes?|mins?|m|hours?|hrs?|h|days?|d|weeks?|w|years?|yrs?|y)?$/i.exec(
        l
      );
      if (u) {
        var m = parseFloat(u[1]), g = (u[2] || "ms").toLowerCase();
        switch (g) {
          case "years":
          case "year":
          case "yrs":
          case "yr":
          case "y":
            return m * n;
          case "weeks":
          case "week":
          case "w":
            return m * i;
          case "days":
          case "day":
          case "d":
            return m * s;
          case "hours":
          case "hour":
          case "hrs":
          case "hr":
          case "h":
            return m * t;
          case "minutes":
          case "minute":
          case "mins":
          case "min":
          case "m":
            return m * e;
          case "seconds":
          case "second":
          case "secs":
          case "sec":
          case "s":
            return m * r;
          case "milliseconds":
          case "millisecond":
          case "msecs":
          case "msec":
          case "ms":
            return m;
          default:
            return;
        }
      }
    }
  }
  function o(l) {
    var u = Math.abs(l);
    return u >= s ? Math.round(l / s) + "d" : u >= t ? Math.round(l / t) + "h" : u >= e ? Math.round(l / e) + "m" : u >= r ? Math.round(l / r) + "s" : l + "ms";
  }
  function d(l) {
    var u = Math.abs(l);
    return u >= s ? p(l, u, s, "day") : u >= t ? p(l, u, t, "hour") : u >= e ? p(l, u, e, "minute") : u >= r ? p(l, u, r, "second") : l + " ms";
  }
  function p(l, u, m, g) {
    var T = u >= m * 1.5;
    return Math.round(l / m) + " " + g + (T ? "s" : "");
  }
  return ko;
}
function X_(r) {
  t.debug = t, t.default = t, t.coerce = d, t.disable = n, t.enable = i, t.enabled = a, t.humanize = Z_(), t.destroy = p, Object.keys(r).forEach((l) => {
    t[l] = r[l];
  }), t.names = [], t.skips = [], t.formatters = {};
  function e(l) {
    let u = 0;
    for (let m = 0; m < l.length; m++)
      u = (u << 5) - u + l.charCodeAt(m), u |= 0;
    return t.colors[Math.abs(u) % t.colors.length];
  }
  t.selectColor = e;
  function t(l) {
    let u, m = null, g, T;
    function S(...R) {
      if (!S.enabled)
        return;
      const D = S, I = Number(new Date()), re = I - (u || I);
      D.diff = re, D.prev = u, D.curr = I, u = I, R[0] = t.coerce(R[0]), typeof R[0] != "string" && R.unshift("%O");
      let ge = 0;
      R[0] = R[0].replace(/%([a-zA-Z%])/g, (pe, st) => {
        if (pe === "%%")
          return "%";
        ge++;
        const rt = t.formatters[st];
        if (typeof rt == "function") {
          const gt = R[ge];
          pe = rt.call(D, gt), R.splice(ge, 1), ge--;
        }
        return pe;
      }), t.formatArgs.call(D, R), (D.log || t.log).apply(D, R);
    }
    return S.namespace = l, S.useColors = t.useColors(), S.color = t.selectColor(l), S.extend = s, S.destroy = t.destroy, Object.defineProperty(S, "enabled", {
      enumerable: !0,
      configurable: !1,
      get: () => m !== null ? m : (g !== t.namespaces && (g = t.namespaces, T = t.enabled(l)), T),
      set: (R) => {
        m = R;
      }
    }), typeof t.init == "function" && t.init(S), S;
  }
  function s(l, u) {
    const m = t(this.namespace + (typeof u == "undefined" ? ":" : u) + l);
    return m.log = this.log, m;
  }
  function i(l) {
    t.save(l), t.namespaces = l, t.names = [], t.skips = [];
    let u;
    const m = (typeof l == "string" ? l : "").split(/[\s,]+/), g = m.length;
    for (u = 0; u < g; u++)
      m[u] && (l = m[u].replace(/\*/g, ".*?"), l[0] === "-" ? t.skips.push(new RegExp("^" + l.slice(1) + "$")) : t.names.push(new RegExp("^" + l + "$")));
  }
  function n() {
    const l = [
      ...t.names.map(o),
      ...t.skips.map(o).map((u) => "-" + u)
    ].join(",");
    return t.enable(""), l;
  }
  function a(l) {
    if (l[l.length - 1] === "*")
      return !0;
    let u, m;
    for (u = 0, m = t.skips.length; u < m; u++)
      if (t.skips[u].test(l))
        return !1;
    for (u = 0, m = t.names.length; u < m; u++)
      if (t.names[u].test(l))
        return !0;
    return !1;
  }
  function o(l) {
    return l.toString().substring(2, l.toString().length - 2).replace(/\.\*\?$/, "*");
  }
  function d(l) {
    return l instanceof Error ? l.stack || l.message : l;
  }
  function p() {
    console.warn("Instance method `debug.destroy()` is deprecated and no longer does anything. It will be removed in the next major version of `debug`.");
  }
  return t.enable(t.load()), t;
}
var ev = X_;
(function(r, e) {
  e.formatArgs = s, e.save = i, e.load = n, e.useColors = t, e.storage = a(), e.destroy = (() => {
    let d = !1;
    return () => {
      d || (d = !0, console.warn("Instance method `debug.destroy()` is deprecated and no longer does anything. It will be removed in the next major version of `debug`."));
    };
  })(), e.colors = [
    "#0000CC",
    "#0000FF",
    "#0033CC",
    "#0033FF",
    "#0066CC",
    "#0066FF",
    "#0099CC",
    "#0099FF",
    "#00CC00",
    "#00CC33",
    "#00CC66",
    "#00CC99",
    "#00CCCC",
    "#00CCFF",
    "#3300CC",
    "#3300FF",
    "#3333CC",
    "#3333FF",
    "#3366CC",
    "#3366FF",
    "#3399CC",
    "#3399FF",
    "#33CC00",
    "#33CC33",
    "#33CC66",
    "#33CC99",
    "#33CCCC",
    "#33CCFF",
    "#6600CC",
    "#6600FF",
    "#6633CC",
    "#6633FF",
    "#66CC00",
    "#66CC33",
    "#9900CC",
    "#9900FF",
    "#9933CC",
    "#9933FF",
    "#99CC00",
    "#99CC33",
    "#CC0000",
    "#CC0033",
    "#CC0066",
    "#CC0099",
    "#CC00CC",
    "#CC00FF",
    "#CC3300",
    "#CC3333",
    "#CC3366",
    "#CC3399",
    "#CC33CC",
    "#CC33FF",
    "#CC6600",
    "#CC6633",
    "#CC9900",
    "#CC9933",
    "#CCCC00",
    "#CCCC33",
    "#FF0000",
    "#FF0033",
    "#FF0066",
    "#FF0099",
    "#FF00CC",
    "#FF00FF",
    "#FF3300",
    "#FF3333",
    "#FF3366",
    "#FF3399",
    "#FF33CC",
    "#FF33FF",
    "#FF6600",
    "#FF6633",
    "#FF9900",
    "#FF9933",
    "#FFCC00",
    "#FFCC33"
  ];
  function t() {
    return typeof window != "undefined" && window.process && (window.process.type === "renderer" || window.process.__nwjs) ? !0 : typeof navigator != "undefined" && navigator.userAgent && navigator.userAgent.toLowerCase().match(/(edge|trident)\/(\d+)/) ? !1 : typeof document != "undefined" && document.documentElement && document.documentElement.style && document.documentElement.style.WebkitAppearance || // Is firebug? http://stackoverflow.com/a/398120/376773
    typeof window != "undefined" && window.console && (window.console.firebug || window.console.exception && window.console.table) || // Is firefox >= v31?
    // https://developer.mozilla.org/en-US/docs/Tools/Web_Console#Styling_messages
    typeof navigator != "undefined" && navigator.userAgent && navigator.userAgent.toLowerCase().match(/firefox\/(\d+)/) && parseInt(RegExp.$1, 10) >= 31 || // Double check webkit in userAgent just in case we are in a worker
    typeof navigator != "undefined" && navigator.userAgent && navigator.userAgent.toLowerCase().match(/applewebkit\/(\d+)/);
  }
  function s(d) {
    if (d[0] = (this.useColors ? "%c" : "") + this.namespace + (this.useColors ? " %c" : " ") + d[0] + (this.useColors ? "%c " : " ") + "+" + r.exports.humanize(this.diff), !this.useColors)
      return;
    const p = "color: " + this.color;
    d.splice(1, 0, p, "color: inherit");
    let l = 0, u = 0;
    d[0].replace(/%[a-zA-Z%]/g, (m) => {
      m !== "%%" && (l++, m === "%c" && (u = l));
    }), d.splice(u, 0, p);
  }
  e.log = console.debug || console.log || (() => {
  });
  function i(d) {
    try {
      d ? e.storage.setItem("debug", d) : e.storage.removeItem("debug");
    } catch (p) {
    }
  }
  function n() {
    let d;
    try {
      d = e.storage.getItem("debug");
    } catch (p) {
    }
    return !d && typeof process != "undefined" && "env" in process && (d = process.env.DEBUG), d;
  }
  function a() {
    try {
      return localStorage;
    } catch (d) {
    }
  }
  r.exports = ev(e);
  const { formatters: o } = r.exports;
  o.j = function(d) {
    try {
      return JSON.stringify(d);
    } catch (p) {
      return "[UnexpectedJSONParseError]: " + p.message;
    }
  };
})(Y_, ss);
const ai = "mediasoup-client";
let Lt = class {
  constructor(e) {
    e ? (this._debug = ss(`${ai}:${e}`), this._warn = ss(`${ai}:WARN:${e}`), this._error = ss(`${ai}:ERROR:${e}`)) : (this._debug = ss(ai), this._warn = ss(`${ai}:WARN`), this._error = ss(`${ai}:ERROR`)), this._debug.log = console.info.bind(console), this._warn.log = console.warn.bind(console), this._error.log = console.error.bind(console);
  }
  get debug() {
    return this._debug;
  }
  get warn() {
    return this._warn;
  }
  get error() {
    return this._error;
  }
};
const tv = new Lt("EnhancedEventEmitter");
let Kt = class extends bt.EventEmitter {
  constructor() {
    super(), this.setMaxListeners(1 / 0);
  }
  emit(e, ...t) {
    return super.emit(e, ...t);
  }
  /**
   * Special addition to the EventEmitter API.
   */
  safeEmit(e, ...t) {
    const s = super.listenerCount(e);
    try {
      return super.emit(e, ...t);
    } catch (i) {
      return tv.error("safeEmit() | event listener threw an error [eventName:%s]:%o", e, i), Boolean(s);
    }
  }
  on(e, t) {
    return super.on(e, t), this;
  }
  off(e, t) {
    return super.off(e, t), this;
  }
  addListener(e, t) {
    return super.on(e, t), this;
  }
  prependListener(e, t) {
    return super.prependListener(e, t), this;
  }
  once(e, t) {
    return super.once(e, t), this;
  }
  prependOnceListener(e, t) {
    return super.prependOnceListener(e, t), this;
  }
  removeListener(e, t) {
    return super.off(e, t), this;
  }
  removeAllListeners(e) {
    return super.removeAllListeners(e), this;
  }
  listenerCount(e) {
    return super.listenerCount(e);
  }
  listeners(e) {
    return super.listeners(e);
  }
  rawListeners(e) {
    return super.rawListeners(e);
  }
}, Mt = class $u extends Error {
  constructor(e) {
    super(e), this.name = "UnsupportedError", Error.hasOwnProperty("captureStackTrace") ? Error.captureStackTrace(this, $u) : this.stack = new Error(e).stack;
  }
}, Ae = class Hu extends Error {
  constructor(e) {
    super(e), this.name = "InvalidStateError", Error.hasOwnProperty("captureStackTrace") ? Error.captureStackTrace(this, Hu) : this.stack = new Error(e).stack;
  }
};
function ze(r, e) {
  return typeof r == "undefined" ? e : JSON.parse(JSON.stringify(r));
}
function Do() {
  return Math.round(Math.random() * 1e7);
}
var Qo = {};
(function(r) {
  const e = ss("h264-profile-level-id");
  e.log = console.info.bind(console);
  const t = 1, s = 2, i = 3, n = 4, a = 5;
  r.ProfileConstrainedBaseline = t, r.ProfileBaseline = s, r.ProfileMain = i, r.ProfileConstrainedHigh = n, r.ProfileHigh = a;
  const o = 0, d = 10, p = 11, l = 12, u = 13, m = 20, g = 21, T = 22, S = 30, R = 31, D = 32, I = 40, re = 41, ge = 42, Me = 50, pe = 51, st = 52;
  r.Level1_b = o, r.Level1 = d, r.Level1_1 = p, r.Level1_2 = l, r.Level1_3 = u, r.Level2 = m, r.Level2_1 = g, r.Level2_2 = T, r.Level3 = S, r.Level3_1 = R, r.Level3_2 = D, r.Level4 = I, r.Level4_1 = re, r.Level4_2 = ge, r.Level5 = Me, r.Level5_1 = pe, r.Level5_2 = st;
  class rt {
    constructor(L, ke) {
      this.profile = L, this.level = ke;
    }
  }
  r.ProfileLevelId = rt;
  const gt = new rt(t, R), wt = 16;
  class Rt {
    constructor(L) {
      this._mask = ~nn("x", L), this._maskedValue = nn("1", L);
    }
    isMatch(L) {
      return this._maskedValue === (L & this._mask);
    }
  }
  class Ct {
    constructor(L, ke, kt) {
      this.profile_idc = L, this.profile_iop = ke, this.profile = kt;
    }
  }
  const $s = [
    new Ct(66, new Rt("x1xx0000"), t),
    new Ct(77, new Rt("1xxx0000"), t),
    new Ct(88, new Rt("11xx0000"), t),
    new Ct(66, new Rt("x0xx0000"), s),
    new Ct(88, new Rt("10xx0000"), s),
    new Ct(77, new Rt("0x0x0000"), i),
    new Ct(100, new Rt("00000000"), a),
    new Ct(100, new Rt("00001100"), n)
  ];
  r.parseProfileLevelId = function(Q) {
    if (typeof Q != "string" || Q.length !== 6)
      return null;
    const L = parseInt(Q, 16);
    if (L === 0)
      return null;
    const ke = L & 255, kt = L >> 8 & 255, ni = L >> 16 & 255;
    let ys;
    switch (ke) {
      case p: {
        ys = kt & wt ? o : p;
        break;
      }
      case d:
      case l:
      case u:
      case m:
      case g:
      case T:
      case S:
      case R:
      case D:
      case I:
      case re:
      case ge:
      case Me:
      case pe:
      case st: {
        ys = ke;
        break;
      }
      default:
        return e("parseProfileLevelId() | unrecognized level_idc:%s", ke), null;
    }
    for (const Hs of $s)
      if (ni === Hs.profile_idc && Hs.profile_iop.isMatch(kt))
        return new rt(Hs.profile, ys);
    return e("parseProfileLevelId() | unrecognized profile_idc/profile_iop combination"), null;
  }, r.profileLevelIdToString = function(Q) {
    if (Q.level == o)
      switch (Q.profile) {
        case t:
          return "42f00b";
        case s:
          return "42100b";
        case i:
          return "4d100b";
        default:
          return e(
            "profileLevelIdToString() | Level 1_b not is allowed for profile:%s",
            Q.profile
          ), null;
      }
    let L;
    switch (Q.profile) {
      case t: {
        L = "42e0";
        break;
      }
      case s: {
        L = "4200";
        break;
      }
      case i: {
        L = "4d00";
        break;
      }
      case n: {
        L = "640c";
        break;
      }
      case a: {
        L = "6400";
        break;
      }
      default:
        return e(
          "profileLevelIdToString() | unrecognized profile:%s",
          Q.profile
        ), null;
    }
    let ke = Q.level.toString(16);
    return ke.length === 1 && (ke = `0${ke}`), `${L}${ke}`;
  }, r.parseSdpProfileLevelId = function(Q = {}) {
    const L = Q["profile-level-id"];
    return L ? r.parseProfileLevelId(L) : gt;
  }, r.isSameProfile = function(Q = {}, L = {}) {
    const ke = r.parseSdpProfileLevelId(Q), kt = r.parseSdpProfileLevelId(L);
    return Boolean(
      ke && kt && ke.profile === kt.profile
    );
  }, r.generateProfileLevelIdForAnswer = function(Q = {}, L = {}) {
    if (!Q["profile-level-id"] && !L["profile-level-id"])
      return e(
        "generateProfileLevelIdForAnswer() | no profile-level-id in local and remote params"
      ), null;
    const ke = r.parseSdpProfileLevelId(Q), kt = r.parseSdpProfileLevelId(L);
    if (!ke)
      throw new TypeError("invalid local_profile_level_id");
    if (!kt)
      throw new TypeError("invalid remote_profile_level_id");
    if (ke.profile !== kt.profile)
      throw new TypeError("H264 Profile mismatch");
    const ni = an(Q) && an(L), ys = ke.level, Hs = kt.level, aa = Se(ys, Hs), oa = ni ? ys : aa;
    return e(
      "generateProfileLevelIdForAnswer() | result: [profile:%s, level:%s]",
      ke.profile,
      oa
    ), r.profileLevelIdToString(
      new rt(ke.profile, oa)
    );
  };
  function nn(Q, L) {
    return (L[0] === Q) << 7 | (L[1] === Q) << 6 | (L[2] === Q) << 5 | (L[3] === Q) << 4 | (L[4] === Q) << 3 | (L[5] === Q) << 2 | (L[6] === Q) << 1 | (L[7] === Q) << 0;
  }
  function na(Q, L) {
    return Q === o ? L !== d && L !== o : L === o ? Q !== d : Q < L;
  }
  function Se(Q, L) {
    return na(Q, L) ? Q : L;
  }
  function an(Q = {}) {
    const L = Q["level-asymmetry-allowed"];
    return L === 1 || L === "1";
  }
})(Qo);
const sv = "probator", rv = 1234, iv = 127;
function Io(r) {
  if (typeof r != "object")
    throw new TypeError("caps is not an object");
  if (r.codecs && !Array.isArray(r.codecs))
    throw new TypeError("caps.codecs is not an array");
  r.codecs || (r.codecs = []);
  for (const e of r.codecs)
    nv(e);
  if (r.headerExtensions && !Array.isArray(r.headerExtensions))
    throw new TypeError("caps.headerExtensions is not an array");
  r.headerExtensions || (r.headerExtensions = []);
  for (const e of r.headerExtensions)
    av(e);
}
function nv(r) {
  const e = new RegExp("^(audio|video)/(.+)", "i");
  if (typeof r != "object")
    throw new TypeError("codec is not an object");
  if (!r.mimeType || typeof r.mimeType != "string")
    throw new TypeError("missing codec.mimeType");
  const t = e.exec(r.mimeType);
  if (!t)
    throw new TypeError("invalid codec.mimeType");
  if (r.kind = t[1].toLowerCase(), r.preferredPayloadType && typeof r.preferredPayloadType != "number")
    throw new TypeError("invalid codec.preferredPayloadType");
  if (typeof r.clockRate != "number")
    throw new TypeError("missing codec.clockRate");
  r.kind === "audio" ? typeof r.channels != "number" && (r.channels = 1) : delete r.channels, (!r.parameters || typeof r.parameters != "object") && (r.parameters = {});
  for (const s of Object.keys(r.parameters)) {
    let i = r.parameters[s];
    if (i === void 0 && (r.parameters[s] = "", i = ""), typeof i != "string" && typeof i != "number")
      throw new TypeError(`invalid codec parameter [key:${s}s, value:${i}]`);
    if (s === "apt" && typeof i != "number")
      throw new TypeError("invalid codec apt parameter");
  }
  (!r.rtcpFeedback || !Array.isArray(r.rtcpFeedback)) && (r.rtcpFeedback = []);
  for (const s of r.rtcpFeedback)
    Bu(s);
}
function Bu(r) {
  if (typeof r != "object")
    throw new TypeError("fb is not an object");
  if (!r.type || typeof r.type != "string")
    throw new TypeError("missing fb.type");
  (!r.parameter || typeof r.parameter != "string") && (r.parameter = "");
}
function av(r) {
  if (typeof r != "object")
    throw new TypeError("ext is not an object");
  if (r.kind !== "audio" && r.kind !== "video")
    throw new TypeError("invalid ext.kind");
  if (!r.uri || typeof r.uri != "string")
    throw new TypeError("missing ext.uri");
  if (typeof r.preferredId != "number")
    throw new TypeError("missing ext.preferredId");
  if (r.preferredEncrypt && typeof r.preferredEncrypt != "boolean")
    throw new TypeError("invalid ext.preferredEncrypt");
  if (r.preferredEncrypt || (r.preferredEncrypt = !1), r.direction && typeof r.direction != "string")
    throw new TypeError("invalid ext.direction");
  r.direction || (r.direction = "sendrecv");
}
function Nc(r) {
  if (typeof r != "object")
    throw new TypeError("params is not an object");
  if (r.mid && typeof r.mid != "string")
    throw new TypeError("params.mid is not a string");
  if (!Array.isArray(r.codecs))
    throw new TypeError("missing params.codecs");
  for (const e of r.codecs)
    ov(e);
  if (r.headerExtensions && !Array.isArray(r.headerExtensions))
    throw new TypeError("params.headerExtensions is not an array");
  r.headerExtensions || (r.headerExtensions = []);
  for (const e of r.headerExtensions)
    cv(e);
  if (r.encodings && !Array.isArray(r.encodings))
    throw new TypeError("params.encodings is not an array");
  r.encodings || (r.encodings = []);
  for (const e of r.encodings)
    dv(e);
  if (r.rtcp && typeof r.rtcp != "object")
    throw new TypeError("params.rtcp is not an object");
  r.rtcp || (r.rtcp = {}), lv(r.rtcp);
}
function ov(r) {
  const e = new RegExp("^(audio|video)/(.+)", "i");
  if (typeof r != "object")
    throw new TypeError("codec is not an object");
  if (!r.mimeType || typeof r.mimeType != "string")
    throw new TypeError("missing codec.mimeType");
  const t = e.exec(r.mimeType);
  if (!t)
    throw new TypeError("invalid codec.mimeType");
  if (typeof r.payloadType != "number")
    throw new TypeError("missing codec.payloadType");
  if (typeof r.clockRate != "number")
    throw new TypeError("missing codec.clockRate");
  t[1].toLowerCase() === "audio" ? typeof r.channels != "number" && (r.channels = 1) : delete r.channels, (!r.parameters || typeof r.parameters != "object") && (r.parameters = {});
  for (const i of Object.keys(r.parameters)) {
    let n = r.parameters[i];
    if (n === void 0 && (r.parameters[i] = "", n = ""), typeof n != "string" && typeof n != "number")
      throw new TypeError(`invalid codec parameter [key:${i}s, value:${n}]`);
    if (i === "apt" && typeof n != "number")
      throw new TypeError("invalid codec apt parameter");
  }
  (!r.rtcpFeedback || !Array.isArray(r.rtcpFeedback)) && (r.rtcpFeedback = []);
  for (const i of r.rtcpFeedback)
    Bu(i);
}
function cv(r) {
  if (typeof r != "object")
    throw new TypeError("ext is not an object");
  if (!r.uri || typeof r.uri != "string")
    throw new TypeError("missing ext.uri");
  if (typeof r.id != "number")
    throw new TypeError("missing ext.id");
  if (r.encrypt && typeof r.encrypt != "boolean")
    throw new TypeError("invalid ext.encrypt");
  r.encrypt || (r.encrypt = !1), (!r.parameters || typeof r.parameters != "object") && (r.parameters = {});
  for (const e of Object.keys(r.parameters)) {
    let t = r.parameters[e];
    if (t === void 0 && (r.parameters[e] = "", t = ""), typeof t != "string" && typeof t != "number")
      throw new TypeError("invalid header extension parameter");
  }
}
function dv(r) {
  if (typeof r != "object")
    throw new TypeError("encoding is not an object");
  if (r.ssrc && typeof r.ssrc != "number")
    throw new TypeError("invalid encoding.ssrc");
  if (r.rid && typeof r.rid != "string")
    throw new TypeError("invalid encoding.rid");
  if (r.rtx && typeof r.rtx != "object")
    throw new TypeError("invalid encoding.rtx");
  if (r.rtx && typeof r.rtx.ssrc != "number")
    throw new TypeError("missing encoding.rtx.ssrc");
  if ((!r.dtx || typeof r.dtx != "boolean") && (r.dtx = !1), r.scalabilityMode && typeof r.scalabilityMode != "string")
    throw new TypeError("invalid encoding.scalabilityMode");
}
function lv(r) {
  if (typeof r != "object")
    throw new TypeError("rtcp is not an object");
  if (r.cname && typeof r.cname != "string")
    throw new TypeError("invalid rtcp.cname");
  (!r.reducedSize || typeof r.reducedSize != "boolean") && (r.reducedSize = !0);
}
function uv(r) {
  if (typeof r != "object")
    throw new TypeError("caps is not an object");
  if (!r.numStreams || typeof r.numStreams != "object")
    throw new TypeError("missing caps.numStreams");
  pv(r.numStreams);
}
function pv(r) {
  if (typeof r != "object")
    throw new TypeError("numStreams is not an object");
  if (typeof r.OS != "number")
    throw new TypeError("missing numStreams.OS");
  if (typeof r.MIS != "number")
    throw new TypeError("missing numStreams.MIS");
}
function Yd(r) {
  if (typeof r != "object")
    throw new TypeError("params is not an object");
  if (typeof r.streamId != "number")
    throw new TypeError("missing params.streamId");
  let e = !1;
  if (typeof r.ordered == "boolean" ? e = !0 : r.ordered = !0, r.maxPacketLifeTime && typeof r.maxPacketLifeTime != "number")
    throw new TypeError("invalid params.maxPacketLifeTime");
  if (r.maxRetransmits && typeof r.maxRetransmits != "number")
    throw new TypeError("invalid params.maxRetransmits");
  if (r.maxPacketLifeTime && r.maxRetransmits)
    throw new TypeError("cannot provide both maxPacketLifeTime and maxRetransmits");
  if (e && r.ordered && (r.maxPacketLifeTime || r.maxRetransmits))
    throw new TypeError("cannot be ordered with maxPacketLifeTime or maxRetransmits");
  if (!e && (r.maxPacketLifeTime || r.maxRetransmits) && (r.ordered = !1), r.label && typeof r.label != "string")
    throw new TypeError("invalid params.label");
  if (r.protocol && typeof r.protocol != "string")
    throw new TypeError("invalid params.protocol");
}
function hv(r, e) {
  const t = {
    codecs: [],
    headerExtensions: []
  };
  for (const s of e.codecs || []) {
    if (mn(s))
      continue;
    const i = (r.codecs || []).find((a) => qu(a, s, { strict: !0, modify: !0 }));
    if (!i)
      continue;
    const n = {
      mimeType: i.mimeType,
      kind: i.kind,
      clockRate: i.clockRate,
      channels: i.channels,
      localPayloadType: i.preferredPayloadType,
      localRtxPayloadType: void 0,
      remotePayloadType: s.preferredPayloadType,
      remoteRtxPayloadType: void 0,
      localParameters: i.parameters,
      remoteParameters: s.parameters,
      rtcpFeedback: vv(i, s)
    };
    t.codecs.push(n);
  }
  for (const s of t.codecs) {
    const i = r.codecs.find((a) => mn(a) && a.parameters.apt === s.localPayloadType), n = e.codecs.find((a) => mn(a) && a.parameters.apt === s.remotePayloadType);
    i && n && (s.localRtxPayloadType = i.preferredPayloadType, s.remoteRtxPayloadType = n.preferredPayloadType);
  }
  for (const s of e.headerExtensions) {
    const i = r.headerExtensions.find((a) => _v(a, s));
    if (!i)
      continue;
    const n = {
      kind: s.kind,
      uri: s.uri,
      sendId: i.preferredId,
      recvId: s.preferredId,
      encrypt: i.preferredEncrypt,
      direction: "sendrecv"
    };
    switch (s.direction) {
      case "sendrecv":
        n.direction = "sendrecv";
        break;
      case "recvonly":
        n.direction = "sendonly";
        break;
      case "sendonly":
        n.direction = "recvonly";
        break;
      case "inactive":
        n.direction = "inactive";
        break;
    }
    t.headerExtensions.push(n);
  }
  return t;
}
function mv(r) {
  const e = {
    codecs: [],
    headerExtensions: []
  };
  for (const t of r.codecs) {
    const s = {
      mimeType: t.mimeType,
      kind: t.kind,
      preferredPayloadType: t.remotePayloadType,
      clockRate: t.clockRate,
      channels: t.channels,
      parameters: t.localParameters,
      rtcpFeedback: t.rtcpFeedback
    };
    if (e.codecs.push(s), !t.remoteRtxPayloadType)
      continue;
    const i = {
      mimeType: `${t.kind}/rtx`,
      kind: t.kind,
      preferredPayloadType: t.remoteRtxPayloadType,
      clockRate: t.clockRate,
      parameters: {
        apt: t.remotePayloadType
      },
      rtcpFeedback: []
    };
    e.codecs.push(i);
  }
  for (const t of r.headerExtensions) {
    if (t.direction !== "sendrecv" && t.direction !== "recvonly")
      continue;
    const s = {
      kind: t.kind,
      uri: t.uri,
      preferredId: t.recvId,
      preferredEncrypt: t.encrypt,
      direction: t.direction
    };
    e.headerExtensions.push(s);
  }
  return e;
}
function zt(r, e) {
  const t = {
    mid: void 0,
    codecs: [],
    headerExtensions: [],
    encodings: [],
    rtcp: {}
  };
  for (const s of e.codecs) {
    if (s.kind !== r)
      continue;
    const i = {
      mimeType: s.mimeType,
      payloadType: s.localPayloadType,
      clockRate: s.clockRate,
      channels: s.channels,
      parameters: s.localParameters,
      rtcpFeedback: s.rtcpFeedback
    };
    if (t.codecs.push(i), s.localRtxPayloadType) {
      const n = {
        mimeType: `${s.kind}/rtx`,
        payloadType: s.localRtxPayloadType,
        clockRate: s.clockRate,
        parameters: {
          apt: s.localPayloadType
        },
        rtcpFeedback: []
      };
      t.codecs.push(n);
    }
  }
  for (const s of e.headerExtensions) {
    if (s.kind && s.kind !== r || s.direction !== "sendrecv" && s.direction !== "sendonly")
      continue;
    const i = {
      uri: s.uri,
      id: s.sendId,
      encrypt: s.encrypt,
      parameters: {}
    };
    t.headerExtensions.push(i);
  }
  return t;
}
function _s(r, e) {
  const t = {
    mid: void 0,
    codecs: [],
    headerExtensions: [],
    encodings: [],
    rtcp: {}
  };
  for (const s of e.codecs) {
    if (s.kind !== r)
      continue;
    const i = {
      mimeType: s.mimeType,
      payloadType: s.localPayloadType,
      clockRate: s.clockRate,
      channels: s.channels,
      parameters: s.remoteParameters,
      rtcpFeedback: s.rtcpFeedback
    };
    if (t.codecs.push(i), s.localRtxPayloadType) {
      const n = {
        mimeType: `${s.kind}/rtx`,
        payloadType: s.localRtxPayloadType,
        clockRate: s.clockRate,
        parameters: {
          apt: s.localPayloadType
        },
        rtcpFeedback: []
      };
      t.codecs.push(n);
    }
  }
  for (const s of e.headerExtensions) {
    if (s.kind && s.kind !== r || s.direction !== "sendrecv" && s.direction !== "sendonly")
      continue;
    const i = {
      uri: s.uri,
      id: s.sendId,
      encrypt: s.encrypt,
      parameters: {}
    };
    t.headerExtensions.push(i);
  }
  if (t.headerExtensions.some((s) => s.uri === "http://www.ietf.org/id/draft-holmer-rmcat-transport-wide-cc-extensions-01"))
    for (const s of t.codecs)
      s.rtcpFeedback = (s.rtcpFeedback || []).filter((i) => i.type !== "goog-remb");
  else if (t.headerExtensions.some((s) => s.uri === "http://www.webrtc.org/experiments/rtp-hdrext/abs-send-time"))
    for (const s of t.codecs)
      s.rtcpFeedback = (s.rtcpFeedback || []).filter((i) => i.type !== "transport-cc");
  else
    for (const s of t.codecs)
      s.rtcpFeedback = (s.rtcpFeedback || []).filter((i) => i.type !== "transport-cc" && i.type !== "goog-remb");
  return t;
}
function ns(r, e) {
  const t = [];
  if (!e)
    t.push(r[0]), mn(r[1]) && t.push(r[1]);
  else {
    for (let s = 0; s < r.length; ++s)
      if (qu(r[s], e)) {
        t.push(r[s]), mn(r[s + 1]) && t.push(r[s + 1]);
        break;
      }
    if (t.length === 0)
      throw new TypeError("no matching codec found");
  }
  return t;
}
function fv(r) {
  r = ze(r, {}), Nc(r);
  const e = {
    mid: sv,
    codecs: [],
    headerExtensions: [],
    encodings: [{ ssrc: rv }],
    rtcp: { cname: "probator" }
  };
  return e.codecs.push(r.codecs[0]), e.codecs[0].payloadType = iv, e.headerExtensions = r.headerExtensions, e;
}
function Zd(r, e) {
  return e.codecs.some((t) => t.kind === r);
}
function gv(r, e) {
  if (Nc(r), r.codecs.length === 0)
    return !1;
  const t = r.codecs[0];
  return e.codecs.some((s) => s.remotePayloadType === t.payloadType);
}
function mn(r) {
  return r ? /.+\/rtx$/i.test(r.mimeType) : !1;
}
function qu(r, e, { strict: t = !1, modify: s = !1 } = {}) {
  const i = r.mimeType.toLowerCase(), n = e.mimeType.toLowerCase();
  if (i !== n || r.clockRate !== e.clockRate || r.channels !== e.channels)
    return !1;
  switch (i) {
    case "video/h264": {
      if (t) {
        const a = r.parameters["packetization-mode"] || 0, o = e.parameters["packetization-mode"] || 0;
        if (a !== o || !Qo.isSameProfile(r.parameters, e.parameters))
          return !1;
        let d;
        try {
          d = Qo.generateProfileLevelIdForAnswer(r.parameters, e.parameters);
        } catch (p) {
          return !1;
        }
        s && (d ? (r.parameters["profile-level-id"] = d, e.parameters["profile-level-id"] = d) : (delete r.parameters["profile-level-id"], delete e.parameters["profile-level-id"]));
      }
      break;
    }
    case "video/vp9": {
      if (t) {
        const a = r.parameters["profile-id"] || 0, o = e.parameters["profile-id"] || 0;
        if (a !== o)
          return !1;
      }
      break;
    }
  }
  return !0;
}
function _v(r, e) {
  return !(r.kind && e.kind && r.kind !== e.kind || r.uri !== e.uri);
}
function vv(r, e) {
  const t = [];
  for (const s of r.rtcpFeedback || []) {
    const i = (e.rtcpFeedback || []).find((n) => n.type === s.type && (n.parameter === s.parameter || !n.parameter && !s.parameter));
    i && t.push(i);
  }
  return t;
}
var Gr = {}, uo = {}, Tv = Go && Go.__importDefault || function(r) {
  return r && r.__esModule ? r : { default: r };
};
Object.defineProperty(uo, "__esModule", { value: !0 });
uo.Logger = void 0;
const oi = Tv(ss), ci = "awaitqueue";
let yv = class {
  constructor(e) {
    e ? (this._debug = (0, oi.default)(`${ci}:${e}`), this._warn = (0, oi.default)(`${ci}:WARN:${e}`), this._error = (0, oi.default)(`${ci}:ERROR:${e}`)) : (this._debug = (0, oi.default)(ci), this._warn = (0, oi.default)(`${ci}:WARN`), this._error = (0, oi.default)(`${ci}:ERROR`)), this._debug.log = console.info.bind(console), this._warn.log = console.warn.bind(console), this._error.log = console.error.bind(console);
  }
  get debug() {
    return this._debug;
  }
  get warn() {
    return this._warn;
  }
  get error() {
    return this._error;
  }
};
uo.Logger = yv;
Object.defineProperty(Gr, "__esModule", { value: !0 });
var Gu = Gr.AwaitQueue = Gr.AwaitQueueRemovedTaskError = Gr.AwaitQueueStoppedError = void 0;
const Ev = uo, Bs = new Ev.Logger();
class Lc extends Error {
  constructor(e) {
    super(e != null ? e : "AwaitQueue stopped"), this.name = "AwaitQueueStoppedError", typeof Error.captureStackTrace == "function" && Error.captureStackTrace(this, Lc);
  }
}
Gr.AwaitQueueStoppedError = Lc;
class po extends Error {
  constructor(e) {
    super(e != null ? e : "AwaitQueue task removed"), this.name = "AwaitQueueRemovedTaskError", typeof Error.captureStackTrace == "function" && Error.captureStackTrace(this, po);
  }
}
Gr.AwaitQueueRemovedTaskError = po;
class Sv {
  constructor() {
    this.pendingTasks = /* @__PURE__ */ new Map(), this.nextTaskId = 0, this.stopping = !1;
  }
  get size() {
    return this.pendingTasks.size;
  }
  async push(e, t) {
    if (t = t != null ? t : e.name, Bs.debug(`push() [name:${t}]`), typeof e != "function")
      throw new TypeError("given task is not a function");
    if (t)
      try {
        Object.defineProperty(e, "name", { value: t });
      } catch (s) {
      }
    return new Promise((s, i) => {
      const n = {
        id: this.nextTaskId++,
        task: e,
        name: t,
        enqueuedAt: Date.now(),
        executedAt: void 0,
        completed: !1,
        resolve: (a) => {
          if (n.completed)
            return;
          n.completed = !0, this.pendingTasks.delete(n.id), Bs.debug(`resolving task [name:${n.name}]`), s(a);
          const [o] = this.pendingTasks.values();
          o && !o.executedAt && this.execute(o);
        },
        reject: (a) => {
          if (!n.completed && (n.completed = !0, this.pendingTasks.delete(n.id), Bs.debug(`rejecting task [name:${n.name}]: %s`, String(a)), i(a), !this.stopping)) {
            const [o] = this.pendingTasks.values();
            o && !o.executedAt && this.execute(o);
          }
        }
      };
      this.pendingTasks.set(n.id, n), this.pendingTasks.size === 1 && this.execute(n);
    });
  }
  stop() {
    Bs.debug("stop()"), this.stopping = !0;
    for (const e of this.pendingTasks.values())
      Bs.debug(`stop() | stopping task [name:${e.name}]`);
    this.stopping = !1;
  }
  remove(e) {
    Bs.debug(`remove() [taskIdx:${e}]`);
    const t = Array.from(this.pendingTasks.values())[e];
    if (!t) {
      Bs.debug(`stop() | no task with given idx [taskIdx:${e}]`);
      return;
    }
    t.reject(new po());
  }
  dump() {
    const e = Date.now();
    let t = 0;
    return Array.from(this.pendingTasks.values()).map((s) => ({
      idx: t++,
      task: s.task,
      name: s.name,
      enqueuedTime: s.executedAt ? s.executedAt - s.enqueuedAt : e - s.enqueuedAt,
      executionTime: s.executedAt ? e - s.executedAt : 0
    }));
  }
  async execute(e) {
    if (Bs.debug(`execute() [name:${e.name}]`), e.executedAt)
      throw new Error("task already being executed");
    e.executedAt = Date.now();
    try {
      const t = await e.task();
      e.resolve(t);
    } catch (t) {
      e.reject(t);
    }
  }
}
Gu = Gr.AwaitQueue = Sv;
/*! queue-microtask. MIT License. Feross Aboukhadijeh <https://feross.org/opensource> */
let Xd;
var Ao = typeof queueMicrotask == "function" ? queueMicrotask.bind(typeof window != "undefined" ? window : Go) : (r) => (Xd || (Xd = Promise.resolve())).then(r).catch((e) => setTimeout(() => {
  throw e;
}, 0));
const ds = new Lt("Producer");
let wv = class extends Kt {
  constructor({ id: e, localId: t, rtpSender: s, track: i, rtpParameters: n, stopTracks: a, disableTrackOnPause: o, zeroRtpOnPause: d, appData: p }) {
    super(), this._closed = !1, this._observer = new Kt(), ds.debug("constructor()"), this._id = e, this._localId = t, this._rtpSender = s, this._track = i, this._kind = i.kind, this._rtpParameters = n, this._paused = o ? !i.enabled : !1, this._maxSpatialLayer = void 0, this._stopTracks = a, this._disableTrackOnPause = o, this._zeroRtpOnPause = d, this._appData = p || {}, this.onTrackEnded = this.onTrackEnded.bind(this), this.handleTrack();
  }
  /**
   * Producer id.
   */
  get id() {
    return this._id;
  }
  /**
   * Local id.
   */
  get localId() {
    return this._localId;
  }
  /**
   * Whether the Producer is closed.
   */
  get closed() {
    return this._closed;
  }
  /**
   * Media kind.
   */
  get kind() {
    return this._kind;
  }
  /**
   * Associated RTCRtpSender.
   */
  get rtpSender() {
    return this._rtpSender;
  }
  /**
   * The associated track.
   */
  get track() {
    return this._track;
  }
  /**
   * RTP parameters.
   */
  get rtpParameters() {
    return this._rtpParameters;
  }
  /**
   * Whether the Producer is paused.
   */
  get paused() {
    return this._paused;
  }
  /**
   * Max spatial layer.
   *
   * @type {Number | undefined}
   */
  get maxSpatialLayer() {
    return this._maxSpatialLayer;
  }
  /**
   * App custom data.
   */
  get appData() {
    return this._appData;
  }
  /**
   * Invalid setter.
   */
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  set appData(e) {
    throw new Error("cannot override appData object");
  }
  get observer() {
    return this._observer;
  }
  /**
   * Closes the Producer.
   */
  close() {
    this._closed || (ds.debug("close()"), this._closed = !0, this.destroyTrack(), this.emit("@close"), this._observer.safeEmit("close"));
  }
  /**
   * Transport was closed.
   */
  transportClosed() {
    this._closed || (ds.debug("transportClosed()"), this._closed = !0, this.destroyTrack(), this.safeEmit("transportclose"), this._observer.safeEmit("close"));
  }
  /**
   * Get associated RTCRtpSender stats.
   */
  async getStats() {
    if (this._closed)
      throw new Ae("closed");
    return new Promise((e, t) => {
      this.safeEmit("@getstats", e, t);
    });
  }
  /**
   * Pauses sending media.
   */
  pause() {
    if (ds.debug("pause()"), this._closed) {
      ds.error("pause() | Producer closed");
      return;
    }
    this._paused = !0, this._track && this._disableTrackOnPause && (this._track.enabled = !1), this._zeroRtpOnPause && new Promise((e, t) => {
      this.safeEmit("@pause", e, t);
    }).catch(() => {
    }), this._observer.safeEmit("pause");
  }
  /**
   * Resumes sending media.
   */
  resume() {
    if (ds.debug("resume()"), this._closed) {
      ds.error("resume() | Producer closed");
      return;
    }
    this._paused = !1, this._track && this._disableTrackOnPause && (this._track.enabled = !0), this._zeroRtpOnPause && new Promise((e, t) => {
      this.safeEmit("@resume", e, t);
    }).catch(() => {
    }), this._observer.safeEmit("resume");
  }
  /**
   * Replaces the current track with a new one or null.
   */
  async replaceTrack({ track: e }) {
    if (ds.debug("replaceTrack() [track:%o]", e), this._closed) {
      if (e && this._stopTracks)
        try {
          e.stop();
        } catch (t) {
        }
      throw new Ae("closed");
    } else if (e && e.readyState === "ended")
      throw new Ae("track ended");
    if (e === this._track) {
      ds.debug("replaceTrack() | same track, ignored");
      return;
    }
    await new Promise((t, s) => {
      this.safeEmit("@replacetrack", e, t, s);
    }), this.destroyTrack(), this._track = e, this._track && this._disableTrackOnPause && (this._paused ? this._paused && (this._track.enabled = !1) : this._track.enabled = !0), this.handleTrack();
  }
  /**
   * Sets the video max spatial layer to be sent.
   */
  async setMaxSpatialLayer(e) {
    if (this._closed)
      throw new Ae("closed");
    if (this._kind !== "video")
      throw new Mt("not a video Producer");
    if (typeof e != "number")
      throw new TypeError("invalid spatialLayer");
    e !== this._maxSpatialLayer && (await new Promise((t, s) => {
      this.safeEmit("@setmaxspatiallayer", e, t, s);
    }).catch(() => {
    }), this._maxSpatialLayer = e);
  }
  async setRtpEncodingParameters(e) {
    if (this._closed)
      throw new Ae("closed");
    if (typeof e != "object")
      throw new TypeError("invalid params");
    await new Promise((t, s) => {
      this.safeEmit("@setrtpencodingparameters", e, t, s);
    });
  }
  onTrackEnded() {
    ds.debug('track "ended" event'), this.safeEmit("trackended"), this._observer.safeEmit("trackended");
  }
  handleTrack() {
    this._track && this._track.addEventListener("ended", this.onTrackEnded);
  }
  destroyTrack() {
    if (this._track)
      try {
        this._track.removeEventListener("ended", this.onTrackEnded), this._stopTracks && this._track.stop();
      } catch (e) {
      }
  }
};
const ls = new Lt("Consumer");
let Rv = class extends Kt {
  constructor({ id: e, localId: t, producerId: s, rtpReceiver: i, track: n, rtpParameters: a, appData: o }) {
    super(), this._closed = !1, this._observer = new Kt(), ls.debug("constructor()"), this._id = e, this._localId = t, this._producerId = s, this._rtpReceiver = i, this._track = n, this._rtpParameters = a, this._paused = !n.enabled, this._appData = o || {}, this.onTrackEnded = this.onTrackEnded.bind(this), this.handleTrack();
  }
  /**
   * Consumer id.
   */
  get id() {
    return this._id;
  }
  /**
   * Local id.
   */
  get localId() {
    return this._localId;
  }
  /**
   * Associated Producer id.
   */
  get producerId() {
    return this._producerId;
  }
  /**
   * Whether the Consumer is closed.
   */
  get closed() {
    return this._closed;
  }
  /**
   * Media kind.
   */
  get kind() {
    return this._track.kind;
  }
  /**
   * Associated RTCRtpReceiver.
   */
  get rtpReceiver() {
    return this._rtpReceiver;
  }
  /**
   * The associated track.
   */
  get track() {
    return this._track;
  }
  /**
   * RTP parameters.
   */
  get rtpParameters() {
    return this._rtpParameters;
  }
  /**
   * Whether the Consumer is paused.
   */
  get paused() {
    return this._paused;
  }
  /**
   * App custom data.
   */
  get appData() {
    return this._appData;
  }
  /**
   * Invalid setter.
   */
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  set appData(e) {
    throw new Error("cannot override appData object");
  }
  get observer() {
    return this._observer;
  }
  /**
   * Closes the Consumer.
   */
  close() {
    this._closed || (ls.debug("close()"), this._closed = !0, this.destroyTrack(), this.emit("@close"), this._observer.safeEmit("close"));
  }
  /**
   * Transport was closed.
   */
  transportClosed() {
    this._closed || (ls.debug("transportClosed()"), this._closed = !0, this.destroyTrack(), this.safeEmit("transportclose"), this._observer.safeEmit("close"));
  }
  /**
   * Get associated RTCRtpReceiver stats.
   */
  async getStats() {
    if (this._closed)
      throw new Ae("closed");
    return new Promise((e, t) => {
      this.safeEmit("@getstats", e, t);
    });
  }
  /**
   * Pauses receiving media.
   */
  pause() {
    if (ls.debug("pause()"), this._closed) {
      ls.error("pause() | Consumer closed");
      return;
    }
    if (this._paused) {
      ls.debug("pause() | Consumer is already paused");
      return;
    }
    this._paused = !0, this._track.enabled = !1, this.emit("@pause"), this._observer.safeEmit("pause");
  }
  /**
   * Resumes receiving media.
   */
  resume() {
    if (ls.debug("resume()"), this._closed) {
      ls.error("resume() | Consumer closed");
      return;
    }
    if (!this._paused) {
      ls.debug("resume() | Consumer is already resumed");
      return;
    }
    this._paused = !1, this._track.enabled = !0, this.emit("@resume"), this._observer.safeEmit("resume");
  }
  onTrackEnded() {
    ls.debug('track "ended" event'), this.safeEmit("trackended"), this._observer.safeEmit("trackended");
  }
  handleTrack() {
    this._track.addEventListener("ended", this.onTrackEnded);
  }
  destroyTrack() {
    try {
      this._track.removeEventListener("ended", this.onTrackEnded), this._track.stop();
    } catch (e) {
    }
  }
};
const Es = new Lt("DataProducer");
class bv extends Kt {
  constructor({ id: e, dataChannel: t, sctpStreamParameters: s, appData: i }) {
    super(), this._closed = !1, this._observer = new Kt(), Es.debug("constructor()"), this._id = e, this._dataChannel = t, this._sctpStreamParameters = s, this._appData = i || {}, this.handleDataChannel();
  }
  /**
   * DataProducer id.
   */
  get id() {
    return this._id;
  }
  /**
   * Whether the DataProducer is closed.
   */
  get closed() {
    return this._closed;
  }
  /**
   * SCTP stream parameters.
   */
  get sctpStreamParameters() {
    return this._sctpStreamParameters;
  }
  /**
   * DataChannel readyState.
   */
  get readyState() {
    return this._dataChannel.readyState;
  }
  /**
   * DataChannel label.
   */
  get label() {
    return this._dataChannel.label;
  }
  /**
   * DataChannel protocol.
   */
  get protocol() {
    return this._dataChannel.protocol;
  }
  /**
   * DataChannel bufferedAmount.
   */
  get bufferedAmount() {
    return this._dataChannel.bufferedAmount;
  }
  /**
   * DataChannel bufferedAmountLowThreshold.
   */
  get bufferedAmountLowThreshold() {
    return this._dataChannel.bufferedAmountLowThreshold;
  }
  /**
   * Set DataChannel bufferedAmountLowThreshold.
   */
  set bufferedAmountLowThreshold(e) {
    this._dataChannel.bufferedAmountLowThreshold = e;
  }
  /**
   * App custom data.
   */
  get appData() {
    return this._appData;
  }
  /**
   * Invalid setter.
   */
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  set appData(e) {
    throw new Error("cannot override appData object");
  }
  get observer() {
    return this._observer;
  }
  /**
   * Closes the DataProducer.
   */
  close() {
    this._closed || (Es.debug("close()"), this._closed = !0, this._dataChannel.close(), this.emit("@close"), this._observer.safeEmit("close"));
  }
  /**
   * Transport was closed.
   */
  transportClosed() {
    this._closed || (Es.debug("transportClosed()"), this._closed = !0, this._dataChannel.close(), this.safeEmit("transportclose"), this._observer.safeEmit("close"));
  }
  /**
   * Send a message.
   *
   * @param {String|Blob|ArrayBuffer|ArrayBufferView} data.
   */
  send(e) {
    if (Es.debug("send()"), this._closed)
      throw new Ae("closed");
    this._dataChannel.send(e);
  }
  handleDataChannel() {
    this._dataChannel.addEventListener("open", () => {
      this._closed || (Es.debug('DataChannel "open" event'), this.safeEmit("open"));
    }), this._dataChannel.addEventListener("error", (e) => {
      if (this._closed)
        return;
      let { error: t } = e;
      t || (t = new Error("unknown DataChannel error")), t.errorDetail === "sctp-failure" ? Es.error("DataChannel SCTP error [sctpCauseCode:%s]: %s", t.sctpCauseCode, t.message) : Es.error('DataChannel "error" event: %o', t), this.safeEmit("error", t);
    }), this._dataChannel.addEventListener("close", () => {
      this._closed || (Es.warn('DataChannel "close" event'), this._closed = !0, this.emit("@close"), this.safeEmit("close"), this._observer.safeEmit("close"));
    }), this._dataChannel.addEventListener("message", () => {
      this._closed || Es.warn('DataChannel "message" event in a DataProducer, message discarded');
    }), this._dataChannel.addEventListener("bufferedamountlow", () => {
      this._closed || this.safeEmit("bufferedamountlow");
    });
  }
}
const yr = new Lt("DataConsumer");
class Pv extends Kt {
  constructor({ id: e, dataProducerId: t, dataChannel: s, sctpStreamParameters: i, appData: n }) {
    super(), this._closed = !1, this._observer = new Kt(), yr.debug("constructor()"), this._id = e, this._dataProducerId = t, this._dataChannel = s, this._sctpStreamParameters = i, this._appData = n || {}, this.handleDataChannel();
  }
  /**
   * DataConsumer id.
   */
  get id() {
    return this._id;
  }
  /**
   * Associated DataProducer id.
   */
  get dataProducerId() {
    return this._dataProducerId;
  }
  /**
   * Whether the DataConsumer is closed.
   */
  get closed() {
    return this._closed;
  }
  /**
   * SCTP stream parameters.
   */
  get sctpStreamParameters() {
    return this._sctpStreamParameters;
  }
  /**
   * DataChannel readyState.
   */
  get readyState() {
    return this._dataChannel.readyState;
  }
  /**
   * DataChannel label.
   */
  get label() {
    return this._dataChannel.label;
  }
  /**
   * DataChannel protocol.
   */
  get protocol() {
    return this._dataChannel.protocol;
  }
  /**
   * DataChannel binaryType.
   */
  get binaryType() {
    return this._dataChannel.binaryType;
  }
  /**
   * Set DataChannel binaryType.
   */
  set binaryType(e) {
    this._dataChannel.binaryType = e;
  }
  /**
   * App custom data.
   */
  get appData() {
    return this._appData;
  }
  /**
   * Invalid setter.
   */
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  set appData(e) {
    throw new Error("cannot override appData object");
  }
  get observer() {
    return this._observer;
  }
  /**
   * Closes the DataConsumer.
   */
  close() {
    this._closed || (yr.debug("close()"), this._closed = !0, this._dataChannel.close(), this.emit("@close"), this._observer.safeEmit("close"));
  }
  /**
   * Transport was closed.
   */
  transportClosed() {
    this._closed || (yr.debug("transportClosed()"), this._closed = !0, this._dataChannel.close(), this.safeEmit("transportclose"), this._observer.safeEmit("close"));
  }
  handleDataChannel() {
    this._dataChannel.addEventListener("open", () => {
      this._closed || (yr.debug('DataChannel "open" event'), this.safeEmit("open"));
    }), this._dataChannel.addEventListener("error", (e) => {
      if (this._closed)
        return;
      let { error: t } = e;
      t || (t = new Error("unknown DataChannel error")), t.errorDetail === "sctp-failure" ? yr.error("DataChannel SCTP error [sctpCauseCode:%s]: %s", t.sctpCauseCode, t.message) : yr.error('DataChannel "error" event: %o', t), this.safeEmit("error", t);
    }), this._dataChannel.addEventListener("close", () => {
      this._closed || (yr.warn('DataChannel "close" event'), this._closed = !0, this.emit("@close"), this.safeEmit("close"), this._observer.safeEmit("close"));
    }), this._dataChannel.addEventListener("message", (e) => {
      this._closed || this.safeEmit("message", e.data);
    });
  }
}
const Qe = new Lt("Transport");
class Cv {
  constructor(e) {
    this.consumerOptions = e, this.promise = new Promise((t, s) => {
      this.resolve = t, this.reject = s;
    });
  }
}
let kv = class extends Kt {
  constructor({ direction: e, id: t, iceParameters: s, iceCandidates: i, dtlsParameters: n, sctpParameters: a, iceServers: o, iceTransportPolicy: d, additionalSettings: p, proprietaryConstraints: l, appData: u, handlerFactory: m, extendedRtpCapabilities: g, canProduceByKind: T }) {
    super(), this._closed = !1, this._connectionState = "new", this._producers = /* @__PURE__ */ new Map(), this._consumers = /* @__PURE__ */ new Map(), this._dataProducers = /* @__PURE__ */ new Map(), this._dataConsumers = /* @__PURE__ */ new Map(), this._probatorConsumerCreated = !1, this._awaitQueue = new Gu(), this._pendingConsumerTasks = [], this._consumerCreationInProgress = !1, this._pendingPauseConsumers = /* @__PURE__ */ new Map(), this._consumerPauseInProgress = !1, this._pendingResumeConsumers = /* @__PURE__ */ new Map(), this._consumerResumeInProgress = !1, this._pendingCloseConsumers = /* @__PURE__ */ new Map(), this._consumerCloseInProgress = !1, this._observer = new Kt(), Qe.debug("constructor() [id:%s, direction:%s]", t, e), this._id = t, this._direction = e, this._extendedRtpCapabilities = g, this._canProduceByKind = T, this._maxSctpMessageSize = a ? a.maxMessageSize : null, p = ze(p, {}), delete p.iceServers, delete p.iceTransportPolicy, delete p.bundlePolicy, delete p.rtcpMuxPolicy, delete p.sdpSemantics, this._handler = m(), this._handler.run({
      direction: e,
      iceParameters: s,
      iceCandidates: i,
      dtlsParameters: n,
      sctpParameters: a,
      iceServers: o,
      iceTransportPolicy: d,
      additionalSettings: p,
      proprietaryConstraints: l,
      extendedRtpCapabilities: g
    }), this._appData = u || {}, this.handleHandler();
  }
  /**
   * Transport id.
   */
  get id() {
    return this._id;
  }
  /**
   * Whether the Transport is closed.
   */
  get closed() {
    return this._closed;
  }
  /**
   * Transport direction.
   */
  get direction() {
    return this._direction;
  }
  /**
   * RTC handler instance.
   */
  get handler() {
    return this._handler;
  }
  /**
   * Connection state.
   */
  get connectionState() {
    return this._connectionState;
  }
  /**
   * App custom data.
   */
  get appData() {
    return this._appData;
  }
  /**
   * NOTE(callmetarush): Exposing all active producers to not
   * duplicate the same type of producers
   */
  get producers() {
    return this._producers;
  }
  /**
   * Invalid setter.
   */
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  set appData(e) {
    throw new Error("cannot override appData object");
  }
  get observer() {
    return this._observer;
  }
  /**
   * Close the Transport.
   */
  close() {
    if (!this._closed) {
      Qe.debug("close()"), this._closed = !0, this._awaitQueue.stop(), this._handler.close();
      for (const e of this._producers.values())
        e.transportClosed();
      this._producers.clear();
      for (const e of this._consumers.values())
        e.transportClosed();
      this._consumers.clear();
      for (const e of this._dataProducers.values())
        e.transportClosed();
      this._dataProducers.clear();
      for (const e of this._dataConsumers.values())
        e.transportClosed();
      this._dataConsumers.clear(), this._observer.safeEmit("close");
    }
  }
  /**
   * Get associated Transport (RTCPeerConnection) stats.
   *
   * @returns {RTCStatsReport}
   */
  async getStats() {
    if (this._closed)
      throw new Ae("closed");
    return this._handler.getTransportStats();
  }
  /**
   * Restart ICE connection.
   */
  async restartIce({ iceParameters: e }) {
    if (Qe.debug("restartIce()"), this._closed)
      throw new Ae("closed");
    if (!e)
      throw new TypeError("missing iceParameters");
    return this._awaitQueue.push(async () => this._handler.restartIce(e), "transport.restartIce()");
  }
  /**
   * Update ICE servers.
   */
  async updateIceServers({ iceServers: e } = {}) {
    if (Qe.debug("updateIceServers()"), this._closed)
      throw new Ae("closed");
    if (!Array.isArray(e))
      throw new TypeError("missing iceServers");
    return this._awaitQueue.push(async () => this._handler.updateIceServers(e), "transport.updateIceServers()");
  }
  /**
   * Create a Producer.
   */
  async produce({ track: e, encodings: t, codecOptions: s, codec: i, stopTracks: n = !0, disableTrackOnPause: a = !0, zeroRtpOnPause: o = !1, appData: d = {} } = {}) {
    if (Qe.debug("produce() [track:%o]", e), this._closed)
      throw new Ae("closed");
    if (e) {
      if (this._direction !== "send")
        throw new Mt("not a sending Transport");
      if (this._canProduceByKind[e.kind]) {
        if (e.readyState === "ended")
          throw new Ae("track ended");
        if (this.listenerCount("connect") === 0 && this._connectionState === "new")
          throw new TypeError('no "connect" listener set into this transport');
        if (this.listenerCount("produce") === 0)
          throw new TypeError('no "produce" listener set into this transport');
        if (d && typeof d != "object")
          throw new TypeError("if given, appData must be an object");
      } else
        throw new Mt(`cannot produce ${e.kind}`);
    } else
      throw new TypeError("missing track");
    return this._awaitQueue.push(async () => {
      let p;
      if (t && !Array.isArray(t))
        throw TypeError("encodings must be an array");
      t && t.length === 0 ? p = void 0 : t && (p = t.map((g) => {
        const T = { active: !0 };
        return g.active === !1 && (T.active = !1), typeof g.dtx == "boolean" && (T.dtx = g.dtx), typeof g.scalabilityMode == "string" && (T.scalabilityMode = g.scalabilityMode), typeof g.scaleResolutionDownBy == "number" && (T.scaleResolutionDownBy = g.scaleResolutionDownBy), typeof g.maxBitrate == "number" && (T.maxBitrate = g.maxBitrate), typeof g.maxFramerate == "number" && (T.maxFramerate = g.maxFramerate), typeof g.adaptivePtime == "boolean" && (T.adaptivePtime = g.adaptivePtime), typeof g.priority == "string" && (T.priority = g.priority), typeof g.networkPriority == "string" && (T.networkPriority = g.networkPriority), T;
      }));
      const { localId: l, rtpParameters: u, rtpSender: m } = await this._handler.send({
        track: e,
        encodings: p,
        codecOptions: s,
        codec: i
      });
      try {
        Nc(u);
        const { id: g } = await new Promise((S, R) => {
          this.safeEmit("produce", {
            kind: e.kind,
            rtpParameters: u,
            appData: d
          }, S, R);
        }), T = new wv({
          id: g,
          localId: l,
          rtpSender: m,
          track: e,
          rtpParameters: u,
          stopTracks: n,
          disableTrackOnPause: a,
          zeroRtpOnPause: o,
          appData: d
        });
        return this._producers.set(T.id, T), this.handleProducer(T), this._observer.safeEmit("newproducer", T), T;
      } catch (g) {
        throw this._handler.stopSending(l).catch(() => {
        }), g;
      }
    }, "transport.produce()").catch((p) => {
      if (n)
        try {
          e.stop();
        } catch (l) {
        }
      throw p;
    });
  }
  /**
   * Create a Consumer to consume a remote Producer.
   */
  async consume({ id: e, producerId: t, kind: s, rtpParameters: i, streamId: n, appData: a = {} }) {
    if (Qe.debug("consume()"), i = ze(i, void 0), this._closed)
      throw new Ae("closed");
    if (this._direction !== "recv")
      throw new Mt("not a receiving Transport");
    if (typeof e != "string")
      throw new TypeError("missing id");
    if (typeof t != "string")
      throw new TypeError("missing producerId");
    if (s !== "audio" && s !== "video")
      throw new TypeError(`invalid kind '${s}'`);
    if (this.listenerCount("connect") === 0 && this._connectionState === "new")
      throw new TypeError('no "connect" listener set into this transport');
    if (a && typeof a != "object")
      throw new TypeError("if given, appData must be an object");
    if (!gv(i, this._extendedRtpCapabilities))
      throw new Mt("cannot consume this Producer");
    const d = new Cv({
      id: e,
      producerId: t,
      kind: s,
      rtpParameters: i,
      streamId: n,
      appData: a
    });
    return this._pendingConsumerTasks.push(d), Ao(() => {
      if (this._closed)
        throw new Ae("closed");
      this._consumerCreationInProgress === !1 && this.createPendingConsumers();
    }), d.promise;
  }
  /**
   * Create a DataProducer
   */
  async produceData({ ordered: e = !0, maxPacketLifeTime: t, maxRetransmits: s, label: i = "", protocol: n = "", appData: a = {} } = {}) {
    if (Qe.debug("produceData()"), this._closed)
      throw new Ae("closed");
    if (this._direction !== "send")
      throw new Mt("not a sending Transport");
    if (this._maxSctpMessageSize) {
      if (this.listenerCount("connect") === 0 && this._connectionState === "new")
        throw new TypeError('no "connect" listener set into this transport');
      if (this.listenerCount("producedata") === 0)
        throw new TypeError('no "producedata" listener set into this transport');
      if (a && typeof a != "object")
        throw new TypeError("if given, appData must be an object");
    } else
      throw new Mt("SCTP not enabled by remote Transport");
    return (t || s) && (e = !1), this._awaitQueue.push(async () => {
      const { dataChannel: o, sctpStreamParameters: d } = await this._handler.sendDataChannel({
        ordered: e,
        maxPacketLifeTime: t,
        maxRetransmits: s,
        label: i,
        protocol: n
      });
      Yd(d);
      const { id: p } = await new Promise((u, m) => {
        this.safeEmit("producedata", {
          sctpStreamParameters: d,
          label: i,
          protocol: n,
          appData: a
        }, u, m);
      }), l = new bv({ id: p, dataChannel: o, sctpStreamParameters: d, appData: a });
      return this._dataProducers.set(l.id, l), this.handleDataProducer(l), this._observer.safeEmit("newdataproducer", l), l;
    }, "transport.produceData()");
  }
  /**
   * Create a DataConsumer
   */
  async consumeData({ id: e, dataProducerId: t, sctpStreamParameters: s, label: i = "", protocol: n = "", appData: a = {} }) {
    if (Qe.debug("consumeData()"), s = ze(s, void 0), this._closed)
      throw new Ae("closed");
    if (this._direction !== "recv")
      throw new Mt("not a receiving Transport");
    if (this._maxSctpMessageSize) {
      if (typeof e != "string")
        throw new TypeError("missing id");
      if (typeof t != "string")
        throw new TypeError("missing dataProducerId");
      if (this.listenerCount("connect") === 0 && this._connectionState === "new")
        throw new TypeError('no "connect" listener set into this transport');
      if (a && typeof a != "object")
        throw new TypeError("if given, appData must be an object");
    } else
      throw new Mt("SCTP not enabled by remote Transport");
    return Yd(s), this._awaitQueue.push(async () => {
      const { dataChannel: o } = await this._handler.receiveDataChannel({
        sctpStreamParameters: s,
        label: i,
        protocol: n
      }), d = new Pv({
        id: e,
        dataProducerId: t,
        dataChannel: o,
        sctpStreamParameters: s,
        appData: a
      });
      return this._dataConsumers.set(d.id, d), this.handleDataConsumer(d), this._observer.safeEmit("newdataconsumer", d), d;
    }, "transport.consumeData()");
  }
  // This method is guaranteed to never throw.
  async createPendingConsumers() {
    this._consumerCreationInProgress = !0, this._awaitQueue.push(async () => {
      if (this._pendingConsumerTasks.length === 0) {
        Qe.debug("createPendingConsumers() | there is no Consumer to be created");
        return;
      }
      const e = [...this._pendingConsumerTasks];
      this._pendingConsumerTasks = [];
      let t;
      const s = [];
      for (const i of e) {
        const { id: n, kind: a, rtpParameters: o, streamId: d } = i.consumerOptions;
        s.push({
          trackId: n,
          kind: a,
          rtpParameters: o,
          streamId: d
        });
      }
      try {
        const i = await this._handler.receive(s);
        for (let n = 0; n < i.length; n++) {
          const a = e[n], o = i[n], { id: d, producerId: p, kind: l, rtpParameters: u, appData: m } = a.consumerOptions, { localId: g, rtpReceiver: T, track: S } = o, R = new Rv({
            id: d,
            localId: g,
            producerId: p,
            rtpReceiver: T,
            track: S,
            rtpParameters: u,
            appData: m
          });
          this._consumers.set(R.id, R), this.handleConsumer(R), !this._probatorConsumerCreated && !t && l === "video" && (t = R), this._observer.safeEmit("newconsumer", R), a.resolve(R);
        }
      } catch (i) {
        for (const n of e)
          n.reject(i);
      }
      if (t)
        try {
          const i = fv(t.rtpParameters);
          await this._handler.receive([{
            trackId: "probator",
            kind: "video",
            rtpParameters: i
          }]), Qe.debug("createPendingConsumers() | Consumer for RTP probation created"), this._probatorConsumerCreated = !0;
        } catch (i) {
          Qe.error("createPendingConsumers() | failed to create Consumer for RTP probation:%o", i);
        }
    }, "transport.createPendingConsumers()").then(() => {
      this._consumerCreationInProgress = !1, this._pendingConsumerTasks.length > 0 && this.createPendingConsumers();
    }).catch(() => {
    });
  }
  pausePendingConsumers() {
    this._consumerPauseInProgress = !0, this._awaitQueue.push(async () => {
      if (this._pendingPauseConsumers.size === 0) {
        Qe.debug("pausePendingConsumers() | there is no Consumer to be paused");
        return;
      }
      const e = Array.from(this._pendingPauseConsumers.values());
      this._pendingPauseConsumers.clear();
      try {
        const t = e.map((s) => s.localId);
        await this._handler.pauseReceiving(t);
      } catch (t) {
        Qe.error("pausePendingConsumers() | failed to pause Consumers:", t);
      }
    }, "transport.pausePendingConsumers").then(() => {
      this._consumerPauseInProgress = !1, this._pendingPauseConsumers.size > 0 && this.pausePendingConsumers();
    }).catch(() => {
    });
  }
  resumePendingConsumers() {
    this._consumerResumeInProgress = !0, this._awaitQueue.push(async () => {
      if (this._pendingResumeConsumers.size === 0) {
        Qe.debug("resumePendingConsumers() | there is no Consumer to be resumed");
        return;
      }
      const e = Array.from(this._pendingResumeConsumers.values());
      this._pendingResumeConsumers.clear();
      try {
        const t = e.map((s) => s.localId);
        await this._handler.resumeReceiving(t);
      } catch (t) {
        Qe.error("resumePendingConsumers() | failed to resume Consumers:", t);
      }
    }, "transport.resumePendingConsumers").then(() => {
      this._consumerResumeInProgress = !1, this._pendingResumeConsumers.size > 0 && this.resumePendingConsumers();
    }).catch(() => {
    });
  }
  closePendingConsumers() {
    this._consumerCloseInProgress = !0, this._awaitQueue.push(async () => {
      if (this._pendingCloseConsumers.size === 0) {
        Qe.debug("closePendingConsumers() | there is no Consumer to be closed");
        return;
      }
      const e = Array.from(this._pendingCloseConsumers.values());
      this._pendingCloseConsumers.clear();
      try {
        await this._handler.stopReceiving(e.map((t) => t.localId));
      } catch (t) {
        Qe.error("closePendingConsumers() | failed to close Consumers:", t);
      }
    }, "transport.closePendingConsumers").then(() => {
      this._consumerCloseInProgress = !1, this._pendingCloseConsumers.size > 0 && this.closePendingConsumers();
    }).catch(() => {
    });
  }
  handleHandler() {
    const e = this._handler;
    e.on("@connect", ({ dtlsParameters: t }, s, i) => {
      if (this._closed) {
        i(new Ae("closed"));
        return;
      }
      this.safeEmit("connect", { dtlsParameters: t }, s, i);
    }), e.on("@connectionstatechange", (t) => {
      t !== this._connectionState && (Qe.debug("connection state changed to %s", t), this._connectionState = t, this._closed || this.safeEmit("connectionstatechange", t));
    });
  }
  handleProducer(e) {
    e.on("@close", () => {
      this._producers.delete(e.id), !this._closed && this._awaitQueue.push(async () => this._handler.stopSending(e.localId), "producer @close event").catch((t) => Qe.warn("producer.close() failed:%o", t));
    }), e.on("@pause", (t, s) => {
      this._awaitQueue.push(async () => this._handler.pauseSending(e.localId), "producer @pause event").then(t).catch(s);
    }), e.on("@resume", (t, s) => {
      this._awaitQueue.push(async () => this._handler.resumeSending(e.localId), "producer @resume event").then(t).catch(s);
    }), e.on("@replacetrack", (t, s, i) => {
      this._awaitQueue.push(async () => this._handler.replaceTrack(e.localId, t), "producer @replacetrack event").then(s).catch(i);
    }), e.on("@setmaxspatiallayer", (t, s, i) => {
      this._awaitQueue.push(async () => this._handler.setMaxSpatialLayer(e.localId, t), "producer @setmaxspatiallayer event").then(s).catch(i);
    }), e.on("@setrtpencodingparameters", (t, s, i) => {
      this._awaitQueue.push(async () => this._handler.setRtpEncodingParameters(e.localId, t), "producer @setrtpencodingparameters event").then(s).catch(i);
    }), e.on("@getstats", (t, s) => {
      if (this._closed)
        return s(new Ae("closed"));
      this._handler.getSenderStats(e.localId).then(t).catch(s);
    });
  }
  handleConsumer(e) {
    e.on("@close", () => {
      this._consumers.delete(e.id), this._pendingPauseConsumers.delete(e.id), this._pendingResumeConsumers.delete(e.id), !this._closed && (this._pendingCloseConsumers.set(e.id, e), this._consumerCloseInProgress === !1 && this.closePendingConsumers());
    }), e.on("@pause", () => {
      this._pendingResumeConsumers.has(e.id) && this._pendingResumeConsumers.delete(e.id), this._pendingPauseConsumers.set(e.id, e), Ao(() => {
        this._closed || this._consumerPauseInProgress === !1 && this.pausePendingConsumers();
      });
    }), e.on("@resume", () => {
      this._pendingPauseConsumers.has(e.id) && this._pendingPauseConsumers.delete(e.id), this._pendingResumeConsumers.set(e.id, e), Ao(() => {
        this._closed || this._consumerResumeInProgress === !1 && this.resumePendingConsumers();
      });
    }), e.on("@getstats", (t, s) => {
      if (this._closed)
        return s(new Ae("closed"));
      this._handler.getReceiverStats(e.localId).then(t).catch(s);
    });
  }
  handleDataProducer(e) {
    e.on("@close", () => {
      this._dataProducers.delete(e.id);
    });
  }
  handleDataConsumer(e) {
    e.on("@close", () => {
      this._dataConsumers.delete(e.id);
    });
  }
};
const mt = new Lt("Device");
function Dv() {
  var r, e, t, s;
  if (typeof navigator == "object" && navigator.product === "ReactNative") {
    if (typeof RTCPeerConnection == "undefined") {
      mt.warn("this._detectDevice() | unsupported react-native-webrtc without RTCPeerConnection, forgot to call registerGlobals()?");
      return;
    }
    return typeof RTCRtpTransceiver != "undefined" ? (mt.debug("this._detectDevice() | ReactNative UnifiedPlan handler chosen"), "ReactNativeUnifiedPlan") : (mt.debug("this._detectDevice() | ReactNative PlanB handler chosen"), "ReactNative");
  } else if (typeof navigator == "object" && typeof navigator.userAgent == "string") {
    let i = navigator.userAgent;
    i = i == null ? void 0 : i.replace("motorola edge", "motorola x");
    const n = Sc.getParser(i), a = n.getEngine();
    if (n.satisfies({ chrome: ">=111", chromium: ">=111", "microsoft edge": ">=111" }))
      return "Chrome111";
    if (n.satisfies({ chrome: ">=74", chromium: ">=74", "microsoft edge": ">=88" }))
      return "Chrome74";
    if (n.satisfies({ chrome: ">=70", chromium: ">=70" }))
      return "Chrome70";
    if (n.satisfies({ firefox: ">=60" }))
      return "Firefox60";
    if (n.satisfies({ ios: { OS: ">=14.3", firefox: ">=30.0" } }))
      return "Safari12";
    if (n.satisfies({ safari: ">=12.0" }) && typeof RTCRtpTransceiver != "undefined" && RTCRtpTransceiver.prototype.hasOwnProperty("currentDirection"))
      return "Safari12";
    if (((e = (r = n.parsedResult) === null || r === void 0 ? void 0 : r.os) === null || e === void 0 ? void 0 : e.name) === "iOS" && typeof RTCRtpTransceiver != "undefined" && RTCRtpTransceiver.prototype.hasOwnProperty("currentDirection"))
      return "Safari12";
    if (n.satisfies({ "microsoft edge": ">=11" }) && n.satisfies({ "microsoft edge": "<=18" }))
      return "Edge11";
    if (a.name && a.name.toLowerCase() === "blink") {
      const o = i.match(/(?:(?:Chrome|Chromium))[ /](\w+)/i);
      if (o) {
        const d = Number(o[1]);
        return d >= 111 ? "Chrome111" : d >= 74 ? "Chrome74" : "Chrome70";
      } else
        return "Chrome111";
    } else {
      if (((s = (t = n.parsedResult) === null || t === void 0 ? void 0 : t.os) === null || s === void 0 ? void 0 : s.name) === "iOS" && typeof RTCRtpTransceiver != "undefined" && RTCRtpTransceiver.prototype.hasOwnProperty("currentDirection"))
        return "Safari12";
      if (a.name && a.name.toLowerCase() === "webkit" && a.version && parseFloat(a.version) > 605)
        return "Safari12";
      mt.warn("this._detectDevice() | browser not supported [name:%s, version:%s]", n.getBrowserName(), n.getBrowserVersion());
      return;
    }
  } else {
    mt.warn("this._detectDevice() | unknown device");
    return;
  }
}
class Iv {
  /**
   * Create a new Device to connect to mediasoup server.
   *
   * @throws {UnsupportedError} if device is not supported.
   */
  constructor({ handlerName: e, handlerFactory: t, Handler: s } = {}) {
    if (this._loaded = !1, this._observer = new Kt(), mt.debug("constructor()"), s)
      if (mt.warn("constructor() | Handler option is DEPRECATED, use handlerName or handlerFactory instead"), typeof s == "string")
        e = s;
      else
        throw new TypeError("non string Handler option no longer supported, use handlerFactory instead");
    if (e && t)
      throw new TypeError("just one of handlerName or handlerInterface can be given");
    if (t)
      this._handlerFactory = t;
    else {
      if (e)
        mt.debug("constructor() | handler given: %s", e);
      else if (e = Dv(), e)
        mt.debug("constructor() | detected handler: %s", e);
      else
        throw new Mt("device not supported");
      this.switchDevice(e);
    }
    const i = this._handlerFactory();
    this._handlerName = i.name, i.close(), this._extendedRtpCapabilities = void 0, this._recvRtpCapabilities = void 0, this._canProduceByKind = {
      audio: !1,
      video: !1
    }, this._sctpCapabilities = void 0;
  }
  /**
   * The RTC handler name.
   */
  get handlerName() {
    return this._handlerName;
  }
  /**
   * Whether the Device is loaded.
   */
  get loaded() {
    return this._loaded;
  }
  /**
   * RTP capabilities of the Device for receiving media.
   *
   * @throws {InvalidStateError} if not loaded.
   */
  get rtpCapabilities() {
    if (!this._loaded)
      throw new Ae("not loaded");
    return this._recvRtpCapabilities;
  }
  /**
   * SCTP capabilities of the Device.
   *
   * @throws {InvalidStateError} if not loaded.
   */
  get sctpCapabilities() {
    if (!this._loaded)
      throw new Ae("not loaded");
    return this._sctpCapabilities;
  }
  get observer() {
    return this._observer;
  }
  /**
   * Initialize the Device.
   */
  async load({ routerRtpCapabilities: e }) {
    mt.debug("load() [routerRtpCapabilities:%o]", e), e = ze(e, void 0);
    let t;
    try {
      if (this._loaded)
        throw new Ae("already loaded");
      Io(e), t = this._handlerFactory();
      const s = await t.getNativeRtpCapabilities();
      mt.debug("load() | got native RTP capabilities:%o", s), Io(s), this._extendedRtpCapabilities = hv(s, e), mt.debug("load() | got extended RTP capabilities:%o", this._extendedRtpCapabilities), this._canProduceByKind.audio = Zd("audio", this._extendedRtpCapabilities), this._canProduceByKind.video = Zd("video", this._extendedRtpCapabilities), this._recvRtpCapabilities = mv(this._extendedRtpCapabilities), Io(this._recvRtpCapabilities), mt.debug("load() | got receiving RTP capabilities:%o", this._recvRtpCapabilities), this._sctpCapabilities = await t.getNativeSctpCapabilities(), mt.debug("load() | got native SCTP capabilities:%o", this._sctpCapabilities), uv(this._sctpCapabilities), mt.debug("load() succeeded"), this._loaded = !0, t.close();
    } catch (s) {
      throw t && t.close(), s;
    }
  }
  /**
   * Whether we can produce audio/video.
   *
   * @throws {InvalidStateError} if not loaded.
   * @throws {TypeError} if wrong arguments.
   */
  canProduce(e) {
    if (this._loaded) {
      if (e !== "audio" && e !== "video")
        throw new TypeError(`invalid kind "${e}"`);
    } else
      throw new Ae("not loaded");
    return this._canProduceByKind[e];
  }
  /**
   * Creates a Transport for sending media.
   *
   * @throws {InvalidStateError} if not loaded.
   * @throws {TypeError} if wrong arguments.
   */
  createSendTransport({ id: e, iceParameters: t, iceCandidates: s, dtlsParameters: i, sctpParameters: n, iceServers: a, iceTransportPolicy: o, additionalSettings: d, proprietaryConstraints: p, appData: l }) {
    return mt.debug("createSendTransport()"), this.createTransport({
      direction: "send",
      id: e,
      iceParameters: t,
      iceCandidates: s,
      dtlsParameters: i,
      sctpParameters: n,
      iceServers: a,
      iceTransportPolicy: o,
      additionalSettings: d,
      proprietaryConstraints: p,
      appData: l
    });
  }
  /**
   * Creates a Transport for receiving media.
   *
   * @throws {InvalidStateError} if not loaded.
   * @throws {TypeError} if wrong arguments.
   */
  createRecvTransport({ id: e, iceParameters: t, iceCandidates: s, dtlsParameters: i, sctpParameters: n, iceServers: a, iceTransportPolicy: o, additionalSettings: d, proprietaryConstraints: p, appData: l }) {
    return mt.debug("createRecvTransport()"), this.createTransport({
      direction: "recv",
      id: e,
      iceParameters: t,
      iceCandidates: s,
      dtlsParameters: i,
      sctpParameters: n,
      iceServers: a,
      iceTransportPolicy: o,
      additionalSettings: d,
      proprietaryConstraints: p,
      appData: l
    });
  }
  createTransport({ direction: e, id: t, iceParameters: s, iceCandidates: i, dtlsParameters: n, sctpParameters: a, iceServers: o, iceTransportPolicy: d, additionalSettings: p, proprietaryConstraints: l, appData: u }) {
    if (this._loaded) {
      if (typeof t != "string")
        throw new TypeError("missing id");
      if (typeof s != "object")
        throw new TypeError("missing iceParameters");
      if (Array.isArray(i)) {
        if (typeof n != "object")
          throw new TypeError("missing dtlsParameters");
        if (a && typeof a != "object")
          throw new TypeError("wrong sctpParameters");
        if (u && typeof u != "object")
          throw new TypeError("if given, appData must be an object");
      } else
        throw new TypeError("missing iceCandidates");
    } else
      throw new Ae("not loaded");
    const m = new kv({
      direction: e,
      id: t,
      iceParameters: s,
      iceCandidates: i,
      dtlsParameters: n,
      sctpParameters: a,
      iceServers: o,
      iceTransportPolicy: d,
      additionalSettings: p,
      proprietaryConstraints: l,
      appData: u,
      handlerFactory: this._handlerFactory,
      extendedRtpCapabilities: this._extendedRtpCapabilities,
      canProduceByKind: this._canProduceByKind
    });
    return this._observer.safeEmit("newtransport", m), m;
  }
}
function Jn({ sdpObject: r }) {
  const e = /* @__PURE__ */ new Map(), t = [];
  let s = !1, i = !1;
  for (const a of r.media) {
    const o = a.type;
    switch (o) {
      case "audio": {
        if (s)
          continue;
        s = !0;
        break;
      }
      case "video": {
        if (i)
          continue;
        i = !0;
        break;
      }
      default:
        continue;
    }
    for (const d of a.rtp) {
      const p = {
        kind: o,
        mimeType: `${o}/${d.codec}`,
        preferredPayloadType: d.payload,
        clockRate: d.rate,
        channels: d.encoding,
        parameters: {},
        rtcpFeedback: []
      };
      e.set(p.preferredPayloadType, p);
    }
    for (const d of a.fmtp || []) {
      const p = O.parseParams(d.config), l = e.get(d.payload);
      l && (p && p.hasOwnProperty("profile-level-id") && (p["profile-level-id"] = String(p["profile-level-id"])), l.parameters = p);
    }
    for (const d of a.rtcpFb || []) {
      const p = {
        type: d.type,
        parameter: d.subtype
      };
      if (p.parameter || delete p.parameter, d.payload !== "*") {
        const l = e.get(d.payload);
        if (!l)
          continue;
        l.rtcpFeedback.push(p);
      } else
        for (const l of e.values())
          l.kind === o && !/.+\/rtx$/i.test(l.mimeType) && l.rtcpFeedback.push(p);
    }
    for (const d of a.ext || []) {
      if (d["encrypt-uri"])
        continue;
      const p = {
        kind: o,
        uri: d.uri,
        preferredId: d.value
      };
      t.push(p);
    }
  }
  return {
    codecs: Array.from(e.values()),
    headerExtensions: t
  };
}
function Kn({ sdpObject: r }) {
  const e = (r.media || []).find((n) => n.iceUfrag && n.port !== 0);
  if (!e)
    throw new Error("no active media section found");
  const t = e.fingerprint || r.fingerprint;
  let s;
  switch (e.setup) {
    case "active":
      s = "client";
      break;
    case "passive":
      s = "server";
      break;
    case "actpass":
      s = "auto";
      break;
  }
  return {
    role: s,
    fingerprints: [
      {
        algorithm: t.type,
        value: t.hash
      }
    ]
  };
}
function zn({ offerMediaObject: r }) {
  const e = (r.ssrcs || []).find((t) => t.attribute === "cname");
  return e ? e.value : "";
}
function Qn({ offerRtpParameters: r, answerMediaObject: e }) {
  for (const t of r.codecs) {
    const s = t.mimeType.toLowerCase();
    if (s !== "audio/opus" || !(e.rtp || []).find((o) => o.payload === t.payloadType))
      continue;
    e.fmtp = e.fmtp || [];
    let n = e.fmtp.find((o) => o.payload === t.payloadType);
    n || (n = { payload: t.payloadType, config: "" }, e.fmtp.push(n));
    const a = O.parseParams(n.config);
    switch (s) {
      case "audio/opus": {
        const o = t.parameters["sprop-stereo"];
        o !== void 0 && (a.stereo = o ? 1 : 0);
        break;
      }
    }
    n.config = "";
    for (const o of Object.keys(a))
      n.config && (n.config += ";"), n.config += `${o}=${a[o]}`;
  }
}
function hr({ offerMediaObject: r }) {
  const e = /* @__PURE__ */ new Set();
  for (const i of r.ssrcs || []) {
    const n = i.id;
    e.add(n);
  }
  if (e.size === 0)
    throw new Error("no a=ssrc lines found");
  const t = /* @__PURE__ */ new Map();
  for (const i of r.ssrcGroups || []) {
    if (i.semantics !== "FID")
      continue;
    let [n, a] = i.ssrcs.split(/\s+/);
    n = Number(n), a = Number(a), e.has(n) && (e.delete(n), e.delete(a), t.set(n, a));
  }
  for (const i of e)
    t.set(i, null);
  const s = [];
  for (const [i, n] of t) {
    const a = { ssrc: i };
    n && (a.rtx = { ssrc: n }), s.push(a);
  }
  return s;
}
function Oa({ offerMediaObject: r, numStreams: e }) {
  if (e <= 1)
    throw new TypeError("numStreams must be greater than 1");
  const t = (r.ssrcs || []).find((u) => u.attribute === "msid");
  if (!t)
    throw new Error("a=ssrc line with msid information not found");
  const [s, i] = t.value.split(" "), n = t.id;
  let a;
  (r.ssrcGroups || []).some((u) => {
    if (u.semantics !== "FID")
      return !1;
    const m = u.ssrcs.split(/\s+/);
    return Number(m[0]) === n ? (a = Number(m[1]), !0) : !1;
  });
  const o = r.ssrcs.find((u) => u.attribute === "cname");
  if (!o)
    throw new Error("a=ssrc line with cname information not found");
  const d = o.value, p = [], l = [];
  for (let u = 0; u < e; ++u)
    p.push(n + u), a && l.push(a + u);
  r.ssrcGroups = [], r.ssrcs = [], r.ssrcGroups.push({
    semantics: "SIM",
    ssrcs: p.join(" ")
  });
  for (let u = 0; u < p.length; ++u) {
    const m = p[u];
    r.ssrcs.push({
      id: m,
      attribute: "cname",
      value: d
    }), r.ssrcs.push({
      id: m,
      attribute: "msid",
      value: `${s} ${i}`
    });
  }
  for (let u = 0; u < l.length; ++u) {
    const m = p[u], g = l[u];
    r.ssrcs.push({
      id: g,
      attribute: "cname",
      value: d
    }), r.ssrcs.push({
      id: g,
      attribute: "msid",
      value: `${s} ${i}`
    }), r.ssrcGroups.push({
      semantics: "FID",
      ssrcs: `${m} ${g}`
    });
  }
}
let Zi = class extends Kt {
  constructor() {
    super();
  }
};
class Wu {
  constructor({ iceParameters: e, iceCandidates: t, dtlsParameters: s, planB: i = !1 }) {
    if (this._mediaObject = {}, this._planB = i, e && this.setIceParameters(e), t) {
      this._mediaObject.candidates = [];
      for (const n of t) {
        const a = {};
        a.component = 1, a.foundation = n.foundation, a.ip = n.ip, a.port = n.port, a.priority = n.priority, a.transport = n.protocol, a.type = n.type, n.tcpType && (a.tcptype = n.tcpType), this._mediaObject.candidates.push(a);
      }
      this._mediaObject.endOfCandidates = "end-of-candidates", this._mediaObject.iceOptions = "renomination";
    }
    s && this.setDtlsRole(s.role);
  }
  get mid() {
    return String(this._mediaObject.mid);
  }
  get closed() {
    return this._mediaObject.port === 0;
  }
  getObject() {
    return this._mediaObject;
  }
  setIceParameters(e) {
    this._mediaObject.iceUfrag = e.usernameFragment, this._mediaObject.icePwd = e.password;
  }
  pause() {
    this._mediaObject.direction = "inactive";
  }
  disable() {
    this.pause(), delete this._mediaObject.ext, delete this._mediaObject.ssrcs, delete this._mediaObject.ssrcGroups, delete this._mediaObject.simulcast, delete this._mediaObject.simulcast_03, delete this._mediaObject.rids, delete this._mediaObject.extmapAllowMixed;
  }
  close() {
    this.disable(), this._mediaObject.port = 0;
  }
  muxSimulcastStreams(e) {
    if (this._mediaObject.simulcast && this._mediaObject.simulcast.list1) {
      const t = {};
      e.forEach((n) => {
        n.rid && (t[n.rid] = n);
      });
      const s = this._mediaObject.simulcast.list1, i = O.parseSimulcastStreamList(s);
      i.forEach((n) => {
        n.forEach((a) => {
          var o;
          a.paused = !(!((o = t[a.scid]) === null || o === void 0) && o.active);
        });
      }), this._mediaObject.simulcast.list1 = i.map((n) => n.map((a) => `${a.paused ? "~" : ""}${a.scid}`).join(",")).join(";");
    }
  }
}
class el extends Wu {
  constructor({ iceParameters: e, iceCandidates: t, dtlsParameters: s, sctpParameters: i, plainRtpParameters: n, planB: a = !1, offerMediaObject: o, offerRtpParameters: d, answerRtpParameters: p, codecOptions: l, extmapAllowMixed: u = !1, forceGoogConference: m = !1 }) {
    switch (super({ iceParameters: e, iceCandidates: t, dtlsParameters: s, planB: a }), this._mediaObject.mid = String(o.mid), this._mediaObject.type = o.type, this._mediaObject.protocol = o.protocol, n ? (this._mediaObject.connection = {
      ip: n.ip,
      version: n.ipVersion
    }, this._mediaObject.port = n.port) : (this._mediaObject.connection = { ip: "127.0.0.1", version: 4 }, this._mediaObject.port = 7), o.type) {
      case "audio":
      case "video": {
        this._mediaObject.direction = "recvonly", this._mediaObject.rtp = [], this._mediaObject.rtcpFb = [], this._mediaObject.fmtp = [];
        for (const g of p.codecs) {
          const T = {
            payload: g.payloadType,
            codec: Yo(g),
            rate: g.clockRate
          };
          g.channels > 1 && (T.encoding = g.channels), this._mediaObject.rtp.push(T);
          const S = ze(g.parameters, {});
          if (l) {
            const { opusStereo: D, opusFec: I, opusDtx: re, opusMaxPlaybackRate: ge, opusMaxAverageBitrate: Me, opusPtime: pe, videoGoogleStartBitrate: st, videoGoogleMaxBitrate: rt, videoGoogleMinBitrate: gt } = l, wt = d.codecs.find((Rt) => Rt.payloadType === g.payloadType);
            switch (g.mimeType.toLowerCase()) {
              case "audio/opus": {
                D !== void 0 && (wt.parameters["sprop-stereo"] = D ? 1 : 0, S.stereo = D ? 1 : 0), I !== void 0 && (wt.parameters.useinbandfec = I ? 1 : 0, S.useinbandfec = I ? 1 : 0), re !== void 0 && (wt.parameters.usedtx = re ? 1 : 0, S.usedtx = re ? 1 : 0), ge !== void 0 && (S.maxplaybackrate = ge), Me !== void 0 && (S.maxaveragebitrate = Me), pe !== void 0 && (wt.parameters.ptime = pe, S.ptime = pe);
                break;
              }
              case "video/vp8":
              case "video/vp9":
              case "video/h264":
              case "video/h265": {
                st !== void 0 && (S["x-google-start-bitrate"] = st), rt !== void 0 && (S["x-google-max-bitrate"] = rt), gt !== void 0 && (S["x-google-min-bitrate"] = gt);
                break;
              }
            }
          }
          const R = {
            payload: g.payloadType,
            config: ""
          };
          for (const D of Object.keys(S))
            R.config && (R.config += ";"), R.config += `${D}=${S[D]}`;
          R.config && this._mediaObject.fmtp.push(R);
          for (const D of g.rtcpFeedback)
            this._mediaObject.rtcpFb.push({
              payload: g.payloadType,
              type: D.type,
              subtype: D.parameter
            });
        }
        this._mediaObject.payloads = p.codecs.map((g) => g.payloadType).join(" "), this._mediaObject.ext = [];
        for (const g of p.headerExtensions)
          (o.ext || []).some((S) => S.uri === g.uri) && this._mediaObject.ext.push({
            uri: g.uri,
            value: g.id
          });
        if (u && o.extmapAllowMixed === "extmap-allow-mixed" && (this._mediaObject.extmapAllowMixed = "extmap-allow-mixed"), o.simulcast) {
          this._mediaObject.simulcast = {
            dir1: "recv",
            list1: o.simulcast.list1
          }, this._mediaObject.rids = [];
          for (const g of o.rids || [])
            g.direction === "send" && this._mediaObject.rids.push({
              id: g.id,
              direction: "recv"
            });
        } else if (o.simulcast_03) {
          this._mediaObject.simulcast_03 = {
            value: o.simulcast_03.value.replace(/send/g, "recv")
          }, this._mediaObject.rids = [];
          for (const g of o.rids || [])
            g.direction === "send" && this._mediaObject.rids.push({
              id: g.id,
              direction: "recv"
            });
        }
        this._mediaObject.rtcpMux = "rtcp-mux", this._mediaObject.rtcpRsize = "rtcp-rsize", (this._planB || m) && this._mediaObject.type === "video" && (this._mediaObject.xGoogleFlag = "conference");
        break;
      }
      case "application": {
        typeof o.sctpPort == "number" ? (this._mediaObject.payloads = "webrtc-datachannel", this._mediaObject.sctpPort = i.port, this._mediaObject.maxMessageSize = i.maxMessageSize) : o.sctpmap && (this._mediaObject.payloads = i.port, this._mediaObject.sctpmap = {
          app: "webrtc-datachannel",
          sctpmapNumber: i.port,
          maxMessageSize: i.maxMessageSize
        });
        break;
      }
    }
  }
  setDtlsRole(e) {
    switch (e) {
      case "client":
        this._mediaObject.setup = "active";
        break;
      case "server":
        this._mediaObject.setup = "passive";
        break;
      case "auto":
        this._mediaObject.setup = "actpass";
        break;
    }
  }
  resume() {
    this._mediaObject.direction = "recvonly";
  }
  muxSimulcastStreams(e) {
    var t;
    if (!this._mediaObject.simulcast || !this._mediaObject.simulcast.list1)
      return;
    const s = {};
    for (const a of e)
      a.rid && (s[a.rid] = a);
    const i = this._mediaObject.simulcast.list1, n = O.parseSimulcastStreamList(i);
    for (const a of n)
      for (const o of a)
        o.paused = !(!((t = s[o.scid]) === null || t === void 0) && t.active);
    this._mediaObject.simulcast.list1 = n.map((a) => a.map((o) => `${o.paused ? "~" : ""}${o.scid}`).join(",")).join(";");
  }
}
class tl extends Wu {
  constructor({ iceParameters: e, iceCandidates: t, dtlsParameters: s, sctpParameters: i, plainRtpParameters: n, planB: a = !1, mid: o, kind: d, offerRtpParameters: p, streamId: l, trackId: u, oldDataChannelSpec: m = !1 }) {
    switch (super({ iceParameters: e, iceCandidates: t, dtlsParameters: s, planB: a }), this._mediaObject.mid = String(o), this._mediaObject.type = d, n ? (this._mediaObject.connection = {
      ip: n.ip,
      version: n.ipVersion
    }, this._mediaObject.protocol = "RTP/AVP", this._mediaObject.port = n.port) : (this._mediaObject.connection = { ip: "127.0.0.1", version: 4 }, i ? this._mediaObject.protocol = "UDP/DTLS/SCTP" : this._mediaObject.protocol = "UDP/TLS/RTP/SAVPF", this._mediaObject.port = 7), d) {
      case "audio":
      case "video": {
        this._mediaObject.direction = "sendonly", this._mediaObject.rtp = [], this._mediaObject.rtcpFb = [], this._mediaObject.fmtp = [], this._planB || (this._mediaObject.msid = `${l || "-"} ${u}`);
        for (const R of p.codecs) {
          const D = {
            payload: R.payloadType,
            codec: Yo(R),
            rate: R.clockRate
          };
          R.channels > 1 && (D.encoding = R.channels), this._mediaObject.rtp.push(D);
          const I = {
            payload: R.payloadType,
            config: ""
          };
          for (const re of Object.keys(R.parameters))
            I.config && (I.config += ";"), I.config += `${re}=${R.parameters[re]}`;
          I.config && this._mediaObject.fmtp.push(I);
          for (const re of R.rtcpFeedback)
            this._mediaObject.rtcpFb.push({
              payload: R.payloadType,
              type: re.type,
              subtype: re.parameter
            });
        }
        this._mediaObject.payloads = p.codecs.map((R) => R.payloadType).join(" "), this._mediaObject.ext = [];
        for (const R of p.headerExtensions)
          this._mediaObject.ext.push({
            uri: R.uri,
            value: R.id
          });
        this._mediaObject.rtcpMux = "rtcp-mux", this._mediaObject.rtcpRsize = "rtcp-rsize";
        const g = p.encodings[0], T = g.ssrc, S = g.rtx && g.rtx.ssrc ? g.rtx.ssrc : void 0;
        this._mediaObject.ssrcs = [], this._mediaObject.ssrcGroups = [], p.rtcp.cname && this._mediaObject.ssrcs.push({
          id: T,
          attribute: "cname",
          value: p.rtcp.cname
        }), this._planB && this._mediaObject.ssrcs.push({
          id: T,
          attribute: "msid",
          value: `${l || "-"} ${u}`
        }), S && (p.rtcp.cname && this._mediaObject.ssrcs.push({
          id: S,
          attribute: "cname",
          value: p.rtcp.cname
        }), this._planB && this._mediaObject.ssrcs.push({
          id: S,
          attribute: "msid",
          value: `${l || "-"} ${u}`
        }), this._mediaObject.ssrcGroups.push({
          semantics: "FID",
          ssrcs: `${T} ${S}`
        }));
        break;
      }
      case "application": {
        m ? (this._mediaObject.payloads = i.port, this._mediaObject.sctpmap = {
          app: "webrtc-datachannel",
          sctpmapNumber: i.port,
          maxMessageSize: i.maxMessageSize
        }) : (this._mediaObject.payloads = "webrtc-datachannel", this._mediaObject.sctpPort = i.port, this._mediaObject.maxMessageSize = i.maxMessageSize);
        break;
      }
    }
  }
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  setDtlsRole(e) {
    this._mediaObject.setup = "actpass";
  }
  resume() {
    this._mediaObject.direction = "sendonly";
  }
  planBReceive({ offerRtpParameters: e, streamId: t, trackId: s }) {
    const i = e.encodings[0], n = i.ssrc, a = i.rtx && i.rtx.ssrc ? i.rtx.ssrc : void 0, o = this._mediaObject.payloads.split(" ");
    for (const d of e.codecs) {
      if (o.includes(String(d.payloadType)))
        continue;
      const p = {
        payload: d.payloadType,
        codec: Yo(d),
        rate: d.clockRate
      };
      d.channels > 1 && (p.encoding = d.channels), this._mediaObject.rtp.push(p);
      const l = {
        payload: d.payloadType,
        config: ""
      };
      for (const u of Object.keys(d.parameters))
        l.config && (l.config += ";"), l.config += `${u}=${d.parameters[u]}`;
      l.config && this._mediaObject.fmtp.push(l);
      for (const u of d.rtcpFeedback)
        this._mediaObject.rtcpFb.push({
          payload: d.payloadType,
          type: u.type,
          subtype: u.parameter
        });
    }
    this._mediaObject.payloads += ` ${e.codecs.filter((d) => !this._mediaObject.payloads.includes(d.payloadType)).map((d) => d.payloadType).join(" ")}`, this._mediaObject.payloads = this._mediaObject.payloads.trim(), e.rtcp.cname && this._mediaObject.ssrcs.push({
      id: n,
      attribute: "cname",
      value: e.rtcp.cname
    }), this._mediaObject.ssrcs.push({
      id: n,
      attribute: "msid",
      value: `${t || "-"} ${s}`
    }), a && (e.rtcp.cname && this._mediaObject.ssrcs.push({
      id: a,
      attribute: "cname",
      value: e.rtcp.cname
    }), this._mediaObject.ssrcs.push({
      id: a,
      attribute: "msid",
      value: `${t || "-"} ${s}`
    }), this._mediaObject.ssrcGroups.push({
      semantics: "FID",
      ssrcs: `${n} ${a}`
    }));
  }
  planBStopReceiving({ offerRtpParameters: e }) {
    const t = e.encodings[0], s = t.ssrc, i = t.rtx && t.rtx.ssrc ? t.rtx.ssrc : void 0;
    this._mediaObject.ssrcs = this._mediaObject.ssrcs.filter((n) => n.id !== s && n.id !== i), i && (this._mediaObject.ssrcGroups = this._mediaObject.ssrcGroups.filter((n) => n.ssrcs !== `${s} ${i}`));
  }
}
function Yo(r) {
  const t = new RegExp("^(audio|video)/(.+)", "i").exec(r.mimeType);
  if (!t)
    throw new TypeError("invalid codec.mimeType");
  return t[2];
}
const Mo = new Lt("RemoteSdp");
class Yn {
  constructor({ iceParameters: e, iceCandidates: t, dtlsParameters: s, sctpParameters: i, plainRtpParameters: n, planB: a = !1 }) {
    if (this._mediaSections = [], this._midToIndex = /* @__PURE__ */ new Map(), this._iceParameters = e, this._iceCandidates = t, this._dtlsParameters = s, this._sctpParameters = i, this._plainRtpParameters = n, this._planB = a, this._sdpObject = {
      version: 0,
      origin: {
        address: "0.0.0.0",
        ipVer: 4,
        netType: "IN",
        sessionId: 1e4,
        sessionVersion: 0,
        username: "mediasoup-client"
      },
      name: "-",
      timing: { start: 0, stop: 0 },
      media: []
    }, e && e.iceLite && (this._sdpObject.icelite = "ice-lite"), s) {
      this._sdpObject.msidSemantic = { semantic: "WMS", token: "*" };
      const o = this._dtlsParameters.fingerprints.length;
      this._sdpObject.fingerprint = {
        type: s.fingerprints[o - 1].algorithm,
        hash: s.fingerprints[o - 1].value
      }, this._sdpObject.groups = [{ type: "BUNDLE", mids: "" }];
    }
    n && (this._sdpObject.origin.address = n.ip, this._sdpObject.origin.ipVer = n.ipVersion);
  }
  updateIceParameters(e) {
    Mo.debug("updateIceParameters() [iceParameters:%o]", e), this._iceParameters = e, this._sdpObject.icelite = e.iceLite ? "ice-lite" : void 0;
    for (const t of this._mediaSections)
      t.setIceParameters(e);
  }
  updateDtlsRole(e) {
    Mo.debug("updateDtlsRole() [role:%s]", e), this._dtlsParameters.role = e;
    for (const t of this._mediaSections)
      t.setDtlsRole(e);
  }
  getNextMediaSectionIdx() {
    for (let e = 0; e < this._mediaSections.length; ++e) {
      const t = this._mediaSections[e];
      if (t.closed)
        return { idx: e, reuseMid: t.mid };
    }
    return { idx: this._mediaSections.length };
  }
  send({ offerMediaObject: e, reuseMid: t, offerRtpParameters: s, answerRtpParameters: i, codecOptions: n, extmapAllowMixed: a = !1, forceGoogConference: o = !1 }) {
    const d = new el({
      iceParameters: this._iceParameters,
      iceCandidates: this._iceCandidates,
      dtlsParameters: this._dtlsParameters,
      plainRtpParameters: this._plainRtpParameters,
      planB: this._planB,
      offerMediaObject: e,
      offerRtpParameters: s,
      answerRtpParameters: i,
      codecOptions: n,
      extmapAllowMixed: a,
      forceGoogConference: o
    });
    t ? this._replaceMediaSection(d, t) : this._midToIndex.has(d.mid) ? this._replaceMediaSection(d) : this._addMediaSection(d);
  }
  receive({ mid: e, kind: t, offerRtpParameters: s, streamId: i, trackId: n }) {
    const a = this._midToIndex.get(e);
    let o;
    if (a !== void 0 && (o = this._mediaSections[a]), o)
      o.planBReceive({ offerRtpParameters: s, streamId: i, trackId: n }), this._replaceMediaSection(o);
    else {
      o = new tl({
        iceParameters: this._iceParameters,
        iceCandidates: this._iceCandidates,
        dtlsParameters: this._dtlsParameters,
        plainRtpParameters: this._plainRtpParameters,
        planB: this._planB,
        mid: e,
        kind: t,
        offerRtpParameters: s,
        streamId: i,
        trackId: n
      });
      const d = this._mediaSections.find((p) => p.closed);
      d ? this._replaceMediaSection(o, d.mid) : this._addMediaSection(o);
    }
  }
  pauseMediaSection(e) {
    this._findMediaSection(e).pause();
  }
  resumeSendingMediaSection(e) {
    this._findMediaSection(e).resume();
  }
  resumeReceivingMediaSection(e) {
    this._findMediaSection(e).resume();
  }
  disableMediaSection(e) {
    this._findMediaSection(e).disable();
  }
  /**
   * Closes media section. Returns true if the given MID corresponds to a m
   * section that has been indeed closed. False otherwise.
   *
   * NOTE: Closing the first m section is a pain since it invalidates the bundled
   * transport, so instead closing it we just disable it.
   */
  closeMediaSection(e) {
    const t = this._findMediaSection(e);
    return e === this._firstMid ? (Mo.debug("closeMediaSection() | cannot close first media section, disabling it instead [mid:%s]", e), this.disableMediaSection(e), !1) : (t.close(), this._regenerateBundleMids(), !0);
  }
  muxMediaSectionSimulcast(e, t) {
    const s = this._midToIndex.get(e);
    if (s === void 0)
      throw new Error(`no media section found with mid '${e}'`);
    const i = this._mediaSections[s];
    if (i === void 0)
      throw new Error(`no media section found with idx '${s}'`);
    i.muxSimulcastStreams(t), this._replaceMediaSection(i);
  }
  planBStopReceiving({ mid: e, offerRtpParameters: t }) {
    const s = this._findMediaSection(e);
    s.planBStopReceiving({ offerRtpParameters: t }), this._replaceMediaSection(s);
  }
  sendSctpAssociation({ offerMediaObject: e }) {
    const t = new el({
      iceParameters: this._iceParameters,
      iceCandidates: this._iceCandidates,
      dtlsParameters: this._dtlsParameters,
      sctpParameters: this._sctpParameters,
      plainRtpParameters: this._plainRtpParameters,
      offerMediaObject: e
    });
    this._addMediaSection(t);
  }
  receiveSctpAssociation({ oldDataChannelSpec: e = !1 } = {}) {
    const t = new tl({
      iceParameters: this._iceParameters,
      iceCandidates: this._iceCandidates,
      dtlsParameters: this._dtlsParameters,
      sctpParameters: this._sctpParameters,
      plainRtpParameters: this._plainRtpParameters,
      mid: "datachannel",
      kind: "application",
      oldDataChannelSpec: e
    });
    this._addMediaSection(t);
  }
  getSdp() {
    return this._sdpObject.origin.sessionVersion++, O.write(this._sdpObject);
  }
  _addMediaSection(e) {
    this._firstMid || (this._firstMid = e.mid), this._mediaSections.push(e), this._midToIndex.set(e.mid, this._mediaSections.length - 1), this._sdpObject.media.push(e.getObject()), this._regenerateBundleMids();
  }
  _replaceMediaSection(e, t) {
    if (typeof t == "string") {
      const s = this._midToIndex.get(t);
      if (s === void 0)
        throw new Error(`no media section found for reuseMid '${t}'`);
      const i = this._mediaSections[s];
      this._mediaSections[s] = e, this._midToIndex.delete(i.mid), this._midToIndex.set(e.mid, s), this._sdpObject.media[s] = e.getObject(), this._regenerateBundleMids();
    } else {
      const s = this._midToIndex.get(e.mid);
      if (s === void 0)
        throw new Error(`no media section found with mid '${e.mid}'`);
      this._mediaSections[s] = e, this._sdpObject.media[s] = e.getObject();
    }
  }
  _findMediaSection(e) {
    const t = this._midToIndex.get(e);
    if (t === void 0)
      throw new Error(`no media section found with mid '${e}'`);
    return this._mediaSections[t];
  }
  _regenerateBundleMids() {
    this._dtlsParameters && (this._sdpObject.groups[0].mids = this._mediaSections.filter((e) => !e.closed).map((e) => e.mid).join(" "));
  }
}
const Av = new RegExp("^[LS]([1-9]\\d{0,1})T([1-9]\\d{0,1})");
function Zn(r) {
  const e = Av.exec(r || "");
  return e ? {
    spatialLayers: Number(e[1]),
    temporalLayers: Number(e[2])
  } : {
    spatialLayers: 1,
    temporalLayers: 1
  };
}
const X = new Lt("Chrome70"), sl = { OS: 1024, MIS: 1024 };
class xc extends Zi {
  /**
   * Creates a factory function.
   */
  static createFactory() {
    return () => new xc();
  }
  constructor() {
    super(), this._mapMidTransceiver = /* @__PURE__ */ new Map(), this._sendStream = new MediaStream(), this._hasDataChannelMediaSection = !1, this._nextSendSctpStreamId = 0, this._transportReady = !1;
  }
  get name() {
    return "Chrome70";
  }
  close() {
    if (X.debug("close()"), this._pc)
      try {
        this._pc.close();
      } catch (e) {
      }
    this.emit("@close");
  }
  async getNativeRtpCapabilities() {
    X.debug("getNativeRtpCapabilities()");
    const e = new RTCPeerConnection({
      iceServers: [],
      iceTransportPolicy: "all",
      bundlePolicy: "max-bundle",
      rtcpMuxPolicy: "require",
      sdpSemantics: "unified-plan"
    });
    try {
      e.addTransceiver("audio"), e.addTransceiver("video");
      const t = await e.createOffer();
      try {
        e.close();
      } catch (n) {
      }
      const s = O.parse(t.sdp);
      return Jn({ sdpObject: s });
    } catch (t) {
      try {
        e.close();
      } catch (s) {
      }
      throw t;
    }
  }
  async getNativeSctpCapabilities() {
    return X.debug("getNativeSctpCapabilities()"), {
      numStreams: sl
    };
  }
  run({ direction: e, iceParameters: t, iceCandidates: s, dtlsParameters: i, sctpParameters: n, iceServers: a, iceTransportPolicy: o, additionalSettings: d, proprietaryConstraints: p, extendedRtpCapabilities: l }) {
    X.debug("run()"), this._direction = e, this._remoteSdp = new Yn({
      iceParameters: t,
      iceCandidates: s,
      dtlsParameters: i,
      sctpParameters: n
    }), this._sendingRtpParametersByKind = {
      audio: zt("audio", l),
      video: zt("video", l)
    }, this._sendingRemoteRtpParametersByKind = {
      audio: _s("audio", l),
      video: _s("video", l)
    }, i.role && i.role !== "auto" && (this._forcedLocalDtlsRole = i.role === "server" ? "client" : "server"), this._pc = new RTCPeerConnection({
      iceServers: a || [],
      iceTransportPolicy: o || "all",
      bundlePolicy: "max-bundle",
      rtcpMuxPolicy: "require",
      sdpSemantics: "unified-plan",
      ...d
    }, p), this._pc.connectionState ? this._pc.addEventListener("connectionstatechange", () => {
      this.emit("@connectionstatechange", this._pc.connectionState);
    }) : this._pc.addEventListener("iceconnectionstatechange", () => {
      switch (X.warn("run() | pc.connectionState not supported, using pc.iceConnectionState"), this._pc.iceConnectionState) {
        case "checking":
          this.emit("@connectionstatechange", "connecting");
          break;
        case "connected":
        case "completed":
          this.emit("@connectionstatechange", "connected");
          break;
        case "failed":
          this.emit("@connectionstatechange", "failed");
          break;
        case "disconnected":
          this.emit("@connectionstatechange", "disconnected");
          break;
        case "closed":
          this.emit("@connectionstatechange", "closed");
          break;
      }
    });
  }
  async updateIceServers(e) {
    X.debug("updateIceServers()");
    const t = this._pc.getConfiguration();
    t.iceServers = e, this._pc.setConfiguration(t);
  }
  async restartIce(e) {
    if (X.debug("restartIce()"), this._remoteSdp.updateIceParameters(e), !!this._transportReady)
      if (this._direction === "send") {
        const t = await this._pc.createOffer({ iceRestart: !0 });
        X.debug("restartIce() | calling pc.setLocalDescription() [offer:%o]", t), await this._pc.setLocalDescription(t);
        const s = { type: "answer", sdp: this._remoteSdp.getSdp() };
        X.debug("restartIce() | calling pc.setRemoteDescription() [answer:%o]", s), await this._pc.setRemoteDescription(s);
      } else {
        const t = { type: "offer", sdp: this._remoteSdp.getSdp() };
        X.debug("restartIce() | calling pc.setRemoteDescription() [offer:%o]", t), await this._pc.setRemoteDescription(t);
        const s = await this._pc.createAnswer();
        X.debug("restartIce() | calling pc.setLocalDescription() [answer:%o]", s), await this._pc.setLocalDescription(s);
      }
  }
  async getTransportStats() {
    return this._pc.getStats();
  }
  async send({ track: e, encodings: t, codecOptions: s, codec: i }) {
    var n;
    this.assertSendDirection(), X.debug("send() [kind:%s, track.id:%s]", e.kind, e.id);
    const a = ze(this._sendingRtpParametersByKind[e.kind], {});
    a.codecs = ns(a.codecs, i);
    const o = ze(this._sendingRemoteRtpParametersByKind[e.kind], {});
    o.codecs = ns(o.codecs, i);
    const d = this._remoteSdp.getNextMediaSectionIdx(), p = this._pc.addTransceiver(e, { direction: "sendonly", streams: [this._sendStream] });
    let l = await this._pc.createOffer(), u = O.parse(l.sdp), m;
    this._transportReady || await this.setupTransport({
      localDtlsRole: (n = this._forcedLocalDtlsRole) !== null && n !== void 0 ? n : "client",
      localSdpObject: u
    }), t && t.length > 1 && (X.debug("send() | enabling legacy simulcast"), u = O.parse(l.sdp), m = u.media[d.idx], Oa({
      offerMediaObject: m,
      numStreams: t.length
    }), l = { type: "offer", sdp: O.write(u) });
    let g = !1;
    const T = Zn((t || [{}])[0].scalabilityMode);
    if (t && t.length === 1 && T.spatialLayers > 1 && a.codecs[0].mimeType.toLowerCase() === "video/vp9" && (X.debug("send() | enabling legacy simulcast for VP9 SVC"), g = !0, u = O.parse(l.sdp), m = u.media[d.idx], Oa({
      offerMediaObject: m,
      numStreams: T.spatialLayers
    }), l = { type: "offer", sdp: O.write(u) }), X.debug("send() | calling pc.setLocalDescription() [offer:%o]", l), await this._pc.setLocalDescription(l), t) {
      X.debug("send() | applying given encodings");
      const D = p.sender.getParameters();
      for (let I = 0; I < (D.encodings || []).length; ++I) {
        const re = D.encodings[I], ge = t[I];
        if (!ge)
          break;
        D.encodings[I] = Object.assign(re, ge);
      }
      await p.sender.setParameters(D);
    }
    const S = p.mid;
    if (a.mid = S, u = O.parse(this._pc.localDescription.sdp), m = u.media[d.idx], a.rtcp.cname = zn({ offerMediaObject: m }), a.encodings = hr({ offerMediaObject: m }), t)
      for (let D = 0; D < a.encodings.length; ++D)
        t[D] && Object.assign(a.encodings[D], t[D]);
    if (g && (a.encodings = [a.encodings[0]]), a.encodings.length > 1 && (a.codecs[0].mimeType.toLowerCase() === "video/vp8" || a.codecs[0].mimeType.toLowerCase() === "video/h264"))
      for (const D of a.encodings)
        D.scalabilityMode = "L1T3";
    this._remoteSdp.send({
      offerMediaObject: m,
      reuseMid: d.reuseMid,
      offerRtpParameters: a,
      answerRtpParameters: o,
      codecOptions: s
    });
    const R = { type: "answer", sdp: this._remoteSdp.getSdp() };
    return X.debug("send() | calling pc.setRemoteDescription() [answer:%o]", R), await this._pc.setRemoteDescription(R), this._mapMidTransceiver.set(S, p), {
      localId: S,
      rtpParameters: a,
      rtpSender: p.sender
    };
  }
  async stopSending(e) {
    this.assertSendDirection(), X.debug("stopSending() [localId:%s]", e);
    const t = this._mapMidTransceiver.get(e);
    if (!t)
      throw new Error("associated RTCRtpTransceiver not found");
    if (t.sender.replaceTrack(null), this._pc.removeTrack(t.sender), this._remoteSdp.closeMediaSection(t.mid))
      try {
        t.stop();
      } catch (a) {
      }
    const i = await this._pc.createOffer();
    X.debug("stopSending() | calling pc.setLocalDescription() [offer:%o]", i), await this._pc.setLocalDescription(i);
    const n = { type: "answer", sdp: this._remoteSdp.getSdp() };
    X.debug("stopSending() | calling pc.setRemoteDescription() [answer:%o]", n), await this._pc.setRemoteDescription(n), this._mapMidTransceiver.delete(e);
  }
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  async pauseSending(e) {
  }
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  async resumeSending(e) {
  }
  async replaceTrack(e, t) {
    this.assertSendDirection(), t ? X.debug("replaceTrack() [localId:%s, track.id:%s]", e, t.id) : X.debug("replaceTrack() [localId:%s, no track]", e);
    const s = this._mapMidTransceiver.get(e);
    if (!s)
      throw new Error("associated RTCRtpTransceiver not found");
    await s.sender.replaceTrack(t);
  }
  async setMaxSpatialLayer(e, t) {
    this.assertSendDirection(), X.debug("setMaxSpatialLayer() [localId:%s, spatialLayer:%s]", e, t);
    const s = this._mapMidTransceiver.get(e);
    if (!s)
      throw new Error("associated RTCRtpTransceiver not found");
    const i = s.sender.getParameters();
    i.encodings.forEach((o, d) => {
      d <= t ? o.active = !0 : o.active = !1;
    }), await s.sender.setParameters(i), this._remoteSdp.muxMediaSectionSimulcast(e, i.encodings);
    const n = await this._pc.createOffer();
    X.debug("setMaxSpatialLayer() | calling pc.setLocalDescription() [offer:%o]", n), await this._pc.setLocalDescription(n);
    const a = { type: "answer", sdp: this._remoteSdp.getSdp() };
    X.debug("setMaxSpatialLayer() | calling pc.setRemoteDescription() [answer:%o]", a), await this._pc.setRemoteDescription(a);
  }
  async setRtpEncodingParameters(e, t) {
    this.assertSendDirection(), X.debug("setRtpEncodingParameters() [localId:%s, params:%o]", e, t);
    const s = this._mapMidTransceiver.get(e);
    if (!s)
      throw new Error("associated RTCRtpTransceiver not found");
    const i = s.sender.getParameters();
    i.encodings.forEach((o, d) => {
      i.encodings[d] = { ...o, ...t };
    }), await s.sender.setParameters(i), this._remoteSdp.muxMediaSectionSimulcast(e, i.encodings);
    const n = await this._pc.createOffer();
    X.debug("setRtpEncodingParameters() | calling pc.setLocalDescription() [offer:%o]", n), await this._pc.setLocalDescription(n);
    const a = { type: "answer", sdp: this._remoteSdp.getSdp() };
    X.debug("setRtpEncodingParameters() | calling pc.setRemoteDescription() [answer:%o]", a), await this._pc.setRemoteDescription(a);
  }
  async getSenderStats(e) {
    this.assertSendDirection();
    const t = this._mapMidTransceiver.get(e);
    if (!t)
      throw new Error("associated RTCRtpTransceiver not found");
    return t.sender.getStats();
  }
  async sendDataChannel({ ordered: e, maxPacketLifeTime: t, maxRetransmits: s, label: i, protocol: n }) {
    var a;
    this.assertSendDirection();
    const o = {
      negotiated: !0,
      id: this._nextSendSctpStreamId,
      ordered: e,
      maxPacketLifeTime: t,
      maxRetransmitTime: t,
      maxRetransmits: s,
      protocol: n
    };
    X.debug("sendDataChannel() [options:%o]", o);
    const d = this._pc.createDataChannel(i, o);
    if (this._nextSendSctpStreamId = ++this._nextSendSctpStreamId % sl.MIS, !this._hasDataChannelMediaSection) {
      const l = await this._pc.createOffer(), u = O.parse(l.sdp), m = u.media.find((T) => T.type === "application");
      this._transportReady || await this.setupTransport({
        localDtlsRole: (a = this._forcedLocalDtlsRole) !== null && a !== void 0 ? a : "client",
        localSdpObject: u
      }), X.debug("sendDataChannel() | calling pc.setLocalDescription() [offer:%o]", l), await this._pc.setLocalDescription(l), this._remoteSdp.sendSctpAssociation({ offerMediaObject: m });
      const g = { type: "answer", sdp: this._remoteSdp.getSdp() };
      X.debug("sendDataChannel() | calling pc.setRemoteDescription() [answer:%o]", g), await this._pc.setRemoteDescription(g), this._hasDataChannelMediaSection = !0;
    }
    const p = {
      streamId: o.id,
      ordered: o.ordered,
      maxPacketLifeTime: o.maxPacketLifeTime,
      maxRetransmits: o.maxRetransmits
    };
    return { dataChannel: d, sctpStreamParameters: p };
  }
  async receive(e) {
    var t;
    this.assertRecvDirection();
    const s = [], i = /* @__PURE__ */ new Map();
    for (const d of e) {
      const { trackId: p, kind: l, rtpParameters: u, streamId: m } = d;
      X.debug("receive() [trackId:%s, kind:%s]", p, l);
      const g = u.mid || String(this._mapMidTransceiver.size);
      i.set(p, g), this._remoteSdp.receive({
        mid: g,
        kind: l,
        offerRtpParameters: u,
        streamId: m || u.rtcp.cname,
        trackId: p
      });
    }
    const n = { type: "offer", sdp: this._remoteSdp.getSdp() };
    X.debug("receive() | calling pc.setRemoteDescription() [offer:%o]", n), await this._pc.setRemoteDescription(n);
    let a = await this._pc.createAnswer();
    const o = O.parse(a.sdp);
    for (const d of e) {
      const { trackId: p, rtpParameters: l } = d, u = i.get(p), m = o.media.find((g) => String(g.mid) === u);
      Qn({
        offerRtpParameters: l,
        answerMediaObject: m
      });
    }
    a = { type: "answer", sdp: O.write(o) }, this._transportReady || await this.setupTransport({
      localDtlsRole: (t = this._forcedLocalDtlsRole) !== null && t !== void 0 ? t : "client",
      localSdpObject: o
    }), X.debug("receive() | calling pc.setLocalDescription() [answer:%o]", a), await this._pc.setLocalDescription(a);
    for (const d of e) {
      const { trackId: p } = d, l = i.get(p), u = this._pc.getTransceivers().find((m) => m.mid === l);
      if (!u)
        throw new Error("new RTCRtpTransceiver not found");
      this._mapMidTransceiver.set(l, u), s.push({
        localId: l,
        track: u.receiver.track,
        rtpReceiver: u.receiver
      });
    }
    return s;
  }
  async stopReceiving(e) {
    this.assertRecvDirection();
    for (const i of e) {
      X.debug("stopReceiving() [localId:%s]", i);
      const n = this._mapMidTransceiver.get(i);
      if (!n)
        throw new Error("associated RTCRtpTransceiver not found");
      this._remoteSdp.closeMediaSection(n.mid);
    }
    const t = { type: "offer", sdp: this._remoteSdp.getSdp() };
    X.debug("stopReceiving() | calling pc.setRemoteDescription() [offer:%o]", t), await this._pc.setRemoteDescription(t);
    const s = await this._pc.createAnswer();
    X.debug("stopReceiving() | calling pc.setLocalDescription() [answer:%o]", s), await this._pc.setLocalDescription(s);
    for (const i of e)
      this._mapMidTransceiver.delete(i);
  }
  async pauseReceiving(e) {
  }
  async resumeReceiving(e) {
  }
  async getReceiverStats(e) {
    this.assertRecvDirection();
    const t = this._mapMidTransceiver.get(e);
    if (!t)
      throw new Error("associated RTCRtpTransceiver not found");
    return t.receiver.getStats();
  }
  async receiveDataChannel({ sctpStreamParameters: e, label: t, protocol: s }) {
    var i;
    this.assertRecvDirection();
    const { streamId: n, ordered: a, maxPacketLifeTime: o, maxRetransmits: d } = e, p = {
      negotiated: !0,
      id: n,
      ordered: a,
      maxPacketLifeTime: o,
      maxRetransmitTime: o,
      maxRetransmits: d,
      protocol: s
    };
    X.debug("receiveDataChannel() [options:%o]", p);
    const l = this._pc.createDataChannel(t, p);
    if (!this._hasDataChannelMediaSection) {
      this._remoteSdp.receiveSctpAssociation();
      const u = { type: "offer", sdp: this._remoteSdp.getSdp() };
      X.debug("receiveDataChannel() | calling pc.setRemoteDescription() [offer:%o]", u), await this._pc.setRemoteDescription(u);
      const m = await this._pc.createAnswer();
      if (!this._transportReady) {
        const g = O.parse(m.sdp);
        await this.setupTransport({
          localDtlsRole: (i = this._forcedLocalDtlsRole) !== null && i !== void 0 ? i : "client",
          localSdpObject: g
        });
      }
      X.debug("receiveDataChannel() | calling pc.setRemoteDescription() [answer:%o]", m), await this._pc.setLocalDescription(m), this._hasDataChannelMediaSection = !0;
    }
    return { dataChannel: l };
  }
  async setupTransport({ localDtlsRole: e, localSdpObject: t }) {
    t || (t = O.parse(this._pc.localDescription.sdp));
    const s = Kn({ sdpObject: t });
    s.role = e, this._remoteSdp.updateDtlsRole(e === "client" ? "server" : "client"), await new Promise((i, n) => {
      this.safeEmit("@connect", { dtlsParameters: s }, i, n);
    }), this._transportReady = !0;
  }
  assertSendDirection() {
    if (this._direction !== "send")
      throw new Error('method can just be called for handlers with "send" direction');
  }
  assertRecvDirection() {
    if (this._direction !== "recv")
      throw new Error('method can just be called for handlers with "recv" direction');
  }
}
const U = new Lt("Chrome74"), rl = { OS: 1024, MIS: 1024 };
let Mv = class Ju extends Zi {
  /**
   * Creates a factory function.
   */
  static createFactory() {
    return () => new Ju();
  }
  constructor() {
    super(), this._mapMidTransceiver = /* @__PURE__ */ new Map(), this._sendStream = new MediaStream(), this._hasDataChannelMediaSection = !1, this._nextSendSctpStreamId = 0, this._transportReady = !1;
  }
  get name() {
    return "Chrome74";
  }
  close() {
    if (U.debug("close()"), this._pc)
      try {
        this._pc.close();
      } catch (e) {
      }
    this.emit("@close");
  }
  async getNativeRtpCapabilities() {
    U.debug("getNativeRtpCapabilities()");
    const e = new RTCPeerConnection({
      iceServers: [],
      iceTransportPolicy: "all",
      bundlePolicy: "max-bundle",
      rtcpMuxPolicy: "require",
      sdpSemantics: "unified-plan"
    });
    try {
      e.addTransceiver("audio"), e.addTransceiver("video");
      const t = await e.createOffer();
      try {
        e.close();
      } catch (n) {
      }
      const s = O.parse(t.sdp);
      return Jn({ sdpObject: s });
    } catch (t) {
      try {
        e.close();
      } catch (s) {
      }
      throw t;
    }
  }
  async getNativeSctpCapabilities() {
    return U.debug("getNativeSctpCapabilities()"), {
      numStreams: rl
    };
  }
  run({ direction: e, iceParameters: t, iceCandidates: s, dtlsParameters: i, sctpParameters: n, iceServers: a, iceTransportPolicy: o, additionalSettings: d, proprietaryConstraints: p, extendedRtpCapabilities: l }) {
    U.debug("run()"), this._direction = e, this._remoteSdp = new Yn({
      iceParameters: t,
      iceCandidates: s,
      dtlsParameters: i,
      sctpParameters: n
    }), this._sendingRtpParametersByKind = {
      audio: zt("audio", l),
      video: zt("video", l)
    }, this._sendingRemoteRtpParametersByKind = {
      audio: _s("audio", l),
      video: _s("video", l)
    }, i.role && i.role !== "auto" && (this._forcedLocalDtlsRole = i.role === "server" ? "client" : "server"), this._pc = new RTCPeerConnection({
      iceServers: a || [],
      iceTransportPolicy: o || "all",
      bundlePolicy: "max-bundle",
      rtcpMuxPolicy: "require",
      sdpSemantics: "unified-plan",
      ...d
    }, p), this._pc.connectionState ? this._pc.addEventListener("connectionstatechange", () => {
      this.emit("@connectionstatechange", this._pc.connectionState);
    }) : (U.warn("run() | pc.connectionState not supported, using pc.iceConnectionState"), this._pc.addEventListener("iceconnectionstatechange", () => {
      switch (this._pc.iceConnectionState) {
        case "checking":
          this.emit("@connectionstatechange", "connecting");
          break;
        case "connected":
        case "completed":
          this.emit("@connectionstatechange", "connected");
          break;
        case "failed":
          this.emit("@connectionstatechange", "failed");
          break;
        case "disconnected":
          this.emit("@connectionstatechange", "disconnected");
          break;
        case "closed":
          this.emit("@connectionstatechange", "closed");
          break;
      }
    }));
  }
  async updateIceServers(e) {
    U.debug("updateIceServers()");
    const t = this._pc.getConfiguration();
    t.iceServers = e, this._pc.setConfiguration(t);
  }
  async restartIce(e) {
    if (U.debug("restartIce()"), this._remoteSdp.updateIceParameters(e), !!this._transportReady)
      if (this._direction === "send") {
        const t = await this._pc.createOffer({ iceRestart: !0 });
        U.debug("restartIce() | calling pc.setLocalDescription() [offer:%o]", t), await this._pc.setLocalDescription(t);
        const s = { type: "answer", sdp: this._remoteSdp.getSdp() };
        U.debug("restartIce() | calling pc.setRemoteDescription() [answer:%o]", s), await this._pc.setRemoteDescription(s);
      } else {
        const t = { type: "offer", sdp: this._remoteSdp.getSdp() };
        U.debug("restartIce() | calling pc.setRemoteDescription() [offer:%o]", t), await this._pc.setRemoteDescription(t);
        const s = await this._pc.createAnswer();
        U.debug("restartIce() | calling pc.setLocalDescription() [answer:%o]", s), await this._pc.setLocalDescription(s);
      }
  }
  async getTransportStats() {
    return this._pc.getStats();
  }
  async send({ track: e, encodings: t, codecOptions: s, codec: i }) {
    var n, a;
    this.assertSendDirection(), U.debug("send() [kind:%s, track.id:%s]", e.kind, e.id), t && t.length > 1 && t.forEach((I, re) => {
      I.rid = `r${re}`;
    });
    const o = ze(this._sendingRtpParametersByKind[e.kind], {});
    o.codecs = ns(o.codecs, i);
    const d = ze(this._sendingRemoteRtpParametersByKind[e.kind], {});
    d.codecs = ns(d.codecs, i);
    const p = this._remoteSdp.getNextMediaSectionIdx(), l = this._pc.addTransceiver(e, {
      direction: "sendonly",
      streams: [this._sendStream],
      sendEncodings: t
    });
    let u = await this._pc.createOffer(), m = O.parse(u.sdp), g;
    this._transportReady || await this.setupTransport({
      localDtlsRole: (n = this._forcedLocalDtlsRole) !== null && n !== void 0 ? n : "client",
      localSdpObject: m
    });
    let T = !1;
    const S = Zn((t || [{}])[0].scalabilityMode);
    t && t.length === 1 && S.spatialLayers > 1 && o.codecs[0].mimeType.toLowerCase() === "video/vp9" && (U.debug("send() | enabling legacy simulcast for VP9 SVC"), T = !0, m = O.parse(u.sdp), g = m.media[p.idx], Oa({
      offerMediaObject: g,
      numStreams: S.spatialLayers
    }), u = { type: "offer", sdp: O.write(m) }), U.debug("send() | calling pc.setLocalDescription() [offer:%o]", u), await this._pc.setLocalDescription(u);
    const R = l.mid;
    if (o.mid = R, m = O.parse(this._pc.localDescription.sdp), g = m.media[p.idx], o.rtcp.cname = zn({ offerMediaObject: g }), !t)
      o.encodings = hr({ offerMediaObject: g });
    else if (t.length === 1) {
      let I = hr({ offerMediaObject: g });
      Object.assign(I[0], t[0]), T && (I = [I[0]]), o.encodings = I;
    } else
      o.encodings = t;
    if (o.encodings.length > 1 && (o.codecs[0].mimeType.toLowerCase() === "video/vp8" || o.codecs[0].mimeType.toLowerCase() === "video/h264"))
      for (const I of o.encodings)
        I.scalabilityMode ? I.scalabilityMode = `L1T${S.temporalLayers}` : I.scalabilityMode = "L1T3";
    this._remoteSdp.send({
      offerMediaObject: g,
      reuseMid: p.reuseMid,
      offerRtpParameters: o,
      answerRtpParameters: d,
      codecOptions: s,
      extmapAllowMixed: !0,
      forceGoogConference: (a = s == null ? void 0 : s.forceGoogConference) !== null && a !== void 0 ? a : !1
    });
    const D = { type: "answer", sdp: this._remoteSdp.getSdp() };
    return U.debug("send() | calling pc.setRemoteDescription() [answer:%o]", D), await this._pc.setRemoteDescription(D), this._mapMidTransceiver.set(R, l), {
      localId: R,
      rtpParameters: o,
      rtpSender: l.sender
    };
  }
  async stopSending(e) {
    this.assertSendDirection(), U.debug("stopSending() [localId:%s]", e);
    const t = this._mapMidTransceiver.get(e);
    if (!t)
      throw new Error("associated RTCRtpTransceiver not found");
    if (t.sender.replaceTrack(null), this._pc.removeTrack(t.sender), this._remoteSdp.closeMediaSection(t.mid))
      try {
        t.stop();
      } catch (a) {
      }
    const i = await this._pc.createOffer();
    U.debug("stopSending() | calling pc.setLocalDescription() [offer:%o]", i), await this._pc.setLocalDescription(i);
    const n = { type: "answer", sdp: this._remoteSdp.getSdp() };
    U.debug("stopSending() | calling pc.setRemoteDescription() [answer:%o]", n), await this._pc.setRemoteDescription(n), this._mapMidTransceiver.delete(e);
  }
  async pauseSending(e) {
    this.assertSendDirection(), U.debug("pauseSending() [localId:%s]", e);
    const t = this._mapMidTransceiver.get(e);
    if (!t)
      throw new Error("associated RTCRtpTransceiver not found");
    t.direction = "inactive", this._remoteSdp.pauseMediaSection(e);
    const s = await this._pc.createOffer();
    U.debug("pauseSending() | calling pc.setLocalDescription() [offer:%o]", s), await this._pc.setLocalDescription(s);
    const i = { type: "answer", sdp: this._remoteSdp.getSdp() };
    U.debug("pauseSending() | calling pc.setRemoteDescription() [answer:%o]", i), await this._pc.setRemoteDescription(i);
  }
  async resumeSending(e) {
    this.assertSendDirection(), U.debug("resumeSending() [localId:%s]", e);
    const t = this._mapMidTransceiver.get(e);
    if (this._remoteSdp.resumeSendingMediaSection(e), !t)
      throw new Error("associated RTCRtpTransceiver not found");
    t.direction = "sendonly";
    const s = await this._pc.createOffer();
    U.debug("resumeSending() | calling pc.setLocalDescription() [offer:%o]", s), await this._pc.setLocalDescription(s);
    const i = { type: "answer", sdp: this._remoteSdp.getSdp() };
    U.debug("resumeSending() | calling pc.setRemoteDescription() [answer:%o]", i), await this._pc.setRemoteDescription(i);
  }
  async replaceTrack(e, t) {
    this.assertSendDirection(), t ? U.debug("replaceTrack() [localId:%s, track.id:%s]", e, t.id) : U.debug("replaceTrack() [localId:%s, no track]", e);
    const s = this._mapMidTransceiver.get(e);
    if (!s)
      throw new Error("associated RTCRtpTransceiver not found");
    await s.sender.replaceTrack(t);
  }
  async setMaxSpatialLayer(e, t) {
    this.assertSendDirection(), U.debug("setMaxSpatialLayer() [localId:%s, spatialLayer:%s]", e, t);
    const s = this._mapMidTransceiver.get(e);
    if (!s)
      throw new Error("associated RTCRtpTransceiver not found");
    const i = s.sender.getParameters();
    i.encodings.forEach((o, d) => {
      d <= t ? o.active = !0 : o.active = !1;
    }), await s.sender.setParameters(i), this._remoteSdp.muxMediaSectionSimulcast(e, i.encodings);
    const n = await this._pc.createOffer();
    U.debug("setMaxSpatialLayer() | calling pc.setLocalDescription() [offer:%o]", n), await this._pc.setLocalDescription(n);
    const a = { type: "answer", sdp: this._remoteSdp.getSdp() };
    U.debug("setMaxSpatialLayer() | calling pc.setRemoteDescription() [answer:%o]", a), await this._pc.setRemoteDescription(a);
  }
  async setRtpEncodingParameters(e, t) {
    this.assertSendDirection(), U.debug("setRtpEncodingParameters() [localId:%s, params:%o]", e, t);
    const s = this._mapMidTransceiver.get(e);
    if (!s)
      throw new Error("associated RTCRtpTransceiver not found");
    const i = s.sender.getParameters();
    i.encodings.forEach((o, d) => {
      i.encodings[d] = { ...o, ...t };
    }), await s.sender.setParameters(i), this._remoteSdp.muxMediaSectionSimulcast(e, i.encodings);
    const n = await this._pc.createOffer();
    U.debug("setRtpEncodingParameters() | calling pc.setLocalDescription() [offer:%o]", n), await this._pc.setLocalDescription(n);
    const a = { type: "answer", sdp: this._remoteSdp.getSdp() };
    U.debug("setRtpEncodingParameters() | calling pc.setRemoteDescription() [answer:%o]", a), await this._pc.setRemoteDescription(a);
  }
  async getSenderStats(e) {
    this.assertSendDirection();
    const t = this._mapMidTransceiver.get(e);
    if (!t)
      throw new Error("associated RTCRtpTransceiver not found");
    return t.sender.getStats();
  }
  async sendDataChannel({ ordered: e, maxPacketLifeTime: t, maxRetransmits: s, label: i, protocol: n }) {
    var a;
    this.assertSendDirection();
    const o = {
      negotiated: !0,
      id: this._nextSendSctpStreamId,
      ordered: e,
      maxPacketLifeTime: t,
      maxRetransmits: s,
      protocol: n
    };
    U.debug("sendDataChannel() [options:%o]", o);
    const d = this._pc.createDataChannel(i, o);
    if (this._nextSendSctpStreamId = ++this._nextSendSctpStreamId % rl.MIS, !this._hasDataChannelMediaSection) {
      const l = await this._pc.createOffer(), u = O.parse(l.sdp), m = u.media.find((T) => T.type === "application");
      this._transportReady || await this.setupTransport({
        localDtlsRole: (a = this._forcedLocalDtlsRole) !== null && a !== void 0 ? a : "client",
        localSdpObject: u
      }), U.debug("sendDataChannel() | calling pc.setLocalDescription() [offer:%o]", l), await this._pc.setLocalDescription(l), this._remoteSdp.sendSctpAssociation({ offerMediaObject: m });
      const g = { type: "answer", sdp: this._remoteSdp.getSdp() };
      U.debug("sendDataChannel() | calling pc.setRemoteDescription() [answer:%o]", g), await this._pc.setRemoteDescription(g), this._hasDataChannelMediaSection = !0;
    }
    const p = {
      streamId: o.id,
      ordered: o.ordered,
      maxPacketLifeTime: o.maxPacketLifeTime,
      maxRetransmits: o.maxRetransmits
    };
    return { dataChannel: d, sctpStreamParameters: p };
  }
  async receive(e) {
    var t;
    this.assertRecvDirection();
    const s = [], i = /* @__PURE__ */ new Map();
    for (const d of e) {
      const { trackId: p, kind: l, rtpParameters: u, streamId: m } = d;
      U.debug("receive() [trackId:%s, kind:%s]", p, l);
      const g = u.mid || String(this._mapMidTransceiver.size);
      i.set(p, g), this._remoteSdp.receive({
        mid: g,
        kind: l,
        offerRtpParameters: u,
        streamId: m || u.rtcp.cname,
        trackId: p
      });
    }
    const n = { type: "offer", sdp: this._remoteSdp.getSdp() };
    U.debug("receive() | calling pc.setRemoteDescription() [offer:%o]", n), await this._pc.setRemoteDescription(n);
    let a = await this._pc.createAnswer();
    const o = O.parse(a.sdp);
    for (const d of e) {
      const { trackId: p, rtpParameters: l } = d, u = i.get(p), m = o.media.find((g) => String(g.mid) === u);
      Qn({
        offerRtpParameters: l,
        answerMediaObject: m
      });
    }
    a = { type: "answer", sdp: O.write(o) }, this._transportReady || await this.setupTransport({
      localDtlsRole: (t = this._forcedLocalDtlsRole) !== null && t !== void 0 ? t : "client",
      localSdpObject: o
    }), U.debug("receive() | calling pc.setLocalDescription() [answer:%o]", a), await this._pc.setLocalDescription(a);
    for (const d of e) {
      const { trackId: p } = d, l = i.get(p), u = this._pc.getTransceivers().find((m) => m.mid === l);
      if (u)
        this._mapMidTransceiver.set(l, u), s.push({
          localId: l,
          track: u.receiver.track,
          rtpReceiver: u.receiver
        });
      else
        throw new Error("new RTCRtpTransceiver not found");
    }
    return s;
  }
  async stopReceiving(e) {
    this.assertRecvDirection();
    for (const i of e) {
      U.debug("stopReceiving() [localId:%s]", i);
      const n = this._mapMidTransceiver.get(i);
      if (!n)
        throw new Error("associated RTCRtpTransceiver not found");
      this._remoteSdp.closeMediaSection(n.mid);
    }
    const t = { type: "offer", sdp: this._remoteSdp.getSdp() };
    U.debug("stopReceiving() | calling pc.setRemoteDescription() [offer:%o]", t), await this._pc.setRemoteDescription(t);
    const s = await this._pc.createAnswer();
    U.debug("stopReceiving() | calling pc.setLocalDescription() [answer:%o]", s), await this._pc.setLocalDescription(s);
    for (const i of e)
      this._mapMidTransceiver.delete(i);
  }
  async pauseReceiving(e) {
    this.assertRecvDirection();
    for (const i of e) {
      U.debug("pauseReceiving() [localId:%s]", i);
      const n = this._mapMidTransceiver.get(i);
      if (!n)
        throw new Error("associated RTCRtpTransceiver not found");
      n.direction = "inactive", this._remoteSdp.pauseMediaSection(i);
    }
    const t = { type: "offer", sdp: this._remoteSdp.getSdp() };
    U.debug("pauseReceiving() | calling pc.setRemoteDescription() [offer:%o]", t), await this._pc.setRemoteDescription(t);
    const s = await this._pc.createAnswer();
    U.debug("pauseReceiving() | calling pc.setLocalDescription() [answer:%o]", s), await this._pc.setLocalDescription(s);
  }
  async resumeReceiving(e) {
    this.assertRecvDirection();
    for (const i of e) {
      U.debug("resumeReceiving() [localId:%s]", i);
      const n = this._mapMidTransceiver.get(i);
      if (!n)
        throw new Error("associated RTCRtpTransceiver not found");
      n.direction = "recvonly", this._remoteSdp.resumeReceivingMediaSection(i);
    }
    const t = { type: "offer", sdp: this._remoteSdp.getSdp() };
    U.debug("resumeReceiving() | calling pc.setRemoteDescription() [offer:%o]", t), await this._pc.setRemoteDescription(t);
    const s = await this._pc.createAnswer();
    U.debug("resumeReceiving() | calling pc.setLocalDescription() [answer:%o]", s), await this._pc.setLocalDescription(s);
  }
  async getReceiverStats(e) {
    this.assertRecvDirection();
    const t = this._mapMidTransceiver.get(e);
    if (!t)
      throw new Error("associated RTCRtpTransceiver not found");
    return t.receiver.getStats();
  }
  async receiveDataChannel({ sctpStreamParameters: e, label: t, protocol: s }) {
    var i;
    this.assertRecvDirection();
    const { streamId: n, ordered: a, maxPacketLifeTime: o, maxRetransmits: d } = e, p = {
      negotiated: !0,
      id: n,
      ordered: a,
      maxPacketLifeTime: o,
      maxRetransmits: d,
      protocol: s
    };
    U.debug("receiveDataChannel() [options:%o]", p);
    const l = this._pc.createDataChannel(t, p);
    if (!this._hasDataChannelMediaSection) {
      this._remoteSdp.receiveSctpAssociation();
      const u = { type: "offer", sdp: this._remoteSdp.getSdp() };
      U.debug("receiveDataChannel() | calling pc.setRemoteDescription() [offer:%o]", u), await this._pc.setRemoteDescription(u);
      const m = await this._pc.createAnswer();
      if (!this._transportReady) {
        const g = O.parse(m.sdp);
        await this.setupTransport({
          localDtlsRole: (i = this._forcedLocalDtlsRole) !== null && i !== void 0 ? i : "client",
          localSdpObject: g
        });
      }
      U.debug("receiveDataChannel() | calling pc.setRemoteDescription() [answer:%o]", m), await this._pc.setLocalDescription(m), this._hasDataChannelMediaSection = !0;
    }
    return { dataChannel: l };
  }
  async setupTransport({ localDtlsRole: e, localSdpObject: t }) {
    t || (t = O.parse(this._pc.localDescription.sdp));
    const s = Kn({ sdpObject: t });
    s.role = e, this._remoteSdp.updateDtlsRole(e === "client" ? "server" : "client"), await new Promise((i, n) => {
      this.safeEmit("@connect", { dtlsParameters: s }, i, n);
    }), this._transportReady = !0;
  }
  assertSendDirection() {
    if (this._direction !== "send")
      throw new Error('method can just be called for handlers with "send" direction');
  }
  assertRecvDirection() {
    if (this._direction !== "recv")
      throw new Error('method can just be called for handlers with "recv" direction');
  }
};
const F = new Lt("Chrome111"), il = { OS: 1024, MIS: 1024 };
class Uc extends Zi {
  /**
   * Creates a factory function.
   */
  static createFactory() {
    return () => new Uc();
  }
  constructor() {
    super(), this._mapMidTransceiver = /* @__PURE__ */ new Map(), this._sendStream = new MediaStream(), this._hasDataChannelMediaSection = !1, this._nextSendSctpStreamId = 0, this._transportReady = !1;
  }
  get name() {
    return "Chrome111";
  }
  close() {
    if (F.debug("close()"), this._pc)
      try {
        this._pc.close();
      } catch (e) {
      }
    this.emit("@close");
  }
  async getNativeRtpCapabilities() {
    F.debug("getNativeRtpCapabilities()");
    const e = new RTCPeerConnection({
      iceServers: [],
      iceTransportPolicy: "all",
      bundlePolicy: "max-bundle",
      rtcpMuxPolicy: "require",
      sdpSemantics: "unified-plan"
    });
    try {
      e.addTransceiver("audio"), e.addTransceiver("video");
      const t = await e.createOffer();
      try {
        e.close();
      } catch (n) {
      }
      const s = O.parse(t.sdp);
      return Jn({ sdpObject: s });
    } catch (t) {
      try {
        e.close();
      } catch (s) {
      }
      throw t;
    }
  }
  async getNativeSctpCapabilities() {
    return F.debug("getNativeSctpCapabilities()"), {
      numStreams: il
    };
  }
  run({ direction: e, iceParameters: t, iceCandidates: s, dtlsParameters: i, sctpParameters: n, iceServers: a, iceTransportPolicy: o, additionalSettings: d, proprietaryConstraints: p, extendedRtpCapabilities: l }) {
    F.debug("run()"), this._direction = e, this._remoteSdp = new Yn({
      iceParameters: t,
      iceCandidates: s,
      dtlsParameters: i,
      sctpParameters: n
    }), this._sendingRtpParametersByKind = {
      audio: zt("audio", l),
      video: zt("video", l)
    }, this._sendingRemoteRtpParametersByKind = {
      audio: _s("audio", l),
      video: _s("video", l)
    }, i.role && i.role !== "auto" && (this._forcedLocalDtlsRole = i.role === "server" ? "client" : "server"), this._pc = new RTCPeerConnection({
      iceServers: a || [],
      iceTransportPolicy: o || "all",
      bundlePolicy: "max-bundle",
      rtcpMuxPolicy: "require",
      sdpSemantics: "unified-plan",
      ...d
    }, p), this._pc.connectionState ? this._pc.addEventListener("connectionstatechange", () => {
      this.emit("@connectionstatechange", this._pc.connectionState);
    }) : (F.warn("run() | pc.connectionState not supported, using pc.iceConnectionState"), this._pc.addEventListener("iceconnectionstatechange", () => {
      switch (this._pc.iceConnectionState) {
        case "checking":
          this.emit("@connectionstatechange", "connecting");
          break;
        case "connected":
        case "completed":
          this.emit("@connectionstatechange", "connected");
          break;
        case "failed":
          this.emit("@connectionstatechange", "failed");
          break;
        case "disconnected":
          this.emit("@connectionstatechange", "disconnected");
          break;
        case "closed":
          this.emit("@connectionstatechange", "closed");
          break;
      }
    }));
  }
  async updateIceServers(e) {
    F.debug("updateIceServers()");
    const t = this._pc.getConfiguration();
    t.iceServers = e, this._pc.setConfiguration(t);
  }
  async restartIce(e) {
    if (F.debug("restartIce()"), this._remoteSdp.updateIceParameters(e), !!this._transportReady)
      if (this._direction === "send") {
        const t = await this._pc.createOffer({ iceRestart: !0 });
        F.debug("restartIce() | calling pc.setLocalDescription() [offer:%o]", t), await this._pc.setLocalDescription(t);
        const s = { type: "answer", sdp: this._remoteSdp.getSdp() };
        F.debug("restartIce() | calling pc.setRemoteDescription() [answer:%o]", s), await this._pc.setRemoteDescription(s);
      } else {
        const t = { type: "offer", sdp: this._remoteSdp.getSdp() };
        F.debug("restartIce() | calling pc.setRemoteDescription() [offer:%o]", t), await this._pc.setRemoteDescription(t);
        const s = await this._pc.createAnswer();
        F.debug("restartIce() | calling pc.setLocalDescription() [answer:%o]", s), await this._pc.setLocalDescription(s);
      }
  }
  async getTransportStats() {
    return this._pc.getStats();
  }
  async send({ track: e, encodings: t, codecOptions: s, codec: i }) {
    var n;
    if (this.assertSendDirection(), F.debug("send() [kind:%s, track.id:%s]", e.kind, e.id), t && t.length > 1) {
      t.forEach((D, I) => {
        D.rid = `r${I}`;
      });
      let S = 1, R = 1;
      for (const D of t) {
        const I = D.scalabilityMode ? Zn(D.scalabilityMode).temporalLayers : 3;
        I > R && (R = I);
      }
      for (const D of t)
        D.rid = `r${S++}`, D.scalabilityMode = `L1T${R}`;
    }
    const a = ze(this._sendingRtpParametersByKind[e.kind], {});
    a.codecs = ns(a.codecs, i);
    const o = ze(this._sendingRemoteRtpParametersByKind[e.kind], {});
    o.codecs = ns(o.codecs, i);
    const d = this._remoteSdp.getNextMediaSectionIdx(), p = this._pc.addTransceiver(e, {
      direction: "sendonly",
      streams: [this._sendStream],
      sendEncodings: t
    }), l = await this._pc.createOffer();
    let u = O.parse(l.sdp);
    this._transportReady || await this.setupTransport({
      localDtlsRole: (n = this._forcedLocalDtlsRole) !== null && n !== void 0 ? n : "client",
      localSdpObject: u
    }), F.debug("send() | calling pc.setLocalDescription() [offer:%o]", l), await this._pc.setLocalDescription(l);
    const m = p.mid;
    a.mid = m, u = O.parse(this._pc.localDescription.sdp);
    const g = u.media[d.idx];
    if (a.rtcp.cname = zn({ offerMediaObject: g }), !t)
      a.encodings = hr({ offerMediaObject: g });
    else if (t.length === 1) {
      const S = hr({ offerMediaObject: g });
      Object.assign(S[0], t[0]), a.encodings = S;
    } else
      a.encodings = t;
    this._remoteSdp.send({
      offerMediaObject: g,
      reuseMid: d.reuseMid,
      offerRtpParameters: a,
      answerRtpParameters: o,
      codecOptions: s,
      extmapAllowMixed: !0
    });
    const T = { type: "answer", sdp: this._remoteSdp.getSdp() };
    return F.debug("send() | calling pc.setRemoteDescription() [answer:%o]", T), await this._pc.setRemoteDescription(T), this._mapMidTransceiver.set(m, p), {
      localId: m,
      rtpParameters: a,
      rtpSender: p.sender
    };
  }
  async stopSending(e) {
    this.assertSendDirection(), F.debug("stopSending() [localId:%s]", e);
    const t = this._mapMidTransceiver.get(e);
    if (!t)
      throw new Error("associated RTCRtpTransceiver not found");
    if (t.sender.replaceTrack(null), this._pc.removeTrack(t.sender), this._remoteSdp.closeMediaSection(t.mid))
      try {
        t.stop();
      } catch (a) {
      }
    const i = await this._pc.createOffer();
    F.debug("stopSending() | calling pc.setLocalDescription() [offer:%o]", i), await this._pc.setLocalDescription(i);
    const n = { type: "answer", sdp: this._remoteSdp.getSdp() };
    F.debug("stopSending() | calling pc.setRemoteDescription() [answer:%o]", n), await this._pc.setRemoteDescription(n), this._mapMidTransceiver.delete(e);
  }
  async pauseSending(e) {
    this.assertSendDirection(), F.debug("pauseSending() [localId:%s]", e);
    const t = this._mapMidTransceiver.get(e);
    if (!t)
      throw new Error("associated RTCRtpTransceiver not found");
    t.direction = "inactive", this._remoteSdp.pauseMediaSection(e);
    const s = await this._pc.createOffer();
    F.debug("pauseSending() | calling pc.setLocalDescription() [offer:%o]", s), await this._pc.setLocalDescription(s);
    const i = { type: "answer", sdp: this._remoteSdp.getSdp() };
    F.debug("pauseSending() | calling pc.setRemoteDescription() [answer:%o]", i), await this._pc.setRemoteDescription(i);
  }
  async resumeSending(e) {
    this.assertSendDirection(), F.debug("resumeSending() [localId:%s]", e);
    const t = this._mapMidTransceiver.get(e);
    if (this._remoteSdp.resumeSendingMediaSection(e), !t)
      throw new Error("associated RTCRtpTransceiver not found");
    t.direction = "sendonly";
    const s = await this._pc.createOffer();
    F.debug("resumeSending() | calling pc.setLocalDescription() [offer:%o]", s), await this._pc.setLocalDescription(s);
    const i = { type: "answer", sdp: this._remoteSdp.getSdp() };
    F.debug("resumeSending() | calling pc.setRemoteDescription() [answer:%o]", i), await this._pc.setRemoteDescription(i);
  }
  async replaceTrack(e, t) {
    this.assertSendDirection(), t ? F.debug("replaceTrack() [localId:%s, track.id:%s]", e, t.id) : F.debug("replaceTrack() [localId:%s, no track]", e);
    const s = this._mapMidTransceiver.get(e);
    if (!s)
      throw new Error("associated RTCRtpTransceiver not found");
    await s.sender.replaceTrack(t);
  }
  async setMaxSpatialLayer(e, t) {
    this.assertSendDirection(), F.debug("setMaxSpatialLayer() [localId:%s, spatialLayer:%s]", e, t);
    const s = this._mapMidTransceiver.get(e);
    if (!s)
      throw new Error("associated RTCRtpTransceiver not found");
    const i = s.sender.getParameters();
    i.encodings.forEach((o, d) => {
      d <= t ? o.active = !0 : o.active = !1;
    }), await s.sender.setParameters(i), this._remoteSdp.muxMediaSectionSimulcast(e, i.encodings);
    const n = await this._pc.createOffer();
    F.debug("setMaxSpatialLayer() | calling pc.setLocalDescription() [offer:%o]", n), await this._pc.setLocalDescription(n);
    const a = { type: "answer", sdp: this._remoteSdp.getSdp() };
    F.debug("setMaxSpatialLayer() | calling pc.setRemoteDescription() [answer:%o]", a), await this._pc.setRemoteDescription(a);
  }
  async setRtpEncodingParameters(e, t) {
    this.assertSendDirection(), F.debug("setRtpEncodingParameters() [localId:%s, params:%o]", e, t);
    const s = this._mapMidTransceiver.get(e);
    if (!s)
      throw new Error("associated RTCRtpTransceiver not found");
    const i = s.sender.getParameters();
    i.encodings.forEach((o, d) => {
      i.encodings[d] = { ...o, ...t };
    }), await s.sender.setParameters(i), this._remoteSdp.muxMediaSectionSimulcast(e, i.encodings);
    const n = await this._pc.createOffer();
    F.debug("setRtpEncodingParameters() | calling pc.setLocalDescription() [offer:%o]", n), await this._pc.setLocalDescription(n);
    const a = { type: "answer", sdp: this._remoteSdp.getSdp() };
    F.debug("setRtpEncodingParameters() | calling pc.setRemoteDescription() [answer:%o]", a), await this._pc.setRemoteDescription(a);
  }
  async getSenderStats(e) {
    this.assertSendDirection();
    const t = this._mapMidTransceiver.get(e);
    if (!t)
      throw new Error("associated RTCRtpTransceiver not found");
    return t.sender.getStats();
  }
  async sendDataChannel({ ordered: e, maxPacketLifeTime: t, maxRetransmits: s, label: i, protocol: n }) {
    var a;
    this.assertSendDirection();
    const o = {
      negotiated: !0,
      id: this._nextSendSctpStreamId,
      ordered: e,
      maxPacketLifeTime: t,
      maxRetransmits: s,
      protocol: n
    };
    F.debug("sendDataChannel() [options:%o]", o);
    const d = this._pc.createDataChannel(i, o);
    if (this._nextSendSctpStreamId = ++this._nextSendSctpStreamId % il.MIS, !this._hasDataChannelMediaSection) {
      const l = await this._pc.createOffer(), u = O.parse(l.sdp), m = u.media.find((T) => T.type === "application");
      this._transportReady || await this.setupTransport({
        localDtlsRole: (a = this._forcedLocalDtlsRole) !== null && a !== void 0 ? a : "client",
        localSdpObject: u
      }), F.debug("sendDataChannel() | calling pc.setLocalDescription() [offer:%o]", l), await this._pc.setLocalDescription(l), this._remoteSdp.sendSctpAssociation({ offerMediaObject: m });
      const g = { type: "answer", sdp: this._remoteSdp.getSdp() };
      F.debug("sendDataChannel() | calling pc.setRemoteDescription() [answer:%o]", g), await this._pc.setRemoteDescription(g), this._hasDataChannelMediaSection = !0;
    }
    const p = {
      streamId: o.id,
      ordered: o.ordered,
      maxPacketLifeTime: o.maxPacketLifeTime,
      maxRetransmits: o.maxRetransmits
    };
    return { dataChannel: d, sctpStreamParameters: p };
  }
  async receive(e) {
    var t;
    this.assertRecvDirection();
    const s = [], i = /* @__PURE__ */ new Map();
    for (const d of e) {
      const { trackId: p, kind: l, rtpParameters: u, streamId: m } = d;
      F.debug("receive() [trackId:%s, kind:%s]", p, l);
      const g = u.mid || String(this._mapMidTransceiver.size);
      i.set(p, g), this._remoteSdp.receive({
        mid: g,
        kind: l,
        offerRtpParameters: u,
        streamId: m || u.rtcp.cname,
        trackId: p
      });
    }
    const n = { type: "offer", sdp: this._remoteSdp.getSdp() };
    F.debug("receive() | calling pc.setRemoteDescription() [offer:%o]", n), await this._pc.setRemoteDescription(n);
    let a = await this._pc.createAnswer();
    const o = O.parse(a.sdp);
    for (const d of e) {
      const { trackId: p, rtpParameters: l } = d, u = i.get(p), m = o.media.find((g) => String(g.mid) === u);
      Qn({
        offerRtpParameters: l,
        answerMediaObject: m
      });
    }
    a = { type: "answer", sdp: O.write(o) }, this._transportReady || await this.setupTransport({
      localDtlsRole: (t = this._forcedLocalDtlsRole) !== null && t !== void 0 ? t : "client",
      localSdpObject: o
    }), F.debug("receive() | calling pc.setLocalDescription() [answer:%o]", a), await this._pc.setLocalDescription(a);
    for (const d of e) {
      const { trackId: p } = d, l = i.get(p), u = this._pc.getTransceivers().find((m) => m.mid === l);
      if (u)
        this._mapMidTransceiver.set(l, u), s.push({
          localId: l,
          track: u.receiver.track,
          rtpReceiver: u.receiver
        });
      else
        throw new Error("new RTCRtpTransceiver not found");
    }
    return s;
  }
  async stopReceiving(e) {
    this.assertRecvDirection();
    for (const i of e) {
      F.debug("stopReceiving() [localId:%s]", i);
      const n = this._mapMidTransceiver.get(i);
      if (!n)
        throw new Error("associated RTCRtpTransceiver not found");
      this._remoteSdp.closeMediaSection(n.mid);
    }
    const t = { type: "offer", sdp: this._remoteSdp.getSdp() };
    F.debug("stopReceiving() | calling pc.setRemoteDescription() [offer:%o]", t), await this._pc.setRemoteDescription(t);
    const s = await this._pc.createAnswer();
    F.debug("stopReceiving() | calling pc.setLocalDescription() [answer:%o]", s), await this._pc.setLocalDescription(s);
    for (const i of e)
      this._mapMidTransceiver.delete(i);
  }
  async pauseReceiving(e) {
    this.assertRecvDirection();
    for (const i of e) {
      F.debug("pauseReceiving() [localId:%s]", i);
      const n = this._mapMidTransceiver.get(i);
      if (!n)
        throw new Error("associated RTCRtpTransceiver not found");
      n.direction = "inactive", this._remoteSdp.pauseMediaSection(i);
    }
    const t = { type: "offer", sdp: this._remoteSdp.getSdp() };
    F.debug("pauseReceiving() | calling pc.setRemoteDescription() [offer:%o]", t), await this._pc.setRemoteDescription(t);
    const s = await this._pc.createAnswer();
    F.debug("pauseReceiving() | calling pc.setLocalDescription() [answer:%o]", s), await this._pc.setLocalDescription(s);
  }
  async resumeReceiving(e) {
    this.assertRecvDirection();
    for (const i of e) {
      F.debug("resumeReceiving() [localId:%s]", i);
      const n = this._mapMidTransceiver.get(i);
      if (!n)
        throw new Error("associated RTCRtpTransceiver not found");
      n.direction = "recvonly", this._remoteSdp.resumeReceivingMediaSection(i);
    }
    const t = { type: "offer", sdp: this._remoteSdp.getSdp() };
    F.debug("resumeReceiving() | calling pc.setRemoteDescription() [offer:%o]", t), await this._pc.setRemoteDescription(t);
    const s = await this._pc.createAnswer();
    F.debug("resumeReceiving() | calling pc.setLocalDescription() [answer:%o]", s), await this._pc.setLocalDescription(s);
  }
  async getReceiverStats(e) {
    this.assertRecvDirection();
    const t = this._mapMidTransceiver.get(e);
    if (!t)
      throw new Error("associated RTCRtpTransceiver not found");
    return t.receiver.getStats();
  }
  async receiveDataChannel({ sctpStreamParameters: e, label: t, protocol: s }) {
    var i;
    this.assertRecvDirection();
    const { streamId: n, ordered: a, maxPacketLifeTime: o, maxRetransmits: d } = e, p = {
      negotiated: !0,
      id: n,
      ordered: a,
      maxPacketLifeTime: o,
      maxRetransmits: d,
      protocol: s
    };
    F.debug("receiveDataChannel() [options:%o]", p);
    const l = this._pc.createDataChannel(t, p);
    if (!this._hasDataChannelMediaSection) {
      this._remoteSdp.receiveSctpAssociation();
      const u = { type: "offer", sdp: this._remoteSdp.getSdp() };
      F.debug("receiveDataChannel() | calling pc.setRemoteDescription() [offer:%o]", u), await this._pc.setRemoteDescription(u);
      const m = await this._pc.createAnswer();
      if (!this._transportReady) {
        const g = O.parse(m.sdp);
        await this.setupTransport({
          localDtlsRole: (i = this._forcedLocalDtlsRole) !== null && i !== void 0 ? i : "client",
          localSdpObject: g
        });
      }
      F.debug("receiveDataChannel() | calling pc.setRemoteDescription() [answer:%o]", m), await this._pc.setLocalDescription(m), this._hasDataChannelMediaSection = !0;
    }
    return { dataChannel: l };
  }
  async setupTransport({ localDtlsRole: e, localSdpObject: t }) {
    t || (t = O.parse(this._pc.localDescription.sdp));
    const s = Kn({ sdpObject: t });
    s.role = e, this._remoteSdp.updateDtlsRole(e === "client" ? "server" : "client"), await new Promise((i, n) => {
      this.safeEmit("@connect", { dtlsParameters: s }, i, n);
    }), this._transportReady = !0;
  }
  assertSendDirection() {
    if (this._direction !== "send")
      throw new Error('method can just be called for handlers with "send" direction');
  }
  assertRecvDirection() {
    if (this._direction !== "recv")
      throw new Error('method can just be called for handlers with "recv" direction');
  }
}
function Ov() {
  const r = RTCRtpReceiver.getCapabilities(), e = ze(r, {});
  for (const t of e.codecs) {
    if (t.channels = t.numChannels, delete t.numChannels, t.mimeType = t.mimeType || `${t.kind}/${t.name}`, t.parameters) {
      const s = t.parameters;
      s.apt && (s.apt = Number(s.apt)), s["packetization-mode"] && (s["packetization-mode"] = Number(s["packetization-mode"]));
    }
    for (const s of t.rtcpFeedback || [])
      s.parameter || (s.parameter = "");
  }
  return e;
}
function nl(r) {
  const e = ze(r, {});
  e.mid && (e.muxId = e.mid, delete e.mid);
  for (const t of e.codecs)
    t.channels && (t.numChannels = t.channels, delete t.channels), t.mimeType && !t.name && (t.name = t.mimeType.split("/")[1]), delete t.mimeType;
  return e;
}
const ve = new Lt("Edge11");
class Vc extends Zi {
  /**
   * Creates a factory function.
   */
  static createFactory() {
    return () => new Vc();
  }
  constructor() {
    super(), this._rtpSenders = /* @__PURE__ */ new Map(), this._rtpReceivers = /* @__PURE__ */ new Map(), this._nextSendLocalId = 0, this._transportReady = !1;
  }
  get name() {
    return "Edge11";
  }
  close() {
    ve.debug("close()");
    try {
      this._iceGatherer.close();
    } catch (e) {
    }
    try {
      this._iceTransport.stop();
    } catch (e) {
    }
    try {
      this._dtlsTransport.stop();
    } catch (e) {
    }
    for (const e of this._rtpSenders.values())
      try {
        e.stop();
      } catch (t) {
      }
    for (const e of this._rtpReceivers.values())
      try {
        e.stop();
      } catch (t) {
      }
    this.emit("@close");
  }
  async getNativeRtpCapabilities() {
    return ve.debug("getNativeRtpCapabilities()"), Ov();
  }
  async getNativeSctpCapabilities() {
    return ve.debug("getNativeSctpCapabilities()"), {
      numStreams: { OS: 0, MIS: 0 }
    };
  }
  run({
    direction: e,
    // eslint-disable-line @typescript-eslint/no-unused-vars
    iceParameters: t,
    iceCandidates: s,
    dtlsParameters: i,
    sctpParameters: n,
    // eslint-disable-line @typescript-eslint/no-unused-vars
    iceServers: a,
    iceTransportPolicy: o,
    additionalSettings: d,
    // eslint-disable-line @typescript-eslint/no-unused-vars
    proprietaryConstraints: p,
    // eslint-disable-line @typescript-eslint/no-unused-vars
    extendedRtpCapabilities: l
  }) {
    ve.debug("run()"), this._sendingRtpParametersByKind = {
      audio: zt("audio", l),
      video: zt("video", l)
    }, this._remoteIceParameters = t, this._remoteIceCandidates = s, this._remoteDtlsParameters = i, this._cname = `CNAME-${Do()}`, this.setIceGatherer({ iceServers: a, iceTransportPolicy: o }), this.setIceTransport(), this.setDtlsTransport();
  }
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  async updateIceServers(e) {
    throw new Mt("not supported");
  }
  async restartIce(e) {
    if (ve.debug("restartIce()"), this._remoteIceParameters = e, !!this._transportReady) {
      ve.debug("restartIce() | calling iceTransport.start()"), this._iceTransport.start(this._iceGatherer, e, "controlling");
      for (const t of this._remoteIceCandidates)
        this._iceTransport.addRemoteCandidate(t);
      this._iceTransport.addRemoteCandidate({});
    }
  }
  async getTransportStats() {
    return this._iceTransport.getStats();
  }
  async send({ track: e, encodings: t, codecOptions: s, codec: i }) {
    ve.debug("send() [kind:%s, track.id:%s]", e.kind, e.id), this._transportReady || await this.setupTransport({ localDtlsRole: "server" }), ve.debug("send() | calling new RTCRtpSender()");
    const n = new RTCRtpSender(e, this._dtlsTransport), a = ze(this._sendingRtpParametersByKind[e.kind], {});
    a.codecs = ns(a.codecs, i);
    const o = a.codecs.some((l) => /.+\/rtx$/i.test(l.mimeType));
    t || (t = [{}]);
    for (const l of t)
      l.ssrc = Do(), o && (l.rtx = { ssrc: Do() });
    a.encodings = t, a.rtcp = {
      cname: this._cname,
      reducedSize: !0,
      mux: !0
    };
    const d = nl(a);
    ve.debug("send() | calling rtpSender.send() [params:%o]", d), await n.send(d);
    const p = String(this._nextSendLocalId);
    return this._nextSendLocalId++, this._rtpSenders.set(p, n), { localId: p, rtpParameters: a, rtpSender: n };
  }
  async stopSending(e) {
    ve.debug("stopSending() [localId:%s]", e);
    const t = this._rtpSenders.get(e);
    if (!t)
      throw new Error("RTCRtpSender not found");
    this._rtpSenders.delete(e);
    try {
      ve.debug("stopSending() | calling rtpSender.stop()"), t.stop();
    } catch (s) {
      throw ve.warn("stopSending() | rtpSender.stop() failed:%o", s), s;
    }
  }
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  async pauseSending(e) {
  }
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  async resumeSending(e) {
  }
  async replaceTrack(e, t) {
    t ? ve.debug("replaceTrack() [localId:%s, track.id:%s]", e, t.id) : ve.debug("replaceTrack() [localId:%s, no track]", e);
    const s = this._rtpSenders.get(e);
    if (!s)
      throw new Error("RTCRtpSender not found");
    s.setTrack(t);
  }
  async setMaxSpatialLayer(e, t) {
    ve.debug("setMaxSpatialLayer() [localId:%s, spatialLayer:%s]", e, t);
    const s = this._rtpSenders.get(e);
    if (!s)
      throw new Error("RTCRtpSender not found");
    const i = s.getParameters();
    i.encodings.forEach((n, a) => {
      a <= t ? n.active = !0 : n.active = !1;
    }), await s.setParameters(i);
  }
  async setRtpEncodingParameters(e, t) {
    ve.debug("setRtpEncodingParameters() [localId:%s, params:%o]", e, t);
    const s = this._rtpSenders.get(e);
    if (!s)
      throw new Error("RTCRtpSender not found");
    const i = s.getParameters();
    i.encodings.forEach((n, a) => {
      i.encodings[a] = { ...n, ...t };
    }), await s.setParameters(i);
  }
  async getSenderStats(e) {
    const t = this._rtpSenders.get(e);
    if (!t)
      throw new Error("RTCRtpSender not found");
    return t.getStats();
  }
  async sendDataChannel(e) {
    throw new Mt("not implemented");
  }
  async receive(e) {
    const t = [];
    for (const s of e) {
      const { trackId: i, kind: n } = s;
      ve.debug("receive() [trackId:%s, kind:%s]", i, n);
    }
    this._transportReady || await this.setupTransport({ localDtlsRole: "server" });
    for (const s of e) {
      const { trackId: i, kind: n, rtpParameters: a } = s;
      ve.debug("receive() | calling new RTCRtpReceiver()");
      const o = new RTCRtpReceiver(this._dtlsTransport, n);
      o.addEventListener("error", (l) => {
        ve.error('rtpReceiver "error" event [event:%o]', l);
      });
      const d = nl(a);
      ve.debug("receive() | calling rtpReceiver.receive() [params:%o]", d), await o.receive(d);
      const p = i;
      this._rtpReceivers.set(p, o), t.push({
        localId: p,
        track: o.track,
        rtpReceiver: o
      });
    }
    return t;
  }
  async stopReceiving(e) {
    for (const t of e) {
      ve.debug("stopReceiving() [localId:%s]", t);
      const s = this._rtpReceivers.get(t);
      if (!s)
        throw new Error("RTCRtpReceiver not found");
      this._rtpReceivers.delete(t);
      try {
        ve.debug("stopReceiving() | calling rtpReceiver.stop()"), s.stop();
      } catch (i) {
        ve.warn("stopReceiving() | rtpReceiver.stop() failed:%o", i);
      }
    }
  }
  async pauseReceiving(e) {
  }
  async resumeReceiving(e) {
  }
  async getReceiverStats(e) {
    const t = this._rtpReceivers.get(e);
    if (!t)
      throw new Error("RTCRtpReceiver not found");
    return t.getStats();
  }
  async receiveDataChannel(e) {
    throw new Mt("not implemented");
  }
  setIceGatherer({ iceServers: e, iceTransportPolicy: t }) {
    const s = new RTCIceGatherer({
      iceServers: e || [],
      gatherPolicy: t || "all"
    });
    s.addEventListener("error", (i) => {
      ve.error('iceGatherer "error" event [event:%o]', i);
    });
    try {
      s.gather();
    } catch (i) {
      ve.debug("setIceGatherer() | iceGatherer.gather() failed: %s", i.toString());
    }
    this._iceGatherer = s;
  }
  setIceTransport() {
    const e = new RTCIceTransport(this._iceGatherer);
    e.addEventListener("statechange", () => {
      switch (e.state) {
        case "checking":
          this.emit("@connectionstatechange", "connecting");
          break;
        case "connected":
        case "completed":
          this.emit("@connectionstatechange", "connected");
          break;
        case "failed":
          this.emit("@connectionstatechange", "failed");
          break;
        case "disconnected":
          this.emit("@connectionstatechange", "disconnected");
          break;
        case "closed":
          this.emit("@connectionstatechange", "closed");
          break;
      }
    }), e.addEventListener("icestatechange", () => {
      switch (e.state) {
        case "checking":
          this.emit("@connectionstatechange", "connecting");
          break;
        case "connected":
        case "completed":
          this.emit("@connectionstatechange", "connected");
          break;
        case "failed":
          this.emit("@connectionstatechange", "failed");
          break;
        case "disconnected":
          this.emit("@connectionstatechange", "disconnected");
          break;
        case "closed":
          this.emit("@connectionstatechange", "closed");
          break;
      }
    }), e.addEventListener("candidatepairchange", (t) => {
      ve.debug('iceTransport "candidatepairchange" event [pair:%o]', t.pair);
    }), this._iceTransport = e;
  }
  setDtlsTransport() {
    const e = new RTCDtlsTransport(this._iceTransport);
    e.addEventListener("statechange", () => {
      ve.debug('dtlsTransport "statechange" event [state:%s]', e.state);
    }), e.addEventListener("dtlsstatechange", () => {
      ve.debug('dtlsTransport "dtlsstatechange" event [state:%s]', e.state), e.state === "closed" && this.emit("@connectionstatechange", "closed");
    }), e.addEventListener("error", (t) => {
      ve.error('dtlsTransport "error" event [event:%o]', t);
    }), this._dtlsTransport = e;
  }
  async setupTransport({ localDtlsRole: e }) {
    ve.debug("setupTransport()");
    const t = this._dtlsTransport.getLocalParameters();
    t.role = e, await new Promise((s, i) => {
      this.safeEmit("@connect", { dtlsParameters: t }, s, i);
    }), this._iceTransport.start(this._iceGatherer, this._remoteIceParameters, "controlling");
    for (const s of this._remoteIceCandidates)
      this._iceTransport.addRemoteCandidate(s);
    this._iceTransport.addRemoteCandidate({}), this._remoteDtlsParameters.fingerprints = this._remoteDtlsParameters.fingerprints.filter((s) => s.algorithm === "sha-256" || s.algorithm === "sha-384" || s.algorithm === "sha-512"), this._dtlsTransport.start(this._remoteDtlsParameters), this._transportReady = !0;
  }
}
const B = new Lt("Firefox60"), al = { OS: 16, MIS: 2048 };
let Nv = class Ku extends Zi {
  /**
   * Creates a factory function.
   */
  static createFactory() {
    return () => new Ku();
  }
  constructor() {
    super(), this._mapMidTransceiver = /* @__PURE__ */ new Map(), this._sendStream = new MediaStream(), this._hasDataChannelMediaSection = !1, this._nextSendSctpStreamId = 0, this._transportReady = !1;
  }
  get name() {
    return "Firefox60";
  }
  close() {
    if (B.debug("close()"), this._pc)
      try {
        this._pc.close();
      } catch (e) {
      }
    this.emit("@close");
  }
  async getNativeRtpCapabilities() {
    B.debug("getNativeRtpCapabilities()");
    const e = new RTCPeerConnection({
      iceServers: [],
      iceTransportPolicy: "all",
      bundlePolicy: "max-bundle",
      rtcpMuxPolicy: "require"
    }), t = document.createElement("canvas");
    t.getContext("2d");
    const i = t.captureStream().getVideoTracks()[0];
    try {
      e.addTransceiver("audio", { direction: "sendrecv" });
      const n = e.addTransceiver(i, { direction: "sendrecv" }), a = n.sender.getParameters(), o = [
        { rid: "r0", maxBitrate: 1e5 },
        { rid: "r1", maxBitrate: 5e5 }
      ];
      a.encodings = o, await n.sender.setParameters(a);
      const d = await e.createOffer();
      try {
        t.remove();
      } catch (u) {
      }
      try {
        i.stop();
      } catch (u) {
      }
      try {
        e.close();
      } catch (u) {
      }
      const p = O.parse(d.sdp);
      return Jn({ sdpObject: p });
    } catch (n) {
      try {
        t.remove();
      } catch (a) {
      }
      try {
        i.stop();
      } catch (a) {
      }
      try {
        e.close();
      } catch (a) {
      }
      throw n;
    }
  }
  async getNativeSctpCapabilities() {
    return B.debug("getNativeSctpCapabilities()"), {
      numStreams: al
    };
  }
  run({ direction: e, iceParameters: t, iceCandidates: s, dtlsParameters: i, sctpParameters: n, iceServers: a, iceTransportPolicy: o, additionalSettings: d, proprietaryConstraints: p, extendedRtpCapabilities: l }) {
    B.debug("run()"), this._direction = e, this._remoteSdp = new Yn({
      iceParameters: t,
      iceCandidates: s,
      dtlsParameters: i,
      sctpParameters: n
    }), this._sendingRtpParametersByKind = {
      audio: zt("audio", l),
      video: zt("video", l)
    }, this._sendingRemoteRtpParametersByKind = {
      audio: _s("audio", l),
      video: _s("video", l)
    }, this._pc = new RTCPeerConnection({
      iceServers: a || [],
      iceTransportPolicy: o || "all",
      bundlePolicy: "max-bundle",
      rtcpMuxPolicy: "require",
      ...d
    }, p), this._pc.connectionState ? this._pc.addEventListener("connectionstatechange", () => {
      this.emit("@connectionstatechange", this._pc.connectionState);
    }) : this._pc.addEventListener("iceconnectionstatechange", () => {
      switch (B.warn("run() | pc.connectionState not supported, using pc.iceConnectionState"), this._pc.iceConnectionState) {
        case "checking":
          this.emit("@connectionstatechange", "connecting");
          break;
        case "connected":
        case "completed":
          this.emit("@connectionstatechange", "connected");
          break;
        case "failed":
          this.emit("@connectionstatechange", "failed");
          break;
        case "disconnected":
          this.emit("@connectionstatechange", "disconnected");
          break;
        case "closed":
          this.emit("@connectionstatechange", "closed");
          break;
      }
    });
  }
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  async updateIceServers(e) {
    throw new Mt("not supported");
  }
  async restartIce(e) {
    if (B.debug("restartIce()"), this._remoteSdp.updateIceParameters(e), !!this._transportReady)
      if (this._direction === "send") {
        const t = await this._pc.createOffer({ iceRestart: !0 });
        B.debug("restartIce() | calling pc.setLocalDescription() [offer:%o]", t), await this._pc.setLocalDescription(t);
        const s = { type: "answer", sdp: this._remoteSdp.getSdp() };
        B.debug("restartIce() | calling pc.setRemoteDescription() [answer:%o]", s), await this._pc.setRemoteDescription(s);
      } else {
        const t = { type: "offer", sdp: this._remoteSdp.getSdp() };
        B.debug("restartIce() | calling pc.setRemoteDescription() [offer:%o]", t), await this._pc.setRemoteDescription(t);
        const s = await this._pc.createAnswer();
        B.debug("restartIce() | calling pc.setLocalDescription() [answer:%o]", s), await this._pc.setLocalDescription(s);
      }
  }
  async getTransportStats() {
    return this._pc.getStats();
  }
  async send({ track: e, encodings: t, codecOptions: s, codec: i }) {
    this.assertSendDirection(), B.debug("send() [kind:%s, track.id:%s]", e.kind, e.id), t && (t = ze(t, []), t.length > 1 && (t.forEach((T, S) => {
      T.rid = `r${S}`;
    }), t.reverse()));
    const n = ze(this._sendingRtpParametersByKind[e.kind], {});
    n.codecs = ns(n.codecs, i);
    const a = ze(this._sendingRemoteRtpParametersByKind[e.kind], {});
    a.codecs = ns(a.codecs, i);
    const o = this._pc.addTransceiver(e, { direction: "sendonly", streams: [this._sendStream] });
    if (t) {
      const T = o.sender.getParameters();
      T.encodings = t, await o.sender.setParameters(T);
    }
    const d = await this._pc.createOffer();
    let p = O.parse(d.sdp);
    this._transportReady || await this.setupTransport({ localDtlsRole: "client", localSdpObject: p });
    const l = Zn((t || [{}])[0].scalabilityMode);
    B.debug("send() | calling pc.setLocalDescription() [offer:%o]", d), await this._pc.setLocalDescription(d);
    const u = o.mid;
    n.mid = u, p = O.parse(this._pc.localDescription.sdp);
    const m = p.media[p.media.length - 1];
    if (n.rtcp.cname = zn({ offerMediaObject: m }), !t)
      n.encodings = hr({ offerMediaObject: m });
    else if (t.length === 1) {
      const T = hr({ offerMediaObject: m });
      Object.assign(T[0], t[0]), n.encodings = T;
    } else
      n.encodings = t.reverse();
    if (n.encodings.length > 1 && (n.codecs[0].mimeType.toLowerCase() === "video/vp8" || n.codecs[0].mimeType.toLowerCase() === "video/h264"))
      for (const T of n.encodings)
        T.scalabilityMode ? T.scalabilityMode = `L1T${l.temporalLayers}` : T.scalabilityMode = "L1T3";
    this._remoteSdp.send({
      offerMediaObject: m,
      offerRtpParameters: n,
      answerRtpParameters: a,
      codecOptions: s,
      extmapAllowMixed: !0
    });
    const g = { type: "answer", sdp: this._remoteSdp.getSdp() };
    return B.debug("send() | calling pc.setRemoteDescription() [answer:%o]", g), await this._pc.setRemoteDescription(g), this._mapMidTransceiver.set(u, o), {
      localId: u,
      rtpParameters: n,
      rtpSender: o.sender
    };
  }
  async stopSending(e) {
    B.debug("stopSending() [localId:%s]", e);
    const t = this._mapMidTransceiver.get(e);
    if (!t)
      throw new Error("associated transceiver not found");
    t.sender.replaceTrack(null), this._pc.removeTrack(t.sender), this._remoteSdp.disableMediaSection(t.mid);
    const s = await this._pc.createOffer();
    B.debug("stopSending() | calling pc.setLocalDescription() [offer:%o]", s), await this._pc.setLocalDescription(s);
    const i = { type: "answer", sdp: this._remoteSdp.getSdp() };
    B.debug("stopSending() | calling pc.setRemoteDescription() [answer:%o]", i), await this._pc.setRemoteDescription(i), this._mapMidTransceiver.delete(e);
  }
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  async pauseSending(e) {
    this.assertSendDirection(), B.debug("pauseSending() [localId:%s]", e);
    const t = this._mapMidTransceiver.get(e);
    if (!t)
      throw new Error("associated RTCRtpTransceiver not found");
    t.direction = "inactive", this._remoteSdp.pauseMediaSection(e);
    const s = await this._pc.createOffer();
    B.debug("pauseSending() | calling pc.setLocalDescription() [offer:%o]", s), await this._pc.setLocalDescription(s);
    const i = { type: "answer", sdp: this._remoteSdp.getSdp() };
    B.debug("pauseSending() | calling pc.setRemoteDescription() [answer:%o]", i), await this._pc.setRemoteDescription(i);
  }
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  async resumeSending(e) {
    this.assertSendDirection(), B.debug("resumeSending() [localId:%s]", e);
    const t = this._mapMidTransceiver.get(e);
    if (!t)
      throw new Error("associated RTCRtpTransceiver not found");
    t.direction = "sendonly", this._remoteSdp.resumeSendingMediaSection(e);
    const s = await this._pc.createOffer();
    B.debug("resumeSending() | calling pc.setLocalDescription() [offer:%o]", s), await this._pc.setLocalDescription(s);
    const i = { type: "answer", sdp: this._remoteSdp.getSdp() };
    B.debug("resumeSending() | calling pc.setRemoteDescription() [answer:%o]", i), await this._pc.setRemoteDescription(i);
  }
  async replaceTrack(e, t) {
    this.assertSendDirection(), t ? B.debug("replaceTrack() [localId:%s, track.id:%s]", e, t.id) : B.debug("replaceTrack() [localId:%s, no track]", e);
    const s = this._mapMidTransceiver.get(e);
    if (!s)
      throw new Error("associated RTCRtpTransceiver not found");
    await s.sender.replaceTrack(t);
  }
  async setMaxSpatialLayer(e, t) {
    this.assertSendDirection(), B.debug("setMaxSpatialLayer() [localId:%s, spatialLayer:%s]", e, t);
    const s = this._mapMidTransceiver.get(e);
    if (!s)
      throw new Error("associated transceiver not found");
    const i = s.sender.getParameters();
    t = i.encodings.length - 1 - t, i.encodings.forEach((o, d) => {
      d >= t ? o.active = !0 : o.active = !1;
    }), await s.sender.setParameters(i), this._remoteSdp.muxMediaSectionSimulcast(e, i.encodings);
    const n = await this._pc.createOffer();
    B.debug("setMaxSpatialLayer() | calling pc.setLocalDescription() [offer:%o]", n), await this._pc.setLocalDescription(n);
    const a = { type: "answer", sdp: this._remoteSdp.getSdp() };
    B.debug("setMaxSpatialLayer() | calling pc.setRemoteDescription() [answer:%o]", a), await this._pc.setRemoteDescription(a);
  }
  async setRtpEncodingParameters(e, t) {
    this.assertSendDirection(), B.debug("setRtpEncodingParameters() [localId:%s, params:%o]", e, t);
    const s = this._mapMidTransceiver.get(e);
    if (!s)
      throw new Error("associated RTCRtpTransceiver not found");
    const i = s.sender.getParameters();
    i.encodings.forEach((o, d) => {
      i.encodings[d] = { ...o, ...t };
    }), await s.sender.setParameters(i), this._remoteSdp.muxMediaSectionSimulcast(e, i.encodings);
    const n = await this._pc.createOffer();
    B.debug("setRtpEncodingParameters() | calling pc.setLocalDescription() [offer:%o]", n), await this._pc.setLocalDescription(n);
    const a = { type: "answer", sdp: this._remoteSdp.getSdp() };
    B.debug("setRtpEncodingParameters() | calling pc.setRemoteDescription() [answer:%o]", a), await this._pc.setRemoteDescription(a);
  }
  async getSenderStats(e) {
    this.assertSendDirection();
    const t = this._mapMidTransceiver.get(e);
    if (!t)
      throw new Error("associated RTCRtpTransceiver not found");
    return t.sender.getStats();
  }
  async sendDataChannel({ ordered: e, maxPacketLifeTime: t, maxRetransmits: s, label: i, protocol: n }) {
    this.assertSendDirection();
    const a = {
      negotiated: !0,
      id: this._nextSendSctpStreamId,
      ordered: e,
      maxPacketLifeTime: t,
      maxRetransmits: s,
      protocol: n
    };
    B.debug("sendDataChannel() [options:%o]", a);
    const o = this._pc.createDataChannel(i, a);
    if (this._nextSendSctpStreamId = ++this._nextSendSctpStreamId % al.MIS, !this._hasDataChannelMediaSection) {
      const p = await this._pc.createOffer(), l = O.parse(p.sdp), u = l.media.find((g) => g.type === "application");
      this._transportReady || await this.setupTransport({ localDtlsRole: "client", localSdpObject: l }), B.debug("sendDataChannel() | calling pc.setLocalDescription() [offer:%o]", p), await this._pc.setLocalDescription(p), this._remoteSdp.sendSctpAssociation({ offerMediaObject: u });
      const m = { type: "answer", sdp: this._remoteSdp.getSdp() };
      B.debug("sendDataChannel() | calling pc.setRemoteDescription() [answer:%o]", m), await this._pc.setRemoteDescription(m), this._hasDataChannelMediaSection = !0;
    }
    const d = {
      streamId: a.id,
      ordered: a.ordered,
      maxPacketLifeTime: a.maxPacketLifeTime,
      maxRetransmits: a.maxRetransmits
    };
    return { dataChannel: o, sctpStreamParameters: d };
  }
  async receive(e) {
    this.assertRecvDirection();
    const t = [], s = /* @__PURE__ */ new Map();
    for (const o of e) {
      const { trackId: d, kind: p, rtpParameters: l, streamId: u } = o;
      B.debug("receive() [trackId:%s, kind:%s]", d, p);
      const m = l.mid || String(this._mapMidTransceiver.size);
      s.set(d, m), this._remoteSdp.receive({
        mid: m,
        kind: p,
        offerRtpParameters: l,
        streamId: u || l.rtcp.cname,
        trackId: d
      });
    }
    const i = { type: "offer", sdp: this._remoteSdp.getSdp() };
    B.debug("receive() | calling pc.setRemoteDescription() [offer:%o]", i), await this._pc.setRemoteDescription(i);
    let n = await this._pc.createAnswer();
    const a = O.parse(n.sdp);
    for (const o of e) {
      const { trackId: d, rtpParameters: p } = o, l = s.get(d), u = a.media.find((m) => String(m.mid) === l);
      Qn({
        offerRtpParameters: p,
        answerMediaObject: u
      }), n = { type: "answer", sdp: O.write(a) };
    }
    this._transportReady || await this.setupTransport({ localDtlsRole: "client", localSdpObject: a }), B.debug("receive() | calling pc.setLocalDescription() [answer:%o]", n), await this._pc.setLocalDescription(n);
    for (const o of e) {
      const { trackId: d } = o, p = s.get(d), l = this._pc.getTransceivers().find((u) => u.mid === p);
      if (!l)
        throw new Error("new RTCRtpTransceiver not found");
      this._mapMidTransceiver.set(p, l), t.push({
        localId: p,
        track: l.receiver.track,
        rtpReceiver: l.receiver
      });
    }
    return t;
  }
  async stopReceiving(e) {
    this.assertRecvDirection();
    for (const i of e) {
      B.debug("stopReceiving() [localId:%s]", i);
      const n = this._mapMidTransceiver.get(i);
      if (!n)
        throw new Error("associated RTCRtpTransceiver not found");
      this._remoteSdp.closeMediaSection(n.mid);
    }
    const t = { type: "offer", sdp: this._remoteSdp.getSdp() };
    B.debug("stopReceiving() | calling pc.setRemoteDescription() [offer:%o]", t), await this._pc.setRemoteDescription(t);
    const s = await this._pc.createAnswer();
    B.debug("stopReceiving() | calling pc.setLocalDescription() [answer:%o]", s), await this._pc.setLocalDescription(s);
    for (const i of e)
      this._mapMidTransceiver.delete(i);
  }
  async pauseReceiving(e) {
    this.assertRecvDirection();
    for (const i of e) {
      B.debug("pauseReceiving() [localId:%s]", i);
      const n = this._mapMidTransceiver.get(i);
      if (!n)
        throw new Error("associated RTCRtpTransceiver not found");
      n.direction = "inactive", this._remoteSdp.pauseMediaSection(i);
    }
    const t = { type: "offer", sdp: this._remoteSdp.getSdp() };
    B.debug("pauseReceiving() | calling pc.setRemoteDescription() [offer:%o]", t), await this._pc.setRemoteDescription(t);
    const s = await this._pc.createAnswer();
    B.debug("pauseReceiving() | calling pc.setLocalDescription() [answer:%o]", s), await this._pc.setLocalDescription(s);
  }
  async resumeReceiving(e) {
    this.assertRecvDirection();
    for (const i of e) {
      B.debug("resumeReceiving() [localId:%s]", i);
      const n = this._mapMidTransceiver.get(i);
      if (!n)
        throw new Error("associated RTCRtpTransceiver not found");
      n.direction = "recvonly", this._remoteSdp.resumeReceivingMediaSection(i);
    }
    const t = { type: "offer", sdp: this._remoteSdp.getSdp() };
    B.debug("resumeReceiving() | calling pc.setRemoteDescription() [offer:%o]", t), await this._pc.setRemoteDescription(t);
    const s = await this._pc.createAnswer();
    B.debug("resumeReceiving() | calling pc.setLocalDescription() [answer:%o]", s), await this._pc.setLocalDescription(s);
  }
  async getReceiverStats(e) {
    this.assertRecvDirection();
    const t = this._mapMidTransceiver.get(e);
    if (!t)
      throw new Error("associated RTCRtpTransceiver not found");
    return t.receiver.getStats();
  }
  async receiveDataChannel({ sctpStreamParameters: e, label: t, protocol: s }) {
    this.assertRecvDirection();
    const { streamId: i, ordered: n, maxPacketLifeTime: a, maxRetransmits: o } = e, d = {
      negotiated: !0,
      id: i,
      ordered: n,
      maxPacketLifeTime: a,
      maxRetransmits: o,
      protocol: s
    };
    B.debug("receiveDataChannel() [options:%o]", d);
    const p = this._pc.createDataChannel(t, d);
    if (!this._hasDataChannelMediaSection) {
      this._remoteSdp.receiveSctpAssociation();
      const l = { type: "offer", sdp: this._remoteSdp.getSdp() };
      B.debug("receiveDataChannel() | calling pc.setRemoteDescription() [offer:%o]", l), await this._pc.setRemoteDescription(l);
      const u = await this._pc.createAnswer();
      if (!this._transportReady) {
        const m = O.parse(u.sdp);
        await this.setupTransport({ localDtlsRole: "client", localSdpObject: m });
      }
      B.debug("receiveDataChannel() | calling pc.setRemoteDescription() [answer:%o]", u), await this._pc.setLocalDescription(u), this._hasDataChannelMediaSection = !0;
    }
    return { dataChannel: p };
  }
  async setupTransport({ localDtlsRole: e, localSdpObject: t }) {
    t || (t = O.parse(this._pc.localDescription.sdp));
    const s = Kn({ sdpObject: t });
    s.role = e, this._remoteSdp.updateDtlsRole(e === "client" ? "server" : "client"), await new Promise((i, n) => {
      this.safeEmit("@connect", { dtlsParameters: s }, i, n);
    }), this._transportReady = !0;
  }
  assertSendDirection() {
    if (this._direction !== "send")
      throw new Error('method can just be called for handlers with "send" direction');
  }
  assertRecvDirection() {
    if (this._direction !== "recv")
      throw new Error('method can just be called for handlers with "recv" direction');
  }
};
const V = new Lt("Safari12"), ol = { OS: 1024, MIS: 1024 };
let Lv = class zu extends Zi {
  /**
   * Creates a factory function.
   */
  static createFactory() {
    return () => new zu();
  }
  constructor() {
    super(), this._mapMidTransceiver = /* @__PURE__ */ new Map(), this._sendStream = new MediaStream(), this._hasDataChannelMediaSection = !1, this._nextSendSctpStreamId = 0, this._transportReady = !1;
  }
  get name() {
    return "Safari12";
  }
  close() {
    if (V.debug("close()"), this._pc)
      try {
        this._pc.close();
      } catch (e) {
      }
    this.emit("@close");
  }
  async getNativeRtpCapabilities() {
    V.debug("getNativeRtpCapabilities()");
    const e = new RTCPeerConnection({
      iceServers: [],
      iceTransportPolicy: "all",
      bundlePolicy: "max-bundle",
      rtcpMuxPolicy: "require"
    });
    try {
      e.addTransceiver("audio"), e.addTransceiver("video");
      const t = await e.createOffer();
      try {
        e.close();
      } catch (n) {
      }
      const s = O.parse(t.sdp);
      return Jn({ sdpObject: s });
    } catch (t) {
      try {
        e.close();
      } catch (s) {
      }
      throw t;
    }
  }
  async getNativeSctpCapabilities() {
    return V.debug("getNativeSctpCapabilities()"), {
      numStreams: ol
    };
  }
  run({ direction: e, iceParameters: t, iceCandidates: s, dtlsParameters: i, sctpParameters: n, iceServers: a, iceTransportPolicy: o, additionalSettings: d, proprietaryConstraints: p, extendedRtpCapabilities: l }) {
    V.debug("run()"), this._direction = e, this._remoteSdp = new Yn({
      iceParameters: t,
      iceCandidates: s,
      dtlsParameters: i,
      sctpParameters: n
    }), this._sendingRtpParametersByKind = {
      audio: zt("audio", l),
      video: zt("video", l)
    }, this._sendingRemoteRtpParametersByKind = {
      audio: _s("audio", l),
      video: _s("video", l)
    }, i.role && i.role !== "auto" && (this._forcedLocalDtlsRole = i.role === "server" ? "client" : "server"), this._pc = new RTCPeerConnection({
      iceServers: a || [],
      iceTransportPolicy: o || "all",
      bundlePolicy: "max-bundle",
      rtcpMuxPolicy: "require",
      ...d
    }, p), this._pc.connectionState ? this._pc.addEventListener("connectionstatechange", () => {
      this.emit("@connectionstatechange", this._pc.connectionState);
    }) : this._pc.addEventListener("iceconnectionstatechange", () => {
      switch (V.warn("run() | pc.connectionState not supported, using pc.iceConnectionState"), this._pc.iceConnectionState) {
        case "checking":
          this.emit("@connectionstatechange", "connecting");
          break;
        case "connected":
        case "completed":
          this.emit("@connectionstatechange", "connected");
          break;
        case "failed":
          this.emit("@connectionstatechange", "failed");
          break;
        case "disconnected":
          this.emit("@connectionstatechange", "disconnected");
          break;
        case "closed":
          this.emit("@connectionstatechange", "closed");
          break;
      }
    });
  }
  async updateIceServers(e) {
    V.debug("updateIceServers()");
    const t = this._pc.getConfiguration();
    t.iceServers = e, this._pc.setConfiguration(t);
  }
  async restartIce(e) {
    if (V.debug("restartIce()"), this._remoteSdp.updateIceParameters(e), !!this._transportReady)
      if (this._direction === "send") {
        const t = await this._pc.createOffer({ iceRestart: !0 });
        V.debug("restartIce() | calling pc.setLocalDescription() [offer:%o]", t), await this._pc.setLocalDescription(t);
        const s = { type: "answer", sdp: this._remoteSdp.getSdp() };
        V.debug("restartIce() | calling pc.setRemoteDescription() [answer:%o]", s), await this._pc.setRemoteDescription(s);
      } else {
        const t = { type: "offer", sdp: this._remoteSdp.getSdp() };
        V.debug("restartIce() | calling pc.setRemoteDescription() [offer:%o]", t), await this._pc.setRemoteDescription(t);
        const s = await this._pc.createAnswer();
        V.debug("restartIce() | calling pc.setLocalDescription() [answer:%o]", s), await this._pc.setLocalDescription(s);
      }
  }
  async getTransportStats() {
    return this._pc.getStats();
  }
  async send({ track: e, encodings: t, codecOptions: s, codec: i }) {
    var n;
    this.assertSendDirection(), V.debug("send() [kind:%s, track.id:%s]", e.kind, e.id);
    const a = ze(this._sendingRtpParametersByKind[e.kind], {});
    a.codecs = ns(a.codecs, i);
    const o = ze(this._sendingRemoteRtpParametersByKind[e.kind], {});
    o.codecs = ns(o.codecs, i);
    const d = this._remoteSdp.getNextMediaSectionIdx(), p = this._pc.addTransceiver(e, { direction: "sendonly", streams: [this._sendStream] });
    let l = await this._pc.createOffer(), u = O.parse(l.sdp), m;
    this._transportReady || await this.setupTransport({
      localDtlsRole: (n = this._forcedLocalDtlsRole) !== null && n !== void 0 ? n : "client",
      localSdpObject: u
    });
    const g = Zn((t || [{}])[0].scalabilityMode);
    t && t.length > 1 && (V.debug("send() | enabling legacy simulcast"), u = O.parse(l.sdp), m = u.media[d.idx], Oa({
      offerMediaObject: m,
      numStreams: t.length
    }), l = { type: "offer", sdp: O.write(u) }), V.debug("send() | calling pc.setLocalDescription() [offer:%o]", l), await this._pc.setLocalDescription(l);
    const T = p.mid;
    if (a.mid = T, u = O.parse(this._pc.localDescription.sdp), m = u.media[d.idx], a.rtcp.cname = zn({ offerMediaObject: m }), a.encodings = hr({ offerMediaObject: m }), t)
      for (let R = 0; R < a.encodings.length; ++R)
        t[R] && Object.assign(a.encodings[R], t[R]);
    if (a.encodings.length > 1 && (a.codecs[0].mimeType.toLowerCase() === "video/vp8" || a.codecs[0].mimeType.toLowerCase() === "video/h264"))
      for (const R of a.encodings)
        R.scalabilityMode ? R.scalabilityMode = `L1T${g.temporalLayers}` : R.scalabilityMode = "L1T3";
    this._remoteSdp.send({
      offerMediaObject: m,
      reuseMid: d.reuseMid,
      offerRtpParameters: a,
      answerRtpParameters: o,
      codecOptions: s
    });
    const S = { type: "answer", sdp: this._remoteSdp.getSdp() };
    return V.debug("send() | calling pc.setRemoteDescription() [answer:%o]", S), await this._pc.setRemoteDescription(S), this._mapMidTransceiver.set(T, p), {
      localId: T,
      rtpParameters: a,
      rtpSender: p.sender
    };
  }
  async stopSending(e) {
    this.assertSendDirection(), V.debug("stopSending() [localId:%s]", e);
    const t = this._mapMidTransceiver.get(e);
    if (!t)
      throw new Error("associated RTCRtpTransceiver not found");
    if (t.sender.replaceTrack(null), this._pc.removeTrack(t.sender), this._remoteSdp.closeMediaSection(t.mid))
      try {
        t.stop();
      } catch (a) {
      }
    const i = await this._pc.createOffer();
    V.debug("stopSending() | calling pc.setLocalDescription() [offer:%o]", i), await this._pc.setLocalDescription(i);
    const n = { type: "answer", sdp: this._remoteSdp.getSdp() };
    V.debug("stopSending() | calling pc.setRemoteDescription() [answer:%o]", n), await this._pc.setRemoteDescription(n), this._mapMidTransceiver.delete(e);
  }
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  async pauseSending(e) {
    this.assertSendDirection(), V.debug("pauseSending() [localId:%s]", e);
    const t = this._mapMidTransceiver.get(e);
    if (!t)
      throw new Error("associated RTCRtpTransceiver not found");
    t.direction = "inactive", this._remoteSdp.pauseMediaSection(e);
    const s = await this._pc.createOffer();
    V.debug("pauseSending() | calling pc.setLocalDescription() [offer:%o]", s), await this._pc.setLocalDescription(s);
    const i = { type: "answer", sdp: this._remoteSdp.getSdp() };
    V.debug("pauseSending() | calling pc.setRemoteDescription() [answer:%o]", i), await this._pc.setRemoteDescription(i);
  }
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  async resumeSending(e) {
    this.assertSendDirection(), V.debug("resumeSending() [localId:%s]", e);
    const t = this._mapMidTransceiver.get(e);
    if (!t)
      throw new Error("associated RTCRtpTransceiver not found");
    t.direction = "sendonly", this._remoteSdp.resumeSendingMediaSection(e);
    const s = await this._pc.createOffer();
    V.debug("resumeSending() | calling pc.setLocalDescription() [offer:%o]", s), await this._pc.setLocalDescription(s);
    const i = { type: "answer", sdp: this._remoteSdp.getSdp() };
    V.debug("resumeSending() | calling pc.setRemoteDescription() [answer:%o]", i), await this._pc.setRemoteDescription(i);
  }
  async replaceTrack(e, t) {
    this.assertSendDirection(), t ? V.debug("replaceTrack() [localId:%s, track.id:%s]", e, t.id) : V.debug("replaceTrack() [localId:%s, no track]", e);
    const s = this._mapMidTransceiver.get(e);
    if (!s)
      throw new Error("associated RTCRtpTransceiver not found");
    await s.sender.replaceTrack(t);
  }
  async setMaxSpatialLayer(e, t) {
    this.assertSendDirection(), V.debug("setMaxSpatialLayer() [localId:%s, spatialLayer:%s]", e, t);
    const s = this._mapMidTransceiver.get(e);
    if (!s)
      throw new Error("associated RTCRtpTransceiver not found");
    const i = s.sender.getParameters();
    i.encodings.forEach((o, d) => {
      d <= t ? o.active = !0 : o.active = !1;
    }), await s.sender.setParameters(i), this._remoteSdp.muxMediaSectionSimulcast(e, i.encodings);
    const n = await this._pc.createOffer();
    V.debug("setMaxSpatialLayer() | calling pc.setLocalDescription() [offer:%o]", n), await this._pc.setLocalDescription(n);
    const a = { type: "answer", sdp: this._remoteSdp.getSdp() };
    V.debug("setMaxSpatialLayer() | calling pc.setRemoteDescription() [answer:%o]", a), await this._pc.setRemoteDescription(a);
  }
  async setRtpEncodingParameters(e, t) {
    this.assertSendDirection(), V.debug("setRtpEncodingParameters() [localId:%s, params:%o]", e, t);
    const s = this._mapMidTransceiver.get(e);
    if (!s)
      throw new Error("associated RTCRtpTransceiver not found");
    const i = s.sender.getParameters();
    i.encodings.forEach((o, d) => {
      i.encodings[d] = { ...o, ...t };
    }), await s.sender.setParameters(i), this._remoteSdp.muxMediaSectionSimulcast(e, i.encodings);
    const n = await this._pc.createOffer();
    V.debug("setRtpEncodingParameters() | calling pc.setLocalDescription() [offer:%o]", n), await this._pc.setLocalDescription(n);
    const a = { type: "answer", sdp: this._remoteSdp.getSdp() };
    V.debug("setRtpEncodingParameters() | calling pc.setRemoteDescription() [answer:%o]", a), await this._pc.setRemoteDescription(a);
  }
  async getSenderStats(e) {
    this.assertSendDirection();
    const t = this._mapMidTransceiver.get(e);
    if (!t)
      throw new Error("associated RTCRtpTransceiver not found");
    return t.sender.getStats();
  }
  async sendDataChannel({ ordered: e, maxPacketLifeTime: t, maxRetransmits: s, label: i, protocol: n }) {
    var a;
    this.assertSendDirection();
    const o = {
      negotiated: !0,
      id: this._nextSendSctpStreamId,
      ordered: e,
      maxPacketLifeTime: t,
      maxRetransmits: s,
      protocol: n
    };
    V.debug("sendDataChannel() [options:%o]", o);
    const d = this._pc.createDataChannel(i, o);
    if (this._nextSendSctpStreamId = ++this._nextSendSctpStreamId % ol.MIS, !this._hasDataChannelMediaSection) {
      const l = await this._pc.createOffer(), u = O.parse(l.sdp), m = u.media.find((T) => T.type === "application");
      this._transportReady || await this.setupTransport({
        localDtlsRole: (a = this._forcedLocalDtlsRole) !== null && a !== void 0 ? a : "client",
        localSdpObject: u
      }), V.debug("sendDataChannel() | calling pc.setLocalDescription() [offer:%o]", l), await this._pc.setLocalDescription(l), this._remoteSdp.sendSctpAssociation({ offerMediaObject: m });
      const g = { type: "answer", sdp: this._remoteSdp.getSdp() };
      V.debug("sendDataChannel() | calling pc.setRemoteDescription() [answer:%o]", g), await this._pc.setRemoteDescription(g), this._hasDataChannelMediaSection = !0;
    }
    const p = {
      streamId: o.id,
      ordered: o.ordered,
      maxPacketLifeTime: o.maxPacketLifeTime,
      maxRetransmits: o.maxRetransmits
    };
    return { dataChannel: d, sctpStreamParameters: p };
  }
  async receive(e) {
    var t;
    this.assertRecvDirection();
    const s = [], i = /* @__PURE__ */ new Map();
    for (const d of e) {
      const { trackId: p, kind: l, rtpParameters: u, streamId: m } = d;
      V.debug("receive() [trackId:%s, kind:%s]", p, l);
      const g = u.mid || String(this._mapMidTransceiver.size);
      i.set(p, g), this._remoteSdp.receive({
        mid: g,
        kind: l,
        offerRtpParameters: u,
        streamId: m || u.rtcp.cname,
        trackId: p
      });
    }
    const n = { type: "offer", sdp: this._remoteSdp.getSdp() };
    V.debug("receive() | calling pc.setRemoteDescription() [offer:%o]", n), await this._pc.setRemoteDescription(n);
    let a = await this._pc.createAnswer();
    const o = O.parse(a.sdp);
    for (const d of e) {
      const { trackId: p, rtpParameters: l } = d, u = i.get(p), m = o.media.find((g) => String(g.mid) === u);
      Qn({
        offerRtpParameters: l,
        answerMediaObject: m
      });
    }
    a = { type: "answer", sdp: O.write(o) }, this._transportReady || await this.setupTransport({
      localDtlsRole: (t = this._forcedLocalDtlsRole) !== null && t !== void 0 ? t : "client",
      localSdpObject: o
    }), V.debug("receive() | calling pc.setLocalDescription() [answer:%o]", a), await this._pc.setLocalDescription(a);
    for (const d of e) {
      const { trackId: p } = d, l = i.get(p), u = this._pc.getTransceivers().find((m) => m.mid === l);
      if (!u)
        throw new Error("new RTCRtpTransceiver not found");
      this._mapMidTransceiver.set(l, u), s.push({
        localId: l,
        track: u.receiver.track,
        rtpReceiver: u.receiver
      });
    }
    return s;
  }
  async stopReceiving(e) {
    this.assertRecvDirection();
    for (const i of e) {
      V.debug("stopReceiving() [localId:%s]", i);
      const n = this._mapMidTransceiver.get(i);
      if (!n)
        throw new Error("associated RTCRtpTransceiver not found");
      this._remoteSdp.closeMediaSection(n.mid);
    }
    const t = { type: "offer", sdp: this._remoteSdp.getSdp() };
    V.debug("stopReceiving() | calling pc.setRemoteDescription() [offer:%o]", t), await this._pc.setRemoteDescription(t);
    const s = await this._pc.createAnswer();
    V.debug("stopReceiving() | calling pc.setLocalDescription() [answer:%o]", s), await this._pc.setLocalDescription(s);
    for (const i of e)
      this._mapMidTransceiver.delete(i);
  }
  async pauseReceiving(e) {
    this.assertRecvDirection();
    for (const i of e) {
      V.debug("pauseReceiving() [localId:%s]", i);
      const n = this._mapMidTransceiver.get(i);
      if (!n)
        throw new Error("associated RTCRtpTransceiver not found");
      n.direction = "inactive", this._remoteSdp.pauseMediaSection(i);
    }
    const t = { type: "offer", sdp: this._remoteSdp.getSdp() };
    V.debug("pauseReceiving() | calling pc.setRemoteDescription() [offer:%o]", t), await this._pc.setRemoteDescription(t);
    const s = await this._pc.createAnswer();
    V.debug("pauseReceiving() | calling pc.setLocalDescription() [answer:%o]", s), await this._pc.setLocalDescription(s);
  }
  async resumeReceiving(e) {
    this.assertRecvDirection();
    for (const i of e) {
      V.debug("resumeReceiving() [localId:%s]", i);
      const n = this._mapMidTransceiver.get(i);
      if (!n)
        throw new Error("associated RTCRtpTransceiver not found");
      n.direction = "recvonly", this._remoteSdp.resumeReceivingMediaSection(i);
    }
    const t = { type: "offer", sdp: this._remoteSdp.getSdp() };
    V.debug("resumeReceiving() | calling pc.setRemoteDescription() [offer:%o]", t), await this._pc.setRemoteDescription(t);
    const s = await this._pc.createAnswer();
    V.debug("resumeReceiving() | calling pc.setLocalDescription() [answer:%o]", s), await this._pc.setLocalDescription(s);
  }
  async getReceiverStats(e) {
    this.assertRecvDirection();
    const t = this._mapMidTransceiver.get(e);
    if (!t)
      throw new Error("associated RTCRtpTransceiver not found");
    return t.receiver.getStats();
  }
  async receiveDataChannel({ sctpStreamParameters: e, label: t, protocol: s }) {
    var i;
    this.assertRecvDirection();
    const { streamId: n, ordered: a, maxPacketLifeTime: o, maxRetransmits: d } = e, p = {
      negotiated: !0,
      id: n,
      ordered: a,
      maxPacketLifeTime: o,
      maxRetransmits: d,
      protocol: s
    };
    V.debug("receiveDataChannel() [options:%o]", p);
    const l = this._pc.createDataChannel(t, p);
    if (!this._hasDataChannelMediaSection) {
      this._remoteSdp.receiveSctpAssociation();
      const u = { type: "offer", sdp: this._remoteSdp.getSdp() };
      V.debug("receiveDataChannel() | calling pc.setRemoteDescription() [offer:%o]", u), await this._pc.setRemoteDescription(u);
      const m = await this._pc.createAnswer();
      if (!this._transportReady) {
        const g = O.parse(m.sdp);
        await this.setupTransport({
          localDtlsRole: (i = this._forcedLocalDtlsRole) !== null && i !== void 0 ? i : "client",
          localSdpObject: g
        });
      }
      V.debug("receiveDataChannel() | calling pc.setRemoteDescription() [answer:%o]", m), await this._pc.setLocalDescription(m), this._hasDataChannelMediaSection = !0;
    }
    return { dataChannel: l };
  }
  async setupTransport({ localDtlsRole: e, localSdpObject: t }) {
    t || (t = O.parse(this._pc.localDescription.sdp));
    const s = Kn({ sdpObject: t });
    s.role = e, this._remoteSdp.updateDtlsRole(e === "client" ? "server" : "client"), await new Promise((i, n) => {
      this.safeEmit("@connect", { dtlsParameters: s }, i, n);
    }), this._transportReady = !0;
  }
  assertSendDirection() {
    if (this._direction !== "send")
      throw new Error('method can just be called for handlers with "send" direction');
  }
  assertRecvDirection() {
    if (this._direction !== "recv")
      throw new Error('method can just be called for handlers with "recv" direction');
  }
}, Qu = class extends Iv {
  constructor({ handlerName: e, handlerFactory: t, Handler: s } = {}) {
    super({ handlerName: e, handlerFactory: t, Handler: s });
  }
  switchDevice(e) {
    switch (e) {
      case "Chrome111":
        this._handlerFactory = Uc.createFactory();
        break;
      case "Chrome74":
        this._handlerFactory = Mv.createFactory();
        break;
      case "Chrome70":
        this._handlerFactory = xc.createFactory();
        break;
      case "Firefox60":
        this._handlerFactory = Nv.createFactory();
        break;
      case "Safari12":
        this._handlerFactory = Lv.createFactory();
        break;
      case "Edge11":
        this._handlerFactory = Vc.createFactory();
        break;
      default:
        throw new TypeError(`unknown handlerName "${e}"`);
    }
  }
};
const yn = "chrome", Yu = "opera", Zu = "firefox", Xu = "iexplorer", ep = "safari", tp = "nwjs", sp = "electron", rp = "react-native", Fc = "unknown", Na = {
  Chrome: yn,
  Chromium: yn,
  Opera: Yu,
  Firefox: Zu,
  "Internet Explorer": Xu,
  Safari: ep
};
function xv() {
  const { userAgent: r } = navigator, e = {
    name: Fc,
    version: void 0
  };
  if (r.match(/Chrome/) && !r.match(/Edge/))
    if (r.match(/Edg(A?)/)) {
      const t = r.match(/Chrome\/([\d.]+)/)[1];
      Number.parseInt(t, 10) > 72 && (e.name = yn, e.version = t);
    } else
      e.name = yn, e.version = r.match(/Chrome\/([\d.]+)/)[1];
  return e;
}
function Uv() {
  const { userAgent: r } = navigator;
  if (r.match(/Electron/)) {
    const e = r.match(/Electron\/([\d.]+)/)[1];
    return {
      name: sp,
      version: e
    };
  }
  return null;
}
function Vv() {
  const { userAgent: r } = navigator;
  if (r.match(/JitsiMeetNW/)) {
    const e = r.match(/JitsiMeetNW\/([\d.]+)/)[1];
    return {
      name: tp,
      version: e
    };
  }
}
function Fv() {
  const r = navigator.userAgent.match(/\b(react[ \t_-]*native)(?:\/(\S+))?/i);
  let e;
  if (r || navigator.product === "ReactNative")
    return r && r.length > 2 && (r[1], e = r[2]), e || (e = "unknown"), {
      name: rp,
      version: e
    };
}
function jv(r) {
  let e;
  const t = [
    Fv,
    Uv,
    Vv
  ];
  for (let i = 0; i < t.length; i += 1)
    if (e = t[i](), e)
      return e;
  const s = r.getBrowserName();
  return s in Na ? {
    name: Na[s],
    version: r.getBrowserVersion()
  } : (e = xv(), e || {
    name: Fc,
    version: void 0
  });
}
class $v {
  constructor() {
    h(this, "_bowser");
    h(this, "_name");
    h(this, "_version");
    h(this, "getDeviceInfo", () => ({
      isMobile: this.isMobile(),
      browserName: this._bowser.getBrowserName(),
      osName: this._bowser.getOSName(),
      browserVersion: this._bowser.getBrowserVersion(),
      osVersionName: this._bowser.getOSVersion(),
      engineName: this._bowser.getEngineName()
    }));
  }
  /**
   * Creates new BrowserDetection instance.
   *
   * @param {Object} [browserInfo] - Information about the browser.
   * @param {string} browserInfo.name - The name of the browser.
   * @param {string} browserInfo.version - The version of the browser.
   */
  init(e) {
    let t, s;
    if (this._bowser = Sc.getParser(navigator.userAgent), typeof e == "undefined") {
      const i = jv(this._bowser);
      t = i.name, s = i.version;
    } else
      e.name in Na ? (t = Na[e.name], s = e.version) : (t = Fc, s = void 0);
    this._name = t, this._version = s;
  }
  /**
   * Gets current browser name.
   * @returns {string}
   */
  getName() {
    return this._name;
  }
  /**
   * Checks if current browser is Chrome.
   * @returns {boolean}
   */
  isChrome() {
    return this._name === yn;
  }
  /**
   * Checks if current browser is Opera.
   * @returns {boolean}
   */
  isOpera() {
    return this._name === Yu;
  }
  /**
   * Checks if current browser is Firefox.
   * @returns {boolean}
   */
  isFirefox() {
    return this._name === Zu;
  }
  /**
   * Checks if current browser is Internet Explorer.
   * @returns {boolean}
   */
  isIExplorer() {
    return this._name === Xu;
  }
  /**
   * Checks if current browser is Safari.
   * @returns {boolean}
   */
  isSafari() {
    return this._name === ep;
  }
  /**
   * Checks if current environment is NWJS.
   * @returns {boolean}
   */
  isNWJS() {
    return this._name === tp;
  }
  /**
   * Checks if current environment is Electron.
   * @returns {boolean}
   */
  isElectron() {
    return this._name === sp;
  }
  /**
   * Checks if current environment is React Native.
   * @returns {boolean}
   */
  isReactNative() {
    return this._name === rp || navigator.isReactNative === !0;
  }
  /**
   * Returns the version of the current browser.
   * @returns {string}
   */
  getVersion() {
    return this._version;
  }
  isMobile() {
    return this._bowser.getPlatformType() === "mobile";
  }
  /**
   * Check if the parsed browser matches the passed condition.
   *
   * @param {Object} checkTree - It's one or two layered object, which can include a
   * platform or an OS on the first layer and should have browsers specs on the
   * bottom layer.
   * Eg. { chrome: '>71.1.0' }
   *     { windows: { chrome: '<70.2' } }
   * @returns {boolean | undefined} - Returns true if the browser satisfies the set
   * conditions, false if not and undefined when the browser is not defined in the
   * checktree object or when the current browser's version is unknown.
   * @private
   */
  _checkCondition(e) {
    if (this._version)
      return this._bowser.satisfies(e);
  }
  /**
   * Compares the passed version with the current browser version.
   *
   * @param {*} version - The version to compare with. Anything different
   * than string will be converted to string.
   * @returns {boolean|undefined} - Returns true if the current version is
   * greater than the passed version and false otherwise. Returns undefined if
   * the current browser version is unknown.
   */
  isVersionGreaterThan(e) {
    return this._checkCondition({ [this._name]: `>${e}` });
  }
  /**
   * Compares the passed version with the current browser version.
   *
   * @param {*} version - The version to compare with. Anything different
   * than string will be converted to string.
   * @returns {boolean|undefined} - Returns true if the current version is
   * lower than the passed version and false otherwise. Returns undefined if
   * the current browser version is unknown.
   */
  isVersionLessThan(e) {
    return this._checkCondition({ [this._name]: `<${e}` });
  }
  /**
   * Compares the passed version with the current browser version.
   *
   * @param {*} version - The version to compare with. Anything different
   * than string will be converted to string.
   * @returns {boolean|undefined} - Returns true if the current version is
   * equal to the passed version and false otherwise. Returns undefined if
   * the current browser version is unknown.
   * A loose-equality operator is used here so that it matches the sub-versions as well.
   */
  isVersionEqualTo(e) {
    return this._checkCondition({ [this._name]: `~${e}` });
  }
}
const Hv = 72;
class Bv extends $v {
  /**
   * Tells whether or not the <tt>MediaStream/tt> is removed from
   * the <tt>PeerConnection</tt> and disposed on video mute (in order to turn
   * off the camera device).
   * @return {boolean} <tt>true</tt> if the current browser supports this
   * strategy or <tt>false</tt> otherwise.
   */
  doesVideoMuteByStreamRemove() {
    return this.isChromiumBased() || this.isWebKitBased();
  }
  /**
   * Check whether or not the current browser support peer to peer connections
   * @return {boolean} <tt>true</tt> if p2p is supported or <tt>false</tt>
   * otherwise.
   */
  supportsP2P() {
    return !this.usesUnifiedPlan();
  }
  /**
   * Checks if the current browser is Chromium based, that is, it's either
   * Chrome / Chromium or uses it as its engine, but doesn't identify as
   * Chrome.
   *
   * This includes the following browsers:
   * - Chrome and Chromium
   * - Other browsers which use the Chrome engine, but are detected as Chrome,
   *   such as Brave and Vivaldi
   * - Browsers which are NOT Chrome but use it as their engine, and have
   *   custom detection code: Opera, Electron and NW.JS
   */
  isChromiumBased() {
    return this.isChrome() || this.isElectron() || this.isNWJS() || this.isOpera();
  }
  /**
   * Checks if the current browser is WebKit based. It's either
   * Safari or uses WebKit as its engine.
   *
   * This includes Chrome and Firefox on iOS
   *
   * @returns {boolean}
   */
  isWebKitBased() {
    return this._bowser.isEngine("webkit") && typeof navigator.mediaDevices != "undefined" && typeof navigator.mediaDevices.getUserMedia != "undefined" && typeof window.RTCRtpTransceiver != "undefined" && Object.keys(RTCRtpTransceiver.prototype).indexOf("currentDirection") > -1;
  }
  /**
   * Checks if the current browser is supported.
   *
   * @returns {boolean} true if the browser is supported, false otherwise.
   */
  isSupported() {
    return this.isChromiumBased() && this._getChromiumBasedVersion() >= Hv || this.isFirefox() || this.isReactNative() || this.isWebKitBased();
  }
  /**
   * Returns whether or not the current environment needs a user interaction
   * with the page before any unmute can occur.
   *
   * @returns {boolean}
   */
  isUserInteractionRequiredForUnmute() {
    return this.isFirefox() && this.isVersionLessThan("68");
  }
  /**
   * Checks if the current browser triggers 'onmute'/'onunmute' events when
   * user's connection is interrupted and the video stops playback.
   * @returns {*|boolean} 'true' if the event is supported or 'false'
   * otherwise.
   */
  supportsVideoMuteOnConnInterrupted() {
    return this.isChromiumBased() || this.isReactNative() || this.isWebKitBased();
  }
  /**
   * Checks if the current browser reports upload and download bandwidth
   * statistics.
   * @return {boolean}
   */
  supportsBandwidthStatistics() {
    return !this.isFirefox() && !this.isWebKitBased();
  }
  /**
   * Checks if the current browser supports setting codec preferences on the transceiver.
   * @returns {boolean}
   */
  supportsCodecPreferences() {
    return this.usesUnifiedPlan() && typeof window.RTCRtpTransceiver != "undefined" && Object.keys(window.RTCRtpTransceiver.prototype).indexOf("setCodecPreferences") > -1 && Object.keys(RTCRtpSender.prototype).indexOf("getCapabilities") > -1 && !this.isWebKitBased();
  }
  /**
   * Checks if the current browser support the device change event.
   * @return {boolean}
   */
  // eslint-disable-next-line class-methods-use-this
  supportsDeviceChangeEvent() {
    return navigator.mediaDevices && typeof navigator.mediaDevices.ondevicechange != "undefined" && typeof navigator.mediaDevices.addEventListener != "undefined";
  }
  /**
   * Checks if the current browser supports RTT statistics for srflx local
   * candidates through the legacy getStats() API.
   */
  supportsLocalCandidateRttStatistics() {
    return this.isChromiumBased() || this.isReactNative() || this.isWebKitBased();
  }
  /**
   * Checks if the current browser supports the Long Tasks API that lets us observe
   * performance measurement events and be notified of tasks that take longer than
   * 50ms to execute on the main thread.
   */
  supportsPerformanceObserver() {
    return typeof window.PerformanceObserver != "undefined" && PerformanceObserver.supportedEntryTypes.indexOf("longtask") > -1;
  }
  /**
   * Checks if the current browser supports audio level stats on the receivers.
   */
  supportsReceiverStats() {
    return typeof window.RTCRtpReceiver != "undefined" && Object.keys(RTCRtpReceiver.prototype).indexOf("getSynchronizationSources") > -1;
  }
  /**
   * Checks if the current browser reports round trip time statistics for
   * the ICE candidate pair.
   * @return {boolean}
   */
  supportsRTTStatistics() {
    return !this.isFirefox();
  }
  /**
   * Checks if the browser uses plan B.
   *
   * @returns {boolean}
   */
  usesPlanB() {
    return !this.usesUnifiedPlan();
  }
  /**
   * Checks if the browser uses SDP munging for turning on simulcast.
   *
   * @returns {boolean}
   */
  usesSdpMungingForSimulcast() {
    return this.isChromiumBased() || this.isReactNative() || this.isWebKitBased();
  }
  /**
   * Checks if the browser uses unified plan.
   *
   * @returns {boolean}
   */
  usesUnifiedPlan() {
    return !!(this.isFirefox() || this.isWebKitBased());
  }
  /**
   * Returns whether or not the current browser should be using the new
   * getUserMedia flow, which utilizes the adapter shim. This method should
   * be temporary and used while migrating all browsers to use adapter and
   * the new getUserMedia.
   *
   * @returns {boolean}
   */
  usesNewGumFlow() {
    return !!(this.isChromiumBased() || this.isFirefox() || this.isWebKitBased());
  }
  /**
   * Checks if the browser uses webrtc-adapter. All browsers using the new
   * getUserMedia flow.
   *
   * @returns {boolean}
   */
  usesAdapter() {
    return this.usesNewGumFlow();
  }
  /**
   * Checks if the browser uses RIDs/MIDs for siganling the simulcast streams
   * to the bridge instead of the ssrcs.
   */
  usesRidsForSimulcast() {
    return !1;
  }
  /**
   * Checks if the browser supports getDisplayMedia.
   * @returns {boolean} {@code true} if the browser supports getDisplayMedia.
   */
  supportsGetDisplayMedia() {
    return typeof navigator.getDisplayMedia != "undefined" || typeof navigator.mediaDevices != "undefined" && typeof navigator.mediaDevices.getDisplayMedia != "undefined";
  }
  /**
   * Checks if the browser supports insertable streams, needed for E2EE.
   * @returns {boolean} {@code true} if the browser supports insertable streams.
   */
  supportsInsertableStreams() {
    if (!(typeof window.RTCRtpSender != "undefined" && (window.RTCRtpSender.prototype.createEncodedStreams || window.RTCRtpSender.prototype.createEncodedVideoStreams)))
      return !1;
    const e = new ReadableStream();
    try {
      return window.postMessage(e, "*", [e]), !0;
    } catch (t) {
      return !1;
    }
  }
  /**
   * Whether the browser supports the RED format for audio.
   */
  supportsAudioRed() {
    return Boolean(window.RTCRtpSender && window.RTCRtpSender.getCapabilities && window.RTCRtpSender.getCapabilities("audio").codecs.some((e) => e.mimeType === "audio/red") && window.RTCRtpReceiver && window.RTCRtpReceiver.getCapabilities && window.RTCRtpReceiver.getCapabilities("audio").codecs.some((e) => e.mimeType === "audio/red"));
  }
  /**
   * Checks if the browser supports the "sdpSemantics" configuration option.
   * https://webrtc.org/web-apis/chrome/unified-plan/
   *
   * @returns {boolean}
   */
  supportsSdpSemantics() {
    return this.isChromiumBased();
  }
  /**
   * Returns the version of a Chromium based browser.
   *
   * @returns {Number}
   */
  _getChromiumBasedVersion() {
    if (this.isChromiumBased()) {
      if (this.isNWJS())
        return Number.parseInt(process.versions.chromium, 10);
      const e = navigator.userAgent;
      if (e.match(/Chrome/))
        return Number.parseInt(e.match(/Chrome\/([\d.]+)/)[1], 10);
    }
    return -1;
  }
  isIOSMobile() {
    return this.isMobile && this._bowser.getOSName() === "iOS";
  }
}
const ae = new Bv(), ip = {
  qvga: { width: { ideal: 320 }, height: { ideal: 240 } },
  vga: { width: { ideal: 640 }, height: { ideal: 480 } },
  hd: { width: { ideal: 1280 }, height: { ideal: 720 } },
  hd_cropped: { width: { ideal: 900 }, height: { ideal: 720 } }
}, cl = {}, qv = [
  { rid: "r0", scalabilityMode: "L1T2" },
  { rid: "r1", scalabilityMode: "L1T2" }
], Gv = [
  {
    active: !1,
    adaptivePtime: !1,
    networkPriority: "low",
    priority: "low"
  },
  {
    active: !1,
    adaptivePtime: !1,
    networkPriority: "low",
    priority: "low"
  },
  {
    active: !0,
    adaptivePtime: !1,
    networkPriority: "low",
    priority: "low",
    maxBitrate: 25e5
  }
], Wv = [
  {
    active: !1,
    priority: "low"
  },
  {
    active: !1,
    priority: "low"
  },
  {
    active: !0,
    priority: "low"
  }
], dl = {
  320: [
    // For QVGA, we can only send the lowest layer.
    {
      rid: "q",
      maxBitrate: 25e4,
      maxFramerate: 30,
      scalabilityMode: "L1T3"
    }
  ],
  640: [
    // For VGA, we can send the lowest and middle layer.
    {
      rid: "q",
      scaleResolutionDownBy: 2,
      maxBitrate: 25e4,
      maxFramerate: 30,
      scalabilityMode: "L1T3"
    },
    {
      rid: "h",
      maxBitrate: 75e4,
      maxFramerate: 30,
      scalabilityMode: "L1T3"
    }
  ],
  1280: [
    // For HD, we can send all the layers but it takes too much bandwidth, so
    // we are sending only the half and quarter layers for now
    {
      rid: "q",
      scaleResolutionDownBy: 4,
      maxBitrate: 25e4,
      maxFramerate: 30,
      scalabilityMode: "L1T3"
    },
    {
      rid: "h",
      scaleResolutionDownBy: 2,
      maxBitrate: 75e4,
      maxFramerate: 30,
      scalabilityMode: "L1T3"
    },
    {
      rid: "f",
      maxBitrate: 15e5,
      maxFramerate: 30,
      scalabilityMode: "L1T3"
    }
  ]
}, Jv = [
  { scalabilityMode: "L3T3_KEY" }
];
var x = /* @__PURE__ */ ((r) => (r.WEBCAM = "webcam", r.MIC = "mic", r.SCREENSHARE_VIDEO = "screenshare_video", r.SCREENSHARE_AUDIO = "screenshare_audio", r))(x || {});
function Kv(r) {
  return r.replace(/([-_]\w)/g, (e) => e[1].toUpperCase());
}
function Wt(r) {
  if (!r || typeof r != "object")
    return r;
  if (Array.isArray(r))
    return r.map((t) => Wt(t));
  const e = {};
  return Object.keys(r).forEach((t) => {
    const s = eu(t) ? t : Kv(t);
    e[s] = Wt(r[t]);
  }), e;
}
function zv(r) {
  return r.replace(/[A-Z]/g, (e) => `_${e.toLowerCase()}`);
}
function np(r) {
  if (!r || typeof r != "object")
    return r;
  if (Array.isArray(r))
    return r.map((t) => np(t));
  const e = {};
  return Object.keys(r).forEach((t) => {
    const s = eu(t) ? t : zv(t);
    e[s] = r[t];
  }), e;
}
function Zo(r, e = {}) {
  return r == null ? {} : (Object.getOwnPropertyNames(r).forEach((t) => {
    if (typeof r[t] != "function") {
      if (typeof r[t] == "object") {
        Zo(r[t], e[t] = {});
        return;
      }
      e[t] = r[t];
    }
  }), e);
}
var Xo = /* @__PURE__ */ ((r) => (r.PARTICIPANT = "PARTICIPANT", r.PEER = "PEER", r.CLIENT = "CLIENT", r))(Xo || {});
const N = {
  INTERNAL_CALL_STATS: "internal_call_stats",
  SIMULCAST: "simulcast",
  CHAT_SOCKET_SERVER: "chat_socket_server",
  POLL_SOCKET_SERVER: "poll_socket_server",
  PLUGIN_SOCKET_SERVER: "plugin_socket_server",
  NR_OTEL_WEB: "nr_otel_web",
  CONNECTED_MEETINGS: "connected_meetings",
  FEAT_SPOTLIGHT: "feat_spotlight",
  ICE_RESTART_ON_FAILED_STATE: "ice_restart_on_failed_state",
  ICE_RESTART_ON_DISCONNECTED_STATE: "ice_restart_on_disconnected_state",
  ENABLE_ICE_STATE_LOGGING: "enable_ice_state_logging",
  REMOVE_OPERATIONAL_MIC: "web_core_remove_operational_mic",
  SUPPRESS_PEER_MUTE_UNMUTE_EMITS: "web_core_suppress_peer_mute_unmute_emits",
  SKIP_OTEL_TRACES: "skip_otel_traces",
  NEW_LOCAL_MEDIA_HANDLER: "new_local_media_handler",
  CALLSTATS_INGESTION_LAYER: "callstats_ingestion_layer",
  USE_USERIDS_IN_CHAT: "use_userids_in_chat",
  CUSTOM_PING_PONG: "custom_ping_pong",
  // NOTE(itzmanish) below flags is added by me
  ENABLE_HIVE_SIMULCAST: "enable_hive_simulcast",
  ENABLE_HIVE_TRANSPORT_RECONNECTION_ON_ICE_FAILED: "enable_hive_transport_reconnection_on_ice_failed",
  BYPASS_LOG_EXCLUSION_LIST: "bypass_log_exclusion_list",
  LOG_LEVEL: "log_level",
  V1_PLUGINS: "v1_plugins",
  SCREENSHARE_DTX: "screenshare_dtx",
  SCREENSHARE_PRIORITY: "screenshare_priority",
  SCREENSHARE_MIN_BITRATE: "screenshare_minbitrate",
  SCREENSHARE_MAX_DIMENSIONS: "screenshare_maxdimensions",
  SCREENSHARE_SIMULCAST: "screenshare_simulcast",
  DISABLE_WEBCAM_LAYERS_ON_SCREENSHARE: "disable_webcam_layers_on_screenshare",
  SCREENSHARE_FORCE_GOOG_CONFERENCE: "screenshare_force_goog_conference",
  LIVESTREAM: "feat_livestream",
  FETCH_RETRY: "fetch_retry",
  DEVICE_REMOVE_EXP: "device_remove_exp",
  DISABLE_WEBCAM_SIMULCAST: "webcore_disable_webcam_simulcast",
  OVERRIDE_WEBCAM_SIMULCAST: "override_webcam_simulcast",
  SOCKET_POLLING: "socket_polling",
  NS_NETWORK_SCORE: "ns_network_score",
  FEAT_PAGINATED_CHAT: "feat_paginated_chat",
  VAL_MIN_FRAMERATE: "val_min_framerate",
  EXTENSION_HACK: "extension_hack",
  VAL_MAX_FRAMERATE_EXT: "val_max_framerate_ext",
  VAL_MIN_FRAMERATE_EXT: "val_min_framerate_ext",
  SCREEENSHARE_ERR_HACK: "screenshare_err_hack",
  TROUBLESHOOTING: "feat_troubleshooting",
  VIDEO_CONSTRAINTS: "video_constraints",
  SCREENSHARE_CONSTRAINTS: "screenshare_constraints"
}, ue = {
  roomName: void 0,
  authToken: void 0,
  peerId: void 0,
  apiBase: void 0,
  defaults: {
    audio: !0,
    video: !0
  },
  modules: void 0,
  organizationId: void 0,
  overrides: {}
};
function Qv(r) {
  var e, t, s, i, n, a, o;
  (e = ue.roomName) != null || (ue.roomName = r == null ? void 0 : r.roomName), (t = ue.authToken) != null || (ue.authToken = r == null ? void 0 : r.authToken), (s = ue.peerId) != null || (ue.peerId = r == null ? void 0 : r.peerId), (i = ue.apiBase) != null || (ue.apiBase = r == null ? void 0 : r.apiBase), (n = ue.modules) != null || (ue.modules = r == null ? void 0 : r.modules), (a = ue.organizationId) != null || (ue.organizationId = r == null ? void 0 : r.organizationId), ue.defaults = { ...ue.defaults, ...(o = r == null ? void 0 : r.defaults) != null ? o : {} };
}
const La = "1.12.4", Yv = z_(), Nt = Wt(
  Yv.config.media
);
var Pn;
class ap {
  constructor(e) {
    b(this, Pn, void 0);
    h(this, "getScreenShareConstraints", () => {
      var s, i;
      const { displaySurface: e } = (s = ue.defaults.screenShare) != null ? s : {};
      let t = {
        width: { max: 1920 },
        height: { max: 1080 },
        frameRate: {
          ideal: parseInt(
            (i = M.getValue(N.VAL_MIN_FRAMERATE)) != null ? i : "5",
            10
          ),
          max: 5
        }
      };
      if (M.hasFeature(N.SCREENSHARE_CONSTRAINTS)) {
        const n = M.getValue(
          N.SCREENSHARE_CONSTRAINTS
        );
        t = JSON.parse(n);
      }
      return e !== void 0 && ["monitor", "browser", "window"].includes(e) && (t = { ...t, displaySurface: e }), {
        audio: !0,
        video: t
      };
    });
    h(this, "getAudioConstraints", (e) => {
      const t = {};
      return ae.isFirefox() || ae.isWebKitBased() ? (t.audio = {
        deviceId: e,
        autoGainControl: !0,
        echoCancellation: !0,
        noiseSuppression: !0
      }, t) : (t.audio = {}, t.audio.optional = [
        e ? { sourceId: e } : { sourceId: "default" },
        { echoCancellation: !0 },
        { googEchoCancellation: !0 },
        { googAutoGainControl: !0 },
        { googNoiseSuppression: !0 },
        { googHighpassFilter: !0 }
      ], t);
    });
    h(this, "getVideoConstraints", (e) => {
      const t = {}, { quality: s } = c(this, Pn).video;
      let i = ip[s];
      if (i.frameRate = {
        ideal: 24
      }, ae.isChromiumBased() && (i.frameRate.max = 30), M.hasFeature(N.VIDEO_CONSTRAINTS)) {
        const n = M.getValue(
          N.VIDEO_CONSTRAINTS
        );
        i = JSON.parse(n);
      }
      return t.video = i, e ? t.video.deviceId = { exact: e } : t.video.facingMode = "user", t;
    });
    P(this, Pn, e != null ? e : Nt);
  }
}
Pn = new WeakMap();
var Zv = /\s/;
function Xv(r) {
  for (var e = r.length; e-- && Zv.test(r.charAt(e)); )
    ;
  return e;
}
var eT = /^\s+/;
function tT(r) {
  return r && r.slice(0, Xv(r) + 1).replace(eT, "");
}
var ll = 0 / 0, sT = /^[-+]0x[0-9a-f]+$/i, rT = /^0b[01]+$/i, iT = /^0o[0-7]+$/i, nT = parseInt;
function ul(r) {
  if (typeof r == "number")
    return r;
  if (G_(r))
    return ll;
  if (pr(r)) {
    var e = typeof r.valueOf == "function" ? r.valueOf() : r;
    r = pr(e) ? e + "" : e;
  }
  if (typeof r != "string")
    return r === 0 ? r : +r;
  r = tT(r);
  var t = rT.test(r);
  return t || iT.test(r) ? nT(r.slice(2), t ? 2 : 8) : sT.test(r) ? ll : +r;
}
var aT = function() {
  return as.Date.now();
};
const Oo = aT;
var oT = "Expected a function", cT = Math.max, dT = Math.min;
function lT(r, e, t) {
  var s, i, n, a, o, d, p = 0, l = !1, u = !1, m = !0;
  if (typeof r != "function")
    throw new TypeError(oT);
  e = ul(e) || 0, pr(t) && (l = !!t.leading, u = "maxWait" in t, n = u ? cT(ul(t.maxWait) || 0, e) : n, m = "trailing" in t ? !!t.trailing : m);
  function g(pe) {
    var st = s, rt = i;
    return s = i = void 0, p = pe, a = r.apply(rt, st), a;
  }
  function T(pe) {
    return p = pe, o = setTimeout(D, e), l ? g(pe) : a;
  }
  function S(pe) {
    var st = pe - d, rt = pe - p, gt = e - st;
    return u ? dT(gt, n - rt) : gt;
  }
  function R(pe) {
    var st = pe - d, rt = pe - p;
    return d === void 0 || st >= e || st < 0 || u && rt >= n;
  }
  function D() {
    var pe = Oo();
    if (R(pe))
      return I(pe);
    o = setTimeout(D, S(pe));
  }
  function I(pe) {
    return o = void 0, m && s ? g(pe) : (s = i = void 0, a);
  }
  function re() {
    o !== void 0 && clearTimeout(o), p = 0, s = d = i = o = void 0;
  }
  function ge() {
    return o === void 0 ? a : I(Oo());
  }
  function Me() {
    var pe = Oo(), st = R(pe);
    if (s = arguments, i = this, d = pe, st) {
      if (o === void 0)
        return T(d);
      if (u)
        return clearTimeout(o), o = setTimeout(D, e), g(d);
    }
    return o === void 0 && (o = setTimeout(D, e)), a;
  }
  return Me.cancel = re, Me.flush = ge, Me;
}
var uT = "[object Map]", pT = "[object Set]", hT = Object.prototype, mT = hT.hasOwnProperty;
function fT(r) {
  if (r == null)
    return !0;
  if (Cc(r) && (oo(r) || typeof r == "string" || typeof r.splice == "function" || bc(r) || Cu(r) || wu(r)))
    return !r.length;
  var e = lo(r);
  if (e == uT || e == pT)
    return !r.size;
  if (co(r))
    return !Iu(r).length;
  for (var t in r)
    if (mT.call(r, t))
      return !1;
  return !0;
}
function ga(r) {
  const e = {};
  return typeof (r == null ? void 0 : r.code) == "number" && (e.code = r.code), typeof (r == null ? void 0 : r.code) == "string" && (e.code = r.code.substring(0, 100)), typeof (r == null ? void 0 : r.name) == "string" && (e.name = r.name.substring(0, 500)), typeof (r == null ? void 0 : r.message) == "string" && (e.message = r.message.substring(0, 500)), typeof (r == null ? void 0 : r.reason) == "string" && (e.reason = r.reason.substring(0, 500)), typeof (r == null ? void 0 : r.stack) == "string" && (e.stack = r.stack.substring(0, 500)), e;
}
function _a() {
  var t, s, i, n;
  const r = typeof navigator != "undefined" && !navigator.isReactNative && ((t = window.location.host) == null ? void 0 : t.includes("staging")) && ((s = window.location.host) == null ? void 0 : s.includes("dyte.io")), e = !!((n = (i = ue.modules) == null ? void 0 : i.devTools) != null && n.logs);
  return r || e;
}
function gT(r) {
  if (M.hasFeature(N.LOG_LEVEL)) {
    let e = M.getValue(N.LOG_LEVEL) || "all";
    if (e = e.toLowerCase().trim(), e === "off")
      return !1;
    if (e !== "all") {
      const t = ["debug", "log", "info", "warn", "error"], s = t.indexOf(r), i = t.indexOf(e);
      if (s < i)
        return !1;
    }
  }
  return !0;
}
function op(r, e, t = {}) {
  return Object.getOwnPropertyNames(r).forEach((s) => {
    var n;
    if ([null, void 0, NaN].includes(r[s]) || e && (((n = e.match(/\./g)) == null ? void 0 : n.length) || 0) >= 10)
      return;
    const i = e ? `${e}.${s}` : s;
    typeof r[s] == "object" ? op(r[s], i, t) : ["number", "string", "boolean"].includes(typeof r[s]) && (t[i] = r[s]);
  }), t;
}
function No(r, e = {}, t) {
  const s = {};
  try {
    const i = JSON.stringify(e), n = JSON.parse(i), a = op(n, t), o = JSON.stringify(a);
    if (o.length > 5e3) {
      const d = `Log named: "${r}" is trying to log an flattened object of size ${o.length} chars that is beyond permitted limit of 5000 chars. Please optimize.`;
      throw _a() && console.error(
        d,
        { log: e, flattened: o }
      ), new Error(d);
    }
    return JSON.parse(o);
  } catch (i) {
    const n = ga(i);
    s[`${t}.error.message`] = n.message || "", s[`${t}.error.stack`] = n.stack || "", s[`${t}.error.reason`] = n.reason || "", s[`${t}.error.source`] = "safelyFlattenObjForOpenTelemetry";
  }
  return s;
}
const ee = class {
  static get logsEndpoint() {
    return _a() ? "https://api-silos-staging.dyte.io/otel/logs" : "https://api-silos.dyte.io/otel/logs";
  }
  static init(e, t) {
    if (navigator.isReactNative)
      return;
    const s = new nh({
      url: "https://otel.dyte.io/v1/traces",
      headers: {
        "api-key": ""
      }
    });
    let i = _a() ? "staging" : "production";
    const n = new rh({
      resource: new dh({
        "service.name": "web-core",
        sdk_version: La,
        env: i,
        ...No("OTELResource", ae.getDeviceInfo(), "device")
      }),
      idGenerator: {
        generateTraceId: () => `${e}`.replace(/-/g, ""),
        generateSpanId: () => so().replace(/-/g, "").substring(0, 16)
      }
    });
    ee.tracingEnabled = t, ee.tracer = n.getTracer(e), ee.meetingMetadata.peerId = e, ee.meetingMetadata.sdkVersion = La, ee.meetingMetadata.deviceInfo = ae.getDeviceInfo(), ee.meetingMetadata.visitedUrl = !navigator.isReactNative && typeof window != "undefined" && window.location.href, n.addSpanProcessor(new ah(s)), "zone" in window ? n.register({
      contextManager: new oh()
      // Zone is required to keep async calls in the same trace
    }) : n.register({
      contextManager: new ih()
    }), ee.contextPropagator = ch, document.addEventListener("visibilitychange", ee.processCachedLogs), ee.logsProcessorTimer = setInterval(
      ee.processCachedLogs,
      ee.logsProcessingInterval
    ), t && (ee.rootSpan = ee.tracer.startSpan(`peer_${e}`, {}, bo), ee.rootSpan.end(), ee.initialized = !0);
  }
  static trace(e) {
    return (t, s, i) => {
      const n = i.value;
      return i.value = function(...o) {
        if (!ee.initialized || navigator.isReactNative || !ee.tracingEnabled || M.hasFeature(N.SKIP_OTEL_TRACES))
          return n.apply(this, o);
        const d = ee.getCurrentSpan(), p = da.trace.setSpan(bo, d);
        return M.hasFeature(N.NR_OTEL_WEB) || ee.addLogInCurrentSpan("info", e), ee.tracer.startActiveSpan(e, {}, p, (l) => {
          const u = n.apply(this, o);
          return Promise.resolve(u).then(() => {
            l.end();
          }).catch(() => {
            l.end();
          }), u;
        });
      }, i;
    };
  }
  static getCurrentSpan() {
    if (navigator.isReactNative)
      return null;
    let e = da.trace.getSpan(da.context.active());
    return e != null || (e = ee.rootSpan), e;
  }
  static getCurrentContext() {
    return da.trace.setSpan(bo, ee.getCurrentSpan());
  }
  static getCurrentSpanName() {
    var e;
    return (e = this.getCurrentSpan()) == null ? void 0 : e.name;
  }
  static injectContext(e) {
    ee.getCurrentSpan() && ee.contextPropagator.inject(
      ee.getCurrentContext(),
      e
    );
  }
  /**
   * Adds event into the current span or the main span.
   * Event(or this method) is not a replacement for a log.
   * Tip :: Heavy objects should be logged.
   * Tip :: Light objects with `to the point` info should be added as events.
   * @param eventSeverity severity of the passed event to create better dashboards
   * @param eventName name of event in format
   *  fileName::functionName::eventName or functionName::eventName or whatever seems fit
   * @param metadata pass any information which makes sense for analytics or debugging
   * @param noCache optionally pass if log can be cached in FE or it has to be sent instantly
   * @returns nothing
   */
  static addLogInCurrentSpan(e = "info", t, s = {}, i) {
    var a, o;
    if (s != null && s.error && Object.assign(s, { error: ga(s.error) }), _a() && (fT(s) ? console[e]("DyteInternalLogs:: ", e, t) : console[e]("DyteInternalLogs:: ", e, t, s)), !!gT(e))
      try {
        const d = No(t, s, "metadata"), p = ee.getCurrentSpan(), l = new Date(), u = {
          message: t,
          level: e,
          ...d,
          "trace.id": (a = p == null ? void 0 : p.spanContext()) == null ? void 0 : a.traceId,
          "span.id": (o = p == null ? void 0 : p.spanContext()) == null ? void 0 : o.spanId,
          loggedAt: l.toISOString(),
          loggedAtTzOffset: l.getTimezoneOffset()
        };
        i ? ee.sendOtelLogsToNewRelic([u]) : ee.logsCache.push(u);
      } catch (d) {
        ee.addLogInCurrentSpan("error", "opentelemetry::addLogInCurrentSpan_failed", {
          error: ga(d)
        });
      }
  }
  static sendOtelLogsToNewRelic(e) {
    Pa.post(ee.logsEndpoint, {
      meetingMetadata: No("sendOtelLogsToNewRelic", ee.meetingMetadata, "meetingMetadata"),
      serviceName: "web-core",
      logs: e
    }).catch((t) => {
      ee.addLogInCurrentSpan("error", "opentelemetry::sendOtelLogToNewRelic_failed", {
        error: ga(t)
      }), ee.logsCache.push(...e);
    });
  }
  static processCachedLogs() {
    const e = ee.logsCache.splice(0, 25);
    e != null && e.length && ee.sendOtelLogsToNewRelic(e);
  }
  static destruct() {
    clearInterval(ee.logsProcessorTimer), ee.processCachedLogs(), !navigator.isReactNative && document.removeEventListener("visibilitychange", ee.processCachedLogs);
  }
};
let _ = ee;
h(_, "tracer"), h(_, "contextPropagator"), h(_, "rootSpan"), h(_, "logsCache", []), h(_, "logsProcessorTimer"), h(_, "tracingEnabled", !0), h(_, "initialized", !1), /**
 * NOTE(ravindra-dyte)
 * Periodically send logs to Log Aggregator. Current period: 7 secs
 */
h(_, "logsProcessingInterval", 7e3), h(_, "logExclusionList", [
  "message",
  "websocket/message",
  "roomMessage",
  "websocket/room-message",
  "websocket/room-legacy-mode",
  "chatMessage",
  "websocket/new-chat-message",
  "websocket/no-active-speaker",
  "websocket/selected-peers",
  "websocket/active-speaker",
  "ping",
  "websocket/new-consumer",
  "websocket/producer-score",
  "websocket/consumer-score",
  "websocket/plugin-event",
  "websocket/plugin-data",
  "websocket/plugin-internal-data"
]), h(_, "meetingMetadata", {});
class f {
  static info(e, t, s) {
    _.addLogInCurrentSpan("info", e, t, s);
  }
  static error(e, t, s) {
    _.addLogInCurrentSpan("error", e, t, s);
  }
  static debug(e, t, s) {
    _.addLogInCurrentSpan("debug", e, t, s);
  }
  static log(e, t, s) {
    _.addLogInCurrentSpan("log", e, t, s);
  }
  static warn(e, t, s) {
    _.addLogInCurrentSpan("warn", e, t, s);
  }
}
const _T = {
  "00": "DyteClient",
  "01": "Controller",
  "02": "RoomNodeClient",
  "03": "HiveNodeClient",
  "04": "SocketService",
  "05": "Chat",
  "06": "Plugin",
  "07": "Polls",
  "08": "Meta",
  "09": "Preset",
  10: "Recording",
  11: "Self",
  12: "Participant",
  13: "Spotlight",
  14: "Remote Request",
  15: "Webinar",
  16: "LocalMediaHandler"
}, va = {
  "0000": "Internal exception.",
  "0001": "Failed to initialize.",
  "0002": "Failed to join room.",
  "0003": "Failed to leave room.",
  "0100": "Internal exception",
  "0200": "Internal exception.",
  "0300": "Internal exception",
  "0400": "Internal exception",
  "0500": "Internal exception",
  "0501": "Permission denied.",
  "0502": "Invalid message body.",
  "0600": "Internal exception",
  "0700": "Internal exception",
  "0800": "Internal exception",
  "0900": "Internal exception",
  1e3: "Internal exception",
  1100: "Internal exception",
  1200: "Internal exception",
  1300: "Internal exception",
  1400: "Internal exception",
  1500: "Internal exception",
  1600: "Internal exception",
  1601: "Failed to get audio track",
  1602: "Failed to get video track",
  1603: "Incorrect device",
  1604: "Failed to change device"
};
Object.keys(va).forEach((r) => {
  va[r] = `{${_T[r.slice(0, 2)]}} ${va[r]}`;
});
class E extends Error {
  constructor(t, s, i = !1) {
    super(t);
    h(this, "code");
    this.code = s, this.name = "DyteError", this.message = `[ERR${this.code}]: ${va[this.code]}
${this.message}`;
    try {
      let n = i;
      s && s.endsWith("00") && (n = !0), n && f.error("DyteError", { error: { message: this.message, name: this.name, code: s } });
    } catch (n) {
    }
  }
}
function la(r, e, t, s) {
  if (typeof t == "function" && s instanceof e)
    t.call(null, s, r);
  else
    throw s;
}
function pl(r, e, t) {
  if (!r.value) {
    const i = r.get, n = r.set;
    return i && (r.get = function() {
      try {
        return i.apply(this);
      } catch (a) {
        la(this, e, t, a);
      }
    }), n && (r.set = function(a) {
      try {
        return n.apply(this, [a]);
      } catch (o) {
        la(this, e, t, o);
      }
    }), r;
  }
  const s = r.value;
  return r.value = function(...i) {
    try {
      const n = s.apply(this, i);
      return n && n instanceof Promise ? n.catch((a) => {
        la(this, e, t, a);
      }) : n;
    } catch (n) {
      la(this, e, t, n);
    }
  }, r;
}
function vT(r, e) {
  return (t, s, i) => {
    if (i)
      return pl(i, r, e);
    for (const n of Reflect.ownKeys(t.prototype).filter((a) => a !== "constructor")) {
      const a = Object.getOwnPropertyDescriptor(t.prototype, n);
      (a.value instanceof Function || a.get instanceof Function || a.set instanceof Function) && Object.defineProperty(
        t.prototype,
        n,
        pl(a, r, e)
      );
    }
  };
}
const ft = (r) => vT(Error, r);
var wr = /* @__PURE__ */ ((r) => (r.allowed = "ALLOWED", r.notAllowed = "NOT_ALLOWED", r.canRequest = "CAN_REQUEST", r))(wr || {});
const TT = {
  view_type: is.GroupCall,
  accept_waiting_requests: !1,
  request_produce: !1,
  can_allow_participant_audio: !0,
  can_allow_participant_screensharing: !1,
  can_allow_participant_video: !0,
  request_kick_participant: !1,
  kick_participant: !0,
  pin_participant: !0,
  can_record: !1,
  waiting_room_type: "SKIP",
  plugins: {
    can_close: !0,
    can_start: !0,
    can_edit_acl: !1,
    config: {}
  },
  polls: {
    can_create: !0,
    can_vote: !0,
    can_view: !0
  },
  produce: {
    video: {
      allow: !0,
      quality: Nt.video.quality,
      frame_rate: Nt.video.frameRate
    },
    audio: !0,
    screenshare: {
      allow: !0,
      quality: Nt.screenshare.quality,
      frame_rate: Nt.screenshare.frameRate
    }
  },
  chat: {
    public: {
      can_send: !0,
      text: !0,
      files: !0
    },
    private: {
      can_send: !1,
      can_receive: !1,
      text: !1,
      files: !1
    }
  },
  reactions: !1,
  hidden_participant: !1,
  show_participant_list: !0,
  can_change_participant_role: !0,
  can_change_theme: !1,
  can_present: !1,
  accept_present_requests: !1,
  can_edit_display_name: !1,
  max_screenshare_count: 1,
  is_recorder: !1,
  can_spotlight: !1
}, yT = Wt(TT);
var Z;
const Ga = class {
  constructor(e) {
    b(this, Z, void 0);
    if (!e)
      throw f.error("DytePermissionsPresetV1::load_preset_permissions_failed"), new E("Could not load preset permissions.");
    P(this, Z, e);
  }
  static fromResponse(e) {
    return new Ga(e);
  }
  static default() {
    return new Ga(yT);
  }
  /**
   * @deprecated in favour of `suggestedTheme.viewType`
   * The `viewType` tells the type of the meeting
   * possible values are WEBINAR, GROUP_CALL
   */
  get viewType() {
    return c(this, Z).viewType;
  }
  /**
   * The `acceptWaitingRequests` returns boolean value.
   * If `true`, participant can accept the request of waiting participant.
   */
  get acceptWaitingRequests() {
    return c(this, Z).acceptWaitingRequests;
  }
  /**
   * @deprecated
   * The `requestProduce` returns boolean value.
   * If `true`, participant can send request to participants
   * about producing audio, video or screenshare.
   */
  get requestProduce() {
    return c(this, Z).requestProduce;
  }
  /**
   * The `requestProduceAudio` returns boolean value.
   * If `true`, participant can send request to participants
   * about producing audio.
  */
  get requestProduceAudio() {
    return this.requestProduce;
  }
  /**
   * The `requestProduceScreenshare` returns boolean value.
   * If `true`, participant can send request to participants
   * about sharing screen.
  */
  get requestProduceScreenshare() {
    return this.requestProduce;
  }
  /**
   * The `canAllowParticipantAudio` returns boolean value.
   * If `true`, participant can enable other participants` audio.
   */
  get canAllowParticipantAudio() {
    return c(this, Z).canAllowParticipantAudio;
  }
  /**
   * The `canAllowParticipantScreensharing` returns boolean value.
   * If `true`, participant can enable other participants` screen share.
   */
  get canAllowParticipantScreensharing() {
    return c(this, Z).canAllowParticipantScreensharing;
  }
  /**
   * The `canAllowParticipantVideo` returns boolean value.
   * If `true`, participant can enable other participants` video.
   */
  get canAllowParticipantVideo() {
    return c(this, Z).canAllowParticipantVideo;
  }
  /**
   * If `true`, a participant can disable other participants` audio.
   */
  get canDisableParticipantAudio() {
    return this.canAllowParticipantAudio;
  }
  /**
   * If `true`, a participant can disable other participants` video.
   */
  get canDisableParticipantVideo() {
    return this.canAllowParticipantVideo;
  }
  /**
   * The `kickParticipant` returns boolean value.
   * If `true`, participant can remove other participants from the meeting.
   */
  get kickParticipant() {
    return c(this, Z).kickParticipant;
  }
  /**
   * The `pinParticipant` returns boolean value.
   * If `true`, participant can pin a participant in the meeting.
   */
  get pinParticipant() {
    return c(this, Z).pinParticipant;
  }
  /**
   * The `canRecord` returns boolean value.
   * If `true`, participant can record the meeting.
   */
  get canRecord() {
    return c(this, Z).canRecord;
  }
  /**
   * * @deprecated in favour of `waitingRoomBehaviour`.
   * The `waitingRoomType` returns string value.
   * type of waiting room behavior
   * possible values are `SKIP_ON_ACCEPT`, `ON_ACCEPT`, `SKIP_ON_PRIVILEGED_USER_ENTRY`
   */
  get waitingRoomType() {
    return c(this, Z).waitingRoomType;
  }
  /**
   * The `waitingRoomType` returns string value.
   * type of waiting room behavior
   * possible values are `SKIP`, `ON_PRIVILEGED_USER_ENTRY`, `SKIP_ON_ACCEPT`
  */
  get waitingRoomBehaviour() {
    return c(this, Z).waitingRoomType === "SKIP" ? "SKIP" : c(this, Z).waitingRoomType === "SKIP_ON_PRIVILEGED_USER_ENTRY" ? "ON_PRIVILEGED_USER_ENTRY" : c(this, Z).waitingRoomType === "ON_ACCEPT" ? "SKIP_ON_ACCEPT" : "SKIP";
  }
  /**
   * The `plugins` tells if the participant can act on plugins
   * there are 2 permissions with boolean values, `canStart` and `canClose`.
   */
  get plugins() {
    return c(this, Z).plugins;
  }
  /**
   * The `polls` tells if the participant can use polls.
   * There are 3 permissions with boolean values, `canCreate`, `canVote`, `canView`
   */
  get polls() {
    return { ...c(this, Z).polls, canViewResults: c(this, Z).polls.canView };
  }
  /**
   * @deprecated in favour of `canProduceVideo`
   * The `produceVideo` shows permissions for enabling video for the participant.
   * There are 3 permissions
   * `allow` - if video is allowed
   * `quality` - quality of the video
   * `frameRate` - frame rate of the video
   */
  get produceVideo() {
    return {
      ...c(this, Z).produce.video,
      allow: c(this, Z).produce.video.allow ? "ALLOWED" : "NOT_ALLOWED"
      /* notAllowed */
    };
  }
  /**
   * The `canProduceVideo` shows permissions for enabling video.
   * There possible values are `ALLOWED`, `NOT_ALLOWED`, `CAN_REQUEST`
  */
  get canProduceVideo() {
    const e = c(this, Z).produce.video.allow;
    return this.requestProduce ? "CAN_REQUEST" : e ? "ALLOWED" : "NOT_ALLOWED";
  }
  /**
   * @deprecated
   * The `produceScreenshare` shows permissions for enabling screen share for the participant.
   * There are 3 permissions
   * `allow` - if sharing screen is allowed
   * `quality` - quality of the video
   * `frameRate` - frame rate of the video
   */
  get produceScreenshare() {
    return {
      ...c(this, Z).produce.screenshare,
      allow: c(this, Z).produce.screenshare.allow ? "ALLOWED" : "NOT_ALLOWED"
      /* notAllowed */
    };
  }
  /**
   * The `canProduceScreenshare` shows permissions for sharing screen.
   * There possible values are `ALLOWED`, `NOT_ALLOWED`, `CAN_REQUEST`
  */
  get canProduceScreenshare() {
    const e = c(this, Z).produce.screenshare.allow;
    return this.requestProduce ? "CAN_REQUEST" : e ? "ALLOWED" : "NOT_ALLOWED";
  }
  /**
   * @deprecated in favour of `canProduceAudio`
   * The `produceAudio` shows permissions for enabling audio for the participant.
   * If true, participant can enable audio.
   */
  get produceAudio() {
    return c(this, Z).produce.audio ? "ALLOWED" : "NOT_ALLOWED";
  }
  /**
   * The `canProduceAudio` shows permissions for enabling audio.
   * There possible values are `ALLOWED`, `NOT_ALLOWED`, `CAN_REQUEST`
  */
  get canProduceAudio() {
    const e = c(this, Z).produce.audio;
    return this.requestProduce ? "CAN_REQUEST" : e ? "ALLOWED" : "NOT_ALLOWED";
  }
  /**
   * The `chatPublic` shows permissions for public chat
   * there are 4 permissions
   * `canSend` - if true, the participant can send chat
   * `text` - if true, the participant can send text
   * `files` - if true, the participant can send files
   */
  get chatPublic() {
    return c(this, Z).chat.public;
  }
  /**
   * The `chatPrivate` shows permissions for public chat
   * there are 4 permissions
   * `canSend` - if true, the participant can send private chat
   * `text` - if true, the participant can send text as private chat
   * `files` - if true, the participant can send files as private chat
   * `canReceive` - (optional) if true, the participant can receive private chat
   */
  get chatPrivate() {
    return c(this, Z).chat.private;
  }
  // eslint-disable-next-line class-methods-use-this
  get connectedMeetings() {
    return {
      canAlterConnectedMeetings: !1,
      canSwitchConnectedMeetings: !1,
      canSwitchToParentMeeting: !1
    };
  }
  /**
   * @deprecated
   * The `reactions` returns boolean value.
   * If `true`, reactions are enabled for the participant
   */
  get reactions() {
    return c(this, Z).reactions;
  }
  /**
   * The `hiddenParticipant` returns boolean value.
   * If `true`, participant is hidden.
   */
  get hiddenParticipant() {
    return c(this, Z).hiddenParticipant;
  }
  /**
   * The `showParticipantList` returns boolean value.
   * If `true`, participant list can be shown to the participant.
   */
  get showParticipantList() {
    return c(this, Z).showParticipantList;
  }
  /**
   * The `canChangeParticipantRole` returns boolean value.
   * If `true`, allow changing the participants' role.
   */
  get canChangeParticipantRole() {
    return c(this, Z).canChangeParticipantRole;
  }
  /**
   * @deprecated
   * The `canChangeTheme` returns boolean value.
   * If `true`, the participant can change the meeting theme.
   */
  get canChangeTheme() {
    return c(this, Z).canChangeTheme;
  }
  /**
   * @deprecated
   * The `canPresent` returns boolean value.
   * If `true`, the participant can become a presentor.
   */
  get canPresent() {
    return c(this, Z).canPresent;
  }
  get acceptPresentRequests() {
    return c(this, Z).acceptPresentRequests;
  }
  get canEditDisplayName() {
    return c(this, Z).canEditDisplayName;
  }
  /**
  * @deprecated in favour of `suggestedTheme.maxScreenShareCount`
  */
  get maxScreenShareCount() {
    return c(this, Z).maxScreenshareCount;
  }
  get isRecorder() {
    return c(this, Z).isRecorder;
  }
  /**
   * NOTE(callmetarush): This will always return false and should onlu
   * be used to not have to convert presets.
   */
  // eslint-disable-next-line class-methods-use-this
  get canLivestream() {
    return !1;
  }
  get canSpotlight() {
    return c(this, Z).canSpotlight;
  }
  // eslint-disable-next-line class-methods-use-this
  get isV2() {
    return !1;
  }
};
let xa = Ga;
Z = new WeakMap();
const te = {
  isV2AuthToken: !1,
  meetingId: null,
  overrides: {},
  roomNodeOptions: void 0
}, dn = {
  baseURL: "http://localhost:5000",
  createdAt: "2021-08-05T10:49:56.602Z",
  description: "Develop plugins locally",
  id: "09259e3b-7be8-46f6-9801-106bf1866e1c",
  name: "Localhost Dev",
  organizationId: "4ad15a19-80e2-4105-bf43-48039fd2963e",
  picture: "https://dyte-uploads.s3.ap-south-1.amazonaws.com/dyte.png",
  private: !1,
  published: !0,
  staggered: !1,
  tags: ["#localhost", "#dev"],
  type: "self_hosted",
  updatedAt: "2021-08-05T10:50:07.681Z"
};
function ET(r, e) {
  if (e) {
    te.isV2AuthToken = !1;
    return;
  }
  try {
    const { meetingId: t } = JSON.parse(atob(r.split(".")[1]));
    if (!t)
      throw Error(`Received V1 auth token ${r}`);
    te.isV2AuthToken = !0, te.meetingId = t;
  } catch (t) {
    throw f.error("constants::setIsV2AuthToken", {
      error: t,
      debuggingHint: `Unable to decode auth token: ${r}`
    }, !0), new E("Invalid auth token");
  }
}
function cp(r, e) {
  if (te.isV2AuthToken && M.hasFeature(N.CONNECTED_MEETINGS))
    return !0;
  const t = M.getValue(
    N.CHAT_SOCKET_SERVER
  ) || "socket-service", s = M.getValue(
    N.PLUGIN_SOCKET_SERVER
  ) || "socket-service", i = M.getValue(
    N.POLL_SOCKET_SERVER
  ) || "socket-service";
  return te.isV2AuthToken && r === is.Livestream || [t, s, i].includes("socket-service") || e.includes("HIVE");
}
function ST(r) {
  te.overrides = r;
}
function En(r) {
  return te.overrides && te.overrides[r] ? te.overrides[r] : !1;
}
function wT(r) {
  te.roomNodeOptions = r;
}
var jc = /* @__PURE__ */ ((r) => (r.REQUESTED_BY_PARTICIPANT = "REQUESTED_BY_PARTICIPANT", r.REQUESTED_BY_MODERATOR = "REQUESTED_BY_MODERATOR", r))(jc || {}), $c = /* @__PURE__ */ ((r) => (r.PRESENT = "REQUEST_TO_PRESENT", r))($c || {}), Ps, Cs;
class RT extends bt.EventEmitter {
  constructor() {
    super();
    b(this, Ps, void 0);
    b(this, Cs, void 0);
    h(this, "asyncPromiseTimeout");
    P(this, Ps, /* @__PURE__ */ new Map()), P(this, Cs, /* @__PURE__ */ new Map()), this.asyncPromiseTimeout = 8e3;
  }
  async emitAsync(t, ...s) {
    c(this, Ps).set(t, []);
    const i = c(this, Cs).get(t).map(() => new Promise((n) => {
      c(this, Ps).get(t).push(n);
    }));
    super.emit(t, ...s), await Promise.race([
      Promise.all(i),
      new Promise((n, a) => setTimeout(() => a(new Error("emitAsync failed to resolve.")), this.asyncPromiseTimeout))
    ]), c(this, Ps).delete(t);
  }
  onAsync(t, s) {
    const i = c(this, Ps), n = async (...a) => {
      var d;
      try {
        await s(...a);
      } catch (p) {
        f.error("[onAsync]", { error: p });
      }
      const o = (d = i.get(t)) == null ? void 0 : d.shift();
      o == null || o();
    };
    return c(this, Cs).get(t) || c(this, Cs).set(t, []), c(this, Cs).get(t).push(n), super.on(t, n);
  }
  /**
   * removes all attached listeners
   */
  reset() {
    P(this, Ps, /* @__PURE__ */ new Map()), P(this, Cs, /* @__PURE__ */ new Map()), super.removeAllListeners();
  }
}
Ps = new WeakMap(), Cs = new WeakMap();
const y = new RT();
var v = /* @__PURE__ */ ((r) => (r.NEW_PRODUCER = "NEW_PRODUCER", r.ROOM_NODE_CONNECTED = "ROOM_NODE_CONNECTED", r.ROOM_NODE_DISCONNECTED = "ROOM_NODE_DISCONNECTED", r.ROOM_NODE_CONNECTION_ERROR = "ROOM_NODE_CONNECTION_ERROR", r.SOCKET_SERVICE_CONNECTED = "SOCKET_SERVICE_CONNECTED", r.SOCKET_SERVICE_DISCONNECTED = "SOCKET_SERVICE_DISCONNECTED", r.SOCKET_SERVICE_RECONNECTING = "SOCKET_SERVICE_RECONNECTING", r.SOCKET_SERVICE_RECONNECTION_ATTEMPT = "SOCKET_SERVICE_RECONNECTION_ATTEMPT", r.SOCKET_SERVICE_RECONNECT_FAILURE = "SOCKET_SERVICE_RECONNECT_FAILURE", r.SOCKET_SERVICE_RECONNECTED = "SOCKET_SERVICE_RECONNECTED", r.SOCKET_SERVICE_FAILED = "SOCKET_SERVICE_FAILED", r.ROOM_JOINED = "ROOM_JOINED", r.SOCKET_SERVICE_ROOM_JOINED = "SOCKET_SERVICE_ROOM_JOINED", r.SELF_ROOM_JOINED = "SELF_ROOM_JOINED", r.PRODUCER_SCORE_UPDATE = "PRODUCER_SCORE_UPDATE", r.CONSUMER_SCORE_UPDATE = "CONSUMER_SCORE_UPDATE", r.PRODUCER_STATUS_UPDATE = "PRODUCER_STATUS_UPDATE", r.CONSUMER_STATUS_UPDATE = "CONSUMER_STATUS_UPDATE", r.LOW_PRODUCER_SCORE = "LOW_PRODUCER_SCORE", r.LOW_CONSUMER_SCORE = "LOW_CONSUMER_SCORE", r.MEDIA_PERMISSION_ERROR = "MEDIA_PERMISSION_ERROR", r.MEDIA_PERMISSION_UPDATE = "MEDIA_PERMISSION_UPDATE", r.WAITLISTED = "WAIT_LISTED", r.WAITLIST_ACCEPTED = "websocket/waitlist-accepted", r.WAITLIST_REJECTED = "websocket/waitlist-rejected", r.WAITLIST_PEER_ADDED = "websocket/waitlist-peer-added", r.WAITLIST_PEER_REMOVED = "websocket/waitlist-peer-closed", r.MESSAGE = "websocket/message", r.ROOM_MESSAGE = "websocket/room-message", r.DISABLE_AUDIO = "websocket/disable-audio", r.DISABLE_VIDEO = "websocket/disable-video", r.PEER_JOINED = "websocket/peer-joined", r.PEER_CLOSED = "websocket/peer-closed", r.PEER_MUTED = "websocket/peer-muted", r.PEER_UNMUTED = "websocket/peer-unmuted", r.PEER_PINNED = "websocket/pin-peer", r.PEER_UNPINNED = "websocker/unpin-peer", r.MUTE_ALL = "websocket/mute-all", r.MUTE_ALL_VIDEO = "websocket/mute-all-video", r.CONSUMER_CLOSED = "websocket/consumer-closed", r.CONSUMER_PAUSED = "websocket/consumer-paused", r.CONSUMER_RESUMED = "websocket/consumer-resumed", r.PRODUCER_CLOSED = "websocket/producer-closed", r.NEW_CONSUMER = "websocket/new-consumer", r.CONNECTED_MEETING_STATE = "websocket/connectedMeetingState", r.MOVE_TO_CONNECTED_MEETING = "websocket/transferMeeting", r.GET_CHAT_MESSAGES = "websocket/get-chat-messages", r.NEW_CHAT_MESSAGE = "websocket/new-chat-message", r.PIN_CHAT_MESSAGE = "websocket/pin-chat-message", r.UNPIN_CHAT_MESSAGE = "websocket/unpin-chat-message", r.GET_POLLS = "websocket/get-polls", r.UPDATE_POLL = "websocket/update-poll", r.SELECTED_PEERS = "websocket/selected-peers", r.GET_PAGE = "websocket/get-page", r.ACTIVE_SPEAKER = "websocket/active-speaker", r.NO_ACTIVE_SPEAKER = "websocket/no-active-speaker", r.PRODUCER_SCORE = "websocket/producer-score", r.CONSUMER_SCORE = "websocket/consumer-score", r.ENABLE_PLUGIN = "websocket/enable-plugin", r.DISABLE_PLUGIN = "websocket/disable-plugin", r.PLUGIN_EVENT = "websocket/plugin-event", r.PLUGIN_DATA = "websocket/plugin-data", r.PLUGIN_INTERNAL_DATA = "websocket/plugin-internal-data", r.KICKED = "websocket/kicked", r.RECORDING_STARTED = "websocket/recording-started", r.RECORDING_STOPPED = "websocket/recording-stopped", r.ICE_CONNECTED = "ICE_CONNECTED", r.ICE_DISCONNECTED = "ICE_DISCONNECTED", r.ICE_FAILED = "ICE_FAILED", r.ICE_RECONNECTING = "ICE_RECONNECTING", r.PRODUCER_TOGGLE = "hive/producer-toggle", r.CONSUMER_TOGGLE = "hive/consumer-toggle", r.SELECTED_PEERS_DIFF = "hive/selected-peers-diff", r.REFRESH_GRID = "hive/refresh-grid", r.RESET_PRODUCER_STATE = "hive/reset-producer-state", r.HIVE_RECORDING_STARTED = "hive/recording-started", r.HIVE_RECORDING_STOPPED = "hive/recording-stopped", r.HIVE_TRANSPORT_STATE_CHANGED = "hive/transport-state-changed", r.ROOM_STATE = "sockethub/room-state", r.PEER_DISPLAY_NAME_CHANGED = "hive/display-name-changed", r.ASSERT_SPOTLIGHTER = "websocket/assert-spotlighter", r.PEER_REQUESTED_TO_JOIN_STAGE = "websocket/request-to-join-stage-peer-added", r.PEER_WITHDRAWN_REQUEST_TO_JOIN_STAGE = "websocket/request-to-join-stage-peer-withdrawn", r.PEER_REJECTED_TO_JOIN_STAGE = "websocket/peer-rejected-to-join-stage", r.PEER_ADDED_TO_STAGE = "websocket/peer-added-to-stage", r.PEER_REMOVED_FROM_STAGE = "websocket/peer-removed-from-stage", r.PEER_STARTED_PRESENTING = "websocket/peer-started-presenting", r.PEER_STOPPED_PRESENTING = "websocket/peer-stopped-presenting", r.REQUEST_TO_JOIN_STAGE_ACCEPTED = "websocket/request-to-join-stage-accepted", r.REQUEST_TO_JOIN_STAGE_REJECTED = "websocket/request-to-join-stage-rejected", r.STARTED_PRESENTING = "websocket/started-presenting", r.STOPPED_PRESENTING = "websocket/stopped-presenting", r.REMOVED_FROM_STAGE = "websocket/removed-from-stage", r.JOIN_MEDIA_ROOM = "JOIN_MEDIA_ROOM", r.LEAVE_MEDIA_ROOM = "LEAVE_MEDIA_ROOM", r))(v || {}), Qs;
(function(r) {
  r[r.PUBLISHER = 0] = "PUBLISHER", r[r.SUBSCRIBER = 1] = "SUBSCRIBER";
})(Qs || (Qs = {}));
var rs;
(function(r) {
  r[r.AUDIO = 0] = "AUDIO", r[r.VIDEO = 1] = "VIDEO";
})(rs || (rs = {}));
class bT extends w {
  constructor() {
    super("media.Pair", [
      {
        no: 1,
        name: "key",
        kind: "scalar",
        T: 9
        /*ScalarType.STRING*/
      },
      {
        no: 2,
        name: "value",
        kind: "scalar",
        T: 9
        /*ScalarType.STRING*/
      }
    ]);
  }
}
new bT();
class PT extends w {
  constructor() {
    super("media.Codec", []);
  }
}
new PT();
class CT extends w {
  constructor() {
    super("media.Fingerprint", [
      {
        no: 1,
        name: "algorithm",
        kind: "scalar",
        T: 9
        /*ScalarType.STRING*/
      },
      {
        no: 2,
        name: "value",
        kind: "scalar",
        T: 9
        /*ScalarType.STRING*/
      }
    ]);
  }
}
new CT();
class kT extends w {
  constructor() {
    super("media.SessionDescription", [
      { no: 1, name: "target", kind: "enum", T: () => ["media.Target", Qs] },
      {
        no: 2,
        name: "type",
        kind: "scalar",
        T: 9
        /*ScalarType.STRING*/
      },
      {
        no: 3,
        name: "sdp",
        kind: "scalar",
        T: 9
        /*ScalarType.STRING*/
      }
    ]);
  }
}
const Fs = new kT();
class DT extends w {
  constructor() {
    super("media.CreateTransportRequest", [
      {
        no: 1,
        name: "consuming",
        kind: "scalar",
        T: 8
        /*ScalarType.BOOL*/
      },
      {
        no: 2,
        name: "force_tcp",
        kind: "scalar",
        opt: !0,
        T: 8
        /*ScalarType.BOOL*/
      },
      { no: 3, name: "description", kind: "message", T: () => Fs }
    ]);
  }
}
const IT = new DT();
class AT extends w {
  constructor() {
    super("media.CreateTransportResponse", [
      {
        no: 1,
        name: "transport_id",
        kind: "scalar",
        T: 9
        /*ScalarType.STRING*/
      },
      { no: 2, name: "description", kind: "message", T: () => Fs }
    ]);
  }
}
const ho = new AT();
class MT extends w {
  constructor() {
    super("media.RenegotiateRequest", [
      {
        no: 1,
        name: "transport_id",
        kind: "scalar",
        T: 9
        /*ScalarType.STRING*/
      },
      { no: 2, name: "description", kind: "message", T: () => Fs }
    ]);
  }
}
const OT = new MT();
class NT extends w {
  constructor() {
    super("media.RenegotiateResponse", [
      {
        no: 1,
        name: "transport_id",
        kind: "scalar",
        T: 9
        /*ScalarType.STRING*/
      },
      { no: 2, name: "description", kind: "message", T: () => Fs }
    ]);
  }
}
new NT();
class LT extends w {
  constructor() {
    super("media.NestedScore", [
      {
        no: 1,
        name: "encoding_idx",
        kind: "scalar",
        T: 5
        /*ScalarType.INT32*/
      },
      {
        no: 2,
        name: "rid",
        kind: "scalar",
        T: 9
        /*ScalarType.STRING*/
      },
      {
        no: 3,
        name: "score",
        kind: "scalar",
        T: 5
        /*ScalarType.INT32*/
      },
      {
        no: 4,
        name: "ssrc",
        kind: "scalar",
        T: 3,
        L: 0
        /*LongType.BIGINT*/
      }
    ]);
  }
}
const xT = new LT();
class UT extends w {
  constructor() {
    super("media.ProducerTrack", [
      {
        no: 1,
        name: "track_id",
        kind: "scalar",
        T: 9
        /*ScalarType.STRING*/
      },
      {
        no: 2,
        name: "producer_id",
        kind: "scalar",
        T: 9
        /*ScalarType.STRING*/
      },
      {
        no: 3,
        name: "stream_id",
        kind: "scalar",
        T: 9
        /*ScalarType.STRING*/
      }
    ]);
  }
}
const VT = new UT();
class FT extends w {
  constructor() {
    super("media.ProducerEntry", [
      {
        no: 1,
        name: "producing_transport_id",
        kind: "scalar",
        T: 9
        /*ScalarType.STRING*/
      },
      {
        no: 2,
        name: "producer_id",
        kind: "scalar",
        T: 9
        /*ScalarType.STRING*/
      }
    ]);
  }
}
new FT();
class jT extends w {
  constructor() {
    super("media.ConsumerEntry", [
      {
        no: 1,
        name: "consuming_transport_id",
        kind: "scalar",
        T: 9
        /*ScalarType.STRING*/
      },
      {
        no: 2,
        name: "consumer_id",
        kind: "scalar",
        T: 9
        /*ScalarType.STRING*/
      }
    ]);
  }
}
new jT();
class $T extends w {
  constructor() {
    super("media.ProducerState", [
      {
        no: 1,
        name: "producer_id",
        kind: "scalar",
        T: 9
        /*ScalarType.STRING*/
      },
      { no: 2, name: "kind", kind: "enum", T: () => ["media.ProducerKind", rs] },
      {
        no: 3,
        name: "pause",
        kind: "scalar",
        T: 8
        /*ScalarType.BOOL*/
      },
      {
        no: 4,
        name: "screen_share",
        kind: "scalar",
        T: 8
        /*ScalarType.BOOL*/
      }
    ]);
  }
}
const Xn = new $T();
class HT extends w {
  constructor() {
    super("media.ConsumerState", [
      {
        no: 1,
        name: "consumer_id",
        kind: "scalar",
        T: 9
        /*ScalarType.STRING*/
      },
      { no: 2, name: "producer_state", kind: "message", T: () => Xn },
      { no: 3, name: "producer_track", kind: "message", T: () => VT }
    ]);
  }
}
const BT = new HT();
class qT extends w {
  constructor() {
    super("media.ProducerIdToConsumerMap", [
      { no: 1, name: "map", kind: "map", K: 9, V: { kind: "message", T: () => BT } }
    ]);
  }
}
const dp = new qT();
class GT extends w {
  constructor() {
    super("media.edge.PeerJoinRequest", [
      {
        no: 1,
        name: "display_name",
        kind: "scalar",
        opt: !0,
        T: 9
        /*ScalarType.STRING*/
      },
      {
        no: 2,
        name: "prejoined",
        kind: "scalar",
        T: 8
        /*ScalarType.BOOL*/
      },
      {
        no: 3,
        name: "room_uuid",
        kind: "scalar",
        T: 9
        /*ScalarType.STRING*/
      },
      {
        no: 4,
        name: "meeting_id",
        kind: "scalar",
        opt: !0,
        T: 9
        /*ScalarType.STRING*/
      },
      {
        no: 5,
        name: "preset",
        kind: "scalar",
        opt: !0,
        T: 12
        /*ScalarType.BYTES*/
      },
      {
        no: 6,
        name: "user_id",
        kind: "scalar",
        opt: !0,
        T: 9
        /*ScalarType.STRING*/
      },
      {
        no: 7,
        name: "organization_id",
        kind: "scalar",
        opt: !0,
        T: 9
        /*ScalarType.STRING*/
      }
    ]);
  }
}
const WT = new GT();
class JT extends w {
  constructor() {
    super("media.edge.PeerJoinCompleteRequest", []);
  }
}
const KT = new JT();
class zT extends w {
  constructor() {
    super("media.edge.PeerLeaveRequest", [
      {
        no: 1,
        name: "close_room",
        kind: "scalar",
        T: 8
        /*ScalarType.BOOL*/
      }
    ]);
  }
}
const QT = new zT();
class YT extends w {
  constructor() {
    super("media.edge.ConsumeMultipleProducerRequest", [
      {
        no: 1,
        name: "producer_ids",
        kind: "scalar",
        repeat: 2,
        T: 9
        /*ScalarType.STRING*/
      },
      {
        no: 2,
        name: "paused",
        kind: "scalar",
        opt: !0,
        T: 8
        /*ScalarType.BOOL*/
      }
    ]);
  }
}
new YT();
class ZT extends w {
  constructor() {
    super("media.edge.ConsumePeerRequest", [
      {
        no: 1,
        name: "producing_peer_id",
        kind: "scalar",
        T: 9
        /*ScalarType.STRING*/
      },
      {
        no: 2,
        name: "paused",
        kind: "scalar",
        opt: !0,
        T: 8
        /*ScalarType.BOOL*/
      },
      {
        no: 3,
        name: "producer_id",
        kind: "scalar",
        opt: !0,
        T: 9
        /*ScalarType.STRING*/
      }
    ]);
  }
}
const XT = new ZT();
class ey extends w {
  constructor() {
    super("media.edge.ProducerCreateRequest", [
      {
        no: 1,
        name: "kind",
        kind: "scalar",
        T: 9
        /*ScalarType.STRING*/
      },
      {
        no: 2,
        name: "paused",
        kind: "scalar",
        T: 8
        /*ScalarType.BOOL*/
      },
      {
        no: 3,
        name: "screen_share",
        kind: "scalar",
        T: 8
        /*ScalarType.BOOL*/
      },
      { no: 4, name: "description", kind: "message", T: () => Fs },
      {
        no: 5,
        name: "msid",
        kind: "scalar",
        T: 9
        /*ScalarType.STRING*/
      }
    ]);
  }
}
const ty = new ey();
class sy extends w {
  constructor() {
    super("media.edge.SelectedPeersRequest", []);
  }
}
new sy();
class ry extends w {
  constructor() {
    super("media.edge.GlobalPeerPinningRequest", [
      {
        no: 1,
        name: "participant_id",
        kind: "scalar",
        T: 9
        /*ScalarType.STRING*/
      }
    ]);
  }
}
const iy = new ry();
class ny extends w {
  constructor() {
    super("media.edge.ProducerToggleRequest", [
      {
        no: 1,
        name: "producer_id",
        kind: "scalar",
        T: 9
        /*ScalarType.STRING*/
      },
      {
        no: 2,
        name: "pause",
        kind: "scalar",
        T: 8
        /*ScalarType.BOOL*/
      }
    ]);
  }
}
const ua = new ny();
class ay extends w {
  constructor() {
    super("media.edge.ConsumerToggleRequest", [
      {
        no: 1,
        name: "consumer_id",
        kind: "scalar",
        T: 9
        /*ScalarType.STRING*/
      },
      {
        no: 2,
        name: "pause",
        kind: "scalar",
        T: 8
        /*ScalarType.BOOL*/
      }
    ]);
  }
}
const hl = new ay();
class oy extends w {
  constructor() {
    super("media.edge.ProducerCloseRequest", [
      {
        no: 1,
        name: "producer_id",
        kind: "scalar",
        T: 9
        /*ScalarType.STRING*/
      },
      { no: 2, name: "description", kind: "message", T: () => Fs }
    ]);
  }
}
const cy = new oy();
class dy extends w {
  constructor() {
    super("media.edge.ConsumerCloseRequest", [
      {
        no: 1,
        name: "consumer_ids",
        kind: "scalar",
        repeat: 2,
        T: 9
        /*ScalarType.STRING*/
      },
      { no: 2, name: "description", kind: "message", T: () => Fs }
    ]);
  }
}
const ly = new dy();
class uy extends w {
  constructor() {
    super("media.edge.KickPeerRequest", [
      {
        no: 1,
        name: "participant_id",
        kind: "scalar",
        T: 9
        /*ScalarType.STRING*/
      }
    ]);
  }
}
const py = new uy();
class hy extends w {
  constructor() {
    super("media.edge.KickAllPeersRequest", []);
  }
}
const my = new hy();
class fy extends w {
  constructor() {
    super("media.edge.PeerDisplayNameEditRequest", [
      {
        no: 1,
        name: "participant_id",
        kind: "scalar",
        T: 9
        /*ScalarType.STRING*/
      },
      {
        no: 2,
        name: "display_name",
        kind: "scalar",
        T: 9
        /*ScalarType.STRING*/
      }
    ]);
  }
}
const gy = new fy();
class _y extends w {
  constructor() {
    super("media.edge.HostMediaControlForPeerRequest", [
      {
        no: 1,
        name: "participant_id",
        kind: "scalar",
        T: 9
        /*ScalarType.STRING*/
      },
      {
        no: 2,
        name: "audio",
        kind: "scalar",
        T: 8
        /*ScalarType.BOOL*/
      },
      {
        no: 3,
        name: "video",
        kind: "scalar",
        T: 8
        /*ScalarType.BOOL*/
      },
      {
        no: 4,
        name: "scree_share",
        kind: "scalar",
        T: 8
        /*ScalarType.BOOL*/
      }
    ]);
  }
}
const vy = new _y();
class Ty extends w {
  constructor() {
    super("media.edge.HostMediaControlForAllPeerRequest", [
      {
        no: 1,
        name: "audio",
        kind: "scalar",
        T: 8
        /*ScalarType.BOOL*/
      },
      {
        no: 2,
        name: "video",
        kind: "scalar",
        T: 8
        /*ScalarType.BOOL*/
      },
      {
        no: 3,
        name: "screen_share",
        kind: "scalar",
        T: 8
        /*ScalarType.BOOL*/
      }
    ]);
  }
}
const yy = new Ty();
class Ey extends w {
  constructor() {
    super("media.edge.GetRoomStateResponse", [
      {
        no: 1,
        name: "display_title",
        kind: "scalar",
        T: 9
        /*ScalarType.STRING*/
      },
      {
        no: 2,
        name: "locked_mode",
        kind: "scalar",
        T: 8
        /*ScalarType.BOOL*/
      },
      {
        no: 3,
        name: "room_uuid",
        kind: "scalar",
        T: 9
        /*ScalarType.STRING*/
      },
      {
        no: 4,
        name: "room_name",
        kind: "scalar",
        T: 9
        /*ScalarType.STRING*/
      },
      {
        no: 5,
        name: "current_peer_id",
        kind: "scalar",
        T: 9
        /*ScalarType.STRING*/
      },
      {
        no: 6,
        name: "is_recording",
        kind: "scalar",
        opt: !0,
        T: 8
        /*ScalarType.BOOL*/
      },
      {
        no: 7,
        name: "recorder_participant_id",
        kind: "scalar",
        opt: !0,
        T: 9
        /*ScalarType.STRING*/
      }
    ]);
  }
}
const Sy = new Ey();
class wy extends w {
  constructor() {
    super("media.edge.ErrorResponse", [
      {
        no: 1,
        name: "error_message",
        kind: "scalar",
        T: 9
        /*ScalarType.STRING*/
      },
      {
        no: 2,
        name: "event_id",
        kind: "scalar",
        T: 5
        /*ScalarType.INT32*/
      }
    ]);
  }
}
new wy();
class Ry extends w {
  constructor() {
    super("media.edge.EmptyResponse", []);
  }
}
new Ry();
class by extends w {
  constructor() {
    super("media.edge.RoomParticipants", [
      {
        no: 1,
        name: "peer_id",
        kind: "scalar",
        T: 9
        /*ScalarType.STRING*/
      },
      { no: 2, name: "producer_states", kind: "message", repeat: 1, T: () => Xn },
      {
        no: 3,
        name: "display_name",
        kind: "scalar",
        T: 9
        /*ScalarType.STRING*/
      },
      {
        no: 4,
        name: "user_id",
        kind: "scalar",
        opt: !0,
        T: 9
        /*ScalarType.STRING*/
      }
    ]);
  }
}
const lp = new by();
class Py extends w {
  constructor() {
    super("media.edge.SelectedPeersResponse", [
      {
        no: 1,
        name: "audio_peers",
        kind: "scalar",
        repeat: 2,
        T: 9
        /*ScalarType.STRING*/
      },
      {
        no: 2,
        name: "compulsory_peers",
        kind: "scalar",
        repeat: 2,
        T: 9
        /*ScalarType.STRING*/
      }
    ]);
  }
}
const up = new Py();
class Cy extends w {
  constructor() {
    super("media.edge.SelectedPeersDiffEntry", [
      {
        no: 1,
        name: "peer_id",
        kind: "scalar",
        T: 9
        /*ScalarType.STRING*/
      },
      {
        no: 2,
        name: "priority",
        kind: "scalar",
        T: 5
        /*ScalarType.INT32*/
      }
    ]);
  }
}
const ky = new Cy();
class Dy extends w {
  constructor() {
    super("media.edge.SelectedPeersDiffResponse", [
      { no: 1, name: "entries", kind: "message", repeat: 1, T: () => ky }
    ]);
  }
}
const Iy = new Dy();
class Ay extends w {
  constructor() {
    super("media.edge.PeerJoinResponse", []);
  }
}
new Ay();
class My extends w {
  constructor() {
    super("media.edge.PeerJoinCompleteResponse", [
      { no: 1, name: "room_state", kind: "message", T: () => Sy },
      { no: 2, name: "participants", kind: "message", repeat: 1, T: () => lp },
      { no: 3, name: "selected_peers", kind: "message", T: () => up },
      {
        no: 4,
        name: "max_preferred_streams",
        kind: "scalar",
        T: 5
        /*ScalarType.INT32*/
      }
    ]);
  }
}
const Oy = new My();
class Ny extends w {
  constructor() {
    super("media.edge.PeerLeaveResponse", [
      {
        no: 1,
        name: "closed",
        kind: "scalar",
        T: 8
        /*ScalarType.BOOL*/
      }
    ]);
  }
}
const Ly = new Ny();
class xy extends w {
  constructor() {
    super("media.edge.ConsumeMultipleProducerResponse", [
      {
        no: 1,
        name: "status",
        kind: "scalar",
        T: 8
        /*ScalarType.BOOL*/
      },
      { no: 2, name: "consumer_ids_map", kind: "message", T: () => dp },
      { no: 3, name: "transport_details", kind: "message", T: () => ho }
    ]);
  }
}
new xy();
class Uy extends w {
  constructor() {
    super("media.edge.ConsumePeerResponse", [
      {
        no: 1,
        name: "status",
        kind: "scalar",
        T: 8
        /*ScalarType.BOOL*/
      },
      { no: 2, name: "consumer_ids_map", kind: "message", T: () => dp },
      { no: 3, name: "transport_details", kind: "message", T: () => ho }
    ]);
  }
}
const Vy = new Uy();
class Fy extends w {
  constructor() {
    super("media.edge.ProducerCreateResponse", [
      {
        no: 1,
        name: "status",
        kind: "scalar",
        T: 8
        /*ScalarType.BOOL*/
      },
      {
        no: 2,
        name: "producer_id",
        kind: "scalar",
        T: 9
        /*ScalarType.STRING*/
      },
      { no: 3, name: "transport_details", kind: "message", T: () => ho },
      { no: 4, name: "description", kind: "message", T: () => Fs }
    ]);
  }
}
const jy = new Fy();
class $y extends w {
  constructor() {
    super("media.edge.ProducerScoreResponse", [
      {
        no: 1,
        name: "responseid",
        kind: "scalar",
        T: 9
        /*ScalarType.STRING*/
      },
      { no: 2, name: "score", kind: "message", T: () => xT }
    ]);
  }
}
new $y();
class Hy extends w {
  constructor() {
    super("media.edge.ActiveSpeakerResponse", [
      {
        no: 1,
        name: "responsepeer_id",
        kind: "scalar",
        T: 9
        /*ScalarType.STRING*/
      },
      {
        no: 2,
        name: "volume",
        kind: "scalar",
        T: 5
        /*ScalarType.INT32*/
      }
    ]);
  }
}
new Hy();
class By extends w {
  constructor() {
    super("media.edge.NoActiveSpeakerResponse", []);
  }
}
new By();
class qy extends w {
  constructor() {
    super("media.edge.ProducerToggleResponse", []);
  }
}
new qy();
class Gy extends w {
  constructor() {
    super("media.edge.ConsumerToggleResponse", []);
  }
}
new Gy();
class Wy extends w {
  constructor() {
    super("media.edge.ProducerClosingResponse", [
      { no: 1, name: "description", kind: "message", T: () => Fs }
    ]);
  }
}
const Jy = new Wy();
class Ky extends w {
  constructor() {
    super("media.edge.ConsumerClosingResponse", []);
  }
}
new Ky();
class zy extends w {
  constructor() {
    super("media.edge.GlobalPeerPinningResponse", []);
  }
}
new zy();
class Qy extends w {
  constructor() {
    super("media.edge.KickPeerResponse", [
      {
        no: 1,
        name: "status",
        kind: "scalar",
        T: 9
        /*ScalarType.STRING*/
      }
    ]);
  }
}
const Yy = new Qy();
class Zy extends w {
  constructor() {
    super("media.edge.KickAllPeersResponse", [
      {
        no: 1,
        name: "status",
        kind: "scalar",
        T: 9
        /*ScalarType.STRING*/
      }
    ]);
  }
}
const Xy = new Zy();
class eE extends w {
  constructor() {
    super("media.edge.HostMediaControlForPeerResponse", [
      {
        no: 1,
        name: "status",
        kind: "scalar",
        T: 9
        /*ScalarType.STRING*/
      }
    ]);
  }
}
const tE = new eE();
class sE extends w {
  constructor() {
    super("media.edge.HostMediaControlForAllPeerResponse", [
      {
        no: 1,
        name: "status",
        kind: "scalar",
        T: 9
        /*ScalarType.STRING*/
      }
    ]);
  }
}
const rE = new sE();
class iE extends w {
  constructor() {
    super("media.edge.PeerDisplayNameEditResponse", [
      {
        no: 1,
        name: "status",
        kind: "scalar",
        T: 9
        /*ScalarType.STRING*/
      }
    ]);
  }
}
const nE = new iE();
class aE extends w {
  constructor() {
    super("media.edge.PeerJoinBroadcastResponse", [
      { no: 1, name: "participant", kind: "message", T: () => lp }
    ]);
  }
}
const oE = new aE();
class cE extends w {
  constructor() {
    super("media.edge.PeerProducerCreateBroadcastResponse", [
      {
        no: 1,
        name: "participant_id",
        kind: "scalar",
        T: 9
        /*ScalarType.STRING*/
      },
      { no: 2, name: "producer_state", kind: "message", T: () => Xn }
    ]);
  }
}
const dE = new cE();
class lE extends w {
  constructor() {
    super("media.edge.PeerProducerToggleBroadcastResponse", [
      {
        no: 1,
        name: "participant_id",
        kind: "scalar",
        T: 9
        /*ScalarType.STRING*/
      },
      { no: 2, name: "producer_state", kind: "message", T: () => Xn }
    ]);
  }
}
const uE = new lE();
class pE extends w {
  constructor() {
    super("media.edge.PeerProducerCloseBroadcastResponse", [
      {
        no: 1,
        name: "participant_id",
        kind: "scalar",
        T: 9
        /*ScalarType.STRING*/
      },
      { no: 2, name: "producer_state", kind: "message", T: () => Xn }
    ]);
  }
}
const hE = new pE();
class mE extends w {
  constructor() {
    super("media.edge.PeerLeaveBroadcastResponse", [
      {
        no: 1,
        name: "participant_id",
        kind: "scalar",
        T: 9
        /*ScalarType.STRING*/
      }
    ]);
  }
}
const fE = new mE();
class gE extends w {
  constructor() {
    super("media.edge.GlobalPeerPinningBroadcastResponse", [
      {
        no: 1,
        name: "participant_id",
        kind: "scalar",
        T: 9
        /*ScalarType.STRING*/
      }
    ]);
  }
}
const _E = new gE();
class vE extends w {
  constructor() {
    super("media.edge.RecordingStartedBroadcastResponse", [
      {
        no: 1,
        name: "participant_id",
        kind: "scalar",
        T: 9
        /*ScalarType.STRING*/
      }
    ]);
  }
}
const TE = new vE();
class yE extends w {
  constructor() {
    super("media.edge.RecordingStoppedBroadcastResponse", [
      {
        no: 1,
        name: "participant_id",
        kind: "scalar",
        T: 9
        /*ScalarType.STRING*/
      }
    ]);
  }
}
const EE = new yE();
class SE extends w {
  constructor() {
    super("media.edge.PeerDisplayNameEditBroadcastResponse", [
      {
        no: 1,
        name: "participant_id",
        kind: "scalar",
        T: 9
        /*ScalarType.STRING*/
      },
      {
        no: 2,
        name: "display_name",
        kind: "scalar",
        T: 9
        /*ScalarType.STRING*/
      }
    ]);
  }
}
const wE = new SE();
class RE extends w {
  constructor() {
    super("socket.api.BaseSocketHubMessage", [
      {
        no: 1,
        name: "event",
        kind: "scalar",
        T: 5
        /*ScalarType.INT32*/
      },
      {
        no: 2,
        name: "id",
        kind: "scalar",
        T: 9
        /*ScalarType.STRING*/
      },
      {
        no: 3,
        name: "peer_id",
        kind: "scalar",
        T: 9
        /*ScalarType.STRING*/
      },
      {
        no: 4,
        name: "room_id",
        kind: "scalar",
        T: 9
        /*ScalarType.STRING*/
      },
      {
        no: 5,
        name: "user_id",
        kind: "scalar",
        T: 9
        /*ScalarType.STRING*/
      },
      {
        no: 6,
        name: "payload",
        kind: "scalar",
        T: 12
        /*ScalarType.BYTES*/
      }
    ]);
  }
}
new RE();
class bE extends w {
  constructor() {
    super("socket.api.ErrorMessage", [
      {
        no: 1,
        name: "code",
        kind: "scalar",
        opt: !0,
        T: 5
        /*ScalarType.INT32*/
      },
      {
        no: 2,
        name: "message",
        kind: "scalar",
        T: 9
        /*ScalarType.STRING*/
      }
    ]);
  }
}
new bE();
class PE extends w {
  constructor() {
    super("socket.PeerPreset", [
      {
        no: 1,
        name: "success",
        kind: "scalar",
        T: 8
        /*ScalarType.BOOL*/
      },
      {
        no: 2,
        name: "message",
        kind: "scalar",
        T: 9
        /*ScalarType.STRING*/
      },
      { no: 3, name: "data", kind: "message", T: () => KE }
    ]);
  }
}
new PE();
class CE extends w {
  constructor() {
    super("socket.PeerPreset.Plugins", [
      {
        no: 1,
        name: "can_close",
        kind: "scalar",
        T: 8
        /*ScalarType.BOOL*/
      },
      {
        no: 2,
        name: "can_start",
        kind: "scalar",
        T: 8
        /*ScalarType.BOOL*/
      }
    ]);
  }
}
const kE = new CE();
class DE extends w {
  constructor() {
    super("socket.PeerPreset.Polls", [
      {
        no: 1,
        name: "can_create",
        kind: "scalar",
        T: 8
        /*ScalarType.BOOL*/
      },
      {
        no: 2,
        name: "can_vote",
        kind: "scalar",
        T: 8
        /*ScalarType.BOOL*/
      },
      {
        no: 3,
        name: "can_view",
        kind: "scalar",
        T: 8
        /*ScalarType.BOOL*/
      }
    ]);
  }
}
const IE = new DE();
class AE extends w {
  constructor() {
    super("socket.PeerPreset.Video", [
      {
        no: 1,
        name: "allow",
        kind: "scalar",
        T: 8
        /*ScalarType.BOOL*/
      },
      {
        no: 2,
        name: "quality",
        kind: "scalar",
        T: 9
        /*ScalarType.STRING*/
      },
      {
        no: 3,
        name: "frame_rate",
        kind: "scalar",
        T: 13
        /*ScalarType.UINT32*/
      }
    ]);
  }
}
const ME = new AE();
class OE extends w {
  constructor() {
    super("socket.PeerPreset.Screenshare", [
      {
        no: 1,
        name: "allow",
        kind: "scalar",
        T: 8
        /*ScalarType.BOOL*/
      },
      {
        no: 2,
        name: "quality",
        kind: "scalar",
        T: 9
        /*ScalarType.STRING*/
      },
      {
        no: 3,
        name: "frame_rate",
        kind: "scalar",
        T: 13
        /*ScalarType.UINT32*/
      }
    ]);
  }
}
const NE = new OE();
class LE extends w {
  constructor() {
    super("socket.PeerPreset.Produce", [
      { no: 1, name: "video", kind: "message", T: () => ME },
      {
        no: 2,
        name: "audio",
        kind: "scalar",
        T: 8
        /*ScalarType.BOOL*/
      },
      { no: 3, name: "screenshare", kind: "message", T: () => NE }
    ]);
  }
}
const xE = new LE();
class UE extends w {
  constructor() {
    super("socket.PeerPreset.Public", [
      {
        no: 1,
        name: "can_send",
        kind: "scalar",
        T: 8
        /*ScalarType.BOOL*/
      },
      {
        no: 2,
        name: "text",
        kind: "scalar",
        T: 8
        /*ScalarType.BOOL*/
      },
      {
        no: 3,
        name: "files",
        kind: "scalar",
        T: 8
        /*ScalarType.BOOL*/
      }
    ]);
  }
}
const VE = new UE();
class FE extends w {
  constructor() {
    super("socket.PeerPreset.Private", [
      {
        no: 1,
        name: "can_send",
        kind: "scalar",
        T: 8
        /*ScalarType.BOOL*/
      },
      {
        no: 2,
        name: "can_receive",
        kind: "scalar",
        T: 8
        /*ScalarType.BOOL*/
      },
      {
        no: 3,
        name: "text",
        kind: "scalar",
        T: 8
        /*ScalarType.BOOL*/
      },
      {
        no: 4,
        name: "files",
        kind: "scalar",
        T: 8
        /*ScalarType.BOOL*/
      }
    ]);
  }
}
const jE = new FE();
class $E extends w {
  constructor() {
    super("socket.PeerPreset.Chat", [
      { no: 1, name: "public", kind: "message", T: () => VE },
      { no: 2, name: "private", kind: "message", T: () => jE }
    ]);
  }
}
const HE = new $E();
class BE extends w {
  constructor() {
    super("socket.PeerPreset.Permissions", [
      {
        no: 1,
        name: "view_type",
        kind: "scalar",
        T: 9
        /*ScalarType.STRING*/
      },
      {
        no: 2,
        name: "accept_waiting_requests",
        kind: "scalar",
        T: 8
        /*ScalarType.BOOL*/
      },
      {
        no: 3,
        name: "request_produce",
        kind: "scalar",
        T: 8
        /*ScalarType.BOOL*/
      },
      {
        no: 4,
        name: "can_allow_participant_audio",
        kind: "scalar",
        T: 8
        /*ScalarType.BOOL*/
      },
      {
        no: 5,
        name: "can_allow_participant_screensharing",
        kind: "scalar",
        T: 8
        /*ScalarType.BOOL*/
      },
      {
        no: 6,
        name: "can_allow_participant_video",
        kind: "scalar",
        T: 8
        /*ScalarType.BOOL*/
      },
      {
        no: 7,
        name: "request_kick_participant",
        kind: "scalar",
        T: 8
        /*ScalarType.BOOL*/
      },
      {
        no: 8,
        name: "kick_participant",
        kind: "scalar",
        T: 8
        /*ScalarType.BOOL*/
      },
      {
        no: 9,
        name: "pin_participant",
        kind: "scalar",
        T: 8
        /*ScalarType.BOOL*/
      },
      {
        no: 10,
        name: "can_record",
        kind: "scalar",
        T: 8
        /*ScalarType.BOOL*/
      },
      {
        no: 11,
        name: "waiting_room_type",
        kind: "scalar",
        T: 9
        /*ScalarType.STRING*/
      },
      { no: 12, name: "plugins", kind: "message", T: () => kE },
      { no: 13, name: "polls", kind: "message", T: () => IE },
      { no: 14, name: "produce", kind: "message", T: () => xE },
      { no: 15, name: "chat", kind: "message", T: () => HE },
      {
        no: 16,
        name: "reactions",
        kind: "scalar",
        T: 8
        /*ScalarType.BOOL*/
      },
      {
        no: 17,
        name: "hidden_participant",
        kind: "scalar",
        T: 8
        /*ScalarType.BOOL*/
      },
      {
        no: 18,
        name: "show_participant_list",
        kind: "scalar",
        T: 8
        /*ScalarType.BOOL*/
      },
      {
        no: 19,
        name: "can_change_participant_role",
        kind: "scalar",
        T: 8
        /*ScalarType.BOOL*/
      },
      {
        no: 20,
        name: "can_change_theme",
        kind: "scalar",
        T: 8
        /*ScalarType.BOOL*/
      },
      {
        no: 21,
        name: "can_present",
        kind: "scalar",
        T: 8
        /*ScalarType.BOOL*/
      },
      {
        no: 22,
        name: "is_recorder",
        kind: "scalar",
        opt: !0,
        T: 8
        /*ScalarType.BOOL*/
      }
    ]);
  }
}
const qE = new BE();
class GE extends w {
  constructor() {
    super("socket.PeerPreset.Preset", [
      { no: 1, name: "permissions", kind: "message", T: () => qE },
      {
        no: 3,
        name: "version",
        kind: "scalar",
        T: 9
        /*ScalarType.STRING*/
      },
      {
        no: 4,
        name: "preset_name",
        kind: "scalar",
        T: 9
        /*ScalarType.STRING*/
      }
    ]);
  }
}
const WE = new GE();
class JE extends w {
  constructor() {
    super("socket.PeerPreset.Data", [
      { no: 1, name: "preset", kind: "message", T: () => WE }
    ]);
  }
}
const KE = new JE();
class zE extends w {
  constructor() {
    super("socket.chat.ChatMessage", [
      {
        no: 1,
        name: "chat_id",
        kind: "scalar",
        T: 9
        /*ScalarType.STRING*/
      },
      {
        no: 2,
        name: "peer_id",
        kind: "scalar",
        T: 9
        /*ScalarType.STRING*/
      },
      {
        no: 3,
        name: "user_id",
        kind: "scalar",
        T: 9
        /*ScalarType.STRING*/
      },
      {
        no: 4,
        name: "display_name",
        kind: "scalar",
        T: 9
        /*ScalarType.STRING*/
      },
      {
        no: 5,
        name: "pinned",
        kind: "scalar",
        T: 8
        /*ScalarType.BOOL*/
      },
      {
        no: 6,
        name: "is_edited",
        kind: "scalar",
        T: 8
        /*ScalarType.BOOL*/
      },
      {
        no: 7,
        name: "payload_type",
        kind: "scalar",
        T: 5
        /*ScalarType.INT32*/
      },
      {
        no: 8,
        name: "payload",
        kind: "scalar",
        T: 9
        /*ScalarType.STRING*/
      },
      {
        no: 10,
        name: "target_user_ids",
        kind: "scalar",
        repeat: 2,
        T: 9
        /*ScalarType.STRING*/
      },
      {
        no: 11,
        name: "created_at",
        kind: "scalar",
        T: 4,
        L: 2
        /*LongType.NUMBER*/
      },
      {
        no: 12,
        name: "created_at_ms",
        kind: "scalar",
        opt: !0,
        T: 4,
        L: 2
        /*LongType.NUMBER*/
      }
    ]);
  }
}
const ea = new zE();
class QE extends w {
  constructor() {
    super("socket.chat.GetPaginatedChatMessageRoomRequest", [
      {
        no: 1,
        name: "time_stamp",
        kind: "scalar",
        T: 4,
        L: 2
        /*LongType.NUMBER*/
      },
      {
        no: 2,
        name: "size",
        kind: "scalar",
        T: 5
        /*ScalarType.INT32*/
      },
      {
        no: 3,
        name: "from",
        kind: "scalar",
        T: 5
        /*ScalarType.INT32*/
      },
      {
        no: 4,
        name: "reversed",
        kind: "scalar",
        T: 8
        /*ScalarType.BOOL*/
      }
    ]);
  }
}
const YE = new QE();
class ZE extends w {
  constructor() {
    super("socket.chat.GetPaginatedChatMessageRoomResponse", [
      { no: 1, name: "messages", kind: "message", repeat: 1, T: () => ea },
      {
        no: 2,
        name: "next",
        kind: "scalar",
        T: 8
        /*ScalarType.BOOL*/
      }
    ]);
  }
}
const XE = new ZE();
class eS extends w {
  constructor() {
    super("socket.chat.GetChatMessagesResponse", [
      { no: 1, name: "messages", kind: "message", repeat: 1, T: () => ea }
    ]);
  }
}
const tS = new eS();
class sS extends w {
  constructor() {
    super("socket.chat.SendChatMessageToRoomRequest", [
      {
        no: 1,
        name: "payload_type",
        kind: "scalar",
        T: 5
        /*ScalarType.INT32*/
      },
      {
        no: 2,
        name: "payload",
        kind: "scalar",
        T: 9
        /*ScalarType.STRING*/
      }
    ]);
  }
}
const rS = new sS();
class iS extends w {
  constructor() {
    super("socket.chat.SendChatMessageToRoomResponse", [
      { no: 1, name: "message", kind: "message", T: () => ea }
    ]);
  }
}
const Lo = new iS();
class nS extends w {
  constructor() {
    super("socket.chat.SendChatMessageToPeersRequest", [
      {
        no: 1,
        name: "peer_ids",
        kind: "scalar",
        repeat: 2,
        T: 9
        /*ScalarType.STRING*/
      },
      {
        no: 2,
        name: "payload_type",
        kind: "scalar",
        T: 5
        /*ScalarType.INT32*/
      },
      {
        no: 3,
        name: "payload",
        kind: "scalar",
        T: 9
        /*ScalarType.STRING*/
      }
    ]);
  }
}
const aS = new nS();
class oS extends w {
  constructor() {
    super("socket.chat.SendChatMessageToPeersResponse", [
      { no: 1, name: "message", kind: "message", T: () => ea }
    ]);
  }
}
const xo = new oS();
class cS extends w {
  constructor() {
    super("socket.chat.EditChatMessageRequest", [
      {
        no: 1,
        name: "chat_id",
        kind: "scalar",
        T: 9
        /*ScalarType.STRING*/
      },
      {
        no: 2,
        name: "payload_type",
        kind: "scalar",
        opt: !0,
        T: 5
        /*ScalarType.INT32*/
      },
      {
        no: 3,
        name: "payload",
        kind: "scalar",
        opt: !0,
        T: 9
        /*ScalarType.STRING*/
      },
      {
        no: 4,
        name: "pinned",
        kind: "scalar",
        opt: !0,
        T: 8
        /*ScalarType.BOOL*/
      }
    ]);
  }
}
const dS = new cS();
class lS extends w {
  constructor() {
    super("socket.chat.EditChatMessageResponse", [
      { no: 1, name: "message", kind: "message", T: () => ea }
    ]);
  }
}
const Uo = new lS();
class uS extends w {
  constructor() {
    super("socket.chat.DeleteChatMessageRequest", [
      {
        no: 1,
        name: "chat_id",
        kind: "scalar",
        T: 9
        /*ScalarType.STRING*/
      }
    ]);
  }
}
const pS = new uS();
class hS extends w {
  constructor() {
    super("socket.chat.DeleteChatMessageResponse", [
      {
        no: 1,
        name: "chat_id",
        kind: "scalar",
        T: 9
        /*ScalarType.STRING*/
      }
    ]);
  }
}
const Vo = new hS();
var Dr;
(function(r) {
  r[r.UNSPECIFIED = 0] = "UNSPECIFIED", r[r.ON_STAGE = 1] = "ON_STAGE", r[r.APPROVED_STAGE = 2] = "APPROVED_STAGE", r[r.REQUESTED_STAGE = 3] = "REQUESTED_STAGE", r[r.OFF_STAGE = 4] = "OFF_STAGE";
})(Dr || (Dr = {}));
var Ua;
(function(r) {
  r[r.HIVE = 0] = "HIVE", r[r.CHAT = 1] = "CHAT", r[r.PING = 2] = "PING";
})(Ua || (Ua = {}));
class mS extends w {
  constructor() {
    super("socket.room.Peer", [
      {
        no: 1,
        name: "peer_id",
        kind: "scalar",
        T: 9
        /*ScalarType.STRING*/
      },
      {
        no: 2,
        name: "user_id",
        kind: "scalar",
        T: 9
        /*ScalarType.STRING*/
      },
      {
        no: 3,
        name: "display_name",
        kind: "scalar",
        T: 9
        /*ScalarType.STRING*/
      },
      { no: 4, name: "stage_type", kind: "enum", opt: !0, T: () => ["socket.room.StageType", Dr, "STAGE_TYPE_"] },
      {
        no: 5,
        name: "custom_participant_id",
        kind: "scalar",
        opt: !0,
        T: 9
        /*ScalarType.STRING*/
      },
      {
        no: 6,
        name: "preset_id",
        kind: "scalar",
        opt: !0,
        T: 9
        /*ScalarType.STRING*/
      },
      {
        no: 7,
        name: "display_picture_url",
        kind: "scalar",
        opt: !0,
        T: 9
        /*ScalarType.STRING*/
      }
    ]);
  }
}
const mo = new mS();
class fS extends w {
  constructor() {
    super("socket.room.PeerInfoResponse", [
      { no: 1, name: "peer", kind: "message", T: () => mo }
    ]);
  }
}
const gS = new fS();
class _S extends w {
  constructor() {
    super("socket.room.RoomPeersInfoResponse", [
      { no: 1, name: "peers", kind: "message", repeat: 1, T: () => mo }
    ]);
  }
}
new _S();
class vS extends w {
  constructor() {
    super("socket.room.RoomPeerCountResponse", [
      {
        no: 1,
        name: "count",
        kind: "scalar",
        T: 4,
        L: 2
        /*LongType.NUMBER*/
      }
    ]);
  }
}
const ml = new vS();
class TS extends w {
  constructor() {
    super("socket.room.Room", [
      {
        no: 1,
        name: "room_id",
        kind: "scalar",
        T: 9
        /*ScalarType.STRING*/
      },
      {
        no: 2,
        name: "title",
        kind: "scalar",
        T: 9
        /*ScalarType.STRING*/
      },
      {
        no: 4,
        name: "created_at",
        kind: "scalar",
        T: 4,
        L: 2
        /*LongType.NUMBER*/
      }
    ]);
  }
}
const pp = new TS();
class yS extends w {
  constructor() {
    super("socket.room.RoomInfoResponse", [
      { no: 1, name: "room", kind: "message", T: () => pp }
    ]);
  }
}
const fl = new yS();
class ES extends w {
  constructor() {
    super("socket.room.GetPeerInfoRequest", [
      {
        no: 1,
        name: "peer_id",
        kind: "scalar",
        T: 9
        /*ScalarType.STRING*/
      }
    ]);
  }
}
new ES();
class SS extends w {
  constructor() {
    super("socket.room.UpdatePeerInfoRequest", [
      {
        no: 1,
        name: "peer_id",
        kind: "scalar",
        T: 9
        /*ScalarType.STRING*/
      },
      {
        no: 2,
        name: "display_name",
        kind: "scalar",
        opt: !0,
        T: 9
        /*ScalarType.STRING*/
      }
    ]);
  }
}
new SS();
class wS extends w {
  constructor() {
    super("socket.room.JoinRoomRequest", [
      { no: 1, name: "peer", kind: "message", T: () => mo },
      {
        no: 3,
        name: "room_uuid",
        kind: "scalar",
        T: 9
        /*ScalarType.STRING*/
      },
      {
        no: 4,
        name: "organization_id",
        kind: "scalar",
        opt: !0,
        T: 9
        /*ScalarType.STRING*/
      },
      {
        no: 5,
        name: "use_hive",
        kind: "scalar",
        opt: !0,
        T: 8
        /*ScalarType.BOOL*/
      },
      {
        no: 6,
        name: "preset",
        kind: "scalar",
        opt: !0,
        T: 12
        /*ScalarType.BYTES*/
      },
      { no: 7, name: "capabilities", kind: "enum", repeat: 1, T: () => ["socket.room.Capabilities", Ua, "CAPABILITIES_"] }
    ]);
  }
}
const RS = new wS();
class bS extends w {
  constructor() {
    super("socket.room.LeaveRoomRequest", [
      { no: 1, name: "peer", kind: "message", T: () => mo }
    ]);
  }
}
const PS = new bS();
class CS extends w {
  constructor() {
    super("socket.room.UpdateRoomInfoRequest", [
      { no: 1, name: "room", kind: "message", T: () => pp }
    ]);
  }
}
new CS();
class kS extends w {
  constructor() {
    super("socket.room.GetConnectedRoomsDumpRequest", []);
  }
}
new kS();
class DS extends w {
  constructor() {
    super("socket.room.ServiceError", [
      {
        no: 1,
        name: "message",
        kind: "scalar",
        opt: !0,
        T: 9
        /*ScalarType.STRING*/
      },
      {
        no: 2,
        name: "code",
        kind: "scalar",
        opt: !0,
        T: 9
        /*ScalarType.STRING*/
      }
    ]);
  }
}
const Hc = new DS();
class IS extends w {
  constructor() {
    super("socket.room.ConnectedMeetingPeer", [
      {
        no: 1,
        name: "id",
        kind: "scalar",
        opt: !0,
        T: 9
        /*ScalarType.STRING*/
      },
      {
        no: 2,
        name: "display_name",
        kind: "scalar",
        opt: !0,
        T: 9
        /*ScalarType.STRING*/
      },
      {
        no: 3,
        name: "custom_participant_id",
        kind: "scalar",
        opt: !0,
        T: 9
        /*ScalarType.STRING*/
      },
      {
        no: 4,
        name: "preset_id",
        kind: "scalar",
        opt: !0,
        T: 9
        /*ScalarType.STRING*/
      },
      {
        no: 5,
        name: "display_picture_url",
        kind: "scalar",
        opt: !0,
        T: 9
        /*ScalarType.STRING*/
      }
    ]);
  }
}
const AS = new IS();
class MS extends w {
  constructor() {
    super("socket.room.ConnectedMeetingDump", [
      {
        no: 1,
        name: "id",
        kind: "scalar",
        opt: !0,
        T: 9
        /*ScalarType.STRING*/
      },
      {
        no: 2,
        name: "title",
        kind: "scalar",
        opt: !0,
        T: 9
        /*ScalarType.STRING*/
      },
      { no: 3, name: "participants", kind: "message", repeat: 1, T: () => AS }
    ]);
  }
}
const gl = new MS();
class OS extends w {
  constructor() {
    super("socket.room.GetConnectedRoomsDumpResponse", [
      { no: 1, name: "parent_meeting", kind: "message", T: () => gl },
      { no: 2, name: "meetings", kind: "message", repeat: 1, T: () => gl }
    ]);
  }
}
const NS = new OS();
class LS extends w {
  constructor() {
    super("socket.room.CreateRoomRequestPayload", [
      {
        no: 1,
        name: "title",
        kind: "scalar",
        opt: !0,
        T: 9
        /*ScalarType.STRING*/
      }
    ]);
  }
}
const xS = new LS();
class US extends w {
  constructor() {
    super("socket.room.CreateConnectedRoomsRequest", [
      { no: 1, name: "payloads", kind: "message", repeat: 1, T: () => xS }
    ]);
  }
}
const VS = new US();
class FS extends w {
  constructor() {
    super("socket.room.CreateRoomResponsePayload", [
      {
        no: 1,
        name: "id",
        kind: "scalar",
        opt: !0,
        T: 9
        /*ScalarType.STRING*/
      },
      {
        no: 2,
        name: "title",
        kind: "scalar",
        opt: !0,
        T: 9
        /*ScalarType.STRING*/
      },
      { no: 3, name: "error", kind: "message", T: () => Hc }
    ]);
  }
}
const jS = new FS();
class $S extends w {
  constructor() {
    super("socket.room.CreateConnectedRoomsResponse", [
      { no: 1, name: "payloads", kind: "message", repeat: 1, T: () => jS }
    ]);
  }
}
const _l = new $S();
class HS extends w {
  constructor() {
    super("socket.room.UpdateRoomRequestPayload", [
      {
        no: 1,
        name: "meeting_id",
        kind: "scalar",
        opt: !0,
        T: 9
        /*ScalarType.STRING*/
      },
      {
        no: 2,
        name: "title",
        kind: "scalar",
        opt: !0,
        T: 9
        /*ScalarType.STRING*/
      }
    ]);
  }
}
const BS = new HS();
class qS extends w {
  constructor() {
    super("socket.room.UpdateConnectedRoomsRequest", [
      { no: 1, name: "payloads", kind: "message", repeat: 1, T: () => BS }
    ]);
  }
}
new qS();
class GS extends w {
  constructor() {
    super("socket.room.DisableRoomPayload", [
      {
        no: 1,
        name: "id",
        kind: "scalar",
        opt: !0,
        T: 9
        /*ScalarType.STRING*/
      }
    ]);
  }
}
const WS = new GS();
class JS extends w {
  constructor() {
    super("socket.room.DisableConnectedRoomsRequest", [
      { no: 1, name: "payloads", kind: "message", repeat: 1, T: () => WS }
    ]);
  }
}
const KS = new JS();
class zS extends w {
  constructor() {
    super("socket.room.DisableConnectedRoomsResponse", [
      { no: 1, name: "payloads", kind: "message", repeat: 1, T: () => ZS }
    ]);
  }
}
const QS = new zS();
class YS extends w {
  constructor() {
    super("socket.room.DisableConnectedRoomPayload", [
      {
        no: 1,
        name: "id",
        kind: "scalar",
        opt: !0,
        T: 9
        /*ScalarType.STRING*/
      },
      {
        no: 2,
        name: "status",
        kind: "scalar",
        opt: !0,
        T: 9
        /*ScalarType.STRING*/
      },
      {
        no: 3,
        name: "title",
        kind: "scalar",
        opt: !0,
        T: 9
        /*ScalarType.STRING*/
      },
      { no: 4, name: "error", kind: "message", T: () => Hc }
    ]);
  }
}
const ZS = new YS();
class XS extends w {
  constructor() {
    super("socket.room.MovePeerPayload", [
      {
        no: 1,
        name: "id",
        kind: "scalar",
        opt: !0,
        T: 9
        /*ScalarType.STRING*/
      }
    ]);
  }
}
const ew = new XS();
class tw extends w {
  constructor() {
    super("socket.room.MovePeersBetweenRoomsRequest", [
      {
        no: 1,
        name: "source_meeting_id",
        kind: "scalar",
        opt: !0,
        T: 9
        /*ScalarType.STRING*/
      },
      {
        no: 2,
        name: "destination_meeting_id",
        kind: "scalar",
        opt: !0,
        T: 9
        /*ScalarType.STRING*/
      },
      { no: 3, name: "participants", kind: "message", repeat: 1, T: () => ew }
    ]);
  }
}
const sw = new tw();
class rw extends w {
  constructor() {
    super("socket.room.MovedPeer", [
      {
        no: 1,
        name: "meeting_id",
        kind: "scalar",
        opt: !0,
        T: 9
        /*ScalarType.STRING*/
      },
      {
        no: 2,
        name: "custom_participant_id",
        kind: "scalar",
        opt: !0,
        T: 9
        /*ScalarType.STRING*/
      },
      { no: 3, name: "error", kind: "message", T: () => Hc }
    ]);
  }
}
const hp = new rw();
class iw extends w {
  constructor() {
    super("socket.room.MovePeersBetweenRoomsResponse", [
      { no: 1, name: "payloads", kind: "message", repeat: 1, T: () => hp }
    ]);
  }
}
new iw();
class nw extends w {
  constructor() {
    super("socket.room.TransferPeer", [
      {
        no: 1,
        name: "meeting_id",
        kind: "scalar",
        opt: !0,
        T: 9
        /*ScalarType.STRING*/
      },
      {
        no: 2,
        name: "auth_token",
        kind: "scalar",
        opt: !0,
        T: 9
        /*ScalarType.STRING*/
      }
    ]);
  }
}
const aw = new nw();
class ow extends w {
  constructor() {
    super("socket.plugin.AddPluginRequest", [
      {
        no: 1,
        name: "plugin_id",
        kind: "scalar",
        T: 9
        /*ScalarType.STRING*/
      },
      {
        no: 2,
        name: "staggered",
        kind: "scalar",
        T: 8
        /*ScalarType.BOOL*/
      }
    ]);
  }
}
const cw = new ow();
class dw extends w {
  constructor() {
    super("socket.plugin.RemovePluginRequest", [
      {
        no: 1,
        name: "plugin_id",
        kind: "scalar",
        T: 9
        /*ScalarType.STRING*/
      },
      {
        no: 2,
        name: "staggered",
        kind: "scalar",
        T: 8
        /*ScalarType.BOOL*/
      }
    ]);
  }
}
const lw = new dw();
class uw extends w {
  constructor() {
    super("socket.plugin.EnablePluginForRoomRequest", [
      {
        no: 1,
        name: "plugin_id",
        kind: "scalar",
        T: 9
        /*ScalarType.STRING*/
      }
    ]);
  }
}
const pw = new uw();
class hw extends w {
  constructor() {
    super("socket.plugin.DisablePluginForRoomRequest", [
      {
        no: 1,
        name: "plugin_id",
        kind: "scalar",
        T: 9
        /*ScalarType.STRING*/
      }
    ]);
  }
}
const mw = new hw();
class fw extends w {
  constructor() {
    super("socket.plugin.EnablePluginForPeersRequest", [
      {
        no: 1,
        name: "plugin_id",
        kind: "scalar",
        T: 9
        /*ScalarType.STRING*/
      },
      {
        no: 2,
        name: "peer_ids",
        kind: "scalar",
        repeat: 2,
        T: 9
        /*ScalarType.STRING*/
      }
    ]);
  }
}
const gw = new fw();
class _w extends w {
  constructor() {
    super("socket.plugin.DisablePluginForPeersRequest", [
      {
        no: 1,
        name: "plugin_id",
        kind: "scalar",
        T: 9
        /*ScalarType.STRING*/
      },
      {
        no: 2,
        name: "peer_ids",
        kind: "scalar",
        repeat: 2,
        T: 9
        /*ScalarType.STRING*/
      }
    ]);
  }
}
const vw = new _w();
class Tw extends w {
  constructor() {
    super("socket.plugin.PluginEventToRoomRequest", [
      {
        no: 1,
        name: "plugin_id",
        kind: "scalar",
        T: 9
        /*ScalarType.STRING*/
      },
      {
        no: 2,
        name: "plugin_data",
        kind: "scalar",
        T: 12
        /*ScalarType.BYTES*/
      }
    ]);
  }
}
const yw = new Tw();
class Ew extends w {
  constructor() {
    super("socket.plugin.PluginEventToPeersRequest", [
      {
        no: 1,
        name: "plugin_id",
        kind: "scalar",
        T: 9
        /*ScalarType.STRING*/
      },
      {
        no: 2,
        name: "peer_ids",
        kind: "scalar",
        repeat: 2,
        T: 9
        /*ScalarType.STRING*/
      },
      {
        no: 3,
        name: "plugin_data",
        kind: "scalar",
        T: 12
        /*ScalarType.BYTES*/
      }
    ]);
  }
}
const Sw = new Ew();
class ww extends w {
  constructor() {
    super("socket.plugin.StoreKeys", [
      {
        no: 1,
        name: "store_key",
        kind: "scalar",
        T: 9
        /*ScalarType.STRING*/
      },
      {
        no: 2,
        name: "payload",
        kind: "scalar",
        opt: !0,
        T: 12
        /*ScalarType.BYTES*/
      }
    ]);
  }
}
const Bc = new ww();
class Rw extends w {
  constructor() {
    super("socket.plugin.PluginStoreInsertKeysRequest", [
      {
        no: 1,
        name: "plugin_id",
        kind: "scalar",
        T: 9
        /*ScalarType.STRING*/
      },
      {
        no: 2,
        name: "store_name",
        kind: "scalar",
        T: 9
        /*ScalarType.STRING*/
      },
      { no: 3, name: "insert_keys", kind: "message", repeat: 1, T: () => Bc }
    ]);
  }
}
const vl = new Rw();
class bw extends w {
  constructor() {
    super("socket.plugin.PluginStoreGetKeysRequest", [
      {
        no: 1,
        name: "plugin_id",
        kind: "scalar",
        T: 9
        /*ScalarType.STRING*/
      },
      {
        no: 2,
        name: "store_name",
        kind: "scalar",
        T: 9
        /*ScalarType.STRING*/
      },
      { no: 3, name: "get_keys", kind: "message", repeat: 1, T: () => Bc }
    ]);
  }
}
const Pw = new bw();
class Cw extends w {
  constructor() {
    super("socket.plugin.PluginStoreDeleteKeysRequest", [
      {
        no: 1,
        name: "plugin_id",
        kind: "scalar",
        T: 9
        /*ScalarType.STRING*/
      },
      {
        no: 2,
        name: "store_name",
        kind: "scalar",
        T: 9
        /*ScalarType.STRING*/
      },
      { no: 3, name: "delete_keys", kind: "message", repeat: 1, T: () => Bc }
    ]);
  }
}
const kw = new Cw();
class Dw extends w {
  constructor() {
    super("socket.plugin.PluginStoreDeleteRequest", [
      {
        no: 1,
        name: "plugin_id",
        kind: "scalar",
        T: 9
        /*ScalarType.STRING*/
      },
      {
        no: 2,
        name: "store_name",
        kind: "scalar",
        T: 9
        /*ScalarType.STRING*/
      }
    ]);
  }
}
const Iw = new Dw();
class Aw extends w {
  constructor() {
    super("socket.plugin.EnablePluginResponse", [
      {
        no: 1,
        name: "plugin_id",
        kind: "scalar",
        T: 9
        /*ScalarType.STRING*/
      },
      {
        no: 2,
        name: "enabled_by",
        kind: "scalar",
        T: 9
        /*ScalarType.STRING*/
      }
    ]);
  }
}
const ec = new Aw();
class Mw extends w {
  constructor() {
    super("socket.plugin.EnablePluginsResponse", [
      { no: 1, name: "plugins", kind: "message", repeat: 1, T: () => ec }
    ]);
  }
}
const Ow = new Mw();
class Nw extends w {
  constructor() {
    super("socket.plugin.DisablePluginResponse", [
      {
        no: 1,
        name: "plugin_id",
        kind: "scalar",
        T: 9
        /*ScalarType.STRING*/
      },
      {
        no: 2,
        name: "disabled_by",
        kind: "scalar",
        T: 9
        /*ScalarType.STRING*/
      }
    ]);
  }
}
const Tl = new Nw();
class Lw extends w {
  constructor() {
    super("socket.plugin.PluginStoreItem", [
      {
        no: 1,
        name: "timestamp",
        kind: "scalar",
        T: 9
        /*ScalarType.STRING*/
      },
      {
        no: 2,
        name: "peer_id",
        kind: "scalar",
        T: 9
        /*ScalarType.STRING*/
      },
      {
        no: 3,
        name: "store_key",
        kind: "scalar",
        T: 9
        /*ScalarType.STRING*/
      },
      {
        no: 4,
        name: "payload",
        kind: "scalar",
        T: 12
        /*ScalarType.BYTES*/
      }
    ]);
  }
}
const xw = new Lw();
class Uw extends w {
  constructor() {
    super("socket.plugin.PluginStoreResponse", [
      {
        no: 1,
        name: "plugin_id",
        kind: "scalar",
        T: 9
        /*ScalarType.STRING*/
      },
      {
        no: 2,
        name: "store_name",
        kind: "scalar",
        T: 9
        /*ScalarType.STRING*/
      },
      { no: 3, name: "store_items", kind: "message", repeat: 1, T: () => xw }
    ]);
  }
}
const yl = new Uw();
class Vw extends w {
  constructor() {
    super("socket.plugin.PluginEventResponse", [
      {
        no: 1,
        name: "plugin_id",
        kind: "scalar",
        T: 9
        /*ScalarType.STRING*/
      },
      {
        no: 2,
        name: "plugin_data",
        kind: "scalar",
        T: 12
        /*ScalarType.BYTES*/
      }
    ]);
  }
}
const El = new Vw();
class Fw extends w {
  constructor() {
    super("socket.livestreaming.LiveStreamingEvent", [
      {
        no: 1,
        name: "livestream_id",
        kind: "scalar",
        T: 9
        /*ScalarType.STRING*/
      },
      {
        no: 2,
        name: "err_message",
        kind: "scalar",
        T: 9
        /*ScalarType.STRING*/
      },
      {
        no: 3,
        name: "name",
        kind: "scalar",
        T: 9
        /*ScalarType.STRING*/
      },
      {
        no: 4,
        name: "meeting_id",
        kind: "scalar",
        T: 9
        /*ScalarType.STRING*/
      },
      {
        no: 5,
        name: "playback_url",
        kind: "scalar",
        T: 9
        /*ScalarType.STRING*/
      },
      {
        no: 6,
        name: "org_id",
        kind: "scalar",
        T: 9
        /*ScalarType.STRING*/
      },
      {
        no: 7,
        name: "room_name",
        kind: "scalar",
        T: 9
        /*ScalarType.STRING*/
      },
      {
        no: 8,
        name: "room_uuid",
        kind: "scalar",
        T: 9
        /*ScalarType.STRING*/
      },
      {
        no: 9,
        name: "status",
        kind: "scalar",
        T: 9
        /*ScalarType.STRING*/
      }
    ]);
  }
}
const Sl = new Fw();
class jw extends w {
  constructor() {
    super("socket.livestreaming.GetStagePeersResponse", [
      {
        no: 1,
        name: "stage_peers",
        kind: "scalar",
        repeat: 2,
        T: 9
        /*ScalarType.STRING*/
      }
    ]);
  }
}
const wl = new jw();
class $w extends w {
  constructor() {
    super("socket.livestreaming.StageRequest", [
      {
        no: 1,
        name: "display_name",
        kind: "scalar",
        T: 9
        /*ScalarType.STRING*/
      },
      {
        no: 2,
        name: "user_id",
        kind: "scalar",
        T: 9
        /*ScalarType.STRING*/
      },
      {
        no: 3,
        name: "peer_id",
        kind: "scalar",
        T: 9
        /*ScalarType.STRING*/
      }
    ]);
  }
}
const Hw = new $w();
class Bw extends w {
  constructor() {
    super("socket.livestreaming.GetStageRequestsResponse", [
      { no: 1, name: "stage_requests", kind: "message", repeat: 1, T: () => Hw }
    ]);
  }
}
const Fo = new Bw();
class qw extends w {
  constructor() {
    super("socket.livestreaming.GrantStageAccessRequest", [
      {
        no: 1,
        name: "user_ids",
        kind: "scalar",
        repeat: 2,
        T: 9
        /*ScalarType.STRING*/
      }
    ]);
  }
}
const Gw = new qw();
class Ww extends w {
  constructor() {
    super("socket.livestreaming.DenyStageAccessRequest", [
      {
        no: 1,
        name: "user_ids",
        kind: "scalar",
        repeat: 2,
        T: 9
        /*ScalarType.STRING*/
      }
    ]);
  }
}
const Jw = new Ww();
class Kw extends w {
  constructor() {
    super("socket.livestreaming.LeaveStageRequest", [
      {
        no: 1,
        name: "user_ids",
        kind: "scalar",
        repeat: 2,
        T: 9
        /*ScalarType.STRING*/
      }
    ]);
  }
}
const Rl = new Kw();
class zw extends w {
  constructor() {
    super("socket.polls.Poll", [
      {
        no: 1,
        name: "poll_id",
        kind: "scalar",
        T: 9
        /*ScalarType.STRING*/
      },
      {
        no: 2,
        name: "created_by",
        kind: "scalar",
        T: 9
        /*ScalarType.STRING*/
      },
      {
        no: 3,
        name: "created_by_user_id",
        kind: "scalar",
        T: 9
        /*ScalarType.STRING*/
      },
      {
        no: 4,
        name: "question",
        kind: "scalar",
        T: 9
        /*ScalarType.STRING*/
      },
      { no: 5, name: "options", kind: "message", repeat: 1, T: () => Yw },
      {
        no: 6,
        name: "hide_votes",
        kind: "scalar",
        T: 8
        /*ScalarType.BOOL*/
      },
      {
        no: 7,
        name: "anonymous",
        kind: "scalar",
        T: 8
        /*ScalarType.BOOL*/
      },
      {
        no: 8,
        name: "votes",
        kind: "scalar",
        repeat: 2,
        T: 9
        /*ScalarType.STRING*/
      }
    ]);
  }
}
const mp = new zw();
class Qw extends w {
  constructor() {
    super("socket.polls.PollOption", [
      {
        no: 1,
        name: "text",
        kind: "scalar",
        T: 9
        /*ScalarType.STRING*/
      },
      {
        no: 2,
        name: "count",
        kind: "scalar",
        opt: !0,
        T: 4,
        L: 2
        /*LongType.NUMBER*/
      },
      { no: 3, name: "votes", kind: "message", repeat: 1, T: () => Xw }
    ]);
  }
}
const Yw = new Qw();
class Zw extends w {
  constructor() {
    super("socket.polls.PollVote", [
      {
        no: 1,
        name: "user_id",
        kind: "scalar",
        T: 9
        /*ScalarType.STRING*/
      },
      {
        no: 2,
        name: "name",
        kind: "scalar",
        T: 9
        /*ScalarType.STRING*/
      }
    ]);
  }
}
const Xw = new Zw();
class eR extends w {
  constructor() {
    super("socket.polls.NewPollRequest", [
      {
        no: 1,
        name: "question",
        kind: "scalar",
        T: 9
        /*ScalarType.STRING*/
      },
      {
        no: 2,
        name: "options",
        kind: "scalar",
        repeat: 2,
        T: 9
        /*ScalarType.STRING*/
      },
      {
        no: 3,
        name: "anonymous",
        kind: "scalar",
        T: 8
        /*ScalarType.BOOL*/
      },
      {
        no: 4,
        name: "hide_votes",
        kind: "scalar",
        T: 8
        /*ScalarType.BOOL*/
      },
      {
        no: 5,
        name: "created_by",
        kind: "scalar",
        opt: !0,
        T: 9
        /*ScalarType.STRING*/
      },
      {
        no: 6,
        name: "created_by_user_id",
        kind: "scalar",
        opt: !0,
        T: 9
        /*ScalarType.STRING*/
      }
    ]);
  }
}
const tR = new eR();
class sR extends w {
  constructor() {
    super("socket.polls.VotePollRequest", [
      {
        no: 1,
        name: "poll_id",
        kind: "scalar",
        T: 9
        /*ScalarType.STRING*/
      },
      {
        no: 2,
        name: "index",
        kind: "scalar",
        T: 4,
        L: 2
        /*LongType.NUMBER*/
      }
    ]);
  }
}
const rR = new sR();
class iR extends w {
  constructor() {
    super("socket.polls.UpdatePollResponse", [
      { no: 1, name: "poll", kind: "message", T: () => mp }
    ]);
  }
}
const jo = new iR();
class nR extends w {
  constructor() {
    super("socket.polls.GetPollsResponse", [
      { no: 1, name: "polls", kind: "message", repeat: 1, T: () => mp }
    ]);
  }
}
const aR = new nR();
var tc;
(function(r) {
  r[r.ACTION = 0] = "ACTION", r[r.RESPONSE = 1] = "RESPONSE", r[r.EVENT = 2] = "EVENT";
})(tc || (tc = {}));
var sc;
(function(r) {
  r[r.SERVICE_NOT_FOUND = 0] = "SERVICE_NOT_FOUND", r[r.PARAMETER_VALIDATION_ERROR = 1] = "PARAMETER_VALIDATION_ERROR", r[r.TIMEOUT_ERROR = 2] = "TIMEOUT_ERROR", r[r.APPLICATION_ERROR = 3] = "APPLICATION_ERROR";
})(sc || (sc = {}));
class oR extends w {
  constructor() {
    super("bridge.BridgeMessage", [
      { no: 1, name: "type", kind: "enum", T: () => ["bridge.BridgeMessageType", tc] },
      { no: 2, name: "action", kind: "message", oneof: "data", T: () => dR },
      { no: 3, name: "response", kind: "message", oneof: "data", T: () => uR },
      { no: 4, name: "event", kind: "message", oneof: "data", T: () => fR }
    ]);
  }
}
new oR();
class cR extends w {
  constructor() {
    super("bridge.BridgeAction", [
      {
        no: 1,
        name: "action",
        kind: "scalar",
        T: 9
        /*ScalarType.STRING*/
      },
      {
        no: 2,
        name: "params",
        kind: "scalar",
        T: 9
        /*ScalarType.STRING*/
      }
    ]);
  }
}
const dR = new cR();
class lR extends w {
  constructor() {
    super("bridge.BridgeResponse", [
      {
        no: 1,
        name: "success",
        kind: "scalar",
        T: 8
        /*ScalarType.BOOL*/
      },
      {
        no: 2,
        name: "response",
        kind: "scalar",
        T: 9
        /*ScalarType.STRING*/
      },
      { no: 3, name: "error", kind: "message", T: () => hR }
    ]);
  }
}
const uR = new lR();
class pR extends w {
  constructor() {
    super("bridge.BridgeError", [
      { no: 1, name: "type", kind: "enum", T: () => ["bridge.ErrorType", sc] },
      {
        no: 2,
        name: "message",
        kind: "scalar",
        T: 9
        /*ScalarType.STRING*/
      }
    ]);
  }
}
const hR = new pR();
class mR extends w {
  constructor() {
    super("bridge.BridgeEvent", [
      {
        no: 1,
        name: "event",
        kind: "scalar",
        T: 9
        /*ScalarType.STRING*/
      },
      {
        no: 2,
        name: "params",
        kind: "scalar",
        T: 9
        /*ScalarType.STRING*/
      }
    ]);
  }
}
const fR = new mR();
class gR extends w {
  constructor() {
    super("google.protobuf.Timestamp", [
      {
        no: 1,
        name: "seconds",
        kind: "scalar",
        T: 3,
        L: 0
        /*LongType.BIGINT*/
      },
      {
        no: 2,
        name: "nanos",
        kind: "scalar",
        T: 5
        /*ScalarType.INT32*/
      }
    ]);
  }
  /**
   * Creates a new `Timestamp` for the current time.
   */
  now() {
    const e = this.create(), t = Date.now();
    return e.seconds = on.from(Math.floor(t / 1e3)).toBigInt(), e.nanos = t % 1e3 * 1e6, e;
  }
  /**
   * Converts a `Timestamp` to a JavaScript Date.
   */
  toDate(e) {
    return new Date(on.from(e.seconds).toNumber() * 1e3 + Math.ceil(e.nanos / 1e6));
  }
  /**
   * Converts a JavaScript Date to a `Timestamp`.
   */
  fromDate(e) {
    const t = this.create(), s = e.getTime();
    return t.seconds = on.from(Math.floor(s / 1e3)).toBigInt(), t.nanos = s % 1e3 * 1e6, t;
  }
  /**
   * In JSON format, the `Timestamp` type is encoded as a string
   * in the RFC 3339 format.
   */
  internalJsonWrite(e, t) {
    let s = on.from(e.seconds).toNumber() * 1e3;
    if (s < Date.parse("0001-01-01T00:00:00Z") || s > Date.parse("9999-12-31T23:59:59Z"))
      throw new Error("Unable to encode Timestamp to JSON. Must be from 0001-01-01T00:00:00Z to 9999-12-31T23:59:59Z inclusive.");
    if (e.nanos < 0)
      throw new Error("Unable to encode invalid Timestamp to JSON. Nanos must not be negative.");
    let i = "Z";
    if (e.nanos > 0) {
      let n = (e.nanos + 1e9).toString().substring(1);
      n.substring(3) === "000000" ? i = "." + n.substring(0, 3) + "Z" : n.substring(6) === "000" ? i = "." + n.substring(0, 6) + "Z" : i = "." + n + "Z";
    }
    return new Date(s).toISOString().replace(".000Z", i);
  }
  /**
   * In JSON format, the `Timestamp` type is encoded as a string
   * in the RFC 3339 format.
   */
  internalJsonRead(e, t, s) {
    if (typeof e != "string")
      throw new Error("Unable to parse Timestamp from JSON " + lh(e) + ".");
    let i = e.match(/^([0-9]{4})-([0-9]{2})-([0-9]{2})T([0-9]{2}):([0-9]{2}):([0-9]{2})(?:Z|\.([0-9]{3,9})Z|([+-][0-9][0-9]:[0-9][0-9]))$/);
    if (!i)
      throw new Error("Unable to parse Timestamp from JSON. Invalid format.");
    let n = Date.parse(i[1] + "-" + i[2] + "-" + i[3] + "T" + i[4] + ":" + i[5] + ":" + i[6] + (i[8] ? i[8] : "Z"));
    if (Number.isNaN(n))
      throw new Error("Unable to parse Timestamp from JSON. Invalid value.");
    if (n < Date.parse("0001-01-01T00:00:00Z") || n > Date.parse("9999-12-31T23:59:59Z"))
      throw new globalThis.Error("Unable to parse Timestamp from JSON. Must be from 0001-01-01T00:00:00Z to 9999-12-31T23:59:59Z inclusive.");
    return s || (s = this.create()), s.seconds = on.from(n / 1e3).toBigInt(), s.nanos = 0, i[7] && (s.nanos = parseInt("1" + i[7] + "0".repeat(9 - i[7].length)) - 1e9), s;
  }
}
new gR();
const _R = 3, vR = 30, TR = 8e3;
class yR {
  constructor(e) {
    h(this, "ipInfo");
    h(this, "axios");
    h(this, "requests");
    h(this, "roomName");
    h(this, "roomUUID");
    h(this, "peerId");
    h(this, "authToken");
    h(this, "organizationId");
    const {
      timeout: t = TR,
      retry: s = _R,
      retryDelay: i = vR,
      baseURL: n = "https://api.cluster.dyte.in",
      authToken: a
    } = e || {};
    this.requests = Pa.create({
      baseURL: n,
      responseType: "json",
      timeout: t,
      retry: s,
      retryDelay: i
    }), this.axios = Pa, this.setAuthToken(a, { bearer: !0 }), this.requests.interceptors.request.use((o) => (_.injectContext(this.requests.defaults.headers.common), o), async (o) => {
      f.error("xhr::axios", { debuggingHint: "otelRequestInterceptor failed.", error: o });
    }), this.requests.interceptors.response.use((o) => (o.config.url !== _.logsEndpoint && f.debug("xhr::axios", {
      // Note(ravindra-dyte): Do not Log entire data, log what is needed
      networkCall: {
        status: o.status,
        statusText: o.statusText,
        baseURL: o.config.baseURL,
        url: o.config.url,
        method: o.config.method
      }
    }), o), async (o) => {
      var l;
      if (!o)
        return Promise.reject(new Error("Unknown error occurred"));
      o && o.config && ((l = o.config) == null ? void 0 : l.url) !== _.logsEndpoint && f.error("xhr::axios", {
        error: o,
        networkCall: {
          status: o.status,
          statusText: o.statusText,
          baseURL: o.config.baseURL,
          url: o.config.url,
          retries: o.config.retry,
          method: o.config.method,
          isOnline: navigator.onLine ? "online" : "offline"
        }
      });
      const { config: d, message: p } = o;
      return d && p && d.retry !== void 0 && d.retry > 0 && (p.includes("timeout") || p.includes("Network Error")) ? (d.retry -= 1, d.baseURL === "https://api.cluster.dyte.in" ? d.baseURL = "https://network2.dyte.io" : d.baseURL === "https://network2.dyte.io" && (d.baseURL = "https://api.cluster.dyte.in"), this.requests(d)) : Promise.reject(o);
    });
  }
  setAuthToken(e, t) {
    const { bearer: s } = t || {};
    this.authToken = e, this.requests.defaults.headers.common.Authorization = s ? `Bearer ${e}` : e;
  }
  setHeader(e, t) {
    this.requests.defaults.headers.common[e] = t;
  }
  setRoomName(e) {
    this.roomName = e;
  }
  setRoomUUID(e) {
    this.roomUUID = e;
  }
  setPeerId(e) {
    this.peerId = e;
  }
  setOrganizationId(e) {
    this.organizationId = e;
  }
}
var ER = Object.defineProperty, SR = Object.getOwnPropertyDescriptor, fp = (r, e, t, s) => {
  for (var i = s > 1 ? void 0 : s ? SR(e, t) : e, n = r.length - 1, a; n >= 0; n--)
    (a = r[n]) && (i = (s ? a(e, t, i) : a(i)) || i);
  return s && i && ER(e, t, i), i;
};
class fo extends yR {
  constructor(e) {
    super(e), this.setHeader("x-dyte-web-core-version", La);
  }
  async getIPDetails({ peerId: e }) {
    var t;
    try {
      const i = (await this.requests.get("https://media-location.dyte.io")).data;
      if (((t = i.loc) == null ? void 0 : t.length) > 5)
        return i;
      throw Error("Insufficient data");
    } catch (s) {
      f.error("getIPDetails::failed");
    }
    try {
      const s = await Rc.getIPDetails({ peerId: e });
      return f.info("gotIPDetails", { networkCall: { ip: s.ip, timezone: s.timezone } }), s;
    } catch (s) {
      f.warn(
        "ApiClient.getRoomNodeLinkAndTitleV1 Failed to get ip details",
        { error: { name: s.name, message: s.message } }
      );
      return;
    }
  }
  async getICEServers() {
    const { success: e, iceServers: t } = (await this.requests.get("/iceservers")).data;
    if (e)
      return t;
  }
  async getPlugins(e) {
    var n, a, o, d, p, l, u;
    let { plugins: t } = (await this.requests.get("/v2/plugins/user")).data.data;
    const s = ((a = (n = M.getValue(N.V1_PLUGINS)) == null ? void 0 : n.toString()) == null ? void 0 : a.split(",")) || [], i = t.reduce((m, g) => (m[s.includes(g.id) ? "v1" : "v2"].push(g), m), { v1: [], v2: [] });
    return e === "socket-service" ? t = i.v2 : t = i.v1, (p = (d = (o = ue.modules) == null ? void 0 : o.devTools) == null ? void 0 : d.plugins) != null && p.length && ((u = (l = ue.modules) == null ? void 0 : l.devTools) == null || u.plugins.forEach((m) => {
      var T, S, R;
      const g = {
        ...dn,
        tags: [...dn.tags]
      };
      g.baseURL = `http://localhost:${m.port}`, g.name = m.name, g.picture = (T = m.picture) != null ? T : dn.picture, g.description = (S = m.description) != null ? S : dn.description, g.staggered = (R = m.staggered) != null ? R : dn.staggered, g.createdAt = new Date().toISOString(), g.updatedAt = new Date().toISOString(), g.id = m.id, g.organizationId = this.organizationId, t.push(g);
    })), t;
  }
  async getPluginDetails(e) {
    const { plugin: t } = (await this.requests.get(`/v2/plugins/view/${e}`)).data.data;
    return t;
  }
  async getPluginConfig(e) {
    return (await this.axios.get(`${e}/dyte-config.json`)).data;
  }
  async authorizePlugin(e) {
    const t = {
      peerId: this.peerId
    };
    te.isV2AuthToken || (t.roomName = this.roomName);
    const { token: s } = (await this.requests.post(`/v2/plugins/authorize/${e}`, t)).data.data;
    return s;
  }
  async getPresignedUrls(e) {
    const { getLocation: t, putLocation: s } = (await this.requests.post("/v1/meetings/genPreSignedUploadUrl", {
      roomUUID: this.roomUUID,
      filename: e
    })).data.data;
    return {
      getLocation: t,
      putLocation: s
    };
  }
  async uploadFile(e, t) {
    await this.axios.put(t, e, {
      headers: {
        "Content-Type": e.type
      }
    });
  }
}
fp([
  _.trace("APIClient.getIPDetails")
], fo.prototype, "getIPDetails", 1);
fp([
  _.trace("APIClient.getICEServers")
], fo.prototype, "getICEServers", 1);
var wR = Object.defineProperty, RR = Object.getOwnPropertyDescriptor, Xi = (r, e, t, s) => {
  for (var i = s > 1 ? void 0 : s ? RR(e, t) : e, n = r.length - 1, a; n >= 0; n--)
    (a = r[n]) && (i = (s ? a(e, t, i) : a(i)) || i);
  return s && i && wR(e, t, i), i;
};
class Xr extends fo {
  // eslint-disable-next-line class-methods-use-this
  async startLivestreaming() {
    var t, s;
    return (s = (t = (await this.requests.post(`/v2/meetings/${te.meetingId}/livestreams`)).data) == null ? void 0 : t.data) == null ? void 0 : s.playback_url;
  }
  // eslint-disable-next-line class-methods-use-this
  async stopLivestreaming() {
    return this.requests.post(`/v2/meetings/${te.meetingId}/active-livestream/stop`);
  }
  async getActiveLivestream() {
    const { playbackUrl: e, status: t } = Wt((await this.requests.get(`/v2/meetings/${te.meetingId}/active-livestream`)).data.data);
    return { status: t, playbackUrl: e };
  }
  async getUserDetails() {
    const e = (await this.requests.get("v2/internals/participant-details")).data.data;
    return Wt(e);
  }
  // eslint-disable-next-line
  getUserPreset(e) {
    throw new Error("getUserPreset does not exist for v2");
  }
  async startRecording(e) {
    return (await this.requests.post("/v2/recordings", {
      ...np(e),
      meeting_id: te.meetingId
    })).data.id;
  }
  stopRecording(e) {
    return this.requests.put(
      `v2/recordings/${e}`,
      { action: "stop" }
    );
  }
  async getActiveRecording() {
    const { status: e, id: t } = (await this.requests.get(`v2/recordings/active-recording/${te.meetingId}`)).data.data;
    return { status: e, id: t };
  }
  async getRoomNodeData({ peerId: e }) {
    const t = await this.getIPDetails({ peerId: e });
    this.ipInfo = t;
    const { roomNodeLink: s, title: i, useHiveMedia: n } = Wt((await this.requests.post("v2/internals/rooms", {
      ip_information: t
    })).data.data);
    return {
      roomNodeUrl: s,
      meetingTitle: i,
      useHiveMedia: n != null ? n : !1
    };
  }
}
Xi([
  _.trace("APIClient.getUserDetails")
], Xr.prototype, "getUserDetails", 1);
Xi([
  _.trace("APIClient.getUserPreset")
], Xr.prototype, "getUserPreset", 1);
Xi([
  _.trace("APIClient.startRecording")
], Xr.prototype, "startRecording", 1);
Xi([
  _.trace("APIClient.stopRecording")
], Xr.prototype, "stopRecording", 1);
Xi([
  _.trace("APIClient.getActiveRecording")
], Xr.prototype, "getActiveRecording", 1);
Xi([
  _.trace("APIClient.getRoomNodeData")
], Xr.prototype, "getRoomNodeData", 1);
var bR = Object.defineProperty, PR = Object.getOwnPropertyDescriptor, en = (r, e, t, s) => {
  for (var i = s > 1 ? void 0 : s ? PR(e, t) : e, n = r.length - 1, a; n >= 0; n--)
    (a = r[n]) && (i = (s ? a(e, t, i) : a(i)) || i);
  return s && i && bR(e, t, i), i;
};
class ei extends fo {
  startLivestreaming() {
    throw new Error("Method not implemented.");
  }
  stopLivestreaming() {
    throw new Error("Method not implemented.");
  }
  getActiveLivestream() {
    throw new Error("Method not implemented.");
  }
  async getUserDetails() {
    const { user: e } = (await this.requests.get("/auth/basicUserDetails")).data;
    return e;
  }
  async getUserPreset(e) {
    const { preset: t } = (await this.requests.post("/v1/userpreset", {
      roomName: e,
      authToken: this.authToken,
      // TODO: remove the hardcoded version and clientType params
      clientType: "CLIENT_APP",
      version: "0.5.0"
    })).data.data;
    return Wt(t);
  }
  async startRecording(e) {
    const t = await this.requests.post(`/v1/organizations/${this.organizationId}/rooms/${this.roomName}/recording`, e);
    if (t.status !== 201)
      throw new Error("Recording failed to start");
    return t.data.data.recording.id;
  }
  async stopRecording(e) {
    if ((await this.requests.put(
      `/v1/organizations/${this.organizationId}/rooms/${this.roomName}/recordings/${e}`,
      { recordingAction: "stop" }
    )).status !== 201)
      throw new Error("Recording failed to stop");
  }
  async getActiveRecording() {
    return this.organizationId ? (await this.requests.get(`/v1/organizations/${this.organizationId}/rooms/${this.roomName}/active-recording?limit=50`)).data.data.recording : {};
  }
  async getRoomNodeData({ roomName: e, peerId: t }) {
    const s = `
        query Session($roomName: String!, $password: String, $ipInformation: String) {
            session(roomName: $roomName, password: $password) {
              title,
              roomNodeLink(ipInformation: $ipInformation),
              useHiveMedia,
              roomName,
              password
            }
          }
        `, i = await this.getIPDetails({ peerId: t });
    this.ipInfo = i;
    const { roomNodeLink: n, title: a, useHiveMedia: o } = (await this.requests.post("/graphql", {
      query: s,
      variables: { roomName: e, ipInformation: JSON.stringify(i) }
    })).data.data.session;
    return {
      roomNodeUrl: n,
      meetingTitle: a,
      useHiveMedia: o != null ? o : !1
    };
  }
}
en([
  _.trace("APIClientV1.getUserDetails")
], ei.prototype, "getUserDetails", 1);
en([
  _.trace("APIClientV1.getUserPreset")
], ei.prototype, "getUserPreset", 1);
en([
  _.trace("APIClientV1.startRecording")
], ei.prototype, "startRecording", 1);
en([
  _.trace("APIClientV1.stopRecording")
], ei.prototype, "stopRecording", 1);
en([
  _.trace("APIClientV1.getActiveRecording")
], ei.prototype, "getActiveRecording", 1);
en([
  _.trace("APIClientV1.getRoomNodeData")
], ei.prototype, "getRoomNodeData", 1);
let rc;
function CR(r) {
  return rc = te.isV2AuthToken ? new Xr(r) : new ei(r), rc;
}
function ct() {
  return rc;
}
const kR = 0, DR = 1, IR = 2, AR = 3, MR = {
  getPeerInfo: 0,
  updatePeerInfo: 1,
  getRoomPeersInfo: 2,
  joinRoom: 3,
  leaveRoom: 4,
  getRoomInfo: 5,
  updateRoomInfo: 6,
  closeRoom: 7,
  startedLivestream: 8,
  stoppedLivestream: 9,
  erroredLivestream: 10,
  getStagePeers: 11,
  getStageRequests: 12,
  requestStageAccess: 13,
  cancelStageRequest: 14,
  grantStageAccess: 15,
  denyStageAccess: 16,
  roomPeerCount: 17,
  joinStage: 18,
  leaveStage: 19,
  // getConnectedRoomsDump returns entire dump for a breakout rooms meeting
  // This details which peer is in which meeting currently, and which is the parent meeting
  getConnectedRoomsDump: 20,
  // createConnectedRooms to create breakout rooms
  createConnectedRooms: 21,
  // deleteConnectedRooms to delete breakout rooms
  deleteConnectedRooms: 22,
  // move peers between breakout rooms
  movePeers: 23,
  // transfer peer to new room
  transferPeer: 24,
  // message sent by socket service to inform client of a participant joining a breakout room
  movedPeer: 25,
  // message sent by socket service to inform client of updates in connected rooms
  connectedRoomsUpdated: 26,
  // message sent by socket service to inform client of deletion in connected rooms
  connectedRoomsDeleted: 27
}, OR = {
  getMessages: 0,
  sendMessageToRoom: 1,
  sendMessageToPeers: 2,
  editMessage: 3,
  deleteMessage: 4,
  getPaginatedMessages: 5
}, NR = {
  getPlugins: 0,
  addPlugin: 1,
  enablePluginForRoom: 2,
  disablePluginForPeers: 3,
  enablePluginForPeers: 4,
  disablePluginForRoom: 5,
  removePlugin: 6,
  customPluginEventToRoom: 7,
  customPluginEventToPeers: 8,
  storeInsertKeys: 9,
  storeGetKeys: 10,
  storeDeleteKeys: 11,
  storeDelete: 12
}, LR = {
  createPoll: 0,
  getPolls: 1,
  votePoll: 2,
  updatePoll: 3
}, xR = {
  unknown: 0,
  createWebRTCTransport: 1,
  produce: 2,
  consume: 3,
  toggleProducer: 4,
  toggleConsumer: 5,
  closeProducer: 6,
  closeConsumer: 7,
  // adding some buffers for new media events.
  joinRoom: 16,
  leaveRoom: 17,
  selectedPeer: 18,
  globalPinPeer: 19,
  selfJoinComplete: 20,
  // some additional buffer for broadcast events.
  peerJoinedBroadcast: 25,
  peerLeaveBroadcast: 26,
  peerProducerCreateBroadcast: 27,
  peerProducerToggleBroadcast: 28,
  peerProducerCloseBroadcast: 29,
  globalPeerPinBroadcast: 30,
  recordingStartedBroadcast: 31,
  recordingStoppedBroadcast: 32,
  peerDisplayNameEditBroadcast: 33,
  selectedPeerDiff: 40,
  renegotiateSessionDescription: 50,
  kickPeer: 90,
  kickAll: 91,
  changeDisplayName: 92,
  hostControlPeer: 93,
  hostControlAllPeers: 94
};
function go(r, e) {
  return Object.keys(e).reduce((t, s) => (t[s] = (r << 16) + e[s], t), {});
}
function UR(r) {
  return Object.keys(r).reduce((e, t) => (e[t] = 16777216 | r[t], e), {});
}
const ce = go(kR, MR), Et = go(DR, OR), $ = go(
  IR,
  NR
), Ss = go(AR, LR), me = UR(xR);
var Wa;
class gp {
  constructor() {
    h(this, "meetingTitle");
    h(this, "roomName");
    h(this, "roomUUID");
    h(this, "isDisconnected");
    // sfuHandler: any;
    h(this, "roomJoined");
    b(this, Wa, void 0);
    h(this, "peerId");
    h(this, "authToken");
    h(this, "maxPreferredStreams");
  }
  get sfuHandler() {
    return c(this, Wa);
  }
  reconnect() {
    throw new E("Method not implemented.");
  }
  async joinRoom(e, t, s, i, n = {}) {
    throw new E("Method not implemented.");
  }
  async leaveRoom() {
    throw new E("Method not implemented.");
  }
  async handleSocketCallbacks(e) {
    throw new E("Method not implemented.");
  }
  async handleSockets(e, t) {
    throw new E("Method not implemented.");
  }
  async shareMic(e) {
    throw new E("Method not implemented.");
  }
  async shareWebcam(e) {
    throw new E("Method not implemented.");
  }
  async shareScreen(e) {
    throw new E("Method not implemented.");
  }
  async unmuteSelf() {
    throw new E("Method not implemented.");
  }
  async muteSelf() {
    throw new E("Method not implemented.");
  }
  async pauseWebcam() {
    throw new E("Method not implemented.");
  }
  async disableScreenShare() {
    throw new E("Method not implemented.");
  }
  async acceptWaitingRequest(e) {
    throw new E("Method not implemented.");
  }
  async rejectWaitingRequest(e) {
    throw new E("Method not implemented.");
  }
  async muteAll(e) {
    throw new E("Method not implemented.");
  }
  async muteAllVideo() {
    throw new E("Method not implemented.");
  }
  async disableAudio(e) {
    throw new E("Method not implemented.");
  }
  async disableVideo(e) {
    throw new E("Method not implemented.");
  }
  async kickAll() {
    throw new E("Method not implemented.");
  }
  async kick(e) {
    throw new E("Method not implemented.");
  }
  async pinPeer(e) {
    throw new E("Method not implemented.");
  }
  async getChatMessages() {
    throw new E("Method not implemented.");
  }
  async requestRemoteControl(e) {
    throw new E("Method not implemented.");
  }
  async acceptRemoteControl(e) {
    throw new E("Method not implemented.");
  }
  async terminateRemoteControl(e, t) {
    throw new E("Method not implemented.");
  }
  async sendEventRemoteControl(e, t, s) {
    throw new E("Method not implemented.");
  }
  async getPolls() {
    throw new E("Method not implemented.");
  }
  async newPoll(e) {
    throw new E("Method not implemented.");
  }
  async votePoll(e) {
    throw new E("Method not implemented.");
  }
  async getPage(e) {
    throw new E("Method not implemented.");
  }
  getConsumers() {
    throw new E("Method not implemented.");
  }
  async sendMessage(e) {
    throw new E("Method not implemented.");
  }
  async getRoomState() {
    throw new E("Method not implemented.");
  }
  async addRoomPlugin(e) {
    throw new E("Method not implemented.");
  }
  async removeRoomPlugin(e) {
    throw new E("Method not implemented.");
  }
  async unpinChatMessage(e) {
    throw new E("Method not implemented.");
  }
  async pinChatMessage(e) {
    throw new E("Method not implemented.");
  }
  async sendChatMessage(e) {
    throw new E("Method not implemented.");
  }
  async broadcastMessage(e, t) {
    throw new E("Method not implemented.");
  }
  async acceptAllRequestToJoinStage(e) {
    throw new E("Method not implemented.");
  }
  async stopPresenting() {
    throw new E("Method not implemented.");
  }
  async startPresenting() {
    throw new E("Method not implemented.");
  }
  async requestToJoinStage(e) {
    throw new E("Method not implemented.");
  }
  async rejectRequestToJoinStage(e) {
    throw new E("Method not implemented.");
  }
  async withdrawRequestToJoinStage() {
    throw new E("Method not implemented.");
  }
  async removePeerFromStage(e, t) {
    throw new E("Method not implemented.");
  }
  stopAllProducers() {
    throw new E("Method not implemented.");
  }
}
Wa = new WeakMap();
class VR extends bt.EventEmitter {
}
class St {
  constructor(e) {
    h(this, "_name");
    this._name = e;
  }
  /**
   * getLogger is for creating an instance of Logger with name
   * appended in the log
   * @param name takes string value to append before the log
   * @returns Logger
   */
  static getLogger(e) {
    return new St(e);
  }
  /**
   * format takes a format string where we can have format specifiers
   * and list of arguments to replace the format specifiers with.
   * format specifiers can be %s for string, %d for number, %o for object.
   * @param s is the format string with or without format specifiers
   * @param args heterogeneous list of values to be replaced or appended
   * on the format string
   * @returns formatted string
   */
  static format(e, ...t) {
    const s = e.split("%");
    let i = e;
    s.length && ([i] = s), t.reverse();
    for (let n = 1; n < s.length && t.length; n += 1) {
      const a = t.pop();
      let o = s[n];
      switch (o.at(0)) {
        case "s":
          o = o.replace("s", a);
          break;
        case "d":
          o = o.replace("d", a.toString());
          break;
        case "o":
          o = o.replace("o", JSON.stringify(a, null, 2));
          break;
      }
      i = `${i}${o}`;
    }
    return t.length && t.reverse().forEach((n) => {
      i = `${i} ${n instanceof Object ? JSON.stringify(n, null, 2) : n}`;
    }), i;
  }
  info(e, ...t) {
    let s = St.format(e, ...t);
    this._name && (s = `${this._name}::${s}`), f.info(s);
  }
  debug(e, ...t) {
    let s = St.format(e, ...t);
    this._name && (s = `${this._name}::${s}`), f.info(s);
  }
  warn(e, ...t) {
    let s = St.format(e, ...t);
    this._name && (s = `${this._name}::${s}`), f.info(s);
  }
  error(e, ...t) {
    let s = St.format(e, ...t);
    this._name && (s = `${this._name}::${s}`), f.error(s);
  }
}
const bl = St.getLogger("EnhancedEventEmitter");
class zr extends bt.EventEmitter {
  constructor() {
    super(), this.setMaxListeners(1 / 0);
  }
  safeEmit(e, ...t) {
    const s = this.listenerCount(e);
    try {
      return this.emit(e, ...t);
    } catch (i) {
      return bl.error(
        "safeEmit() | event listener threw an error [event:%s]:%o",
        e,
        i
      ), Boolean(s);
    }
  }
  async safeEmitAsPromise(e, ...t) {
    const s = {}.EVENT_PROMISE_TIMEOUT ? parseInt({}.EVENT_PROMISE_TIMEOUT, 10) : 1e4;
    return this.safeEmitAsPromiseWithTimeout(e, s, ...t);
  }
  async safeEmitAsPromiseWithTimeout(e, t, ...s) {
    return new Promise((i, n) => {
      setTimeout(n, t, "event request timeout");
      try {
        this.emit(e, ...s, i, n);
      } catch (a) {
        bl.error(
          "safeEmitAsPromise() | event listener threw an error [event:%s]:%o",
          e,
          a
        ), n(a);
      }
    });
  }
}
class qc extends zr {
  // eslint-disable-next-line no-useless-constructor
  constructor() {
    super();
    // Map of RTCTransceivers indexed by MID.
    h(this, "_mapMidTransceiver", /* @__PURE__ */ new Map());
    this._mapMidTransceiver = /* @__PURE__ */ new Map();
  }
  get midTransceiverMap() {
    return this._mapMidTransceiver;
  }
}
const ne = St.getLogger("Chrome74");
class Gc extends qc {
  // static async getNativeRtpCapabilities(): Promise<RTCRtpCapabilities> {
  //     logger.debug('getNativeRtpCapabilities()');
  //     const pc = new (RTCPeerConnection as any)(
  //         {
  //             iceServers: [],
  //             bundlePolicy: 'max-bundle',
  //             rtcpMuxPolicy: 'require',
  //             iceTransportPolicy: 'all',
  //             sdpSemantics: 'unified-plan',
  //         },
  //     );
  //     try {
  //         pc.addTransceiver('audio');
  //         pc.addTransceiver('video');
  //         const offer = await pc.createOffer();
  //         pc.close();
  //         const sdpObject = sdpTransform.parse(offer.sdp);
  //         const nativeRtpCapabilities = sdpUtils.extractRtpCapabilities({ sdpObject });
  //         return nativeRtpCapabilities;
  //     } catch (error) {
  //         logger.error('getNativeRtpCapabilities() | failed:%o', error);
  //         throw error;
  //     }
  // }
  // eslint-disable-next-line no-useless-constructor
  constructor() {
    super();
    // Handler direction.
    h(this, "_direction");
    // RTCPeerConnection instance.
    h(this, "_pc");
    // Local stream for sending general media tracks.
    h(this, "_sendWebStream", new MediaStream());
    // Local stream for sending screenshare tracks.
    h(this, "_sendScreenShareStream", new MediaStream());
    // Got transport local and remote parameters.
    h(this, "_transportReady", !1);
  }
  // private _nativeRtpCapabilities: Promise<RTCRtpCapabilities>;
  /**
   * Creates a factory function.
   */
  static createFactory() {
    return () => new Gc();
  }
  // eslint-disable-next-line class-methods-use-this
  get name() {
    return "Chrome74";
  }
  get pc() {
    return this._pc;
  }
  // get rtpCapabilities(): Promise<RtpCapabilities> {
  //     return this._nativeRtpCapabilities;
  // }
  close() {
    if (ne.debug("close()"), this._pc)
      try {
        this._pc.close();
      } catch (t) {
        ne.error("pc.close()", t);
      }
  }
  init({
    direction: t,
    iceServers: s,
    iceTransportPolicy: i,
    additionalSettings: n,
    proprietaryConstraints: a,
    onTrackHandler: o
  }) {
    ne.debug("init()", n), this._direction = t, this._pc = new RTCPeerConnection(
      {
        iceServers: s || [],
        iceTransportPolicy: i || "all",
        bundlePolicy: "max-bundle",
        rtcpMuxPolicy: "require",
        sdpSemantics: "unified-plan",
        ...n
      },
      a
    ), o && this._pc.addEventListener("track", (d) => {
      o(d);
    }), this._addEventListeners();
  }
  async connect() {
    const t = this._pc.createDataChannel("dyte"), s = await this._pc.createOffer();
    return ne.info("connect offer", s), await this._pc.setLocalDescription(s), {
      offerSdp: s,
      callback: async (n) => {
        ne.debug(
          "connect() | calling pc.setRemoteDescription() [answer:%o]",
          n
        ), await this._pc.setRemoteDescription(n), t.close();
      }
    };
  }
  async updateIceServers(t) {
    ne.debug("updateIceServers()");
    const s = this._pc.getConfiguration();
    s.iceServers = t, this._pc.setConfiguration(s);
  }
  async restartIce() {
    ne.debug("restartIce()");
    const t = await this.pc.createOffer({
      iceRestart: !0
    });
    return ne.debug(
      "restartIce() | calling pc.setLocalDescription() [offer:%o]",
      t
    ), {
      offerSdp: t,
      callback: async (i) => {
        ne.info("restartIce() | calling pc.setRemoteDescription() [answer:%o]", i), await this._pc.setRemoteDescription(i);
      }
    };
  }
  async getTransportStats() {
    return this._pc.getStats();
  }
  async send({
    track: t,
    encodings: s,
    codecOption: i,
    screenShare: n
  }) {
    var u;
    this._assertSendDirection(), ne.debug("send() [kind:%s, track.id:%s]", t.kind, t.id), ne.debug("creating new transceiver");
    const a = this._pc.addTransceiver(
      t,
      {
        direction: "sendonly",
        streams: [n ? this._sendScreenShareStream : this._sendWebStream],
        sendEncodings: s
      }
    ), o = RTCRtpSender.getCapabilities(t.kind);
    ne.info("senders available params:", o);
    const d = [];
    if (i) {
      const m = o.codecs.find(
        (g) => g.mimeType.includes(i.name)
      );
      if (i.parameters) {
        ne.info("codecOption.parameters:", i.parameters);
        const g = ((u = m.sdpFmtpLine) == null ? void 0 : u.split(";")) || [];
        g.push(...i.parameters);
        const T = [...new Set(g).values()];
        m.sdpFmtpLine = T.join(";");
      }
      d.push(m);
    }
    ne.info("selected codecs:", d), a.setCodecPreferences(d);
    const p = await this._pc.createOffer();
    if (!this._transportReady)
      throw new Error("webrtc transport not connected");
    return await this._pc.setLocalDescription(p), i && i.name === "opus" && (p.sdp = p.sdp.replace("minptime=10;useinbandfec=1", "minptime=10;useinbandfec=1;usedtx=1"), p.sdp += `a=rtcp-fb:111 nack\r
`), {
      offerSdp: p,
      callback: async (m) => (ne.debug(
        "send() | calling pc.setRemoteDescription() [answer:%o]",
        m
      ), await this._pc.setRemoteDescription(m), this.midTransceiverMap.set(a.mid, a), a.mid)
    };
  }
  async stopSending(t) {
    this._assertSendDirection(), ne.debug("stopSending() [localId:%s]", t);
    const s = this.midTransceiverMap.get(t);
    if (!s)
      throw new Error("associated RTCRtpTransceiver not found");
    s.sender.replaceTrack(null), this._pc.removeTrack(s.sender), s.direction = "inactive";
    const i = await this._pc.createOffer();
    return ne.debug(
      "stopSending() | calling pc.setLocalDescription() [offer:%o]",
      i
    ), await this._pc.setLocalDescription(i), {
      offerSdp: i,
      callback: async (a) => {
        ne.debug(
          "stopSending() | calling pc.setRemoteDescription() [answer:%o]",
          a
        ), await this._pc.setRemoteDescription(a), this.midTransceiverMap.delete(t);
      }
    };
  }
  async replaceTrack(t, s) {
    this._assertSendDirection(), s ? ne.debug(
      "replaceTrack() [localId:%s, track.id:%s]",
      t,
      s.id
    ) : ne.debug("replaceTrack() [localId:%s, no track]", t);
    const i = this.midTransceiverMap.get(t);
    if (!i)
      throw new Error("associated RTCRtpTransceiver not found");
    await i.sender.replaceTrack(s);
  }
  async setMaxSpatialLayer(t, s) {
    this._assertSendDirection(), ne.debug(
      "setMaxSpatialLayer() [localId:%s, spatialLayer:%s]",
      t,
      s
    );
    const i = this.midTransceiverMap.get(t);
    if (!i)
      throw new Error("associated RTCRtpTransceiver not found");
    const n = i.sender.getParameters();
    n.encodings.forEach((a, o) => {
      o <= s ? a.active = !0 : a.active = !1;
    }), await i.sender.setParameters(n);
  }
  async setRtpEncodingParameters(t, s) {
    this._assertSendDirection(), ne.debug(
      "setRtpEncodingParameters() [localId:%s, params:%o]",
      t,
      s
    );
    const i = this.midTransceiverMap.get(t);
    if (!i)
      throw new Error("associated RTCRtpTransceiver not found");
    const n = i.sender.getParameters();
    n.encodings.forEach((a, o) => {
      n.encodings[o] = { ...a, ...s };
    }), await i.sender.setParameters(n);
  }
  getSenderStats(t) {
    this._assertSendDirection();
    const s = this.midTransceiverMap.get(t);
    if (!s)
      throw new Error("associated RTCRtpTransceiver not found");
    return s.sender.getStats();
  }
  async stopReceiving(t) {
    throw this._assertRecvDirection(), ne.debug("stopReceiving() [localId:%s]", t), Error("method not implemented");
  }
  async pauseReceiving(t) {
    throw this._assertRecvDirection(), ne.debug("pauseReceiving() [localId:%s]", t), Error("method not implemented");
  }
  async resumeReceiving(t) {
    throw this._assertRecvDirection(), ne.debug("resumeReceiving() [localId:%s]", t), Error("method not implemented");
  }
  async getReceiverStats(t) {
    this._assertRecvDirection();
    const s = this.midTransceiverMap.get(t);
    if (!s)
      throw new Error("associated RTCRtpTransceiver not found");
    return s.receiver.getStats();
  }
  _assertSendDirection() {
    if (this._direction !== "send")
      throw new Error(
        'method can just be called for handlers with "send" direction'
      );
  }
  _assertRecvDirection() {
    if (this._direction !== "recv")
      throw new Error(
        'method can just be called for handlers with "recv" direction'
      );
  }
  async _generateOffer() {
    const t = await this._pc.createOffer();
    return await this._pc.setLocalDescription(t), t;
  }
  async _setAnswer(t) {
    ne.debug("_setAnswer() | calling pc.setRemoteDescription() [answer:%o]", t), await this._pc.setRemoteDescription(t);
  }
  _addEventListeners() {
    this._pc.addEventListener("iceconnectionstatechange", () => {
      switch (this._pc.iceConnectionState) {
        case "checking":
          this.emit("@connectionstatechange", "connecting");
          break;
        case "connected":
        case "completed":
          this.emit("@connectionstatechange", "connected"), this._transportReady = !0;
          break;
        case "failed":
          this.emit("@connectionstatechange", "failed");
          break;
        case "disconnected":
          this.emit("@connectionstatechange", "disconnected");
          break;
        case "closed":
          this.emit("@connectionstatechange", "closed");
          break;
        default:
          ne.warn("unknown state");
          break;
      }
    }), this._pc.addEventListener("icecandidate", (t) => {
      t.candidate && this.emit("@icecandidate", {
        candidate: t.candidate
      });
    }), this._pc.addEventListener("negotiationneeded", () => {
      this.emit("@negotiationneeded", {}), ne.debug("negotiationneeded");
    }), this._pc.addEventListener("icegatheringstatechange", () => {
      switch (this._pc.iceGatheringState) {
        case "gathering":
          ne.debug("icegatheringstatechange | gathering"), this.emit("@icegatheringstatechange", "gathering");
          break;
        case "complete":
          ne.debug("icegatheringstatechange | complete"), this.emit("@icegatheringstatechange", "complete");
          break;
        default:
          ne.warn("unknown state");
          break;
      }
    }), this._pc.addEventListener("icecandidateerror", (t) => {
      ne.info("icecandidateerror", t);
    }), this._pc.addEventListener("datachannel", (t) => {
      ne.info("data channel created: ", t.channel.label);
      const { channel: s } = t;
      s.onopen = () => {
        ne.info("data channel open: ", t.channel.label);
      }, s.onclose = () => {
        ne.warn("data channel closed: ", t.channel.label);
      }, s.onerror = (i) => {
        ne.error("data channel error: ", t.channel.label, i);
      }, s.onmessage = (i) => {
        ne.info("data channel message: ", t.channel.label, i), this.safeEmit("datachannel", t.channel, String.fromCharCode.apply(null, new Uint8Array(i.data)));
      };
    });
  }
}
const Y = St.getLogger("Firefox60");
class Wc extends qc {
  // eslint-disable-next-line no-useless-constructor
  constructor() {
    super();
    // Handler direction.
    h(this, "_direction");
    // Initial server side DTLS role. If not 'auto', it will force the opposite
    // value in client side.
    // TODO: fixme
    // private _forcedLocalDtlsRole?: DtlsRole;
    // RTCPeerConnection instance.
    h(this, "_pc");
    // Local stream for sending general media tracks.
    h(this, "_sendWebStream", new MediaStream());
    // Local stream for sending screenshare tracks.
    h(this, "_sendScreenShareStream", new MediaStream());
    // Got transport local and remote parameters.
    h(this, "_transportReady", !1);
  }
  /**
   * Creates a factory function.
   */
  static createFactory() {
    return () => new Wc();
  }
  // eslint-disable-next-line class-methods-use-this
  get name() {
    return "Firefox60";
  }
  get pc() {
    return this._pc;
  }
  close() {
    if (Y.debug("close()"), this._pc)
      try {
        this._pc.close();
      } catch (t) {
        Y.error("pc.close()", t);
      }
  }
  init({
    direction: t,
    iceServers: s,
    iceTransportPolicy: i,
    additionalSettings: n,
    proprietaryConstraints: a,
    onTrackHandler: o
  }) {
    Y.debug("init()"), this._direction = t, this._pc = new RTCPeerConnection(
      {
        iceServers: s || [],
        iceTransportPolicy: i || "all",
        bundlePolicy: "max-bundle",
        rtcpMuxPolicy: "require",
        ...n
      },
      a
    ), o && this._pc.addEventListener("track", (d) => {
      o(d);
    }), this._addEventListeners();
  }
  async connect() {
    const t = this._pc.createDataChannel("dyte"), s = await this._pc.createOffer();
    return Y.info("connect offer", s), await this._pc.setLocalDescription(s), {
      offerSdp: s,
      callback: async (n) => {
        Y.debug(
          "connect() | calling pc.setRemoteDescription() [answer:%o]",
          n
        ), await this._pc.setRemoteDescription(n), t.close();
      }
    };
  }
  // eslint-disable-next-line class-methods-use-this, @typescript-eslint/no-unused-vars
  async updateIceServers(t) {
    throw Y.debug("updateIceServers()"), new Error("not supported");
  }
  async restartIce() {
    Y.debug("restartIce()");
    const t = await this.pc.createOffer({
      iceRestart: !0
    });
    return Y.debug(
      "restartIce() | calling pc.setLocalDescription() [offer:%o]",
      t
    ), {
      offerSdp: t,
      callback: async (i) => {
        Y.info("restartIce() | calling pc.setRemoteDescription() [answer:%o]", i), await this._pc.setRemoteDescription(i);
      }
    };
  }
  async getTransportStats() {
    return this._pc.getStats();
  }
  async send({
    track: t,
    encodings: s,
    screenShare: i
  }) {
    this._assertSendDirection(), Y.debug("send() [kind:%s, track.id:%s]", t.kind, t.id), Y.debug("creating new transceiver");
    const n = this._pc.addTransceiver(
      t,
      {
        direction: "sendonly",
        streams: [i ? this._sendScreenShareStream : this._sendWebStream]
      }
    );
    if (s) {
      s.reverse();
      const d = n.sender.getParameters();
      d.encodings = s, await n.sender.setParameters(d);
    }
    const a = await this._pc.createOffer();
    if (!this._transportReady)
      throw new Error("webrtc transport not connected");
    return await this._pc.setLocalDescription(a), a.sdp = a.sdp.replace("minptime=10;useinbandfec=1", "minptime=10;useinbandfec=1;usedtx=1;maxaveragebitrate=16000"), {
      offerSdp: a,
      callback: async (d) => (Y.debug(
        "send() | calling pc.setRemoteDescription() [answer:%o]",
        d
      ), await this._pc.setRemoteDescription(d), this.midTransceiverMap.set(n.mid, n), n.mid)
    };
  }
  async stopSending(t) {
    this._assertSendDirection(), Y.debug("stopSending() [localId:%s]", t);
    const s = this.midTransceiverMap.get(t);
    if (!s)
      throw new Error("associated transceiver not found");
    s.sender.replaceTrack(null), this._pc.removeTrack(s.sender), s.direction = "inactive";
    const i = await this._pc.createOffer();
    return Y.debug(
      "stopSending() | calling pc.setLocalDescription() [offer:%o]",
      i
    ), await this._pc.setLocalDescription(i), {
      offerSdp: i,
      callback: async (a) => {
        Y.debug(
          "stopSending() | calling pc.setRemoteDescription() [answer:%o]",
          a
        ), await this._pc.setRemoteDescription(a), this.midTransceiverMap.delete(t);
      }
    };
  }
  async replaceTrack(t, s) {
    this._assertSendDirection(), s ? Y.debug(
      "replaceTrack() [localId:%s, track.id:%s]",
      t,
      s.id
    ) : Y.debug("replaceTrack() [localId:%s, no track]", t);
    const i = this.midTransceiverMap.get(t);
    if (!i)
      throw new Error("associated RTCRtpTransceiver not found");
    await i.sender.replaceTrack(s);
  }
  async setMaxSpatialLayer(t, s) {
    this._assertSendDirection(), Y.debug(
      "setMaxSpatialLayer() [localId:%s, spatialLayer:%s]",
      t,
      s
    );
    const i = this.midTransceiverMap.get(t);
    if (!i)
      throw new Error("associated RTCRtpTransceiver not found");
    const n = i.sender.getParameters(), a = n.encodings.length - 1 - s;
    n.encodings.forEach((o, d) => {
      d >= a ? o.active = !0 : o.active = !1;
    }), await i.sender.setParameters(n);
  }
  async setRtpEncodingParameters(t, s) {
    this._assertSendDirection(), Y.debug(
      "setRtpEncodingParameters() [localId:%s, params:%o]",
      t,
      s
    );
    const i = this.midTransceiverMap.get(t);
    if (!i)
      throw new Error("associated RTCRtpTransceiver not found");
    const n = i.sender.getParameters();
    n.encodings.forEach((a, o) => {
      n.encodings[o] = { ...a, ...s };
    }), await i.sender.setParameters(n);
  }
  getSenderStats(t) {
    this._assertSendDirection();
    const s = this.midTransceiverMap.get(t);
    if (!s)
      throw new Error("associated RTCRtpTransceiver not found");
    return s.sender.getStats();
  }
  async stopReceiving(t) {
    this._assertRecvDirection(), Y.debug("stopReceiving() [localId:%s]", t);
    const s = this.midTransceiverMap.get(t);
    if (!s)
      throw new Error("associated RTCRtpTransceiver not found");
    s.direction = "inactive", Y.info("active transcievers: %o", this._pc.getTransceivers());
    const i = await this._pc.createOffer();
    return Y.debug(
      "stopRecieving() | calling pc.setLocalDescription() [offer:%o]",
      i
    ), await this._pc.setLocalDescription(i), {
      offerSdp: i,
      callback: async (a) => {
        Y.debug(
          "stopRecieving() | calling pc.setRemoteDescription() [answer:%o]",
          a
        ), await this._pc.setRemoteDescription(a), this.midTransceiverMap.delete(t);
      }
    };
  }
  async pauseReceiving(t) {
    this._assertRecvDirection(), Y.debug("pauseReceiving() [localId:%s]", t);
    const s = this.midTransceiverMap.get(t);
    if (!s)
      throw new Error("associated RTCRtpTransceiver not found");
    s.direction = "inactive";
    const i = await this._pc.createOffer();
    return Y.debug(
      "pauseReceiving() | calling pc.setLocalDescription() [offer:%o]",
      i
    ), await this._pc.setLocalDescription(i), {
      offerSdp: i,
      callback: async (a) => {
        Y.debug(
          "pauseReceiving() | calling pc.setRemoteDescription() [answer:%o]",
          a
        ), await this._pc.setRemoteDescription(a);
      }
    };
  }
  async resumeReceiving(t) {
    this._assertRecvDirection(), Y.debug("resumeReceiving() [localId:%s]", t);
    const s = this.midTransceiverMap.get(t);
    if (!s)
      throw new Error("associated RTCRtpTransceiver not found");
    s.direction = "recvonly";
    const i = await this._generateOffer();
    return Y.debug(
      "resumeReceiving() | calling pc.setLocalDescription() [offer:%o]",
      i
    ), {
      offerSdp: i,
      callback: async (a) => {
        Y.debug(
          "resumeReceiving() | calling pc.setRemoteDescription() [answer:%o]",
          a
        ), await this._pc.setRemoteDescription(a);
      }
    };
  }
  async getReceiverStats(t) {
    this._assertRecvDirection();
    const s = this.midTransceiverMap.get(t);
    if (!s)
      throw new Error("associated RTCRtpTransceiver not found");
    return s.receiver.getStats();
  }
  _assertSendDirection() {
    if (this._direction !== "send")
      throw new Error(
        'method can just be called for handlers with "send" direction'
      );
  }
  _assertRecvDirection() {
    if (this._direction !== "recv")
      throw new Error(
        'method can just be called for handlers with "recv" direction'
      );
  }
  async _generateOffer() {
    const t = await this._pc.createOffer();
    return await this._pc.setLocalDescription(t), t;
  }
  async _setAnswer(t) {
    Y.debug("_setAnswer() | calling pc.setRemoteDescription() [answer:%o]", t), await this._pc.setRemoteDescription(t);
  }
  _addEventListeners() {
    this._pc.addEventListener("datachannel", (t) => {
      Y.info("data channel created: ", t.channel.label);
      const { channel: s } = t;
      s.onopen = () => {
        Y.info("data channel open: ", t.channel.label);
      }, s.onclose = () => {
        Y.warn("data channel closed: ", t.channel.label);
      }, s.onerror = (i) => {
        Y.error("data channel error: ", t.channel.label, i);
      }, s.onmessage = async (i) => {
        Y.debug("data channel message: ", t.channel.label, i);
        const n = await i.data.arrayBuffer();
        this.safeEmit("datachannel", t.channel, String.fromCharCode.apply(null, new Uint8Array(n)));
      };
    }), this._pc.addEventListener("iceconnectionstatechange", () => {
      switch (this._pc.iceConnectionState) {
        case "checking":
          this.emit("@connectionstatechange", "connecting");
          break;
        case "connected":
        case "completed":
          this.emit("@connectionstatechange", "connected"), this._transportReady = !0;
          break;
        case "failed":
          this.emit("@connectionstatechange", "failed");
          break;
        case "disconnected":
          this.emit("@connectionstatechange", "disconnected");
          break;
        case "closed":
          this.emit("@connectionstatechange", "closed");
          break;
        default:
          Y.warn("unknown state");
          break;
      }
    }), this._pc.addEventListener("icecandidate", (t) => {
      t.candidate && this.emit("@icecandidate", {
        candidate: t.candidate
      });
    }), this._pc.addEventListener("negotiationneeded", () => {
      this.emit("@negotiationneeded", {}), Y.debug("negotiationneeded");
    }), this._pc.addEventListener("icegatheringstatechange", () => {
      switch (this._pc.iceGatheringState) {
        case "gathering":
          Y.debug("icegatheringstatechange | gathering"), this.emit("@icegatheringstatechange", "gathering");
          break;
        case "complete":
          Y.debug("icegatheringstatechange | complete"), this.emit("@icegatheringstatechange", "complete");
          break;
        default:
          Y.warn("unknown state");
          break;
      }
    }), this._pc.addEventListener("icecandidateerror", (t) => {
      Y.info("chrome74::icecandidateerror", t);
    });
  }
}
const W = St.getLogger("Safari12");
class Jc extends qc {
  // eslint-disable-next-line no-useless-constructor
  constructor() {
    super();
    // Handler direction.
    h(this, "_direction");
    // RTCPeerConnection instance.
    h(this, "_pc");
    // Local stream for sending general media tracks.
    h(this, "_sendWebStream", new MediaStream());
    // Local stream for sending screenshare tracks.
    h(this, "_sendScreenShareStream", new MediaStream());
    // Got transport local and remote parameters.
    h(this, "_transportReady", !1);
  }
  /**
   * Creates a factory function.
   */
  static createFactory() {
    return () => new Jc();
  }
  // eslint-disable-next-line class-methods-use-this
  get name() {
    return "Chrome74";
  }
  get pc() {
    return this._pc;
  }
  close() {
    if (W.debug("close()"), this._pc)
      try {
        this._pc.close();
      } catch (t) {
        W.error("pc.close()", t);
      }
  }
  init({
    direction: t,
    iceServers: s,
    iceTransportPolicy: i,
    additionalSettings: n,
    proprietaryConstraints: a,
    onTrackHandler: o
  }) {
    W.debug("init()"), this._direction = t, this._pc = new RTCPeerConnection(
      {
        iceServers: s || [],
        iceTransportPolicy: i || "all",
        bundlePolicy: "max-bundle",
        rtcpMuxPolicy: "require",
        ...n
      },
      a
    ), o && this._pc.addEventListener("track", (d) => {
      o(d);
    }), this._addEventListeners();
  }
  async connect() {
    const t = this._pc.createDataChannel("dyte"), s = await this._pc.createOffer();
    return W.info("connect offer", s), await this._pc.setLocalDescription(s), {
      offerSdp: s,
      callback: async (n) => {
        W.debug(
          "connect() | calling pc.setRemoteDescription() [answer:%o]",
          n
        ), await this._pc.setRemoteDescription(n), t.close();
      }
    };
  }
  async updateIceServers(t) {
    W.debug("updateIceServers()");
    const s = this._pc.getConfiguration();
    s.iceServers = t, this._pc.setConfiguration(s);
  }
  async restartIce() {
    W.debug("restartIce()");
    const t = await this.pc.createOffer({
      iceRestart: !0
    });
    return W.debug(
      "restartIce() | calling pc.setLocalDescription() [offer:%o]",
      t
    ), {
      offerSdp: t,
      callback: async (i) => {
        W.info("restartIce() | calling pc.setRemoteDescription() [answer:%o]", i), await this._pc.setRemoteDescription(i);
      }
    };
  }
  async getTransportStats() {
    return this._pc.getStats();
  }
  async send({
    track: t,
    encodings: s,
    codecOption: i,
    screenShare: n
  }) {
    var u;
    this._assertSendDirection(), W.debug("send() [kind:%s, track.id:%s]", t.kind, t.id), W.debug("creating new transceiver");
    const a = this._pc.addTransceiver(
      t,
      {
        direction: "sendonly",
        streams: [n ? this._sendScreenShareStream : this._sendWebStream],
        sendEncodings: s
      }
    ), o = RTCRtpSender.getCapabilities(t.kind);
    W.info("senders available params:", o);
    const d = [];
    if (i) {
      const m = o.codecs.find(
        (g) => g.mimeType.includes(i.name)
      );
      if (i.parameters) {
        W.info("codecOption.parameters:", i.parameters);
        const g = ((u = m.sdpFmtpLine) == null ? void 0 : u.split(";")) || [];
        g.push(...i.parameters);
        const T = [...new Set(g).values()];
        m.sdpFmtpLine = T.join(";");
      }
      d.push(m);
    }
    W.info("selected codecs:", d), a.setCodecPreferences(d);
    const p = await this._pc.createOffer();
    if (!this._transportReady)
      throw new Error("webrtc transport not connected");
    return await this._pc.setLocalDescription(p), p.sdp = p.sdp.replace("minptime=10;useinbandfec=1", "minptime=10;useinbandfec=1;usedtx=1;maxaveragebitrate=16000"), {
      offerSdp: p,
      callback: async (m) => (W.debug(
        "send() | calling pc.setRemoteDescription() [answer:%o]",
        m
      ), await this._pc.setRemoteDescription(m), this.midTransceiverMap.set(a.mid, a), a.mid)
    };
  }
  async stopSending(t) {
    this._assertSendDirection(), W.debug("stopSending() [localId:%s]", t);
    const s = this.midTransceiverMap.get(t);
    if (!s)
      throw new Error("associated RTCRtpTransceiver not found");
    s.sender.replaceTrack(null), this._pc.removeTrack(s.sender), s.direction = "inactive";
    const i = await this._pc.createOffer();
    return W.debug(
      "stopSending() | calling pc.setLocalDescription() [offer:%o]",
      i
    ), await this._pc.setLocalDescription(i), {
      offerSdp: i,
      callback: async (a) => {
        W.debug(
          "stopSending() | calling pc.setRemoteDescription() [answer:%o]",
          a
        ), await this._pc.setRemoteDescription(a), this.midTransceiverMap.delete(t);
      }
    };
  }
  async replaceTrack(t, s) {
    this._assertSendDirection(), s ? W.debug(
      "replaceTrack() [localId:%s, track.id:%s]",
      t,
      s.id
    ) : W.debug("replaceTrack() [localId:%s, no track]", t);
    const i = this.midTransceiverMap.get(t);
    if (!i)
      throw new Error("associated RTCRtpTransceiver not found");
    await i.sender.replaceTrack(s);
  }
  async setMaxSpatialLayer(t, s) {
    this._assertSendDirection(), W.debug(
      "setMaxSpatialLayer() [localId:%s, spatialLayer:%s]",
      t,
      s
    );
    const i = this.midTransceiverMap.get(t);
    if (!i)
      throw new Error("associated RTCRtpTransceiver not found");
    const n = i.sender.getParameters();
    n.encodings.forEach((a, o) => {
      o <= s ? a.active = !0 : a.active = !1;
    }), await i.sender.setParameters(n);
  }
  async setRtpEncodingParameters(t, s) {
    this._assertSendDirection(), W.debug(
      "setRtpEncodingParameters() [localId:%s, params:%o]",
      t,
      s
    );
    const i = this.midTransceiverMap.get(t);
    if (!i)
      throw new Error("associated RTCRtpTransceiver not found");
    const n = i.sender.getParameters();
    n.encodings.forEach((a, o) => {
      n.encodings[o] = { ...a, ...s };
    }), await i.sender.setParameters(n);
  }
  getSenderStats(t) {
    this._assertSendDirection();
    const s = this.midTransceiverMap.get(t);
    if (!s)
      throw new Error("associated RTCRtpTransceiver not found");
    return s.sender.getStats();
  }
  async receive(t) {
    this._assertRecvDirection(), W.debug(
      "recieve() | calling pc.setLocalDescription() [answer:%o]",
      t
    );
    const s = this._pc.getTransceivers().at(-1);
    return W.info("Transceiver is now receiving", s, this._pc.getTransceivers()), this.midTransceiverMap.set(s.mid, s), {
      track: s.receiver.track,
      localId: s.mid
    };
  }
  async stopReceiving(t) {
    this._assertRecvDirection(), W.debug("stopReceiving() [localId:%s]", t);
    const s = this.midTransceiverMap.get(t);
    if (!s)
      throw new Error("associated RTCRtpTransceiver not found");
    s.direction = "inactive", W.info("active transcievers: %o", this._pc.getTransceivers());
    const i = await this._pc.createOffer();
    return W.debug(
      "stopRecieving() | calling pc.setLocalDescription() [offer:%o]",
      i
    ), await this._pc.setLocalDescription(i), {
      offerSdp: i,
      callback: async (a) => {
        W.debug(
          "stopRecieving() | calling pc.setRemoteDescription() [answer:%o]",
          a
        ), await this._pc.setRemoteDescription(a), this.midTransceiverMap.delete(t);
      }
    };
  }
  async pauseReceiving(t) {
    this._assertRecvDirection(), W.debug("pauseReceiving() [localId:%s]", t);
    const s = this.midTransceiverMap.get(t);
    if (!s)
      throw new Error("associated RTCRtpTransceiver not found");
    s.direction = "inactive";
    const i = await this._pc.createOffer();
    return W.debug(
      "pauseReceiving() | calling pc.setLocalDescription() [offer:%o]",
      i
    ), await this._pc.setLocalDescription(i), {
      offerSdp: i,
      callback: async (a) => {
        W.debug(
          "pauseReceiving() | calling pc.setRemoteDescription() [answer:%o]",
          a
        ), await this._pc.setRemoteDescription(a);
      }
    };
  }
  async resumeReceiving(t) {
    this._assertRecvDirection(), W.debug("resumeReceiving() [localId:%s]", t);
    const s = this.midTransceiverMap.get(t);
    if (!s)
      throw new Error("associated RTCRtpTransceiver not found");
    s.direction = "recvonly";
    const i = await this._generateOffer();
    return W.debug(
      "resumeReceiving() | calling pc.setLocalDescription() [offer:%o]",
      i
    ), {
      offerSdp: i,
      callback: async (a) => {
        W.debug(
          "resumeReceiving() | calling pc.setRemoteDescription() [answer:%o]",
          a
        ), await this._pc.setRemoteDescription(a);
      }
    };
  }
  async getReceiverStats(t) {
    this._assertRecvDirection();
    const s = this.midTransceiverMap.get(t);
    if (!s)
      throw new Error("associated RTCRtpTransceiver not found");
    return s.receiver.getStats();
  }
  _assertSendDirection() {
    if (this._direction !== "send")
      throw new Error(
        'method can just be called for handlers with "send" direction'
      );
  }
  _assertRecvDirection() {
    if (this._direction !== "recv")
      throw new Error(
        'method can just be called for handlers with "recv" direction'
      );
  }
  async _generateOffer() {
    const t = await this._pc.createOffer();
    return await this._pc.setLocalDescription(t), t;
  }
  async _setAnswer(t) {
    W.debug("_setAnswer() | calling pc.setRemoteDescription() [answer:%o]", t), await this._pc.setRemoteDescription(t);
  }
  _addEventListeners() {
    this._pc.addEventListener("iceconnectionstatechange", () => {
      switch (this._pc.iceConnectionState) {
        case "checking":
          this.emit("@connectionstatechange", "connecting");
          break;
        case "connected":
        case "completed":
          this.emit("@connectionstatechange", "connected"), this._transportReady = !0;
          break;
        case "failed":
          this.emit("@connectionstatechange", "failed");
          break;
        case "disconnected":
          this.emit("@connectionstatechange", "disconnected");
          break;
        case "closed":
          this.emit("@connectionstatechange", "closed");
          break;
        default:
          W.warn("unknown state");
          break;
      }
    }), this._pc.addEventListener("icecandidate", (t) => {
      t.candidate && this.emit("@icecandidate", {
        candidate: t.candidate
      });
    }), this._pc.addEventListener("negotiationneeded", () => {
      this.emit("@negotiationneeded", {}), W.debug("negotiationneeded");
    }), this._pc.addEventListener("icegatheringstatechange", () => {
      switch (this._pc.iceGatheringState) {
        case "gathering":
          W.debug("icegatheringstatechange | gathering"), this.emit("@icegatheringstatechange", "gathering");
          break;
        case "complete":
          W.debug("icegatheringstatechange | complete"), this.emit("@icegatheringstatechange", "complete");
          break;
        default:
          W.warn("unknown state");
          break;
      }
    }), this._pc.addEventListener("icecandidateerror", (t) => {
      W.info("chrome74::icecandidateerror", t);
    }), this._pc.ondatachannel = (t) => {
      W.info("data channel created: ", t.channel.label);
      const { channel: s } = t;
      s.onopen = () => {
        W.info("data channel open: ", t.channel.label);
      }, s.onclose = () => {
        W.warn("data channel closed: ", t.channel.label);
      }, s.onerror = (i) => {
        W.error("data channel error: ", t.channel.label, i);
      }, s.onmessage = async (i) => {
        W.debug("data channel message: ", t.channel.label, i);
        const n = String.fromCharCode.apply(null, new Uint8Array(i.data));
        this.safeEmit("datachannel", t.channel, n);
      };
    };
  }
}
function FR(r, e) {
  return typeof r == "undefined" ? e : JSON.parse(JSON.stringify(r));
}
const ic = "transport closed";
class fi extends Error {
  constructor(e) {
    super(e), this.name = "UnsupportedError", Error.hasOwnProperty("captureStackTrace") ? Error.captureStackTrace(this, fi) : this.stack = new Error(e).stack;
  }
}
class Ot extends Error {
  constructor(e) {
    super(e), this.name = "InvalidStateError", Error.hasOwnProperty("captureStackTrace") ? Error.captureStackTrace(this, Ot) : this.stack = new Error(e).stack;
  }
}
const us = St.getLogger("Producer");
class jR extends zr {
  /**
   * @emits transportclose
   * @emits trackended
   * @emits @replacetrack - (track: MediaStreamTrack | null)
   * @emits @setmaxspatiallayer - (spatialLayer: string)
   * @emits @setrtpencodingparameters - (params: any)
   * @emits @getstats
   */
  constructor({
    id: t,
    localId: s,
    track: i,
    stopTracks: n,
    disableTrackOnPause: a,
    zeroRtpOnPause: o,
    handler: d,
    appData: p
  }) {
    super();
    // Id.
    h(this, "_id");
    // Local id.
    h(this, "_localId");
    // Closed flag.
    h(this, "_closed", !1);
    // Associated RTCRtpSender.
    h(this, "_handler");
    // Local track.
    h(this, "_track");
    // Producer kind.
    h(this, "_kind");
    // Paused flag.
    h(this, "_paused");
    // Video max spatial layer.
    h(this, "_maxSpatialLayer");
    // Whether the Producer should call stop() in given tracks.
    h(this, "_stopTracks");
    // Whether the Producer should set track.enabled = false when paused.
    h(this, "_disableTrackOnPause");
    // Whether we should replace the RTCRtpSender.track with null when paused.
    h(this, "_zeroRtpOnPause");
    // custom data.
    h(this, "_appData");
    // Observer for external libs listen for few events
    h(this, "observer");
    this._id = t, this._localId = s, this._track = i, this._kind = i.kind, this._paused = a ? !i.enabled : !1, this._maxSpatialLayer = void 0, this._stopTracks = n, this._disableTrackOnPause = a, this._zeroRtpOnPause = o, this._appData = p || {}, this._onTrackEnded = this._onTrackEnded.bind(this), this._handler = d, this.observer = new zr(), this._handleTrack();
  }
  /**
   * Producer id.
   */
  get id() {
    return this._id;
  }
  /**
   * Local id.
   */
  get localId() {
    return this._localId;
  }
  /**
   * Whether the Producer is closed.
   */
  get closed() {
    return this._closed;
  }
  /**
   * Media kind.
   */
  get kind() {
    return this._kind;
  }
  /**
   * The associated track.
   */
  get track() {
    return this._track;
  }
  /**
   * Whether the Producer is paused.
   */
  get paused() {
    return this._paused;
  }
  /**
   * Max spatial layer.
   *
   * @type {Number | undefined}
   */
  get maxSpatialLayer() {
    return this._maxSpatialLayer;
  }
  /**
   * App custom data.
   */
  get appData() {
    return this._appData;
  }
  /**
   * Invalid setter.
   */
  // eslint-disable-next-line class-methods-use-this
  set appData(t) {
    throw new Error("cannot override appData object");
  }
  /**
   * Closes the Producer.
   */
  close(t) {
    if (!this._closed) {
      if (us.debug("close() with reason:", t), this._closed = !0, this._destroyTrack(), t === ic) {
        this.observer.emit("close");
        return;
      }
      this._handler.stopSending(this.localId).then(({ offerSdp: s, callback: i }) => {
        this.safeEmit("close", s, i, t);
      }).finally(() => {
        this.observer.emit("close");
      });
    }
  }
  /**
   * Get associated RTCRtpSender stats.
   */
  async getStats() {
    if (this._closed)
      throw new Ot("closed");
    return this._handler.getSenderStats(this.localId);
  }
  /**
   * Pauses sending media.
   */
  pause() {
    us.debug(`producer(${this.id}):pause()`), this._closed && us.error("pause() | Producer closed"), this._paused = !0, this._track && this._disableTrackOnPause && (this._track.enabled = !1), this._zeroRtpOnPause && this._handler.replaceTrack(this.localId, null), this.observer.emit("pause");
  }
  /**
   * Resumes sending media.
   */
  resume() {
    if (us.debug(`producer(${this.id}):resume()`), this._closed) {
      us.error("resume() | Producer closed");
      return;
    }
    this._paused = !1, this._track && this._disableTrackOnPause && (this._track.enabled = !0), this._zeroRtpOnPause && this._handler.replaceTrack(this.localId, this._track), this.observer.emit("resume");
  }
  /**
   * Replaces the current track with a new one or null.
   */
  async replaceTrack({ track: t }) {
    if (us.debug("replaceTrack() [track:%o]", t), this._closed) {
      if (t && this._stopTracks)
        try {
          t.stop();
        } catch (s) {
          us.error(s);
        }
      throw new Ot("closed");
    } else if (t && t.readyState === "ended")
      throw new Ot("track ended");
    if (t === this._track) {
      us.debug("replaceTrack() | same track, ignored");
      return;
    }
    (!this._zeroRtpOnPause || !this._paused) && await this._handler.replaceTrack(this.localId, t), this._destroyTrack(), this._track = t, this._track && this._disableTrackOnPause && (this._paused ? this._paused && (this._track.enabled = !1) : this._track.enabled = !0), this._handleTrack();
  }
  /**
   * Sets the video max spatial layer to be sent.
   */
  async setMaxSpatialLayer(t) {
    if (this._closed)
      throw new Ot("closed");
    if (this._kind !== "video")
      throw new fi("not a video Producer");
    if (typeof t != "number")
      throw new TypeError("invalid spatialLayer");
    await this._handler.setMaxSpatialLayer(this.localId, t), this._maxSpatialLayer = t;
  }
  /**
   * Sets the DSCP value.
   */
  async setRtpEncodingParameters(t) {
    if (this._closed)
      throw new Ot("closed");
    if (typeof t != "object")
      throw new TypeError("invalid params");
    await this._handler.setRtpEncodingParameters(this.localId, t);
  }
  _onTrackEnded() {
    us.debug('track "ended" event'), this.observer.emit("trackended"), this.safeEmit("trackended", this.track.id);
  }
  _handleTrack() {
    this._track && this._track.addEventListener("ended", this._onTrackEnded);
  }
  _destroyTrack() {
    if (this._track)
      try {
        this._track.removeEventListener("ended", this._onTrackEnded), this._stopTracks && this._track.stop();
      } catch (t) {
        us.error(t);
      }
  }
}
const Er = St.getLogger("Consumer");
class $R extends zr {
  constructor({
    id: t,
    localId: s,
    producerId: i,
    producingPeerId: n,
    handler: a,
    track: o,
    appData: d,
    paused: p
  }) {
    super();
    // Id.
    h(this, "_id");
    // Local id.
    h(this, "_localId");
    // Associated Producer id.
    h(this, "_producerId");
    // Closed flag.
    h(this, "_closed", !1);
    // Associated RTCRtpReceiver.
    h(this, "_handler");
    // Remote track.
    h(this, "_track");
    // Paused flag.
    h(this, "_paused");
    // Peer id of consumer
    h(this, "_peerId");
    // App custom data.
    h(this, "_appData");
    // Observer is for external libs to listen for some of the events
    h(this, "observer");
    this._id = t, this._localId = s, this._handler = a, this._appData = d, this._peerId = n, this._producerId = i, this._onTrackEnded = this._onTrackEnded.bind(this), this._track = o, this._paused = p != null ? p : !1, this.observer = new zr(), this._handleTrack();
  }
  /**
   * Consumer id.
   */
  get id() {
    return this._id;
  }
  /**
   * Producing peer id
   */
  get peerId() {
    return this._peerId;
  }
  /**
   * Local id.
   */
  get localId() {
    return this._localId;
  }
  /**
   * Associated Producer id.
   */
  get producerId() {
    return this._producerId;
  }
  /**
   * Whether the Consumer is closed.
   */
  get closed() {
    return this._closed;
  }
  /**
   * Media kind.
   */
  get kind() {
    return this._track.kind;
  }
  /**
   * The associated track.
   */
  get track() {
    return this._track;
  }
  /**
   * Whether the Consumer is paused.
   */
  get paused() {
    return this._paused;
  }
  get remotelyPaused() {
    return this.paused;
  }
  /**
   *  custom data.
   */
  get appData() {
    return this._appData;
  }
  /**
   * Invalid setter.
   */
  // eslint-disable-next-line class-methods-use-this
  set appData(t) {
    throw new Error("cannot override appData object");
  }
  /**
   * Closes the Consumer.
   */
  close(t) {
    this._closed || (Er.debug("close() with reason:", t), this._closed = !0, this._destroyTrack(), this.emit("close", t), this.observer.safeEmit("close", t));
  }
  /**
   * Get associated RTCRtpReceiver stats.
   */
  async getStats() {
    if (this._closed)
      throw new Ot("closed");
    return this._handler.getReceiverStats(this.localId);
  }
  /**
   * Pauses receiving media.
   */
  pause() {
    if (Er.debug(`consumer(${this.id}):pause()`), this._closed) {
      Er.error("pause() | Consumer closed");
      return;
    }
    this._paused = !0, this._track.enabled = !1, this.observer.safeEmit("pause");
  }
  /**
   * Resumes receiving media.
   */
  resume() {
    if (Er.debug(`consumer(${this.id}):resume()`), this._closed) {
      Er.error("resume() | Consumer closed");
      return;
    }
    this._paused = !1, this._track.enabled = !0, this.observer.safeEmit("resume");
  }
  _onTrackEnded() {
    Er.debug('track "ended" event'), this.safeEmit("trackended"), this.observer.safeEmit("trackended");
  }
  _handleTrack() {
    this._track.addEventListener("ended", this._onTrackEnded);
  }
  _destroyTrack() {
    try {
      this._track.removeEventListener("ended", this._onTrackEnded), this._track.stop();
    } catch (t) {
      Er.error(t);
    }
  }
}
const it = St.getLogger("Transport");
class HR extends zr {
  constructor({
    id: t,
    direction: s,
    handlerFactory: i,
    iceServers: n,
    iceTransportPolicy: a,
    proprietaryConstraints: o,
    additionalSettings: d,
    appData: p
  }) {
    super();
    // Id.
    h(this, "_id");
    h(this, "_serverId");
    // Closed flag.
    h(this, "_closed", !1);
    // Direction.
    h(this, "_direction");
    // SCTP max message size if enabled, null otherwise.
    h(this, "_maxSctpMessageSize");
    // RTC handler isntance.
    h(this, "_handler");
    // Transport connection state.
    h(this, "_connectionState", "new");
    // Producers map
    h(this, "_producers");
    // Consumers map
    h(this, "_consumers");
    // datachannels map
    h(this, "_datachannels");
    h(this, "_connected", !1);
    h(this, "_transportConnectionPromise", null);
    h(this, "awaitQueue");
    h(this, "observer");
    h(this, "consumerTrackEvents");
    h(this, "unknownTracksMap");
    // App custom data.
    h(this, "_appData");
    h(this, "datachannelCache", /* @__PURE__ */ new Map());
    it.debug("constructor() [id: %s, direction: %s]", t, s), this._id = t, this._direction = s;
    const l = FR(d, {});
    delete l.iceServers, delete l.iceTransportPolicy, delete l.bundlePolicy, delete l.rtcpMuxPolicy, delete l.sdpSemantics, this._producers = /* @__PURE__ */ new Map(), this._consumers = /* @__PURE__ */ new Map(), this._datachannels = /* @__PURE__ */ new Map(), this.consumerTrackEvents = /* @__PURE__ */ new Map(), this.unknownTracksMap = /* @__PURE__ */ new Map(), this.awaitQueue = new uh(), this.observer = new zr(), this._handler = i(), this._handler.init({
      onTrackHandler: this._ontrack.bind(this),
      direction: s,
      iceServers: n,
      iceTransportPolicy: a,
      additionalSettings: d,
      proprietaryConstraints: o
    }), this._appData = p || {}, this._transportConnectionPromise = new Promise((u) => {
      this.observer.once("connected", () => {
        u(!0);
      }), this.observer.once("disconnect", () => {
        u(!1);
      }), this.observer.once("close", () => {
        u(!1);
      });
    }), this._handler.on("@connectionstatechange", (u) => {
      u !== this._connectionState && (it.debug("connection state changed to %s", u), this._connectionState = u, u === "connected" && (this._connected = !0, this.observer.emit("connected")), u === "disconnected" && (this._connected = !1, this.observer.emit("disconnect")), (u === "failed" || u === "closed") && (this._connected = !1, this.observer.emit("close")), this._closed || this.safeEmit("connectionstatechange", u));
    }), this._handler.on("@icecandidate", ({ candidate: u }) => {
      this._closed || this.safeEmit("icecandidate", u);
    }), this._handler.on("datachannel", (u, m) => {
      var T, S;
      this._datachannels.has(u.label) || this._datachannels.set(u.label, u);
      const g = JSON.parse(m);
      if (this.datachannelCache.has(g.id) || this.datachannelCache.set(g.id, []), (T = this.datachannelCache.get(g.id)) == null || T.push(g), ((S = this.datachannelCache.get(g.id)) == null ? void 0 : S.length) === g.count) {
        const R = this.datachannelCache.get(g.id), D = R == null ? void 0 : R.reduce((I, re) => I + re.chunk, "");
        this.datachannelCache.delete(g.id);
        try {
          const I = JSON.parse(D);
          this.safeEmit(`datachannel:${u.label}`, u, I);
        } catch (I) {
          it.error("error parsing message", I);
        }
      }
    });
  }
  /**
   * Transport id.
   */
  get id() {
    return this._id;
  }
  get serverId() {
    return this._serverId;
  }
  get connected() {
    return this._connected;
  }
  get isConnected() {
    return this._transportConnectionPromise;
  }
  get datachannels() {
    return this._datachannels;
  }
  /**
   * Whether the Transport is closed.
   */
  get closed() {
    return this._closed;
  }
  /**
   * Transport direction.
   */
  get direction() {
    return this._direction;
  }
  /**
   * RTC handler instance.
   */
  get handler() {
    return this._handler;
  }
  /**
   * Connection state.
   */
  get connectionState() {
    return this._connectionState;
  }
  /**
   * custom data.
   */
  get appData() {
    return this._appData;
  }
  /**
   * Invalid setter.
   */
  // eslint-disable-next-line class-methods-use-this
  set appData(t) {
    throw new Error("cannot override appData object");
  }
  setServerId(t) {
    this._serverId = t;
  }
  getDatachannel(t) {
    return this._datachannels.get(t);
  }
  /**
   * Close the Transport.
   */
  close() {
    this._closed || (it.debug("close()"), this._connected = !1, this._closed = !0, this._handler.close(), [...this._producers.values()].forEach((t) => t.close(ic)), this._producers.clear(), [...this._consumers.values()].forEach((t) => t.close(ic)), this._consumers.clear(), this.emit("close"), this.observer.emit("close"));
  }
  /**
   * Get associated Transport (RTCPeerConnection) stats.
   *
   * @returns {RTCStatsReport}
   */
  async getStats() {
    if (this._closed)
      throw new Ot("closed");
    return this._handler.getTransportStats();
  }
  async connect() {
    try {
      const { offerSdp: t, callback: s } = await this._handler.connect(), { answer: i } = await this.safeEmitAsPromise("connect", { offer: t });
      if (await s(i), !await this.isConnected)
        throw new Error("ice connection failed");
    } catch (t) {
      throw it.error("transport failed to connect:", t), t;
    }
  }
  /**
   * Restart ICE connection.
   */
  async restartIce() {
    if (it.debug("restartIce()"), this._closed)
      throw new Ot("closed");
    return this._handler.restartIce();
  }
  /**
   * Update ICE servers.
   */
  async updateIceServers({ iceServers: t } = {}) {
    if (it.debug("updateIceServers()"), this._closed)
      throw new Ot("closed");
    this._handler.updateIceServers(t);
  }
  /**
   * Create a Producer.
   */
  async produce({
    track: t,
    encodings: s,
    codecOptions: i,
    stopTracks: n = !0,
    disableTrackOnPause: a = !0,
    zeroRtpOnPause: o = !1,
    appData: d = {}
  } = {}) {
    if (it.debug(`produce() [track:${t.id}]`), t) {
      if (this._direction !== "send")
        throw new fi("not a sending Transport");
      if (t.readyState === "ended")
        throw new Ot("track ended");
      if (this.listenerCount("connect") === 0 && this._connectionState === "new")
        throw new TypeError('no "connect" listener set into this transport');
      if (this.listenerCount("produce") === 0)
        throw new TypeError('no "produce" listener set into this transport');
      if (d && typeof d != "object")
        throw new TypeError("if given, appData must be an object");
    } else
      throw new TypeError("missing track");
    if (!await this.isConnected)
      return Promise.reject(new Error("Transport not connected"));
    const { producerId: p, localId: l } = await this.awaitQueue.push(async () => {
      const { offerSdp: m, callback: g } = await this._handler.send(
        {
          track: t,
          encodings: s,
          codecOption: i,
          screenShare: d == null ? void 0 : d.screenShare
        }
      ), { answer: T, producerId: S } = await this.safeEmitAsPromise(
        "produce",
        {
          offer: m,
          kind: t.kind,
          paused: a ? !t.enabled : !1,
          appData: d
        }
      ), R = await g(T);
      return { producerId: S, localId: R };
    }), u = new jR({
      id: p,
      localId: l,
      track: t,
      stopTracks: n,
      disableTrackOnPause: a,
      zeroRtpOnPause: o,
      appData: d,
      handler: this.handler
    });
    return this._producers.set(p, u), u.observer.on("close", () => {
      this._producers.delete(u.id);
    }), this.emit("newproducer", u), this.observer.emit("newproducer", u), u;
  }
  async consumePeer(t, s = {}) {
    if (it.debug("consumePeer() producingPeerId:", t), this._closed)
      throw new Ot("closed");
    if (this._direction !== "recv")
      throw new fi("not a receiving Transport");
    if (typeof t != "string")
      throw new TypeError("missing producingPeerId");
    if (this.listenerCount("connect") === 0 && this._connectionState === "new")
      throw new TypeError('no "connect" listener set into this transport');
    if (s && typeof s != "object")
      throw new TypeError("if given, appData must be an object");
    if (!await this.isConnected)
      return Promise.reject(new Error("Transport not connected"));
    const i = [], { consumersMap: n } = await this.safeEmitAsPromise("consumePeer", { producingPeerId: t });
    return n.forEach((a, o) => {
      const {
        consumerId: d,
        trackId: p,
        screenShare: l,
        paused: u,
        streamId: m,
        kind: g
      } = a;
      i.push(this._consumerCreationTask({
        consumerId: d,
        trackId: p,
        streamId: m,
        kind: g,
        producerId: o,
        producingPeerId: t,
        paused: u,
        screenShare: l,
        appData: s
      }));
    }), it.info("promises", i), Promise.allSettled(i);
  }
  async consume({
    producerId: t,
    producingPeerId: s,
    appData: i = {}
  }) {
    if (it.debug("consume()"), this._closed)
      throw new Ot("closed");
    if (this._direction !== "recv")
      throw new fi("not a receiving Transport");
    if (typeof t != "string")
      throw new TypeError("missing producerId");
    if (this.listenerCount("connect") === 0 && this._connectionState === "new")
      throw new TypeError('no "connect" listener set into this transport');
    if (i && typeof i != "object")
      throw new TypeError("if given, appData must be an object");
    if (!await this.isConnected)
      return Promise.reject(new Error("Transport not connected"));
    try {
      const {
        // eslint-disable-next-line @typescript-eslint/no-shadow
        consumerId: n,
        screenShare: a,
        trackId: o,
        paused: d,
        streamId: p,
        kind: l
      } = await this.safeEmitAsPromise("consume", { producerId: t, producingPeerId: s });
      return this._consumerCreationTask({
        consumerId: n,
        screenShare: a,
        trackId: o,
        streamId: p,
        kind: l,
        paused: d,
        producerId: t,
        producingPeerId: s,
        appData: i
      });
    } catch (n) {
      throw it.error("consume failed:", n), n;
    }
  }
  async _consumerCreationTask({
    consumerId: t,
    producerId: s,
    producingPeerId: i,
    streamId: n,
    trackId: a,
    paused: o,
    screenShare: d,
    appData: p,
    kind: l
  }) {
    const u = `${n}:${l}`, m = {
      consumerId: t,
      producerId: s,
      producingPeerId: i,
      streamId: n,
      trackId: a,
      appData: p,
      kind: l,
      paused: o,
      screenShare: d,
      name: "consumer creation task error",
      message: "consumer creation failed"
    };
    return new Promise((T, S) => {
      const R = setTimeout(() => {
        this.consumerTrackEvents.delete(u), m.isTimedout = !0, this.consumerTrackEvents.delete(u), S(m);
      }, 5e3), D = async (re) => {
        try {
          if (re.track.readyState === "ended")
            clearTimeout(R), S(m);
          else {
            const { transceiver: ge } = re;
            this.handler.midTransceiverMap.set(ge.mid, ge);
            const Me = new $R({
              id: t,
              localId: re.transceiver.mid,
              track: re.track,
              paused: o,
              producerId: s,
              producingPeerId: i,
              handler: this._handler,
              appData: { ...p, screenShare: d }
            });
            this._consumers.set(t, Me), Me.once("close", () => {
              this._consumers.delete(Me.id), this.handler.midTransceiverMap.delete(ge.mid);
            }), it.info("consumer created for ", { producerId: s, trackId: a, producingPeerId: i }), this.observer.emit("newconsumer", Me), clearTimeout(R), T(Me);
          }
        } catch (ge) {
          it.warn("error while creating consumer:", ge), clearTimeout(R), S(m);
        }
      }, I = this.unknownTracksMap.get(u);
      I ? (this.unknownTracksMap.delete(u), D(I)) : this.consumerTrackEvents.set(u, D);
    });
  }
  _ontrack(t) {
    it.info("track event received", t);
    const s = `${t.streams[0].id}:${t.track.kind}`, i = this.consumerTrackEvents.get(s);
    i ? (i(t), this.consumerTrackEvents.delete(s)) : (it.warn(`track event handler not found ${s}`), this.unknownTracksMap.set(s, t));
  }
  async setRemoteDescription(t) {
    await this._handler.pc.setRemoteDescription(t);
  }
  async setLocalDescription(t) {
    it.debug(
      `${this.direction}() {transportId: ${this.serverId}} | calling pc.setLocalDescription() [offer:%o]`,
      t
    ), await this._handler.pc.setLocalDescription(t);
  }
  async setRemoteOffer(t) {
    await this.setRemoteDescription(t);
    const s = await this._handler.pc.createAnswer(), i = O.parse(s.sdp);
    return i.media = i.media.map((n) => {
      if (n.type === "audio") {
        const a = { ...n };
        return a.rtcpFb || (a.rtcpFb = []), a.rtcpFb.some(
          (d) => d.type === "nack"
        ) || a.rtcpFb.push({
          payload: parseInt(a.payloads, 10),
          type: "nack"
        }), a;
      }
      return n;
    }), s.sdp = O.write(i), await this.setLocalDescription(s), s;
  }
  async retryFailedConsumerCreationTasks(t) {
    return Promise.allSettled(t.map((s) => (it.warn("retrying failed consumer creation task", s), this._consumerCreationTask({
      ...s
    }))));
  }
}
function BR(r) {
  return "name" in r && r.name === "consumer creation task error";
}
const ms = St.getLogger("Device");
function qR() {
  if (typeof navigator == "object" && navigator.product === "ReactNative") {
    if (typeof RTCPeerConnection == "undefined") {
      ms.warn(
        "this._detectDevice() | unsupported ReactNative without RTCPeerConnection"
      );
      return;
    }
    return ms.debug("this._detectDevice() | ReactNative handler chosen"), "ReactNative";
  }
  if (typeof navigator == "object" && typeof navigator.userAgent == "string") {
    const r = navigator.userAgent, e = Sc.getParser(r), t = e.getEngine();
    if (e.satisfies({ chrome: ">=74", chromium: ">=74", "microsoft edge": ">=88" }))
      return "Chrome74";
    if (e.satisfies({ chrome: ">=70", chromium: ">=70" }))
      return "Chrome70";
    if (e.satisfies({ chrome: ">=67", chromium: ">=67" }))
      return "Chrome67";
    if (e.satisfies({ chrome: ">=55", chromium: ">=55" }))
      return "Chrome55";
    if (e.satisfies({ firefox: ">=60" }))
      return "Firefox60";
    if (e.satisfies({ ios: { OS: ">=14.3", firefox: ">=30.0" } }) || e.satisfies({ safari: ">=12.0" }) && typeof RTCRtpTransceiver != "undefined" && RTCRtpTransceiver.prototype.hasOwnProperty("currentDirection"))
      return "Safari12";
    if (e.satisfies({ safari: ">=11" }))
      return "Safari11";
    if (e.satisfies({ "microsoft edge": ">=11" }) && e.satisfies({ "microsoft edge": "<=18" }))
      return "Edge11";
    if (t.name && t.name.toLowerCase() === "blink") {
      const s = r.match(/(?:(?:Chrome|Chromium))[ /](\w+)/i);
      if (s) {
        const i = Number(s[1]);
        return i >= 74 ? "Chrome74" : i >= 70 ? "Chrome70" : i >= 67 ? "Chrome67" : "Chrome55";
      }
      return "Chrome74";
    }
    ms.warn(
      "this._detectDevice() | browser not supported [name:%s, version:%s]",
      e.getBrowserName(),
      e.getBrowserVersion()
    );
    return;
  }
  ms.warn("this._detectDevice() | unknown device");
}
class GR {
  constructor({ handlerName: e, handlerFactory: t } = {}) {
    // RTC handler factory.
    h(this, "_handlerFactory");
    // Handler name.
    h(this, "_handlerName");
    // observer
    h(this, "_observer");
    if (ms.debug("constructor()"), e && t)
      throw new TypeError(
        "just one of handlerName or handlerInterface can be given"
      );
    if (t)
      this._handlerFactory = t;
    else {
      if (e)
        ms.debug("constructor() | handler given: %s", e);
      else if (e = qR(), e)
        ms.debug("constructor() | detected handler: %s", e);
      else
        throw new Error("device not supported");
      switch (e) {
        case "Chrome74":
          this._handlerFactory = Gc.createFactory();
          break;
        case "Safari12":
          this._handlerFactory = Jc.createFactory();
          break;
        case "Firefox60":
          this._handlerFactory = Wc.createFactory();
          break;
        default:
          throw new TypeError(`unknown handlerName "${e}"`);
      }
    }
    const s = this._handlerFactory();
    this._handlerName = s.name, s.close(), this._observer = new bt();
  }
  /**
   * The RTC handler name.
   */
  get handlerName() {
    return this._handlerName;
  }
  /**
   * Creates a Transport for sending media.
   *
   * @throws {InvalidStateError} if not loaded.
   * @throws {TypeError} if wrong arguments.
   */
  createSendTransport({
    iceServers: e,
    iceTransportPolicy: t,
    additionalSettings: s,
    proprietaryConstraints: i,
    appData: n
  }) {
    return ms.debug("createSendTransport()"), this._createTransport(
      {
        direction: "send",
        iceServers: e,
        iceTransportPolicy: t,
        additionalSettings: s,
        proprietaryConstraints: i,
        appData: n
      }
    );
  }
  /**
   * Creates a Transport for receiving media.
   *
   * @throws {InvalidStateError} if not loaded.
   * @throws {TypeError} if wrong arguments.
   */
  createRecvTransport({
    iceServers: e,
    iceTransportPolicy: t,
    additionalSettings: s,
    proprietaryConstraints: i,
    appData: n
  }) {
    return ms.debug("createRecvTransport()"), this._createTransport(
      {
        direction: "recv",
        iceServers: e,
        iceTransportPolicy: t,
        additionalSettings: s,
        proprietaryConstraints: i,
        appData: n
      }
    );
  }
  _createTransport({
    direction: e,
    iceServers: t,
    iceTransportPolicy: s,
    additionalSettings: i,
    proprietaryConstraints: n,
    appData: a
  }) {
    const o = so(), d = new HR(
      {
        id: o,
        direction: e,
        iceServers: t,
        iceTransportPolicy: s,
        additionalSettings: i,
        proprietaryConstraints: n,
        appData: a,
        handlerFactory: this._handlerFactory
      }
    );
    return ms.info("transport created", d), this._observer.emit("newtransport", d), d;
  }
}
var _t;
class WR {
  constructor(e) {
    b(this, _t, void 0);
    P(this, _t, e);
  }
  async joinRoom(e, t) {
    const s = {
      roomUuid: e,
      displayName: t,
      prejoined: !1
    };
    return (await c(this, _t).sendMessagePromise(
      me.joinRoom,
      WT.toBinary(s)
    )).payload;
  }
  async connectTransport(e) {
    const t = (await c(this, _t).sendMessagePromise(
      me.createWebRTCTransport,
      IT.toBinary(e)
    )).payload, { transportId: s, description: i } = ho.fromBinary(t), n = {
      sdp: i == null ? void 0 : i.sdp,
      type: i.type
    };
    return {
      transportId: s,
      answer: n
    };
  }
  async produce(e) {
    var n, a;
    const t = (await c(this, _t).sendMessagePromise(
      me.produce,
      ty.toBinary(e)
    )).payload, s = jy.fromBinary(t);
    return {
      answer: {
        sdp: (n = s == null ? void 0 : s.description) == null ? void 0 : n.sdp,
        type: (a = s == null ? void 0 : s.description) == null ? void 0 : a.type
      },
      producerId: s.producerId
    };
  }
  async consume(e) {
    const t = (await c(this, _t).sendMessagePromise(
      me.consume,
      XT.toBinary(e)
    )).payload, {
      consumerIdsMap: { map: s }
    } = Vy.fromBinary(t);
    return s;
  }
  async closeProducer(e) {
    const t = (await c(this, _t).sendMessagePromise(
      me.closeProducer,
      cy.toBinary(e)
    )).payload, { description: s } = Jy.fromBinary(t);
    return s;
  }
  async closeConsumer(e) {
    return (await c(this, _t).sendMessagePromise(
      me.closeConsumer,
      ly.toBinary(e)
    )).payload;
  }
  async hostControlForPeer(e, t) {
    const s = {
      audio: t === "audio",
      screeShare: !1,
      video: t === "video",
      participantId: e
    }, i = (await c(this, _t).sendMessagePromise(
      me.hostControlPeer,
      vy.toBinary(s)
    )).payload;
    if (!i)
      return !1;
    const { status: n } = tE.fromBinary(i);
    return n === "success";
  }
  async hostControlForAll(e) {
    const t = {
      audio: e === "audio",
      screenShare: !1,
      video: e === "video"
    }, s = (await c(this, _t).sendMessagePromise(
      me.hostControlAllPeers,
      yy.toBinary(t)
    )).payload;
    if (!s)
      return !1;
    const { status: i } = rE.fromBinary(s);
    return i === "success";
  }
  async kickAll() {
    const e = {}, t = (await c(this, _t).sendMessagePromise(
      me.kickAll,
      my.toBinary(e)
    )).payload;
    if (!t)
      return !1;
    const { status: s } = Xy.fromBinary(t);
    return s === "success";
  }
  async kickPeer(e) {
    const t = (await c(this, _t).sendMessagePromise(
      me.kickPeer,
      py.toBinary(e)
    )).payload;
    if (!t)
      return !1;
    const { status: s } = Yy.fromBinary(t);
    return s === "success";
  }
  async changeDisplayName(e) {
    const t = (await c(this, _t).sendMessagePromise(
      me.changeDisplayName,
      gy.toBinary(e)
    )).payload;
    if (!t)
      return !1;
    const { status: s } = nE.fromBinary(t);
    return s === "success";
  }
  async notifySelfJoinComplete() {
    const e = {}, t = (await c(this, _t).sendMessagePromise(
      me.selfJoinComplete,
      KT.toBinary(e)
    )).payload;
    return Oy.fromBinary(t);
  }
}
_t = new WeakMap();
class JR extends VR {
  constructor(t) {
    super();
    h(this, "_device");
    h(this, "_sendTransport");
    h(this, "_recvTransport");
    h(this, "_consumers");
    // map producer type to Producer
    h(this, "_producers");
    h(this, "_producerIdToConsumerIdMap");
    h(this, "_logger");
    h(this, "_socket");
    h(this, "_socketHandler");
    h(this, "transportConnectionStatus");
    this._producers = /* @__PURE__ */ new Map(), this._consumers = /* @__PURE__ */ new Map(), this._producerIdToConsumerIdMap = /* @__PURE__ */ new Map(), this.transportConnectionStatus = /* @__PURE__ */ new Map(), this._device = new GR(), this._logger = St.getLogger("HiveSFUHandler"), this._socket = t, this._socketHandler = new WR(t);
  }
  get socket() {
    return this._socket;
  }
  get producers() {
    return this._producers;
  }
  get consumers() {
    return this._consumers;
  }
  get producerIdToConsumerIdMap() {
    return this._producerIdToConsumerIdMap;
  }
  get hiveSocketHandler() {
    return this._socketHandler;
  }
  async setupTransports(t) {
    const i = await ct().getICEServers(), n = t.map((a) => {
      const o = this.transportConnectionStatus.get(a);
      if (o)
        return o;
      switch (a) {
        case "send": {
          const d = this.createSendTransport({ iceServers: i });
          return this.transportConnectionStatus.set(a, d), d;
        }
        case "recv": {
          const d = this.createRecvTransport({ iceServers: i });
          return this.transportConnectionStatus.set(a, d), d;
        }
        default:
          return this._logger.warn(`what are you thinking when passing this ${a}?`), Promise.reject(Error("TYPE_OF_TRANSPORT_UNKNOWN"));
      }
    });
    await Promise.all(n).finally(() => {
      t.forEach((a) => {
        this.transportConnectionStatus.delete(a);
      });
    });
  }
  async stopAllTransports() {
    var t, s;
    this._logger.info("closing all the transports"), (t = this._sendTransport) == null || t.close(), (s = this._recvTransport) == null || s.close(), this._sendTransport = void 0, this._recvTransport = void 0;
  }
  async createSendTransport(t) {
    if (this._sendTransport && this._sendTransport.connected)
      return;
    this._logger.info("sendTransport::initializing_transport");
    const s = this._device.createSendTransport(t);
    this._logger.info("sendTransport::initialized_transport"), this.handleTransport(s, !1), this._logger.info("sendTransport::connecting_transport");
    try {
      await s.connect();
    } catch (i) {
      this._logger.error("fail to connect send transport:", s.id, "[Error]:", i, "retrying once."), await s.connect().catch((n) => {
        this._logger.error("failed to connect send transport after retry:", s.id, "[Error]:", n);
      });
    }
    this._logger.info("sendTransport::connected_transport"), this._sendTransport = s, A.onSafeInitialization(() => {
      A.configureSendTransport(s);
    }), Object.assign(window, { sendTransport: s });
  }
  async createRecvTransport(t) {
    if (this._recvTransport && this._recvTransport.connected)
      return;
    this._logger.info("recvTransport::initializing_transport");
    const s = this._device.createRecvTransport({
      ...t,
      additionalSettings: {
        rtcAudioJitterBufferMaxPackets: 25,
        rtcAudioJitterBufferFastAccelerate: !0,
        rtcAudioJitterBufferMinDelayMs: 20
      }
    });
    A.onSafeInitialization(() => {
      A.configureRecvTransport(s);
    }), this._logger.info("recvTransport::initialized_transport"), this.handleTransport(s, !0), this._logger.info("recvTransport::connecting_transport");
    try {
      await s.connect();
    } catch (i) {
      this._logger.error("fail to connect recv transport:", s.id, "[Error]:", i, "retrying once."), await s.connect().catch((n) => {
        this._logger.error("failed to connect recv transport after retry:", s.id, "[Error]:", n);
      });
    }
    this._logger.info("recvTransport::connected_transport"), this._recvTransport = s, this.producerIdToConsumerIdMap.clear();
  }
  handleTransport(t, s) {
    if (t.on("connect", async ({ offer: i }, n, a) => {
      try {
        const o = {
          consuming: s,
          description: {
            sdp: i.sdp,
            type: i.type,
            target: s ? Qs.SUBSCRIBER : Qs.PUBLISHER
          }
        }, {
          transportId: d,
          answer: p
        } = await this._socketHandler.connectTransport(o);
        t.setServerId(d), n({ answer: p });
      } catch (o) {
        this._logger.error(`${s ? "consumer" : "producer"} transport connection error:`, o), a(o);
      }
    }), t.on("connectionstatechange", async (i) => {
      switch (this._logger.info(`${s ? "consumer" : "producer"} transport connectionState:`, i), i) {
        case "failed":
        case "disconnected":
          if (t.closed)
            return;
          this._logger.info(`${s ? "consumer" : "producer"} transport disconnected or failed, reconnecting...`), M.hasFeature(
            N.ENABLE_HIVE_TRANSPORT_RECONNECTION_ON_ICE_FAILED
          ) ? (y.emit(
            v.HIVE_TRANSPORT_STATE_CHANGED,
            { state: "reconnecting", transportDirection: s ? "recv" : "send" }
          ), this.emit("reconnect_transport", t)) : y.emit(
            v.HIVE_TRANSPORT_STATE_CHANGED,
            { state: i, transportDirection: s ? "recv" : "send" }
          );
          break;
        case "new":
        case "closed":
          break;
        default:
          y.emit(
            v.HIVE_TRANSPORT_STATE_CHANGED,
            { state: i, transportDirection: s ? "recv" : "send" }
          );
          break;
      }
    }), t.on("icecandidate", async (i) => {
      this._logger.debug("sending icecandidate:", i.toJSON());
    }), t.on("datachannel:events", async (i, n) => {
      this._logger.debug("got data channel message on event:", n);
      try {
        switch (n.type) {
          case "offer": {
            const a = {
              sdp: n.payload.sdp,
              type: "offer"
            };
            let o;
            try {
              const d = await t.setRemoteOffer(a);
              o = {
                type: "answer",
                payload: {
                  type: d.type,
                  sdp: d.sdp
                }
              };
            } catch (d) {
              this._logger.error("datachannel:events::Error:", d), o = {
                type: "error",
                payload: {
                  error: d.message
                }
              };
            }
            this._logger.debug("datachannel answer:", o), i.send(JSON.stringify(o));
            break;
          }
          case "consumer_toggle": {
            const { mute: a, trackId: o } = n.payload;
            this._logger.info("consumer toggled for", o, "muted:", a);
            const d = this.consumers.get(o);
            if (!d) {
              this._logger.warn("consumer with id", o, " not found");
              return;
            }
            d.paused !== a && (this._logger.debug("consumer state is not same", { consumerPaused: d.paused, mute: a }), a ? (d.pause(), y.emit(v.CONSUMER_PAUSED, { id: d.id })) : (d.resume(), y.emit(v.CONSUMER_RESUMED, { id: d.id })));
            break;
          }
          default:
            this._logger.warn("unknown event received from hive node, event:", n.type);
            break;
        }
      } catch (a) {
        this._logger.error("Unable to handle the incoming datachannel message on", i.label);
      }
    }), t.on("negotiate", async ({ description: i }, n, a) => {
      try {
        const o = {
          sdp: i == null ? void 0 : i.sdp,
          type: i == null ? void 0 : i.type
        }, d = await this.negotiate(t, o);
        n({
          answer: d
        });
      } catch (o) {
        this._logger.error("negotiate error:", o), a(o);
      }
    }), t.on("close", () => {
      if (this._logger.info(`${s ? "consumer" : "producer"} transport closed`, t.id), s) {
        this._recvTransport = void 0;
        return;
      }
      this._sendTransport = void 0;
    }), !s) {
      t.on("produce", async ({
        offer: i,
        kind: n,
        paused: a,
        appData: o
      }, d, p) => {
        var g;
        const u = O.parse(i.sdp).media.filter((T) => n === "video" ? T.type === "video" : T.type === "audio").at(-1).msid, m = {
          description: {
            sdp: i.sdp,
            type: i.type,
            target: Qs.PUBLISHER
          },
          paused: a,
          kind: n,
          msid: u,
          screenShare: (g = o.screenShare) != null ? g : !1
        };
        try {
          const { answer: T, producerId: S } = await this._socketHandler.produce(m);
          d({ answer: T, producerId: S });
        } catch (T) {
          this._logger.error("create producer error:", T), p(T);
        }
      });
      return;
    }
    t.on("datachannel:negotiation", async (i, n) => {
      try {
        this._logger.info("datachannel message recieved:", i.label, n);
        const a = {
          sdp: n,
          type: "offer"
        }, o = await t.setRemoteOffer(a);
        this._logger.info("datachannel answer:", o), i.send(o.sdp);
      } catch (a) {
        this._logger.error("datachannel:negotiation::Error:", a);
      }
    }), t.on("consumePeer", async ({ producingPeerId: i }, n, a) => {
      this._logger.info("consumePeer:", i);
      const o = {
        producingPeerId: i
      };
      try {
        const d = await this._socketHandler.consume(o);
        this._logger.debug(`consumePeer response for ${i}:`, { consumerStateMap: d });
        const p = /* @__PURE__ */ new Map();
        Object.entries(d).forEach(([l, u]) => {
          var m, g, T;
          p.set(l, {
            consumerId: u.consumerId,
            trackId: (m = u.producerTrack) == null ? void 0 : m.trackId,
            streamId: u.producerTrack.streamId,
            kind: u.producerState.kind === rs.VIDEO ? "video" : "audio",
            screenShare: (g = u.producerState) == null ? void 0 : g.screenShare,
            paused: (T = u.producerState) == null ? void 0 : T.pause
          });
        }), n({ consumersMap: p });
      } catch (d) {
        this._logger.error("consumePeer error:", d), a(d);
      }
    }), t.on("consume", async ({ producerId: i, producingPeerId: n }, a, o) => {
      var p, l, u, m;
      const d = {
        producingPeerId: n,
        producerId: i
      };
      try {
        const T = (await this._socketHandler.consume(d))[i];
        this._logger.info("consumer create response:", {
          consumerState: T,
          paused: (p = T.producerState) == null ? void 0 : p.pause
        }), a({
          consumerId: T.consumerId,
          screenShare: (l = T.producerState) == null ? void 0 : l.screenShare,
          trackId: (u = T.producerTrack) == null ? void 0 : u.trackId,
          streamId: T.producerTrack.streamId,
          kind: T.producerState.kind === rs.VIDEO ? "video" : "audio",
          paused: (m = T.producerState) == null ? void 0 : m.pause
        });
      } catch (g) {
        this._logger.error("error during consuming on server:", g), o(g);
      }
    });
  }
  async createProducer(t, s, i) {
    if (this._sendTransport === void 0 || this._sendTransport.closed)
      return;
    const n = await this._sendTransport.produce(s);
    n.on("close", async (a, o, d) => {
      this._logger.info("producer id:", n.id, "closed with reason:", d);
      const p = {
        producerId: n.id,
        description: {
          sdp: a.sdp,
          type: a.type,
          target: Qs.PUBLISHER
        }
      };
      try {
        const l = await this._socketHandler.closeProducer(p);
        this._logger.info("response", l);
        const u = {
          sdp: l == null ? void 0 : l.sdp,
          type: l == null ? void 0 : l.type
        };
        o(u);
      } catch (l) {
        this._logger.error("producer close error:", l);
      }
      this._producers.delete(t), i(), t === x.SCREENSHARE_VIDEO && this._switchWebcamLayers(3);
    }), n.on("trackended", () => {
      f.info("producer::trackended", {
        producer: {
          id: n == null ? void 0 : n.id,
          kind: t,
          status: "UNKNOWN",
          appData: n == null ? void 0 : n.appData
        }
      }), [x.MIC, x.WEBCAM].includes(t) || i();
    }), this._producers.set(t, n), this._producers.has(x.SCREENSHARE_VIDEO) && this._switchWebcamLayers(0);
  }
  /**
   * switches spatial layers of webcam
   * @layer can be number from 0-3. It will set the max spatial
   * layer to that number.
   * If you pass layer value 0 then there will be only 1 active encoding
   * higher values means more active encodings.
   */
  async _switchWebcamLayers(t) {
    const s = this._producers.get(x.WEBCAM);
    if (s)
      try {
        this._logger.debug("switching layer of webcam producer to:", t), await s.setMaxSpatialLayer(t);
      } catch (i) {
        this._logger.error("failed to switch spatial layer", i);
      }
  }
  _initConsumer(t) {
    t && (t.observer.on("close", async (s) => {
      this._logger.debug("consumer closed", s), this._consumers.delete(t.id), y.emit(v.CONSUMER_CLOSED, { id: t.id });
    }), this._consumers.set(t.id, t), this.producerIdToConsumerIdMap.set(t.producerId, t.id), y.emit(v.NEW_CONSUMER, { id: t.id }));
  }
  async consumePeer(t) {
    if (this._recvTransport === void 0 || this._recvTransport.closed || !this._recvTransport.connected)
      throw Error("Receiving transport not connected");
    try {
      const s = await this._recvTransport.consumePeer(t), i = [];
      s.forEach((n) => {
        n.status === "rejected" ? i.push(n.reason) : this._initConsumer(n.value);
      }), this._recvTransport.retryFailedConsumerCreationTasks(i).then((n) => {
        n.forEach((a) => {
          a.status === "rejected" ? this._logger.error(
            "consumer creation failed 2nd time, this should never happen second time.",
            a.reason
          ) : this._initConsumer(a.value);
        });
      });
    } catch (s) {
      throw this._logger.error("got error in consumePeer", s), s;
    }
  }
  async createConsumer(t) {
    if (this._recvTransport === void 0 || this._recvTransport.closed || !this._recvTransport.connected)
      return;
    const {
      producerId: s,
      producingPeerId: i,
      appData: n
    } = t;
    if (this.getProducer(s)) {
      this._logger.warn("why are you creating a consumer for local producer?");
      return;
    }
    try {
      const o = await this._recvTransport.consume({
        producerId: s,
        producingPeerId: i,
        appData: n
      });
      this._initConsumer(o);
    } catch (o) {
      BR(o) && this._recvTransport.retryFailedConsumerCreationTasks([o]).then(([d]) => {
        d.status === "fulfilled" ? this._initConsumer(d.value) : this._logger.error(
          "failed to complete consumer creation task again.",
          "this should not happen",
          d.reason
        );
      });
    }
    Object.assign(window, { consumers: this._consumers });
  }
  async pauseProducer(t) {
    const s = this._producers.get(t);
    if (!s) {
      this._logger.warn("producer type:", t, "not found");
      return;
    }
    s.pause(), this._logger.info(t, "producer id:", s.id, "paused");
  }
  async resumeProducer(t) {
    const s = this._producers.get(t);
    if (!s) {
      this._logger.warn("producer type:", t, "not found");
      return;
    }
    s.resume(), this._logger.info(t, "producer id:", s.id, "resumed");
  }
  async replaceTrack(t, s) {
    const i = this._producers.get(t);
    if (!i) {
      this._logger.warn("producer type:", t, "not found");
      return;
    }
    await i.replaceTrack({ track: s }), this._logger.info("track replaced with id:", s.id, "on producer:", t);
  }
  async removeProducer(t, s) {
    const i = this._producers.get(t);
    if (!i) {
      this._logger.warn("producer type:", t, "not found");
      return;
    }
    s && i.track.stop(), i.close();
  }
  async pauseConsumer(t) {
    const s = this._consumers.get(t);
    if (!s) {
      this._logger.warn("consumer id:", t, "not found");
      return;
    }
    try {
      const i = {
        consumerId: t,
        pause: !0
      };
      await this.socket.sendMessagePromise(
        me.toggleConsumer,
        hl.toBinary(i)
      ), s.pause(), y.emit(v.CONSUMER_PAUSED, { id: s.id }), this._logger.info("consumer:", t, "paused");
    } catch (i) {
      this._logger.error("error on pausing consumer", i);
    }
  }
  // Experimental
  async toggleConsumerOverDC(t, s) {
    const i = {
      type: "consumer_toggle",
      payload: {
        consumerId: t,
        mute: s
      }
    }, n = this._recvTransport.getDatachannel("events");
    if (!n) {
      this._logger.warn("events datachannel not found");
      return;
    }
    n.send(JSON.stringify(i));
  }
  async resumeConsumer(t) {
    const s = this._consumers.get(t);
    if (!s) {
      this._logger.warn("consumer id:", t, "not found");
      return;
    }
    if (!s.paused) {
      this._logger.warn("consumer is not paused so not resuming", t);
      return;
    }
    try {
      const i = {
        consumerId: t,
        pause: !1
      };
      await this.socket.sendMessagePromise(
        me.toggleConsumer,
        hl.toBinary(i)
      ), s.resume(), y.emit(v.CONSUMER_RESUMED, { id: s.id }), this._logger.info("consumer:", t, "resumed");
    } catch (i) {
      this._logger.error("error on resuming consumer", i);
    }
  }
  // if force is true it will close the consumer irrespective of failure in
  // close consumer request
  async closeConsumer(t, s) {
    return this.closeConsumers([t], s);
  }
  // if force is true it will close the consumer irrespective of failure in
  // close consumer request
  async closeConsumers(t, s = !1) {
    this._logger.info("Closing consumers:", t, "with force:", s);
    let i = !0;
    const n = t.filter((d) => this._consumers.get(d) ? !0 : (this._logger.warn("consumer id:", d, "not found"), !1)), a = {
      consumerIds: n
    }, o = async () => {
      var d;
      return (d = this._recvTransport) == null ? void 0 : d.awaitQueue.push(async () => {
        await this._socketHandler.closeConsumer(a);
      }).catch((p) => {
        this._logger.warn("error on closing consumer:", p), i = s;
      });
    };
    s ? o() : await o(), i && n.forEach((d) => {
      const p = this.consumers.get(d);
      this.producerIdToConsumerIdMap.delete(p.producerId), p.close(s ? "manually closed" : void 0);
    });
  }
  async cleanupConsumers(t) {
    const s = [];
    this._consumers.forEach((i) => {
      t ? i.peerId === t && s.push(i.id) : s.push(i.id);
    }), this.closeConsumers(s, !0);
  }
  async stopAllProducers() {
    this._logger.info("stopping all available producers"), this._producers.forEach((t, s) => {
      this._logger.debug("closing producer type", s), t.close();
    });
  }
  getProducer(t) {
    return [...this.producers.values()].filter((s) => s.id === t).at(0);
  }
  async negotiate(t, s) {
    this._logger.info("initiating negotiation", s), this._logger.info("setting remote offer :", s, "on transport", t.serverId);
    const i = await t.setRemoteOffer(s), n = {
      transportId: t.serverId,
      description: {
        sdp: i.sdp,
        type: i.type,
        target: Qs.SUBSCRIBER
      }
    };
    return this._logger.info("sending renegotiate request", n), await this.socket.sendMessagePromise(
      me.renegotiateSessionDescription,
      OT.toBinary(n)
    ), this._logger.info("renegotiation done", t.serverId), i;
  }
}
var KR = Object.defineProperty, zR = Object.getOwnPropertyDescriptor, de = (r, e, t, s) => {
  for (var i = s > 1 ? void 0 : s ? zR(e, t) : e, n = r.length - 1, a; n >= 0; n--)
    (a = r[n]) && (i = (s ? a(e, t, i) : a(i)) || i);
  return s && i && KR(e, t, i), i;
}, Ve, he, Si, Ys, Ll;
const _p = (Ll = class extends gp {
  constructor(e) {
    super();
    b(this, Ve, void 0);
    b(this, he, void 0);
    b(this, Si, void 0);
    b(this, Ys, void 0);
    h(this, "legacyMode");
    h(this, "roomNodeUrl");
    h(this, "peerDisplayName");
    h(this, "activatedProducingPeerIds");
    h(this, "logger");
    const {
      roomName: t,
      peerId: s,
      authToken: i,
      legacyMode: n,
      socketClient: a,
      meetingTitle: o
    } = e;
    this.roomName = t, this.peerId = s, this.authToken = i, this.legacyMode = n, this.roomJoined = !1, this.meetingTitle = o, P(this, Ys, !1), P(this, Ve, a), P(this, he, new JR(a)), this.maxPreferredStreams = 6, this.activatedProducingPeerIds = /* @__PURE__ */ new Set(), this.logger = St.getLogger("HiveNodeClient()"), A.legacySwitch(n), this.handleSocketEvents(), this.handleSFUEvents(), P(this, Si, () => {
      this.logger.info("noop reconnection handler");
    });
  }
  static async init(e) {
    const {
      legacyMode: t = !0,
      roomName: s,
      peerId: i,
      authToken: n,
      meetingTitle: a,
      socket: o
    } = e, d = new _p({
      legacyMode: t,
      authToken: n,
      socketClient: o,
      peerId: i,
      roomName: s,
      meetingTitle: a
    });
    return o.onStateEvent("disconnected", (p) => {
      var l;
      d.isDisconnected = !0, (l = c(d, he)) == null || l.cleanupConsumers(), y.emit(v.ROOM_NODE_DISCONNECTED, p), d.roomJoined = !1, d.activatedProducingPeerIds = /* @__PURE__ */ new Set(), f.info("HIVE_NODE_DISCONNECTED");
    }), o.onStateEvent("reconnected", async () => {
      var p, l;
      f.info("HIVE_NODE_RECONNECTED"), await ((p = c(d, he)) == null ? void 0 : p.cleanupConsumers()), c(l = d, Si).call(l);
    }), o.onStateEvent("connected", async (p) => {
      y.emit(v.ROOM_NODE_CONNECTED, p), f.info("HIVE_NODE_CONNECTED");
    }), d;
  }
  get sfuHandler() {
    return c(this, he);
  }
  set onSocketReconnection(e) {
    P(this, Si, e);
  }
  async reconnectTransport(e) {
    if (this.logger.info("Room joining state", c(this, Ys)), !(!e || c(this, Ys))) {
      if (e.close(), e.direction === "send") {
        await this.sfuHandler.setupTransports(["send"]), this.logger.info("send transport reconected!"), y.emit(v.RESET_PRODUCER_STATE);
        return;
      }
      this.sfuHandler.cleanupConsumers(), await this.sfuHandler.setupTransports(["recv"]), this.logger.info("recv transport reconnected!"), this.activatedProducingPeerIds = /* @__PURE__ */ new Set(), y.emit(v.REFRESH_GRID, !0);
    }
  }
  async setupTransports() {
    await c(this, he).setupTransports(["recv", "send"]);
  }
  async joinRoom(e, t, s, i, n = {}) {
    await this.sfuHandler.stopAllTransports(), this.peerDisplayName = e, P(this, Ys, !0);
    try {
      return await this.sfuHandler.hiveSocketHandler.joinRoom(s, e), await this.setupTransports(), M.hasFeature(N.INTERNAL_CALL_STATS) && navigator.product !== "ReactNative" && setTimeout(async () => {
        var u;
        const d = await ct().getUserDetails(), p = te.isV2AuthToken ? d.participant : d, l = {
          userId: (u = p.id) != null ? u : p.participant.id,
          peerId: this.peerId,
          displayName: e,
          roomUUID: this.roomUUID,
          roomViewType: "groupCall",
          roomName: this.roomName,
          deviceInfo: {
            ...ae.getDeviceInfo(),
            userAgent: navigator.userAgent,
            memory: navigator.deviceMemory,
            cpus: navigator.hardwareConcurrency
          },
          metaData: {},
          permissions: {}
        };
        A.roomJoined(l), n != null && n.audio ? A.audioOn() : A.audioOff(), n != null && n.video ? A.videoOn() : A.videoOff();
      }), { roomJoined: await this.completeJoinRoom() };
    } catch (a) {
      return this.logger.error("error on sending join room request", a), { roomJoined: !1 };
    }
  }
  async completeJoinRoom() {
    try {
      const {
        maxPreferredStreams: e,
        participants: t,
        roomState: s,
        selectedPeers: i
      } = await this.sfuHandler.hiveSocketHandler.notifySelfJoinComplete();
      this.logger.debug("peerJoinCompleteResponse", { participants: t, roomState: s, selectedPeers: i }), this.roomUUID = s.roomUuid, this.maxPreferredStreams = e;
      const n = t.map((p) => {
        const l = p.producerStates, u = {
          id: p.peerId,
          isHost: !1,
          displayName: p.displayName,
          flags: {},
          userId: p.userId,
          audioMuted: !0,
          videoEnabled: !1,
          audioTrack: null,
          videoTrack: null,
          producers: []
        };
        return l.forEach((m) => {
          m.kind === rs.AUDIO ? u.audioMuted = m.pause : u.videoEnabled = !m.pause, u.producers.push({
            producerId: m.producerId,
            kind: m.kind === rs.AUDIO ? "audio" : "video",
            pause: m.pause,
            screenShare: m.screenShare
          });
        }), u;
      }), { audioPeers: a, compulsoryPeers: o } = i != null ? i : {}, d = n.filter((p) => p.id !== this.peerId);
      return P(this, Ys, !1), this.roomJoined = !0, f.info("HiveNodeClient::joinRoom::pre_emitasync_room_joined"), await y.emitAsync(v.ROOM_JOINED, {
        peers: d
      }), s.isRecording && y.emit(
        v.HIVE_RECORDING_STARTED,
        s.recorderParticipantId
      ), f.info("HiveNodeClient::joinRoom::post_emitasync_room_joined"), y.emit(v.SELF_ROOM_JOINED), y.emit(v.SELECTED_PEERS, {
        peerIds: a != null ? a : [],
        compulsoryPeers: o
      }), y.emit(v.REFRESH_GRID), !0;
    } catch (e) {
      return this.logger.error("error on completing join room:", e), !1;
    }
  }
  async leaveRoom() {
    await c(this, he).stopAllTransports();
    const e = {
      closeRoom: !1
    };
    c(this, Ve).sendMessagePromise(
      me.leaveRoom,
      QT.toBinary(e)
    ).then((t) => {
      var i;
      ((i = Ly.fromBinary(t.payload)) == null ? void 0 : i.closed) || this.logger.warn("weird state on peer closed and should not happen");
    }).catch((t) => {
      this.logger.error("error on sending leave room request", t);
    }), A.callEnded(), _.destruct();
  }
  getConsumers() {
    return c(this, he).consumers;
  }
  async activatePeers(e) {
    const t = e.map(({ peerId: s, producers: i, force: n }) => {
      if (i.length === 0)
        return Promise.resolve();
      let a = !1;
      const o = [];
      return i.every((d) => {
        const p = this.sfuHandler.producerIdToConsumerIdMap.get(d.producerId);
        if (!p)
          return a = !0, !1;
        const l = this.sfuHandler.consumers.get(p);
        return l && !d.pause && l.paused && o.push(p), !0;
      }), a || n ? this.consumePeer(s, n) : o.length > 0 ? this.resumeConsumers(o) : Promise.resolve();
    });
    await Promise.all(t);
  }
  async deactivatePeers(e) {
    this.logger.info("deactivating producers", e), e.producers.forEach(({ producerId: t, kind: s, screenShare: i }) => {
      if (s === "audio" || s === "video" && i) {
        this.logger.debug("we don't want to pause audio or screenshare");
        return;
      }
      const n = this.sfuHandler.producerIdToConsumerIdMap.get(t);
      if (!n) {
        this.logger.warn("consumer not found in deactivate producers:", t);
        return;
      }
      this.sfuHandler.pauseConsumer(n);
    }), this.activatedProducingPeerIds.delete(e.peerId);
  }
  async createConsumer({
    producerId: e,
    producingPeerId: t,
    screenShare: s
  }) {
    return this.sfuHandler.createConsumer({
      producerId: e,
      producingPeerId: t,
      appData: {
        screenShare: s
      }
    });
  }
  async pauseConsumers(e) {
    e.forEach((t) => {
      this.sfuHandler.pauseConsumer(t);
    });
  }
  async resumeConsumers(e) {
    e.forEach((t) => {
      this.sfuHandler.resumeConsumer(t);
    });
  }
  async closeConsumers(e) {
    const t = [...this.getConsumers().values()].filter((s) => e.includes(s.peerId)).map((s) => s.id);
    return e.forEach((s) => {
      this.activatedProducingPeerIds.delete(s);
    }), this.sfuHandler.closeConsumers(t);
  }
  async consumePeer(e, t) {
    if (this.logger.info("current activated Peer ids", [...this.activatedProducingPeerIds.values()], "forced?:", t), !this.activatedProducingPeerIds.has(e) || t)
      try {
        await c(this, he).consumePeer(e), this.activatedProducingPeerIds.add(e);
      } catch (s) {
        this.logger.error("consumePeer failed in HiveNodeClient.ts", s);
      }
    else
      this.logger.info("not creating consumer for this peerId", e);
  }
  async shareWebcam(e) {
    if (e === void 0)
      return;
    if (c(this, he).producers.has(x.WEBCAM)) {
      const i = c(this, he).producers.get(x.WEBCAM);
      if (!i.closed) {
        await i.replaceTrack({ track: e }), await this.resumeWebcam();
        return;
      }
      await c(this, he).removeProducer(i.id);
    }
    const t = {
      track: e,
      codecOptions: {
        name: "VP8"
      },
      appData: {
        screenShare: !1
      },
      stopTracks: !1
    };
    if (M.hasFeature(N.ENABLE_HIVE_SIMULCAST)) {
      let i = e.getConstraints().width;
      i in dl || (i = 320), t.encodings = dl[i];
    }
    const s = () => {
      this.disableWebcam();
    };
    await c(this, he).createProducer(x.WEBCAM, t, s);
  }
  async shareScreen(e) {
    const { video: t, audio: s } = e;
    if (t === void 0)
      return;
    const i = {
      track: t,
      codecOptions: {
        name: "VP8"
      },
      appData: {
        screenShare: !0,
        supportsRemoteControl: ae.isElectron()
      },
      stopTracks: !1
    };
    let n = () => {
      this.disableScreenShare();
    };
    if (A.screenShareRequested(), await c(this, he).createProducer(x.SCREENSHARE_VIDEO, i, n), s) {
      const a = {
        track: s,
        codecOptions: {
          name: "opus"
        },
        appData: {
          screenShare: !0,
          supportsRemoteControl: ae.isElectron()
        },
        stopTracks: !1
      };
      n = () => {
      }, await c(this, he).createProducer(
        x.SCREENSHARE_AUDIO,
        a,
        n
      );
    }
  }
  async shareMic(e) {
    if (e === void 0)
      return;
    if (c(this, he).producers.has(x.MIC)) {
      const i = c(this, he).producers.get(x.MIC);
      if (!i.closed) {
        await i.replaceTrack({ track: e }), await this.resumeMic();
        return;
      }
      await c(this, he).removeProducer(x.MIC, !1);
    }
    const t = {
      track: e,
      encodings: [{
        priority: "high"
      }],
      codecOptions: {
        name: "opus"
      },
      stopTracks: !1
    }, s = () => {
      this.disableMic();
    };
    await c(this, he).createProducer(x.MIC, t, s);
  }
  pauseMic() {
    const e = c(this, he).producers.get(x.MIC);
    if (!e) {
      f.error("pauseMic::could_not_find_mic_producer");
      return;
    }
    if (e.paused) {
      f.info("pauseMic::mic_producer_already_paused");
      return;
    }
    e.pause();
    const t = {
      producerId: e.id,
      pause: !0
    };
    c(this, Ve).sendMessage(
      me.toggleProducer,
      ua.toBinary(t)
    );
  }
  async pauseWebcam() {
    const e = c(this, he).producers.get(x.WEBCAM);
    if (!e) {
      f.error("pauseWebcam::could_not_find_webcam_producer");
      return;
    }
    e.pause();
    const t = {
      producerId: e.id,
      pause: !0
    };
    c(this, Ve).sendMessage(
      me.toggleProducer,
      ua.toBinary(t)
    );
  }
  async resumeMic() {
    const e = c(this, he).producers.get(x.MIC);
    if (!e) {
      f.error("resumeMic::could_not_find_mic_producer");
      return;
    }
    if (!e.pause) {
      f.info("resumeMic::mic_producer_already_resumed");
      return;
    }
    e.resume();
    const t = {
      producerId: e.id,
      pause: !1
    };
    c(this, Ve).sendMessage(
      me.toggleProducer,
      ua.toBinary(t)
    );
  }
  async resumeWebcam() {
    const e = c(this, he).producers.get(x.WEBCAM);
    if (!e) {
      f.error("resumeWebcam::could_not_find_webcam_producer");
      return;
    }
    e.resume();
    const t = {
      producerId: e.id,
      pause: !1
    };
    c(this, Ve).sendMessage(
      me.toggleProducer,
      ua.toBinary(t)
    );
  }
  async disableWebcam() {
    await c(this, he).removeProducer(x.WEBCAM);
  }
  async disableMic() {
    await c(this, he).removeProducer(x.MIC);
  }
  async disableScreenShare() {
    f.info("screen_sharing_stopped"), await c(this, he).removeProducer(x.SCREENSHARE_VIDEO), await c(this, he).removeProducer(x.SCREENSHARE_AUDIO);
  }
  async muteSelf() {
    this.pauseMic();
  }
  async unmuteSelf() {
    await this.resumeMic();
  }
  async resetVideoProducers(e, t) {
    e && (await c(this, he).removeProducer(x.WEBCAM, !1), this.shareWebcam(e)), t && (await c(this, he).removeProducer(x.SCREENSHARE_VIDEO, !1), this.shareScreen({ video: t }));
  }
  // eslint-disable-next-line class-methods-use-this
  async getPolls() {
    return { payload: { polls: {} } };
  }
  async changeDisplayName(e, t) {
    const s = {
      displayName: e,
      participantId: t != null ? t : this.peerId
    };
    if (!await this.sfuHandler.hiveSocketHandler.changeDisplayName(s))
      throw new Error("failed to change display name!");
  }
  async kick(e) {
    const t = {
      participantId: e
    };
    if (!await this.sfuHandler.hiveSocketHandler.kickPeer(t))
      throw new Error("failed to kickout the participant!");
  }
  async kickAll() {
    if (!await this.sfuHandler.hiveSocketHandler.kickAll())
      throw new Error("failed to kickout all participant!");
  }
  async muteAll(e) {
    if (!await this.sfuHandler.hiveSocketHandler.hostControlForAll("audio"))
      throw new Error("failed to mute all participant");
  }
  async muteAllVideo() {
    if (!await this.sfuHandler.hiveSocketHandler.hostControlForAll("video"))
      throw new Error("failed to mute all video participant");
  }
  async mutePeer(e) {
    if (!await this.sfuHandler.hiveSocketHandler.hostControlForPeer(e, "audio"))
      throw new Error("failed to mute given participant");
  }
  async mutePeerVideo(e) {
    if (!await this.sfuHandler.hiveSocketHandler.hostControlForPeer(e, "video"))
      throw new Error("failed to mute video of given participant");
  }
  async pinPeer(e) {
    const t = {
      participantId: e != null ? e : ""
    };
    try {
      await c(this, Ve).sendMessagePromise(
        me.globalPinPeer,
        iy.toBinary(t)
      );
    } catch (s) {
      this.logger.error(`Error in pinning peer: ${s}`);
    }
  }
  async handleSocketEvents() {
    c(this, Ve).on(me.peerJoinedBroadcast, ({ id: e, payload: t }) => {
      if (this.roomJoined) {
        this.logger.debug("got peer joined with id", e);
        try {
          const {
            participant: {
              peerId: s,
              displayName: i,
              producerStates: n,
              userId: a
            }
          } = oE.fromBinary(t);
          if (s === this.peerId)
            return;
          this.logger.info("peer-joined", { peerId: s, displayName: i, producerStates: n });
          const o = {
            id: s,
            isHost: !1,
            displayName: i,
            flags: {},
            userId: a,
            audioMuted: !0,
            videoEnabled: !1,
            audioTrack: null,
            videoTrack: null,
            producers: []
          };
          n.forEach((d) => {
            d.kind === rs.AUDIO ? o.audioMuted = d.pause : o.videoEnabled = !d.pause, o.producers.push({
              producerId: d.producerId,
              kind: d.kind === rs.AUDIO ? "audio" : "video",
              pause: d.pause,
              screenShare: d.screenShare
            });
          }), y.emit(v.PEER_JOINED, o), y.emit(v.REFRESH_GRID);
        } catch (s) {
          this.logger.error("error in peer-joined-broadcast", s);
        }
      }
    }), c(this, Ve).on(me.peerProducerCreateBroadcast, ({ payload: e }) => {
      if (this.roomJoined)
        try {
          const {
            participantId: t,
            producerState: s
          } = dE.fromBinary(e);
          if (t === this.peerId)
            return;
          this.logger.info("producer created broadcast:", t, "producer state", s), y.emit(v.NEW_PRODUCER, {
            peerId: t,
            producer: {
              producerId: s.producerId,
              kind: s.kind === rs.AUDIO ? "audio" : "video",
              pause: s.pause,
              screenShare: s.screenShare
            }
          });
        } catch (t) {
          this.logger.error("error in peer-producer-create-broadcast", t);
        }
    }), c(this, Ve).on(me.peerProducerToggleBroadcast, ({ payload: e }) => {
      if (this.roomJoined)
        try {
          const {
            participantId: t,
            producerState: { kind: s, pause: i, producerId: n }
          } = uE.fromBinary(e), a = s === rs.AUDIO ? "audio" : "video";
          if (this.logger.info("producer toggle broadcast:", t, "producerId", n, "kind", a, "paused", i), t === this.peerId && i) {
            y.emit(a === "audio" ? v.MUTE_ALL : v.MUTE_ALL_VIDEO);
            return;
          }
          y.emit(v.PRODUCER_TOGGLE, {
            peerId: t,
            producerId: n,
            paused: i,
            kind: a
          }), [...this.getConsumers().values()].filter((d) => d.producerId === n).forEach((d) => {
            d.paused !== i && (this.logger.debug(
              "consumer state mismatched for",
              d.id,
              ". updating consumer pause state",
              d.paused,
              "to",
              i
            ), i ? (d.pause(), y.emit(v.CONSUMER_PAUSED, { id: d.id })) : (d.resume(), y.emit(v.CONSUMER_RESUMED, { id: d.id })));
          });
        } catch (t) {
          this.logger.error("error in producer toggle broadcast handler", t);
        }
    }), c(this, Ve).on(me.selectedPeer, ({ payload: e }) => {
      if (this.roomJoined)
        try {
          const { audioPeers: t, compulsoryPeers: s } = up.fromBinary(e);
          this.logger.info("selected peers:", t, s), y.emit(v.SELECTED_PEERS, {
            peerIds: s.concat(t)
          });
        } catch (t) {
          this.logger.error("error in selected-peer", t);
        }
    }), c(this, Ve).on(me.selectedPeerDiff, ({ payload: e }) => {
      if (this.roomJoined)
        try {
          const { entries: t } = Iy.fromBinary(e);
          this.logger.debug("selected peers diff:", t);
          const s = t.map((i) => ({
            peerId: i.peerId,
            priority: i.priority
          }));
          y.emit(
            v.SELECTED_PEERS_DIFF,
            { entries: s }
          );
        } catch (t) {
          this.logger.error("error in selected-peer-diff", t);
        }
    }), c(this, Ve).on(me.peerLeaveBroadcast, ({ payload: e }) => {
      if (this.roomJoined)
        try {
          const { participantId: t } = fE.fromBinary(e);
          if (t === this.peerId) {
            this.logger.warn("peer got kicked out of the room"), y.emit(v.KICKED);
            return;
          }
          this.logger.info("peer left broadcast:", t), this.sfuHandler.cleanupConsumers(t), y.emit(v.PEER_CLOSED, { id: t });
        } catch (t) {
          this.logger.error("error in peer left broadcast", t);
        }
    }), c(this, Ve).on(me.peerProducerCloseBroadcast, ({ payload: e }) => {
      if (this.roomJoined)
        try {
          const {
            participantId: t,
            producerState: { producerId: s }
          } = hE.fromBinary(e);
          if (t === this.peerId)
            return;
          this.logger.info("producer closed broadcast:", t), y.emit(v.PRODUCER_CLOSED, {
            peerId: t,
            producerId: s
          });
          const i = this.sfuHandler.producerIdToConsumerIdMap.get(s);
          if (!i) {
            this.logger.warn("no consumer found for producer", s);
            return;
          }
          this.logger.info("closing consumer", i, "producer id ", s), this.sfuHandler.closeConsumer(i).then(() => {
            this.logger.info("closed consumer", i), this.sfuHandler.producerIdToConsumerIdMap.delete(s), y.emit(v.CONSUMER_CLOSED, { id: i });
          }).catch((n) => {
            this.logger.error("error closing consumer", n);
          });
        } catch (t) {
          this.logger.error("error on producer close broadcast", t);
        }
    }), c(this, Ve).on(me.globalPeerPinBroadcast, ({ payload: e }) => {
      if (this.roomJoined)
        try {
          let t;
          if (e) {
            const s = _E.fromBinary(e);
            this.logger.info("pinning peerId: ", s), t = s.participantId;
          }
          y.emit(v.PEER_PINNED, {
            peerId: t
          });
        } catch (t) {
          this.logger.error("error on global peer pin broadcast", t);
        }
    }), c(this, Ve).on(me.recordingStartedBroadcast, ({ payload: e }) => {
      if (this.roomJoined)
        try {
          let t;
          if (e) {
            const s = TE.fromBinary(e);
            this.logger.info("recording started. peerId: ", s), t = s.participantId;
          }
          y.emit(v.HIVE_RECORDING_STARTED, t);
        } catch (t) {
          this.logger.error("error on recording started broadcast", t);
        }
    }), c(this, Ve).on(me.recordingStoppedBroadcast, ({ payload: e }) => {
      if (this.roomJoined)
        try {
          let t;
          if (e) {
            const s = EE.fromBinary(e);
            this.logger.info("recording stopped. peerId: ", s), t = s.participantId;
          }
          y.emit(v.HIVE_RECORDING_STOPPED, t);
        } catch (t) {
          this.logger.error("error on recording started broadcast", t);
        }
    }), c(this, Ve).on(me.peerDisplayNameEditBroadcast, ({ payload: e }) => {
      if (this.roomJoined)
        try {
          const t = wE.fromBinary(e);
          this.logger.debug("peer display name changed to:", t.displayName), y.emit(v.PEER_DISPLAY_NAME_CHANGED, t.participantId);
        } catch (t) {
          this.logger.error("failed to handle peerDisplayNameEditBroadcast:", t);
        }
    });
  }
  handleSFUEvents() {
    c(this, he).on("reconnect_transport", async (e) => {
      try {
        await this.reconnectTransport(e), this.logger.info("transport reconnected [id:%s]", e.id);
      } catch (t) {
        this.logger.error("error on reconnection transports", t);
      }
    });
  }
}, Ve = new WeakMap(), he = new WeakMap(), Si = new WeakMap(), Ys = new WeakMap(), Ll);
let z = _p;
de([
  _.trace("HiveNodeClient.reconnect")
], z.prototype, "reconnectTransport", 1);
de([
  _.trace("HiveNodeClient.setupTransport")
], z.prototype, "setupTransports", 1);
de([
  _.trace("HiveNodeClient.joinRoom")
], z.prototype, "joinRoom", 1);
de([
  _.trace("HiveNodeClient.completeJoinRoom")
], z.prototype, "completeJoinRoom", 1);
de([
  _.trace("HiveNodeClient.leaveRoom")
], z.prototype, "leaveRoom", 1);
de([
  _.trace("HiveNodeClient.activatePeers")
], z.prototype, "activatePeers", 1);
de([
  _.trace("HiveNodeClient.deactivatePeers")
], z.prototype, "deactivatePeers", 1);
de([
  _.trace("HiveNodeClient.createConsumer")
], z.prototype, "createConsumer", 1);
de([
  _.trace("HiveNodeClient.pauseConsumers")
], z.prototype, "pauseConsumers", 1);
de([
  _.trace("HiveNodeClient.resumeConsumers")
], z.prototype, "resumeConsumers", 1);
de([
  _.trace("HiveNodeClient.closeConsumers")
], z.prototype, "closeConsumers", 1);
de([
  _.trace("HiveNodeClient.consumePeer")
], z.prototype, "consumePeer", 1);
de([
  _.trace("HiveNodeClient.shareWebcam")
], z.prototype, "shareWebcam", 1);
de([
  _.trace("HiveNodeClient.shareScreen")
], z.prototype, "shareScreen", 1);
de([
  _.trace("HiveNodeClient.shareMic")
], z.prototype, "shareMic", 1);
de([
  _.trace("HiveNodeClient.pauseMic")
], z.prototype, "pauseMic", 1);
de([
  _.trace("HiveNodeClient.pauseWebcam")
], z.prototype, "pauseWebcam", 1);
de([
  _.trace("HiveNodeClient.resumeMic")
], z.prototype, "resumeMic", 1);
de([
  _.trace("HiveNodeClient.resumeWebcam")
], z.prototype, "resumeWebcam", 1);
de([
  _.trace("HiveNodeClient.disableWebcam")
], z.prototype, "disableWebcam", 1);
de([
  _.trace("HiveClient.disableMic")
], z.prototype, "disableMic", 1);
de([
  _.trace("HiveClient.disableScreenShare")
], z.prototype, "disableScreenShare", 1);
de([
  _.trace("HiveNodeClient.muteSelf")
], z.prototype, "muteSelf", 1);
de([
  _.trace("HiveNodeClient.unmuteSelf")
], z.prototype, "unmuteSelf", 1);
de([
  _.trace("HiveNodeClient.resetVideoProducers")
], z.prototype, "resetVideoProducers", 1);
de([
  _.trace("HiveNodeClient.getPolls")
], z.prototype, "getPolls", 1);
de([
  _.trace("HiveNodeClient.changeDisplayName")
], z.prototype, "changeDisplayName", 1);
de([
  _.trace("HiveNodeClient.kickPeer")
], z.prototype, "kick", 1);
de([
  _.trace("HiveNodeClient.kickAllPeers")
], z.prototype, "kickAll", 1);
de([
  _.trace("HiveNodeClient.muteAll")
], z.prototype, "muteAll", 1);
de([
  _.trace("HiveNodeClient.muteAllVideo")
], z.prototype, "muteAllVideo", 1);
de([
  _.trace("HiveNodeClient.mute")
], z.prototype, "mutePeer", 1);
de([
  _.trace("HiveNodeClient.muteVideo")
], z.prototype, "mutePeerVideo", 1);
de([
  _.trace("HiveNodeClient.pinPeer")
], z.prototype, "pinPeer", 1);
de([
  _.trace("HiveNodeClient.init")
], z, "init", 1);
var Ns = /* @__PURE__ */ ((r) => (r.SOCKET_CONNECTED = "SOCKET_CONNECTED", r.SOCKET_DISCONNECTED = "SOCKET_DISCONNECTED", r.SOCKET_CONNECTION_ERROR = "SOCKET_CONNECTION_ERROR", r.SOCKET_MESSAGE = "SOCKET_MESSAGE", r))(Ns || {}), ln = /* @__PURE__ */ ((r) => (r[r.NOT_STARTED = 0] = "NOT_STARTED", r[r.CONNECTED = 1] = "CONNECTED", r[r.DISCONNECTED = 2] = "DISCONNECTED", r[r.ERRORED = 3] = "ERRORED", r))(ln || {}), QR = Object.defineProperty, YR = Object.getOwnPropertyDescriptor, _o = (r, e, t, s) => {
  for (var i = s > 1 ? void 0 : s ? YR(e, t) : e, n = r.length - 1, a; n >= 0; n--)
    (a = r[n]) && (i = (s ? a(e, t, i) : a(i)) || i);
  return s && i && QR(e, t, i), i;
};
const ZR = "event://server-simple-message", XR = "event://send-message";
class ta extends bt {
  constructor(t) {
    super();
    h(this, "socket");
    h(this, "socketState");
    h(this, "callbackHandler", null);
    this.socketState = ln.NOT_STARTED, t.callbackHandler && (this.callbackHandler = t.callbackHandler);
  }
  connect(t) {
    this.socket && (this.socket.removeAllListeners(), this.socket.disconnect()), this.socket = ph(t, { closeOnBeforeunload: !1 }), this.setupSocket();
  }
  disconnect() {
    this.socket.disconnect();
  }
  reconnect() {
    this.socket.connect();
  }
  setupSocket() {
    this.socket.on("disconnect", (t) => {
      this.socketState = ln.DISCONNECTED, f.warn("SocketClient::socket_disconnected", { error: { reason: t } }), this.emit(Ns.SOCKET_DISCONNECTED, { reason: t });
    }), this.socket.on("connect_error", (t) => {
      this.socketState = ln.ERRORED, M.hasFeature(N.SOCKET_POLLING) && (this.socket.io.opts.transports = ["polling", "websocket"]), f.error("SocketClient::socket_connection_errored", { error: t }), this.emit(Ns.SOCKET_CONNECTION_ERROR, { err: t });
    }), this.socket.on("connect", () => {
      this.socketState = ln.CONNECTED, f.info("SocketClient::socket_connected"), this.emit(Ns.SOCKET_CONNECTED);
    }), this.socket.on(ZR, async (t, s) => {
      const i = JSON.parse(t);
      if ((!_.logExclusionList.includes(i == null ? void 0 : i.type) || M.hasFeature(N.BYPASS_LOG_EXCLUSION_LIST)) && f.info(
        `SocketClient::SIMPLE_SERVER_MESSAGE_EVENT::${i == null ? void 0 : i.type}`
      ), s) {
        let n = "OK";
        this.callbackHandler && (n = await this.callbackHandler(i)), s(n);
      } else
        this.emit(Ns.SOCKET_MESSAGE, i);
      Object.values(v).find((n) => n === i.type) && y.emit(i.type, i.payload);
    });
  }
  async sendMessage(t) {
    return (!_.logExclusionList.includes(t == null ? void 0 : t.type) || M.hasFeature(N.BYPASS_LOG_EXCLUSION_LIST)) && f.info(
      `SocketClient::sendMessage::${t == null ? void 0 : t.type}`
    ), Object.assign(t, { metadata: t.metadata || {} }), _.injectContext(t.metadata), new Promise((s) => {
      this.socket.emit(XR, JSON.stringify(t), (i) => {
        if (!i) {
          s(void 0);
          return;
        }
        const n = JSON.parse(i);
        s(n);
      });
    });
  }
}
_o([
  _.trace("SocketClient.connect")
], ta.prototype, "connect", 1);
_o([
  _.trace("SocketClient.disconnect")
], ta.prototype, "disconnect", 1);
_o([
  _.trace("SocketClient.reconnect")
], ta.prototype, "reconnect", 1);
_o([
  _.trace("SocketClient.setupSocket")
], ta.prototype, "setupSocket", 1);
var eb = Object.defineProperty, tb = Object.getOwnPropertyDescriptor, xt = (r, e, t, s) => {
  for (var i = s > 1 ? void 0 : s ? tb(e, t) : e, n = r.length - 1, a; n >= 0; n--)
    (a = r[n]) && (i = (s ? a(e, t, i) : a(i)) || i);
  return s && i && eb(e, t, i), i;
};
class Pt extends bt {
  constructor(t, s) {
    super();
    h(this, "device");
    h(this, "sendTransport");
    h(this, "recvTransport");
    h(this, "sendTransportIceStateDisconnectTime");
    h(this, "recvTransportIceStateDisconnectTime");
    h(this, "producerCreationStatus");
    h(this, "consumers");
    h(this, "producers");
    h(this, "socketClient");
    h(this, "iceRestartInProgress");
    this.producers = /* @__PURE__ */ new Map(), this.consumers = /* @__PURE__ */ new Map(), this.producerCreationStatus = /* @__PURE__ */ new Map(), this.iceRestartInProgress = { sendTransport: !1, recvTransport: !1 }, s !== void 0 ? this.device = s : this.device = new Qu(), this.socketClient = t;
  }
  async setupTransports() {
    const s = await ct().getICEServers();
    await this.loadRouter(), await Promise.all([
      this.createRecvTransport(s),
      this.createSendTransport(s)
    ]);
  }
  async loadRouter() {
    (this.recvTransport || this.sendTransport) && await this.stopAllTransports();
  }
  getRTPCapabilities() {
    return this.device.rtpCapabilities;
  }
  async createRecvTransport(t) {
    if (!this.socketClient)
      return;
    const s = {
      forceTcp: !1,
      producing: !1,
      consuming: !0
    }, i = (await this.socketClient.sendMessage({
      type: "createWebRtcTransport",
      payload: s
    })).payload;
    if (f.info("recvTransport::initializing_transport"), this.recvTransport = this.device.createRecvTransport({
      ...i,
      iceServers: t,
      proprietaryConstraints: cl
    }), f.info("recvTransport::initialized_transport"), A.onSafeInitialization(() => {
      A.configureRecvTransport(this.recvTransport);
    }), this.recvTransport.on("connect", async ({ dtlsParameters: n }, a, o) => {
      var p, l, u, m;
      const d = await this.socketClient.sendMessage({
        type: "connectWebRtcTransport",
        payload: {
          transportId: this.recvTransport.id,
          dtlsParameters: n
        }
      });
      (p = d.payload) != null && p.error ? (f.error("recvTransport::transport_status", {
        error: (u = d.payload) == null ? void 0 : u.error,
        transport: {
          id: (m = this == null ? void 0 : this.recvTransport) == null ? void 0 : m.id,
          status: "failed",
          type: "recv"
        }
      }), o(new Error("failed"))) : (a(), f.info("recvTransport::transport_status", {
        transport: {
          id: (l = this == null ? void 0 : this.recvTransport) == null ? void 0 : l.id,
          status: "connected",
          type: "recv"
        }
      }));
    }), M.hasFeature(N.ENABLE_ICE_STATE_LOGGING)) {
      f.info("enabling_ice_state_logging_for_recv_transport");
      let n;
      this.recvTransport.on("connectionstatechange", async (a) => {
        var o, d, p, l, u, m, g, T;
        switch (f.info("recvTransport::connection_state_change", {
          transport: {
            id: (o = this == null ? void 0 : this.recvTransport) == null ? void 0 : o.id,
            status: a,
            type: "recv"
          }
        }), a) {
          case "failed":
            if (y.emit(v.ICE_FAILED, { transport: "recv" }), f.warn("recvTransport::ice_state_failed"), M.hasFeature(N.ICE_RESTART_ON_FAILED_STATE))
              try {
                await this.restartIceTillSuccess(this.recvTransport);
              } catch (S) {
                f.error("recvTransport::ice_restart_failed", {
                  error: S,
                  transport: {
                    id: (d = this == null ? void 0 : this.recvTransport) == null ? void 0 : d.id,
                    status: "failed",
                    type: "recv"
                  }
                });
              }
            break;
          case "disconnected":
            y.emit(v.ICE_DISCONNECTED, { transport: "recv" }), f.warn("recvTransport::ice_state_disconnected"), this.recvTransportIceStateDisconnectTime && f.warn("recvTransport::ice_state_disconnected_again", {
              transport: {
                id: (p = this == null ? void 0 : this.recvTransport) == null ? void 0 : p.id,
                status: "disconnected",
                type: "recv",
                lastDisconnectedTime: (l = this.recvTransportIceStateDisconnectTime) == null ? void 0 : l.toISOString(),
                lastDisconnectedTimeOffset: (u = this.recvTransportIceStateDisconnectTime) == null ? void 0 : u.getTimezoneOffset(),
                durationPassed: new Date().getTime() - this.recvTransportIceStateDisconnectTime.getTime()
              }
            }), this.recvTransportIceStateDisconnectTime = new Date();
            try {
              n = M.getValue(
                N.ICE_RESTART_ON_DISCONNECTED_STATE
              ), typeof n != "number" && (n = void 0);
            } catch (S) {
              n = void 0;
            }
            n && setTimeout(
              async () => {
                var S, R, D, I, re;
                if (this.recvTransportIceStateDisconnectTime !== void 0) {
                  y.emit(v.ICE_RECONNECTING, { transport: "recv" }), f.info("recvTransport::attempting_ice_restart", {
                    transport: {
                      id: (S = this == null ? void 0 : this.recvTransport) == null ? void 0 : S.id,
                      type: "recv",
                      status: "reconnecting",
                      lastDisconnectedTime: (R = this.recvTransportIceStateDisconnectTime) == null ? void 0 : R.toISOString(),
                      lastDisconnectedTimeOffset: (D = this.recvTransportIceStateDisconnectTime) == null ? void 0 : D.getTimezoneOffset()
                    },
                    iceRestart: {
                      isSendTransport: (I = this == null ? void 0 : this.iceRestartInProgress) == null ? void 0 : I.sendTransport,
                      isRecvTransport: (re = this == null ? void 0 : this.iceRestartInProgress) == null ? void 0 : re.recvTransport
                    }
                  });
                  try {
                    await this.restartIceTillSuccess(this.recvTransport);
                  } catch (ge) {
                    f.info("SFUHandler.disconnected.restartIceFailed", {
                      error: ge,
                      iceRestart: {
                        status: "failed",
                        isRecvTransport: !0
                      }
                    });
                  }
                }
              },
              n
            );
            break;
          case "connected":
            y.emit(v.ICE_CONNECTED, { transport: "recv" }), f.info("recvTransport::ice_state_connected", {
              transport: {
                id: (m = this == null ? void 0 : this.recvTransport) == null ? void 0 : m.id,
                type: "recv",
                status: "connected",
                lastDisconnectedTime: (g = this.recvTransportIceStateDisconnectTime) == null ? void 0 : g.toISOString(),
                lastDisconnectedTimeOffset: (T = this.recvTransportIceStateDisconnectTime) == null ? void 0 : T.getTimezoneOffset(),
                durationPassed: this.recvTransportIceStateDisconnectTime ? new Date().getTime() - this.recvTransportIceStateDisconnectTime.getTime() : null
              }
            }), this.recvTransportIceStateDisconnectTime = void 0;
            break;
        }
      });
    }
    this.recvTransport.observer.on("close", () => {
      this.recvTransport = void 0, f.warn("recvTransport_closed");
    });
  }
  async createSendTransport(t) {
    const s = {
      forceTcp: !1,
      producing: !0,
      consuming: !1
    }, i = (await this.socketClient.sendMessage({
      type: "createWebRtcTransport",
      payload: s
    })).payload;
    if (f.info("sendTransport::initializing_transport"), this.sendTransport = this.device.createSendTransport({
      ...i,
      iceServers: t,
      proprietaryConstraints: cl
    }), f.info("sendTransport::initialized_transport"), A.onSafeInitialization(() => {
      A.configureSendTransport(this.sendTransport);
    }), this.sendTransport.on("connect", async ({ dtlsParameters: n }, a, o) => {
      var p, l, u, m;
      (l = (await this.socketClient.sendMessage({
        type: "connectWebRtcTransport",
        payload: {
          transportId: (p = this.sendTransport) == null ? void 0 : p.id,
          dtlsParameters: n
        }
      })).payload) != null && l.error ? (f.error("sendTransport::transport_status", {
        transport: {
          id: (m = this == null ? void 0 : this.sendTransport) == null ? void 0 : m.id,
          status: "failed",
          type: "send"
        }
      }), o(new Error("failed"))) : (f.info("sendTransport::transport_status", {
        transport: {
          id: (u = this == null ? void 0 : this.sendTransport) == null ? void 0 : u.id,
          status: "connected",
          type: "send"
        }
      }), a());
    }), this.sendTransport.on("produce", async ({
      kind: n,
      rtpParameters: a,
      appData: o
    }, d, p) => {
      var u, m, g, T, S, R;
      const l = await this.socketClient.sendMessage({
        type: "produce",
        payload: {
          transportId: (u = this.sendTransport) == null ? void 0 : u.id,
          kind: n,
          rtpParameters: a,
          appData: o
        }
      });
      (m = l.payload) != null && m.error ? (f.info("sendTransport::producer_status::failed", {
        producer: {
          kind: n,
          appData: o,
          status: "failed",
          id: (S = l == null ? void 0 : l.payload) == null ? void 0 : S.id
        }
      }), p((R = l.payload) == null ? void 0 : R.error)) : (f.info("sendTransport::producer_status::producing", {
        producer: {
          kind: n,
          appData: o,
          status: "producing",
          id: (g = l == null ? void 0 : l.payload) == null ? void 0 : g.id
        }
      }), d({ id: (T = l.payload) == null ? void 0 : T.id }));
    }), M.hasFeature(N.ENABLE_ICE_STATE_LOGGING)) {
      f.info("Enabling ice state logging for send transport");
      let n;
      this.sendTransport.on("connectionstatechange", async (a) => {
        var o, d, p, l;
        switch (f.info("sendTransport::connection_state_change", {
          transport: {
            id: (o = this == null ? void 0 : this.sendTransport) == null ? void 0 : o.id,
            status: a,
            type: "send"
          }
        }), a) {
          case "failed":
            if (y.emit(v.ICE_FAILED, { transport: "send" }), f.warn("sendTransport::ice_state_failed"), M.hasFeature(N.ICE_RESTART_ON_FAILED_STATE))
              try {
                await this.restartIceTillSuccess(this.sendTransport);
              } catch (u) {
                f.error("sendTransport::ice_restart_failed", {
                  error: u
                });
              }
            break;
          case "disconnected":
            y.emit(v.ICE_DISCONNECTED, { transport: "send" }), f.warn("sendTransport::ice_state_disconnected"), this.sendTransportIceStateDisconnectTime && f.warn("sendTransport::ice_state_disconnected_again", {
              transport: {
                id: (d = this == null ? void 0 : this.sendTransport) == null ? void 0 : d.id,
                status: "disconnected",
                lastDisconnectedTime: this.sendTransportIceStateDisconnectTime.toLocaleTimeString(),
                durationPassed: (
                  // eslint-disable-next-line max-len
                  new Date().getTime() - this.sendTransportIceStateDisconnectTime.getTime()
                ),
                type: "send"
              }
            }), this.sendTransportIceStateDisconnectTime = new Date();
            try {
              n = M.getValue(
                N.ICE_RESTART_ON_DISCONNECTED_STATE
              ), typeof n != "number" && (n = void 0);
            } catch (u) {
              n = void 0;
            }
            n && setTimeout(
              async () => {
                var u, m, g, T;
                if (this.sendTransportIceStateDisconnectTime !== void 0) {
                  y.emit(v.ICE_RECONNECTING, { transport: "send" }), f.info("sendTransport::attempting_ice_restart", {
                    transport: {
                      id: (u = this == null ? void 0 : this.sendTransport) == null ? void 0 : u.id,
                      status: "reconnecting",
                      type: "send",
                      lastDisconnectedTime: (m = this.sendTransportIceStateDisconnectTime) == null ? void 0 : m.toISOString(),
                      lastDisconnectedTimeOffset: (g = this.sendTransportIceStateDisconnectTime) == null ? void 0 : g.getTimezoneOffset()
                    },
                    iceRestart: {
                      status: "connecting"
                    }
                  });
                  try {
                    await this.restartIceTillSuccess(this.sendTransport);
                  } catch (S) {
                    f.info("SFUHandler.disconnected.restartIceFailed", {
                      error: S,
                      transport: {
                        id: (T = this == null ? void 0 : this.sendTransport) == null ? void 0 : T.id,
                        type: "send",
                        status: "failed"
                      }
                    });
                  }
                }
              },
              n
            );
            break;
          case "connected":
            y.emit(v.ICE_CONNECTED, { transport: "send" }), f.info("sendTransport::ice_state_connected", {
              transport: {
                id: (p = this == null ? void 0 : this.sendTransport) == null ? void 0 : p.id,
                type: "send",
                status: "connected",
                lastDisconnectedTime: (l = this.sendTransportIceStateDisconnectTime) == null ? void 0 : l.toLocaleTimeString(),
                durationPassed: this.sendTransportIceStateDisconnectTime ? new Date().getTime() - this.sendTransportIceStateDisconnectTime.getTime() : null
              }
            }), this.sendTransportIceStateDisconnectTime = void 0;
            break;
        }
      });
    }
    this.sendTransport.observer.on("close", () => {
      this.sendTransport = void 0, f.warn("sendTransport_closed");
    });
  }
  async restartIce(t) {
    const { direction: s } = t;
    if (!(s === "recv" ? this.iceRestartInProgress.recvTransport : this.iceRestartInProgress.sendTransport)) {
      s === "recv" ? this.iceRestartInProgress.recvTransport = !0 : this.iceRestartInProgress.sendTransport = !0;
      try {
        const n = (await this.socketClient.sendMessage({
          type: "restartIce",
          payload: {
            transportId: t.id
          }
        })).payload;
        await t.restartIce(n);
      } catch (n) {
        f.error("SFUHandler.restartIce.Failed", {
          error: n,
          iceRestart: {
            status: "failed"
          },
          transport: {
            id: t == null ? void 0 : t.id,
            status: "failed",
            type: s
          }
        });
      }
      s === "recv" ? this.iceRestartInProgress.recvTransport = !1 : this.iceRestartInProgress.sendTransport = !1;
    }
  }
  async createConsumer(t) {
    if (this.recvTransport === void 0 || this.recvTransport.closed)
      return;
    const {
      peerId: s,
      producerId: i,
      id: n,
      kind: a,
      rtpParameters: o,
      appData: d,
      remotelyPaused: p
    } = t;
    f.info("createConsumer::initializing_consumer", {
      consumer: {
        id: n,
        peerId: s,
        kind: a,
        appData: d,
        remotelyPaused: p
      }
    });
    const l = await this.recvTransport.consume({
      id: n,
      producerId: i,
      kind: a,
      rtpParameters: o,
      appData: { ...d, peerId: s }
    });
    f.info("createConsumer::initialized_consumer", {
      consumer: {
        id: n,
        peerId: s,
        kind: a,
        appData: d,
        remotelyPaused: p
      }
    });
    const u = l;
    u.peerId = s, u.remotelyPaused = p, u.score = 10, this.consumers.set(l.id, u);
  }
  async closeConsumer(t) {
    const { id: s } = t, i = this.consumers.get(s);
    i && (f.info("SFUHandler::close_consumer", {
      consumer: i
    }), i.close(), this.consumers.delete(s));
  }
  async cleanupConsumers() {
    var t;
    (t = this.consumers) == null || t.forEach((s) => {
      y.emit(v.CONSUMER_CLOSED, { id: s.id }), this.closeConsumer({ id: s.id });
    });
  }
  async pauseConsumer(t) {
    const { id: s } = t, i = this.consumers.get(s);
    i && i.pause();
  }
  async resumeConsumer(t) {
    const { id: s } = t, i = this.consumers.get(s);
    i && i.resume();
  }
  async createProducer(t, s, i) {
    if (this.sendTransport === void 0 || this.sendTransport.closed)
      return;
    if (f.info("createProducer::initializing_producer", {
      producer: {
        id: "TO_BE_CREATED",
        kind: t,
        status: "initializing",
        appData: s == null ? void 0 : s.appData
      }
    }), this.producerCreationStatus.get(t) && this.producerCreationStatus.get(t) === "INITIALIZING") {
      f.info("createProducer::producer getting initializing", {
        producer: {
          id: "GETTING_CREATED",
          status: "initializing",
          kind: t,
          appData: s == null ? void 0 : s.appData
        }
      });
      return;
    }
    this.producerCreationStatus.set(
      t,
      "INITIALIZING"
      /* INITIALIZING */
    );
    const n = await Promise.race([
      this.sendTransport.produce(s),
      new Promise((o) => setTimeout(() => o(void 0), 6e3))
    ]);
    if (!n)
      throw f.error("createProducer::transport_initialization_timed_out", {
        producer: {
          id: "FAILED_TO_CREATE",
          kind: t,
          status: "failed",
          appData: s == null ? void 0 : s.appData
        }
      }), this.producerCreationStatus.set(
        t,
        "NOT_INITIALIZED"
        /* NOT_INITIALIZED */
      ), new E(`Producer Creation timed out! ${t}`);
    this.producerCreationStatus.set(
      t,
      "INITIALIZED"
      /* INITIALIZED */
    ), f.info("createProducer::initialized_producer", {
      producer: {
        id: n == null ? void 0 : n.id,
        kind: t,
        status: "UNKNOWN",
        appData: s == null ? void 0 : s.appData
      }
    }), n.on("transportclose", () => {
      f.info("producer::transportclose", {
        producer: {
          id: n == null ? void 0 : n.id,
          kind: t,
          status: "UNKNOWN",
          appData: s == null ? void 0 : s.appData
        }
      }), this.producerCreationStatus.set(
        t,
        "NOT_INITIALIZED"
        /* NOT_INITIALIZED */
      ), this.producers.delete(t);
    }), n.on("trackended", () => {
      f.info("producer::trackended", {
        producer: {
          id: n == null ? void 0 : n.id,
          kind: t,
          status: "UNKNOWN",
          appData: s == null ? void 0 : s.appData
        }
      }), [x.MIC, x.WEBCAM].includes(t) || i();
    });
    const a = n;
    a.score = 10, this.producers.set(t, a), await this.reconfigureWebcamLayers(), await this.reconfigureSafariScreenshareLayers();
  }
  async removeProducer(t, s = !0) {
    const i = this.producers.get(t);
    !i || i.closed || (f.info("SFUHandler::remove_producer", {
      producer: {
        id: i == null ? void 0 : i.id,
        kind: t,
        status: "UNKNOWN",
        appData: i == null ? void 0 : i.appData
      },
      debuggingHint: `stopTrack was ${s}`
    }), s && i.track.stop(), i.close(), await this.socketClient.sendMessage({ type: "closeProducer", payload: { producerId: i.id } }), this.producerCreationStatus.set(
      t,
      "NOT_INITIALIZED"
      /* NOT_INITIALIZED */
    ), this.producers.delete(t), await this.reconfigureWebcamLayers());
  }
  stopAllProducers() {
    Array.from(this.producers.keys()).forEach((t) => {
      this.removeProducer(t);
    });
  }
  async stopAllTransports() {
    if (this.sendTransport) {
      try {
        this.sendTransport.close();
      } catch (t) {
        f.error("stopAllTransports", { error: t });
      }
      this.sendTransport = void 0;
    }
    if (this.recvTransport) {
      try {
        this.recvTransport.close();
      } catch (t) {
        f.error("SFUHandler::stopAllTransports::error", t);
      }
      this.recvTransport = void 0;
    }
  }
  /**
   * Control which simulcast layers are active on the webcam producer. Used to
   * save bandwidth while screensharing by disabling extra layers. Also used to
   * enable back layers when screenshare is not active.
   * Currently, this is behing a feature flag.
   */
  async reconfigureWebcamLayers() {
    if (!M.hasFeature(N.DISABLE_WEBCAM_LAYERS_ON_SCREENSHARE))
      return;
    const t = this.producers.get(x.WEBCAM);
    t && await t.setMaxSpatialLayer(
      this.producers.get(x.SCREENSHARE_VIDEO) ? 0 : 1
    );
  }
  /**
   * Mediasoup Safari bug, where encodings were not correctly passed in the Safari handler
   * set the encodings post creation of the screenshare producer in Safari
   */
  async reconfigureSafariScreenshareLayers() {
    if (!M.hasFeature(N.SCREENSHARE_SIMULCAST) || !ae.isSafari())
      return;
    const t = this.producers.get(x.SCREENSHARE_VIDEO);
    if (!t)
      return;
    const s = t.rtpSender.getParameters();
    s.encodings = Wv, t.rtpSender.setParameters(s);
  }
  async restartIceTillSuccess(t, s = 3) {
    let i = !1, n = 0;
    for (; !i && n < s; )
      try {
        f.info("SFUHandler.restartIceTillSuccess.AttemptRestart", {
          iceRestart: {
            currentAttempt: n,
            isSendTransport: t.direction === "send",
            isRecvTransport: t.direction === "recv"
          }
        }), await this.restartIce(t), i = !0;
      } catch (a) {
        n += 1;
      }
    if (!i)
      throw new E("Failed to restart Ice");
  }
}
xt([
  _.trace("SFUHandler.setupTransports")
], Pt.prototype, "setupTransports", 1);
xt([
  _.trace("SFUHandler.loadRouter")
], Pt.prototype, "loadRouter", 1);
xt([
  _.trace("SFUHandler.createRecvTransport")
], Pt.prototype, "createRecvTransport", 1);
xt([
  _.trace("SFUHandler.createSendTransport")
], Pt.prototype, "createSendTransport", 1);
xt([
  _.trace("SFUHandler.restartIce")
], Pt.prototype, "restartIce", 1);
xt([
  _.trace("SFUHandler.createConsumer")
], Pt.prototype, "createConsumer", 1);
xt([
  _.trace("SFUHandler.closeConsumer")
], Pt.prototype, "closeConsumer", 1);
xt([
  _.trace("SFUHandler.cleanupConsumers")
], Pt.prototype, "cleanupConsumers", 1);
xt([
  _.trace("SFUHandler.pauseConsumer")
], Pt.prototype, "pauseConsumer", 1);
xt([
  _.trace("SFUHandler.resumeConsumer")
], Pt.prototype, "resumeConsumer", 1);
xt([
  _.trace("SFUHandler.createProducer")
], Pt.prototype, "createProducer", 1);
xt([
  _.trace("SFUHandler.removeProducer")
], Pt.prototype, "removeProducer", 1);
xt([
  _.trace("SFUHandler.stopAllProducers")
], Pt.prototype, "stopAllProducers", 1);
xt([
  _.trace("SFUHandler.stopAllTransports")
], Pt.prototype, "stopAllTransports", 1);
class Ue extends bt.EventEmitter {
  emit(e, ...t) {
    return super.emit("*", e, ...t), super.emit(e, ...t);
  }
  on(e, t) {
    return super.on(e, t);
  }
  addListener(e, t) {
    return super.addListener(e, t);
  }
  off(e, t) {
    return super.off(e, t);
  }
  once(e, t) {
    return super.once(e, t);
  }
  prependListener(e, t) {
    return super.prependListener(e, t);
  }
  prependOnceListener(e, t) {
    return super.prependOnceListener(e, t);
  }
  removeListener(e, t) {
    return super.removeListener(e, t);
  }
  removeAllListeners(e) {
    return super.removeAllListeners(e);
  }
  listeners(e) {
    return super.listeners(e);
  }
  listenerCount(e) {
    return super.listenerCount(e);
  }
}
var sb = Object.defineProperty, rb = Object.getOwnPropertyDescriptor, ib = (r, e, t, s) => {
  for (var i = s > 1 ? void 0 : s ? rb(e, t) : e, n = r.length - 1, a; n >= 0; n--)
    (a = r[n]) && (i = (s ? a(e, t, i) : a(i)) || i);
  return s && i && sb(e, t, i), i;
}, Ls = /* @__PURE__ */ ((r) => (r.REQUEST = "REQUEST", r.ACCEPT = "ACCEPT", r.REJECT = "REJECT", r.END = "END", r.EVENT = "EVENT", r))(Ls || {}), gi = /* @__PURE__ */ ((r) => (r.PENDING = "PENDING", r.ACCEPTED = "ACCEPTED", r.REJECTED = "REJECTED", r.ENDED = "ENDED", r))(gi || {}), Sn = /* @__PURE__ */ ((r) => (r.KEYBOARD = "KEYBOARD", r.MOUSE = "MOUSE", r))(Sn || {}), Ta = /* @__PURE__ */ ((r) => (r.LEFT_CLICK = "click", r.RIGHT_CLICK = "contextmenu", r.MOVE = "mousemove", r))(Ta || {}), xs = /* @__PURE__ */ ((r) => (r.REQUEST_RECEIVED = "REQUEST_RECEIVED", r.REQUEST_SENT = "REQUEST_SENT", r.INCOMING_REQUEST_ACCEPTED = "INCOMING_REQUEST_ACCEPTED", r.OUTGOING_REQUEST_ACCEPTED = "OUTGOING_REQUEST_ACCEPTED", r.INCOMING_REQUEST_ENDED = "INCOMING_REQUEST_ENDED", r.OUTGOING_REQUEST_ENDED = "OUTGOING_REQUEST_ENDED", r))(xs || {});
let wn = class extends Ue {
  constructor(e) {
    super();
    // NOTE(roerohan): This class extends DyteEventEmitter because DyteRemoteMap is being
    // used to store these objects, which extends DyteMap. The DyteMap class requires all
    // objects in the map to be event emitters as well.
    h(this, "id");
    h(this, "remotePeerId");
    h(this, "hostPeerId");
    h(this, "state");
    const {
      remotePeerId: t,
      requestId: s,
      hostPeerId: i,
      state: n
    } = e;
    this.id = s, this.remotePeerId = t, this.hostPeerId = i, this.state = n;
  }
};
wn = ib([
  ft((r) => {
    throw new E(r.message, "1400");
  })
], wn);
var nb = Object.defineProperty, ab = Object.getOwnPropertyDescriptor, Ut = (r, e, t, s) => {
  for (var i = s > 1 ? void 0 : s ? ab(e, t) : e, n = r.length - 1, a; n >= 0; n--)
    (a = r[n]) && (i = (s ? a(e, t, i) : a(i)) || i);
  return s && i && nb(e, t, i), i;
}, se, Zs, xl;
const nc = (xl = class extends gp {
  constructor(e) {
    super();
    b(this, se, void 0);
    h(this, "isV2AuthToken");
    b(this, Zs, void 0);
    h(this, "legacyMode");
    h(this, "roomNodeUrl");
    h(this, "peerDisplayName");
    const {
      roomName: t,
      roomNodeUrl: s,
      peerId: i,
      authToken: n,
      legacyMode: a,
      socketClient: o,
      meetingTitle: d
    } = e;
    this.roomName = t, this.roomNodeUrl = s, this.peerId = i, this.authToken = n, this.legacyMode = a, P(this, se, o), this.roomJoined = !1, this.meetingTitle = d, this.isV2AuthToken = te.isV2AuthToken, P(this, Zs, new Pt(o, e.device)), A.legacySwitch(a);
  }
  static async init(e) {
    const {
      legacyMode: t = !0,
      roomName: s,
      peerId: i,
      authToken: n,
      meetingTitle: a,
      device: o
    } = e;
    let d;
    const p = `${e.roomNodeUrl}?roomURL=${s}&peerId=${i}&authToken=${n}&version=0.5.0`, l = new ta({
      callbackHandler: async (u) => {
        await d.handleSocketCallbacks(u);
      }
    });
    return l.on(Ns.SOCKET_MESSAGE, async (u, m) => {
      await d.handleSockets(u, m);
    }), l.connect(p), d = new nc({
      legacyMode: t,
      authToken: n,
      peerId: i,
      roomName: s,
      roomNodeUrl: p,
      socketClient: l,
      meetingTitle: a,
      device: o
    }), l.on(Ns.SOCKET_DISCONNECTED, (u) => {
      var m, g;
      d.isDisconnected = !0, (m = d.sfuHandler) == null || m.cleanupConsumers(), (g = d.sfuHandler) == null || g.stopAllTransports(), y.emit(v.ROOM_NODE_DISCONNECTED, u), d.roomJoined = !1, f.info("ROOM_NODE_DISCONNECTED");
    }), l.on(Ns.SOCKET_CONNECTED, async (u) => {
      y.emit(v.ROOM_NODE_CONNECTED, u), d.isDisconnected, d.isDisconnected = !1, f.info("ROOM_NODE_CONNECTED");
    }), l.on(Ns.SOCKET_CONNECTION_ERROR, async ({ err: u }) => {
      var m;
      d.isDisconnected = !0, (m = d.sfuHandler) == null || m.cleanupConsumers(), y.emit(v.ROOM_NODE_CONNECTION_ERROR, u), d.roomJoined = !1;
    }), d;
  }
  get sfuHandler() {
    return c(this, Zs);
  }
  reconnect() {
    c(this, se).reconnect();
  }
  async setupTransports() {
    await this.sfuHandler.setupTransports();
  }
  async handleSocketCallbacks(e) {
    switch (e.type) {
      case v.NEW_CONSUMER:
        return this.sfuHandler.createConsumer(e.payload);
      default:
        return null;
    }
  }
  async handleSockets(e, t) {
    if (e) {
      switch ((!_.logExclusionList.includes(e == null ? void 0 : e.type) || M.hasFeature(N.BYPASS_LOG_EXCLUSION_LIST)) && f.info(`RoomNodeClient::handleSockets::${e == null ? void 0 : e.type}`), e.type) {
        case v.CONSUMER_CLOSED:
          this.sfuHandler.closeConsumer(e.payload);
          break;
        case v.CONSUMER_PAUSED:
          this.sfuHandler.pauseConsumer(e.payload);
          break;
        case v.CONSUMER_RESUMED:
          this.sfuHandler.resumeConsumer(e.payload);
          break;
        case v.CONSUMER_SCORE:
          this.handleConsumerScore(e.payload);
          break;
        case v.PRODUCER_SCORE:
          this.handleProducerScore(e.payload);
          break;
        case v.PRODUCER_CLOSED:
          this.handleProducerClosed(e.payload);
          break;
      }
      typeof t == "function" && t();
    }
  }
  async joinRoom(e, t, s, i, n = {}) {
    var d, p, l;
    this.peerDisplayName = e, this.roomUUID = s;
    const a = await c(this, se).sendMessage({
      type: "joinRoom",
      payload: {
        device: ae.getDeviceInfo(),
        displayName: e,
        rtpCapabilities: this.sfuHandler.getRTPCapabilities(),
        isLegacy: this.legacyMode,
        audioMuted: t
      }
    });
    if ((d = a.payload) != null && d.waitlisted)
      return y.emit(v.WAITLISTED), { roomJoined: !1 };
    (l = (p = a.payload) == null ? void 0 : p.waitlistedPeers) == null || l.forEach((u) => {
      y.emit(v.WAITLIST_PEER_ADDED, u);
    }), this.legacyMode = a.payload.legacyMode || this.legacyMode, i && i !== "" && await this.changeRoomDisplayTitle(i), this.maxPreferredStreams = a.payload.maxPreferredStreams, this.roomJoined = !0;
    const o = ct();
    f.info("RoomNodeClient::joinRoom::pre emitasync room_joined");
    try {
      await y.emitAsync(v.ROOM_JOINED, a.payload);
    } catch (u) {
      f.error("RoomNodeClient::joinRoom::emitAsync", { error: u });
    }
    return f.info("RoomNodeClient::joinRoom::post emitasync room_joined"), y.emit(v.SELF_ROOM_JOINED), M.hasFeature(N.INTERNAL_CALL_STATS) && navigator.product !== "ReactNative" && setTimeout(async () => {
      const u = await o.getUserDetails(), m = {
        userId: te.isV2AuthToken ? u.participant.id : u.id,
        peerId: this.peerId,
        displayName: e,
        roomUUID: this.roomUUID,
        roomViewType: "groupCall",
        roomName: this.roomName,
        deviceInfo: {
          ...ae.getDeviceInfo(),
          userAgent: navigator.userAgent,
          memory: navigator.deviceMemory,
          cpus: navigator.hardwareConcurrency
        },
        metaData: {},
        permissions: {}
      };
      A.roomJoined(m), n != null && n.audio ? A.audioOn() : A.audioOff(), n != null && n.video ? A.videoOn() : A.videoOff();
    }), { roomJoined: !0 };
  }
  async leaveRoom() {
    this.sfuHandler.stopAllProducers(), await this.sfuHandler.stopAllTransports(), c(this, se).disconnect(), A.callEnded(), _.destruct();
  }
  handleProducerClosed({ id: e }) {
    this.sfuHandler.producers.forEach((t, s) => {
      t.id === e && this.sfuHandler.removeProducer(s);
    });
  }
  getConsumers() {
    return this.sfuHandler.consumers;
  }
  static getComputedScore(e) {
    var s, i;
    let t = 0;
    try {
      Array.isArray(e) ? e.length === 1 ? t = e[0].score : t = e.map(
        ({ score: a }) => a != null ? a : 10
      ).filter((a) => a > 0).reduce(
        (a, o) => a + o,
        0
      ) / e.length : t = (s = e == null ? void 0 : e.score) != null ? s : 10;
    } catch (n) {
      t = (i = e == null ? void 0 : e.score) != null ? i : 10;
    }
    return t;
  }
  handleConsumerScore({ id: e, score: t }) {
    var i;
    const s = c(this, Zs).consumers.get(e);
    s && (s.score = t && t.producerScore !== void 0 && t.producerScore >= 0 ? t.producerScore : (i = t == null ? void 0 : t.score) != null ? i : 10, y.emit(v.CONSUMER_SCORE_UPDATE, {
      id: s.id,
      kind: s.kind,
      peerId: s.peerId,
      score: s.score
    }));
  }
  handleProducerScore({ id: e, score: t }) {
    const s = [...c(this, Zs).producers.values()].find((n) => n.id === e);
    if (!s) {
      f.error(`RoomNodeClient::producer_not_found. ProducerId: ${e}`);
      return;
    }
    if (!s)
      return;
    const i = nc.getComputedScore(t);
    i !== void 0 && i !== s.score && (s.score = i, y.emit(v.PRODUCER_SCORE_UPDATE, {
      id: s.id,
      kind: s.kind,
      appData: s.appData,
      score: s.score
    }));
  }
  async shareWebcam(e) {
    if (e === void 0)
      return;
    if (this.sfuHandler.producers.has(x.WEBCAM)) {
      const p = this.sfuHandler.producers.get(x.WEBCAM);
      if (!p.closed) {
        await p.replaceTrack({ track: e }), await this.resumeWebcam();
        return;
      }
      await this.sfuHandler.removeProducer(x.WEBCAM, !1);
    }
    let t = qv;
    const s = this.sfuHandler.getRTPCapabilities().codecs.find((p) => p.mimeType.toLowerCase() === "video/vp9") || void 0, i = this.sfuHandler.getRTPCapabilities().codecs.find((p) => p.mimeType.toLowerCase() === "video/vp8") || void 0, n = M.getValue(N.OVERRIDE_WEBCAM_SIMULCAST);
    if (s && !this.legacyMode)
      t = Jv;
    else if (n !== void 0)
      try {
        t = JSON.parse(n);
      } catch (p) {
        f.error("Failed to parse flagsmith simulcast");
      }
    const a = () => this.legacyMode ? i : s, o = {
      track: e,
      encodings: M.hasFeature(N.DISABLE_WEBCAM_SIMULCAST) ? void 0 : t,
      codecOptions: {
        videoGoogleStartBitrate: 1e3
      },
      codec: a(),
      appData: {
        screenShare: !1
      },
      stopTracks: !1
    }, d = () => {
      this.disableWebcam();
    };
    await this.sfuHandler.createProducer(x.WEBCAM, o, d);
  }
  async shareScreen(e) {
    var d, p;
    const { video: t, audio: s } = e;
    if (t === void 0)
      return;
    let i;
    M.hasFeature(N.SCREENSHARE_SIMULCAST) && (i = Gv);
    const n = {
      track: t,
      appData: {
        screenShare: !0,
        supportsRemoteControl: ae.isElectron()
      },
      encodings: i,
      stopTracks: !1
    };
    let a = () => {
      this.disableScreenShare();
    };
    A.screenShareRequested(), await this.sfuHandler.createProducer(x.SCREENSHARE_VIDEO, n, a);
    const o = {
      opusDtx: !1,
      opusStereo: !1,
      opusFec: !0,
      forceGoogConference: !1
    };
    if (M.hasFeature(N.SCREENSHARE_FORCE_GOOG_CONFERENCE) && (o.forceGoogConference = !0), s) {
      const l = {
        track: s,
        codecOptions: o,
        appData: {
          screenShare: !0,
          supportsRemoteControl: ae.isElectron()
        },
        stopTracks: !1
      };
      a = () => {
      }, await this.sfuHandler.createProducer(
        x.SCREENSHARE_AUDIO,
        l,
        a
      );
    }
    A.screenShareStart(
      (p = (d = this.sfuHandler.producers.get(x.SCREENSHARE_VIDEO)) == null ? void 0 : d.rtpParameters.encodings[0]) == null ? void 0 : p.ssrc
    );
  }
  async shareMic(e) {
    if (e === void 0)
      return;
    if (this.sfuHandler.producers.has(x.MIC)) {
      const i = this.sfuHandler.producers.get(x.MIC);
      if (!i.closed) {
        await i.replaceTrack({ track: e }), await this.resumeMic();
        return;
      }
      await this.sfuHandler.removeProducer(x.MIC, !1);
    }
    const t = {
      track: e,
      codecOptions: {
        opusDtx: !1,
        opusStereo: !1,
        opusFec: !0,
        opusMaxAverageBitrate: 16e3
      },
      stopTracks: !1
    }, s = () => {
      this.disableMic();
    };
    await this.sfuHandler.createProducer(x.MIC, t, s);
  }
  pauseMic() {
    const e = this.sfuHandler.producers.get(x.MIC);
    if (!e) {
      f.error("pauseMic::could_not_find_mic_producer");
      return;
    }
    e.pause(), c(this, se).sendMessage({
      type: "pauseProducer",
      payload: { producerId: e.id }
    });
  }
  async pauseWebcam() {
    const e = this.sfuHandler.producers.get(x.WEBCAM);
    if (!e) {
      f.error("pauseWebcam::could_not_find_webcam_producer");
      return;
    }
    e.pause(), await c(this, se).sendMessage({
      type: "pauseProducer",
      payload: { producerId: e.id }
    });
  }
  async resumeMic() {
    const e = this.sfuHandler.producers.get(x.MIC);
    if (!e) {
      f.error("resumeMic::could_not_find_mic_producer");
      return;
    }
    e.resume(), await c(this, se).sendMessage({
      type: "resumeProducer",
      payload: { producerId: e.id }
    });
  }
  async resumeWebcam() {
    const e = this.sfuHandler.producers.get(x.WEBCAM);
    if (!e) {
      f.error("resumeWebcam::could_not_find_webcam_producer");
      return;
    }
    e.resume(), await c(this, se).sendMessage({
      type: "resumeProducer",
      payload: { producerId: e.id }
    });
  }
  async disableWebcam() {
    await this.sfuHandler.removeProducer(x.WEBCAM);
  }
  async disableMic() {
    await this.sfuHandler.removeProducer(x.MIC);
  }
  async disableScreenShare() {
    var e, t;
    f.info("screen_sharing_stopped"), A.screenShareStop(
      (t = (e = this.sfuHandler.producers.get(x.SCREENSHARE_VIDEO)) == null ? void 0 : e.rtpParameters.encodings[0]) == null ? void 0 : t.ssrc
    ), await this.sfuHandler.removeProducer(x.SCREENSHARE_VIDEO), await this.sfuHandler.removeProducer(x.SCREENSHARE_AUDIO);
  }
  async resetVideoProducers(e, t) {
    e && (await this.sfuHandler.removeProducer(x.WEBCAM, !1), this.shareWebcam(e)), t && (await this.sfuHandler.removeProducer(x.SCREENSHARE_VIDEO, !1), this.shareScreen({ video: t }));
  }
  async getRoomState() {
    return c(this, se).sendMessage({ type: "getRoomState" });
  }
  async changeRoomDisplayTitle(e) {
    await c(this, se).sendMessage({
      type: "changeDisplayTitle",
      payload: {
        displayTitle: e
      }
    });
  }
  async sendMessage(e) {
    return c(this, se).sendMessage(e);
  }
  async broadcastMessage(e, t) {
    const s = {
      payload: t,
      type: e
    };
    return c(this, se).sendMessage({ type: "roomMessage", payload: s });
  }
  async sendChatMessage(e) {
    await c(this, se).sendMessage({ type: "chatMessage", payload: e });
  }
  async getChatMessages() {
    return c(this, se).sendMessage({ type: "getChatMessages" });
  }
  async pinChatMessage(e) {
    return c(this, se).sendMessage({ type: "pinChatMessage", payload: e });
  }
  async unpinChatMessage(e) {
    return c(this, se).sendMessage({ type: "unpinChatMessage", payload: e });
  }
  async getPolls() {
    return c(this, se).sendMessage({ type: "getPolls" });
  }
  async newPoll(e) {
    await c(this, se).sendMessage({ type: "newPoll", payload: e });
  }
  async votePoll(e) {
    await c(this, se).sendMessage({ type: "votePoll", payload: e });
  }
  async acceptWaitingRequest(e) {
    await c(this, se).sendMessage({ type: "acceptWaitingRequest", payload: { id: e } });
  }
  async rejectWaitingRequest(e) {
    await c(this, se).sendMessage({ type: "rejectWaitingRequest", payload: { id: e } });
  }
  async muteAll(e) {
    await c(this, se).sendMessage({ type: "muteAllNew", payload: { allowUnMute: e } });
  }
  async muteAllVideo() {
    await c(this, se).sendMessage({ type: "muteAllVideo" });
  }
  async pinPeer(e) {
    return c(this, se).sendMessage({ type: "pinPeer", payload: { id: e } });
  }
  async unpinPeer(e) {
    return c(this, se).sendMessage({ type: "unpinPeer", payload: { id: e } });
  }
  async disableAudio(e) {
    await c(this, se).sendMessage({ type: "disableAudioPeerNew", payload: { id: e } });
  }
  async disableVideo(e) {
    await c(this, se).sendMessage({ type: "disableVideoPeer", payload: { id: e } });
  }
  async kickAll() {
    await c(this, se).sendMessage({ type: "kickAll" });
  }
  async kick(e) {
    await c(this, se).sendMessage({ type: "kick", payload: { id: e } });
  }
  async getPage(e) {
    return c(this, se).sendMessage({ type: "getPage", payload: { pageNum: e } });
  }
  async muteSelf() {
    this.pauseMic(), await c(this, se).sendMessage({ type: "muteSelf" });
  }
  async unmuteSelf() {
    await this.resumeMic(), await c(this, se).sendMessage({ type: "unmuteSelf" });
  }
  async addRoomPlugin(e) {
    return c(this, se).sendMessage({
      type: "addPlugin",
      payload: e
    });
  }
  async removeRoomPlugin(e) {
    return c(this, se).sendMessage({
      type: "removePlugin",
      payload: e
    });
  }
  async remoteControlMessage(e) {
    return c(this, se).sendMessage({
      type: "message",
      payload: e
    });
  }
  async requestRemoteControl(e) {
    return this.remoteControlMessage({
      peerId: e.hostPeerId,
      remoteRequestId: e.id,
      hostPeerId: e.hostPeerId,
      remotePeerId: e.remotePeerId,
      remoteRequestType: Ls.REQUEST
    });
  }
  async acceptRemoteControl(e) {
    return this.remoteControlMessage({
      peerId: e.remotePeerId,
      remoteRequestId: e.id,
      hostPeerId: e.hostPeerId,
      remotePeerId: e.remotePeerId,
      remoteRequestType: Ls.ACCEPT
    });
  }
  async terminateRemoteControl(e, t) {
    return this.remoteControlMessage({
      peerId: e,
      remoteRequestId: t.id,
      hostPeerId: t.hostPeerId,
      remotePeerId: t.remotePeerId,
      remoteRequestType: Ls.END
    });
  }
  async sendEventRemoteControl(e, t, s) {
    return this.remoteControlMessage({
      peerId: e,
      remoteRequestId: t,
      remoteEvent: s,
      hostPeerId: this.peerId,
      remotePeerId: e,
      remoteRequestType: Ls.EVENT
    });
  }
  async assertSpotlight(e, t) {
    return c(this, se).sendMessage({
      type: e,
      payload: { ...t, roomMessageType: "spotlight" }
    });
  }
  async assertSpotlightToRoom(e) {
    return this.assertSpotlight(
      "roomMessage",
      e
    );
  }
  async assertSpotlightToPeer(e) {
    return this.assertSpotlight(
      "message",
      e
    );
  }
  async requestToJoinStage(e) {
    await this.sendMessage(
      { type: "requestToJoinStage", payload: e }
    );
  }
  async withdrawRequestToJoinStage() {
    await this.sendMessage(
      { type: "withdrawRequestToJoinStage" }
    );
  }
  async acceptAllRequestToJoinStage(e) {
    await this.sendMessage(
      {
        type: "acceptAllRequestToJoinStage",
        payload: e.map((t) => ({
          ...t,
          type: jc.REQUESTED_BY_MODERATOR
        }))
      }
    );
  }
  async removePeerFromStage(e, t) {
    await this.sendMessage(
      { type: "removePeerFromStage", payload: { id: e, type: t } }
    );
  }
  // NOTE(@madhugb): stop all producers
  stopAllProducers() {
    c(this, Zs).stopAllProducers();
  }
  // NOTE(callmetarush): starting to present by default for now.
  async startPresenting() {
    await this.sendMessage(
      { type: "startPresenting" }
    );
  }
  // NOTE(callmetarush): Unused till above default is on
  async stopPresenting() {
    this.stopAllProducers(), await this.sendMessage(
      { type: "stopPresenting" }
    );
  }
  async rejectRequestToJoinStage(e) {
    await this.sendMessage(
      { type: "rejectRequestToJoinStage", payload: { id: e } }
    );
  }
}, se = new WeakMap(), Zs = new WeakMap(), xl);
let fe = nc;
Ut([
  _.trace("RoomNodeClient.reconnect")
], fe.prototype, "reconnect", 1);
Ut([
  _.trace("RoomNodeClient.joinRoom")
], fe.prototype, "joinRoom", 1);
Ut([
  _.trace("RoomNodeClient.leaveRoom")
], fe.prototype, "leaveRoom", 1);
Ut([
  _.trace("RoomNodeClient.shareWebcam")
], fe.prototype, "shareWebcam", 1);
Ut([
  _.trace("RoomNodeClient.shareScreen")
], fe.prototype, "shareScreen", 1);
Ut([
  _.trace("RoomNodeClient.shareMic")
], fe.prototype, "shareMic", 1);
Ut([
  _.trace("RoomNodeClient.pauseMic")
], fe.prototype, "pauseMic", 1);
Ut([
  _.trace("RoomNodeClient.pauseWebcam")
], fe.prototype, "pauseWebcam", 1);
Ut([
  _.trace("RoomNodeClient.resumeMic")
], fe.prototype, "resumeMic", 1);
Ut([
  _.trace("RoomNodeClient.resumeWebcam")
], fe.prototype, "resumeWebcam", 1);
Ut([
  _.trace("RoomNodeClient.disableWebcam")
], fe.prototype, "disableWebcam", 1);
Ut([
  _.trace("RoomNodeClient.disableMic")
], fe.prototype, "disableMic", 1);
Ut([
  _.trace("RoomNodeClient.disableScreenShare")
], fe.prototype, "disableScreenShare", 1);
Ut([
  _.trace("RoomNodeClient.resetVideoProducers")
], fe.prototype, "resetVideoProducers", 1);
let fs;
async function ob(r) {
  if (fs)
    throw new Error("Room Node Client already setup");
  fs = await z.init(r);
}
async function vp(r) {
  if (fs != null && fs.roomJoined)
    throw new Error("Room Node Client already setup");
  fs && (fs = void 0), fs = await fe.init(r);
}
async function cb() {
  fs = void 0;
}
function Be() {
  return fs;
}
function kr(r) {
  var e, t, s, i, n, a, o, d, p, l, u, m, g;
  return r ? {
    media: {
      audio: {
        enabled: r.audioEnabled,
        trackId: (e = r.audioTrack) == null ? void 0 : e.id,
        permission: "mediaPermissions" in r ? (t = r.mediaPermissions) == null ? void 0 : t.audio : null
      },
      video: {
        enabled: r.videoEnabled,
        trackId: (s = r.videoTrack) == null ? void 0 : s.id,
        permission: "mediaPermissions" in r ? (i = r.mediaPermissions) == null ? void 0 : i.video : null
      },
      screenshare: {
        enabled: r.screenShareEnabled,
        permission: "mediaPermissions" in r ? (n = r.mediaPermissions) == null ? void 0 : n.screenshare : null,
        audio: {
          enabled: (o = (a = r.screenShareTracks) == null ? void 0 : a.audio) == null ? void 0 : o.enabled,
          trackId: (p = (d = r.screenShareTracks) == null ? void 0 : d.audio) == null ? void 0 : p.id
        },
        video: {
          enabled: (u = (l = r.screenShareTracks) == null ? void 0 : l.video) == null ? void 0 : u.enabled,
          trackId: (g = (m = r.screenShareTracks) == null ? void 0 : m.video) == null ? void 0 : g.id
        }
      }
    }
  } : {};
}
const db = async (r, e) => {
  if (!(r != null && r.length))
    return e;
  const t = new AudioContext(), s = await Promise.all(
    r == null ? void 0 : r.map((a) => a(t))
  ), i = t.createMediaStreamSource(new MediaStream([e])), n = t.createMediaStreamDestination();
  try {
    let a = i;
    for (let o = 0; o < s.length; o += 1)
      a.connect(s[o]), a = s[o];
    a.connect(n);
  } catch (a) {
    return f.error("getTransformedAudioTrack::middleware_execution_failed", { error: a }), e;
  }
  return n.stream.getAudioTracks()[0];
};
var lb = Object.defineProperty, ub = Object.getOwnPropertyDescriptor, pb = (r, e, t, s) => {
  for (var i = s > 1 ? void 0 : s ? ub(e, t) : e, n = r.length - 1, a; n >= 0; n--)
    (a = r[n]) && (i = (s ? a(e, t, i) : a(i)) || i);
  return s && i && lb(e, t, i), i;
};
let ac = class extends Ue {
  /**
   * Allows creation of an instance of BaseMediaHandler with a track.
   * We initialize it with a track when we want to enable streams on init.
   * @param mediaInterface
   * @param mediaTrack
   */
  constructor(e, t) {
    super();
    h(this, "constructorName", this.constructor.name);
    // Will be set in case user has explicity used Self.setDevice
    // to set the device.
    h(this, "userSelectedDevice");
    h(this, "mediaInterface");
    h(this, "_mediaTrack");
    h(this, "transformedMediaTrack");
    h(this, "middlewares", []);
    h(this, "currentDevice");
    this.mediaInterface = e, t && this.setMediaTrack(t), this.userSelectedDevice = void 0, this.onTrackEnded = this.onTrackEnded.bind(this), this.onTrackMuted = this.onTrackMuted.bind(this);
  }
  /**
   * NOTE(roerohan): DO NOT use this.#mediaTrack anywhere else,
   * except for these 3 functions below.
   */
  /**
   * Cleans up all acquired tracks.
   */
  disableTrack() {
    var e, t;
    this.removeMediaTrackListeners(), (e = this._mediaTrack) == null || e.stop(), this._mediaTrack = void 0, (t = this.transformedMediaTrack) == null || t.stop(), this.transformedMediaTrack = void 0;
  }
  get mediaTrack() {
    return this._mediaTrack;
  }
  async setMediaTrack(e) {
    const t = (s) => {
      f.error(`${this.constructorName}.setMediaTrack.error`, {
        error: s
      });
    };
    try {
      this.disableTrack();
    } catch (s) {
      t(s);
    }
    this._mediaTrack = e, await this.setTransformedTrack();
    try {
      this.addMediaTrackListeners(), await this.setCurrentDevice();
    } catch (s) {
      t(s);
    }
  }
  /**
   * Represents current audio/video state according to track status
   */
  get trackEnabled() {
    return !!this.mediaTrack && this.mediaTrack.readyState === "live" && this.mediaTrack.enabled;
  }
  /**
   * Mutes track if it's present, DOES NOT STOP IT!
   * Only used for audio streams
   */
  muteTrack() {
    if (!this.mediaTrack) {
      f.warn("BaseMediaHandler.muteTrack Tried muting with no track present");
      return;
    }
    this.transformedMediaTrack && (this.transformedMediaTrack.enabled = !1), this.mediaTrack.enabled = !1;
  }
  /**
   * If track is present and not enabled, we enable it.
   * If no track is present we set one up.
   */
  async unmuteTrack() {
    try {
      this.mediaTrack ? this.mediaTrack.enabled = !0 : await this.enableTrack(!1);
    } catch (e) {
      throw f.error(`${this.constructorName}.unmuteTrack.error`, {
        error: e
      }), this.disableTrack(), new E("Failed to unmute track");
    }
  }
  /**
   * Called after every track switch, maintains local state of current
   * selected device for this particular stream.
   */
  async setCurrentDevice() {
    var e;
    if (!this.mediaTrack) {
      this.currentDevice = void 0;
      return;
    }
    ((e = this.currentDevice) == null ? void 0 : e.deviceId) !== this.mediaTrack.getSettings().deviceId && (this.currentDevice = await this.mediaInterface.getDevice(
      this.mediaTrack.getSettings().deviceId
    ));
  }
  /**
   * Middleware Utility
   */
  async addMiddleware(e) {
    if (ae.isSafari())
      return { success: !1, message: "Middlewares are not yet supported in Safari." };
    if (this.middlewares.includes(e))
      return { success: !1, message: "This middleware has been applied, already. Skipping." };
    try {
      return this.trackEnabled && await this.setTransformedTrack(), this.middlewares.push(e), { success: !0, message: "Successfully added the middleware." };
    } catch (t) {
      return f.error("While adding middleware", { error: t }), { success: !1, message: t == null ? void 0 : t.message };
    }
  }
  async removeMiddleware(e) {
    const t = this.middlewares.indexOf(e, 0);
    if (t > -1)
      try {
        return await this.setTransformedTrack(), this.middlewares.splice(t, 1), { success: !0, message: "Successfully removed the middleware." };
      } catch (s) {
        return f.error("While removing middleware", { error: s }), { success: !1, message: s == null ? void 0 : s.message };
      }
    return { success: !1, message: "No such middleware was found. Skipping." };
  }
  addMediaTrackListeners() {
    var e, t, s;
    this.mediaTrack && (f.info(`${this.constructorName}.addMediaTrackListeners for deviceId ${(t = (e = this.mediaTrack) == null ? void 0 : e.getSettings()) == null ? void 0 : t.deviceId} of type ${(s = this.mediaTrack) == null ? void 0 : s.kind}`), this.mediaTrack.addEventListener("ended", this.onTrackEnded), this.mediaTrack.addEventListener("mute", this.onTrackMuted));
  }
  removeMediaTrackListeners() {
    var e, t, s;
    this.mediaTrack && (f.info(`${this.constructorName}.removeMediaTrackListeners for deviceId ${(t = (e = this.mediaTrack) == null ? void 0 : e.getSettings()) == null ? void 0 : t.deviceId} of type ${(s = this.mediaTrack) == null ? void 0 : s.kind}`), f.info(`${this.constructorName}.removeMediaTrackListeners`), this.mediaTrack.removeEventListener("ended", this.onTrackEnded), this.mediaTrack.removeEventListener("mute", this.onTrackMuted));
  }
};
ac = pb([
  ft((r) => {
    throw new E(r.message, "1600");
  })
], ac);
const Tp = ac;
var hb = Object.defineProperty, mb = Object.getOwnPropertyDescriptor, yp = (r, e, t, s) => {
  for (var i = s > 1 ? void 0 : s ? mb(e, t) : e, n = r.length - 1, a; n >= 0; n--)
    (a = r[n]) && (i = (s ? a(e, t, i) : a(i)) || i);
  return s && i && hb(e, t, i), i;
};
class Kc extends Tp {
  async setDevice(e) {
    if (!e)
      throw f.warn("AudioMediaHandler.setDevice No device received"), new E("No device received!", "1603");
    if (e.kind !== "audioinput")
      throw f.warn("AudioMediaHandler.setDevice Received non audio device"), new E("Non audio device received while setting device!", "1603");
    try {
      const t = this.trackEnabled;
      this.userSelectedDevice = e.deviceId, await this.setMediaTrack(await this.mediaInterface.getAudioTrack(!t, e.deviceId));
    } catch (t) {
      throw f.error("AudioMediaHandler.setDevice.error", {
        error: t
      }), this.disableTrack(), new E(t.message, "1604");
    }
  }
  async enableTrack(e) {
    if (this.trackEnabled) {
      f.warn("AudioMediaHandler.enableTrack Track already enabled!");
      return;
    }
    const t = await this.mediaInterface.getAudioTrack(
      e,
      this.userSelectedDevice
    );
    await this.setMediaTrack(t);
  }
  async setTransformedTrack() {
    var e;
    if (!((e = this.middlewares) != null && e.length)) {
      this.transformedMediaTrack = this.mediaTrack;
      return;
    }
    try {
      this.transformedMediaTrack = await db(
        this.middlewares,
        this.mediaTrack
      ), this.emit("trackChanged");
    } catch (t) {
      f.error("AudioMediaHandler.setTransformedTrack", {
        error: t
      }), this.transformedMediaTrack = this.mediaTrack;
    }
  }
  async onTrackEnded() {
    f.info("AudioMediaHandler.TrackEnded"), this.emit("trackEnded");
    const e = this.mediaTrack.enabled;
    this.disableTrack(), await this.enableTrack(!e), await this.setTransformedTrack(), this.emit("trackChanged");
  }
  onTrackMuted() {
    f.info("AudioMediaHandler.TrackMuted"), this.emit("trackMuted");
  }
}
yp([
  _.trace("AudioMediaHandler.setTransformedTrack")
], Kc.prototype, "setTransformedTrack", 1);
yp([
  _.trace("AudioMediaHandler.onTrackEnded")
], Kc.prototype, "onTrackEnded", 1);
class Wr extends Error {
  constructor(t, s, i) {
    super(s);
    h(this, "constraints");
    h(this, "name");
    this.name = t, this.constraints = i;
  }
}
function Ep(r, e) {
  if (ae.isChromiumBased()) {
    if (r === "NotAllowedError")
      return e.indexOf("by system") > 0 ? "SYSTEM_DENIED" : "DENIED";
    if (r === "NotReadableError")
      return "COULD_NOT_START";
  } else if (ae.isSafari()) {
    if (r === "NotAllowedError")
      return "DENIED";
  } else if (ae.isFirefox()) {
    if (r === "NotFoundError" || r === "NotReadableError")
      return "SYSTEM_DENIED";
    if (r === "NotAllowedError")
      return "DENIED";
    if (r === "AbortError")
      return "COULD_NOT_START";
  }
  return "COULD_NOT_START";
}
function $o(r) {
  return r === 2 .toString() ? ur.DENIED : r === 3 .toString() ? ur.SYS_DENIED : r === 1 .toString() ? ur.ACCEPTED : ur.FAILED;
}
class fb {
  constructor() {
    h(this, "permissions");
    this.permissions = {
      audio: "NOT_REQUESTED",
      video: "NOT_REQUESTED",
      screenshare: "NOT_REQUESTED"
    };
  }
  async getAudioInputDevices() {
    return (await this.getAvailableDevices()).filter((t) => t.kind === "audioinput");
  }
  async getVideoInputDevices() {
    return (await this.getAvailableDevices()).filter((t) => t.kind === "videoinput");
  }
  async getAudioOutputDevices() {
    return (await this.getAvailableDevices()).filter((t) => t.kind === "audiooutput");
  }
}
var gb = Object.defineProperty, _b = Object.getOwnPropertyDescriptor, vb = (r, e, t, s) => {
  for (var i = s > 1 ? void 0 : s ? _b(e, t) : e, n = r.length - 1, a; n >= 0; n--)
    (a = r[n]) && (i = (s ? a(e, t, i) : a(i)) || i);
  return s && i && gb(e, t, i), i;
}, ks, Ul;
let oc = (Ul = class extends fb {
  constructor(e) {
    super();
    b(this, ks, void 0);
    P(this, ks, new ap(e));
  }
  handlePermissionErrors(e, t) {
    const s = Ep(t.name, t.message);
    this.permissions[e] = s, y.emit(
      v.MEDIA_PERMISSION_ERROR,
      {
        message: s,
        constraints: t.constraints,
        kind: e
      }
    );
  }
  // eslint-disable-next-line class-methods-use-this
  async getAudioAndVideoTrack() {
    const e = {
      audio: c(this, ks).getAudioConstraints().audio,
      video: c(this, ks).getVideoConstraints().video
    };
    try {
      const t = await navigator.mediaDevices.getUserMedia(e), s = t.getAudioTracks()[0], i = t.getVideoTracks()[0];
      return this.permissions.audio = "ACCEPTED", this.permissions.video = "ACCEPTED", y.emit(
        v.MEDIA_PERMISSION_UPDATE,
        {
          message: this.permissions.audio,
          kind: "audio"
        }
      ), y.emit(
        v.MEDIA_PERMISSION_UPDATE,
        {
          message: this.permissions.video,
          kind: "video"
        }
      ), { audioTrack: s, videoTrack: i };
    } catch (t) {
      if (t.name === "NotAllowedError") {
        const s = await this.getAudioTrack(!1), i = await this.getVideoTrack();
        return { audioTrack: s, videoTrack: i };
      }
      throw f.error(
        "WebMediaInterface.getAudioAndVideoTrack",
        { error: t }
      ), new E("Couldnt fetch audio and video track");
    }
  }
  async getAudioTrack(e, t) {
    const s = c(this, ks).getAudioConstraints(t);
    try {
      const i = (await navigator.mediaDevices.getUserMedia(
        s
      )).getAudioTracks()[0];
      return i.enabled = !e, this.permissions.audio = "ACCEPTED", y.emit(
        v.MEDIA_PERMISSION_UPDATE,
        {
          message: this.permissions.audio,
          kind: "audio"
        }
      ), i;
    } catch (i) {
      throw this.handlePermissionErrors("audio", new Wr(i.name, i.message, s)), new E(i.message, "1601");
    }
  }
  async getScreenShareTracks() {
    const e = c(this, ks).getScreenShareConstraints();
    try {
      const t = await navigator.mediaDevices.getDisplayMedia(
        e
      );
      return this.permissions.screenshare = "ACCEPTED", y.emit(
        v.MEDIA_PERMISSION_UPDATE,
        {
          message: this.permissions.screenshare,
          kind: "screenshare"
        }
      ), {
        audioTrack: t.getAudioTracks()[0],
        videoTrack: t.getVideoTracks()[0]
      };
    } catch (t) {
      throw this.handlePermissionErrors("screenshare", new Wr(t.name, t.message, e)), f.error(
        "WebMediaInterface.getScreenShareTracks Error while fetching screenshare tracks",
        { error: t }
      ), new E("Couldnt fetch screen share tracks");
    }
  }
  async getVideoTrack(e) {
    const t = c(this, ks).getVideoConstraints(e);
    try {
      const s = (await navigator.mediaDevices.getUserMedia(
        t
      )).getVideoTracks()[0];
      return this.permissions.video = "ACCEPTED", y.emit(
        v.MEDIA_PERMISSION_UPDATE,
        {
          message: this.permissions.video,
          kind: "audio"
        }
      ), s;
    } catch (s) {
      throw this.handlePermissionErrors("video", new Wr(s.name, s.message, t)), f.error(
        "WebMediaInterface.getVideoTrack Error while fetching video track",
        { error: s }
      ), new E("Couldnt fetch video track");
    }
  }
  // eslint-disable-next-line class-methods-use-this
  async getAvailableDevices() {
    try {
      return navigator.mediaDevices.enumerateDevices();
    } catch (e) {
      throw f.error("enumerate_devices_failed", {
        error: e
      }), new E("Failed to get available devices");
    }
  }
  // eslint-disable-next-line class-methods-use-this
  async getAvailableDevicesByKind(e) {
    try {
      return (await navigator.mediaDevices.enumerateDevices()).filter(({ kind: t }) => e === t);
    } catch (t) {
      throw f.error("enumerate_devices_failed", {
        error: t
      }), new E("Failed to get available devices by kind");
    }
  }
  // eslint-disable-next-line class-methods-use-this
  async getDevice(e) {
    try {
      return (await navigator.mediaDevices.enumerateDevices()).filter((s) => s.deviceId === e)[0];
    } catch (t) {
      throw f.error("enumerate_devices_failed", {
        error: t
      }), new E("Failed to get device");
    }
  }
}, ks = new WeakMap(), Ul);
oc = vb([
  ft((r) => {
    throw new E(r.message, "1600");
  })
], oc);
const Sp = oc;
var wi;
class Tb {
  constructor(e) {
    b(this, wi, void 0);
    h(this, "currentDevice");
    P(this, wi, e);
  }
  async setupSpeaker(e) {
    var s, i;
    if (!(c(this, wi) instanceof Sp))
      return;
    let t = e;
    if (e || ([t] = await c(this, wi).getAvailableDevicesByKind("audiooutput")), !t)
      throw new E("No speaker found");
    ((s = this.currentDevice) == null ? void 0 : s.deviceId) !== t.deviceId && ((i = this.currentDevice) != null || (this.currentDevice = t), document.querySelectorAll("audio").forEach(async (n) => {
      if (typeof n.sinkId != "undefined" && this.currentDevice.deviceId && n.sinkId !== this.currentDevice.deviceId)
        try {
          await n.setSinkId(
            this.currentDevice.deviceId
          );
        } catch (a) {
        }
    }));
  }
}
wi = new WeakMap();
class yb extends Ue {
  constructor(t) {
    super();
    h(this, "mediaInterface");
    h(this, "audioMediaTrack");
    h(this, "videoMediaTrack");
    this.mediaInterface = t;
  }
  get trackEnabled() {
    return !!this.videoMediaTrack;
  }
  async enableScreenShare() {
    var i, n;
    const { audioTrack: t, videoTrack: s } = await this.mediaInterface.getScreenShareTracks();
    this.audioMediaTrack = t, this.videoMediaTrack = s, this.addMediaTrackListeners(), ((n = (i = this.mediaInterface) == null ? void 0 : i.permissions) == null ? void 0 : n.screenshare) !== "ACCEPTED" && this.mediaInterface.permissions && (this.mediaInterface.permissions.screenshare = "ACCEPTED", y.emit(
      v.MEDIA_PERMISSION_UPDATE,
      {
        message: this.mediaInterface.permissions.screenshare,
        kind: "screenshare"
      }
    ));
  }
  disableScreenShare() {
    var t, s;
    this.removeMediaTrackListeners(), (t = this.audioMediaTrack) == null || t.stop(), (s = this.videoMediaTrack) == null || s.stop(), this.videoMediaTrack = void 0, this.audioMediaTrack = void 0;
  }
  addMediaTrackListeners() {
    var t;
    (t = this.videoMediaTrack) == null || t.addEventListener("ended", this.onTrackEnded.bind(this));
  }
  removeMediaTrackListeners() {
    var t;
    (t = this.videoMediaTrack) == null || t.removeEventListener("ended", this.onTrackEnded);
  }
  onTrackEnded() {
    this.emit("trackEnded");
  }
}
var Ir;
class Eb {
  constructor() {
    b(this, Ir, void 0);
  }
  terminateMiddlewareWebWorker() {
    if (c(this, Ir))
      try {
        Ca.clearInterval(c(this, Ir)), P(this, Ir, void 0);
      } catch (e) {
        f.debug("WorkerTimers::terminateMiddlewareWebWorker::failed");
      }
  }
  async getTransformedVideoTrack(e, t) {
    if (!(e != null && e.length))
      return t;
    const s = await Promise.all(
      e == null ? void 0 : e.map((l) => l())
    ), i = new MediaStream();
    i.addTrack(t);
    const n = document.createElement("canvas"), a = n.getContext("2d"), o = document.createElement("video");
    o.srcObject = i, o.autoplay = !0, this.terminateMiddlewareWebWorker();
    const d = async () => {
      if (t.enabled === !1 || t.readyState === "ended") {
        this.terminateMiddlewareWebWorker(), o.remove(), n.remove();
        return;
      }
      try {
        a.drawImage(o, 0, 0);
        for (let l = 0; l < s.length; l += 1)
          await s[l](
            n,
            a
          );
      } catch (l) {
        f.error("getTransformedVideoTrack::middleware_execution_failed", { error: l });
      }
    };
    try {
      o.play();
    } catch (l) {
    }
    return o.addEventListener("play", () => {
      n.width = o.width || t.getSettings().width, n.height = o.width || t.getSettings().height, P(this, Ir, Ca.setInterval(d, 50));
    }, !1), n.captureStream().getVideoTracks()[0];
  }
}
Ir = new WeakMap();
var Sb = Object.defineProperty, wb = Object.getOwnPropertyDescriptor, wp = (r, e, t, s) => {
  for (var i = s > 1 ? void 0 : s ? wb(e, t) : e, n = r.length - 1, a; n >= 0; n--)
    (a = r[n]) && (i = (s ? a(e, t, i) : a(i)) || i);
  return s && i && Sb(e, t, i), i;
}, Ri;
class zc extends Tp {
  constructor(t, s) {
    super(t, s);
    b(this, Ri, void 0);
    P(this, Ri, new Eb());
  }
  async setDevice(t) {
    if (!t)
      throw f.warn("VideoMediaHandler.setDevice No device received"), new E("No device received!");
    if (t.kind !== "videoinput")
      throw f.warn("VideoMediaHandler.setDevice Received non video device", {
        devices: [t]
      }), new E("Non video device received while setting video device!");
    if (this.userSelectedDevice = t.deviceId, !(this.mediaTrack && this.mediaTrack.enabled)) {
      f.warn("VideoMediaHandler.setDevice Tried switching device with video disabled", {
        devices: [t]
      }), this.currentDevice = t;
      return;
    }
    try {
      await this.setMediaTrack(
        await this.mediaInterface.getVideoTrack(this.userSelectedDevice)
      );
    } catch (s) {
      throw f.error("VideoMediaHandler.setDevice.error", {
        error: s
      }), this.disableTrack(), new E("Failed to change device");
    }
  }
  async enableTrack() {
    if (this.trackEnabled) {
      f.warn("VideoMediaHandler.enableTrack Track already enabled!");
      return;
    }
    await this.setMediaTrack(await this.mediaInterface.getVideoTrack(this.userSelectedDevice));
  }
  async setTransformedTrack() {
    var t;
    if (!((t = this.middlewares) != null && t.length)) {
      this.transformedMediaTrack = this.mediaTrack;
      return;
    }
    try {
      this.transformedMediaTrack = await c(this, Ri).getTransformedVideoTrack(
        this.middlewares,
        this.mediaTrack
      ), this.emit("trackChanged");
    } catch (s) {
      f.error("VideoMediaHandler.setTransformedTrack", {
        error: s
      }), this.transformedMediaTrack = this.mediaTrack;
    }
  }
  terminateMiddlewareWebWorker() {
    c(this, Ri).terminateMiddlewareWebWorker();
  }
  async onTrackEnded() {
    f.info("VideoMediaHandler.TrackEnded"), this.disableTrack(), this.emit("trackEnded");
  }
  onTrackMuted() {
    f.info("VideoMediaHandler.TrackMuted"), this.emit("trackMuted");
  }
}
Ri = new WeakMap();
wp([
  _.trace("VideoMediaHandler.setTransformedTrack")
], zc.prototype, "setTransformedTrack", 1);
wp([
  _.trace("VideoMediaHandler.onTrackEnded")
], zc.prototype, "onTrackEnded", 1);
var Rb = Object.defineProperty, bb = Object.getOwnPropertyDescriptor, vs = (r, e, t, s) => {
  for (var i = s > 1 ? void 0 : s ? bb(e, t) : e, n = r.length - 1, a; n >= 0; n--)
    (a = r[n]) && (i = (s ? a(e, t, i) : a(i)) || i);
  return s && i && Rb(e, t, i), i;
}, ut, pt, nt, Xs, Zt;
class os extends Ue {
  constructor(t) {
    super();
    b(this, ut, void 0);
    b(this, pt, void 0);
    b(this, nt, void 0);
    b(this, Xs, void 0);
    b(this, Zt, void 0);
    P(this, ut, new Sp(t)), P(this, pt, new Kc(c(this, ut))), P(this, nt, new zc(c(this, ut))), P(this, Zt, new yb(c(this, ut))), P(this, Xs, new Tb(c(this, ut))), c(this, pt).on("trackMuted", this.onAudioTrackMuted.bind(this)), c(this, pt).on("trackChanged", this.onAudioTrackChanged.bind(this)), c(this, nt).on("trackChanged", this.onVideoTrackChanged.bind(this)), c(this, nt).on("trackEnded", this.onVideoTrackEnded.bind(this)), c(this, Zt).on("trackEnded", this.onScreenShareEnded.bind(this)), this.updatePermissions();
  }
  async updatePermissions() {
    var d, p;
    if (ae.getName() === "firefox")
      return;
    const t = "microphone", s = "camera", i = await ((d = navigator == null ? void 0 : navigator.permissions) == null ? void 0 : d.query({ name: t })), n = await ((p = navigator == null ? void 0 : navigator.permissions) == null ? void 0 : p.query({ name: s })), a = (l, u) => {
      this.permissions[l] = u;
      const m = { message: this.permissions[l], kind: l };
      u === "DENIED" ? y.emit(v.MEDIA_PERMISSION_ERROR, m) : y.emit(v.MEDIA_PERMISSION_UPDATE, m);
    }, o = (l, u) => {
      switch (u) {
        case "granted":
          a(l, "ACCEPTED");
          break;
        case "denied":
          a(l, "DENIED");
          break;
      }
    };
    i && (i.onchange = () => o("audio", i.state)), n && (n.onchange = () => o("video", n.state));
  }
  async setupStreams({ audio: t, video: s }) {
    let i, n;
    if (t && s)
      try {
        const a = await c(this, ut).getAudioAndVideoTrack();
        i = a.audioTrack, n = a.videoTrack;
      } catch (a) {
        f.error(
          "LocalMediaHandler::init::Failed to get audio video tracks",
          {
            error: a
          }
        );
      }
    if (!i && t)
      try {
        i = await c(this, ut).getAudioTrack(!1);
      } catch (a) {
        f.error(
          "LocalMediaHandler::init::Failed to get audio track",
          {
            error: a
          }
        );
      }
    if (!n && s)
      try {
        n = await c(this, ut).getVideoTrack();
      } catch (a) {
        f.error(
          "LocalMediaHandler::init::Failed to get video track",
          {
            error: a
          }
        );
      }
    await c(this, pt).setMediaTrack(i), await c(this, nt).setMediaTrack(n);
    try {
      await c(this, Xs).setupSpeaker();
    } catch (a) {
    }
  }
  getCurrentDevices() {
    return {
      audio: c(this, pt).currentDevice,
      video: c(this, nt).currentDevice,
      speaker: c(this, Xs).currentDevice
    };
  }
  get permissions() {
    return c(this, ut).permissions;
  }
  getAllDevices() {
    return c(this, ut).getAvailableDevices();
  }
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  getDeviceById(t, s) {
    return c(this, ut).getDevice(t);
  }
  /**
   * Audio Input Handler
   */
  onAudioTrackMuted() {
    this.emit("AUDIO_TRACK_SILENT");
  }
  onAudioTrackChanged() {
    this.emit("AUDIO_TRACK_CHANGE");
  }
  get rawAudioTrack() {
    return c(this, pt).mediaTrack;
  }
  get audioTrack() {
    return c(this, pt).transformedMediaTrack;
  }
  get audioEnabled() {
    return c(this, pt).trackEnabled;
  }
  async enableAudio() {
    await c(this, pt).unmuteTrack();
  }
  disableAudio() {
    c(this, pt).muteTrack();
  }
  getAudioDevices() {
    return c(this, ut).getAudioInputDevices();
  }
  async setAudioDevice(t) {
    await c(this, pt).setDevice(t), this.emit("AUDIO_TRACK_CHANGE");
  }
  /**
   * Audio Output Handler
   */
  setupSpeaker() {
    return c(this, Xs).setupSpeaker();
  }
  setSpeakerDevice(t) {
    return c(this, Xs).setupSpeaker(t);
  }
  /**
   * Video Handler
   */
  onVideoTrackChanged() {
    this.emit("VIDEO_TRACK_CHANGE");
  }
  onVideoTrackEnded() {
    this.emit("VIDEO_TRACK_CHANGE");
  }
  get rawVideoTrack() {
    return c(this, nt).mediaTrack;
  }
  get videoTrack() {
    return c(this, nt).transformedMediaTrack;
  }
  get videoEnabled() {
    return c(this, nt).trackEnabled;
  }
  async enableVideo() {
    await c(this, nt).unmuteTrack();
  }
  disableVideo() {
    c(this, nt).disableTrack();
  }
  getVideoDevices() {
    return c(this, ut).getVideoInputDevices();
  }
  async setVideoDevice(t) {
    await c(this, nt).setDevice(t), this.emit("VIDEO_TRACK_CHANGE");
  }
  /**
   * Screen Share Handler
   */
  onScreenShareEnded() {
    this.emit("SCREENSHARE_ENDED");
  }
  get screenShareTracks() {
    return {
      audio: c(this, Zt).audioMediaTrack,
      video: c(this, Zt).videoMediaTrack
    };
  }
  get screenShareEnabled() {
    return c(this, Zt).trackEnabled;
  }
  async enableScreenShare() {
    await c(this, Zt).enableScreenShare();
  }
  async disableScreenShare() {
    c(this, Zt).disableScreenShare();
  }
  getSpeakerDevices() {
    return c(this, ut).getAudioOutputDevices();
  }
  /**
   * Middleware Utility
   */
  addAudioMiddleware(t) {
    return c(this, pt).addMiddleware(t);
  }
  removeAudioMiddleware(t) {
    return c(this, pt).removeMiddleware(
      t
    );
  }
  addVideoMiddleware(t) {
    return c(this, nt).addMiddleware(
      t
    );
  }
  removeVideoMiddleware(t) {
    return c(this, nt).removeMiddleware(
      t
    );
  }
  destruct() {
    c(this, pt).disableTrack(), c(this, nt).disableTrack(), c(this, nt).terminateMiddlewareWebWorker(), c(this, Zt).disableScreenShare();
  }
  /**
   * Backward Compatibility
   */
  removeAllTracks() {
    this.destruct();
  }
  // eslint-disable-next-line class-methods-use-this, no-empty-function
  async removeDocumentEventListeners() {
  }
}
ut = new WeakMap(), pt = new WeakMap(), nt = new WeakMap(), Xs = new WeakMap(), Zt = new WeakMap();
vs([
  _.trace("MediaHandler.setupStreams")
], os.prototype, "setupStreams", 1);
vs([
  _.trace("MediaHandler.enableAudio")
], os.prototype, "enableAudio", 1);
vs([
  _.trace("MediaHandler.disableAudio")
], os.prototype, "disableAudio", 1);
vs([
  _.trace("MediaHandler.setAudioDevice")
], os.prototype, "setAudioDevice", 1);
vs([
  _.trace("MediaHandler.enableVideo")
], os.prototype, "enableVideo", 1);
vs([
  _.trace("MediaHandler.disableVideo")
], os.prototype, "disableVideo", 1);
vs([
  _.trace("MediaHandler.setVideoDevice")
], os.prototype, "setVideoDevice", 1);
vs([
  _.trace("MediaHandler.enableScreenShare")
], os.prototype, "enableScreenShare", 1);
vs([
  _.trace("MediaHandler.disableScreenShare")
], os.prototype, "disableScreenShare", 1);
vs([
  _.trace("MediaHandler.destruct")
], os.prototype, "destruct", 1);
class Pb extends Error {
  constructor(t, s) {
    super(t);
    h(this, "code");
    this.code = s;
  }
}
var Cb = Object.defineProperty, kb = Object.getOwnPropertyDescriptor, js = (r, e, t, s) => {
  for (var i = s > 1 ? void 0 : s ? kb(e, t) : e, n = r.length - 1, a; n >= 0; n--)
    (a = r[n]) && (i = (s ? a(e, t, i) : a(i)) || i);
  return s && i && Cb(e, t, i), i;
};
const Ho = {
  port: void 0
}, Db = [
  "virtual",
  "emulator",
  "krisp",
  "solstice conference",
  "teams",
  "manycam",
  "blackHole"
];
function Rr(r) {
  const e = r.label.toLowerCase();
  return ae._bowser.getOSName() === "macOS" && e.includes("iphone") ? (f.log("isVirtualDevice::ignore_macos_continuity"), !0) : Db.some((t) => e.includes(t));
}
var er, bi, Vl;
const Gs = (Vl = class {
  constructor(r) {
    b(this, er, void 0);
    b(this, bi, void 0);
    P(this, er, r), P(this, bi, new AbortController());
  }
  static async init() {
    let r = [];
    return Gs.isDeviceListAvailable() ? (r = await Gs.enumerateDevices(), f.info("initial_full_device_list", {
      devices: JSON.stringify(r)
    })) : f.error("UnsupportedMediaAPI::navigator.mediaDevices.enumerateDevices", {
      debuggingHint: "Try checking meetingMetadata.visitedUrl. It should be running on localhost/127.0.0.1 or HTTPS, if not, there would be issues."
    }), new Gs(r);
  }
  async destruct() {
    var r;
    (r = c(this, bi)) == null || r.abort();
  }
  static isDeviceListAvailable() {
    return !!(navigator.mediaDevices && navigator.mediaDevices.enumerateDevices);
  }
  static enumerateDevices() {
    try {
      return navigator.mediaDevices.enumerateDevices();
    } catch (r) {
      return f.error("enumerate_devices_failed", {
        error: r
      }), Promise.resolve([]);
    }
  }
  static getAudioConstraints(r) {
    const e = {}, {
      disableAP: t = !1,
      disableAEC: s = !1,
      disableNS: i = !1,
      disableAGC: n = !1,
      disableHPF: a = !1
    } = r.audioOptions || {};
    if (ae.isFirefox() || ae.isWebKitBased())
      e.audio = {
        deviceId: r.audioDeviceId,
        autoGainControl: !n && !t,
        echoCancellation: !s && !t,
        noiseSuppression: !i && !t
      };
    else {
      if (typeof e.audio == "boolean")
        return e;
      e.audio = {}, e.audio.optional = [
        r.audioDeviceId ? { sourceId: r.audioDeviceId } : { sourceId: "default" },
        { echoCancellation: !s && !t },
        { googEchoCancellation: !s && !t },
        { googAutoGainControl: !n && !t },
        { googNoiseSuppression: !i && !t },
        { googHighpassFilter: !a && !t },
        { googNoiseSuppression2: !i && !t },
        { googEchoCancellation2: !s && !t },
        { googAutoGainControl2: !n && !t }
      ];
    }
    return e;
  }
  static getVideoConstraints(r) {
    const e = {}, {
      videoDeviceId: t,
      videoTrackConstraints: s,
      facingMode: i = "user",
      frameRate: n = { ideal: 24, max: 30 }
    } = r;
    return e.video = s || ip.vga, typeof e.video == "boolean" || (t && (e.video.deviceId = { exact: t }), e.video.facingMode = i, e.video.frameRate = n), e;
  }
  static async getUserMediaWithTimeout(r = {}, e = 0) {
    try {
      if (f.info("getUserMediaWithTimeout::requesting_user_media", {
        timeout: e,
        constraints: JSON.stringify(r)
      }), !e) {
        const s = await navigator.mediaDevices.getUserMedia(r);
        return f.info("getUserMediaWithTimeout::received_user_media", {
          timeout: e,
          constraints: JSON.stringify(r)
        }), s;
      }
      const t = await Promise.race(
        [
          navigator.mediaDevices.getUserMedia(r),
          new Promise((s, i) => {
            setTimeout(() => i(new Pb(
              "Get user media timed out",
              "ERR_GUM_TIMEOUT"
            )), e);
          })
        ]
      );
      return f.info("getUserMediaWithTimeout::received_user_media", {
        timeout: e,
        constraints: JSON.stringify(r)
      }), t;
    } catch (t) {
      throw f.error("getUserMediaWithTimeout::failed_to_access_local_media", {
        error: t,
        constraints: JSON.stringify(r)
      }), f.error("Failed to get access to local media.", { error: t, constraints: JSON.stringify(r) }), new Wr(t.name, t.message, r);
    }
  }
  static async getAudioTrack(r) {
    return (await Gs.getUserMediaWithTimeout(r)).getAudioTracks()[0];
  }
  static async getVideoTrack(r) {
    return (await Gs.getUserMediaWithTimeout(r)).getVideoTracks()[0];
  }
  static async getScreenShareTracks(r) {
    var i, n;
    let e = M.hasFeature(N.EXTENSION_HACK), t = null;
    if (e)
      try {
        Ho.port = window.chrome.runtime.connect("nkeimhogjdpnpccoofpliimaahmaaome", { name: "chooseDesktopMedia" });
      } catch (a) {
        _.addLogInCurrentSpan("error", "Extension connect error"), e = !1;
      }
    e && (t = await new Promise((a) => {
      const o = setTimeout(() => a(void 0), 12e3);
      Ho.port.onMessage.addListener(async (d) => {
        if (d.value.streamId) {
          const { streamId: p } = d.value;
          clearTimeout(o), a(p);
        }
      }), Ho.port.postMessage({ method: "chooseDesktopMedia", sources: ["screen"] });
    }));
    let s;
    return t ? (_.addLogInCurrentSpan("error", "Acquiring extension screenshare track"), s = await navigator.mediaDevices.getUserMedia({
      audio: !1,
      video: {
        mandatory: {
          maxWidth: 1920,
          maxHeight: 1080,
          chromeMediaSource: "desktop",
          chromeMediaSourceId: t
        },
        optional: [
          {
            maxFrameRate: parseInt(
              (i = M.getValue(N.VAL_MAX_FRAMERATE_EXT)) != null ? i : "12",
              10
            )
          },
          {
            minFrameRate: parseInt(
              (n = M.getValue(N.VAL_MIN_FRAMERATE_EXT)) != null ? n : "8",
              10
            )
          }
        ]
      }
    }), _.addLogInCurrentSpan("error", "Acquired extension screenshare track")) : s = await navigator.mediaDevices.getDisplayMedia(r), { video: s.getVideoTracks()[0], audio: s.getAudioTracks()[0] };
  }
  static async getAudioAndVideoTrack(r) {
    const e = await Gs.getUserMediaWithTimeout(r);
    return {
      audioTrack: e.getAudioTracks()[0],
      videoTrack: e.getVideoTracks()[0]
    };
  }
  onDeviceChange(r) {
    ae.supportsDeviceChangeEvent() && navigator.mediaDevices.addEventListener(
      "devicechange",
      lT(async (e) => {
        const t = this.availableDevices, s = new Set(t.map((o) => o.deviceId));
        await this.repopulateAvailableDevices();
        const i = this.availableDevices, n = new Set(i.map((o) => o.deviceId)), a = {
          added: i.filter((o) => !s.has(o.deviceId)),
          removed: t.filter((o) => !n.has(o.deviceId))
        };
        this.repopulateAvailableDevices().then(() => r(e, a));
      }, 100),
      { signal: c(this, bi).signal }
    );
  }
  async repopulateAvailableDevices() {
    const r = await Gs.enumerateDevices();
    P(this, er, r), A.devices("AUDIO", this.getAudioDevices()), A.devices("VIDEO", this.getVideoDevices()), A.devices("SPEAKER", this.getSpeakerDevices()), f.info("repopulated_full_device_list", {
      devices: JSON.stringify(r)
    });
  }
  get availableDevices() {
    return c(this, er);
  }
  getAvailableDevicesByKind(r) {
    return c(this, er).filter((e) => e.kind === r);
  }
  getDeviceById(r, e) {
    return c(this, er).find((t) => t.deviceId === r && t.kind === e);
  }
  /**
   * Returns all audio input devices (microphone devices).
   */
  getAudioDevices() {
    return this.getAvailableDevicesByKind("audioinput").sort((r, e) => {
      const t = Rr(r) ? 0 : 1;
      return (Rr(e) ? 0 : 1) - t;
    });
  }
  /**
   * Returns all video input devices.
   */
  getVideoDevices() {
    return this.getAvailableDevicesByKind("videoinput").sort((r, e) => {
      const t = Rr(r) ? 0 : 1;
      return (Rr(e) ? 0 : 1) - t;
    });
  }
  /**
   * Returns all audio output devices (speaker devices).
   */
  getSpeakerDevices() {
    return this.getAvailableDevicesByKind("audiooutput").sort((r, e) => {
      const t = Rr(r) ? 0 : 1;
      return (Rr(e) ? 0 : 1) - t;
    });
  }
}, er = new WeakMap(), bi = new WeakMap(), Vl);
let tt = Gs;
js([
  _.trace("LocalMediaUtils.onDeviceChange")
], tt.prototype, "onDeviceChange", 1);
js([
  _.trace("LocalMediaUtils.repopulateAvailableDevices")
], tt.prototype, "repopulateAvailableDevices", 1);
js([
  _.trace("LocalMediaUtils.isDeviceListAvailable")
], tt, "isDeviceListAvailable", 1);
js([
  _.trace("LocalMediaUtils.enumerateDevices")
], tt, "enumerateDevices", 1);
js([
  _.trace("LocalMediaUtils.getUserMediaWithTimeout")
], tt, "getUserMediaWithTimeout", 1);
js([
  _.trace("LocalMediaUtils.getAudioTrack")
], tt, "getAudioTrack", 1);
js([
  _.trace("LocalMediaUtils.getVideoTrack")
], tt, "getVideoTrack", 1);
js([
  _.trace("LocalMediaUtils.getScreenShareTracks")
], tt, "getScreenShareTracks", 1);
js([
  _.trace("LocalMediaUtils.getAudioAndVideoTrack")
], tt, "getAudioAndVideoTrack", 1);
var Ib = Object.defineProperty, Ab = Object.getOwnPropertyDescriptor, tn = (r, e, t, s) => {
  for (var i = s > 1 ? void 0 : s ? Ab(e, t) : e, n = r.length - 1, a; n >= 0; n--)
    (a = r[n]) && (i = (s ? a(e, t, i) : a(i)) || i);
  return s && i && Ib(e, t, i), i;
}, Fe, Ar;
class ti {
  constructor(e) {
    b(this, Fe, void 0);
    h(this, "audioMiddlewares", []);
    h(this, "videoMiddlewares", []);
    b(this, Ar, void 0);
    P(this, Fe, e);
  }
  terminateMiddlewareWebWorker() {
    if (c(this, Ar))
      try {
        Ca.clearInterval(c(this, Ar)), P(this, Ar, void 0);
      } catch (e) {
        f.debug("WorkerTimers::terminateMiddlewareWebWorker::failed");
      }
  }
  async getTransformedVideoTrack(e) {
    var p, l;
    if (!((p = this.videoMiddlewares) != null && p.length))
      return e;
    const t = await Promise.all(
      (l = this.videoMiddlewares) == null ? void 0 : l.map((u) => u())
    ), s = new MediaStream();
    s.addTrack(e);
    const i = document.createElement("canvas"), n = i.getContext("2d"), a = document.createElement("video");
    a.srcObject = s, a.autoplay = !0, this.terminateMiddlewareWebWorker();
    const o = async () => {
      if (!c(this, Fe).videoEnabled || e.readyState === "ended") {
        this.terminateMiddlewareWebWorker(), a.remove(), i.remove();
        return;
      }
      try {
        n.drawImage(a, 0, 0);
        for (let u = 0; u < t.length; u += 1)
          await t[u](
            i,
            n
          );
      } catch (u) {
        f.error("getTransformedVideoTrack::middleware_execution_failed", { error: u });
      }
    };
    try {
      a.play();
    } catch (u) {
    }
    return a.addEventListener("play", () => {
      i.width = a.width || e.getSettings().width, i.height = a.width || e.getSettings().height, P(this, Ar, Ca.setInterval(o, 50));
    }, !1), i.captureStream().getVideoTracks()[0];
  }
  async addVideoMiddleware(e) {
    return ae.isSafari() ? { success: !1, message: "Video middlewares are not yet supported in Safari." } : this.videoMiddlewares.includes(e) ? { success: !0, message: "This video middleware has been applied, already. Skipping." } : (this.videoMiddlewares.push(e), c(this, Fe).videoEnabled ? (c(this, Fe).setVideoTrack(
      await this.getTransformedVideoTrack(c(this, Fe).rawVideoTrack)
    ), c(this, Fe).emit("VIDEO_TRACK_CHANGE"), { success: !0, message: "Successfully applied the video middleware." }) : { success: !0, message: "Successfully added the video middleware. It will be applied automatically once webcam is turned on." });
  }
  async removeVideoMiddleware(e) {
    const t = this.videoMiddlewares.indexOf(e, 0);
    return t > -1 ? (this.videoMiddlewares.splice(t, 1), c(this, Fe).videoEnabled && (c(this, Fe).setVideoTrack(
      await this.getTransformedVideoTrack(c(this, Fe).rawVideoTrack)
    ), c(this, Fe).emit("VIDEO_TRACK_CHANGE")), { success: !0, message: "Successfully removed the video middleware." }) : { success: !0, message: "No such video middleware was found. Skipping." };
  }
  async getTransformedAudioTrack(e) {
    var a, o;
    if (!((a = this.audioMiddlewares) != null && a.length))
      return e;
    const t = new AudioContext(), s = await Promise.all(
      (o = this.audioMiddlewares) == null ? void 0 : o.map((d) => d(t))
    ), i = t.createMediaStreamSource(new MediaStream([e])), n = t.createMediaStreamDestination();
    try {
      let d = i;
      for (let p = 0; p < s.length; p += 1)
        d.connect(s[p]), d = s[p];
      d.connect(n);
    } catch (d) {
      return f.error("getTransformedAudioTrack::middleware_execution_failed", { error: d }), e;
    }
    return n.stream.getAudioTracks()[0];
  }
  async addAudioMiddleware(e) {
    return ae.isSafari() ? { success: !1, message: "Audio middlewares are not yet supported in Safari." } : this.audioMiddlewares.includes(e) ? { success: !0, message: "This audio middleware has been applied, already. Skipping." } : (this.audioMiddlewares.push(e), c(this, Fe).audioEnabled ? (c(this, Fe).setAudioTrack(
      await this.getTransformedAudioTrack(c(this, Fe).rawAudioTrack)
    ), c(this, Fe).emit("AUDIO_TRACK_CHANGE"), { success: !0, message: "Successfully applied the audio middleware." }) : { success: !0, message: "Successfully added the audio middleware. It will be applied automatically once mic is turned on." });
  }
  async removeAudioMiddleware(e) {
    const t = this.audioMiddlewares.indexOf(e, 0);
    return t > -1 ? (this.audioMiddlewares.splice(t, 1), c(this, Fe).audioEnabled && (c(this, Fe).setAudioTrack(
      await this.getTransformedAudioTrack(c(this, Fe).rawAudioTrack)
    ), c(this, Fe).emit("AUDIO_TRACK_CHANGE")), { success: !0, message: "Successfully removed the audio middleware." }) : { success: !0, message: "No such audio middleware was found. Skipping." };
  }
}
Fe = new WeakMap(), Ar = new WeakMap();
tn([
  _.trace("MediaMiddlewareUtils.getTransformedVideoTrack")
], ti.prototype, "getTransformedVideoTrack", 1);
tn([
  _.trace("MediaMiddlewareUtils.addVideoMiddleware")
], ti.prototype, "addVideoMiddleware", 1);
tn([
  _.trace("MediaMiddlewareUtils.removeVideoMiddleware")
], ti.prototype, "removeVideoMiddleware", 1);
tn([
  _.trace("MediaMiddlewareUtils.getTransformedAudioTrack")
], ti.prototype, "getTransformedAudioTrack", 1);
tn([
  _.trace("MediaMiddlewareUtils.addAudioMiddleware")
], ti.prototype, "addAudioMiddleware", 1);
tn([
  _.trace("MediaMiddlewareUtils.removeAudioMiddleware")
], ti.prototype, "removeAudioMiddleware", 1);
const Mb = (r = 0) => new Promise((e) => setTimeout(e, r)), Ob = (r, e, t) => {
  const s = typeof t == "number" ? t : 250, i = r.createMediaStreamSource(e), n = r.createAnalyser();
  n.fftSize = 2048, i.connect(n);
  const a = new Uint8Array(n.fftSize);
  let o = !1;
  setTimeout(() => {
    o = !0;
  }, s);
  function d() {
    return o ? Promise.resolve(!0) : (n.getByteTimeDomainData(a), a.some((p) => p !== 128 && p !== 0) ? Promise.resolve(!1) : Mb().then(d));
  }
  return d().then((p) => (i.disconnect(), p), (p) => {
    throw i.disconnect(), p;
  });
}, Nb = typeof AudioContext != "undefined" ? AudioContext : null;
class Qc {
  constructor(e) {
    h(this, "_AudioContext");
    h(this, "audioContext");
    h(this, "_audioContextRefContainers");
    const t = { AudioContext: Nb, ...e };
    Object.defineProperties(this, {
      _AudioContext: {
        value: t.AudioContext
      },
      audioContext: {
        value: null,
        writable: !0
      },
      _audioContextRefContainers: {
        value: /* @__PURE__ */ new Set()
      },
      AudioContextProvider: {
        enumerable: !0,
        value: Qc
      }
    });
  }
  getOrCreate(e) {
    if (!this._audioContextRefContainers.has(e) && (this._audioContextRefContainers.add(e), this._AudioContext && !this.audioContext))
      try {
        this.audioContext = new this._AudioContext();
      } catch (t) {
      }
    return this.audioContext;
  }
  release(e) {
    this._audioContextRefContainers.has(e) && (this._audioContextRefContainers.delete(e), !this._audioContextRefContainers.size && this.audioContext && (this.audioContext.close(), this.audioContext = null));
  }
}
const Pl = new Qc(), Lb = 3, xb = 250;
function Ub(r) {
  const e = {}, t = Pl.getOrCreate(e);
  let s = Lb;
  function i() {
    return s -= 1, Ob(t, r.srcObject, xb).then(
      (n) => n ? s > 0 ? i() : !0 : !1
    ).catch(() => !0);
  }
  return i().finally(() => {
    Pl.release(e);
  });
}
async function Bo(r) {
  const e = new Audio(), t = new MediaStream();
  t.addTrack(r), e.srcObject = t;
  let s = !1;
  try {
    const i = e.play();
    i && await i, s = await Ub(e), s && f.info("checkIfAudioTrackIsSilent::silence_detected");
  } catch (i) {
    f.error("checkIfAudioTrackIsSilent::failed_to_detect_silence", { error: i });
  } finally {
    e.pause(), e.remove();
  }
  return s;
}
const hi = class {
  constructor() {
    h(this, "mediaPermissionEvent");
    this.mediaPermissionEvent = !0;
  }
  static getInstance() {
    return hi.instance || (hi.instance = new hi()), hi.instance;
  }
  get shouldEmitMediaPermissionEvent() {
    return this.mediaPermissionEvent;
  }
  setEmitMediaPermissionEvent(e) {
    this.mediaPermissionEvent = e;
  }
};
let ya = hi;
h(ya, "instance");
const pa = ya.getInstance(), di = {
  setItem: (r, e) => {
    try {
      localStorage.setItem(r, e);
    } catch (t) {
      f.error("LocalStorage::setItem::crashed", { error: t, localStorage: { key: r, value: e } });
    }
  },
  getItem: (r) => {
    try {
      return localStorage.getItem(r);
    } catch (e) {
      f.error("LocalStorage::getItem::crashed", { error: e, localStorage: { key: r } });
    }
    return null;
  }
};
var Vb = Object.defineProperty, Fb = Object.getOwnPropertyDescriptor, be = (r, e, t, s) => {
  for (var i = s > 1 ? void 0 : s ? Fb(e, t) : e, n = r.length - 1, a; n >= 0; n--)
    (a = r[n]) && (i = (s ? a(e, t, i) : a(i)) || i);
  return s && i && Vb(e, t, i), i;
}, _e, tr, Fl;
const Rp = (Fl = class extends bt.EventEmitter {
  constructor(e, t) {
    super();
    b(this, _e, void 0);
    b(this, tr, void 0);
    h(this, "mediaMiddlewareUtils");
    h(this, "audioTrack");
    h(this, "rawAudioTrack");
    h(this, "videoTrack");
    h(this, "rawVideoTrack");
    h(this, "screenShareTracks");
    h(this, "audioEnabled");
    h(this, "videoEnabled");
    h(this, "screenShareEnabled");
    h(this, "currentDevices");
    h(this, "permissions");
    h(this, "audioUpdateInProgress");
    h(this, "videoUpdateInProgress");
    h(this, "screenShareUpdateInProgress");
    P(this, _e, e), P(this, tr, new ap(t)), this.audioEnabled = !0, this.videoEnabled = !0, this.audioUpdateInProgress = !1, this.videoUpdateInProgress = !1, this.screenShareUpdateInProgress = !1, this.screenShareEnabled = !1, this.permissions = {
      audio: "NOT_REQUESTED",
      video: "NOT_REQUESTED",
      screenshare: "NOT_REQUESTED"
    }, this.screenShareTracks = {
      audio: void 0,
      video: void 0
    }, this.currentDevices = {
      audio: void 0,
      video: void 0,
      speaker: void 0
    }, c(this, _e).onDeviceChange(
      (s, i) => this.onDeviceChange(i, !1)
    ), this.updateDevices(), this.conditionallyRestartAudio = this.conditionallyRestartAudio.bind(this), this.conditionallyRestartVideo = this.conditionallyRestartVideo.bind(this), this.onVisibilityChange = this.onVisibilityChange.bind(this), document.addEventListener("visibilitychange", this.onVisibilityChange), this.on("AUDIO_TRACK_CHANGE", () => {
      this.notifyIfTrackSilent();
    });
  }
  handlePermissionErrors(e, t) {
    const s = Ep(t.name, t.message);
    this.permissions[e] = s, y.emit(
      v.MEDIA_PERMISSION_ERROR,
      {
        message: s,
        constraints: t.constraints,
        kind: e
      }
    );
  }
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  onVisibilityChange(e) {
    document.visibilityState === "visible" && (ae.isMobile() && this.conditionallyRestartAudio(), this.conditionallyRestartVideo()), A.tabChanged(document.visibilityState === "visible"), document.visibilityState !== "visible" ? A.browserBackgrounded() : A.browserForegrounded();
  }
  async conditionallyRestartAudio(e) {
    var s, i;
    if (!((s = this.currentDevices) != null && s.audio) || !this.audioEnabled)
      return;
    await Promise.race([
      new Promise((n) => {
        var a;
        return (a = this.rawAudioTrack) == null ? void 0 : a.addEventListener("unmute", (o) => {
          n(o);
        });
      }),
      new Promise((n) => setTimeout(n, 50))
    ]), f.info("performingCheck::shouldReacquireAudioTrack", { actions: { trackRobustness: { eventType: e == null ? void 0 : e.type } } });
    const t = await this.shouldReacquireTrack("audio");
    f.info("performedCheck::shouldReacquireAudioTrack", {
      actions: {
        trackRobustness: {
          reacquireTrack: t
        }
      }
    }), t && (f.info("reacquiring_audio_track"), this.removeMediaStreamTrackListeners(this.rawAudioTrack), ae.isChromiumBased() && await c(this, _e).repopulateAvailableDevices(), await this.setupAudioStream((i = this.currentDevices.audio) == null ? void 0 : i.deviceId), this.addMediaStreamTrackListeners(this.rawAudioTrack), this.emit("AUDIO_TRACK_CHANGE"));
  }
  async conditionallyRestartVideo(e) {
    var s;
    if (!((s = this.currentDevices) != null && s.video) || !this.videoEnabled)
      return;
    f.info("performingCheck::shouldReacquireVideoTrack", { actions: { trackRobustness: { eventType: e == null ? void 0 : e.type } } }), await Promise.race([
      new Promise((i) => {
        var n;
        return (n = this.rawVideoTrack) == null ? void 0 : n.addEventListener("unmute", i);
      }),
      new Promise((i) => setTimeout(i, 50))
    ]);
    const t = await this.shouldReacquireTrack("video");
    f.info("performedCheck::shouldReacquireVideoTrack", {
      actions: {
        trackRobustness: {
          reacquireTrack: t
        }
      }
    }), t && (f.info("reacquiring_video_track"), this.removeMediaStreamTrackListeners(this.rawVideoTrack), await c(this, _e).repopulateAvailableDevices(), await this.setupVideoStream(this.currentDevices.video.deviceId), this.addMediaStreamTrackListeners(this.rawVideoTrack), this.emit("VIDEO_TRACK_CHANGE"));
  }
  async shouldReacquireTrack(e) {
    let s, i = !1;
    if (e === "audio" ? (s = this.rawAudioTrack, i = this.audioEnabled) : e === "video" && (s = this.rawVideoTrack, i = this.videoEnabled), !s)
      return !1;
    const a = s.readyState === "ended" && i && !0;
    let o = !1;
    return e === "audio" && (o = await Bo(this.rawAudioTrack)), document.visibilityState === "visible" && (s.muted || a || o);
  }
  // eslint-disable-next-line class-methods-use-this
  onAudioUnmute(e) {
    f.info("audio_track_unmuted", {
      actions: {
        trackRobustness: {
          eventType: e == null ? void 0 : e.type
        }
      }
    });
  }
  // eslint-disable-next-line class-methods-use-this
  onVideoUnmute(e) {
    f.info("video_track_unmuted", {
      actions: {
        trackRobustness: {
          eventType: e == null ? void 0 : e.type
        }
      }
    });
  }
  removeMediaStreamTrackListeners(e) {
    if (f.info(`Removing ${e.kind} listerners`), !e)
      return;
    const t = e.kind === "audio" ? this.conditionallyRestartAudio : this.conditionallyRestartVideo;
    return e.removeEventListener("ended", t), e.removeEventListener("mute", t), e.removeEventListener("unmute", e.kind === "audio" ? this.onAudioUnmute : this.onVideoUnmute), e;
  }
  addMediaStreamTrackListeners(e) {
    if (!e)
      return null;
    f.info(`adding_${e.kind}_stream_listerners`);
    const t = e.kind === "audio", s = t ? this.conditionallyRestartAudio : this.conditionallyRestartVideo;
    return e.addEventListener("ended", async () => {
      await s();
      const i = t ? this.audioEnabled : this.videoEnabled, n = t ? this.audioTrack : this.videoTrack, a = t ? "FORCE_MUTE_AUDIO" : "FORCE_MUTE_VIDEO";
      i && !(n && n.readyState === "live" && n.enabled) && (f.info(`LocalMediaHandler::trackEnded::Failed to restart ${e.kind} track`), this.emit(a));
    }), e.addEventListener("mute", s), e.addEventListener("unmute", t ? this.onAudioUnmute : this.onVideoUnmute), e;
  }
  /**
   * NOTE(callmetarush): Emits AUDIO_TRACK_SILENT
   * If audio is enabled and current track is silent
   */
  async notifyIfTrackSilent() {
    var e, t, s, i, n, a;
    this.audioEnabled && this.audioTrack && this.audioTrack.readyState !== "ended" && this.audioTrack.enabled && await Bo(this.audioTrack) === !0 && (f.info("LocalMediaHandler:notifyIfTrackSilent:TrackSilent", {
      media: {
        audio: {
          enabled: this.audioEnabled,
          deviceId: (t = (e = this.audioTrack) == null ? void 0 : e.getSettings()) == null ? void 0 : t.deviceId,
          permission: (s = this.permissions) == null ? void 0 : s.audio,
          deviceName: (n = (i = this.currentDevices) == null ? void 0 : i.audio) == null ? void 0 : n.label,
          trackId: (a = this.audioTrack) == null ? void 0 : a.id
        }
      }
    }), this.emit("AUDIO_TRACK_SILENT"));
  }
  async setupAudioStream(e, t = !0) {
    var s, i, n;
    if (!this.audioUpdateInProgress)
      try {
        this.audioUpdateInProgress = !0;
        const a = c(this, _e).getAudioDevices();
        if (!a.length)
          return;
        let o = e;
        (!o || !a.find((p) => p.deviceId === o)) && (o = await this.getPreferredDeviceId("AUDIO"), f.debug("setupAudioStream::AUDIO::getPreferredDeviceId", {
          preferredDevice: {
            preferredDeviceId: o,
            kind: "audio"
          }
        }));
        const d = tt.getAudioConstraints({ audioDeviceId: o });
        t && ((s = this.rawAudioTrack) == null || s.stop(), (i = this.audioTrack) == null || i.stop()), this.rawAudioTrack = await tt.getAudioTrack(d), o = this.rawAudioTrack.getSettings().deviceId, ((n = this.currentDevices.audio) == null ? void 0 : n.deviceId) !== o && (this.currentDevices.audio = c(this, _e).getDeviceById(o, "audioinput"), this.emit("DEVICE_CHANGE", {
          device: this.currentDevices.audio
        })), this.rawAudioTrack.enabled = this.audioEnabled, this.setAudioTrack(
          await this.mediaMiddlewareUtils.getTransformedAudioTrack(this.rawAudioTrack)
        ), this.addMediaStreamTrackListeners(this.rawAudioTrack), await c(this, _e).repopulateAvailableDevices(), this.permissions.audio = "ACCEPTED", y.emit(
          v.MEDIA_PERMISSION_UPDATE,
          {
            message: this.permissions.audio,
            kind: "audio"
          }
        ), A.mediaPermission("AUDIO", ur.ACCEPTED), A.selectedDevice("AUDIO", this.currentDevices.audio), o && di.setItem("lastUsedAudioDeviceId", o);
      } catch (a) {
        this.handlePermissionErrors("audio", a);
      } finally {
        this.audioUpdateInProgress = !1;
      }
  }
  async getPreferredDeviceId(e) {
    var s, i;
    let t;
    if (e === "AUDIO") {
      const n = c(this, _e).getAudioDevices(), a = di.getItem("lastUsedAudioDeviceId");
      f.debug("getPreferredDeviceId::lastUsedAudioDeviceId", {
        preferredDevice: {
          lastUsedPreferredDeviceId: a,
          kind: "audio"
        }
      });
      let o;
      a && (o = n.find(
        (d) => d.deviceId === a
      )), o ? t = a : M.hasFeature(N.REMOVE_OPERATIONAL_MIC) || (t = (await this.getOperationalMicDeviceId()).deviceId), t || (t = (s = n[0]) == null ? void 0 : s.deviceId);
    }
    if (e === "VIDEO") {
      const n = di.getItem("lastUsedVideoDeviceId");
      f.debug("getPreferredDeviceId::lastUsedVideoDeviceId", {
        preferredDevice: {
          kind: "video",
          lastUsedPreferredDeviceId: n
        }
      });
      const a = c(this, _e).getVideoDevices();
      let o;
      n && (o = a.find(
        (d) => d.deviceId === n
      )), o ? t = n : t = (await this.getOperationalWebcamDeviceId()).deviceId, t || (t = (i = a[0]) == null ? void 0 : i.deviceId);
    }
    return t;
  }
  async setupVideoStream(e, t = !0) {
    var s, i;
    if (!this.videoUpdateInProgress)
      try {
        this.videoUpdateInProgress = !0;
        const n = c(this, _e).getVideoDevices();
        if (!n.length)
          return;
        let a = e;
        if ((!a || !n.find((o) => o.deviceId === a)) && (a = await this.getPreferredDeviceId("VIDEO"), f.debug("setupVideoStream::VIDEO::getPreferredDeviceId", {
          preferredDevice: {
            preferredDeviceId: a,
            kind: "video"
          }
        })), t && ((s = this.videoTrack) == null || s.stop()), this.videoEnabled) {
          const o = c(this, tr).getVideoConstraints(
            a
          );
          this.rawVideoTrack = await tt.getVideoTrack(o), a = this.rawVideoTrack.getSettings().deviceId, this.setVideoTrack(
            await this.mediaMiddlewareUtils.getTransformedVideoTrack(this.rawVideoTrack)
          ), this.addMediaStreamTrackListeners(this.rawVideoTrack);
        }
        await c(this, _e).repopulateAvailableDevices(), ((i = this.currentDevices.video) == null ? void 0 : i.deviceId) !== a && (this.currentDevices.video = c(this, _e).getDeviceById(a, "videoinput"), this.emit("DEVICE_CHANGE", {
          device: this.currentDevices.video
        })), this.permissions.video = "ACCEPTED", y.emit(
          v.MEDIA_PERMISSION_UPDATE,
          {
            message: this.permissions.video,
            kind: "video"
          }
        ), A.mediaPermission("VIDEO", ur.ACCEPTED), A.selectedDevice("VIDEO", this.currentDevices.video), a && di.setItem("lastUsedVideoDeviceId", a);
      } catch (n) {
        this.handlePermissionErrors("video", n);
      } finally {
        this.videoUpdateInProgress = !1;
      }
  }
  async setupScreenShareStreams() {
    if (this.screenShareUpdateInProgress)
      return;
    const e = c(this, tr).getScreenShareConstraints();
    M.hasFeature(N.SCREENSHARE_MAX_DIMENSIONS) && (e.video.width.max = window.screen.width, e.video.height.max = window.screen.height);
    try {
      this.screenShareUpdateInProgress = !0;
      const t = await tt.getScreenShareTracks(e);
      this.setScreenShareTracks(t);
    } catch (t) {
      throw this.handlePermissionErrors("screenshare", new Wr(t.name, t.message, e)), new E(t.message);
    } finally {
      this.screenShareUpdateInProgress = !1;
    }
  }
  async setupSpeaker(e) {
    var i;
    const t = c(this, _e).getSpeakerDevices();
    if (!t.length)
      return;
    const s = e != null ? e : t[0].deviceId;
    ((i = this.currentDevices.speaker) == null ? void 0 : i.deviceId) !== s && (this.currentDevices.speaker = c(this, _e).getDeviceById(s, "audiooutput"), A.selectedDevice("SPEAKER", this.currentDevices.speaker), this.emit("DEVICE_CHANGE", {
      device: this.currentDevices.speaker
    })), document.querySelectorAll("audio").forEach(async (n) => {
      if (typeof n.sinkId != "undefined" && this.currentDevices.speaker.deviceId && n.sinkId !== this.currentDevices.speaker.deviceId)
        try {
          await n.setSinkId(
            this.currentDevices.speaker.deviceId
          );
        } catch (a) {
        }
    });
  }
  async getOperationalWebcamDeviceId() {
    const e = c(this, _e).getVideoDevices();
    if (!e.length)
      return { isOperational: !1, deviceId: null };
    pa.setEmitMediaPermissionEvent(!1);
    const t = [], s = await e.reduce(
      async (i, n) => {
        const a = await i;
        if (a !== null)
          return a;
        const o = c(this, tr).getVideoConstraints(
          n.deviceId
        );
        try {
          return (await tt.getVideoTrack(o)).stop(), n.deviceId;
        } catch (d) {
          f.error("getOperationalWebcamDeviceId::could_not_acquire_video_device", { error: d, constraints: o }), t.push({ exception: d, constraints: o });
        }
        return a;
      },
      Promise.resolve(null)
    );
    if (pa.setEmitMediaPermissionEvent(!0), !s && t.length > 0 && t.length === e.length) {
      const { exception: i, constraints: n } = t[0];
      throw new Wr(i.name, i.message, n);
    }
    return s ? { isOperational: !0, deviceId: s } : { isOperational: !1, deviceId: e[0].deviceId };
  }
  async getOperationalMicDeviceId() {
    const e = c(this, _e).getAudioDevices();
    if (!e.length)
      return { isOperational: !1, deviceId: null };
    const t = [];
    pa.setEmitMediaPermissionEvent(!1);
    const s = await e.reduce(
      async (i, n) => {
        const a = await i;
        if (a !== null)
          return a;
        const o = tt.getAudioConstraints({
          audioDeviceId: n.deviceId
        });
        try {
          const d = await tt.getAudioTrack(o), p = await Bo(d);
          if (d == null || d.stop(), !p)
            return n;
        } catch (d) {
          f.error("getOperationalMicDeviceId::could_not_acquire_audio_device", { error: d, constraints: o }), t.push({ exception: d, constraints: o });
        }
        return a;
      },
      Promise.resolve(null)
    );
    if (pa.setEmitMediaPermissionEvent(!0), !s && t.length > 0 && t.length === e.length) {
      const { exception: i, constraints: n } = t[0];
      throw new Wr(i.name, i.message, n);
    }
    return s ? { isOperational: !0, deviceId: s.deviceId } : { isOperational: !1, deviceId: e[0].deviceId };
  }
  async setupStreams({ audio: e, video: t }) {
    var i;
    const s = {};
    this.currentDevices || (this.currentDevices = {
      audio: void 0,
      video: void 0,
      speaker: void 0
    });
    try {
      if (e && !this.audioUpdateInProgress && c(this, _e).getAudioDevices().length !== 0) {
        const d = await this.getPreferredDeviceId("AUDIO");
        f.info("setupStreams::AUDIO::getPreferredDeviceId", {
          preferredDevice: {
            preferredDeviceId: d,
            kind: "audio"
          }
        });
        const p = tt.getAudioConstraints({ audioDeviceId: d });
        s.audio = p.audio;
      }
      if (t && !this.videoUpdateInProgress && c(this, _e).getVideoDevices().length !== 0) {
        const d = await this.getPreferredDeviceId("VIDEO");
        f.info("setupStreams::VIDEO::getPreferredDeviceId", {
          preferredDevice: {
            preferredDeviceId: d,
            kind: "video"
          }
        });
        const p = c(this, tr).getVideoConstraints(
          d
        );
        s.video = p.video;
      }
      if (((i = Object.keys(s)) == null ? void 0 : i.length) === 0) {
        this.audioEnabled = e != null ? e : this.audioEnabled, this.videoEnabled = t != null ? t : this.videoEnabled, this.audioUpdateInProgress = !1, this.videoUpdateInProgress = !1;
        return;
      }
      const {
        audioTrack: n,
        videoTrack: a
      } = await tt.getAudioAndVideoTrack(s);
      e && n && (this.audioTrack = n, this.rawAudioTrack = n, this.permissions.audio = "ACCEPTED", y.emit(
        v.MEDIA_PERMISSION_UPDATE,
        {
          message: this.permissions.audio,
          kind: "audio"
        }
      ), this.currentDevices.audio = c(this, _e).getDeviceById(
        n.getSettings().deviceId,
        "audioinput"
      ), di.setItem("lastUsedAudioDeviceId", n.getSettings().deviceId)), t && a && (this.videoTrack = a, this.rawVideoTrack = a, this.permissions.video = "ACCEPTED", y.emit(
        v.MEDIA_PERMISSION_UPDATE,
        {
          message: this.permissions.video,
          kind: "video"
        }
      ), this.currentDevices.video = c(this, _e).getDeviceById(
        a.getSettings().deviceId,
        "videoinput"
      ), di.setItem("lastUsedVideoDeviceId", a.getSettings().deviceId)), await c(this, _e).repopulateAvailableDevices();
    } catch (n) {
      n.name === "NotAllowedError" && (e && await this.setupAudioStream(), t && await this.setupVideoStream());
    }
    this.audioEnabled = !!this.audioTrack, this.videoEnabled = !!this.videoTrack, this.screenShareEnabled = !1, this.audioUpdateInProgress = !1, this.videoUpdateInProgress = !1, await this.setupSpeaker();
  }
  stopAudioTrack() {
    var e, t;
    this.audioUpdateInProgress || (this.audioUpdateInProgress = !0, (e = this.audioTrack) == null || e.stop(), (t = this.rawAudioTrack) == null || t.stop(), this.audioEnabled = !1, this.audioUpdateInProgress = !1);
  }
  stopVideoTrack() {
    var e, t;
    this.videoUpdateInProgress || (this.videoUpdateInProgress = !0, (e = this.videoTrack) == null || e.stop(), (t = this.rawVideoTrack) == null || t.stop(), this.videoEnabled = !1, this.videoUpdateInProgress = !1);
  }
  stopScreenShareTracks(e = {}) {
    var i, n, a, o;
    if (this.screenShareUpdateInProgress)
      return;
    this.screenShareUpdateInProgress = !0;
    const { audio: t = !0, video: s = !0 } = e;
    t && ((n = (i = this.screenShareTracks) == null ? void 0 : i.audio) == null || n.stop()), s && ((o = (a = this.screenShareTracks) == null ? void 0 : a.video) == null || o.stop()), this.screenShareEnabled = !1, this.screenShareUpdateInProgress = !1;
  }
  removeAudioTrack() {
    this.stopAudioTrack(), this.audioTrack = void 0, this.rawAudioTrack = void 0;
  }
  removeVideoTrack() {
    this.stopVideoTrack(), this.videoTrack = void 0, this.rawVideoTrack = void 0;
  }
  removeScreenShareTracks(e) {
    var t;
    (t = this.screenShareTracks.video) == null || t.removeEventListener("ended", this.onScreenShareEnded), this.stopScreenShareTracks(e), this.screenShareTracks = {
      audio: void 0,
      video: void 0
    };
  }
  removeAllTracks() {
    this.removeAudioTrack(), this.removeVideoTrack(), this.removeScreenShareTracks({
      audio: !!this.screenShareTracks.audio,
      video: !!this.screenShareTracks.video
    });
  }
  setAudioTrack(e) {
    e !== this.audioTrack && (e === void 0 && this.stopAudioTrack(), this.audioTrack = e, this.audioTrack && (this.audioTrack.enabled = this.audioEnabled));
  }
  setVideoTrack(e) {
    e !== this.videoTrack && (e === void 0 && this.stopVideoTrack(), this.videoTrack = e);
  }
  setScreenShareTracks(e) {
    var i;
    const { audio: t, video: s } = e;
    (!t || !s) && this.stopScreenShareTracks({ audio: !!t, video: !!s }), this.screenShareTracks = e, (i = this.screenShareTracks.video) == null || i.addEventListener("ended", this.onScreenShareEnded.bind(this));
  }
  onScreenShareEnded() {
    this.emit("SCREENSHARE_ENDED");
  }
  disableAudio() {
    this.audioEnabled = !1, this.audioTrack && (this.audioTrack.enabled = this.audioEnabled), this.rawAudioTrack && (this.rawAudioTrack.enabled = this.audioEnabled);
  }
  async enableAudio() {
    var e;
    if (this.permissions.audio === "DENIED") {
      this.audioEnabled = !1;
      return;
    }
    try {
      if ((!this.audioTrack || this.audioTrack.readyState === "ended") && await this.setupAudioStream((e = this.currentDevices.audio) == null ? void 0 : e.deviceId), !this.audioTrack || !this.rawAudioTrack) {
        this.audioEnabled = !1, f.error("LocalMediaHandler::enableAudio:Setting up audio stream failed while enabling audio", {
          debuggingHint: "Refer to SelfController::mediaPermissionError log."
        });
        return;
      }
      this.audioEnabled = !0;
    } catch (t) {
      this.audioEnabled = !1, this.audioTrack = void 0, this.rawAudioTrack = void 0, f.error("LocalMediaHandler::enableAudio", { error: t }, !0);
    }
    this.audioTrack && (this.audioTrack.enabled = !0), this.rawAudioTrack && (this.rawAudioTrack.enabled = !0), !(this.permissions.audio === "ACCEPTED" || !this.audioEnabled) && (this.permissions.audio = "ACCEPTED", y.emit(
      v.MEDIA_PERMISSION_UPDATE,
      {
        message: this.permissions.audio,
        kind: "audio"
      }
    ));
  }
  async toggleAudio() {
    var e;
    if (this.permissions.audio === "DENIED") {
      this.audioEnabled = !1;
      return;
    }
    try {
      if ((!this.audioTrack || this.audioTrack.readyState === "ended") && await this.setupAudioStream((e = this.currentDevices.audio) == null ? void 0 : e.deviceId), !this.audioTrack || !this.rawAudioTrack) {
        this.audioEnabled = !1;
        return;
      }
      this.audioEnabled = !this.audioEnabled;
    } catch (t) {
      this.audioEnabled = !1, f.error("LocalMediaHandler::toggleAudio", { error: t }, !0);
    }
    this.audioTrack && (this.audioTrack.enabled = this.audioEnabled), this.rawAudioTrack && (this.rawAudioTrack.enabled = this.audioEnabled);
  }
  async toggleVideo() {
    var e;
    if (this.permissions.video === "DENIED") {
      this.videoEnabled = !1;
      return;
    }
    if (this.videoEnabled) {
      this.removeVideoTrack();
      return;
    }
    this.videoEnabled = !0;
    try {
      await this.setupVideoStream((e = this.currentDevices.video) == null ? void 0 : e.deviceId);
    } catch (t) {
      this.videoEnabled = !1;
    }
    this.videoTrack && (this.videoTrack.enabled = this.videoEnabled), this.rawVideoTrack && (this.rawVideoTrack.enabled = this.videoEnabled), !(this.permissions.video === "ACCEPTED" || !this.videoEnabled) && (this.permissions.video = "ACCEPTED", y.emit(
      v.MEDIA_PERMISSION_UPDATE,
      {
        message: this.permissions.video,
        kind: "video"
      }
    ));
  }
  async toggleScreenShare() {
    if (this.screenShareEnabled) {
      this.removeScreenShareTracks({
        audio: !!this.screenShareTracks.audio,
        video: !!this.screenShareTracks.video
      });
      return;
    }
    try {
      if (await this.setupScreenShareStreams(), this.screenShareEnabled = !0, this.permissions.screenshare === "ACCEPTED")
        return;
      this.permissions.screenshare = "ACCEPTED", y.emit(
        v.MEDIA_PERMISSION_UPDATE,
        {
          message: this.permissions.screenshare,
          kind: "screenshare"
        }
      );
    } catch (e) {
      this.screenShareEnabled = !1;
    }
  }
  getAllDevices() {
    return c(this, _e).availableDevices;
  }
  getDeviceById(e, t) {
    return c(this, _e).getDeviceById(e, t);
  }
  getAudioDevices() {
    return c(this, _e).getAudioDevices();
  }
  getVideoDevices() {
    return c(this, _e).getVideoDevices();
  }
  getSpeakerDevices() {
    return c(this, _e).getSpeakerDevices();
  }
  async onDeviceChange(e, t) {
    var s, i;
    (s = e == null ? void 0 : e.added) == null || s.forEach(async (n) => {
      n && (t || !Rr(n)) && (n.kind === "audioinput" ? (await this.setupAudioStream(n.deviceId), this.emit("AUDIO_TRACK_CHANGE")) : n.kind === "videoinput" ? (await this.setupVideoStream(n.deviceId), this.emit("VIDEO_TRACK_CHANGE")) : n.kind === "audiooutput" && await this.setupSpeaker(n.deviceId));
    }), (i = e == null ? void 0 : e.removed) == null || i.forEach(async (n) => {
      var a, o, d;
      n && ((M.hasFeature(N.DEVICE_REMOVE_EXP) || !ae.isChromiumBased()) && (n.kind === "audioinput" && n.deviceId === ((a = this.currentDevices.audio) == null ? void 0 : a.deviceId) ? (await this.setupAudioStream(), this.emit("AUDIO_TRACK_CHANGE")) : n.kind === "videoinput" && n.deviceId === ((o = this.currentDevices.video) == null ? void 0 : o.deviceId) && (await this.setupVideoStream(), this.emit("VIDEO_TRACK_CHANGE"))), n.kind === "audiooutput" && n.deviceId === ((d = this.currentDevices.speaker) == null ? void 0 : d.deviceId) && await this.setupSpeaker());
    });
  }
  async updateDevices() {
    var o, d;
    if (ae.getName() === "firefox")
      return;
    const e = "microphone", t = "camera", s = await ((o = navigator == null ? void 0 : navigator.permissions) == null ? void 0 : o.query({ name: e })), i = await ((d = navigator == null ? void 0 : navigator.permissions) == null ? void 0 : d.query({ name: t })), n = (p, l) => {
      this.permissions[p] = l;
      const u = { message: this.permissions[p], kind: p };
      l === "DENIED" ? y.emit(v.MEDIA_PERMISSION_ERROR, u) : y.emit(v.MEDIA_PERMISSION_UPDATE, u);
    }, a = (p, l) => {
      switch (l) {
        case "granted":
          n(p, "ACCEPTED");
          break;
        case "denied":
          n(p, "DENIED");
          break;
      }
      c(this, _e).repopulateAvailableDevices();
    };
    s && (s.onchange = () => a("audio", s.state)), i && (i.onchange = () => a("video", i.state));
  }
  static async init(e) {
    const t = await tt.init(), s = new Rp(
      t,
      e
    ), i = new ti(s);
    return s.mediaMiddlewareUtils = i, s;
  }
  emit(e, ...t) {
    return super.emit(e, ...t);
  }
  on(e, t) {
    return super.on(e, t);
  }
  async removeDocumentEventListeners() {
    document.removeEventListener("visibilitychange", this.onVisibilityChange);
  }
  /**
   * NOTE(callmetarush): Compatibility with Local media refactor
   */
  addAudioMiddleware(e) {
    return this.mediaMiddlewareUtils.addAudioMiddleware(e);
  }
  removeAudioMiddleware(e) {
    return this.mediaMiddlewareUtils.removeAudioMiddleware(
      e
    );
  }
  addVideoMiddleware(e) {
    return this.mediaMiddlewareUtils.addVideoMiddleware(
      e
    );
  }
  removeVideoMiddleware(e) {
    return this.mediaMiddlewareUtils.removeVideoMiddleware(
      e
    );
  }
  async enableVideo() {
    await this.toggleVideo();
  }
  async disableVideo() {
    await this.toggleVideo();
  }
  async enableScreenShare() {
    await this.toggleScreenShare();
  }
  async disableScreenShare() {
    await this.toggleScreenShare();
  }
  getCurrentDevices() {
    return this.currentDevices;
  }
  destruct() {
    this.mediaMiddlewareUtils.terminateMiddlewareWebWorker(), c(this, _e).destruct(), this.removeAllTracks(), this.removeAllListeners();
  }
}, _e = new WeakMap(), tr = new WeakMap(), Fl);
let we = Rp;
be([
  _.trace("OldMediaHandler.shouldReacquireTrack")
], we.prototype, "shouldReacquireTrack", 1);
be([
  _.trace("OldMediaHandler.removeMediaStreamTrackListeners")
], we.prototype, "removeMediaStreamTrackListeners", 1);
be([
  _.trace("OldMediaHandler.addMediaStreamTrackListeners")
], we.prototype, "addMediaStreamTrackListeners", 1);
be([
  _.trace("OldMediaHandler.setupAudioStream")
], we.prototype, "setupAudioStream", 1);
be([
  _.trace("OldMediaHandler.getPreferredDeviceId")
], we.prototype, "getPreferredDeviceId", 1);
be([
  _.trace("OldMediaHandler.setupVideoStream")
], we.prototype, "setupVideoStream", 1);
be([
  _.trace("OldMediaHandler.setupScreenShareStreams")
], we.prototype, "setupScreenShareStreams", 1);
be([
  _.trace("OldMediaHandler.setupSpeaker")
], we.prototype, "setupSpeaker", 1);
be([
  _.trace("OldMediaHandler.getOperationalWebcamDeviceId")
], we.prototype, "getOperationalWebcamDeviceId", 1);
be([
  _.trace("OldMediaHandler.getOperationalMicDeviceId")
], we.prototype, "getOperationalMicDeviceId", 1);
be([
  _.trace("OldMediaHandler.setupStreams")
], we.prototype, "setupStreams", 1);
be([
  _.trace("OldMediaHandler.stopAudioTrack")
], we.prototype, "stopAudioTrack", 1);
be([
  _.trace("OldMediaHandler.stopVideoTrack")
], we.prototype, "stopVideoTrack", 1);
be([
  _.trace("OldMediaHandler.stopScreenShareTracks")
], we.prototype, "stopScreenShareTracks", 1);
be([
  _.trace("OldMediaHandler.removeAudioTrack")
], we.prototype, "removeAudioTrack", 1);
be([
  _.trace("OldMediaHandler.removeVideoTrack")
], we.prototype, "removeVideoTrack", 1);
be([
  _.trace("OldMediaHandler.removeScreenShareTracks")
], we.prototype, "removeScreenShareTracks", 1);
be([
  _.trace("OldMediaHandler.removeAllTracks")
], we.prototype, "removeAllTracks", 1);
be([
  _.trace("OldMediaHandler.setAudioTrack")
], we.prototype, "setAudioTrack", 1);
be([
  _.trace("OldMediaHandler.setVideoTrack")
], we.prototype, "setVideoTrack", 1);
be([
  _.trace("OldMediaHandler.setScreenShareTracks")
], we.prototype, "setScreenShareTracks", 1);
be([
  _.trace("OldMediaHandler::disableAudio")
], we.prototype, "disableAudio", 1);
be([
  _.trace("OldMediaHandler::enableAudio")
], we.prototype, "enableAudio", 1);
be([
  _.trace("OldMediaHandler.toggleAudio")
], we.prototype, "toggleAudio", 1);
be([
  _.trace("OldMediaHandler.toggleVideo")
], we.prototype, "toggleVideo", 1);
be([
  _.trace("OldMediaHandler.toggleScreenShare")
], we.prototype, "toggleScreenShare", 1);
class jb extends Ue {
  constructor() {
    super(...arguments);
    h(this, "localMediaHandler");
  }
  async init(t = {}) {
    var s, i;
    if (ae.init(), !this.localMediaHandler)
      try {
        let n = !0;
        const a = t.constraints || Nt;
        if (ue.defaults.mediaHandler)
          n = !1, this.localMediaHandler = ue.defaults.mediaHandler.localMediaHandler;
        else if (navigator.RNLocalMediaHandlerImpl) {
          const { RNLocalMediaHandlerImpl: o } = navigator;
          this.localMediaHandler = await o.init();
        } else
          M.hasFeature(N.NEW_LOCAL_MEDIA_HANDLER) ? this.localMediaHandler = new os(a) : this.localMediaHandler = await we.init(a);
        n && await this.localMediaHandler.setupStreams({
          video: (s = t == null ? void 0 : t.video) != null ? s : !0,
          audio: (i = t == null ? void 0 : t.audio) != null ? i : !0
        });
      } catch (n) {
        f.error(
          "DyteSelf::init::Failed To Setup Streams",
          {
            error: { name: n.name, message: n.message }
          }
        );
      }
  }
  /**
   * Returns the `audioTrack`.
   */
  get audioTrack() {
    return this.localMediaHandler.audioTrack;
  }
  /**
   * Returns the `rawAudioTrack` having no middleware executed on it.
   */
  get rawAudioTrack() {
    return this.localMediaHandler.rawAudioTrack;
  }
  /**
   * Adds the audio middleware to be executed on the raw audio stream.
   * If there are more than 1 audio middlewares,
   * they will be executed in the sequence they were added in.
   * If you want the sequence to be altered, please remove all previous middlewares and re-add.
   */
  async addAudioMiddleware(t) {
    return this.localMediaHandler.addAudioMiddleware(
      t
    );
  }
  /**
  * Removes the audio middleware, if it is there.
  */
  async removeAudioMiddleware(t) {
    return this.localMediaHandler.removeAudioMiddleware(
      t
    );
  }
  /**
   * Returns the `videoTrack`.
   */
  get videoTrack() {
    return this.localMediaHandler.videoTrack;
  }
  /**
   * Returns the `videoTrack` having no middleware executed on it.
   */
  get rawVideoTrack() {
    return this.localMediaHandler.rawVideoTrack;
  }
  /**
   * Adds the video middleware to be executed on the raw video stream.
   * If there are more than 1 video middlewares,
   * they will be executed in the sequence they were added in.
   * If you want the sequence to be altered, please remove all previous middlewares and re-add.
   */
  async addVideoMiddleware(t) {
    return this.localMediaHandler.addVideoMiddleware(
      t
    );
  }
  /**
   * Removes the video middleware, if it is there.
   */
  async removeVideoMiddleware(t) {
    return this.localMediaHandler.removeVideoMiddleware(
      t
    );
  }
  /**
   * Returns the screen share tracks.
   */
  get screenShareTracks() {
    return this.localMediaHandler.screenShareTracks;
  }
  /**
   * Returns true if audio is enabled.
   */
  get audioEnabled() {
    return this.localMediaHandler.audioEnabled;
  }
  /**
   * Returns true if video is enabled.
   */
  get videoEnabled() {
    return this.localMediaHandler.videoEnabled;
  }
  /**
   * Returns true if screen share is enabled.
   */
  get screenShareEnabled() {
    return this.localMediaHandler.screenShareEnabled;
  }
  async enableAudio() {
    await this.localMediaHandler.enableAudio(), this.emit("audioUpdate", {
      audioEnabled: this.audioEnabled,
      audioTrack: this.audioTrack
    });
  }
  async enableVideo() {
    await this.localMediaHandler.enableVideo(), this.emit("videoUpdate", {
      videoEnabled: this.videoEnabled,
      videoTrack: this.videoTrack
    });
  }
  async disableAudio() {
    await this.localMediaHandler.disableAudio(), this.emit("audioUpdate", {
      audioEnabled: this.audioEnabled,
      audioTrack: this.audioTrack
    });
  }
  async disableVideo() {
    await this.localMediaHandler.disableVideo(), this.emit("videoUpdate", {
      videoEnabled: this.videoEnabled,
      videoTrack: this.videoTrack
    });
  }
  /**
   * Returns the media devices currently being used.
   */
  getCurrentDevices() {
    return this.localMediaHandler.getCurrentDevices();
  }
  /**
   * Returns the local participant's audio devices.
   */
  async getAudioDevices() {
    return await this.localMediaHandler.getAudioDevices();
  }
  /**
   * Returns the local participant's video devices.
   */
  async getVideoDevices() {
    return await this.localMediaHandler.getVideoDevices();
  }
  /**
   * Returns the local participant's speaker devices.
   */
  async getSpeakerDevices() {
    return await this.localMediaHandler.getSpeakerDevices();
  }
  /**
   * Returns the local participant's device, indexed by ID and kind.
   * @param deviceId The ID of the device.
   * @param kind The kind of the device: audio, video, or speaker.
   */
  getDeviceById(t, s) {
    let i;
    return s === "audio" ? i = "audioinput" : s === "video" ? i = "videoinput" : s === "speaker" && (i = "audiooutput"), this.localMediaHandler.getDeviceById(t, i);
  }
  /**
   * Change the current media device that is being used by the local participant.
   * @param device The device that is to be used. A device of the same `kind` will be replaced.
   * the primary stream.
   */
  async setDevice(t) {
    const s = {
      added: [t],
      removed: []
    };
    if ("onDeviceChange" in this.localMediaHandler) {
      await this.localMediaHandler.onDeviceChange(s, !0);
      return;
    }
    switch (t.kind) {
      case "audioinput":
        try {
          await this.localMediaHandler.setAudioDevice(t);
        } catch (i) {
        } finally {
          this.emit("audioUpdate", {
            audioEnabled: this.audioEnabled,
            audioTrack: this.audioTrack
          });
        }
        break;
      case "audiooutput":
        await this.localMediaHandler.setSpeakerDevice(t);
        break;
      case "videoinput":
        try {
          await this.localMediaHandler.setVideoDevice(t);
        } catch (i) {
        } finally {
          this.emit("videoUpdate", {
            videoEnabled: this.videoEnabled,
            videoTrack: this.videoTrack
          });
        }
        break;
    }
    this.emit("deviceUpdate", {
      device: t
    });
  }
}
var $b = Object.defineProperty, Hb = Object.getOwnPropertyDescriptor, dt = (r, e, t, s) => {
  for (var i = s > 1 ? void 0 : s ? Hb(e, t) : e, n = r.length - 1, a; n >= 0; n--)
    (a = r[n]) && (i = (s ? a(e, t, i) : a(i)) || i);
  return s && i && $b(e, t, i), i;
}, Je = /* @__PURE__ */ ((r) => (r.OFF_STAGE = "OFF_STAGE", r.REQUESTED_TO_JOIN_STAGE = "REQUESTED_TO_JOIN_STAGE", r.ACCEPTED_TO_JOIN_STAGE = "ACCEPTED_TO_JOIN_STAGE", r.ON_STAGE = "ON_STAGE", r))(Je || {}), Mr, Ds, hs, Pi, Cn, ie, oe, jl;
let qe = (jl = class extends jb {
  constructor(e, t, s, i, n) {
    var a;
    super();
    // eslint-disable-next-line class-methods-use-this
    b(this, ie);
    h(this, "id");
    h(this, "name");
    h(this, "picture");
    h(this, "clientSpecificId");
    h(this, "waitlistStatus");
    b(this, Mr, void 0);
    b(this, Ds, void 0);
    b(this, hs, void 0);
    b(this, Pi, void 0);
    h(this, "role");
    h(this, "userId");
    h(this, "organizationId");
    h(this, "supportsRemoteControl", !1);
    h(this, "device");
    b(this, Cn, "OFF_STAGE");
    h(this, "stageStatus");
    /* Name of the preset used to join the meeting */
    h(this, "presetName");
    /**
     * Returns the current state of room
     * init - Inital State
     * joined - User is in the meeting
     * waitlisted - User is in the waitlist state
     * rejected - User's was in the waiting room, but the entry was rejected
     * kicked - A priveleged user removed the user from the meeting
     * left - User left the meeting
     * ended - The meeting was ended
     */
    h(this, "roomState", "init");
    this.id = e, this.userId = t.id, this.name = t.name, this.picture = t.picture, this.clientSpecificId = (a = t.customParticipantId) != null ? a : t.clientSpecificId, this.waitlistStatus = "none", P(this, hs, s), P(this, Ds, i), P(this, Pi, !1), this.organizationId = t.organizationId, this.supportsRemoteControl = ae.isElectron(), this.device = ae.getDeviceInfo(), this.presetName = n, P(this, Mr, te.isV2AuthToken ? i.viewType : s.viewType);
  }
  static async __init__(e, t, s, i, n) {
    var p, l, u, m;
    let a = (l = (p = ue.defaults) == null ? void 0 : p.audio) != null ? l : !0, o = (m = (u = ue.defaults) == null ? void 0 : u.video) != null ? m : !0;
    s.canProduceAudio !== "ALLOWED" && (a = !1), s.canProduceVideo !== "ALLOWED" && (o = !1);
    const d = new qe(
      e,
      t,
      s,
      i,
      n
    );
    return await d.init({
      audio: a,
      video: o
    }), d.setupEvents(), d;
  }
  setupEvents() {
    y.on(v.ROOM_NODE_CONNECTED, async () => {
      c(this, ie, oe).isDisconnected && await this.resetSelf(), c(this, ie, oe).isDisconnected = !1, f.info("DyteSelf::ROOM_NODE_CONNECTED");
    }), y.on(v.RESET_PRODUCER_STATE, async () => {
      this.roomJoined && c(this, ie, oe) instanceof z && (this.localMediaHandler.videoEnabled && await c(this, ie, oe).shareWebcam(this.localMediaHandler.videoTrack), this.localMediaHandler.audioEnabled && await c(this, ie, oe).shareMic(this.localMediaHandler.audioTrack), this.localMediaHandler.screenShareEnabled && await c(this, ie, oe).shareScreen({
        video: this.localMediaHandler.screenShareTracks.video,
        audio: this.localMediaHandler.screenShareTracks.audio
      }));
    }), this.localMediaHandler.on("AUDIO_TRACK_CHANGE", async () => {
      if (f.info("DyteSelf::setupEvents::AUDIO_TRACK_CHANGE", {
        ...kr(this)
      }), this.roomJoined && this.audioEnabled)
        try {
          await c(this, ie, oe).shareMic(this.audioTrack);
        } catch (e) {
          f.error("DyteSelf::setupEvents::Error while sharing mic", {
            error: e
          }), this.localMediaHandler.disableAudio();
        }
      this.emit("audioUpdate", {
        audioEnabled: this.audioEnabled,
        audioTrack: this.audioTrack
      });
    }), this.localMediaHandler.on("VIDEO_TRACK_CHANGE", async () => {
      if (f.info("DyteSelf::setupEvents::VIDEO_TRACK_CHANGE", {
        ...kr(this)
      }), this.videoEnabled && this.roomJoined)
        try {
          await c(this, ie, oe).shareWebcam(this.videoTrack);
        } catch (e) {
          f.error("DyteSelf::setupEvents::failed shareWebcam", {
            error: e
          }), this.videoEnabled && await this.localMediaHandler.disableVideo();
        }
      this.emit("videoUpdate", {
        videoEnabled: this.videoEnabled,
        videoTrack: this.videoTrack
      });
    }), this.localMediaHandler.on("DEVICE_CHANGE", async ({ device: e }) => {
      this.emit("deviceUpdate", {
        device: e
      });
    }), this.localMediaHandler.on("SCREENSHARE_TRACK_CHANGE", async () => {
      if (!this.roomJoined) {
        f.error("DyteSelf.SCREENSHARE_TRACK_CHANGE.LocalMediaInitialized_WithoutRoomNode");
        return;
      }
      if (this.screenShareEnabled)
        try {
          await c(this, ie, oe).shareScreen(this.screenShareTracks);
        } catch (e) {
          f.error("DyteSelf::setupEvents::Error while sharing screen", {
            error: e
          }), this.screenShareEnabled && await this.localMediaHandler.disableScreenShare();
        }
      f.info("DyteSelf::setupEvents::SCREENSHARE_TRACK_CHANGE", {
        ...kr(this)
      }), this.emit("screenShareUpdate", {
        screenShareEnabled: this.screenShareEnabled,
        screenShareTracks: this.screenShareTracks
      });
    }), this.localMediaHandler.on("SCREENSHARE_ENDED", async () => {
      await this.disableScreenShare(), f.info("DyteSelf::setupEvents::SCREENSHARE_ENDED", {
        ...kr(this)
      });
    }), this.localMediaHandler.on("AUDIO_TRACK_SILENT", () => {
      this.emit("audioTrackSilent"), A.mediaTrackMuted("AUDIO");
    }), this.localMediaHandler.on("FORCE_MUTE_AUDIO", this.disableAudio), this.localMediaHandler.on("FORCE_MUTE_VIDEO", async () => {
      this.roomJoined && await c(this, ie, oe).pauseWebcam(), this.emit("videoUpdate", {
        videoEnabled: this.videoEnabled,
        videoTrack: this.videoTrack
      }), A.videoOff();
    });
  }
  /**
   * Returns the current audio and video permissions given by the user.
   * 'ACCEPTED' if the user has given permission to use the media.
   * 'DENIED' if the user has denied permission to use the media.
   * 'SYS_DENIED' if the user's system has denied permission to use the media.
   * 'UNAVAILABLE' if the media is not available (or being used by a different application).
   */
  get mediaPermissions() {
    return this.localMediaHandler.permissions;
  }
  /**
   * Returns the current permission given to the user for the meeting.
   */
  get permissions() {
    return c(this, hs);
  }
  /**
   * @deprecated use 'config'
   * Returns suggested theme for the meeting.
   */
  get suggestedTheme() {
    return c(this, Ds);
  }
  /**
   * Returns configuration for the meeting.
   */
  get config() {
    return c(this, Ds);
  }
  /**
   * Returns true if the local participant has joined the meeting.
   */
  get roomJoined() {
    var e;
    return ((e = c(this, ie, oe)) == null ? void 0 : e.roomJoined) === !0;
  }
  /**
   * The name of the user can be set by calling this method.
   * This will get reflected to other participants ONLY if
   * this method is called before the room is joined.
   * @param name Name of the user.
   */
  setName(e) {
    if (!e)
      throw new E("Name cannot be empty.");
    this.name = e;
  }
  async setupTracks(e = {}) {
    var t, s;
    return e.forceReset && (c(this, ie, oe).stopAllProducers(), this.localMediaHandler.removeAllTracks()), this.localMediaHandler.setupStreams({
      video: (t = e.video) != null ? t : !0,
      audio: (s = e.audio) != null ? s : !0
    });
  }
  async resetSelf() {
    var e, t, s, i, n, a, o, d, p, l;
    A.callEnded(), (s = (t = (e = c(this, ie, oe)) == null ? void 0 : e.sfuHandler) == null ? void 0 : t.cleanupConsumers) == null || s.call(t), await ((a = (n = (i = c(this, ie, oe)) == null ? void 0 : i.sfuHandler) == null ? void 0 : n.setupTransports) == null ? void 0 : a.call(n)), await ((o = c(this, ie, oe)) == null ? void 0 : o.joinRoom(
      this.name,
      !this.localMediaHandler.audioEnabled,
      c(this, ie, oe).roomUUID,
      c(this, ie, oe).meetingTitle,
      {
        audio: this.localMediaHandler.audioEnabled,
        video: this.localMediaHandler.videoEnabled,
        screen: this.localMediaHandler.screenShareEnabled
      }
    )), this.localMediaHandler.videoEnabled && await ((d = c(this, ie, oe)) == null ? void 0 : d.shareWebcam(this.localMediaHandler.videoTrack)), this.localMediaHandler.audioEnabled && await ((p = c(this, ie, oe)) == null ? void 0 : p.shareMic(this.localMediaHandler.audioTrack)), this.localMediaHandler.screenShareEnabled && await ((l = c(this, ie, oe)) == null ? void 0 : l.shareScreen({
      video: this.localMediaHandler.screenShareTracks.video,
      audio: this.localMediaHandler.screenShareTracks.audio
    })), f.info("DyteSelf::resetSelf");
  }
  async destructMediaHandler() {
    return f.info("DyteSelf::destructMediaHandler"), this.localMediaHandler.destruct();
  }
  async removeDocumentEventListeners() {
    return f.info("DyteSelf::removeDocumentEventListeners"), this.localMediaHandler.removeDocumentEventListeners();
  }
  async enableAudio() {
    if (this.permissions.canProduceAudio !== wr.notAllowed && !(c(this, Ds).viewType === "WEBINAR" && c(this, hs).canProduceAudio === wr.canRequest && (this.webinarStageStatus === "OFF_STAGE" || this.webinarStageStatus === "REQUESTED_TO_JOIN_STAGE")) && !this.audioEnabled) {
      if (await this.localMediaHandler.enableAudio(), this.roomJoined) {
        if (this.audioTrack)
          try {
            await c(this, ie, oe).shareMic(this.audioTrack);
          } catch (e) {
            f.error("DyteSelf::enableAudio::Error while sharing mic", {
              error: e
            }), this.localMediaHandler.disableAudio();
          }
        if (!this.audioEnabled)
          return;
        c(this, ie, oe).unmuteSelf();
      }
      this.emit("audioUpdate", {
        audioEnabled: this.audioEnabled,
        audioTrack: this.audioTrack
      }), A.audioOn();
    }
  }
  async enableVideo() {
    if (c(this, hs).canProduceVideo !== wr.notAllowed && !(c(this, Ds).viewType === "WEBINAR" && c(this, hs).canProduceVideo === wr.canRequest && (this.webinarStageStatus === "OFF_STAGE" || this.webinarStageStatus === "REQUESTED_TO_JOIN_STAGE")) && !this.videoEnabled) {
      if (await this.localMediaHandler.enableVideo(), this.roomJoined)
        try {
          await c(this, ie, oe).shareWebcam(this.videoTrack);
        } catch (e) {
          f.error("DyteSelf::enableVideo::Error while sharing video", {
            error: e
          }), this.videoEnabled && await this.localMediaHandler.disableVideo();
        }
      this.emit("videoUpdate", {
        videoEnabled: this.videoEnabled,
        videoTrack: this.videoTrack
      }), f.info("DyteSelf.enableVideo", {
        ...kr(this)
      }), A.videoOn();
    }
  }
  async enableScreenShare() {
    if (!this.roomJoined)
      throw new E("Can`t enable screenshare without joining room");
    if (c(this, hs).canProduceScreenshare !== wr.notAllowed && !(c(this, Ds).viewType === "WEBINAR" && c(this, hs).canProduceScreenshare === wr.canRequest && (this.webinarStageStatus === "OFF_STAGE" || this.webinarStageStatus === "REQUESTED_TO_JOIN_STAGE")) && !this.screenShareEnabled) {
      if (await this.localMediaHandler.enableScreenShare(), this.screenShareTracks.audio || this.screenShareTracks.video)
        try {
          await c(this, ie, oe).shareScreen(this.screenShareTracks);
        } catch (e) {
          f.error("DyteSelf::enableScreenShare::Error while sharing screen", {
            error: e
          }), this.screenShareEnabled && await this.localMediaHandler.disableScreenShare();
        }
      this.emit("screenShareUpdate", {
        screenShareEnabled: this.screenShareEnabled,
        screenShareTracks: this.screenShareTracks
      });
    }
  }
  async disableAudio() {
    this.audioEnabled && (this.localMediaHandler.disableAudio(), this.roomJoined && c(this, ie, oe).muteSelf(), this.emit("audioUpdate", {
      audioEnabled: this.audioEnabled,
      audioTrack: this.audioTrack
    }), A.audioOff());
  }
  async disableVideo() {
    this.videoEnabled && (await this.localMediaHandler.disableVideo(), this.roomJoined && await c(this, ie, oe).pauseWebcam(), this.mediaPermissions.video === "ACCEPTED" && (this.emit("videoUpdate", {
      videoEnabled: this.videoEnabled,
      videoTrack: this.videoTrack
    }), A.videoOff()));
  }
  async disableScreenShare() {
    this.screenShareEnabled && (await this.localMediaHandler.disableScreenShare(), this.roomJoined && await c(this, ie, oe).disableScreenShare(), this.emit("screenShareUpdate", {
      screenShareEnabled: this.screenShareEnabled,
      screenShareTracks: this.screenShareTracks
    }));
  }
  /**
   * Returns all media devices accessible by the local participant.
   */
  getAllDevices() {
    return this.localMediaHandler.getAllDevices();
  }
  /**
   * @access private
   * Not for external use.
   */
  setIsPinned(e, t = !0) {
    P(this, Pi, e);
    const s = e ? "pinned" : "unpinned";
    t && this.emit(s, this);
  }
  /**
   * Returns true if the current user is pinned.
   */
  get isPinned() {
    return c(this, Pi);
  }
  /**
   * Returns webinar stage status for current user.
   */
  get webinarStageStatus() {
    return c(this, Cn);
  }
  /**
   * Returns `self.id` if user has permission
   * to pin participants.
   */
  async pin() {
    if (!this.roomJoined)
      throw new E("Can`t pin participants without joining room");
    return c(this, ie, oe).pinPeer(this.id);
  }
  /**
   * Returns `self.id` if user has permission
   * to unpin participants.
   */
  async unpin() {
    if (!this.roomJoined)
      throw new E("Can`t unpin participants without joining room");
    return c(this, ie, oe).pinPeer(null);
  }
  async setDevice(e) {
    const t = {
      added: [e],
      removed: []
    };
    if ("onDeviceChange" in this.localMediaHandler) {
      await this.localMediaHandler.onDeviceChange(t, !0);
      return;
    }
    switch (e.kind) {
      case "audioinput":
        try {
          await this.localMediaHandler.setAudioDevice(e);
        } catch (s) {
          this.roomJoined && await c(this, ie, oe).muteSelf(), this.emit("audioUpdate", {
            audioEnabled: this.audioEnabled,
            audioTrack: this.audioTrack
          });
        }
        break;
      case "audiooutput":
        await this.localMediaHandler.setSpeakerDevice(e);
        break;
      case "videoinput":
        try {
          await this.localMediaHandler.setVideoDevice(e);
        } catch (s) {
          this.roomJoined && await c(this, ie, oe).pauseWebcam(), this.emit("videoUpdate", {
            videoEnabled: this.videoEnabled,
            videoTrack: this.videoTrack
          });
        }
        break;
    }
    this.emit("deviceUpdate", {
      device: e
    });
  }
  cleanUpTracks() {
    var e, t, s, i;
    (e = this.audioTrack) == null || e.stop(), (t = this.rawAudioTrack) == null || t.stop(), (s = this.videoTrack) == null || s.stop(), (i = this.rawVideoTrack) == null || i.stop();
  }
  async requestToJoinStage() {
    if (!this.roomJoined)
      throw new E("Can`t request to join stage without joining room");
    if (c(this, Mr) !== is.Webinar)
      throw new E("Not allowed to go on stage on non webinar meeting");
    if (!this.permissions.requestProduce)
      throw f.error("DyteSelf::requestGoToStage::permission_denied"), new E("User does not have permission to go on stage");
    await c(this, ie, oe).requestToJoinStage($c.PRESENT), this.setWebinarStageStatus(
      "REQUESTED_TO_JOIN_STAGE"
      /* REQUESTED_TO_JOIN_STAGE */
    );
  }
  async withdrawRequestToJoinStage() {
    if (!this.roomJoined)
      throw new E("Can`t request to join stage without joining room");
    if (c(this, Mr) !== is.Webinar)
      throw new E("Not allowed to go on stage on non webinar meeting");
    this.webinarStageStatus === "REQUESTED_TO_JOIN_STAGE" && (await c(this, ie, oe).withdrawRequestToJoinStage(), this.setWebinarStageStatus(
      "OFF_STAGE"
      /* OFF_STAGE */
    ));
  }
  async leaveStage() {
    if (!this.roomJoined)
      throw new E("Can`t leave stage without joining room");
    if (c(this, Mr) !== is.Webinar)
      throw new E("Not allowed to leave stage on non webinar meeting");
    await this.disableScreenShare(), await this.disableVideo(), await this.disableAudio(), this.localMediaHandler.destruct(), await c(this, ie, oe).stopPresenting(), this.setWebinarStageStatus(
      "OFF_STAGE"
      /* OFF_STAGE */
    );
  }
  async joinStage() {
    if (!this.roomJoined)
      throw new E("Can`t join stage without joining room");
    if (!this.permissions.canPresent && this.webinarStageStatus !== "ACCEPTED_TO_JOIN_STAGE")
      throw f.error("DyteSelf::joinStage::permission_denied"), new E("User does not have permission to join stage");
    await c(this, ie, oe).startPresenting();
  }
  setWebinarStageStatus(e) {
    switch (P(this, Cn, e), e) {
      case "REQUESTED_TO_JOIN_STAGE":
        this.emit("peerRequestToJoinStage");
        break;
      case "OFF_STAGE":
        this.emit("stageLeft");
        break;
    }
  }
  async disablePreview() {
    return this;
  }
}, Mr = new WeakMap(), Ds = new WeakMap(), hs = new WeakMap(), Pi = new WeakMap(), Cn = new WeakMap(), ie = new WeakSet(), oe = function() {
  return Be();
}, jl);
dt([
  _.trace("DyteSelf.setupEvents")
], qe.prototype, "setupEvents", 1);
dt([
  _.trace("DyteSelf.setupTracks")
], qe.prototype, "setupTracks", 1);
dt([
  _.trace("DyteSelf.resetSelf")
], qe.prototype, "resetSelf", 1);
dt([
  _.trace("DyteSelf.destructMediaHandler")
], qe.prototype, "destructMediaHandler", 1);
dt([
  _.trace("DyteSelf.removeDocumentEventListeners")
], qe.prototype, "removeDocumentEventListeners", 1);
dt([
  _.trace("DyteSelf.enableAudio")
], qe.prototype, "enableAudio", 1);
dt([
  _.trace("DyteSelf.enableVideo")
], qe.prototype, "enableVideo", 1);
dt([
  _.trace("DyteSelf.enableScreenShare")
], qe.prototype, "enableScreenShare", 1);
dt([
  _.trace("DyteSelf.disableAudio")
], qe.prototype, "disableAudio", 1);
dt([
  _.trace("DyteSelf.disableVideo")
], qe.prototype, "disableVideo", 1);
dt([
  _.trace("DyteSelf.disableScreenShare")
], qe.prototype, "disableScreenShare", 1);
dt([
  _.trace("DyteSelf.setDevice")
], qe.prototype, "setDevice", 1);
dt([
  _.trace("DyteSelf.requestToJoinStage")
], qe.prototype, "requestToJoinStage", 1);
dt([
  _.trace("DyteSelf.withdrawRequestToJoinStage")
], qe.prototype, "withdrawRequestToJoinStage", 1);
dt([
  _.trace("DyteSelf.leaveStage")
], qe.prototype, "leaveStage", 1);
dt([
  _.trace("DyteSelf.joinStage")
], qe.prototype, "joinStage", 1);
dt([
  _.trace("DyteSelf.deprecated.disablePreview")
], qe.prototype, "disablePreview", 1);
qe = dt([
  ft((r) => {
    throw new E(r.message, "1100");
  })
], qe);
class Bb {
  constructor(e) {
    h(this, "socket");
    this.socket = e;
  }
  set onReconnect(e) {
    this.socket.onStateEvent("reconnected", e);
  }
  async joinRoom(e, t, s, i) {
    const n = {
      capabilities: [],
      peer: {
        displayName: e,
        peerId: t,
        userId: s
      },
      roomUuid: i
    }, a = gS.fromBinary(
      (await this.socket.sendMessagePromise(
        ce.joinRoom,
        RS.toBinary(n)
      )).payload
    );
    await y.emitAsync(v.SOCKET_SERVICE_ROOM_JOINED, a);
    try {
      const { room: o } = await this.getRoomState();
      y.emit(v.ROOM_STATE, o);
    } catch (o) {
      f.error("RoomSocketHandler.joinRoom.failedToGetRoomState", {
        error: o
      });
    }
  }
  async getRoomState() {
    let e = fl.create();
    try {
      const t = await this.socket.sendMessagePromise(ce.getRoomInfo);
      e = fl.fromBinary(t.payload);
    } catch (t) {
      f.error("getRoomState::binary_decode_error", { error: t });
    }
    return e;
  }
  leaveRoom() {
    this.socket.sendMessage(
      ce.leaveRoom,
      PS.toBinary({})
    );
  }
}
function qb(r) {
  if (!te.isV2AuthToken)
    return !1;
  const e = r;
  return [e.canProduceAudio, e.canProduceScreenshare, e.canProduceVideo].includes(ot.Allowed);
}
function bp(r) {
  return M.hasFeature(N.LIVESTREAM) ? r.viewType !== "LIVESTREAM" : !0;
}
var Gb = Object.defineProperty, Wb = Object.getOwnPropertyDescriptor, sa = (r, e, t, s) => {
  for (var i = s > 1 ? void 0 : s ? Wb(e, t) : e, n = r.length - 1, a; n >= 0; n--)
    (a = r[n]) && (i = (s ? a(e, t, i) : a(i)) || i);
  return s && i && Gb(e, t, i), i;
}, Or, je, Ye, $l;
const Pp = ($l = class {
  /**
   * Use await SelfController.init(roomNodeClient) instead
   */
  constructor(r, e) {
    // eslint-disable-next-line class-methods-use-this
    b(this, je);
    h(this, "self");
    h(this, "authToken");
    h(this, "peerId");
    b(this, Or, void 0);
    h(this, "roomNodeSetupInProgress", !1);
    var t, s, i, n;
    P(this, Or, r), this.authToken = (s = (t = Be()) == null ? void 0 : t.authToken) != null ? s : r.authToken, this.peerId = (n = (i = Be()) == null ? void 0 : i.peerId) != null ? n : r.peerId, this.self = e, this.setupEvents();
  }
  /**
   * Returns true if the local participant has joined the meeting.
   */
  get roomJoined() {
    var r;
    return ((r = c(this, je, Ye)) == null ? void 0 : r.roomJoined) === !0;
  }
  static async init(r, e, t, s, i) {
    var p, l;
    const n = ct(), { isV2AuthToken: a } = te, o = await qe.__init__(
      (l = (p = Be()) == null ? void 0 : p.peerId) != null ? l : r.peerId,
      te.isV2AuthToken ? e.participant : e,
      t,
      s,
      i
    ), d = a ? e.participant.organizationId : e.organizationId;
    if (_.meetingMetadata.organizationId = d, M.hasFeature(N.INTERNAL_CALL_STATS) && navigator.product !== "ReactNative") {
      M.getValue(N.CALLSTATS_INGESTION_LAYER);
      let u = "dev";
      ue.apiBase.indexOf("cluster.dyte") > -1 ? u = "production" : ue.apiBase.indexOf("staging.dyte") > -1 && (u = "staging"), setTimeout(async () => {
        var m, g;
        A.initialize({
          peerId: (g = (m = Be()) == null ? void 0 : m.peerId) != null ? g : r.peerId,
          engineName: ae.getDeviceInfo().engineName,
          env: u,
          iceServers: await n.getICEServers(),
          apiBase: ue.apiBase,
          flags: M.getAllFlags(),
          logger: f
        });
      });
    }
    return new Pp(r, o);
  }
  async shareMediaTracks() {
    await Promise.all([
      this.self.videoTrack && c(this, je, Ye).shareWebcam(this.self.videoTrack),
      this.self.audioTrack && c(this, je, Ye).shareMic(this.self.audioTrack)
    ]);
  }
  setupEvents() {
    y.on(v.DISABLE_AUDIO, async () => {
      this.self.audioEnabled && (await this.self.disableAudio(), A.audioOff());
    }), y.on(v.DISABLE_VIDEO, async () => {
      this.self.videoEnabled && (await this.self.disableVideo(), A.videoOff());
    }), y.on(v.MUTE_ALL, async () => {
      this.self.audioEnabled && (await this.self.disableAudio(), A.audioOff());
    }), y.on(v.MUTE_ALL_VIDEO, async () => {
      this.self.videoEnabled && (await this.self.disableVideo(), A.videoOff());
    }), y.on(v.WAITLISTED, () => {
      this.self.waitlistStatus = "waiting", this.self.roomState = "waitlisted", this.self.emit("waitlisted");
    }), y.on(v.WAITLIST_ACCEPTED, async () => {
      if (this.self.waitlistStatus === "accepted") {
        f.warn("SelfController.WAITLIST_ACCEPTED.UserAlreadyAccepted");
        return;
      }
      this.self.waitlistStatus = "accepted", this.joinRoom();
    }), y.on(v.WAITLIST_REJECTED, async () => {
      if (this.self.waitlistStatus === "rejected") {
        f.warn("SelfController.WAITLIST_REJECTED.UserAlreadyRejected");
        return;
      }
      this.self.waitlistStatus = "rejected", this.leaveRoom("rejected");
    }), y.on(v.KICKED, async (r) => {
      let e = "kicked";
      (r == null ? void 0 : r.kickType) === "kickAll" && (e = "ended"), this.leaveRoom(e);
    }), y.on(v.SELF_ROOM_JOINED, () => {
      this.self.config.viewType === "WEBINAR" && this.self.permissions.canPresent && this.self.joinStage(), this.self.roomState = "joined", this.self.emit("roomJoined");
    }), y.on(v.SOCKET_SERVICE_ROOM_JOINED, () => {
      this.self.emit("socketServiceRoomJoined");
    }), y.on(v.MEDIA_PERMISSION_UPDATE, (r) => {
      this.self.emit("mediaPermissionUpdate", r);
    }), y.on(v.MEDIA_PERMISSION_ERROR, async (r) => {
      const { kind: e, message: t } = r;
      e === "audio" ? (A.mediaPermission("AUDIO", $o(t)), this.self.disableAudio()) : e === "video" ? (A.mediaPermission("VIDEO", $o(t)), this.self.disableVideo()) : e === "screenshare" && (A.mediaPermission("VIDEO", $o(t)), this.self.disableScreenShare()), f.error("SelfController::mediaPermissionError", {
        error: { message: r.message },
        constraints: r.constraints,
        mediaPermissionsErrors: {
          kind: e,
          message: t
        }
      }), this.self.emit("mediaPermissionError", r), this.self.emit("mediaPermissionUpdate", { message: t, kind: e });
    }), y.on(v.REQUEST_TO_JOIN_STAGE_ACCEPTED, () => {
      this.self.setWebinarStageStatus(Je.ACCEPTED_TO_JOIN_STAGE), this.self.emit("joinStageRequestAccepted");
    }), y.on(v.REQUEST_TO_JOIN_STAGE_REJECTED, () => {
      this.self.setWebinarStageStatus(Je.OFF_STAGE), this.self.emit("joinStageRequestRejected");
    }), y.on(v.REMOVED_FROM_STAGE, async () => {
      this.self.setWebinarStageStatus(Je.OFF_STAGE), await this.self.disableScreenShare(), await this.self.disableVideo(), await this.self.disableAudio(), this.self.destructMediaHandler(), this.self.emit("removedFromStage");
    }), y.on(v.STARTED_PRESENTING, () => {
      this.self.setWebinarStageStatus(Je.ON_STAGE), this.self.emit("stageJoined");
    }), y.on(v.STOPPED_PRESENTING, () => {
      this.self.setWebinarStageStatus(Je.OFF_STAGE), this.self.emit("stageLeft");
    }), y.on(v.PRODUCER_SCORE_UPDATE, ({ score: r, kind: e, appData: t }) => {
      var i;
      const s = e === "video" && ((i = t == null ? void 0 : t.screenShare) != null ? i : !1);
      this.self.emit("mediaScoreUpdate", { kind: e, isScreenshare: s, score: r });
    }), y.on(v.PRODUCER_STATUS_UPDATE, ({ status: r }) => {
      this.self.emit("mediaChannelUpdate", { status: r });
    }), y.onAsync(v.JOIN_MEDIA_ROOM, this.setupRoomNode.bind(this)), y.onAsync(v.LEAVE_MEDIA_ROOM, this.leaveMediaRoom.bind(this));
  }
  async setupRoomNode() {
    var t, s, i;
    if (this.roomNodeSetupInProgress) {
      f.warn("SelfController.roomNodeSetupInProgress");
      return;
    }
    if ((t = c(this, je, Ye)) != null && t.roomJoined) {
      f.warn("SelfController.roomNodeAlreadySetup");
      return;
    }
    this.roomNodeSetupInProgress = !0;
    const r = te.roomNodeOptions;
    await vp({
      ...r,
      roomName: r.roomName,
      peerId: r.peerId
    });
    let e = "";
    if (c(this, je, Ye) instanceof fe) {
      await c(this, je, Ye).setupTransports();
      const n = await c(this, je, Ye).getRoomState();
      ({ roomUUID: e } = (i = (s = n == null ? void 0 : n.payload) == null ? void 0 : s.roomState) != null ? i : {}), ct().setRoomUUID(e);
    }
    await this.joinMediaRoom(e), this.roomNodeSetupInProgress = !1;
  }
  async joinRoom() {
    var r, e;
    try {
      const t = ct();
      let s = "";
      if (c(this, je, Ye) instanceof fe) {
        const n = await c(this, je, Ye).getRoomState();
        ({ roomUUID: s } = (e = (r = n == null ? void 0 : n.payload) == null ? void 0 : r.roomState) != null ? e : {}), t.setRoomUUID(s);
      }
      const i = new Bb(c(this, Or));
      (cp(
        this.self.config.viewType,
        c(this, Or).capabilities
      ) || En("chat_socket_server") === "socket-service") && (await i.joinRoom(
        this.self.name,
        this.self.id,
        this.self.userId,
        s
      ), i.socket.flush(), i.onReconnect = async () => {
        await i.joinRoom(
          this.self.name,
          this.self.id,
          this.self.userId,
          s
        ), i.socket.flush();
      }), bp(this.self.config) && await this.joinMediaRoom(s);
    } catch (t) {
      throw f.error("Error in joinRoom", { error: t }), t;
    }
  }
  async leaveRoom(r = "left") {
    var t;
    const { roomJoined: e } = this;
    await this.leaveMediaRoom();
    try {
      (t = c(this, Or)) == null || t.disconnect();
    } catch (s) {
      f.error("SelfController::leaveRoom::socketDisconnect");
    }
    this.self.roomState = r, cb(), !(this.self.config.viewType !== "LIVESTREAM" && !e) && this.self.emit("roomLeft", { state: r });
  }
  async joinMediaRoom(r) {
    var t, s, i, n;
    if ((t = c(this, je, Ye)) != null && t.isDisconnected && c(this, je, Ye) instanceof fe) {
      (s = c(this, je, Ye)) == null || s.reconnect();
      return;
    }
    const { roomJoined: e } = (n = await ((i = c(this, je, Ye)) == null ? void 0 : i.joinRoom(
      this.self.name,
      !this.self.audioEnabled,
      r,
      void 0,
      {
        audio: this.self.audioEnabled,
        video: this.self.videoEnabled,
        screen: this.self.screenShareEnabled
      }
    ))) != null ? n : {};
    c(this, je, Ye) instanceof z && (c(this, je, Ye).onSocketReconnection = this.joinMediaRoom.bind(this, r)), e && await this.shareMediaTracks();
  }
  async leaveMediaRoom() {
    await this.cleanupSelf(), c(this, je, Ye) && this.roomJoined && (await c(this, je, Ye).leaveRoom(), c(this, je, Ye).roomJoined = !1);
  }
  async cleanupSelf() {
    await this.self.disableAudio(), await this.self.disableVideo(), await this.self.disableScreenShare(), this.self.cleanUpTracks(), this.self.destructMediaHandler(), this.self.removeDocumentEventListeners();
  }
}, Or = new WeakMap(), je = new WeakSet(), Ye = function() {
  return Be();
}, $l);
let sn = Pp;
sa([
  _.trace("SelfController.setupEvents")
], sn.prototype, "setupEvents", 1);
sa([
  _.trace("SelfController.joinRoom")
], sn.prototype, "joinRoom", 1);
sa([
  _.trace("SelfController.leaveRoom")
], sn.prototype, "leaveRoom", 1);
sa([
  _.trace("SelfController.joinMediaRoom")
], sn.prototype, "joinMediaRoom", 1);
sa([
  _.trace("SelfController.leaveMediaRoom")
], sn.prototype, "leaveMediaRoom", 1);
var Jb = Object.defineProperty, Kb = Object.getOwnPropertyDescriptor, fr = (r, e, t, s) => {
  for (var i = s > 1 ? void 0 : s ? Kb(e, t) : e, n = r.length - 1, a; n >= 0; n--)
    (a = r[n]) && (i = (s ? a(e, t, i) : a(i)) || i);
  return s && i && Jb(e, t, i), i;
}, Ci, $t, ps, Nr, Hl;
let Jt = (Hl = class extends Ue {
  constructor(e, t) {
    super();
    // eslint-disable-next-line class-methods-use-this
    b(this, $t);
    /**
     * The peer ID of the participant.
     * The participants are indexed by this ID in the participant map.
     */
    h(this, "id");
    /**
     * The user ID of the participant.
     */
    h(this, "userId");
    /**
     * The name of the participant.
     */
    h(this, "name");
    /**
     * The picture of the participant.
     */
    h(this, "picture");
    h(this, "isHost");
    /**
     * The clientSpecificId of the participant.
     */
    h(this, "clientSpecificId");
    h(this, "flags");
    /**
     * The device configuration of the participant.
     */
    h(this, "device");
    /**
     * The participant's video track.
     */
    h(this, "videoTrack");
    /**
     * The participant's audio track.
     */
    h(this, "audioTrack");
    /**
     * The participant's screenshare video and audio track.
     */
    h(this, "screenShareTracks");
    /**
     * This is true if the participant's video is enabled.
     */
    h(this, "videoEnabled");
    /**
     * This is true if the participant's audio is enabled.
     */
    h(this, "audioEnabled");
    /**
     * This is true if the participant is screensharing.
     */
    h(this, "screenShareEnabled");
    /**
     * producers created by participant
    */
    h(this, "producers");
    /**
     * This is true if the participant is pinned.
     */
    b(this, Ci, void 0);
    /**
     * This is true if the dyte participant supports remote control.
     */
    h(this, "supportsRemoteControl", !1);
    /**
     * Represents the participants current webinar status
     */
    h(this, "webinarStageStatus", Je.OFF_STAGE);
    /**
     * The preset of the participant.
     */
    h(this, "presetName");
    b(this, Nr, void 0);
    const {
      id: s,
      userId: i,
      displayName: n,
      device: a,
      picture: o,
      isHost: d,
      flags: p,
      clientSpecificId: l,
      customParticipantId: u,
      audioMuted: m,
      audioTrack: g,
      videoEnabled: T = !1,
      videoTrack: S,
      producers: R,
      metadata: D
    } = e;
    this.id = s, this.userId = i, this.name = n, this.device = a, this.picture = o, this.isHost = d, this.flags = p, this.clientSpecificId = u != null ? u : l, this.audioEnabled = !m, this.audioTrack = g, this.videoEnabled = T, this.videoTrack = S, this.screenShareTracks = {
      audio: void 0,
      video: void 0
    }, this.producers = R != null ? R : [], this.presetName = D == null ? void 0 : D.preset_name, P(this, Ci, !1), P(this, Nr, t);
  }
  /**
   * Returns true if the local participant has joined the meeting.
   */
  get roomJoined() {
    var e;
    return ((e = c(this, $t, ps)) == null ? void 0 : e.roomJoined) === !0;
  }
  setVideoEnabled(e, t = !0) {
    this.videoEnabled = e, t && (f.info("DyteParticipant::setVideoEnabled::videoUpdate", {
      ...kr(this)
    }), this.emit("videoUpdate", {
      videoEnabled: this.videoEnabled,
      videoTrack: this.videoTrack
    }));
  }
  setAudioEnabled(e, t = !0) {
    this.audioEnabled = e, t && (f.info("DyteParticipant::setAudioEnabled::audioUpdate", {
      ...kr(this)
    }), this.emit("audioUpdate", {
      audioEnabled: this.audioEnabled,
      audioTrack: this.audioTrack
    }));
  }
  setScreenShareEnabled(e, t = !0) {
    this.screenShareEnabled = e, t && this.emit("screenShareUpdate", {
      screenShareEnabled: this.screenShareEnabled,
      screenShareTracks: this.screenShareTracks
    });
  }
  /**
   * Returns `participant.id` if user has permission
   * to pin participants.
   */
  async pin() {
    if (!this.roomJoined)
      throw new E("Can`t pin participant without joining room");
    return c(this, $t, ps).pinPeer(this.id);
  }
  /**
   * Returns `participant.id` if user has permission
   * to unpin participants.
   */
  async unpin() {
    if (!this.roomJoined)
      throw new E("Can`t unpin participant without joining room");
    return c(this, $t, ps).pinPeer(null);
  }
  /**
   * @access private
   * Not for external use
   */
  setIsPinned(e, t = !0) {
    P(this, Ci, e);
    const s = e ? "pinned" : "unpinned";
    t && this.emit(s, this);
  }
  async disableAudio() {
    const e = this.id;
    if (f.info("DyteParticipant::disable_audio", { dyteParticipant: { id: e } }), !this.roomJoined)
      throw new E("Can`t disable participant audio without joining room");
    if (c(this, Nr).permissions.canDisableParticipantAudio)
      return c(this, $t, ps).disableAudio(e);
    throw f.error("DyteParticipant::unauthorized_disable_audio", { dyteParticipant: { id: e } }), new E("Unauthorized: User does not have permission to disable participant audio.");
  }
  async kick() {
    const e = this.id;
    if (f.info("DyteParticipant::kick", { dyteParticipant: { id: e } }), !this.roomJoined)
      throw new E("Can`t kick participant without joining room");
    if (c(this, Nr).permissions.kickParticipant)
      return c(this, $t, ps).kick(e);
    throw f.error("DyteParticipant::unauthorized_kick", { dyteParticipant: { id: e } }), new E("Unauthorized: User does not have permission to kick participants.");
  }
  async disableVideo() {
    const e = this.id;
    if (f.info("DyteParticipant::disable_video", { dyteParticipant: { id: e } }), !this.roomJoined)
      throw new E("Can`t disable participant video without joining room");
    if (c(this, Nr).permissions.canDisableParticipantVideo)
      return c(this, $t, ps).disableVideo(e);
    throw f.error("DyteParticipant::unauthorized_disable_video", { dyteParticipant: { id: e } }), new E("Unauthorized: User does not have permission to disable participant video.");
  }
  async acceptJoinStageRequest() {
    if (!this.roomJoined)
      throw new E("Can`t acceptJoinStageRequest for participant without joining room");
    c(this, $t, ps).acceptAllRequestToJoinStage([{
      id: this.id,
      requestToJoinType: $c.PRESENT
    }]);
  }
  async rejectRequestToJoinStage() {
    if (!this.roomJoined)
      throw new E("Can`t rejectRequestToJoinStage for participant without joining room");
    c(this, $t, ps).rejectRequestToJoinStage(this.id);
  }
  async removeFromStage() {
    if (!this.roomJoined)
      throw new E("Can`t removeFromStage participant without joining room");
    c(this, $t, ps).removePeerFromStage(
      this.id,
      jc.REQUESTED_BY_MODERATOR
    );
  }
  setWebinarStageStatus(e) {
    this.webinarStageStatus = e;
    let t;
    e === Je.OFF_STAGE && (t = "peerStoppedPresenting"), e === Je.ON_STAGE && (t = "peerStartedPresenting"), e === Je.ACCEPTED_TO_JOIN_STAGE && (t = "peerAcceptedToJoinStage"), e === Je.REQUESTED_TO_JOIN_STAGE && (t = "peerRequestToJoinStage"), t && this.emit(t, this);
  }
  /**
   * Returns true if the participant is pinned.
   */
  get isPinned() {
    return c(this, Ci);
  }
}, Ci = new WeakMap(), $t = new WeakSet(), ps = function() {
  return Be();
}, Nr = new WeakMap(), Hl);
fr([
  _.trace("DyteParticipant.disableAudio")
], Jt.prototype, "disableAudio", 1);
fr([
  _.trace("DyteParticipant.kick")
], Jt.prototype, "kick", 1);
fr([
  _.trace("DyteParticipant.disableVideo")
], Jt.prototype, "disableVideo", 1);
fr([
  _.trace("DyteParticipant.acceptJoinStageRequest")
], Jt.prototype, "acceptJoinStageRequest", 1);
fr([
  _.trace("DyteParticipant.rejectRequestToJoinStage")
], Jt.prototype, "rejectRequestToJoinStage", 1);
fr([
  _.trace("DyteParticipant.removeFromStage")
], Jt.prototype, "removeFromStage", 1);
fr([
  _.trace("DyteParticipant.setWebinarStageStatus")
], Jt.prototype, "setWebinarStageStatus", 1);
Jt = fr([
  ft((r) => {
    throw new E(r.message, "1200");
  })
], Jt);
var $e, Lr;
class Yc extends Map {
  constructor(t) {
    const {
      onAddEvent: s = "added",
      onDeleteEvent: i = "deleted",
      onClearEvent: n = "cleared"
    } = t != null ? t : {};
    super();
    b(this, $e, void 0);
    b(this, Lr, void 0);
    h(this, "onAddEvent");
    h(this, "onDeleteEvent");
    h(this, "onClearEvent");
    P(this, $e, new Ue()), this.onAddEvent = s, this.onDeleteEvent = i, this.onClearEvent = n, P(this, Lr, /* @__PURE__ */ new Map());
  }
  emit(t, ...s) {
    return c(this, $e).emit(t, ...s);
  }
  on(t, s) {
    return c(this, $e).on(t, s);
  }
  addListener(t, s) {
    return c(this, $e).addListener(t, s);
  }
  off(t, s) {
    return c(this, $e).off(t, s);
  }
  once(t, s) {
    return c(this, $e).once(t, s);
  }
  prependListener(t, s) {
    return c(this, $e).prependListener(t, s);
  }
  prependOnceListener(t, s) {
    return c(this, $e).prependOnceListener(t, s);
  }
  removeListener(t, s) {
    return c(this, $e).removeListener(t, s);
  }
  removeAllListeners(t) {
    return c(this, $e).removeAllListeners(t);
  }
  listeners(t) {
    return c(this, $e).listeners(t);
  }
  listenerCount(t) {
    return c(this, $e).listenerCount(t);
  }
  getMaxListeners() {
    return c(this, $e).getMaxListeners();
  }
  setMaxListeners(t) {
    return c(this, $e).setMaxListeners(t);
  }
  eventNames() {
    return c(this, $e).eventNames();
  }
  add(t, s = !0) {
    return this.set(t.id, t, s);
  }
  set(t, s, i = !0) {
    const n = super.set(t, s), a = (o, ...d) => {
      this.emit(o, s, ...d);
    };
    return c(this, Lr).set(t, a), s.on("*", a), i && c(this, $e).emit(this.onAddEvent, s), n;
  }
  delete(t, s = !0, i = !1) {
    const n = this.get(t);
    if (!n)
      return !1;
    n.removeListener("*", c(this, Lr).get(t));
    const a = super.delete(t);
    return i && n.removeAllListeners(), s && c(this, $e).emit(this.onDeleteEvent, n), a;
  }
  clear(t = !0, s = !1) {
    this.forEach((n) => {
      n.removeListener("*", c(this, Lr).get(n.id)), s && n.removeAllListeners();
    });
    const i = super.clear();
    return t && c(this, $e).emit(this.onClearEvent), i;
  }
  toArray() {
    return Array.from(this.values());
  }
}
$e = new WeakMap(), Lr = new WeakMap();
class ha extends Yc {
  constructor(e) {
    const {
      onAddEvent: t = "participantJoined",
      onDeleteEvent: s = "participantLeft",
      onClearEvent: i = "participantsCleared"
    } = e != null ? e : {};
    super({
      onAddEvent: t,
      onDeleteEvent: s,
      onClearEvent: i
    });
  }
  add(e, t = !0) {
    return super.add(e, t);
  }
  clear(e = !0, t = !1) {
    return super.clear(e, t);
  }
  delete(e, t = !0, s = !1) {
    return super.delete(e, t, s);
  }
}
class zb {
  constructor() {
    h(this, "_orderedArray");
    h(this, "_map");
    this._map = /* @__PURE__ */ new Map(), this._orderedArray = [];
  }
  add(e, t) {
    if (!this._map.has(e))
      return this._map.set(e, { peerId: e, priority: t }), this._orderedArray.splice(Math.max(t - 1, 0), 0, e), this.index(e);
    const s = this.index(e);
    this.delete(e);
    const i = this.add(e, t);
    return s !== i ? (f.info("DyteSelectedPeer::add()::new_position_for_active_speaker", {
      selectedPeer: {
        oldIndex: s,
        newIndex: i
      }
    }), i) : -1;
  }
  delete(e) {
    if (this._map.has(e)) {
      const t = this.index(e);
      this._map.delete(e), this._orderedArray.splice(t, 1);
    }
  }
  index(e) {
    return this._map.has(e) ? this._orderedArray.indexOf(e) : -1;
  }
  [Symbol.iterator]() {
    return this._orderedArray[Symbol.iterator]();
  }
}
class Qb {
  constructor() {
    h(this, "_activeSpeakerPeers");
    h(this, "_compulsoryPeers");
    this._activeSpeakerPeers = new zb(), this._compulsoryPeers = /* @__PURE__ */ new Set();
  }
  add(e, t) {
    return t < 0 ? (this._compulsoryPeers.add(e), 0) : this.compulsoryPeers.includes(e) && (t > 0 || t === 246267631) && (f.info("DyteSelectedPeer::removing_compulsory_peer", {
      selectedPeer: {
        peerId: e
      }
    }), this._removeFromCompulsoryPeer(e), t === 246267631) ? -1 : this._activeSpeakerPeers.add(e, t);
  }
  delete(e) {
    f.info("DyteSelectedPeer::deleting_peer_from_selectedPeer", {
      selectedPeer: {
        peerId: e
      }
    }), this._removeFromCompulsoryPeer(e), this._activeSpeakerPeers.delete(e);
  }
  index(e) {
    return this._activeSpeakerPeers.index(e);
  }
  get peers() {
    return [...new Set(this.compulsoryPeers.concat(this.activeSpeakerPeers))];
  }
  get compulsoryPeers() {
    return [...this._compulsoryPeers.values()];
  }
  get peerPriorities() {
    return [...this._activeSpeakerPeers].map((e, t) => t);
  }
  get activeSpeakerPeers() {
    return [...this._activeSpeakerPeers];
  }
  _removeFromCompulsoryPeer(e) {
    this._compulsoryPeers.delete(e);
  }
}
var Yb = Object.defineProperty, Zb = Object.getOwnPropertyDescriptor, cs = (r, e, t, s) => {
  for (var i = s > 1 ? void 0 : s ? Zb(e, t) : e, n = r.length - 1, a; n >= 0; n--)
    (a = r[n]) && (i = (s ? a(e, t, i) : a(i)) || i);
  return s && i && Yb(e, t, i), i;
}, Ze, lt, sr, Bl;
let Ft = (Bl = class extends Ue {
  /**
   * This constructs a new DyteParticipant object and maintains
   * the maps of active/joined/waitlisted/pinned/selectedPeers maps.
   * @param self : DyteSelf
   */
  constructor(e) {
    super();
    // eslint-disable-next-line class-methods-use-this
    b(this, Ze);
    /**
     * Returns a list of participants waiting to join the meeting.
     */
    h(this, "waitlisted");
    /**
     * Returns a list of all participants in the meeting.
     */
    h(this, "joined");
    /**
     * Returns a list of participants whose streams are currently consumed.
     */
    h(this, "active");
    /**
     * Returns a list of participants who have been pinned.
     */
    h(this, "pinned");
    b(this, sr, void 0);
    /**
     * Indicates whether the meeting is in 'ACTIVE_GRID' mode or 'PAGINATED' mode.
     *
     * In 'ACTIVE_GRID' mode, participants are populated in the participants.active map
     * dynamically. The participants present in the map will keep changing when other
     * participants unmute their audio or turn on their videos.
     *
     * In 'PAGINATED' mode, participants are populated in the participants.active map
     * just once, and the participants in the map will only change if the page number is
     * changed by the user using setPage(page).
     */
    h(this, "viewMode");
    /**
     * This indicates the current page that has been set by the user in PAGINATED mode.
     * If the meeting is in ACTIVE_GRID mode, this value will be 0.
     */
    h(this, "currentPage");
    /**
     * This stores the `participantId` of the last participant who spoke in the meeting.
     */
    h(this, "lastActiveSpeaker");
    /**
     * Keeps a list of all participants who have been present in the selected peers list.
     */
    h(this, "selectedPeers");
    P(this, sr, e), this.waitlisted = new ha(), this.joined = new ha(), this.active = new ha(), this.pinned = new ha(), this.selectedPeers = new Qb(), this.viewMode = "ACTIVE_GRID", this.currentPage = 0;
  }
  /**
   * Returns true if the local participant has joined the meeting.
   */
  get roomJoined() {
    var e;
    return ((e = c(this, Ze, lt)) == null ? void 0 : e.roomJoined) === !0;
  }
  /**
   * Returns the number of participants who are joined in the meeting.
   */
  get count() {
    return this.joined.size;
  }
  /**
   * Returns the maximum number of participants that can be present in
   * the active map.
   */
  get maxActiveParticipantsCount() {
    var t, s, i;
    if (c(this, Ze, lt) instanceof fe)
      return c(this, Ze, lt).maxPreferredStreams;
    const e = c(this, sr).suggestedTheme;
    return (i = (s = (t = e == null ? void 0 : e.grid) == null ? void 0 : t.multi) == null ? void 0 : s.maxVideoCount) != null ? i : 6;
  }
  /**
   * Returns the number of pages that are available in the meeting in PAGINATED mode.
   * If the meeting is in ACTIVE_GRID mode, this value will be 0.
   */
  get pageCount() {
    return this.viewMode === "PAGINATED" ? Math.ceil(this.joined.size / this.maxActiveParticipantsCount) : 0;
  }
  /**
   * Accepts requests from waitlisted participants if user
   * has appropriate permissions.
   * @param id participantId of the waitlisted participant.
   */
  async acceptWaitingRoomRequest(e) {
    if (!this.roomJoined)
      throw new E("Can`t accept waiting room request without joining room");
    return c(this, Ze, lt).acceptWaitingRequest(e);
  }
  /**
   * Rejects requests from waitlisted participants if user
   * has appropriate permissions.
   * @param id participantId of the waitlisted participant.
   */
  async rejectWaitingRoomRequest(e) {
    if (!this.roomJoined)
      throw new E("Can`t reject waiting room request without joining room");
    await c(this, Ze, lt).rejectWaitingRequest(e), this.waitlisted.delete(e);
  }
  async setViewMode(e) {
    if (f.info("DyteParticipants::set_view_mode", {
      pageNavigation: {
        viewMode: e,
        currentPage: this.currentPage,
        pageCount: this.pageCount,
        maxActiveParticipantsCount: this.maxActiveParticipantsCount
      }
    }), !["ACTIVE_GRID", "PAGINATED"].includes(e))
      throw f.error("DyteParticipants::setViewMode::invalid_view_mode", {
        pageNavigation: {
          viewMode: e,
          currentPage: this.currentPage,
          pageCount: this.pageCount,
          maxActiveParticipantsCount: this.maxActiveParticipantsCount
        }
      }), new E(`Invalid view mode: ${e}. Try ACTIVE_GRID or PAGINATED.`);
    if (this.viewMode === e) {
      f.info("DyteParticipants::setViewMode::view_mode_same_as_previous", {
        pageNavigation: {
          viewMode: e,
          currentPage: this.currentPage,
          pageCount: this.pageCount,
          maxActiveParticipantsCount: this.maxActiveParticipantsCount
        }
      });
      return;
    }
    if (this.viewMode = e, e === "PAGINATED") {
      this.currentPage = 1;
      let t = [];
      c(this, Ze, lt) instanceof fe ? { peerIds: t } = (await c(this, Ze, lt).getPage(this.currentPage)).payload : t = this.getPeerIdsForCurrentPage(), y.emit(
        v.GET_PAGE,
        { peerIds: t }
      );
    } else
      e === "ACTIVE_GRID" && (this.currentPage = 0, c(this, Ze, lt) instanceof fe ? c(this, Ze, lt).getPage(this.currentPage) : y.emit(v.REFRESH_GRID));
    this.emit("viewModeChanged", {
      viewMode: e,
      currentPage: this.currentPage,
      pageCount: this.pageCount
    });
  }
  // NOTE(itzmanish): hive systems specific code
  getPeerIdsForCurrentPage() {
    f.info("DyteParticipants::getPeerIdsForCurrentPage()", {
      pageNavigation: {
        viewMode: this.viewMode,
        currentPage: this.currentPage,
        pageCount: this.pageCount,
        maxActiveParticipantsCount: this.maxActiveParticipantsCount
      }
    });
    const { compulsoryPeers: e } = this.selectedPeers, t = [...this.joined.keys()], s = Math.max(
      (this.currentPage - 1) * (this.maxActiveParticipantsCount - e.length)
    ), i = this.currentPage * (this.maxActiveParticipantsCount - e.length);
    return e.concat(t.slice(s, i));
  }
  async setPage(e) {
    if (f.info("DyteParticipants::set_page", {
      pageNavigation: {
        settingPage: e,
        viewMode: this.viewMode,
        currentPage: this.currentPage,
        pageCount: this.pageCount,
        maxActiveParticipantsCount: this.maxActiveParticipantsCount
      }
    }), this.viewMode !== "PAGINATED")
      return;
    if (!Number.isInteger(e))
      throw f.error("DyteParticipants::invalid_page_number", {
        pageNavigation: {
          settingPage: e,
          viewMode: this.viewMode,
          currentPage: this.currentPage,
          pageCount: this.pageCount,
          maxActiveParticipantsCount: this.maxActiveParticipantsCount
        }
      }), new E(`Invalid page: ${e}. Page must be an integer.`);
    if (e < 1 || e > this.pageCount)
      throw f.error("DyteParticipants::invalid_page_number", {
        pageNavigation: {
          settingPage: e,
          viewMode: this.viewMode,
          currentPage: this.currentPage,
          pageCount: this.pageCount,
          maxActiveParticipantsCount: this.maxActiveParticipantsCount
        }
      }), new E(`Invalid page: ${e}. Page must be greater than 0 and less than or equal to ${this.pageCount}.`);
    this.currentPage = e;
    let t = [];
    c(this, Ze, lt) instanceof fe ? { peerIds: t } = (await c(this, Ze, lt).getPage(e)).payload : t = this.getPeerIdsForCurrentPage(), y.emit(
      v.GET_PAGE,
      { peerIds: t }
    ), this.emit("pageChanged", {
      viewMode: this.viewMode,
      currentPage: this.currentPage,
      pageCount: this.pageCount
    });
  }
  async disableAllAudio(e) {
    if (f.info("DyteParticipants::disable_all_audio", {
      actions: { disableAllAudio: { allowUnmute: e } }
    }), !this.roomJoined)
      throw new E("Can`t disable all audio without joining room");
    if (c(this, sr).permissions.canAllowParticipantAudio)
      return c(this, Ze, lt).muteAll(e);
    throw f.error("DyteParticipants::unauthorized_disable_all_audio", {
      actions: { disableAllAudio: { allowUnmute: e } }
    }), new E("Unauthorized: User does not have permission to disable peer audio.");
  }
  async disableAllVideo() {
    if (f.info("DyteParticipants::disable_all_video"), !this.roomJoined)
      throw new E("Can`t disable all video without joining room");
    if (c(this, sr).permissions.canAllowParticipantVideo)
      return c(this, Ze, lt).muteAllVideo();
    throw f.error("DyteParticipants::unauthorized_disable_all_video"), new E("Unauthorized: User does not have permission to disable peer video.");
  }
  async disableAudio(e) {
    this.joined.get(e).disableAudio();
  }
  async disableVideo(e) {
    this.joined.get(e).disableVideo();
  }
  async kick(e) {
    this.joined.get(e).kick();
  }
  async kickAll() {
    if (f.info("DyteParticipants::kick_all"), !this.roomJoined)
      throw new E("Can`t kick all without joining room");
    if (c(this, sr).permissions.kickParticipant)
      return c(this, Ze, lt).kickAll();
    throw f.error("DyteParticipants::unauthorized_kick_all"), new E("Unauthorized: User does not have permission to kick peers.");
  }
  async broadcastMessage(e, t) {
    if (f.info("DyteParticipants::broadcastMessage"), !this.roomJoined)
      throw new E("Can`t broadcast message without joining room");
    if (!(e != null && e.trim()))
      throw new E("`type` must be a non-empty string.");
    c(this, Ze, lt).broadcastMessage(e, t);
  }
  async acceptAllRequestToJoinStageRequests(e) {
    if (!this.roomJoined)
      throw new E("Can`t acceptAllRequestToJoinStageRequests without joining room");
    c(this, Ze, lt).acceptAllRequestToJoinStage(
      e
    );
  }
}, Ze = new WeakSet(), lt = function() {
  return Be();
}, sr = new WeakMap(), Bl);
cs([
  _.trace("DyteParticipants.setViewMode")
], Ft.prototype, "setViewMode", 1);
cs([
  _.trace("DyteParticipants.setPage")
], Ft.prototype, "setPage", 1);
cs([
  _.trace("DyteParticipants.disableAllAudio")
], Ft.prototype, "disableAllAudio", 1);
cs([
  _.trace("DyteParticipants.disableAllVideo")
], Ft.prototype, "disableAllVideo", 1);
cs([
  _.trace("DyteParticipants.disablePeerAudio")
], Ft.prototype, "disableAudio", 1);
cs([
  _.trace("DyteParticipants.disablePeerVideo")
], Ft.prototype, "disableVideo", 1);
cs([
  _.trace("DyteParticipants.kickPeer")
], Ft.prototype, "kick", 1);
cs([
  _.trace("DyteParticipants.kickAll")
], Ft.prototype, "kickAll", 1);
cs([
  _.trace("DyteParticipants.broadcastMessage")
], Ft.prototype, "broadcastMessage", 1);
cs([
  _.trace("DyteParticipants.acceptAllRequestToJoinStageRequests")
], Ft.prototype, "acceptAllRequestToJoinStageRequests", 1);
Ft = cs([
  ft((r) => {
    throw new E(r.message, "1200");
  })
], Ft);
var Xb = Object.defineProperty, eP = Object.getOwnPropertyDescriptor, si = (r, e, t, s) => {
  for (var i = s > 1 ? void 0 : s ? eP(e, t) : e, n = r.length - 1, a; n >= 0; n--)
    (a = r[n]) && (i = (s ? a(e, t, i) : a(i)) || i);
  return s && i && Xb(e, t, i), i;
}, at, xr, Is, De, Ne;
class gr {
  constructor(e) {
    // eslint-disable-next-line class-methods-use-this
    b(this, De);
    h(this, "participants");
    b(this, at, void 0);
    b(this, xr, void 0);
    b(this, Is, /* @__PURE__ */ new Set());
    this.participants = new Ft(e), P(this, xr, /* @__PURE__ */ new Map()), P(this, at, e), this.setupEvents();
  }
  get roomJoined() {
    var e;
    return ((e = c(this, De, Ne)) == null ? void 0 : e.roomJoined) === !0;
  }
  updatePageParticipants(e) {
    const t = new Set(e), s = new Map(this.participants.active);
    if (this.participants.active.forEach((i, n) => {
      this.participants.active.delete(n, !t.has(n));
    }), t.forEach((i) => {
      if (!this.participants.joined.get(i)) {
        f.warn("updatePageParticipants::participant_not_in_joined_list", {
          dyteParticipant: { id: i }
        });
        return;
      }
      this.participants.active.add(
        this.participants.joined.get(i),
        !s.get(i)
      );
    }), c(this, De, Ne) instanceof z) {
      Array.from(s.keys()).forEach((n) => {
        if (t.has(n))
          return;
        const a = this.participants.joined.get(n);
        if (!a)
          return;
        const o = {
          producers: a.producers,
          peerId: a.id
        };
        c(this, De, Ne).deactivatePeers(o);
      });
      const i = [];
      this.participants.active.forEach((n) => {
        const a = {
          peerId: n.id,
          producers: n.producers
        };
        i.push(a);
      }), c(this, De, Ne).activatePeers(i);
    }
  }
  updatePinnedParticipants() {
    this.participants.pinned.forEach((e) => {
      e.setIsPinned(!1), this.participants.pinned.delete(e.id);
    });
  }
  // NOTE(itzmanish): hive specific code
  refreshGridParticipants(e = !1) {
    const t = [...this.participants.joined.keys()], s = this.participants.selectedPeers.peers;
    if (this.participants.viewMode !== "ACTIVE_GRID") {
      f.warn("ParticipantController::refreshGridParticipants::not_refreshing_grid_in_not_active_grid_mode");
      return;
    }
    const i = this.participants.maxActiveParticipantsCount - 1, n = new Set(s.filter((d) => d !== c(this, at).id));
    let a = [...n];
    const o = i - n.size;
    if (o >= 0) {
      const d = t.filter(
        (p) => !n.has(p) && p !== c(this, at).id
      ).slice(0, o);
      a = [...n].concat(d);
    } else
      a = a.slice(0, i);
    this.updateActiveParticipantsHiveNode(a, e);
  }
  // NOTE(itzmanish): hive specific code
  updateActiveParticipantsHiveNode(e, t = !1) {
    if (!this.roomJoined) {
      f.warn(
        "Skipped::ParticipantController::updateActiveParticipants",
        {
          roomJoined: this.roomJoined
        }
      );
      return;
    }
    const s = Array.from(this.participants.active.keys()), i = new Map(this.participants.active), n = {};
    e.forEach((l) => {
      n[l] = !0;
    });
    const a = [];
    s.forEach((l, u) => {
      (!n[l] || !this.participants.joined.get(l)) && a.push(u);
    }), e.forEach((l) => {
      i.get(l) || (s.length < e.length ? s.push(l) : s[a.shift()] = l);
    }), s.forEach((l, u) => {
      n[l] || s.splice(u, 1);
    }), Array.from(this.participants.active.keys()).forEach((l) => {
      this.participants.active.delete(l, !n[l]);
    }), s.forEach((l) => {
      if (!this.participants.joined.get(l)) {
        f.warn("updateActiveParticipants::participant_not_in_joined_list", {
          dyteParticipant: { id: l }
        });
        return;
      }
      this.participants.active.add(
        this.participants.joined.get(l),
        !i.get(l)
      );
    }), this.updateWebinarStatusForJoinedParticipants(e), this.participants.active.emit("participantsUpdate"), f.info(
      "ParticipantController::updateActiveParticipants::updating_current_selected_peers",
      { debuggingHint: t ? "Forcefully updating currentActiveGridParticipants set" : null }
    ), t && P(this, Is, /* @__PURE__ */ new Set());
    const o = new Set(e), d = [], p = [];
    if (c(this, Is).forEach((l) => {
      o.has(l) || d.push(l);
    }), o.forEach((l) => {
      c(this, Is).has(l) || p.push(l);
    }), P(this, Is, o), p.length === 0 && d.length === 0) {
      f.info("ParticipantController::updateActiveParticipants::current_selected_peers_is_same");
      return;
    }
    if (c(this, De, Ne) instanceof z) {
      const l = [];
      d.forEach((u) => {
        const m = this.participants.joined.get(u);
        if (!m)
          return;
        const g = {
          producers: m.producers,
          peerId: m.id
        };
        l.push(
          c(this, De, Ne).deactivatePeers(g)
        );
      }), Promise.all(l).then(() => {
        const u = [];
        p.forEach((m) => {
          const g = this.participants.active.get(m);
          if (!g) {
            f.warn("peer is not in active map which is going to activate, should not happen", {
              dyteParticipant: { id: m }
            });
            return;
          }
          const T = {
            peerId: g.id,
            producers: g.producers
          };
          u.push(T);
        }), c(this, De, Ne).activatePeers(u);
      }).catch((u) => {
        f.info("Error on deactivating peers", u);
      });
    }
  }
  updateActiveParticipants(e) {
    if (!this.roomJoined) {
      f.warn(
        "Skipped::ParticipantController::updateActiveParticipants",
        {
          roomJoined: this.roomJoined
        }
      );
      return;
    }
    const t = Array.from(this.participants.active.keys()), s = new Map(this.participants.active), i = {};
    e.forEach((a) => {
      i[a] = !0;
    });
    const n = [];
    t.forEach((a, o) => {
      (!i[a] || !this.participants.joined.get(a)) && n.push(o);
    }), e.forEach((a) => {
      s.get(a) || (t.length < e.length ? t.push(a) : t[n.shift()] = a);
    }), t.forEach((a, o) => {
      i[a] || t.splice(o, 1);
    }), Array.from(this.participants.active.keys()).forEach((a) => {
      this.participants.active.delete(a, !i[a]);
    }), t.forEach((a) => {
      if (!this.participants.joined.get(a)) {
        f.warn("updateActiveParticipants::participant_not_in_joined_list", {
          dyteParticipant: { id: a }
        });
        return;
      }
      this.participants.active.add(
        this.participants.joined.get(a),
        !s.get(a)
      );
    }), this.updateWebinarStatusForJoinedParticipants(e), this.participants.active.emit("participantsUpdate");
  }
  // NOTE(itzmanish): hive specific code
  updateActiveParticipantsWithPriorities(e, t = !1) {
    if (!this.roomJoined) {
      f.warn(
        "Skipped::ParticipantController::updateActiveParticipantsWithPriorities",
        {
          roomJoined: this.roomJoined
        }
      );
      return;
    }
    e.forEach((s) => {
      this.participants.joined.get(s.peerId) && this.participants.selectedPeers.add(s.peerId, s.priority);
    }), t && this.refreshGridParticipants();
  }
  setupEvents() {
    y.on(v.PEER_JOINED, async (e) => {
      var s, i, n;
      const t = new Jt(e, c(this, at));
      c(this, at).id !== t.id && !((s = e.flags) != null && s.recorder) && !((i = t.flags) != null && i.hidden_participant) && !((n = t.flags) != null && n.hiddenParticipant) && (this.participants.joined.add(t), this.participants.waitlisted.delete(t.id), this.participants.currentPage === this.participants.pageCount && c(this, De, Ne) instanceof fe && y.emit(
        v.GET_PAGE,
        (await c(this, De, Ne).getPage(this.participants.currentPage)).payload
      ));
    }), y.on(v.WAITLIST_PEER_ADDED, ({ id: e, name: t }) => {
      this.participants.waitlisted.add(
        new Jt({
          id: e,
          displayName: t,
          audioMuted: !0,
          videoEnabled: !1,
          audioTrack: void 0,
          videoTrack: void 0,
          userId: void 0,
          flags: {},
          isHost: !1
        }, c(this, at))
      );
    }), y.on(v.WAITLIST_PEER_REMOVED, ({ id: e }) => {
      this.participants.waitlisted.delete(e);
    }), y.on(v.ROOM_JOINED, (e) => {
      c(this, De, Ne) instanceof z && this.participants.joined.clear(), e.peers.forEach((t) => {
        var i, n, a;
        if ((i = t.flags) != null && i.recorder || (n = t.flags) != null && n.hidden_participant || (a = t.flags) != null && a.hiddenParticipant)
          return;
        const s = new Jt(t, c(this, at));
        s.id === e.pinnedPeerId && (s.setIsPinned(!0, !1), this.participants.pinned.add(s)), this.participants.joined.add(s);
      }), e.requestToJoinPeersList && e.requestToJoinPeersList.forEach(({ id: t }) => {
        var s;
        (s = this.participants.joined.get(t)) == null || s.setWebinarStageStatus(Je.REQUESTED_TO_JOIN_STAGE);
      }), c(this, De, Ne) instanceof fe && c(this, De, Ne).getPage(this.participants.currentPage);
    }), y.on(v.PEER_CLOSED, async ({ id: e }) => {
      if (this.participants.joined.delete(e, !0, !0), this.participants.pinned.delete(e, !0, !0), c(this, De, Ne) instanceof z && (this.participants.selectedPeers.delete(e), this.participants.active.get(e) && this.participants.currentPage === 0)) {
        this.refreshGridParticipants();
        return;
      }
      const { currentPage: t } = this.participants, s = c(this, at).config.maxVideoStreams, n = (ae.isMobile() ? s.mobile : s.desktop) * (t - 1), a = this.participants.active.get(e);
      if (n === 0)
        this.participants.setViewMode("ACTIVE_GRID");
      else if (this.participants.joined.size <= n)
        t === 2 ? this.participants.setViewMode("ACTIVE_GRID") : this.participants.setPage(t - 1);
      else if (a) {
        let o = [];
        c(this, De, Ne) instanceof fe ? { peerIds: o } = (await c(this, De, Ne).getPage(t)).payload : o = this.participants.getPeerIdsForCurrentPage(), y.emit(
          v.GET_PAGE,
          { peerIds: o }
        );
      }
    }), y.on(v.ROOM_NODE_DISCONNECTED, () => {
      Array.from(this.participants.joined.keys()).forEach((e) => {
        this.participants.joined.delete(e);
      }), Array.from(this.participants.active.keys()).forEach((e) => {
        this.participants.active.delete(e);
      }), Array.from(this.participants.pinned.keys()).forEach((e) => {
        this.participants.pinned.delete(e);
      }), this.participants.currentPage = 0, this.participants.viewMode = "ACTIVE_GRID", this.participants.emit("viewModeChanged", {
        viewMode: "ACTIVE_GRID",
        currentPage: this.participants.currentPage,
        pageCount: this.participants.pageCount
      }), P(this, Is, /* @__PURE__ */ new Set());
    }), y.on(v.PEER_MUTED, ({ peerId: e }) => {
      const t = this.participants.joined.get(e);
      t && t.setAudioEnabled(!1);
    }), y.on(v.PEER_UNMUTED, ({ peerId: e }) => {
      const t = this.participants.joined.get(e);
      t && t.setAudioEnabled(!0);
    }), y.on(v.CONSUMER_PAUSED, ({ id: e }) => {
      this.processConsumerPaused(e);
    }), y.on(v.CONSUMER_RESUMED, ({ id: e }) => {
      this.processConsumerResumed(e);
    }), y.on(v.NEW_CONSUMER, ({ id: e }) => {
      this.processNewConsumer(e);
    }), y.on(v.CONSUMER_CLOSED, ({ id: e }) => {
      this.processConsumerClosed(e);
    }), y.on(v.GET_PAGE, ({ peerIds: e }) => {
      this.participants.viewMode === "PAGINATED" && this.updatePageParticipants(e);
    }), y.on(v.SELECTED_PEERS, ({
      peerIds: e,
      compulsoryPeers: t
    }) => {
      if (this.participants.viewMode !== "ACTIVE_GRID")
        return;
      if (c(this, De, Ne) instanceof fe) {
        this.updateActiveParticipants(e);
        return;
      }
      const s = e.map((n, a) => ({
        peerId: n,
        priority: a + 1
      })), i = t == null ? void 0 : t.map((n, a) => ({
        peerId: n,
        priority: -(a + 1)
      }));
      s.push(...i != null ? i : []), s.length > 0 && this.updateActiveParticipantsWithPriorities(s);
    }), y.on(v.SELECTED_PEERS_DIFF, ({ entries: e }) => {
      this.participants.viewMode === "ACTIVE_GRID" && this.updateActiveParticipantsWithPriorities(e, !0);
    }), y.on(v.REFRESH_GRID, (e = !1) => {
      this.participants.viewMode === "ACTIVE_GRID" && this.refreshGridParticipants(e);
    }), y.on(v.NEW_PRODUCER, ({ peerId: e, producer: t }) => {
      const s = this.participants.joined.get(e);
      if (!s) {
        f.warn(
          "ParticipantController::NEW_PRODUCER::participant not found",
          {
            producer: {
              id: t == null ? void 0 : t.producerId,
              kind: t == null ? void 0 : t.kind,
              status: "UNKNOWN",
              appData: { screenShare: t == null ? void 0 : t.screenShare }
            },
            dyteParticipant: { id: e }
          }
        );
        return;
      }
      s.producers.push(t), f.info("ParticipantController::NEW_PRODUCER::producer_added_to_participant", {
        producer: {
          id: t == null ? void 0 : t.producerId,
          peerId: e,
          kind: t == null ? void 0 : t.kind,
          status: "UNKNOWN",
          appData: { screenShare: t == null ? void 0 : t.screenShare }
        }
      }), (t == null ? void 0 : t.kind) === "audio" || t != null && t.screenShare || c(this, Is).has(e) ? c(this, De, Ne).createConsumer({
        producingPeerId: e,
        producerId: t.producerId,
        screenShare: t.screenShare
      }) : f.info(
        "ParticipantController::NEW_PRODUCER::not_consuming_producer",
        {
          producer: {
            id: t == null ? void 0 : t.producerId,
            peerId: e,
            kind: t == null ? void 0 : t.kind,
            status: "UNKNOWN",
            appData: { screenShare: t == null ? void 0 : t.screenShare }
          }
        }
      );
    }), y.on(v.PRODUCER_CLOSED, ({ peerId: e, producerId: t }) => {
      const s = this.participants.joined.get(e);
      if (!s) {
        f.warn("ParticipantController::NEW_PRODUCER::participant not found", {
          dyteParticipant: { id: e }
        });
        return;
      }
      s.producers = s.producers.filter(
        (i) => i.producerId !== t
      );
    }), y.on(v.PRODUCER_TOGGLE, ({
      peerId: e,
      producerId: t,
      paused: s,
      kind: i
    }) => {
      const n = this.participants.joined.get(e);
      if (n && i === "audio") {
        n.setAudioEnabled(!s);
        const a = n.producers.find(
          (o) => o.producerId === t
        );
        a && (a.pause = s);
      }
    }), y.on(v.ACTIVE_SPEAKER, ({ peerId: e, volume: t }) => {
      this.participants.lastActiveSpeaker = e, this.participants.emit("activeSpeaker", { peerId: e, volume: t });
    }), y.on(v.ROOM_MESSAGE, async ({ payload: e, type: t, timestamp: s }) => {
      this.participants.emit("broadcastedMessage", { type: t, payload: e, timestamp: s });
    }), y.on(v.LOW_CONSUMER_SCORE, ({ peerId: e, score: t, kind: s }) => {
      const i = this.participants.joined.get(e);
      i && (i.emit("poorConnection", { score: t, kind: s }), this.participants.emit("poorConnection", { participantId: e, score: t, kind: s }));
    }), y.on(v.CONSUMER_SCORE_UPDATE, ({
      score: e,
      kind: t,
      appData: s,
      peerId: i
    }) => {
      var o;
      const n = t === "video" && ((o = s == null ? void 0 : s.screenShare) != null ? o : !1), a = this.participants.joined.get(i);
      a && (a.emit("mediaScoreUpdate", {
        kind: t,
        isScreenshare: n,
        score: e,
        participantId: i
      }), this.participants.emit("mediaScoreUpdate", {
        kind: t,
        isScreenshare: n,
        score: e,
        participantId: i
      }));
    }), y.on(v.PEER_PINNED, ({ peerId: e }) => {
      if (!e) {
        c(this, at).isPinned && c(this, at).setIsPinned(!1), this.participants.pinned.size !== 0 && this.updatePinnedParticipants();
        return;
      }
      if (e === c(this, at).id) {
        this.participants.pinned.size !== 0 && this.updatePinnedParticipants(), c(this, at).setIsPinned(!0);
        return;
      }
      const t = this.participants.joined.get(e);
      c(this, at).isPinned && c(this, at).setIsPinned(!1), this.updatePinnedParticipants(), t.setIsPinned(!0), this.participants.pinned.add(t), c(this, De, Ne) instanceof z && c(this, De, Ne).activatePeers([{
        peerId: t.id,
        producers: t.producers
      }]).catch((s) => {
        f.error("unable to create consumers", {
          error: s
        });
      });
    }), y.on(v.PEER_REQUESTED_TO_JOIN_STAGE, ({ id: e }) => {
      const t = this.participants.joined.get(e);
      t == null || t.setWebinarStageStatus(Je.REQUESTED_TO_JOIN_STAGE);
    }), y.on(
      v.PEER_WITHDRAWN_REQUEST_TO_JOIN_STAGE,
      ({ id: e }) => {
        const t = this.participants.joined.get(e);
        t == null || t.setWebinarStageStatus(Je.OFF_STAGE);
      }
    ), y.on(v.PEER_REJECTED_TO_JOIN_STAGE, ({ id: e }) => {
      const t = this.participants.joined.get(e);
      t == null || t.setWebinarStageStatus(Je.OFF_STAGE);
    }), y.on(v.PEER_ADDED_TO_STAGE, ({ id: e }) => {
      const t = this.participants.joined.get(e);
      t == null || t.setWebinarStageStatus(Je.ACCEPTED_TO_JOIN_STAGE);
    }), y.on(v.PEER_REMOVED_FROM_STAGE, ({ id: e }) => {
      const t = this.participants.joined.get(e);
      t == null || t.setWebinarStageStatus(Je.OFF_STAGE);
    }), y.on(v.PEER_STARTED_PRESENTING, ({ id: e }) => {
      const t = this.participants.joined.get(e);
      t == null || t.setWebinarStageStatus(Je.ON_STAGE);
    }), y.on(v.PEER_STOPPED_PRESENTING, ({ id: e }) => {
      const t = this.participants.joined.get(e);
      t == null || t.setWebinarStageStatus(Je.OFF_STAGE);
    });
  }
  processMedia(e) {
    var p;
    const t = c(this, De, Ne).getConsumers(), {
      peerId: s,
      kind: i,
      appData: n,
      remotelyPaused: a,
      track: o
    } = (p = t.get(e)) != null ? p : {};
    if (!s)
      return f.warn("processMedia::Peer ID is undefined", {
        consumer: {
          id: e,
          kind: i,
          peerId: s,
          appData: {
            supportsRemoteControl: n == null ? void 0 : n.supportsRemoteControl,
            screenShare: n == null ? void 0 : n.screenShare
          },
          remotelyPaused: a
        }
      }), {};
    const d = n;
    return f.info("ParticipantController::processMedia", {
      consumer: {
        id: e,
        peerId: s,
        kind: i,
        appData: d,
        remotelyPaused: a
      }
    }), c(this, xr).set(e, {
      type: i,
      peerId: s,
      appData: d,
      remotelyPaused: a
    }), {
      peerId: s,
      kind: i,
      appData: d,
      remotelyPaused: a,
      track: o
    };
  }
  processConsumerClosed(e) {
    const {
      peerId: t,
      type: s,
      appData: i,
      remotelyPaused: n
    } = c(this, xr).get(e) || {}, a = this.participants.joined.get(t);
    if (f.info("ParticipantController::processConsumerClosed", {
      consumer: {
        id: e,
        peerId: t,
        appData: i,
        kind: s,
        remotelyPaused: n
      }
    }), c(this, xr).delete(e), !!a) {
      if (i && i.screenShare) {
        a.setScreenShareEnabled(!1), A.consumerSharedMediaState(e, { screen: !1 }), a.screenShareTracks = {
          audio: void 0,
          video: void 0
        };
        return;
      }
      s === "audio" ? (a.setAudioEnabled(!1), A.consumerSharedMediaState(e, { audio: !1 }), a.audioTrack = void 0) : s === "video" && (a.setVideoEnabled(!1), A.consumerSharedMediaState(e, { video: !1 }), a.videoTrack = void 0);
    }
  }
  processConsumerResumed(e) {
    const {
      peerId: t,
      kind: s,
      appData: i,
      track: n,
      remotelyPaused: a
    } = this.processMedia(e);
    if (!t)
      return;
    f.info("ParticipantController::processConsumerResumed", {
      consumer: {
        id: e,
        peerId: t,
        kind: s,
        appData: i,
        remotelyPaused: a
      }
    });
    const o = this.participants.joined.get(t);
    if (o) {
      if (i.screenShare) {
        s === "video" ? o.screenShareTracks.video = n : s === "audio" && (o.screenShareTracks.audio = n), o.setScreenShareEnabled(!0), A.consumerSharedMediaState(e, { screen: !0 });
        return;
      }
      s === "video" ? (o.videoTrack = n, o.setVideoEnabled(!0), A.consumerSharedMediaState(e, { video: !0 })) : s === "audio" && (o.audioTrack = n, o.setAudioEnabled(o.audioEnabled), A.consumerSharedMediaState(e, { audio: o.audioEnabled }));
    }
  }
  processConsumerPaused(e) {
    f.info(`ParticipantController::processConsumerPaused called for consumerId: ${e}`);
    const {
      peerId: t,
      kind: s,
      track: i,
      appData: n,
      remotelyPaused: a
    } = this.processMedia(e);
    if (!t)
      return;
    f.info("ParticipantController::processConsumerPaused", {
      consumer: {
        id: e,
        peerId: t,
        kind: s,
        appData: n,
        remotelyPaused: a
      }
    });
    const o = this.participants.joined.get(t);
    o && (s === "video" ? (o.videoTrack = i, o.setVideoEnabled(!1), A.consumerSharedMediaState(e, { video: !1 })) : s === "audio" && (o.audioTrack = i, o.setAudioEnabled(o.audioEnabled), A.consumerSharedMediaState(e, { audio: o.audioEnabled })));
  }
  processNewConsumer(e) {
    const {
      peerId: t,
      kind: s,
      remotelyPaused: i,
      track: n,
      appData: a
    } = this.processMedia(e);
    if (!t)
      return;
    f.info("ParticipantController::processNewConsumer", {
      consumer: {
        id: e,
        peerId: t,
        kind: s,
        remotelyPaused: i,
        appData: a
      }
    });
    const o = this.participants.joined.get(t);
    if (o) {
      if (a.screenShare) {
        s === "video" ? o.screenShareTracks.video = n : s === "audio" && (o.screenShareTracks.audio = n), (!i || c(this, at).permissions.isRecorder || M.hasFeature(N.SCREEENSHARE_ERR_HACK)) && o.setScreenShareEnabled(!0), a.supportsRemoteControl && (o.supportsRemoteControl = !0);
        return;
      }
      s === "video" ? (o.videoTrack = n, i || o.setVideoEnabled(!0), A.consumerSharedMediaState(e, { video: !i })) : s === "audio" && c(this, De, Ne) instanceof z && (o.audioTrack = n, i || o.setAudioEnabled(!0), A.consumerSharedMediaState(e, { audio: !i }));
    }
  }
  // NOTE(callmetarush): Forcefully changes webinarStageStatus for active participants
  updateWebinarStatusForJoinedParticipants(e) {
    e.forEach((t) => {
      const s = this.participants.joined.get(t);
      s && (s.webinarStageStatus = Je.ON_STAGE);
    });
  }
}
at = new WeakMap(), xr = new WeakMap(), Is = new WeakMap(), De = new WeakSet(), Ne = function() {
  return Be();
};
si([
  _.trace("ParticipantController.updatePageParticipants")
], gr.prototype, "updatePageParticipants", 1);
si([
  _.trace("ParticipantController.setupEvents")
], gr.prototype, "setupEvents", 1);
si([
  _.trace("ParticipantController.processMedia")
], gr.prototype, "processMedia", 1);
si([
  _.trace("ParticipantController.processConsumerClosed")
], gr.prototype, "processConsumerClosed", 1);
si([
  _.trace("ParticipantController.processConsumerResumed")
], gr.prototype, "processConsumerResumed", 1);
si([
  _.trace("ParticipantController.processConsumerPaused")
], gr.prototype, "processConsumerPaused", 1);
si([
  _.trace("ParticipantController.processNewConsumer")
], gr.prototype, "processNewConsumer", 1);
var tP = Object.defineProperty, sP = Object.getOwnPropertyDescriptor, rP = (r, e, t, s) => {
  for (var i = s > 1 ? void 0 : s ? sP(e, t) : e, n = r.length - 1, a; n >= 0; n--)
    (a = r[n]) && (i = (s ? a(e, t, i) : a(i)) || i);
  return s && i && tP(e, t, i), i;
}, kn, dc, Ja, Dn, ql;
let cc = (ql = class extends Ue {
  constructor(e, t, s, i) {
    super();
    // eslint-disable-next-line class-methods-use-this
    b(this, kn);
    b(this, Ja, void 0);
    b(this, Dn, void 0);
    /**
     * The `viewType` tells the type of the meeting
     * possible values are WEBINAR, GROUP_CALL
     */
    h(this, "viewType");
    /**
     * The timestamp of the time when the meeting started.
     */
    h(this, "meetingStartedTimestamp");
    /**
     * The title of the meeting.
     */
    h(this, "meetingTitle");
    P(this, Ja, e), this.viewType = t, P(this, Dn, s), this.meetingTitle = i;
  }
  /**
   * @deprecated
   * This is set to true if the current user has joined the meeting.
   */
  get joined() {
    var e;
    return (e = c(this, kn, dc)) == null ? void 0 : e.roomJoined;
  }
  /**
   * The room name of the meeting.
   */
  get roomName() {
    var e;
    return (e = c(this, kn, dc)) == null ? void 0 : e.roomName;
  }
  /**
   * This is set to true if user has succesfully connected to the socket.
   */
  get socketConnected() {
    return c(this, Dn).isConnected;
  }
}, kn = new WeakSet(), dc = function() {
  return Be();
}, Ja = new WeakMap(), Dn = new WeakMap(), ql);
cc = rP([
  ft((r) => {
    throw new E(r.message, "0800");
  })
], cc);
var iP = Object.defineProperty, nP = Object.getOwnPropertyDescriptor, aP = (r, e, t, s) => {
  for (var i = s > 1 ? void 0 : s ? nP(e, t) : e, n = r.length - 1, a; n >= 0; n--)
    (a = r[n]) && (i = (s ? a(e, t, i) : a(i)) || i);
  return s && i && iP(e, t, i), i;
};
class Cp {
  /**
   * Use await MetaController.init(roomNodeClient) instead
   */
  constructor(e, t, s) {
    h(this, "meta");
    this.meta = new cc(
      e,
      te.isV2AuthToken ? e.config.viewType : e.permissions.viewType,
      t,
      s
    ), this.setupEvents();
  }
  get roomName() {
    return this.meta.roomName;
  }
  setupEvents() {
    y.on(v.ROOM_JOINED, (e) => {
      e.startedAt && (this.meta.meetingStartedTimestamp = new Date(e.startedAt), this.meta.emit("meetingStartTimeUpdate", {
        meetingStartedTimestamp: this.meta.meetingStartedTimestamp
      }));
    }), y.on(v.ROOM_STATE, ({ createdAt: e }) => {
      const t = this.meta.meetingStartedTimestamp;
      if (e && !t) {
        const s = new Date(e * 1e3);
        this.meta.meetingStartedTimestamp = s, this.meta.emit("meetingStartTimeUpdate", {
          meetingStartedTimestamp: this.meta.meetingStartedTimestamp
        });
      }
    }), y.on(v.ROOM_NODE_CONNECTED, () => {
      this.meta.emit("connected");
    }), y.on(v.ROOM_NODE_DISCONNECTED, () => {
      this.meta.emit("disconnected");
    }), y.on(v.ICE_CONNECTED, ({ transport: e }) => {
      this.meta.emit("iceConnected", { transport: e });
    }), y.on(v.ICE_DISCONNECTED, ({ transport: e }) => {
      this.meta.emit("iceDisconnected", { transport: e });
    }), y.on(v.ICE_RECONNECTING, ({ transport: e }) => {
      this.meta.emit("iceReconnecting", { transport: e });
    }), y.on(v.ICE_FAILED, ({ transport: e }) => {
      this.meta.emit("iceFailed", { transport: e });
    }), y.on(v.PRODUCER_SCORE_UPDATE, ({ score: e }) => {
      e < 5 && this.meta.emit("poorConnection", { score: e });
    }), y.on(v.SOCKET_SERVICE_CONNECTED, () => {
      this.meta.emit("socketConnected");
    }), y.on(v.SOCKET_SERVICE_DISCONNECTED, () => {
      this.meta.emit("socketDisconnected");
    }), y.on(v.SOCKET_SERVICE_RECONNECTING, () => {
      this.meta.emit("socketReconnecting");
    }), y.on(
      v.SOCKET_SERVICE_RECONNECTION_ATTEMPT,
      ({ attempt: e }) => {
        this.meta.emit("socketReconnectAttempt", { attempt: e });
      }
    ), y.on(
      v.SOCKET_SERVICE_RECONNECT_FAILURE,
      ({ attempt: e }) => {
        this.meta.emit("socketReconnectFailure", { attempt: e });
      }
    ), y.on(v.SOCKET_SERVICE_RECONNECTED, () => {
      this.meta.emit("socketReconnected");
    }), y.on(v.SOCKET_SERVICE_FAILED, () => {
      this.meta.emit("socketFailure");
    }), y.on(
      v.ROOM_NODE_CONNECTION_ERROR,
      (e) => {
        const { message: t } = e;
        t.match(/room '([a-z0-9-]+)' not found/i) && this.meta.emit("connectionError", { reason: "ROOM_NOT_FOUND" });
      }
    );
  }
}
aP([
  _.trace("MetaController.setupEvents")
], Cp.prototype, "setupEvents", 1);
var oP = Object.defineProperty, cP = Object.getOwnPropertyDescriptor, dP = (r, e, t, s) => {
  for (var i = s > 1 ? void 0 : s ? cP(e, t) : e, n = r.length - 1, a; n >= 0; n--)
    (a = r[n]) && (i = (s ? a(e, t, i) : a(i)) || i);
  return s && i && oP(e, t, i), i;
};
const Ge = {
  getPeer: 14,
  getPeers: 15,
  chatMessage: 16,
  getRoomName: 17,
  getDisplayTitle: 18,
  getPluginInitiator: 19,
  customPluginEventToParent: 20,
  peerJoined: 22,
  peerLeft: 23,
  sendData: 24
};
var vt, rr, It, ki, Di, Ii, Tt, Dt, Gl;
let lc = (Gl = class extends Ue {
  constructor({
    baseURL: e,
    createdAt: t,
    description: s,
    id: i,
    name: n,
    organizationId: a,
    picture: o,
    private: d,
    published: p,
    staggered: l,
    tags: u,
    type: m,
    updatedAt: g
  }, T, S, R, D, I) {
    super();
    // eslint-disable-next-line class-methods-use-this
    b(this, Tt);
    b(this, vt, void 0);
    b(this, rr, void 0);
    h(this, "baseURL");
    h(this, "createdAt");
    h(this, "description");
    h(this, "id");
    h(this, "name");
    b(this, It, void 0);
    b(this, ki, void 0);
    b(this, Di, void 0);
    h(this, "organizationId");
    h(this, "picture");
    h(this, "private");
    h(this, "published");
    h(this, "staggered");
    h(this, "tags");
    h(this, "type");
    h(this, "updatedAt");
    h(this, "config");
    b(this, Ii, void 0);
    h(this, "active");
    h(this, "iframes");
    h(this, "enabledBy");
    this.baseURL = e, this.createdAt = new Date(t), this.description = s, this.id = i, this.name = n, P(this, It, R), this.organizationId = a, this.picture = o, this.private = d, this.published = p, this.staggered = l, this.tags = u, this.type = m, this.updatedAt = new Date(g), this.active = !1, this.iframes = /* @__PURE__ */ new Map(), P(this, vt, T), P(this, rr, S), P(this, ki, D), P(this, Di, I), this.enabledBy = "";
  }
  /**
   * Returns true if the local participant has joined the meeting.
   */
  get roomJoined() {
    var e;
    return ((e = c(this, Tt, Dt)) == null ? void 0 : e.roomJoined) === !0;
  }
  /**
   * @access private
   * This function forwards events to plugin. This is not meant for external use.
   * @param message Socket message forwarded to this plugin.
   */
  sendIframeEvent(e) {
    this.iframes.size && [...this.iframes.keys()].forEach((t) => {
      const { iframe: s } = this.iframes.get(t);
      s && s.contentWindow.postMessage(e, "*");
    });
  }
  async handleIframeMessage(e) {
    var n, a, o, d;
    let t;
    if (c(this, rr) === "socket-service") {
      const p = e, { payload: l, uuid: u, type: m } = p;
      switch (m) {
        case $.customPluginEventToRoom: {
          c(this, vt).customPluginEventToRoom(
            this.id,
            l,
            u
          );
          break;
        }
        case $.customPluginEventToPeers: {
          c(this, vt).customPluginEventToPeers(
            this.id,
            l,
            l.peerIds,
            u
          );
          break;
        }
        case $.enablePluginForRoom: {
          c(this, vt).enablePluginForRoom(
            this.id,
            u
          );
          break;
        }
        case $.enablePluginForPeers: {
          c(this, vt).enablePluginForPeers(
            this.id,
            l.peerIds,
            u
          );
          break;
        }
        case $.disablePluginForRoom: {
          c(this, vt).disablePluginForRoom(
            this.id,
            u
          );
          break;
        }
        case $.disablePluginForPeers: {
          c(this, vt).disablePluginForPeers(
            this.id,
            l.peerIds,
            u
          );
          break;
        }
        case $.storeInsertKeys: {
          c(this, vt).storeInsertKeys(
            this.id,
            l.store,
            l.insertKeys,
            u
          );
          break;
        }
        case $.storeGetKeys: {
          c(this, vt).storeGetKeys(
            this.id,
            l.store,
            l.getKeys,
            u
          );
          break;
        }
        case $.storeDeleteKeys: {
          c(this, vt).storeDeleteKeys(
            this.id,
            l.store,
            l.deleteKeys,
            u
          );
          break;
        }
        case $.storeDelete: {
          c(this, vt).storeDelete(
            this.id,
            l.store,
            u
          );
          break;
        }
        case Ge.chatMessage: {
          const {
            messagePayload: g,
            peerIds: T
          } = l;
          if (!c(this, Di)) {
            this.sendIframeEvent({
              type: Ge.chatMessage,
              uuid: p.uuid,
              payload: { error: "Chat is disabled for this room." }
            });
            return;
          }
          try {
            await c(this, Di).sendMessage(g, T), this.sendIframeEvent({
              type: Ge.chatMessage,
              uuid: p.uuid,
              payload: { success: !0 }
            });
          } catch (S) {
            this.sendIframeEvent({
              type: Ge.chatMessage,
              uuid: p.uuid,
              payload: {
                error: S
              }
            });
          }
          break;
        }
        case Ge.getPeer: {
          let g;
          const { peerId: T } = l, S = {
            ...c(this, It),
            isRecorder: (n = c(this, It).permissions) == null ? void 0 : n.isRecorder
          };
          T ? (g = c(this, ki).joined.get(l.peerId), c(this, It).id === T && (g = S)) : g = S, this.sendIframeEvent({
            type: Ge.getPeer,
            payload: { peer: g && Zo(g) },
            uuid: p.uuid
          });
          break;
        }
        case Ge.getPeers: {
          const g = c(this, ki).joined.toArray().map((T) => Zo(T));
          this.sendIframeEvent({
            type: Ge.getPeers,
            payload: { peers: g },
            uuid: p.uuid
          });
          break;
        }
        case Ge.getPluginInitiator: {
          this.sendIframeEvent({
            type: Ge.getPluginInitiator,
            payload: { enabledBy: this.enabledBy },
            uuid: p.uuid
          });
          break;
        }
        case Ge.getDisplayTitle: {
          this.sendIframeEvent({
            type: Ge.getDisplayTitle,
            payload: { displayTitle: c(this, Tt, Dt).meetingTitle },
            uuid: p.uuid
          });
          break;
        }
        case Ge.getRoomName: {
          this.sendIframeEvent({
            type: Ge.getRoomName,
            payload: { roomName: c(this, Tt, Dt).roomName },
            uuid: p.uuid
          });
          break;
        }
        case Ge.customPluginEventToParent: {
          this.emit(
            p.payload.eventName,
            p.payload.data
          );
          break;
        }
      }
      return;
    }
    const s = (p, l) => {
      if (c(this, It).userId === p)
        return c(this, It).id;
      let u;
      return l.forEach((m) => {
        m.userId === p && (u = m.id);
      }), u;
    }, i = e;
    switch (i.type) {
      case "pluginEvent":
      case "storePluginData":
      case "getPluginData":
      case "enablePluginForAll":
      case "enablePluginForUser":
      case "disablePluginForUser":
      case "chatMessage": {
        t = await c(this, Tt, Dt).sendMessage(i), this.sendIframeEvent(t);
        break;
      }
      case "getJoinedPeers": {
        t = await c(this, Tt, Dt).getRoomState(), this.sendIframeEvent({
          type: "websocket/get-joined-peers",
          payload: {
            ...i.payload,
            peers: t.payload.roomState.peers
          }
        });
        break;
      }
      case "getPeerInfo": {
        t = await c(this, Tt, Dt).sendMessage({
          type: i.type,
          payload: {
            ...i.payload,
            peerId: (o = (a = i.payload) == null ? void 0 : a.peerId) != null ? o : c(this, It).id
          }
        }), this.sendIframeEvent(t);
        break;
      }
      case "getRoomState": {
        t = await c(this, Tt, Dt).getRoomState();
        const { plugins: p, peers: l } = t.payload.roomState, { enabledBy: u } = p.find((g) => g.id === this.id), m = s(u, l);
        this.sendIframeEvent({
          type: "websocket/get-room-state",
          payload: {
            ...i.payload,
            roomName: t.payload.roomState.roomName,
            pluginInitiatorPeerId: m,
            pluginInitiatorUserId: u,
            peers: t.payload.roomState.peers,
            displayTitle: t.payload.roomState.displayTitle,
            roomUUID: t.payload.roomState.roomUUID,
            currentPeer: c(this, It).id,
            isRecorder: (d = c(this, It).permissions) == null ? void 0 : d.isRecorder
          }
        });
        break;
      }
      case "getPluginInitiatorId": {
        t = await c(this, Tt, Dt).getRoomState();
        const { plugins: p, peers: l } = t.payload.roomState, { enabledBy: u } = p.find((g) => g.id === this.id), m = s(u, l);
        this.sendIframeEvent({
          type: "websocket/get-plugin-initiator-peer-id",
          payload: {
            ...i.payload,
            pluginInitiatorPeerId: m
          }
        });
        break;
      }
      case "getPluginInitiatorUserId": {
        t = await c(this, Tt, Dt).getRoomState();
        const { plugins: p } = t.payload.roomState, { enabledBy: l } = p.find((u) => u.id === this.id);
        this.sendIframeEvent({
          type: "websocket/get-plugin-initiator-user-id",
          payload: {
            ...i.payload,
            pluginInitiatorUserId: l
          }
        });
        break;
      }
      case "pluginEventToParent": {
        this.emit(i.payload.eventName, i.payload.data);
        break;
      }
      case "toggleViewMode": {
        this.emit("toggleViewMode", i.payload.data);
        break;
      }
    }
  }
  /**
   * This method is used to send arbitrary data to the plugin.
   * @param payload The payload that you want to send inside the plugin.
   * @param payload.eventName Name of the event.
   * This is used to listen for the event in plugin SDK.
   * @param payload.data Data you wish to emit. It can assume any data type.
   */
  sendData(e) {
    if (c(this, rr) === "socket-service") {
      this.sendIframeEvent({
        type: Ge.sendData,
        uuid: "",
        payload: e
      });
      return;
    }
    this.sendIframeEvent({
      type: v.PLUGIN_INTERNAL_DATA,
      payload: {
        pluginId: this.id,
        data: e
      }
    });
  }
  /**
   * This method is used for cleaning up event listeners attached to an iframe. It must
   * be used before the iframe is removed from the DOM.
   * @param viewId ID of the view corresponding to this iframe. Default is 'default'.
   */
  removePluginView(e = "default") {
    var i;
    const { iframe: t, listener: s } = (i = this.iframes.get(e)) != null ? i : {};
    (t || s) && (window.removeEventListener("message", s), this.iframes.delete(e));
  }
  /**
   * This method adds the communcation layer between the plugin inside the iframe
   * and the core application (meeting object) in the main window.
   * @param iframe Iframe element to display this plugin.
   * @param viewId ID of the view corresponding to this iframe. Default is 'default'.
   */
  addPluginView(e, t = "default") {
    var o;
    if (!c(this, Ii))
      throw f.error("DytePlugin::addPluginView::no_auth_token_set_for_plugin"), new E("No auth token set for plugin.");
    if (!e)
      throw f.error("DytePlugin::addPluginView::iframe_was_not_provided"), new E("Iframe was not provided.");
    this.removePluginView(t);
    const s = e, i = new URL(this.baseURL), n = {
      auth: c(this, Ii),
      parent: !navigator.isReactNative && window.location.origin,
      backend: ue.apiBase,
      pluginId: this.id,
      roomName: (o = c(this, Tt, Dt).roomName) != null ? o : "",
      displayTitle: c(this, Tt, Dt).meetingTitle
    };
    Object.keys(n).forEach((d) => {
      i.searchParams.set(d, n[d]);
    }), s.src = i.href, s.allow = "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture", s.title = t;
    const a = async (d) => {
      d.source === e.contentWindow && await this.handleIframeMessage(d.data);
    };
    window.addEventListener("message", a), this.iframes.set(t, { iframe: s, listener: a });
  }
  setActive(e) {
    var t, s;
    if (this.active = e, e) {
      this.emit("stateUpdate", {
        active: this.active,
        pluginId: this.id,
        bind: this.addPluginView.bind(this),
        views: (t = this.config) == null ? void 0 : t.views
      });
      return;
    }
    this.active = !1, this.emit("stateUpdate", {
      active: this.active,
      pluginId: this.id,
      views: (s = this.config) == null ? void 0 : s.views
    });
  }
  /**
   * @access private
   * Not for external use
   */
  // NOTE(roerohan): Enable this plugin for the current user.
  async activateForSelf() {
    const e = ct(), t = await e.authorizePlugin(this.id);
    P(this, Ii, t);
    try {
      const s = await e.getPluginConfig(this.baseURL);
      this.config = s;
    } catch (s) {
      f.error("DytePlugin::activateForSelf", { error: s });
    }
    this.setActive(!0), this.emit("enabled");
  }
  /**
   * @access private
   * Not for external use
   */
  // NOTE(roerohan): Disable this plugin for the current user.
  deactivateForSelf() {
    [...this.iframes.keys()].forEach((e) => {
      this.removePluginView(e);
    }), this.iframes.clear(), this.setActive(!1), this.emit("closed");
  }
  /**
   * @deprecated
   */
  async enable() {
    return this.activateForSelf();
  }
  /**
   * @deprecated
   */
  disable() {
    return this.deactivateForSelf();
  }
  /**
   * Activate this plugin for all participants.
   */
  async activate() {
    var e, t;
    if ((t = (e = c(this, It).permissions) == null ? void 0 : e.plugins) != null && t.canStart) {
      if (c(this, rr) === "socket-service") {
        c(this, vt).addPlugin(this.id, this.staggered);
        return;
      }
      await c(this, Tt, Dt).addRoomPlugin(this);
    }
  }
  /**
   * Deactivate this plugin for all participants.
   */
  async deactivate() {
    var e, t;
    if ((t = (e = c(this, It).permissions) == null ? void 0 : e.plugins) != null && t.canClose) {
      if (c(this, rr) === "socket-service") {
        c(this, vt).removePlugin(this.id);
        return;
      }
      await c(this, Tt, Dt).removeRoomPlugin(this);
    }
  }
}, vt = new WeakMap(), rr = new WeakMap(), It = new WeakMap(), ki = new WeakMap(), Di = new WeakMap(), Ii = new WeakMap(), Tt = new WeakSet(), Dt = function() {
  return Be();
}, Gl);
lc = dP([
  ft((r) => {
    throw new E(r.message, "0600");
  })
], lc);
class Cl extends Yc {
  constructor() {
    super({
      onAddEvent: "pluginAdded",
      onDeleteEvent: "pluginDeleted"
    });
  }
  add(e, t = !0) {
    return super.add(e, t);
  }
  delete(e, t = !0, s = !1) {
    return super.delete(e, t, s);
  }
}
var lP = Object.defineProperty, uP = Object.getOwnPropertyDescriptor, pP = (r, e, t, s) => {
  for (var i = s > 1 ? void 0 : s ? uP(e, t) : e, n = r.length - 1, a; n >= 0; n--)
    (a = r[n]) && (i = (s ? a(e, t, i) : a(i)) || i);
  return s && i && lP(e, t, i), i;
};
let uc = class {
  constructor() {
    /**
     * All plugins accessible by the current user.
     */
    h(this, "all");
    /**
     * All plugins that are currently enabled in the room.
     */
    h(this, "active");
    this.all = new Cl(), this.active = new Cl();
  }
};
uc = pP([
  ft((r) => {
    throw new E(r.message, "0600");
  })
], uc);
var hP = Object.defineProperty, mP = Object.getOwnPropertyDescriptor, ri = (r, e, t, s) => {
  for (var i = s > 1 ? void 0 : s ? mP(e, t) : e, n = r.length - 1, a; n >= 0; n--)
    (a = r[n]) && (i = (s ? a(e, t, i) : a(i)) || i);
  return s && i && hP(e, t, i), i;
}, gs = /* @__PURE__ */ ((r) => (r[r.TEXT = 0] = "TEXT", r[r.IMAGE = 1] = "IMAGE", r[r.FILE = 2] = "FILE", r))(gs || {}), Xt;
class _r {
  constructor(e) {
    b(this, Xt, void 0);
    P(this, Xt, e);
  }
  getChatMessages() {
    return c(this, Xt).sendMessagePromise(
      Et.getMessages
    );
  }
  async getChatMessagesPaginated(e, t, s, i = 0) {
    const n = {
      timeStamp: e,
      size: t,
      from: i,
      reversed: s
    }, a = await c(this, Xt).sendMessagePromise(
      Et.getPaginatedMessages,
      YE.toBinary(n)
    );
    return a.payload ? XE.fromBinary(
      a.payload
    ) : {
      messages: [],
      next: !1
    };
  }
  sendMessageToRoom(e, t) {
    const s = {
      payloadType: t,
      payload: e
    };
    c(this, Xt).sendMessage(
      Et.sendMessageToRoom,
      rS.toBinary(s)
    );
  }
  sendMessageToPeers(e, t, s) {
    const i = {
      payloadType: t,
      peerIds: s,
      payload: e
    };
    c(this, Xt).sendMessage(
      Et.sendMessageToPeers,
      aS.toBinary(i)
    );
  }
  sendMessage(e, t, s) {
    if (s && s.length > 0) {
      this.sendMessageToPeers(
        e,
        t,
        s
      );
      return;
    }
    this.sendMessageToRoom(
      e,
      t
    );
  }
  editMessage(e, t, s, i) {
    const n = {
      chatId: e,
      pinned: i,
      payloadType: s,
      payload: t
    };
    c(this, Xt).sendMessage(
      Et.editMessage,
      dS.toBinary(n)
    );
  }
  deleteMessage(e) {
    c(this, Xt).sendMessage(
      Et.deleteMessage,
      pS.toBinary({ chatId: e })
    );
  }
  on(e, t) {
    let s, i;
    switch (e) {
      case Et.sendMessageToRoom: {
        s = Lo.fromBinary.bind(Lo), i = Lo.create();
        break;
      }
      case Et.sendMessageToPeers: {
        s = xo.fromBinary.bind(xo), i = xo.create();
        break;
      }
      case Et.editMessage: {
        s = Uo.fromBinary.bind(Uo), i = Uo.create();
        break;
      }
      case Et.deleteMessage: {
        s = Vo.fromBinary.bind(Vo), i = Vo.create();
        break;
      }
    }
    if (!s) {
      f.warn(`ChatSocketHandler::Event ${e} is not recognized`);
      return;
    }
    c(this, Xt).on(e, ({ payload: n }) => {
      let a = i;
      try {
        a = s(n);
      } catch (o) {
        f.error("chatSocketHandler::on::binary_decode_error", { error: o });
      }
      return t(a);
    });
  }
}
Xt = new WeakMap();
ri([
  _.trace("SocketService.getChatMessages")
], _r.prototype, "getChatMessages", 1);
ri([
  _.trace("SocketService.getChatMessagesPaginated")
], _r.prototype, "getChatMessagesPaginated", 1);
ri([
  _.trace("SocketService.sendMessageToRoom")
], _r.prototype, "sendMessageToRoom", 1);
ri([
  _.trace("SocketService.sendMessageToPeers")
], _r.prototype, "sendMessageToPeers", 1);
ri([
  _.trace("SocketService.sendMessage")
], _r.prototype, "sendMessage", 1);
ri([
  _.trace("SocketService.editMessage")
], _r.prototype, "editMessage", 1);
ri([
  _.trace("SocketService.deleteMessage")
], _r.prototype, "deleteMessage", 1);
var fP = Object.defineProperty, gP = Object.getOwnPropertyDescriptor, Ts = (r, e, t, s) => {
  for (var i = s > 1 ? void 0 : s ? gP(e, t) : e, n = r.length - 1, a; n >= 0; n--)
    (a = r[n]) && (i = (s ? a(e, t, i) : a(i)) || i);
  return s && i && fP(e, t, i), i;
};
const _i = ["text", "image", "file", "poll"];
var le, Ur, Ht, At, As, br, Wl;
let Qt = (Wl = class extends Ue {
  constructor(e, t, s, i) {
    super();
    // eslint-disable-next-line class-methods-use-this
    b(this, As);
    /**
     * An array of chat messages.
     */
    h(this, "messages");
    b(this, le, void 0);
    b(this, Ur, void 0);
    b(this, Ht, void 0);
    b(this, At, void 0);
    P(this, Ht, e), P(this, At, t), P(this, le, s), P(this, Ur, i), this.messages = [];
  }
  /**
   * Returns true if the local participant has joined the meeting.
   */
  get roomJoined() {
    var e;
    return ((e = c(this, As, br)) == null ? void 0 : e.roomJoined) === !0;
  }
  async sendTextMessage(e, t) {
    var i, n, a, o, d, p;
    if (!((n = (i = c(this, le).permissions) == null ? void 0 : i.chatPublic) != null && n.canSend) || !((o = (a = c(this, le).permissions) == null ? void 0 : a.chatPublic) != null && o.text))
      throw f.error("sendTextMessage::public_chat_permission_denied"), new E("Could not send message to public chat.", "0501");
    if (t && t.length > 0 && (!((d = c(this, le).permissions) != null && d.chatPrivate.canSend) || !((p = c(this, le).permissions) != null && p.chatPrivate.text)))
      throw f.error("sendTextMessage::private_chat_permission_denied"), new E("Could not send message to private chat.", "0501");
    if (!e)
      throw f.error("sendTextMessage::message_can_not_be_empty"), new E("Message can not be empty.", "0502");
    if (c(this, At) === "socket-service") {
      let l = [];
      t && t.length > 0 && (t.push(c(this, le).id), l = c(this, Ur).joined.toArray().filter((u) => t.includes(u.id)).map((u) => u.userId), l.push(c(this, le).userId)), c(this, Ht).sendMessage(
        e,
        gs.TEXT,
        t
      );
      return;
    }
    if (t !== void 0 && t.length > 0) {
      f.error("sendTextMessage::private_chat_unsupported");
      return;
    }
    const s = {
      userId: c(this, le).userId,
      displayName: c(this, le).name,
      message: e,
      type: _i.indexOf(
        "text"
        /* text */
      ),
      time: +new Date()
    };
    if (!this.roomJoined)
      throw f.error("DyteChat.sendTextMessage.RoomNodeClientSocketUsed_WithoutRoomJoin"), new E("Can`t sendTextMessage without joining room");
    await c(this, As, br).sendChatMessage(s);
  }
  async sendImageMessage(e, t) {
    var i, n, a, o, d, p;
    if (t && t.length > 0) {
      if (!((i = c(this, le).permissions) != null && i.chatPrivate.canSend) || !((n = c(this, le).permissions) != null && n.chatPrivate.files)) {
        f.error("sendImageMessage::private_chat_permission_denied");
        return;
      }
    } else if (!((o = (a = c(this, le).permissions) == null ? void 0 : a.chatPublic) != null && o.canSend) || !((p = (d = c(this, le).permissions) == null ? void 0 : d.chatPublic) != null && p.files)) {
      f.error("sendImageMessage::permission_denied");
      return;
    }
    if (!e) {
      f.error("sendImageMessage::required_argument_image_can_not_be_empty");
      return;
    }
    if (!["image/gif", "image/jpeg", "image/png"].includes(e.type)) {
      f.error("sendImageMessage::image_type_not_supported", { dyteChat: { imageType: e.type } });
      return;
    }
    try {
      const l = ct(), { getLocation: u, putLocation: m } = await l.getPresignedUrls(e.name);
      if (await l.uploadFile(e, m), c(this, At) === "socket-service") {
        let T = [];
        t && t.length > 0 && (t.push(c(this, le).id), T = c(this, Ur).joined.toArray().filter((S) => t.includes(S.id)).map((S) => S.userId), T.push(c(this, le).userId)), c(this, Ht).sendMessage(
          u,
          gs.IMAGE,
          t
        );
        return;
      }
      if (t !== void 0 && t.length > 0) {
        f.error("sendImageMessage::private_chat_unsupported");
        return;
      }
      const g = {
        userId: c(this, le).userId,
        displayName: c(this, le).name,
        type: _i.indexOf(
          "image"
          /* image */
        ),
        link: u,
        time: +new Date()
      };
      if (!this.roomJoined)
        throw f.error("DyteChat.sendImageMessage.RoomNodeClientSocketUsed_WithoutRoomJoin"), new E("Can`t sendImageMessage without joining room");
      await c(this, As, br).sendChatMessage(g);
    } catch (l) {
      throw new E("Error sending image message.");
    }
  }
  async sendFileMessage(e, t) {
    var s, i, n, a, o, d;
    if (t && t.length > 0) {
      if (!((s = c(this, le).permissions) != null && s.chatPrivate.canSend) || !((i = c(this, le).permissions) != null && i.chatPrivate.files)) {
        f.error("sendFileMessage::private_chat_permission_denied");
        return;
      }
    } else if (!((a = (n = c(this, le).permissions) == null ? void 0 : n.chatPublic) != null && a.canSend) || !((d = (o = c(this, le).permissions) == null ? void 0 : o.chatPublic) != null && d.files)) {
      f.error("sendFileMessage::permission_denied");
      return;
    }
    if (!e) {
      f.error("sendFileMessage::required_argument_file_can_not_be_empty");
      return;
    }
    try {
      const p = ct(), { getLocation: l, putLocation: u } = await p.getPresignedUrls(e.name);
      if (await p.uploadFile(e, u), c(this, At) === "socket-service") {
        let g = [];
        t && t.length > 0 && (t.push(c(this, le).id), g = c(this, Ur).joined.toArray().filter((S) => t.includes(S.id)).map((S) => S.userId), g.push(c(this, le).userId));
        const T = JSON.stringify({
          link: l,
          name: e.name,
          size: e.size
        });
        c(this, Ht).sendMessage(
          T,
          gs.FILE,
          t
        );
        return;
      }
      if (t !== void 0 && t.length > 0) {
        f.error("sendFileMessage::private_chat_unsupported");
        return;
      }
      const m = {
        userId: c(this, le).userId,
        displayName: c(this, le).name,
        type: _i.indexOf(
          "file"
          /* file */
        ),
        link: l,
        name: e.name,
        size: e.size,
        time: +new Date()
      };
      if (!this.roomJoined)
        throw f.error("DyteChat.sendFileMessage.RoomNodeClientSocketUsed_WithoutRoomJoin"), new E("Can`t sendFileMessage without joining room");
      await c(this, As, br).sendChatMessage(m);
    } catch (p) {
      throw new E("Error sending file message.");
    }
  }
  async sendMessage(e, t) {
    switch (e.type) {
      case "text":
        await this.sendTextMessage(e.message, t);
        break;
      case "image":
        await this.sendImageMessage(e.image, t);
        break;
      case "file":
        await this.sendFileMessage(e.file, t);
        break;
      default:
        f.error("sendMessage::message_type_not_supported", {
          dyteChat: { messageType: e.type }
        });
        break;
    }
  }
  async editTextMessage(e, t) {
    var s, i, n, a;
    if (c(this, At) !== "socket-service") {
      f.warn("editTextMessage::Coming soon!");
      return;
    }
    if (!((i = (s = c(this, le).permissions) == null ? void 0 : s.chatPublic) != null && i.canSend) || !((a = (n = c(this, le).permissions) == null ? void 0 : n.chatPublic) != null && a.text)) {
      f.error("editTextMessage::permission_denied");
      return;
    }
    if (!t) {
      f.error("editTextMessage::message_can_not_be_empty");
      return;
    }
    c(this, Ht).editMessage(
      e,
      t,
      gs.TEXT
    );
  }
  async editImageMessage(e, t) {
    var i, n, a, o;
    if (c(this, At) !== "socket-service") {
      f.warn("editImageMessage::Coming soon!");
      return;
    }
    if (!((n = (i = c(this, le).permissions) == null ? void 0 : i.chatPublic) != null && n.canSend) || !((o = (a = c(this, le).permissions) == null ? void 0 : a.chatPublic) != null && o.files)) {
      f.error("editImageMessage::permission_denied");
      return;
    }
    if (!t) {
      f.error("editImageMessage::required_argument_image_can_not_be_empty");
      return;
    }
    if (!["image/gif", "image/jpeg", "image/png"].includes(t.type)) {
      f.error("sendImageMessage::image_type_not_supported", {
        dyteChat: { imageType: t.type }
      });
      return;
    }
    try {
      const d = ct(), { getLocation: p, putLocation: l } = await d.getPresignedUrls(t.name);
      await d.uploadFile(t, l), c(this, Ht).editMessage(
        e,
        p,
        gs.IMAGE
      );
    } catch (d) {
      throw new E("Error editing image message.");
    }
  }
  async editFileMessage(e, t) {
    var s, i, n, a;
    if (c(this, At) !== "socket-service") {
      f.warn("editFileMessage::Coming soon!");
      return;
    }
    if (!((i = (s = c(this, le).permissions) == null ? void 0 : s.chatPublic) != null && i.canSend) || !((a = (n = c(this, le).permissions) == null ? void 0 : n.chatPublic) != null && a.files)) {
      f.error("sendFileMessage::permission_denied");
      return;
    }
    if (!t) {
      f.error("sendFileMessage::required_argument_file_can_not_be_empty");
      return;
    }
    try {
      const o = ct(), { getLocation: d, putLocation: p } = await o.getPresignedUrls(t.name);
      await o.uploadFile(t, p), c(this, Ht).editMessage(
        e,
        JSON.stringify({
          link: d,
          name: t.name,
          size: t.size
        }),
        gs.FILE
      );
    } catch (o) {
      throw new E("Error editing file message.");
    }
  }
  async editMessage(e, t) {
    if (c(this, At) !== "socket-service") {
      f.warn("editMessage::Coming soon!");
      return;
    }
    switch (t.type) {
      case "text": {
        this.editTextMessage(e, t.message);
        break;
      }
      case "image": {
        this.editImageMessage(e, t.image);
        break;
      }
      case "file": {
        this.editFileMessage(e, t.file);
        break;
      }
      default: {
        f.error("editMessage::message_type_not_supported", {
          dyteChat: { messageType: t.type }
        });
        break;
      }
    }
  }
  async deleteMessage(e) {
    if (c(this, At) !== "socket-service") {
      f.warn("editMessage::Coming soon!");
      return;
    }
    c(this, Ht).deleteMessage(e);
  }
  /**
   * Returns an array of messages sent by a specific userId.
   * @param userId The user id of the user that sent the message.
   */
  getMessagesByUser(e) {
    return this.messages.filter((t) => t.userId === e);
  }
  /**
   * Returns an array of 'text', 'image' or 'file' messages.
   * @param type 'text', 'image', or 'file'.
   */
  getMessagesByType(e) {
    return this.messages.filter((t) => t.type === e);
  }
  /**
   * Pins a chat message
   * @param id ID of the message to be pinned
   */
  async pin(e) {
    if (c(this, At) !== "socket-service") {
      if (!this.roomJoined)
        throw new E("Can`t pin message without joining room");
      await c(this, As, br).pinChatMessage({ id: e });
    }
  }
  /**
   * Unpins a chat message
   * @param id ID of the message to be unpinned
   */
  async unpin(e) {
    if (c(this, At) !== "socket-service") {
      if (!this.roomJoined)
        throw new E("Can`t unpin message without joining room");
      await c(this, As, br).unpinChatMessage({ id: e });
    }
  }
  /**
   * Gets chat messages in a paginated manner
   */
  async getMessages(e, t, s, i = 0) {
    const n = await c(this, Ht).getChatMessagesPaginated(e, t, s, i);
    return {
      messages: n.messages.map(
        (a) => ws.formatSocketServiceMessage(a)
      ),
      next: n.next
    };
  }
  /**
   * Returns an array of pinned messages.
   */
  get pinned() {
    return this.messages.filter((e) => e.pinned);
  }
}, le = new WeakMap(), Ur = new WeakMap(), Ht = new WeakMap(), At = new WeakMap(), As = new WeakSet(), br = function() {
  return Be();
}, Wl);
Ts([
  _.trace("DyteChat.sendTextMessage")
], Qt.prototype, "sendTextMessage", 1);
Ts([
  _.trace("DyteChat.sendImageMessage")
], Qt.prototype, "sendImageMessage", 1);
Ts([
  _.trace("DyteChat.sendFileMessage")
], Qt.prototype, "sendFileMessage", 1);
Ts([
  _.trace("DyteChat.sendMessage")
], Qt.prototype, "sendMessage", 1);
Ts([
  _.trace("DyteChat.editTextMessage")
], Qt.prototype, "editTextMessage", 1);
Ts([
  _.trace("DyteChat.editImageMessage")
], Qt.prototype, "editImageMessage", 1);
Ts([
  _.trace("DyteChat.editFileMessage")
], Qt.prototype, "editFileMessage", 1);
Ts([
  _.trace("DyteChat.editMessage")
], Qt.prototype, "editMessage", 1);
Ts([
  _.trace("DyteChat.deleteMessage")
], Qt.prototype, "deleteMessage", 1);
Qt = Ts([
  ft((r) => {
    throw new E(r.message, "0500");
  })
], Qt);
var _P = Object.defineProperty, vP = Object.getOwnPropertyDescriptor, TP = (r, e, t, s) => {
  for (var i = s > 1 ? void 0 : s ? vP(e, t) : e, n = r.length - 1, a; n >= 0; n--)
    (a = r[n]) && (i = (s ? a(e, t, i) : a(i)) || i);
  return s && i && _P(e, t, i), i;
}, In, pc, Ai, Jl;
const Yt = (Jl = class {
  constructor(r, e, t, s) {
    // eslint-disable-next-line class-methods-use-this
    b(this, In);
    h(this, "chat");
    h(this, "chatSocketHandler");
    h(this, "self");
    b(this, Ai, void 0);
    this.chatSocketHandler = r, P(this, Ai, e), this.chat = new Qt(
      r,
      e,
      t,
      s
    ), this.self = t, this.setupEvents();
  }
  /**
   * Returns true if the local participant has joined the meeting.
   */
  get roomJoined() {
    var r;
    return ((r = c(this, In, pc)) == null ? void 0 : r.roomJoined) === !0;
  }
  static async init(r, e, t, s) {
    const i = M.getValue(
      N.CHAT_SOCKET_SERVER
    );
    f.debug(`Received flagsmith chat_socket_server: ${i}`);
    const n = En("chat_socket_server") === "socket-service" || i === "socket-service" || s.includes("HIVE") ? "socket-service" : "room-node";
    return f.info(`Using socket server :: ${n} for chat`), new Yt(
      r,
      n,
      e,
      t
    );
  }
  static formatMessage(r) {
    return {
      ...r,
      time: new Date(r.time),
      type: _i[r.type]
    };
  }
  /**
   * @access private
   * This function formates the chat message coming from
   * socket service. This is not meant for external use.
   */
  static formatSocketServiceMessage(r) {
    const e = r.createdAt * 1e3, t = {
      displayName: r.displayName,
      id: r.chatId,
      time: e,
      timeMs: r.createdAtMs,
      type: r.payloadType,
      isEdited: r.isEdited,
      userId: r.userId,
      targetUserIds: r.targetUserIds,
      message: "",
      link: "",
      name: "",
      size: 0
    };
    switch (t.type) {
      case gs.TEXT: {
        t.message = r.payload;
        break;
      }
      case gs.IMAGE: {
        t.link = r.payload;
        break;
      }
      case gs.FILE: {
        const { link: s, name: i, size: n } = JSON.parse(r.payload);
        t.link = s, t.name = i, t.size = n;
        break;
      }
    }
    return Yt.formatMessage(t);
  }
  async getChatMessages() {
    if (this.self.config.viewType === "LIVESTREAM" || M.hasFeature(N.FEAT_PAGINATED_CHAT))
      return;
    if (c(this, Ai) === "socket-service") {
      const e = await this.chatSocketHandler.getChatMessages();
      if (!(e != null && e.payload))
        return;
      const t = tS.fromBinary(
        e.payload
      ).messages;
      this.chat.messages = t.map((s) => Yt.formatSocketServiceMessage(s));
      return;
    }
    if (!this.roomJoined) {
      f.error("ChatController.getChatMessages.RoomNodeClientSocketUsed_WithoutRoomJoin");
      return;
    }
    const { messages: r } = (await c(this, In, pc).getChatMessages()).payload;
    this.chat.messages = r.filter((e) => _i[e.type] !== "poll").map(Yt.formatMessage);
  }
  setupEvents() {
    c(this, Ai) === "socket-service" ? y.on(v.SOCKET_SERVICE_ROOM_JOINED, () => {
      this.getChatMessages();
    }) : y.onAsync(v.ROOM_JOINED, async () => {
      await this.getChatMessages();
    }), this.chatSocketHandler.on(
      Et.sendMessageToRoom,
      (r) => {
        const e = Yt.formatSocketServiceMessage(r.message);
        this.chat.messages = [...this.chat.messages, e], this.chat.emit("chatUpdate", {
          action: "add",
          message: e,
          messages: this.chat.messages
        });
      }
    ), this.chatSocketHandler.on(
      Et.sendMessageToPeers,
      (r) => {
        const e = Yt.formatSocketServiceMessage(r.message);
        this.chat.messages = [...this.chat.messages, e], this.chat.emit("chatUpdate", {
          action: "add",
          message: e,
          messages: this.chat.messages
        });
      }
    ), this.chatSocketHandler.on(
      Et.editMessage,
      (r) => {
        const e = Yt.formatSocketServiceMessage(r.message), t = this.chat.messages.findIndex((s) => s.id === e.id);
        t !== -1 && (this.chat.messages[t] = e, this.chat.emit("chatUpdate", {
          action: "edit",
          message: e,
          messages: this.chat.messages
        }));
      }
    ), this.chatSocketHandler.on(
      Et.deleteMessage,
      (r) => {
        const e = this.chat.messages.findIndex((s) => s.id === r.chatId);
        if (e === -1)
          return;
        const [t] = this.chat.messages.splice(e, 1);
        this.chat.emit("chatUpdate", {
          action: "delete",
          message: t,
          messages: this.chat.messages
        });
      }
    ), y.on(v.NEW_CHAT_MESSAGE, (r) => {
      if (_i[r == null ? void 0 : r.type] === "poll")
        return;
      const e = Yt.formatMessage(r);
      this.chat.messages = [...this.chat.messages, e], this.chat.emit("chatUpdate", {
        action: "add",
        message: e,
        messages: this.chat.messages
      });
    }), y.on(v.PIN_CHAT_MESSAGE, async (r) => {
      const e = Yt.formatMessage(r), t = this.chat.messages.findIndex((s) => s.id === e.id);
      this.chat.messages[t] = e, this.chat.emit("pinMessage", {
        message: e,
        messages: this.chat.messages
      });
    }), y.on(v.UNPIN_CHAT_MESSAGE, async (r) => {
      const e = Yt.formatMessage(r), t = this.chat.messages.findIndex((s) => s.id === e.id);
      this.chat.messages[t] = e, this.chat.emit("unpinMessage", {
        message: e,
        messages: this.chat.messages
      });
    });
  }
}, In = new WeakSet(), pc = function() {
  return Be();
}, Ai = new WeakMap(), Jl);
let ws = Yt;
TP([
  _.trace("ChatController.setupEvents")
], ws.prototype, "setupEvents", 1);
var yP = Object.defineProperty, EP = Object.getOwnPropertyDescriptor, SP = (r, e, t, s) => {
  for (var i = s > 1 ? void 0 : s ? EP(e, t) : e, n = r.length - 1, a; n >= 0; n--)
    (a = r[n]) && (i = (s ? a(e, t, i) : a(i)) || i);
  return s && i && yP(e, t, i), i;
}, Bt, Mi, Oi, An, hc, Kl;
const kp = (Kl = class {
  constructor(r, e, t, s) {
    // eslint-disable-next-line class-methods-use-this
    b(this, An);
    h(this, "plugins");
    b(this, Bt, void 0);
    b(this, Mi, void 0);
    b(this, Oi, void 0);
    P(this, Bt, r), P(this, Oi, e), P(this, Mi, t), this.plugins = s, this.setupEvents();
  }
  /**
   * Returns true if the local participant has joined the meeting.
   */
  get roomJoined() {
    var r;
    return ((r = c(this, An, hc)) == null ? void 0 : r.roomJoined) === !0;
  }
  static async init(r, e, t, s, i, n, a) {
    const o = M.getValue(
      N.PLUGIN_SOCKET_SERVER
    );
    f.debug(`Received flagsmith plugin_socket_server:: ${o}`);
    const d = o === "socket-service" || a.includes("HIVE") ? "socket-service" : "room-node";
    f.info(`Using socket server ${d} for plugin`);
    const p = new uc();
    return r.forEach((l) => {
      const u = new lc(
        l,
        e,
        d,
        i,
        n,
        s
      );
      p.all.add(u);
    }), i.config.isV2 === !1 && i.config.setDisabledPlugins(p.all.toArray().map((l) => l.id)), new kp(
      e,
      t,
      d,
      p
    );
  }
  async getRoomPlugins() {
    if (c(this, Mi) === "socket-service") {
      const { plugins: e } = await c(this, Bt).getActivePlugins();
      await Promise.all(
        e.map((t) => this.enablePlugin({
          id: t.pluginId,
          enabledBy: t.enabledBy
        }))
      );
      return;
    }
    if (!this.roomJoined) {
      f.error("PluginController.getRoomPlugins.RoomNodeClientSocketUsed_WithoutRoomJoin");
      return;
    }
    const { payload: r } = await c(this, An, hc).getRoomState();
    await Promise.all(
      r.roomState.plugins.map(
        (e) => this.enablePlugin(e)
      )
    );
  }
  async enablePlugin({ id: r, enabledBy: e }) {
    const t = this.plugins.all.get(r);
    t && (await t.activateForSelf(), t.enabledBy = e);
  }
  async disablePlugin({ id: r }) {
    const e = this.plugins.all.get(r);
    e && e.deactivateForSelf();
  }
  sendIframeEventOld(r, e) {
    const { id: t } = e, s = this.plugins.all.get(t);
    s && s.sendIframeEvent({ type: r, payload: e });
  }
  sendIframeEvent(r, e, t, s) {
    const i = this.plugins.all.get(e);
    e && i.sendIframeEvent({ type: r, uuid: t, payload: s });
  }
  broadcastIframeEventOld(r, e) {
    this.plugins.active.forEach((t) => {
      this.sendIframeEventOld(r, { ...e, id: t.id });
    });
  }
  broadcastIframeEvent(r, e) {
    this.plugins.active.forEach((t) => {
      this.sendIframeEvent(r, t.id, "", e);
    });
  }
  setupEvents() {
    if (this.plugins.all.on("stateUpdate", ({ active: r, id: e }) => {
      if (r) {
        this.plugins.active.add(this.plugins.all.get(e));
        return;
      }
      this.plugins.active.delete(e);
    }), y.onAsync(v.ROOM_JOINED, async () => {
      await this.getRoomPlugins(), f.debug("[ROOM_JOINED] resolved request to fetch plugins.");
    }), c(this, Mi) === "socket-service") {
      c(this, Bt).on(
        $.addPlugin,
        async (r) => {
          var t;
          const e = r.pluginId;
          (t = this.plugins.all.get(e)) != null && t.active || await this.enablePlugin({ id: e, enabledBy: r.enabledBy });
        }
      ), c(this, Bt).on(
        $.removePlugin,
        async (r) => {
          var t;
          const e = r.pluginId;
          (t = this.plugins.all.get(e)) != null && t.active && await this.disablePlugin({ id: e });
        }
      ), [
        $.enablePluginForPeers,
        $.enablePluginForRoom
      ].forEach((r) => {
        c(this, Bt).on(r, async (e, t) => {
          this.sendIframeEvent(
            r,
            e.pluginId,
            t,
            {
              enabledBy: e.enabledBy
            }
          );
        });
      }), [
        $.disablePluginForPeers,
        $.disablePluginForRoom
      ].forEach((r) => {
        c(this, Bt).on(r, async (e, t) => {
          this.sendIframeEvent(
            r,
            e.pluginId,
            t,
            {
              disabledBy: e.disabledBy
            }
          );
        });
      }), [
        $.customPluginEventToPeers,
        $.customPluginEventToRoom
      ].forEach((r) => {
        c(this, Bt).on(r, async (e, t) => {
          this.sendIframeEvent(
            r,
            e.pluginId,
            t,
            {
              data: JSON.parse(
                new TextDecoder().decode(e.pluginData)
              )
            }
          );
        });
      }), [
        $.storeInsertKeys,
        $.storeGetKeys,
        $.storeDeleteKeys
      ].forEach((r) => {
        c(this, Bt).on(
          r,
          async (e, t) => {
            var i;
            const s = (i = e.storeItems) == null ? void 0 : i.map((n) => ({
              timestamp: n.timestamp,
              peerId: n.peerId,
              payload: JSON.parse(
                n.payload ? new TextDecoder().decode(n.payload) : "{}"
              ),
              key: n.storeKey
            }));
            this.sendIframeEvent(
              r,
              e.pluginId,
              t,
              {
                storeName: e.storeName,
                storeItems: s
              }
            );
          }
        );
      }), c(this, Bt).on(
        $.storeDelete,
        async (r, e) => {
          this.sendIframeEvent(
            $.storeDelete,
            r.pluginId,
            e,
            {
              storeName: r.storeName
            }
          );
        }
      ), c(this, Oi).on(
        Et.sendMessageToPeers,
        (r) => {
          const e = ws == null ? void 0 : ws.formatSocketServiceMessage(r.message);
          this.broadcastIframeEvent(
            Ge.chatMessage,
            { message: e }
          );
        }
      ), c(this, Oi).on(
        Et.sendMessageToRoom,
        (r) => {
          const e = ws == null ? void 0 : ws.formatSocketServiceMessage(r.message);
          this.broadcastIframeEvent(
            Ge.chatMessage,
            { message: e }
          );
        }
      ), y.on(v.PEER_JOINED, (r) => {
        this.broadcastIframeEvent(Ge.peerJoined, r);
      }), y.on(v.PEER_CLOSED, (r) => {
        this.broadcastIframeEvent(Ge.peerLeft, r);
      });
      return;
    }
    y.on(v.ENABLE_PLUGIN, async ({ id: r, enabledBy: e }) => {
      await this.enablePlugin({ id: r, enabledBy: e });
    }), y.on(v.DISABLE_PLUGIN, async ({ id: r }) => {
      await this.disablePlugin({ id: r });
    }), [
      v.PLUGIN_DATA,
      v.PLUGIN_EVENT
    ].forEach((r) => {
      y.on(r, (e) => {
        this.sendIframeEventOld(r, e);
      });
    }), [
      v.PEER_JOINED,
      v.PEER_CLOSED,
      v.NEW_CHAT_MESSAGE
    ].forEach((r) => {
      y.on(r, (e) => {
        this.broadcastIframeEventOld(r, e);
      });
    });
  }
}, Bt = new WeakMap(), Mi = new WeakMap(), Oi = new WeakMap(), An = new WeakSet(), hc = function() {
  return Be();
}, Kl);
let Dp = kp;
SP([
  _.trace("PluginController.setupEvents")
], Dp.prototype, "setupEvents", 1);
function wP() {
  ae.isElectron() && window.dyteElectronGetDisplayMediaSource && (navigator.mediaDevices.getDisplayMedia = async (r) => {
    const e = await window.dyteElectronGetDisplayMediaSource({
      types: ["window", "screen"]
    });
    let t = !1;
    if (r.video) {
      const n = r.video;
      t = {
        mandatory: {
          chromeMediaSource: "desktop",
          chromeMediaSourceId: e.id,
          maxWidth: n.width.max,
          maxHeight: n.height.max
        }
      };
    }
    const s = {
      audio: !1,
      video: t
    };
    return await navigator.mediaDevices.getUserMedia(s);
  });
}
var RP = Object.defineProperty, bP = Object.getOwnPropertyDescriptor, PP = (r, e, t, s) => {
  for (var i = s > 1 ? void 0 : s ? bP(e, t) : e, n = r.length - 1, a; n >= 0; n--)
    (a = r[n]) && (i = (s ? a(e, t, i) : a(i)) || i);
  return s && i && RP(e, t, i), i;
}, Ni, Ea, Ms, Li, xi, zl;
let mc = (zl = class extends Ue {
  constructor(e, t, s) {
    super();
    // eslint-disable-next-line class-methods-use-this
    b(this, Ni);
    /**
     * An array of poll items.
     */
    h(this, "items");
    b(this, Ms, void 0);
    b(this, Li, void 0);
    b(this, xi, void 0);
    P(this, Ms, e), P(this, Li, t), P(this, xi, s), this.items = [];
  }
  /**
   * Returns true if the local participant has joined the meeting.
   */
  get roomJoined() {
    var e;
    return ((e = c(this, Ni, Ea)) == null ? void 0 : e.roomJoined) === !0;
  }
  /**
   * Creates a poll in the meeting.
   * @param question The question that is to be voted for.
   * @param options The options of the poll.
   * @param anonymous If true, the poll votes are anonymous.
   * @param hideVotes If true, the votes on the poll are hidden.
   */
  async create(e, t, s = !1, i = !1) {
    if (c(this, Ms).config.viewType !== "LIVESTREAM" && !this.roomJoined)
      throw new E("Can't create polls without joining room");
    if (!c(this, Ms).permissions.polls.canCreate) {
      f.error("DytePolls::create::permission_denied");
      return;
    }
    if (!e || !t) {
      f.error("DytePolls::question_and_options_can_not_be_empty", {
        dytePolls: {
          hasQuestion: !!e,
          optionsLength: t == null ? void 0 : t.length
        }
      });
      return;
    }
    if (t.length < 2) {
      f.error("DytePolls::there_must_be_at_least_two_options", {
        dytePolls: { hasQuestion: !!e, optionsLength: t.length }
      });
      return;
    }
    if (c(this, xi) === "socket-service") {
      await c(this, Li).createPoll(
        e,
        t,
        s,
        i
      );
      return;
    }
    const n = {
      question: e,
      options: t,
      anonymous: s,
      hideVotes: i,
      createdBy: c(this, Ms).name,
      createdByUserId: c(this, Ms).userId
    };
    await c(this, Ni, Ea).newPoll(n);
  }
  /**
   * Casts a vote on an existing poll.
   * @param pollId The ID of the poll that is to be voted on.
   * @param index The index of the option.
   */
  async vote(e, t) {
    if (!c(this, Ms).permissions.polls.canVote) {
      f.error("DytePolls::vote::permission_denied");
      return;
    }
    if (c(this, xi) === "socket-service") {
      await c(this, Li).votePoll(
        e,
        t
      );
      return;
    }
    const s = {
      pollId: e,
      index: t
    };
    await c(this, Ni, Ea).votePoll(s);
  }
}, Ni = new WeakSet(), Ea = function() {
  return Be();
}, Ms = new WeakMap(), Li = new WeakMap(), xi = new WeakMap(), zl);
mc = PP([
  ft((r) => {
    throw new E(r.message, "0700");
  })
], mc);
var CP = Object.defineProperty, kP = Object.getOwnPropertyDescriptor, DP = (r, e, t, s) => {
  for (var i = s > 1 ? void 0 : s ? kP(e, t) : e, n = r.length - 1, a; n >= 0; n--)
    (a = r[n]) && (i = (s ? a(e, t, i) : a(i)) || i);
  return s && i && CP(e, t, i), i;
}, Mn, ir, Ui, On, fc, Ql;
const li = (Ql = class {
  constructor(r, e, t) {
    // eslint-disable-next-line class-methods-use-this
    b(this, On);
    h(this, "polls");
    b(this, Mn, void 0);
    b(this, ir, void 0);
    b(this, Ui, void 0);
    this.polls = new mc(r, e, t), P(this, Mn, r), P(this, ir, e), P(this, Ui, t), this.setupEvents();
  }
  static async init(r, e, t) {
    const s = M.getValue(
      N.POLL_SOCKET_SERVER
    );
    f.debug(`Received flagsmith poll_socket_server: ${s}`);
    const i = En("poll_socket_server") === "socket-service" || s === "socket-service" || t.includes("HIVE") ? "socket-service" : "room-node";
    return f.info(`Using socket server ${i} for polls`), new li(
      r,
      e,
      i
    );
  }
  canViewPolls() {
    return c(this, Mn).permissions.polls.canView;
  }
  setupEvents() {
    if (c(this, Ui) === "socket-service") {
      if (!this.canViewPolls())
        return;
      y.on(v.SOCKET_SERVICE_ROOM_JOINED, () => {
        this.getPolls();
      }), c(this, ir).on(Ss.createPoll, (r) => {
        r.poll && this.updatePoll(
          li.formatSocketServicePoll(r.poll)
        );
      }), c(this, ir).on(Ss.updatePoll, (r) => {
        r.poll && this.updatePoll(
          li.formatSocketServicePoll(r.poll)
        );
      }), c(this, ir).on(Ss.votePoll, (r) => {
        r.poll && this.updatePoll(
          li.formatSocketServicePoll(r.poll)
        );
      });
    } else
      y.onAsync(v.ROOM_JOINED, async () => {
        this.canViewPolls() && this.getPolls();
      });
    y.on(v.UPDATE_POLL, async ({ poll: r }) => {
      this.updatePoll(r);
    });
  }
  updatePoll(r) {
    if (!this.canViewPolls())
      return;
    const e = this.polls.items.findIndex((t) => t.id === r.id);
    if (e > -1) {
      const t = JSON.stringify(this.polls.items[e]);
      this.polls.items[e] = r, t !== JSON.stringify(r) && this.polls.emit("pollsUpdate", { polls: this.polls.items, newPoll: !1 });
      return;
    }
    this.polls.items = [...this.polls.items, r], this.polls.emit("pollsUpdate", { polls: this.polls.items, newPoll: !0 });
  }
  async getPolls() {
    if (c(this, Ui) === "socket-service") {
      const r = await c(this, ir).getPolls();
      if (!(r != null && r.payload))
        return;
      const { polls: e } = aR.fromBinary(
        r.payload
      );
      this.polls.items = e.map((t) => li.formatSocketServicePoll(t));
      return;
    }
    if (c(this, On, fc) instanceof fe) {
      const { polls: r } = (await c(this, On, fc).getPolls()).payload;
      this.polls.items = Object.values(r);
    }
  }
  static formatSocketServicePoll(r) {
    const e = r.options.map((t) => ({
      count: t.count,
      text: t.text,
      votes: t.votes.map((s) => ({
        id: s.userId,
        name: s.name
      }))
    }));
    return {
      anonymous: r.anonymous,
      createdBy: r.createdBy,
      createdByUserId: r.createdByUserId,
      hideVotes: r.hideVotes,
      id: r.pollId,
      options: e,
      question: r.question,
      voted: r.votes
    };
  }
}, Mn = new WeakMap(), ir = new WeakMap(), Ui = new WeakMap(), On = new WeakSet(), fc = function() {
  return Be();
}, Ql);
let Ip = li;
DP([
  _.trace("PollController.setupEvents")
], Ip.prototype, "setupEvents", 1);
class kl extends Yc {
  constructor() {
    super({
      onAddEvent: "remoteRequestAdd",
      onDeleteEvent: "remoteRequestRemove"
    });
  }
  add(e, t = !0) {
    return super.add(e, t);
  }
  delete(e, t = !0, s = !1) {
    return super.delete(e, t, s);
  }
}
var nr, ui, Vr, Nn;
const Ka = class extends Ue {
  constructor(t, s) {
    super();
    // eslint-disable-next-line class-methods-use-this
    b(this, nr);
    h(this, "incomingRequests");
    h(this, "outgoingRequests");
    h(this, "active");
    b(this, Vr, void 0);
    b(this, Nn, void 0);
    P(this, Nn, s), P(this, Vr, t), this.incomingRequests = new kl(), this.outgoingRequests = new kl(), this.active = null, this.mouseEvent = this.mouseEvent.bind(this), this.keyboardEvent = this.keyboardEvent.bind(this);
  }
  /**
   * Sends a request to a peer for remote control.
   * @param peerId The peer that needs to receive the remote control request
   * @returns request identifier for the control request.
   */
  async requestControl(t) {
    var o;
    if (!c(this, Nn).joined.get(t))
      throw new E("Invalid peer.");
    const i = (o = this.outgoingRequests) == null ? void 0 : o.toArray().find((d) => d.hostPeerId === t);
    if (i)
      return i.id;
    const n = so(), a = new wn({
      requestId: n,
      hostPeerId: t,
      remotePeerId: c(this, Vr).id,
      state: gi.PENDING
    });
    return this.outgoingRequests.add(a), await c(this, nr, ui).requestRemoteControl(a), this.emit("remoteUpdate", {
      payload: {
        request: {
          id: a.id,
          hostPeerId: a.hostPeerId,
          remotePeerId: a.remotePeerId
        }
      },
      type: xs.REQUEST_SENT
    }), n;
  }
  /**
   * Accepts a remote control request from a peer.
   * @param requestId The request identifier that needs to be accepted
   */
  async acceptControl(t) {
    var i;
    if (((i = this.active) == null ? void 0 : i.id) === t)
      return;
    const s = this.incomingRequests.get(t);
    if (!s)
      throw new E("No request found.");
    s.state = gi.ACCEPTED, this.endControl(), this.active = s, c(this, nr, ui).acceptRemoteControl(s), this.emit("remoteUpdate", {
      payload: {
        request: {
          id: this.active.id,
          hostPeerId: this.active.hostPeerId,
          remotePeerId: this.active.remotePeerId
        }
      },
      type: xs.INCOMING_REQUEST_ACCEPTED
    });
  }
  /**
   * End an active remote control.
   */
  async endControl() {
    if (!this.active)
      return;
    const t = { ...this.active };
    c(this, nr, ui).terminateRemoteControl(
      this.active.hostPeerId === c(this, Vr).id ? this.active.remotePeerId : this.active.hostPeerId,
      this.active
    ), this.active = null, this.emit("remoteUpdate", {
      payload: {
        request: {
          id: t.id,
          hostPeerId: t.hostPeerId,
          remotePeerId: t.remotePeerId
        }
      },
      type: t.hostPeerId === c(this, Vr).id ? xs.INCOMING_REQUEST_ENDED : xs.OUTGOING_REQUEST_ENDED
    });
  }
  async keyboardEvent(t) {
    if (!this.active)
      return;
    const s = Ka.getFormattedKeyboardEvent(t);
    if (s) {
      const i = {
        eventType: Sn.KEYBOARD,
        keyboardEvent: s
      };
      c(this, nr, ui).sendEventRemoteControl(this.active.hostPeerId, this.active.id, i);
    }
  }
  async mouseEvent(t, s) {
    if (!this.active)
      return;
    const i = Ka.getFormattedRemoteMouseEvent(t, s);
    if (i) {
      const n = {
        eventType: Sn.MOUSE,
        mouseEvent: i
      };
      c(this, nr, ui).sendEventRemoteControl(this.active.hostPeerId, this.active.id, n);
    }
  }
  static getFormattedRemoteMouseEvent(t, s) {
    const i = s.getBoundingClientRect();
    return {
      type: t.type,
      position: {
        x: Math.floor(t.x - i.left),
        y: Math.floor(t.y - i.top)
      },
      boundingRect: {
        width: i.width,
        height: i.height
      }
    };
  }
  static getFormattedKeyboardEvent(t) {
    return t.type === "keydown" ? {
      type: t.type,
      key: t.key
    } : null;
  }
};
let gc = Ka;
nr = new WeakSet(), ui = function() {
  return Be();
}, Vr = new WeakMap(), Nn = new WeakMap();
var Ln, za;
const Qa = class {
  constructor(e, t) {
    h(this, "remote");
    h(this, "hostPeetId");
    h(this, "remotePeetId");
    h(this, "remoteRequestTokens");
    h(this, "activeRemoteToken");
    b(this, Ln, void 0);
    b(this, za, void 0);
    P(this, Ln, e), P(this, za, t), this.hostPeetId = e.id, this.remote = new gc(e, t), this.setupEvents();
  }
  setupEvents() {
    y.on(v.MESSAGE, (e) => {
      var t;
      if (e.remoteRequestType === Ls.REQUEST && (this.remote.incomingRequests.add(new wn({
        requestId: e.remoteRequestId,
        hostPeerId: e.hostPeerId,
        remotePeerId: e.remotePeerId,
        state: gi.PENDING
      })), this.remote.emit("remoteUpdate", {
        payload: {
          request: {
            id: e.remoteRequestId,
            hostPeerId: e.hostPeerId,
            remotePeerId: e.remotePeerId
          }
        },
        type: xs.REQUEST_RECEIVED
      })), e.remoteRequestType === Ls.ACCEPT) {
        const s = this.remote.outgoingRequests.get(e.remoteRequestId);
        if (!s)
          throw new E("There is no pending remote control request to accept.");
        this.remote.endControl(), s.state = gi.ACCEPTED, this.remote.active = new wn({
          requestId: e.remoteRequestId,
          hostPeerId: e.hostPeerId,
          remotePeerId: e.remotePeerId,
          state: gi.ACCEPTED
        }), this.remote.emit("remoteUpdate", {
          payload: {
            request: {
              id: e.remoteRequestId,
              hostPeerId: e.hostPeerId,
              remotePeerId: e.remotePeerId
            }
          },
          type: xs.OUTGOING_REQUEST_ACCEPTED
        });
      }
      e.remoteRequestType === Ls.END && (((t = this.remote.active) == null ? void 0 : t.id) === e.remoteRequestId && (this.remote.active = null), this.remote.emit("remoteUpdate", {
        payload: {
          request: {
            id: e.remoteRequestId,
            hostPeerId: e.hostPeerId,
            remotePeerId: e.remotePeerId
          }
        },
        type: e.hostPeerId === c(this, Ln).id ? xs.INCOMING_REQUEST_ENDED : xs.OUTGOING_REQUEST_ENDED
      })), e.remoteRequestType === Ls.EVENT && this.remote.active && this.remote.active.id === e.remoteRequestId && window.DyteRobot && (e.remoteEvent.eventType === Sn.MOUSE ? Qa.executeMouseEvent(e.remoteEvent.mouseEvent) : e.remoteEvent.eventType === Sn.KEYBOARD && Qa.executeKeyboardEvent(e.remoteEvent.keyboardEvent));
    }), y.on(v.PEER_CLOSED, ({ id: e }) => {
      var t, s, i, n, a, o, d, p;
      [
        (s = (t = this.remote) == null ? void 0 : t.active) == null ? void 0 : s.hostPeerId,
        (n = (i = this.remote) == null ? void 0 : i.active) == null ? void 0 : n.remotePeerId
      ].includes(e) && this.remote.endControl(), (o = (a = this.remote) == null ? void 0 : a.incomingRequests) == null || o.toArray().forEach((l) => {
        [l.hostPeerId, l.remotePeerId].includes(e) && this.remote.incomingRequests.delete(l.id);
      }), (p = (d = this.remote) == null ? void 0 : d.outgoingRequests) == null || p.toArray().forEach((l) => {
        [l.hostPeerId, l.remotePeerId].includes(e) && this.remote.outgoingRequests.delete(l.id);
      });
    });
  }
  static executeMouseEvent(e) {
    const t = window.screen.width * e.position.x / e.boundingRect.width, s = window.screen.height * e.position.y / e.boundingRect.height, i = {
      width: window.screen.width,
      height: window.screen.height
    };
    switch (e.type) {
      case Ta.LEFT_CLICK:
        window.DyteRobot.mouse.leftClick(t, s, i);
        break;
      case Ta.RIGHT_CLICK:
        window.DyteRobot.mouse.rightClick(t, s, i);
        break;
      case Ta.MOVE:
        window.DyteRobot.mouse.moveTo(t, s, i);
        break;
    }
  }
  static executeKeyboardEvent(e) {
    switch (e.type) {
      case "keydown":
        window.DyteRobot.keyboard.press(e.key);
        break;
    }
  }
};
let _c = Qa;
Ln = new WeakMap(), za = new WeakMap();
var IP = Object.defineProperty, AP = (r, e, t) => e in r ? IP(r, e, { enumerable: !0, configurable: !0, writable: !0, value: t }) : r[e] = t, MP = (r, e, t) => (AP(r, typeof e != "symbol" ? e + "" : e, t), t), Zc = (r, e, t) => {
  if (!e.has(r))
    throw TypeError("Cannot " + t);
}, C = (r, e, t) => (Zc(r, e, "read from private field"), t ? t.call(r) : e.get(r)), Le = (r, e, t) => {
  if (e.has(r))
    throw TypeError("Cannot add the same private member more than once");
  e instanceof WeakSet ? e.add(r) : e.set(r, t);
}, Oe = (r, e, t, s) => (Zc(r, e, "write to private field"), s ? s.call(r, t) : e.set(r, t), t), He = (r, e, t) => (Zc(r, e, "access private method"), t), Ws, Pr, Cr, xe, pi, Pe, Ke, Js, We, Rs, Gt, vi, bs, vc, Ap, un, Sa, Tc, Mp, Xc, Op, Ti, Rn, Va, ed, Fa, td, yi, bn, fn, ja, sd = { exports: {} }, Ei = typeof Reflect == "object" ? Reflect : null, Dl = Ei && typeof Ei.apply == "function" ? Ei.apply : function(e, t, s) {
  return Function.prototype.apply.call(e, t, s);
}, wa;
Ei && typeof Ei.ownKeys == "function" ? wa = Ei.ownKeys : Object.getOwnPropertySymbols ? wa = function(e) {
  return Object.getOwnPropertyNames(e).concat(Object.getOwnPropertySymbols(e));
} : wa = function(e) {
  return Object.getOwnPropertyNames(e);
};
function OP(r) {
  console && console.warn && console.warn(r);
}
var Np = Number.isNaN || function(e) {
  return e !== e;
};
function Ee() {
  Ee.init.call(this);
}
sd.exports = Ee;
sd.exports.once = UP;
Ee.EventEmitter = Ee;
Ee.prototype._events = void 0;
Ee.prototype._eventsCount = 0;
Ee.prototype._maxListeners = void 0;
var Il = 10;
function vo(r) {
  if (typeof r != "function")
    throw new TypeError('The "listener" argument must be of type Function. Received type ' + typeof r);
}
Object.defineProperty(Ee, "defaultMaxListeners", {
  enumerable: !0,
  get: function() {
    return Il;
  },
  set: function(r) {
    if (typeof r != "number" || r < 0 || Np(r))
      throw new RangeError('The value of "defaultMaxListeners" is out of range. It must be a non-negative number. Received ' + r + ".");
    Il = r;
  }
});
Ee.init = function() {
  (this._events === void 0 || this._events === Object.getPrototypeOf(this)._events) && (this._events = /* @__PURE__ */ Object.create(null), this._eventsCount = 0), this._maxListeners = this._maxListeners || void 0;
};
Ee.prototype.setMaxListeners = function(e) {
  if (typeof e != "number" || e < 0 || Np(e))
    throw new RangeError('The value of "n" is out of range. It must be a non-negative number. Received ' + e + ".");
  return this._maxListeners = e, this;
};
function Lp(r) {
  return r._maxListeners === void 0 ? Ee.defaultMaxListeners : r._maxListeners;
}
Ee.prototype.getMaxListeners = function() {
  return Lp(this);
};
Ee.prototype.emit = function(e) {
  for (var t = [], s = 1; s < arguments.length; s++)
    t.push(arguments[s]);
  var i = e === "error", n = this._events;
  if (n !== void 0)
    i = i && n.error === void 0;
  else if (!i)
    return !1;
  if (i) {
    var a;
    if (t.length > 0 && (a = t[0]), a instanceof Error)
      throw a;
    var o = new Error("Unhandled error." + (a ? " (" + a.message + ")" : ""));
    throw o.context = a, o;
  }
  var d = n[e];
  if (d === void 0)
    return !1;
  if (typeof d == "function")
    Dl(d, this, t);
  else
    for (var p = d.length, l = jp(d, p), s = 0; s < p; ++s)
      Dl(l[s], this, t);
  return !0;
};
function xp(r, e, t, s) {
  var i, n, a;
  if (vo(t), n = r._events, n === void 0 ? (n = r._events = /* @__PURE__ */ Object.create(null), r._eventsCount = 0) : (n.newListener !== void 0 && (r.emit("newListener", e, t.listener ? t.listener : t), n = r._events), a = n[e]), a === void 0)
    a = n[e] = t, ++r._eventsCount;
  else if (typeof a == "function" ? a = n[e] = s ? [t, a] : [a, t] : s ? a.unshift(t) : a.push(t), i = Lp(r), i > 0 && a.length > i && !a.warned) {
    a.warned = !0;
    var o = new Error("Possible EventEmitter memory leak detected. " + a.length + " " + String(e) + " listeners added. Use emitter.setMaxListeners() to increase limit");
    o.name = "MaxListenersExceededWarning", o.emitter = r, o.type = e, o.count = a.length, OP(o);
  }
  return r;
}
Ee.prototype.addListener = function(e, t) {
  return xp(this, e, t, !1);
};
Ee.prototype.on = Ee.prototype.addListener;
Ee.prototype.prependListener = function(e, t) {
  return xp(this, e, t, !0);
};
function NP() {
  if (!this.fired)
    return this.target.removeListener(this.type, this.wrapFn), this.fired = !0, arguments.length === 0 ? this.listener.call(this.target) : this.listener.apply(this.target, arguments);
}
function Up(r, e, t) {
  var s = { fired: !1, wrapFn: void 0, target: r, type: e, listener: t }, i = NP.bind(s);
  return i.listener = t, s.wrapFn = i, i;
}
Ee.prototype.once = function(e, t) {
  return vo(t), this.on(e, Up(this, e, t)), this;
};
Ee.prototype.prependOnceListener = function(e, t) {
  return vo(t), this.prependListener(e, Up(this, e, t)), this;
};
Ee.prototype.removeListener = function(e, t) {
  var s, i, n, a, o;
  if (vo(t), i = this._events, i === void 0)
    return this;
  if (s = i[e], s === void 0)
    return this;
  if (s === t || s.listener === t)
    --this._eventsCount === 0 ? this._events = /* @__PURE__ */ Object.create(null) : (delete i[e], i.removeListener && this.emit("removeListener", e, s.listener || t));
  else if (typeof s != "function") {
    for (n = -1, a = s.length - 1; a >= 0; a--)
      if (s[a] === t || s[a].listener === t) {
        o = s[a].listener, n = a;
        break;
      }
    if (n < 0)
      return this;
    n === 0 ? s.shift() : LP(s, n), s.length === 1 && (i[e] = s[0]), i.removeListener !== void 0 && this.emit("removeListener", e, o || t);
  }
  return this;
};
Ee.prototype.off = Ee.prototype.removeListener;
Ee.prototype.removeAllListeners = function(e) {
  var t, s, i;
  if (s = this._events, s === void 0)
    return this;
  if (s.removeListener === void 0)
    return arguments.length === 0 ? (this._events = /* @__PURE__ */ Object.create(null), this._eventsCount = 0) : s[e] !== void 0 && (--this._eventsCount === 0 ? this._events = /* @__PURE__ */ Object.create(null) : delete s[e]), this;
  if (arguments.length === 0) {
    var n = Object.keys(s), a;
    for (i = 0; i < n.length; ++i)
      a = n[i], a !== "removeListener" && this.removeAllListeners(a);
    return this.removeAllListeners("removeListener"), this._events = /* @__PURE__ */ Object.create(null), this._eventsCount = 0, this;
  }
  if (t = s[e], typeof t == "function")
    this.removeListener(e, t);
  else if (t !== void 0)
    for (i = t.length - 1; i >= 0; i--)
      this.removeListener(e, t[i]);
  return this;
};
function Vp(r, e, t) {
  var s = r._events;
  if (s === void 0)
    return [];
  var i = s[e];
  return i === void 0 ? [] : typeof i == "function" ? t ? [i.listener || i] : [i] : t ? xP(i) : jp(i, i.length);
}
Ee.prototype.listeners = function(e) {
  return Vp(this, e, !0);
};
Ee.prototype.rawListeners = function(e) {
  return Vp(this, e, !1);
};
Ee.listenerCount = function(r, e) {
  return typeof r.listenerCount == "function" ? r.listenerCount(e) : Fp.call(r, e);
};
Ee.prototype.listenerCount = Fp;
function Fp(r) {
  var e = this._events;
  if (e !== void 0) {
    var t = e[r];
    if (typeof t == "function")
      return 1;
    if (t !== void 0)
      return t.length;
  }
  return 0;
}
Ee.prototype.eventNames = function() {
  return this._eventsCount > 0 ? wa(this._events) : [];
};
function jp(r, e) {
  for (var t = new Array(e), s = 0; s < e; ++s)
    t[s] = r[s];
  return t;
}
function LP(r, e) {
  for (; e + 1 < r.length; e++)
    r[e] = r[e + 1];
  r.pop();
}
function xP(r) {
  for (var e = new Array(r.length), t = 0; t < e.length; ++t)
    e[t] = r[t].listener || r[t];
  return e;
}
function UP(r, e) {
  return new Promise(function(t, s) {
    function i(a) {
      r.removeListener(e, n), s(a);
    }
    function n() {
      typeof r.removeListener == "function" && r.removeListener("error", i), t([].slice.call(arguments));
    }
    $p(r, e, n, { once: !0 }), e !== "error" && VP(r, i, { once: !0 });
  });
}
function VP(r, e, t) {
  typeof r.on == "function" && $p(r, "error", e, t);
}
function $p(r, e, t, s) {
  if (typeof r.on == "function")
    s.once ? r.once(e, t) : r.on(e, t);
  else if (typeof r.addEventListener == "function")
    r.addEventListener(e, function i(n) {
      s.once && r.removeEventListener(e, i), t(n);
    });
  else
    throw new TypeError('The "emitter" argument must be of type EventEmitter. Received type ' + typeof r);
}
var FP = sd.exports;
class jP extends w {
  constructor() {
    super("message.v1.SocketMessage", [
      { no: 1, name: "event", kind: "scalar", T: 13 },
      { no: 2, name: "id", kind: "scalar", opt: !0, T: 9 },
      { no: 3, name: "payload", kind: "scalar", opt: !0, T: 12 },
      { no: 4, name: "metadata", kind: "scalar", opt: !0, T: 12 }
    ]);
  }
}
const Al = new jP();
class Hp {
  static encode(e) {
    return Al.toBinary(e);
  }
  static decode(e) {
    return Al.fromBinary(new Uint8Array(e));
  }
}
function $P(r, e) {
  return Math.floor(Math.random() * (e - r + 1) + r);
}
class HP {
  constructor(e = {}) {
    MP(this, "opts"), Le(this, Ws, void 0), this.opts = {
      initialTimeout: e.initialTimeout || 1e3,
      maxTimeout: e.maxTimeout || 1e4,
      factor: e.factor || 2
    }, Oe(this, Ws, 0);
  }
  async wait() {
    Oe(this, Ws, C(this, Ws) + 1);
    const e = $P(0, Math.min(this.opts.maxTimeout, this.opts.initialTimeout * 2 ** C(this, Ws)));
    await new Promise((t) => {
      setTimeout(t, e);
    });
  }
  getAttempts() {
    return C(this, Ws);
  }
  reset() {
    Oe(this, Ws, 0);
  }
}
Ws = /* @__PURE__ */ new WeakMap();
const qs = {
  debug: 0,
  info: 1,
  warn: 2,
  error: 3
};
class BP {
  constructor(e) {
    Le(this, Pr, void 0), Le(this, Cr, void 0), Oe(this, Pr, console), Oe(this, Cr, e);
  }
  debug(...e) {
    qs[C(this, Cr)] > qs.debug || C(this, Pr).debug("[Sockrates]:", ...e);
  }
  info(...e) {
    qs[C(this, Cr)] > qs.info || C(this, Pr).info("[Sockrates]:", ...e);
  }
  warn(...e) {
    qs[C(this, Cr)] > qs.warn || C(this, Pr).warn("[Sockrates]:", ...e);
  }
  error(...e) {
    qs[C(this, Cr)] > qs.error || C(this, Pr).error("[Sockrates]:", ...e);
  }
}
Pr = /* @__PURE__ */ new WeakMap();
Cr = /* @__PURE__ */ new WeakMap();
var Bp = /* @__PURE__ */ ((r) => (r[r.CONNECTING = 0] = "CONNECTING", r[r.OPEN = 1] = "OPEN", r[r.CLOSING = 2] = "CLOSING", r[r.CLOSED = 3] = "CLOSED", r))(Bp || {});
const qP = "2", GP = "3";
class WP {
  constructor(e, t) {
    Le(this, vc), Le(this, un), Le(this, Tc), Le(this, Xc), Le(this, Ti), Le(this, Va), Le(this, Fa), Le(this, yi), Le(this, fn), Le(this, xe, void 0), Le(this, pi, void 0), Le(this, Pe, void 0), Le(this, Ke, void 0), Le(this, Js, void 0), Le(this, We, void 0), Le(this, Rs, void 0), Le(this, Gt, void 0), Le(this, vi, void 0), Le(this, bs, void 0);
    var s, i, n, a, o, d, p, l, u, m, g, T, S, R, D, I, re, ge, Me;
    Oe(this, pi, e), Oe(this, Js, []), Oe(this, We, new FP()), Oe(this, Rs, !0), Oe(this, Gt, !1), Oe(this, Pe, t != null ? t : {}), (i = (s = C(this, Pe)).autoReconnect) != null || (s.autoReconnect = !0), (a = (n = C(this, Pe)).retryConnectionInterval) != null || (n.retryConnectionInterval = 1e3), (d = (o = C(this, Pe)).pingTimeout) != null || (o.pingTimeout = 3e4), (l = (p = C(this, Pe)).connectionTimeout) != null || (p.connectionTimeout = 5e3), (m = (u = C(this, Pe)).debug) != null || (u.debug = !0), (T = (g = C(this, Pe)).maxReconnectionAttempts) != null || (g.maxReconnectionAttempts = 10), (R = (S = C(this, Pe)).disconnectOnPingTimeout) != null || (S.disconnectOnPingTimeout = !0), (I = (D = C(this, Pe)).queueOnDisconnect) != null || (D.queueOnDisconnect = !1), (ge = (re = C(this, Pe)).flushOnReconnect) != null || (re.flushOnReconnect = !1), Oe(this, Ke, (Me = C(this, Pe).logger) != null ? Me : new BP(C(this, Pe).debug ? "debug" : "info")), Oe(this, bs, new HP());
  }
  get readyState() {
    return C(this, xe).readyState;
  }
  get url() {
    return C(this, pi);
  }
  get config() {
    return C(this, Pe);
  }
  get sendQueue() {
    return C(this, Js);
  }
  flush() {
    if (!C(this, Pe).queueOnDisconnect)
      return !1;
    const e = [];
    return C(this, Js).forEach((t) => {
      this.send(t.event, t.id, t.payload, t.metadata) || e.push(t);
    }), Oe(this, Js, e), C(this, Js);
  }
  async connect() {
    if (C(this, Rs) !== !1)
      return new Promise((e, t) => {
        He(this, yi, bn).call(this), He(this, fn, ja).call(this);
        try {
          Oe(this, xe, new WebSocket(He(this, vc, Ap).call(this, C(this, pi)))), C(this, xe).binaryType = "arraybuffer", C(this, Ke).debug("Connecting to", C(this, pi));
          const s = setTimeout(() => {
            C(this, Ke).debug("Connection timeout. Closing socket"), Oe(this, Rs, !0), He(this, fn, ja).call(this), C(this, xe).close(3001, "Connection Timeout"), C(this, Pe).autoReconnect && !C(this, Gt) && (C(this, We).emit("reconnecting"), He(this, Ti, Rn).call(this)), t(new Error("Connection timed out!"));
          }, C(this, Pe).connectionTimeout);
          C(this, xe).onopen = () => {
            C(this, Ke).debug(`Ready State: ${Bp[C(this, xe).readyState]}`), s && clearTimeout(s), He(this, Fa, td).call(this), C(this, We).emit("connected"), C(this, Pe).flushOnReconnect && this.flush(), e();
          }, C(this, xe).onclose = (i) => {
            try {
              s && clearTimeout(s);
              const { code: n, reason: a } = i;
              if (t(a), C(this, Ke).debug("Socket closed. Close event:", i), C(this, Ke).debug("Connection closed code:", n), C(this, Ke).debug("Connection closed reason:", a), C(this, Rs) && n !== 1e3 && C(this, Pe).autoReconnect && !C(this, Gt)) {
                C(this, We).emit("reconnecting"), He(this, Ti, Rn).call(this);
                return;
              }
              C(this, Gt) || C(this, We).emit("disconnected", { code: n, reason: a });
            } catch (n) {
              He(this, un, Sa).call(this, n);
            }
          }, C(this, xe).onerror = (i) => {
            He(this, un, Sa).call(this, i);
          }, C(this, xe).onmessage = (i) => He(this, Tc, Mp).call(this, i);
        } catch (s) {
          He(this, un, Sa).call(this, s, t);
        }
      });
  }
  send(e, t, s, i) {
    const n = { event: e, id: t, payload: s, metadata: i };
    if (C(this, Pe).queueOnDisconnect && (!C(this, xe) || C(this, xe).readyState !== 1))
      return C(this, Ke).debug("Queuing message since socket is not connected!", n), C(this, Js).push(n), !1;
    const a = Hp.encode(n);
    return He(this, Va, ed).call(this, a);
  }
  emit(e, t, s, i) {
    return this.send(e, t, s, i);
  }
  receive(e, t) {
    return C(this, We).on(e.toString(), t);
  }
  on(e, t) {
    if (typeof e == "string" && (e === "connected" || e === "disconnected" || e === "errored" || e === "reconnected" || e === "reconnecting" || e === "reconnectAttempt" || e === "reconnectFailure" || e === "failed")) {
      C(this, We).on(e, t);
      return;
    }
    this.receive(e, t);
  }
  removeAllListeners() {
    C(this, We).removeAllListeners();
  }
  removeReceiver(e, t) {
    this.removeListener(e, t);
  }
  removeListener(e, t) {
    C(this, We).removeListener(e.toString(), t);
  }
  removeReceivers(e) {
    this.removeListeners(e);
  }
  removeListeners(e) {
    C(this, We).listeners(e.toString()).map((t) => this.removeListener(e, t));
  }
  disconnect() {
    Oe(this, Rs, !1), He(this, yi, bn).call(this), this.removeAllListeners(), C(this, xe).close(1e3, "Sockrates disconnect method called.");
  }
}
xe = /* @__PURE__ */ new WeakMap();
pi = /* @__PURE__ */ new WeakMap();
Pe = /* @__PURE__ */ new WeakMap();
Ke = /* @__PURE__ */ new WeakMap();
Js = /* @__PURE__ */ new WeakMap();
We = /* @__PURE__ */ new WeakMap();
Rs = /* @__PURE__ */ new WeakMap();
Gt = /* @__PURE__ */ new WeakMap();
vi = /* @__PURE__ */ new WeakMap();
bs = /* @__PURE__ */ new WeakMap();
vc = /* @__PURE__ */ new WeakSet();
Ap = function(r) {
  if (r.startsWith("ws://") || r.startsWith("wss://"))
    return r;
  if (r.startsWith("https://"))
    return `wss://${r.substring(8)}`;
  if (r.startsWith("http://"))
    return `ws://${r.substring(7)}`;
  throw new Error("Invalid URL. URL must start with http(s):// or ws(s)://.");
};
un = /* @__PURE__ */ new WeakSet();
Sa = function(r, e) {
  C(this, Ke).error("Error:", r), C(this, We).emit("errored", { error: r }), e == null || e(r);
};
Tc = /* @__PURE__ */ new WeakSet();
Mp = function(r) {
  if (r.data === qP) {
    C(this, Ke).debug("Received ping from server"), He(this, Fa, td).call(this), He(this, Va, ed).call(this, GP);
    return;
  }
  C(this, Ke).debug("Received data:", r.data);
  const e = Hp.decode(r.data), { id: t, payload: s } = e;
  C(this, We).emit(e.event.toString(), { id: t, payload: s });
};
Xc = /* @__PURE__ */ new WeakSet();
Op = function() {
  return C(this, xe).readyState === 1;
};
Ti = /* @__PURE__ */ new WeakSet();
Rn = async function(r = !0) {
  if (r && C(this, Gt)) {
    C(this, Ke).debug("Reconnect called when already in a reconnect loop. Ignoring.");
    return;
  }
  if (C(this, Gt) || C(this, bs).reset(), C(this, Pe).maxReconnectionAttempts !== null && C(this, bs).getAttempts() >= C(this, Pe).maxReconnectionAttempts) {
    C(this, We).emit("failed"), Oe(this, Gt, !1);
    return;
  }
  Oe(this, Gt, !0), He(this, fn, ja).call(this), He(this, yi, bn).call(this);
  try {
    if (await C(this, bs).wait(), C(this, Rs) === !1)
      return;
    if (C(this, Ke).debug(`Reconnection attempt ${C(this, bs).getAttempts()}`), C(this, We).emit("reconnectAttempt", { attempt: C(this, bs).getAttempts() }), await this.connect(), !He(this, Xc, Op).call(this))
      throw Error("Reconnect Failed");
    Oe(this, Gt, !1), C(this, We).emit("reconnected");
  } catch (e) {
    C(this, Ke).debug("Failed to reconnect."), C(this, We).emit("reconnectFailure", { attempt: C(this, bs).getAttempts() }), He(this, Ti, Rn).call(this, !1);
  }
};
Va = /* @__PURE__ */ new WeakSet();
ed = function(r) {
  try {
    return C(this, xe).send(r), !0;
  } catch (e) {
    return C(this, Ke).error(e.message), !1;
  }
};
Fa = /* @__PURE__ */ new WeakSet();
td = function() {
  this.config.disconnectOnPingTimeout && (C(this, Ke).debug("Resetting ping timeout"), He(this, yi, bn).call(this), Oe(this, vi, setTimeout(() => {
    var r;
    C(this, Ke).debug("Disconnecting the socket due to ping timeout"), Oe(this, Rs, !0);
    const e = 3002, t = "Ping timeout";
    (r = C(this, xe)) == null || r.close(e, t), C(this, We).emit("disconnected", { code: e, reason: t }), C(this, Pe).autoReconnect && !C(this, Gt) && (C(this, Ke).debug("Triggering reconnection due to ping timeout"), C(this, We).emit("reconnecting"), He(this, Ti, Rn).call(this));
  }, C(this, Pe).pingTimeout)));
};
yi = /* @__PURE__ */ new WeakSet();
bn = function() {
  C(this, vi) && (clearTimeout(C(this, vi)), Oe(this, vi, void 0));
};
fn = /* @__PURE__ */ new WeakSet();
ja = function() {
  C(this, xe) && (C(this, xe).onopen = void 0, C(this, xe).onerror = void 0, C(this, xe).onmessage = void 0, C(this, xe).onclose = void 0);
};
var JP = Object.defineProperty, KP = Object.getOwnPropertyDescriptor, To = (r, e, t, s) => {
  for (var i = s > 1 ? void 0 : s ? KP(e, t) : e, n = r.length - 1, a; n >= 0; n--)
    (a = r[n]) && (i = (s ? a(e, t, i) : a(i)) || i);
  return s && i && JP(e, t, i), i;
};
const Ml = 65535;
var Vi, yt, xn, Un, yc;
class ra {
  constructor({
    peerId: e,
    roomName: t,
    authToken: s,
    url: i,
    capabilities: n
  }) {
    b(this, Un);
    b(this, Vi, void 0);
    b(this, yt, void 0);
    b(this, xn, void 0);
    h(this, "roomName");
    h(this, "peerId");
    h(this, "authToken");
    h(this, "capabilities");
    var u;
    if (!e || !t || !s)
      throw new E("peerId, roomName, or authToken can not be empty");
    const { apiBase: a } = ue;
    let o = a.includes("staging.dyte") ? "socket-staging.dyte.io" : "socket-edge.dyte.io";
    typeof En("socket_server_base") == "string" && (o = En("socket_server_base"));
    const d = `wss://${o}`;
    this.roomName = t, this.peerId = e, this.authToken = s, this.capabilities = n;
    const p = new URL(`${i != null ? i : d}/ws`), l = {
      roomID: t,
      peerID: e,
      authToken: s,
      useMediaV2: n.includes("HIVE"),
      ping: n.includes("PING"),
      capabilities: n.map((m) => Ua[m]).join(" ")
    };
    Object.entries(l).forEach(([m, g]) => {
      p.searchParams.append(m, g.toString());
    }), P(this, Vi, p.href), P(this, xn, e), P(this, yt, new WP(c(this, Vi), {
      autoReconnect: !0,
      disconnectOnPingTimeout: (u = n.includes("PING")) != null ? u : !1,
      queueOnDisconnect: !0,
      flushOnReconnect: !1,
      logger: f
    }));
  }
  get url() {
    return c(this, Vi);
  }
  async connect() {
    const e = () => {
      f.info("SocketService::connect::Connected to socket-edge"), y.emit(v.SOCKET_SERVICE_CONNECTED);
    };
    this.onStateEvent("connected", e);
    const t = ({ reason: d, code: p }) => {
      f.info("SocketService::connect::Disconnected from socket-edge", { error: { code: p, reason: d } }), y.emit(v.SOCKET_SERVICE_DISCONNECTED), !(p < 4e3 || p > 4002) && (p === 4e3 ? f.error("SocketService::connect::Bad Request", { error: { code: p, reason: d } }) : p === 4001 ? f.error("SocketService::connect::Unauthorized", { error: { code: p, reason: d } }) : p === 4002 ? f.error("SocketService::connect::Internal Error", { error: { code: p, reason: d } }) : f.error("SocketService::connect::Unknown Error", { error: { code: p, reason: d } }));
    };
    this.onStateEvent("disconnected", t);
    const s = () => {
      f.info("SocketService::connect::Reconnecting to socket-edge"), y.emit(v.SOCKET_SERVICE_RECONNECTING);
    };
    this.onStateEvent("reconnecting", s);
    const i = ({ attempt: d }) => {
      f.info("SocketService::connect::Attempting reconnect to socket-edge"), y.emit(v.SOCKET_SERVICE_RECONNECTION_ATTEMPT, { attempt: d });
    };
    this.onStateEvent("reconnectAttempt", i);
    const n = ({ attempt: d }) => {
      f.info("SocketService::connect::Reconnect attempt failed"), y.emit(v.SOCKET_SERVICE_RECONNECT_FAILURE, { attempt: d });
    };
    this.onStateEvent("reconnectFailure", n);
    const a = () => {
      f.info("SocketService::connect::Reconnected to socket-edge"), y.emit(v.SOCKET_SERVICE_RECONNECTED);
    };
    this.onStateEvent("reconnected", a);
    const o = () => {
      f.info("SocketService::connect::Socket-edge reconnects failed"), y.emit(v.SOCKET_SERVICE_FAILED);
    };
    this.onStateEvent("failed", o), await c(this, yt).connect();
  }
  disconnect() {
    return c(this, yt).disconnect();
  }
  get isConnected() {
    try {
      return c(this, yt).readyState === 1;
    } catch (e) {
      return !1;
    }
  }
  sendMessage(e, t, s) {
    const i = {};
    return _.injectContext(i), c(this, yt).send(
      e,
      s != null ? s : ca(this, Un, yc).call(this),
      t,
      new TextEncoder().encode(JSON.stringify(i))
    );
  }
  sendMessagePromise(e, t, s) {
    const i = parseInt({}.SOCKET_SERVICE_MESSAGE_REQUEST_TIMEOUT, 10) || 2e4;
    return this.sendMessagePromiseWithTimeout({
      event: e,
      timeout: i,
      protobuf: t,
      messageId: s
    });
  }
  sendMessagePromiseWithTimeout({
    event: e,
    timeout: t,
    protobuf: s,
    messageId: i
  }) {
    return new Promise((n, a) => {
      const o = i != null ? i : ca(this, Un, yc).call(this), d = {};
      _.injectContext(d), setTimeout(a, t, "request timeout for callback");
      const p = ({ id: l, payload: u }) => {
        o === l && (n({ id: l, payload: u }), c(this, yt).removeListener(e, p), c(this, yt).removeListener(Ml, p));
      };
      c(this, yt).on(e, p), c(this, yt).on(Ml, p), c(this, yt).send(
        e,
        o,
        s,
        new TextEncoder().encode(JSON.stringify(d))
      );
    });
  }
  on(e, t) {
    c(this, yt).on(e, t);
  }
  onStateEvent(e, t) {
    c(this, yt).on(e, t);
  }
  flush() {
    return c(this, yt).flush();
  }
}
Vi = new WeakMap(), yt = new WeakMap(), xn = new WeakMap(), Un = new WeakSet(), yc = function() {
  return `${c(this, xn)}-${(Math.random() + 1).toString(36).substring(7)}`;
};
To([
  _.trace("SocketService.connect")
], ra.prototype, "connect", 1);
To([
  _.trace("SocketService.disconnect")
], ra.prototype, "disconnect", 1);
To([
  _.trace("SocketService.sendMessage")
], ra.prototype, "sendMessage", 1);
To([
  _.trace("SocketService.sendMessagePromise")
], ra.prototype, "sendMessagePromise", 1);
var Xe;
class zP {
  constructor(e) {
    b(this, Xe, void 0);
    P(this, Xe, e);
  }
  addPlugin(e, t) {
    c(this, Xe).sendMessage(
      $.addPlugin,
      cw.toBinary({ pluginId: e, staggered: t })
    );
  }
  removePlugin(e) {
    c(this, Xe).sendMessage(
      $.removePlugin,
      lw.toBinary({ pluginId: e, staggered: !1 })
    );
  }
  async getActivePlugins() {
    const { payload: e } = await c(this, Xe).sendMessagePromise(
      $.getPlugins
    );
    return e ? Ow.fromBinary(e) : { plugins: [] };
  }
  customPluginEventToRoom(e, t, s) {
    const i = {
      pluginId: e,
      pluginData: new TextEncoder().encode(JSON.stringify(t))
    };
    c(this, Xe).sendMessage(
      $.customPluginEventToRoom,
      yw.toBinary(i),
      s
    );
  }
  customPluginEventToPeers(e, t, s, i) {
    const n = {
      pluginId: e,
      peerIds: t,
      pluginData: new TextEncoder().encode(JSON.stringify(s))
    };
    c(this, Xe).sendMessage(
      $.customPluginEventToPeers,
      Sw.toBinary(n),
      i
    );
  }
  enablePluginForRoom(e, t) {
    c(this, Xe).sendMessage(
      $.enablePluginForRoom,
      pw.toBinary({ pluginId: e }),
      t
    );
  }
  enablePluginForPeers(e, t, s) {
    c(this, Xe).sendMessage(
      $.enablePluginForPeers,
      gw.toBinary({ pluginId: e, peerIds: t }),
      s
    );
  }
  disablePluginForRoom(e, t) {
    c(this, Xe).sendMessage(
      $.disablePluginForRoom,
      mw.toBinary({ pluginId: e }),
      t
    );
  }
  disablePluginForPeers(e, t, s) {
    c(this, Xe).sendMessage(
      $.disablePluginForPeers,
      vw.toBinary({ pluginId: e, peerIds: t }),
      s
    );
  }
  storeInsertKeys(e, t, s, i) {
    const n = {
      pluginId: e,
      storeName: t,
      insertKeys: s.map((a) => ({
        storeKey: a.key,
        payload: new TextEncoder().encode(JSON.stringify(a.payload))
      }))
    };
    c(this, Xe).sendMessage(
      $.storeInsertKeys,
      vl.toBinary(n),
      i
    );
  }
  storeGetKeys(e, t, s, i) {
    const n = {
      pluginId: e,
      storeName: t,
      getKeys: s.map((a) => ({ storeKey: a.key }))
    };
    c(this, Xe).sendMessage(
      $.storeGetKeys,
      Pw.toBinary(n),
      i
    );
  }
  storeDeleteKeys(e, t, s, i) {
    const n = {
      pluginId: e,
      storeName: t,
      deleteKeys: s.map((a) => ({ storeKey: a.key }))
    };
    c(this, Xe).sendMessage(
      $.storeDeleteKeys,
      kw.toBinary(n),
      i
    );
  }
  storeDelete(e, t, s) {
    c(this, Xe).sendMessage(
      $.storeDelete,
      Iw.toBinary({ pluginId: e, storeName: t }),
      s
    );
  }
  /**
   * @deprecated
   */
  // eslint-disable-next-line class-methods-use-this
  getPluginDataOld(e, t) {
    f.info("getPluginDataOld", { plugin: { id: e, storeName: t } });
  }
  /**
   * @deprecated
   */
  storePluginDataOld(e, t, s) {
    const i = {
      pluginId: e,
      storeName: t,
      insertKeys: [{
        storeKey: s.key,
        payload: new TextEncoder().encode(JSON.stringify(s))
      }]
    };
    c(this, Xe).sendMessage(
      $.storeInsertKeys,
      vl.toBinary(i)
    );
  }
  on(e, t) {
    let s;
    switch (e) {
      case $.addPlugin:
      case $.enablePluginForPeers:
      case $.enablePluginForRoom: {
        s = ec.fromBinary.bind(ec);
        break;
      }
      case $.removePlugin:
      case $.disablePluginForPeers:
      case $.disablePluginForRoom: {
        s = Tl.fromBinary.bind(Tl);
        break;
      }
      case $.customPluginEventToPeers:
      case $.customPluginEventToRoom: {
        s = El.fromBinary.bind(El);
        break;
      }
      case $.storeInsertKeys:
      case $.storeGetKeys:
      case $.storeDeleteKeys:
      case $.storeDelete: {
        s = yl.fromBinary.bind(yl);
        break;
      }
    }
    c(this, Xe).on(e, ({ payload: i, id: n }) => {
      const a = s(i);
      return t(a, n);
    });
  }
}
Xe = new WeakMap();
var QP = Object.defineProperty, YP = Object.getOwnPropertyDescriptor, yo = (r, e, t, s) => {
  for (var i = s > 1 ? void 0 : s ? YP(e, t) : e, n = r.length - 1, a; n >= 0; n--)
    (a = r[n]) && (i = (s ? a(e, t, i) : a(i)) || i);
  return s && i && QP(e, t, i), i;
}, Fr, Yl;
let Ki = (Yl = class extends Ue {
  constructor(e) {
    super();
    b(this, Fr, void 0);
    h(this, "recordingState", "IDLE");
    h(this, "recordingId");
    h(this, "recordingPeerId");
    P(this, Fr, e);
  }
  setRecordingState(e) {
    const t = this.recordingState;
    this.recordingState = e, t !== e && this.emitCurrentRecordingState();
  }
  emitCurrentRecordingState() {
    this.emit("recordingUpdate", this.recordingState);
  }
  async start() {
    if (!c(this, Fr).permissions.canRecord)
      throw f.error("DyteRecording::start::permission_denied"), new E("User does not have permission to start recording");
    if (this.recordingState === "STARTING" || this.recordingState === "RECORDING" || this.recordingState === "STOPPING")
      throw f.error("DyteRecording::start::recording_in_progress", {
        recording: {
          state: this.recordingState
        }
      }), new E(`Cant start recording, recordingState irregular: ${this.recordingState}`);
    this.setRecordingState("STARTING");
    try {
      const e = ct(), { recording: t = {} } = ue.defaults, s = await e.startRecording(t);
      this.recordingId = s;
    } catch (e) {
      throw f.error("DyteRecording::stop::recording_failed_to_start", { error: e }), this.setRecordingState("IDLE"), new E("Error while starting recording");
    }
  }
  async stop() {
    if (!c(this, Fr).permissions.canRecord)
      throw f.error("DyteRecording::stop::permission_denied"), new E("User does not have permission to stop recording");
    if ((this.recordingState !== "RECORDING" || !this.recordingId) && (f.error("DyteRecording::stop::recording_not_in_progress", {
      recording: {
        state: this.recordingState,
        id: this.recordingId
      }
    }), await this.getRecordingId()), this.recordingState !== "RECORDING" || !this.recordingId)
      throw f.error("DyteRecording::stop::recording_not_in_progress", {
        recording: {
          state: this.recordingState,
          id: this.recordingId
        }
      }), new E(`Cant stop recording, recordingState irregular: ${this.recordingState}`);
    this.setRecordingState("STOPPING");
    try {
      await ct().stopRecording(this.recordingId), this.setRecordingState("IDLE");
    } catch (e) {
      throw f.error("DyteRecording::stop::recording_failed_to_stop", { error: e }), this.setRecordingState("RECORDING"), new E("Error while stopping recording");
    }
  }
  async getRecordingId() {
    if (!c(this, Fr).permissions.canRecord)
      throw f.error("DyteRecording::getRecordingId::permission_denied"), new E("User does not have permission to stop recording");
    try {
      const e = ct(), { status: t, id: s } = await e.getActiveRecording();
      t === "RECORDING" && (this.recordingState = "RECORDING", this.recordingId = s);
    } catch (e) {
      throw f.error("DyteRecording::getRecordingId::unable_to_get_recording_id", { error: e }), new E("Unable to get recording");
    }
  }
}, Fr = new WeakMap(), Yl);
yo([
  _.trace("DyteRecording.start")
], Ki.prototype, "start", 1);
yo([
  _.trace("DyteRecording.stop")
], Ki.prototype, "stop", 1);
yo([
  _.trace("DyteRecording.getRecordingId")
], Ki.prototype, "getRecordingId", 1);
Ki = yo([
  ft((r) => {
    throw new E(r.message, "1000");
  })
], Ki);
var ZP = Object.defineProperty, XP = Object.getOwnPropertyDescriptor, eC = (r, e, t, s) => {
  for (var i = s > 1 ? void 0 : s ? XP(e, t) : e, n = r.length - 1, a; n >= 0; n--)
    (a = r[n]) && (i = (s ? a(e, t, i) : a(i)) || i);
  return s && i && ZP(e, t, i), i;
};
class qp {
  constructor(e) {
    h(this, "recording");
    this.recording = new Ki(e), this.setupEvents();
  }
  setupEvents() {
    y.on(v.HIVE_RECORDING_STARTED, (e) => {
      this.recording.recordingPeerId = e, this.recording.setRecordingState("RECORDING");
    }), y.on(v.HIVE_RECORDING_STOPPED, () => {
      this.recording.recordingPeerId = void 0, this.recording.setRecordingState("IDLE");
    }), y.on(v.PEER_JOINED, async (e) => {
      var t;
      (t = e.flags) != null && t.recorder && (this.recording.recordingPeerId = e.id, this.recording.setRecordingState("RECORDING"));
    }), y.on(v.PEER_CLOSED, (e) => {
      e.id === this.recording.recordingPeerId && (this.recording.recordingPeerId = void 0, this.recording.setRecordingState("IDLE"));
    }), y.onAsync(v.ROOM_JOINED, async (e) => {
      var s, i;
      f.debug("[ROOM_JOINED] resolved request to fetch recordings.");
      const t = (s = e.peers) == null ? void 0 : s.filter(
        (n) => {
          var a;
          return !!((a = n.flags) != null && a.recorder);
        }
      );
      t.length ? (this.recording.recordingPeerId = t && ((i = t[0]) == null ? void 0 : i.id), this.recording.setRecordingState("RECORDING")) : (this.recording.recordingPeerId = void 0, this.recording.setRecordingState("IDLE"));
    }), y.on(v.RECORDING_STARTED, () => {
      this.recording.setRecordingState("RECORDING");
    }), y.on(v.RECORDING_STOPPED, () => {
      this.recording.recordingId = void 0, this.recording.recordingPeerId = void 0, this.recording.setRecordingState("IDLE");
    });
  }
}
eC([
  _.trace("RecordingController.setupEvents")
], qp.prototype, "setupEvents", 1);
var tC = Object.defineProperty, sC = Object.getOwnPropertyDescriptor, rC = (r, e, t, s) => {
  for (var i = s > 1 ? void 0 : s ? sC(e, t) : e, n = r.length - 1, a; n >= 0; n--)
    (a = r[n]) && (i = (s ? a(e, t, i) : a(i)) || i);
  return s && i && tC(e, t, i), i;
}, Gp = /* @__PURE__ */ ((r) => (r[r.User = 0] = "User", r[r.Spotlight = 1] = "Spotlight", r))(Gp || {}), Fi, Ra, jr, Zl;
let $a = (Zl = class extends Ue {
  constructor(e) {
    super();
    // eslint-disable-next-line class-methods-use-this
    b(this, Fi);
    /**
     *  Represents the current active tab
     */
    h(this, "selfActiveTab");
    /**
     * Represents whether current user is spotlighted
     */
    h(this, "spotlighted");
    b(this, jr, void 0);
    this.spotlighted = e.permissions.canSpotlight, P(this, jr, e);
  }
  /**
   * Returns true if the local participant has joined the meeting.
   */
  get roomJoined() {
    var e;
    return ((e = c(this, Fi, Ra)) == null ? void 0 : e.roomJoined) === !0;
  }
  static init(e) {
    return new $a(e);
  }
  /**
   * Sets current spotlighted state for the user
   * @param spotlighted
   */
  setSpotlighted(e) {
    if (!c(this, jr).permissions.canSpotlight)
      throw f.error("DyteSpotlight::setSpotlighted::permission_denied"), new E("User does not have permission to toggle spotlight");
    this.spotlighted = e, this.emit("spotlightUpdate", this.spotlighted), this.spotlighted && this.assertSpotlightToRoom();
  }
  /**
   * Sets current active tab for user
   * @param spotlightTab
   */
  setSelfActiveTab(e, t) {
    var s;
    f.info("DyteSpotlight::setActiveTab", {
      spotlight: {
        currentTab: {
          id: e.id,
          type: e.type
        }
      }
    }), this.selfActiveTab = e, t === 0 && this.emit("selfTabUpdate", e), (s = c(this, jr).permissions) != null && s.canSpotlight && this.spotlighted && t === 0 && this.assertSpotlightToRoom();
  }
  assertSpotlightToRoom() {
    c(this, Fi, Ra) instanceof fe && this.selfActiveTab && c(this, Fi, Ra).assertSpotlightToRoom({
      spotlightedUserId: c(this, jr).userId,
      currentTab: this.selfActiveTab,
      peerId: void 0
    });
  }
}, Fi = new WeakSet(), Ra = function() {
  return Be();
}, jr = new WeakMap(), Zl);
$a = rC([
  ft((r) => {
    throw new E(r.message, "1300");
  })
], $a);
var iC = Object.defineProperty, nC = Object.getOwnPropertyDescriptor, aC = (r, e, t, s) => {
  for (var i = s > 1 ? void 0 : s ? nC(e, t) : e, n = r.length - 1, a; n >= 0; n--)
    (a = r[n]) && (i = (s ? a(e, t, i) : a(i)) || i);
  return s && i && iC(e, t, i), i;
}, ar, $r, pn;
class Wp {
  constructor(e) {
    // eslint-disable-next-line class-methods-use-this
    b(this, $r);
    h(this, "spotlight");
    b(this, ar, void 0);
    this.spotlight = $a.init(e), P(this, ar, e), this.setupEvents();
  }
  conditionallySetActiveTab(e) {
    var t;
    e != null && e.currentTab && ((t = this.spotlight.selfActiveTab) == null ? void 0 : t.id) !== e.currentTab.id && (this.spotlight.setSelfActiveTab(
      e.currentTab,
      Gp.Spotlight
    ), this.spotlight.emit("activeTabUpdate", e.currentTab));
  }
  async setupEvents() {
    c(this, ar).permissions.canSpotlight && (f.info("DyteSpotlightController::Asserting Spotlight"), c(this, $r, pn) instanceof fe && this.spotlight.selfActiveTab && c(this, $r, pn).assertSpotlightToRoom({
      spotlightedUserId: c(this, ar).userId,
      currentTab: this.spotlight.selfActiveTab,
      peerId: void 0
    })), y.on(v.PEER_JOINED, async (e) => {
      c(this, ar).permissions.canSpotlight && c(this, $r, pn) instanceof fe && this.spotlight.selfActiveTab && c(this, $r, pn).assertSpotlightToPeer({
        spotlightedUserId: c(this, ar).userId,
        currentTab: this.spotlight.selfActiveTab,
        peerId: e.id
      });
    }), y.on(v.ROOM_MESSAGE, (e) => {
      var t, s;
      e.roomMessageType === "spotlight" && (f.info(
        "Spotlight Assertion Received",
        {
          spotlight: {
            spotlighter: { id: e.spotlightedUserId },
            currentTab: { id: (t = e.currentTab) == null ? void 0 : t.id, type: (s = e.currentTab) == null ? void 0 : s.type }
          }
        }
      ), this.conditionallySetActiveTab(e));
    }), y.on(v.MESSAGE, (e) => {
      var t, s;
      e.roomMessageType === "spotlight" && (f.info(
        "Spotlight Assertion Received",
        {
          spotlight: {
            spotlighter: { id: e.spotlightedUserId },
            currentTab: { id: (t = e.currentTab) == null ? void 0 : t.id, type: (s = e.currentTab) == null ? void 0 : s.type }
          }
        }
      ), this.conditionallySetActiveTab(e));
    });
  }
}
ar = new WeakMap(), $r = new WeakSet(), pn = function() {
  return Be();
};
aC([
  _.trace("SpotlightController.setupEvents")
], Wp.prototype, "setupEvents", 1);
function oC(r) {
  let e = 0, t, s;
  if (!r)
    return e;
  for (t = 0; t < r.length; t += 1)
    s = r.charCodeAt(t), e = (e << 5) - e + s, e |= 0;
  return Math.abs(e) % 100 + 1;
}
class cC {
  static hasFeature(e) {
    var t;
    return (t = M.hasFeature(e)) != null ? t : !1;
  }
  static getFeatureValue(e) {
    return M.getValue(e);
  }
  static getAllFeatures() {
    return M.getAllFlags();
  }
}
class rd {
  constructor(e, t, s) {
    h(this, "logger");
    h(this, "features");
    h(this, "browserSpecs");
    h(this, "callStats");
    this.logger = e, this.features = t, this.browserSpecs = ae, this.callStats = s;
  }
  static init() {
    return new rd(f, cC, A);
  }
}
class id {
  constructor(e) {
    h(this, "internals");
    this.internals = e;
  }
  static async init() {
    const e = rd.init();
    return new id(e);
  }
}
var dC = Object.defineProperty, lC = Object.getOwnPropertyDescriptor, Jp = (r, e, t, s) => {
  for (var i = s > 1 ? void 0 : s ? lC(e, t) : e, n = r.length - 1, a; n >= 0; n--)
    (a = r[n]) && (i = (s ? a(e, t, i) : a(i)) || i);
  return s && i && dC(e, t, i), i;
}, ji;
class nd extends Ue {
  constructor(t) {
    super();
    b(this, ji, void 0);
    h(this, "state", "IDLE");
    h(this, "playbackUrl");
    h(this, "viewerCount");
    P(this, ji, t), this.viewerCount = 0;
  }
  setLivestreamState(t) {
    const s = this.state;
    this.state = t, s !== t && this.emitCurrentLivestreamState();
  }
  emitCurrentLivestreamState() {
    this.emit("livestreamUpdate", this.state);
  }
  async start() {
    if (!c(this, ji).permissions.canLivestream)
      throw f.error("DyteLivestream::start::permission_denied"), new E("User does not have permission to start livestreaming");
    this.setLivestreamState("STARTING");
    try {
      const s = await ct().startLivestreaming();
      this.playbackUrl = s;
    } catch (t) {
      throw f.error("DyteRecording::stop::livestream_failed_to_start", {
        error: t
      }), this.setLivestreamState("IDLE"), new E("Error while starting livestream");
    }
  }
  async stop() {
    if (!c(this, ji).permissions.canLivestream)
      throw f.error("DyteLivestream::stop::permission_denied"), new E("User does not have permission to stop livestreaming");
    if (this.state !== "LIVESTREAMING")
      throw f.error("DyteLivestream::stop::inconsistent_state"), new E("Livestream not started yet");
    try {
      this.setLivestreamState("STOPPING"), await ct().stopLivestreaming();
    } catch (t) {
      throw f.error("DyteLivestream::stop::livestream_failed_to_stop", { error: t }), this.setLivestreamState("STOPPING"), new E("Error while stopping livestream");
    }
  }
}
ji = new WeakMap();
Jp([
  _.trace("livestream.start")
], nd.prototype, "start", 1);
Jp([
  _.trace("livestream.stop")
], nd.prototype, "stop", 1);
var uC = Object.defineProperty, pC = Object.getOwnPropertyDescriptor, hC = (r, e, t, s) => {
  for (var i = s > 1 ? void 0 : s ? pC(e, t) : e, n = r.length - 1, a; n >= 0; n--)
    (a = r[n]) && (i = (s ? a(e, t, i) : a(i)) || i);
  return s && i && uC(e, t, i), i;
}, or, cr;
class Kp {
  constructor(e, t) {
    h(this, "livestream");
    b(this, or, void 0);
    b(this, cr, void 0);
    this.livestream = new nd(e), P(this, cr, t), this.setupEvents();
  }
  async fetchInitialLivestreamingState() {
    const e = ct(), { status: t, playbackUrl: s } = await e.getActiveLivestream();
    t === "LIVE" && (this.livestream.playbackUrl = s, this.livestream.setLivestreamState("LIVESTREAMING"));
  }
  setupEvents() {
    c(this, cr).on(
      ce.startedLivestream,
      (e) => {
        this.livestream.playbackUrl = e.playbackUrl, this.livestream.setLivestreamState("LIVESTREAMING");
      }
    ), c(this, cr).on(
      ce.stoppedLivestream,
      () => {
        this.livestream.setLivestreamState("IDLE"), this.livestream.playbackUrl = void 0;
      }
    ), c(this, cr).on(
      ce.erroredLivestream,
      () => {
        this.livestream.setLivestreamState("IDLE"), this.livestream.playbackUrl = void 0;
      }
    ), c(this, cr).on(
      ce.roomPeerCount,
      (e) => {
        this.livestream.viewerCount = e.count, this.livestream.emit("viewerCountUpdate", e.count);
      }
    ), y.on(v.PEER_JOINED, async (e) => {
      var t;
      ((t = e.flags) == null ? void 0 : t.hiddenParticipant) === !0 && e.recorderType === "LIVESTREAMER" && (P(this, or, e.id), this.livestream.setLivestreamState("LIVESTREAMING"));
    }), y.on(v.PEER_CLOSED, (e) => {
      e.id === c(this, or) && (P(this, or, void 0), this.livestream.setLivestreamState("IDLE"));
    }), y.onAsync(v.ROOM_JOINED, async (e) => {
      var s, i;
      f.debug("[ROOM_JOINED] resolved request to fetch livestream.");
      const t = (s = e.peers) == null ? void 0 : s.filter(
        (n) => {
          var a;
          return !!((a = n.flags) != null && a.hiddenParticipant);
        }
      );
      t.length ? (P(this, or, t && ((i = t[0]) == null ? void 0 : i.id)), this.livestream.setLivestreamState("LIVESTREAMING")) : (P(this, or, void 0), this.livestream.setLivestreamState("IDLE"));
    }), y.onAsync(v.LEAVE_MEDIA_ROOM, async () => {
      if (!this.livestream.playbackUrl) {
        f.info("Fetching livestreaming state on leave stage");
        try {
          await this.fetchInitialLivestreamingState();
        } catch (e) {
        }
      }
    }), y.onAsync(v.SOCKET_SERVICE_ROOM_JOINED, async () => {
      try {
        await this.fetchInitialLivestreamingState();
      } catch (e) {
      }
    });
  }
}
or = new WeakMap(), cr = new WeakMap();
hC([
  _.trace("LivestreamController.setupEvents")
], Kp.prototype, "setupEvents", 1);
const Te = Wt(
  Oc().permissions
);
var K;
const Ya = class {
  constructor(e) {
    b(this, K, void 0);
    if (!e)
      throw f.error("DytePermissionsPreset::load_preset_permissions_failed"), new E("Could not load preset permissions.");
    P(this, K, e);
  }
  static fromResponse(e) {
    return new Ya(e);
  }
  static default() {
    return new Ya(Te);
  }
  /**
   * The `acceptWaitingRequests` returns boolean value.
   * If `true`, participant can accept the request of waiting participant.
   */
  get acceptWaitingRequests() {
    var e, t;
    return (t = (e = c(this, K)) == null ? void 0 : e.acceptWaitingRequests) != null ? t : Te.acceptWaitingRequests;
  }
  /**
   * The `requestProduceVideo` returns boolean value.
   * If `true`, participant can send request to participants
   * about producing video.
   */
  get requestProduceVideo() {
    var e, t, s;
    return ((s = (t = (e = c(this, K)) == null ? void 0 : e.media) == null ? void 0 : t.video) == null ? void 0 : s.canProduce) === ot.CanRequest;
  }
  /**
   * The `requestProduceAudio` returns boolean value.
   * If `true`, participant can send request to participants
   * about producing audio.
   */
  get requestProduceAudio() {
    var e, t, s;
    return ((s = (t = (e = c(this, K)) == null ? void 0 : e.media) == null ? void 0 : t.audio) == null ? void 0 : s.canProduce) === ot.CanRequest;
  }
  /**
   * The `requestProduceScreenshare` returns boolean value.
   * If `true`, participant can send request to participants
   * about sharing screen.
   */
  get requestProduceScreenshare() {
    var e, t, s;
    return ((s = (t = (e = c(this, K)) == null ? void 0 : e.media) == null ? void 0 : t.screenshare) == null ? void 0 : s.canProduce) === ot.CanRequest;
  }
  /**
   * The `canAllowParticipantAudio` returns boolean value.
   * If `true`, participant can enable other participants` audio.
   */
  get canAllowParticipantAudio() {
    var e, t;
    return (t = (e = c(this, K)) == null ? void 0 : e.canAcceptProductionRequests) != null ? t : Te.canAcceptProductionRequests;
  }
  /**
   * The `canAllowParticipantScreensharing` returns boolean value.
   * If `true`, participant can enable other participants` screen share.
   */
  get canAllowParticipantScreensharing() {
    var e, t;
    return (t = (e = c(this, K)) == null ? void 0 : e.canAcceptProductionRequests) != null ? t : Te.canAcceptProductionRequests;
  }
  /**
   * The `canAllowParticipantVideo` returns boolean value.
   * If `true`, participant can enable other participants` video.
   */
  get canAllowParticipantVideo() {
    var e, t;
    return (t = (e = c(this, K)) == null ? void 0 : e.canAcceptProductionRequests) != null ? t : Te.canAcceptProductionRequests;
  }
  /**
   * If `true`, a participant can disable other participants` audio.
   */
  get canDisableParticipantAudio() {
    var e, t;
    return (t = (e = c(this, K)) == null ? void 0 : e.disableParticipantAudio) != null ? t : Te.disableParticipantAudio;
  }
  /**
   * If `true`, a participant can disable other participants` video.
   */
  get canDisableParticipantVideo() {
    var e, t;
    return (t = (e = c(this, K)) == null ? void 0 : e.disableParticipantVideo) != null ? t : Te.disableParticipantVideo;
  }
  /**
   * The `kickParticipant` returns boolean value.
   * If `true`, participant can remove other participants from the meeting.
   */
  get kickParticipant() {
    var e, t;
    return (t = (e = c(this, K)) == null ? void 0 : e.kickParticipant) != null ? t : Te.kickParticipant;
  }
  /**
   * The `pinParticipant` returns boolean value.
   * If `true`, participant can pin a participant in the meeting.
   */
  get pinParticipant() {
    var e, t;
    return (t = (e = c(this, K)) == null ? void 0 : e.pinParticipant) != null ? t : Te.pinParticipant;
  }
  /**
   * The `canRecord` returns boolean value.
   * If `true`, participant can record the meeting.
   */
  get canRecord() {
    var e, t;
    return (t = (e = c(this, K)) == null ? void 0 : e.canRecord) != null ? t : Te.canRecord;
  }
  /**
   * @deprecated in favour of `waitingRoomBehaviour`.
   * The `waitingRoomType` returns string value.
   * type of waiting room behavior
   * possible values are `SKIP`, `ON_PRIVILEGED_USER_ENTRY`, `SKIP_ON_ACCEPT`
   */
  get waitingRoomType() {
    var e, t;
    return (t = (e = c(this, K)) == null ? void 0 : e.waitingRoomType) != null ? t : Te.waitingRoomType;
  }
  /**
   * The `waitingRoomType` returns string value.
   * type of waiting room behavior
   * possible values are `SKIP`, `ON_PRIVILEGED_USER_ENTRY`, `SKIP_ON_ACCEPT`
   */
  get waitingRoomBehaviour() {
    var e, t;
    return (t = (e = c(this, K)) == null ? void 0 : e.waitingRoomType) != null ? t : Te.waitingRoomType;
  }
  /**
   * The `plugins` tells if the participant can act on plugins
   * there are 2 permissions with boolean values, `canStart` and `canClose`.
   */
  get plugins() {
    var e, t;
    return (t = (e = c(this, K)) == null ? void 0 : e.plugins) != null ? t : Te.plugins;
  }
  /**
   * The `polls` tells if the participant can use polls.
   * There are 3 permissions with boolean values, `canCreate`, `canVote`, `canViewResults`
   */
  get polls() {
    var e, t;
    return (t = (e = c(this, K)) == null ? void 0 : e.polls) != null ? t : Te.polls;
  }
  /**
   * @deprecated in favour of `canProduceVideo`
   * The `produceVideo` shows permissions for enabling video.
   * There possible values are `ALLOWED`, `NOT_ALLOWED`, `CAN_REQUEST`
   */
  get produceVideo() {
    var e, t, s, i;
    return (i = (s = (t = (e = c(this, K)) == null ? void 0 : e.media) == null ? void 0 : t.video) == null ? void 0 : s.canProduce) != null ? i : Te.media.video.canProduce;
  }
  /**
   * @deprecated
   * The `requestProduce` returns boolean value.
   * If `true`, participant can send request to participants
   * about producing audio, video or screenshare.
   */
  get requestProduce() {
    return c(this, K).media.audio.canProduce === ot.CanRequest || c(this, K).media.video.canProduce === ot.CanRequest || c(this, K).media.screenshare.canProduce === ot.CanRequest;
  }
  /**
   * The `canProduceVideo` shows permissions for enabling video.
   * There possible values are `ALLOWED`, `NOT_ALLOWED`, `CAN_REQUEST`
   */
  get canProduceVideo() {
    var e, t, s, i;
    return (i = (s = (t = (e = c(this, K)) == null ? void 0 : e.media) == null ? void 0 : t.video) == null ? void 0 : s.canProduce) != null ? i : Te.media.video.canProduce;
  }
  /**
   * @deprecated in favour of `canProduceScreenshare`
   * The `produceVideo` shows permissions for sharing screen.
   * There possible values are `ALLOWED`, `NOT_ALLOWED`, `CAN_REQUEST`
   */
  get produceScreenshare() {
    var e, t, s, i;
    return (i = (s = (t = (e = c(this, K)) == null ? void 0 : e.media) == null ? void 0 : t.screenshare) == null ? void 0 : s.canProduce) != null ? i : Te.media.screenshare.canProduce;
  }
  /**
   * The `canProduceScreenshare` shows permissions for sharing screen.
   * There possible values are `ALLOWED`, `NOT_ALLOWED`, `CAN_REQUEST`
   */
  get canProduceScreenshare() {
    var e, t, s, i;
    return (i = (s = (t = (e = c(this, K)) == null ? void 0 : e.media) == null ? void 0 : t.screenshare) == null ? void 0 : s.canProduce) != null ? i : Te.media.screenshare.canProduce;
  }
  /**
   * @deprecated in favour of `canProduceAudio`
   * The `produceAudio` shows permissions for enabling audio.
   * There possible values are `ALLOWED`, `NOT_ALLOWED`, `CAN_REQUEST`
   */
  get produceAudio() {
    var e;
    return (e = c(this, K).media.audio.canProduce) != null ? e : Te.media.audio.canProduce;
  }
  /**
   * The `canProduceAudio` shows permissions for enabling audio.
   * There possible values are `ALLOWED`, `NOT_ALLOWED`, `CAN_REQUEST`
   */
  get canProduceAudio() {
    var e;
    return (e = c(this, K).media.audio.canProduce) != null ? e : Te.media.audio.canProduce;
  }
  /**
   * The `chatPublic` shows permissions for public chat
   * there are 4 permissions
   * `canSend` - if true, the participant can send chat
   * `text` - if true, the participant can send text
   * `files` - if true, the participant can send files
   */
  get chatPublic() {
    var e, t, s;
    return (s = (t = (e = c(this, K)) == null ? void 0 : e.chat) == null ? void 0 : t.public) != null ? s : Te.chat.public;
  }
  /**
   * The `chatPrivate` shows permissions for public chat
   * there are 4 permissions
   * `canSend` - if true, the participant can send private chat
   * `text` - if true, the participant can send text as private chat
   * `files` - if true, the participant can send files as private chat
   * `canReceive` - (optional) if true, the participant can receive private chat
   */
  get chatPrivate() {
    var e, t, s;
    return (s = (t = (e = c(this, K)) == null ? void 0 : e.chat) == null ? void 0 : t.private) != null ? s : Te.chat.private;
  }
  get connectedMeetings() {
    var e, t;
    return (t = (e = c(this, K)) == null ? void 0 : e.connectedMeetings) != null ? t : Te == null ? void 0 : Te.connectedMeetings;
  }
  /**
   * The `hiddenParticipant` returns boolean value.
   * If `true`, participant is hidden.
   */
  get hiddenParticipant() {
    var e, t;
    return (t = (e = c(this, K)) == null ? void 0 : e.hiddenParticipant) != null ? t : Te.hiddenParticipant;
  }
  /**
   * The `showParticipantList` returns boolean value.
   * If `true`, participant list can be shown to the participant.
   */
  get showParticipantList() {
    var e;
    return (e = c(this, K).showParticipantList) != null ? e : Te.showParticipantList;
  }
  /**
   * @deprecated in favour of `canChangeParticipantPermissions`
   * The `canChangeParticipantRole` returns boolean value.
   * If `true`, allow changing the participants' role.
   */
  get canChangeParticipantRole() {
    var e, t;
    return (t = (e = c(this, K)) == null ? void 0 : e.canChangeParticipantPermissions) != null ? t : Te.canChangeParticipantPermissions;
  }
  /**
   * The `canChangeParticipantPermissions` returns boolean value.
   * If `true`, allow changing the participants' permissions.
   */
  get canChangeParticipantPermissions() {
    var e, t;
    return (t = (e = c(this, K)) == null ? void 0 : e.canChangeParticipantPermissions) != null ? t : Te.canChangeParticipantPermissions;
  }
  /**
   * @deprecated
   * The `canChangeTheme` returns boolean value.
   * If `true`, the participant can change the meeting theme.
   */
  // eslint-disable-next-line class-methods-use-this
  get canChangeTheme() {
    return !1;
  }
  /**
   * @deprecated in favour of individual production settings
   * The `canPresent` returns boolean value.
   * If `true`, the participant can become a presentor.
   */
  get canPresent() {
    return c(this, K).media.audio.canProduce === ot.Allowed || c(this, K).media.video.canProduce === ot.Allowed || c(this, K).media.screenshare.canProduce === ot.Allowed;
  }
  get acceptPresentRequests() {
    return c(this, K).canAcceptProductionRequests;
  }
  get canEditDisplayName() {
    var e;
    return (e = c(this, K).canEditDisplayName) != null ? e : !1;
  }
  /**
   * @deprecated DyteSelf.config.maxScreenShareCount
   */
  // eslint-disable-next-line class-methods-use-this
  get maxScreenShareCount() {
    return 1;
  }
  // eslint-disable-next-line class-methods-use-this
  get isRecorder() {
    return c(this, K).isRecorder;
  }
  get canSpotlight() {
    return c(this, K).canSpotlight;
  }
  /** Livestream */
  get canLivestream() {
    return c(this, K).canLivestream;
  }
  // eslint-disable-next-line class-methods-use-this
  get isV2() {
    return !0;
  }
};
let Ha = Ya;
K = new WeakMap();
const mC = Wt(
  Oc()
);
var es, Hr, $i;
const Za = class {
  constructor(e) {
    b(this, es, void 0);
    b(this, Hr, void 0);
    b(this, $i, void 0);
    if (!e)
      throw new E("Could not load preset.");
    P(this, es, e.config), P(this, Hr, e.ui || Wt(Oc().ui)), P(this, $i, e.permissions.plugins.config);
  }
  static fromResponse(e) {
    return new Za(e);
  }
  static default() {
    return new Za(mC);
  }
  /**
   * @deprecated
   * The `setupScreen` represents the setup screen for the meeting.
   */
  get setupScreen() {
    return {
      isEnabled: !0
    };
  }
  /**
   * @deprecated
   * The `waitingRoom` contains the properties to show a layout when
   * the participant is in waiting to join the meeting.
   */
  get waitingRoom() {
    return {
      isEnabled: !0
    };
  }
  /**
   * @deprecated
   * The `controlBar` contains the properties to show the meeting control bar with
   * various action buttons for the meeting.
   * The `elements` key contains the various action buttons.
   */
  get controlBar() {
    return {
      isEnabled: !0,
      elements: {
        chat: !0,
        fullscreen: !0,
        invite: !1,
        layout: !1,
        participants: !0,
        plugins: !0,
        polls: !0,
        reactions: !1,
        screenshare: !0
      }
    };
  }
  /**
   * @deprecated
   * The `header` contains the properties to show the meeting header with various elements.
   * The `elements` key contains the following properties
   * `logo` - string value representing the public URL for the logo
   * `timer` - boolean value suggesting if the timer should be shown
   * `title` - boolean value suggesting if the meeting title should be shown
   * `participantCount` - boolean value suggesting if the participant count shuld be shown
   * `changeLayout` - boolean value suggesting if the participant can change layout
   */
  get header() {
    return {
      isEnabled: !0,
      elements: {
        logo: c(this, Hr).designTokens.logo,
        timer: !0,
        title: !0,
        participantCount: !0,
        changeLayout: !1
      }
    };
  }
  /**
   * @deprecated
   * The `pipMode` property returns a boolean value
   * If true, picture-in-picture mode is enabled for the participant.
   */
  get pipMode() {
    return !0;
  }
  /**
   * The `viewType` tells the type of the meeting
   * possible values are WEBINAR, GROUP_CALL
   */
  get viewType() {
    return c(this, es).viewType;
  }
  /**
   * The `maxVideoStreams` contains the maximum video
   * streams for mobile and desktop
   */
  get maxVideoStreams() {
    return c(this, es).maxVideoStreams;
  }
  /**
   * The `maxScreenShareCount` contains the maximum
   * possible concurrent screen shares
   */
  get maxScreenShareCount() {
    return c(this, es).maxScreenshareCount;
  }
  /**
   * @deprecated in favour of permissions.plugins.config
   */
  get plugins() {
    return [];
  }
  /**
   * The `disabledPlugins` property returns id of all disabled plugins
   */
  get disabledPlugins() {
    return Object.keys(c(this, $i)).filter((e) => c(this, $i)[e].disabled);
  }
  get designTokens() {
    return c(this, Hr).designTokens;
  }
  get configDiff() {
    return c(this, Hr).configDiff;
  }
  get mediaConstraints() {
    var e, t, s, i, n, a, o, d, p, l, u, m, g, T, S, R;
    return {
      video: {
        quality: (i = (s = (t = (e = c(this, es)) == null ? void 0 : e.media) == null ? void 0 : t.video) == null ? void 0 : s.quality) != null ? i : Nt.video.quality,
        frameRate: (d = (o = (a = (n = c(this, es)) == null ? void 0 : n.media) == null ? void 0 : a.video) == null ? void 0 : o.frameRate) != null ? d : Nt.video.frameRate
      },
      screenshare: {
        quality: (m = (u = (l = (p = c(this, es)) == null ? void 0 : p.media) == null ? void 0 : l.screenshare) == null ? void 0 : u.quality) != null ? m : Nt.screenshare.quality,
        frameRate: (R = (S = (T = (g = c(this, es)) == null ? void 0 : g.media) == null ? void 0 : T.screenshare) == null ? void 0 : S.frameRate) != null ? R : Nt.screenshare.frameRate
      }
    };
  }
  get isV2() {
    return !0;
  }
};
let Ba = Za;
es = new WeakMap(), Hr = new WeakMap(), $i = new WeakMap();
const fC = {
  setup_screen: { is_enabled: !1 },
  alone_here: { is_enabled: !1 },
  waiting_room: { is_enabled: !1, enable_preview: !0 },
  control_bar: {
    is_enabled: !0,
    elements: {
      plugins: !0,
      screenshare: !0,
      invite: !1,
      participants: !0,
      chat: !0,
      reactions: !1,
      polls: !0,
      fullscreen: !0,
      layout: !0
    }
  },
  header: {
    is_enabled: !0,
    elements: {
      logo: "",
      timer: !0,
      title: !0,
      participant_count: !0,
      change_layout: !0
    }
  },
  pip_mode: !0,
  auto_tune: !0,
  grid: {
    multi: { max_video_count: 9, video_fit: "cover" },
    single: { max_video_count: 6, video_fit: "cover" },
    default_view: "MULTI"
  },
  colors: {
    primary: "#2160FD",
    secondary: "#1A1A1A",
    text: "#EEEEEE",
    background: "#1A1A1A",
    text_primary: "#EEEEEE",
    video_background: "#1A1A1A"
  },
  controls: { pip_toggle: !1 },
  plugins: []
}, gC = Wt(fC);
var ht, Hi, Bi, Vn, Fn;
const Xa = class {
  constructor(e) {
    b(this, ht, void 0);
    b(this, Hi, void 0);
    b(this, Bi, void 0);
    b(this, Vn, void 0);
    b(this, Fn, []);
    if (!e)
      throw new E("Could not load preset theme.");
    P(this, ht, e), P(this, Hi, 1), P(this, Bi, is.GroupCall);
  }
  static fromResponse(e) {
    return new Xa(e);
  }
  static default() {
    return new Xa(gC);
  }
  configFromPermissions(e) {
    var t, s, i, n, a, o, d, p, l, u, m, g;
    P(this, Hi, e.maxScreenshareCount || 1), P(this, Bi, e.viewType), P(this, Vn, {
      video: {
        quality: (i = (s = (t = e == null ? void 0 : e.produce) == null ? void 0 : t.video) == null ? void 0 : s.quality) != null ? i : Nt.video.quality,
        frameRate: (o = (a = (n = e == null ? void 0 : e.produce) == null ? void 0 : n.video) == null ? void 0 : a.frameRate) != null ? o : Nt.video.frameRate
      },
      screenshare: {
        quality: (l = (p = (d = e == null ? void 0 : e.produce) == null ? void 0 : d.screenshare) == null ? void 0 : p.quality) != null ? l : Nt.screenshare.quality,
        frameRate: (g = (m = (u = e == null ? void 0 : e.produce) == null ? void 0 : u.screenshare) == null ? void 0 : m.frameRate) != null ? g : Nt.screenshare.frameRate
      }
    });
  }
  setDisabledPlugins(e) {
    const t = c(this, ht).plugins;
    t && t.length > 0 && P(this, Fn, e.filter(
      (s) => !t.includes(s)
    ));
  }
  /**
   * @deprecated
   * The `setupScreen` represents the setup screen for the meeting.
   */
  get setupScreen() {
    return c(this, ht).setupScreen;
  }
  /**
   * The `aloneHere` contains the properties to show a layout when
   * the participant is alone in the meeting.
   */
  get aloneHere() {
    return c(this, ht).aloneHere;
  }
  /**
   * The `waitingRoom` contains the properties to show a layout when
   * the participant is in waiting to join the meeting.
   */
  get waitingRoom() {
    return c(this, ht).waitingRoom;
  }
  /**
   * @deprecated
   * The `controlBar` contains the properties to show the meeting control bar with
   * various action buttons for the meeting.
   * The `elements` key contains the various action buttons.
   */
  get controlBar() {
    return c(this, ht).controlBar;
  }
  /**
   * The `header` contains the properties to show the meeting header with various elements.
   * The `elements` key contains the following properties
   * `logo` - string value representing the public URL for the logo
   * `timer` - boolean value suggesting if the timer should be shown
   * `title` - boolean value suggesting if the meeting title should be shown
   * `participantCount` - boolean value suggesting if the participant count shuld be shown
   * `changeLayout` - boolean value suggesting if the participant can change layout
   */
  get header() {
    return c(this, ht).header;
  }
  /**
   * The `pipMode` property returns a boolean value
   * If true, picture-in-picture mode is enabled for the participant.
   */
  get pipMode() {
    var e;
    return ((e = c(this, ht).controls) == null ? void 0 : e.pipToggle) || c(this, ht).pipMode;
  }
  /**
   * The `viewType` tells the type of the meeting
   * possible values are WEBINAR, GROUP_CALL
  */
  get viewType() {
    return c(this, Bi);
  }
  /**
   * @deprecated
   * The `autoTune` property returns a boolean value
   * If true, force the participant's video to be in compatibility mode.
   */
  get autoTune() {
    return c(this, ht).autoTune;
  }
  /**
   * The `grid` contains the properties to show participant grid for the meeting.
   * `defaultView` key points to the view type, possible values are `MULTI`, `SINGLE`
   * `multi` and `single` keys contain the following preferences to show grid layout.
   * `maxVideoCount` - number of participants to show in the grid.
   * `videoFit` - string value suggesting how to align the video content.
   */
  get grid() {
    return c(this, ht).grid;
  }
  /**
   * The `maxVideoStreams` contains the maximum video
   * streams for mobile and desktop
   */
  get maxVideoStreams() {
    return {
      mobile: this.grid.multi.maxVideoCount > 6 ? 6 : this.grid.multi.maxVideoCount,
      desktop: this.grid.multi.maxVideoCount
    };
  }
  /**
   * The `maxScreenShareCount` contains the maximum
   * possible concurrent screen shares
   */
  get maxScreenShareCount() {
    return c(this, Hi);
  }
  get colors() {
    return c(this, ht).colors;
  }
  get controls() {
    return c(this, ht).controls;
  }
  get plugins() {
    return c(this, ht).plugins;
  }
  /**
   * The `disabledPlugins` property returns id of all disabled plugins
   */
  get disabledPlugins() {
    return c(this, Fn);
  }
  get mediaConstraints() {
    return c(this, Vn);
  }
  // eslint-disable-next-line class-methods-use-this
  get isV2() {
    return !1;
  }
};
let qa = Xa;
ht = new WeakMap(), Hi = new WeakMap(), Bi = new WeakMap(), Vn = new WeakMap(), Fn = new WeakMap();
var jn;
class _C {
  constructor(e) {
    b(this, jn, void 0);
    P(this, jn, e);
  }
  on(e, t) {
    let s;
    e === ce.roomPeerCount ? s = ml.fromBinary.bind(ml) : s = Sl.fromBinary.bind(Sl), c(this, jn).on(e, ({ payload: i }) => {
      const n = s(i);
      return t(n);
    });
  }
}
jn = new WeakMap();
var Vt;
class vC {
  constructor(e) {
    b(this, Vt, void 0);
    P(this, Vt, e);
  }
  async getStageRequests() {
    const { payload: e } = await c(this, Vt).sendMessagePromise(
      ce.getStageRequests
    );
    return e ? Fo.fromBinary(e) : { stageRequests: [] };
  }
  requestAccess() {
    c(this, Vt).sendMessage(
      ce.requestStageAccess
    );
  }
  cancelRequestAccess() {
    c(this, Vt).sendMessage(ce.cancelStageRequest);
  }
  async grantAccess(e) {
    const t = {
      userIds: e
    };
    await c(this, Vt).sendMessagePromise(
      ce.grantStageAccess,
      Gw.toBinary(t)
    );
  }
  async denyAccess(e) {
    const t = {
      userIds: e
    };
    await c(this, Vt).sendMessagePromise(
      ce.denyStageAccess,
      Jw.toBinary(t)
    );
  }
  joinStage() {
    return c(this, Vt).sendMessage(
      ce.joinStage
    );
  }
  leaveStage(e) {
    const t = {
      userIds: [e]
    };
    return c(this, Vt).sendMessage(
      ce.leaveStage,
      Rl.toBinary(t)
    );
  }
  kick(e) {
    const t = {
      userIds: e
    };
    return c(this, Vt).sendMessagePromise(
      ce.leaveStage,
      Rl.toBinary(t)
    );
  }
  on(e, t) {
    let s;
    switch (e) {
      case ce.grantStageAccess:
      case ce.denyStageAccess: {
        s = void 0;
        break;
      }
      case ce.getStagePeers: {
        s = wl.fromBinary.bind(wl);
        break;
      }
      case ce.getStageRequests:
      case ce.requestStageAccess:
      case ce.cancelStageRequest: {
        s = Fo.fromBinary.bind(Fo);
        break;
      }
    }
    c(this, Vt).on(e, ({ payload: i, id: n }) => {
      if (!i || !s)
        return t(void 0, n);
      const a = s(i);
      return t(a, n);
    });
  }
}
Vt = new WeakMap();
var TC = Object.defineProperty, yC = Object.getOwnPropertyDescriptor, ii = (r, e, t, s) => {
  for (var i = s > 1 ? void 0 : s ? yC(e, t) : e, n = r.length - 1, a; n >= 0; n--)
    (a = r[n]) && (i = (s ? a(e, t, i) : a(i)) || i);
  return s && i && TC(e, t, i), i;
}, qt, ts, Os;
class vr extends Ue {
  constructor(t, s, i) {
    super();
    b(this, qt, void 0);
    b(this, ts, void 0);
    b(this, Os, void 0);
    h(this, "status");
    P(this, qt, i), P(this, Os, s), P(this, ts, t);
  }
  async getAccessRequests() {
    if (!c(this, ts))
      throw new E("You do not have permissions for getStageRequests");
    const { stageRequests: t } = await c(this, qt).getStageRequests();
    return { stageRequests: t };
  }
  requestAccess() {
    if (this.status !== "OFF_STAGE")
      throw new E(`Unable to request access you are currently ${this.status}`);
    if (c(this, ts)) {
      this.setStatus("ACCEPTED_TO_JOIN_STAGE");
      return;
    }
    c(this, qt).requestAccess(), this.setStatus("REQUESTED_TO_JOIN_STAGE");
  }
  cancelRequestAccess() {
    c(this, qt).cancelRequestAccess(), this.setStatus("OFF_STAGE");
  }
  grantAccess(t) {
    if (!c(this, ts))
      throw new E("You do not have permissions for grantAccess");
    return c(this, qt).grantAccess(t);
  }
  denyAccess(t) {
    if (!c(this, ts))
      throw new E("You do not have permissions for denyAccess");
    return c(this, qt).denyAccess(t);
  }
  async join() {
    if (!c(this, ts) && this.status !== "ACCEPTED_TO_JOIN_STAGE")
      throw new E(`Unable to join stage you are currently ${this.status}`);
    if (c(this, ts) && this.status === "ON_STAGE")
      throw new E("You are already on stage.");
    c(this, qt).joinStage(), await y.emitAsync(v.JOIN_MEDIA_ROOM), this.setStatus("ON_STAGE");
  }
  async leave() {
    var t;
    if (!(this.status === "ON_STAGE" || this.status === "ACCEPTED_TO_JOIN_STAGE"))
      throw new E(`Unable to leave stage you are currently ${this.status}`);
    this.setStatus("OFF_STAGE"), (t = Be()) != null && t.roomJoined && await y.emitAsync(v.LEAVE_MEDIA_ROOM);
    try {
      await c(this, Os).disableScreenShare(), await c(this, Os).disableVideo(), await c(this, Os).disableAudio(), c(this, Os).destructMediaHandler();
    } catch (s) {
      f.error("DyteStage.leaveStage.DisableMediaError", { error: s });
    }
    c(this, qt).leaveStage(c(this, Os).userId);
  }
  /**
   * Method to kick a user off the stage
   *
   * `permissions.kickParticipant` privilege required
  */
  async kick(t) {
    if (!c(this, ts))
      throw new E("You do not have permissions for kick");
    return c(this, qt).kick(t);
  }
  setStatus(t) {
    this.status !== t && (this.status = t, this.emit("stageStatusUpdate", t));
  }
}
qt = new WeakMap(), ts = new WeakMap(), Os = new WeakMap();
ii([
  _.trace("DyteStage.getStageRequests")
], vr.prototype, "getAccessRequests", 1);
ii([
  _.trace("DyteStage.requestAccess")
], vr.prototype, "requestAccess", 1);
ii([
  _.trace("DyteStage.cancelRequestAccess")
], vr.prototype, "cancelRequestAccess", 1);
ii([
  _.trace("DyteStage.grantAccess")
], vr.prototype, "grantAccess", 1);
ii([
  _.trace("DyteStage.denyAccess")
], vr.prototype, "denyAccess", 1);
ii([
  _.trace("DyteStage.joinStage")
], vr.prototype, "join", 1);
ii([
  _.trace("DyteStage.leaveStage")
], vr.prototype, "leave", 1);
var EC = Object.defineProperty, SC = Object.getOwnPropertyDescriptor, wC = (r, e, t, s) => {
  for (var i = s > 1 ? void 0 : s ? SC(e, t) : e, n = r.length - 1, a; n >= 0; n--)
    (a = r[n]) && (i = (s ? a(e, t, i) : a(i)) || i);
  return s && i && EC(e, t, i), i;
}, Br, qi, dr, $n;
class zp {
  constructor(e, t, s) {
    h(this, "stage");
    b(this, Br, void 0);
    b(this, qi, void 0);
    b(this, dr, void 0);
    b(this, $n, 0);
    this.stage = new vr(
      t,
      s,
      e
    ), P(this, dr, e), P(this, Br, t), P(this, qi, s), this.setupEvents();
  }
  setupEvents() {
    c(this, dr).on(
      ce.grantStageAccess,
      () => {
        c(this, Br) || (this.stage.emit("stageRequestApproved"), this.setStageStatus("ACCEPTED_TO_JOIN_STAGE"));
      }
    ), c(this, dr).on(
      ce.denyStageAccess,
      () => {
        c(this, Br) || (this.stage.emit("stageRequestRejected"), this.setStageStatus("OFF_STAGE"));
      }
    ), c(this, dr).on(
      ce.getStagePeers,
      (e) => {
        this.stage.status === "ON_STAGE" && !e.stagePeers.includes(c(this, qi).userId) && y.emitAsync(v.LEAVE_MEDIA_ROOM);
      }
    ), c(this, dr).on(
      ce.getStageRequests,
      (e) => {
        var s;
        if (!c(this, Br))
          return;
        const t = (s = e == null ? void 0 : e.stageRequests) != null ? s : [];
        c(this, $n) < t.length && t.length > 0 && this.stage.emit("newStageRequest", { count: t.length }), P(this, $n, t.length), this.stage.emit("stageAccessRequestUpdate", t);
      }
    ), y.onAsync(
      v.SOCKET_SERVICE_ROOM_JOINED,
      async (e) => {
        var t;
        switch ((t = e.peer) == null ? void 0 : t.stageType) {
          case Dr.OFF_STAGE: {
            this.setStageStatus("OFF_STAGE");
            break;
          }
          case Dr.ON_STAGE: {
            c(this, qi).config.viewType === "LIVESTREAM" && await y.emitAsync(v.JOIN_MEDIA_ROOM), this.setStageStatus("ON_STAGE");
            break;
          }
          case Dr.APPROVED_STAGE: {
            this.stage.emit("stageRequestApproved"), this.setStageStatus("ACCEPTED_TO_JOIN_STAGE");
            break;
          }
          case Dr.REQUESTED_STAGE: {
            this.setStageStatus("REQUESTED_TO_JOIN_STAGE");
            break;
          }
          default:
            this.setStageStatus("OFF_STAGE");
        }
      }
    );
  }
  setStageStatus(e) {
    this.stage.status !== e && (this.stage.status = e, this.stage.emit("stageStatusUpdate", e));
  }
}
Br = new WeakMap(), qi = new WeakMap(), dr = new WeakMap(), $n = new WeakMap();
wC([
  _.trace("DyteStage.setupEvents")
], zp.prototype, "setupEvents", 1);
var RC = Object.defineProperty, bC = Object.getOwnPropertyDescriptor, ad = (r, e, t, s) => {
  for (var i = s > 1 ? void 0 : s ? bC(e, t) : e, n = r.length - 1, a; n >= 0; n--)
    (a = r[n]) && (i = (s ? a(e, t, i) : a(i)) || i);
  return s && i && RC(e, t, i), i;
}, lr;
class Eo {
  constructor(e) {
    b(this, lr, void 0);
    P(this, lr, e);
  }
  getPolls() {
    return c(this, lr).sendMessagePromise(
      Ss.getPolls
    );
  }
  createPoll(e, t, s = !1, i = !1) {
    const n = {
      anonymous: s,
      hideVotes: i,
      question: e,
      options: t
    };
    return c(this, lr).sendMessage(
      Ss.createPoll,
      tR.toBinary(n)
    );
  }
  votePoll(e, t) {
    const s = {
      index: t,
      pollId: e
    };
    return c(this, lr).sendMessage(
      Ss.votePoll,
      rR.toBinary(s)
    );
  }
  on(e, t) {
    let s, i;
    switch (e) {
      case Ss.updatePoll:
      case Ss.createPoll:
      case Ss.votePoll: {
        s = jo.fromBinary.bind(jo), i = jo.create();
        break;
      }
    }
    c(this, lr).on(e, ({ payload: n }) => {
      let a = i;
      try {
        a = s(n);
      } catch (o) {
        f.error("chatSocketHandler::on::binary_decode_error", { error: o });
      }
      return t(a);
    });
  }
}
lr = new WeakMap();
ad([
  _.trace("PollSocketHandler.getPolls")
], Eo.prototype, "getPolls", 1);
ad([
  _.trace("PollSocketHandler.createPoll")
], Eo.prototype, "createPoll", 1);
ad([
  _.trace("PollSocketHandler.votePoll")
], Eo.prototype, "votePoll", 1);
class PC {
  constructor() {
    h(this, "battery");
    h(this, "init", async () => {
      try {
        "getBattery" in navigator && (this.battery = await navigator.getBattery(), this.battery.addEventListener("chargingchange", this.updateChargeInfo), this.battery.addEventListener("levelchange", this.updateLevelInfo), this.updateLevelInfo(), this.updateChargeInfo());
      } catch (e) {
        f.error("Error getting battery", e);
      }
    });
    h(this, "updateChargeInfo", () => {
      var e;
      f.log(`Battery charging? ${(e = this.battery) != null && e.charging ? "Yes" : "No"}`);
    });
    h(this, "updateLevelInfo", () => {
      var e;
      f.log(`Battery level: ${((e = this.battery) == null ? void 0 : e.level) * 100}%`);
    });
    h(this, "cleanup", () => {
      var e, t;
      "getBattery" in navigator && ((e = this.battery) == null || e.removeEventListener("chargingchange", this.updateChargeInfo), (t = this.battery) == null || t.removeEventListener("levelchange", this.updateLevelInfo));
    });
  }
}
const Ol = new PC();
var Hn, eo;
class CC extends Ue {
  constructor(t) {
    super();
    b(this, Hn, void 0);
    b(this, eo, void 0);
    P(this, Hn, t), P(this, eo, !1);
  }
  get mediaPermission() {
    return c(this, Hn).mediaPermissions.audio;
  }
}
Hn = new WeakMap(), eo = new WeakMap();
class kC extends Ue {
  async getNetworkMetadata() {
    return new Promise(
      (e) => {
        A.onSafeInitialization(() => {
          A.onPreCallTestResults((t) => {
            e(t.connectionInfo);
          }), A.startPreCallTest();
        });
      }
    );
  }
}
var Bn;
class DC extends Ue {
  constructor(t) {
    super();
    b(this, Bn, void 0);
    P(this, Bn, t);
  }
  get mediaPermission() {
    return c(this, Bn).mediaPermissions.screenshare;
  }
}
Bn = new WeakMap();
var qn, Ec;
class IC extends Ue {
  constructor(t) {
    super();
    b(this, qn, void 0);
    b(this, Ec, void 0);
    P(this, qn, t);
  }
  get mediaPermission() {
    return c(this, qn).mediaPermissions.video;
  }
}
qn = new WeakMap(), Ec = new WeakMap();
class AC {
  constructor(e) {
    h(this, "audio");
    h(this, "video");
    h(this, "screenshare");
    h(this, "network");
    this.audio = new CC(e), this.video = new IC(e), this.screenshare = new DC(e), this.network = new kC();
  }
}
class MC {
  constructor(e) {
    h(this, "troubleshooter");
    this.troubleshooter = new AC(e);
  }
}
const zs = class {
  static handleConnectedRoomsDumpRaw({ payload: e }) {
    var n;
    const t = NS.fromBinary(e), s = t.meetings.map((a) => {
      var o;
      return {
        id: a.id,
        title: a.title,
        participants: (o = a.participants) != null ? o : []
      };
    });
    return {
      parentMeeting: {
        id: t.parentMeeting.id,
        title: t.parentMeeting.title,
        participants: (n = t.parentMeeting.participants) != null ? n : []
      },
      meetings: s
    };
  }
  static handleTransferPeerRaw({ payload: e }) {
    const t = aw.fromBinary(e);
    return { authToken: t.authToken, meetingId: t.meetingId };
  }
  static handleMovedPeerRaw({ payload: e }) {
    const t = hp.fromBinary(e);
    return {
      meetingId: t.meetingId,
      customParticipantId: t.customParticipantId
    };
  }
  static handleConnectedRoomsUpdatedRaw({ payload: e }) {
    return _l.fromBinary(e).payloads.map((s) => ({
      id: s.id,
      title: s.title
    }));
  }
  static handleConnectedRoomsDeletedRaw({ payload: e }) {
    return QS.fromBinary(e).payloads;
  }
  static async getConnectedRoomsDump() {
    const e = await zs.socketService.sendMessagePromise(
      ce.getConnectedRoomsDump
    );
    return zs.handleConnectedRoomsDumpRaw(e);
  }
  static async createConnectedRooms(e) {
    const { payload: t } = await zs.socketService.sendMessagePromise(
      ce.createConnectedRooms,
      VS.toBinary({ payloads: e })
    );
    return _l.fromBinary(t).payloads.map((i) => ({
      id: i.id,
      title: i.title
    }));
  }
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  static async updateConnectedRooms(e) {
  }
  static async disableConnectedRooms(e) {
    const t = e.map((i) => ({ id: i })), s = await zs.socketService.sendMessagePromise(
      ce.deleteConnectedRooms,
      KS.toBinary({ payloads: t })
    );
    return zs.handleConnectedRoomsDeletedRaw(s);
  }
  static async movePeersBetweenRooms(e) {
    try {
      const t = await zs.socketService.sendMessagePromise(
        ce.movePeers,
        sw.toBinary({
          sourceMeetingId: e.sourceMeetingId,
          destinationMeetingId: e.destinationMeetingId,
          participants: e.participants
        })
      );
      return new TextDecoder().decode(t.payload).includes("error") ? { success: !1, error: "failed to move participants" } : { success: !0 };
    } catch (t) {
      return { success: !1, error: t };
    }
  }
};
let Ie = zs;
h(Ie, "socketService"), h(Ie, "currentMeetingId");
const OC = {
  codecs: [{
    kind: "audio",
    mimeType: "audio/opus",
    clockRate: 48e3,
    channels: 2,
    rtcpFeedback: [{ type: "transport-cc", parameter: "" }],
    parameters: {},
    preferredPayloadType: 100
  }, {
    kind: "video",
    mimeType: "video/VP8",
    clockRate: 9e4,
    rtcpFeedback: [{ type: "nack", parameter: "" }, { type: "nack", parameter: "pli" }, { type: "ccm", parameter: "fir" }, { type: "goog-remb", parameter: "" }, { type: "transport-cc", parameter: "" }],
    parameters: { "x-google-start-bitrate": 1e3 },
    preferredPayloadType: 101
  }, {
    kind: "video",
    mimeType: "video/rtx",
    preferredPayloadType: 102,
    clockRate: 9e4,
    parameters: { apt: 101 },
    rtcpFeedback: []
  }, {
    kind: "video",
    mimeType: "video/VP9",
    clockRate: 9e4,
    rtcpFeedback: [{ type: "nack", parameter: "" }, { type: "nack", parameter: "pli" }, { type: "ccm", parameter: "fir" }, { type: "goog-remb", parameter: "" }, { type: "transport-cc", parameter: "" }],
    parameters: { "profile-id": 0, "x-google-start-bitrate": 1e3 },
    preferredPayloadType: 103
  }, {
    kind: "video",
    mimeType: "video/rtx",
    preferredPayloadType: 104,
    clockRate: 9e4,
    parameters: { apt: 103 },
    rtcpFeedback: []
  }, {
    kind: "video",
    mimeType: "video/H264",
    clockRate: 9e4,
    parameters: {
      "level-asymmetry-allowed": 1,
      "packetization-mode": 1,
      "profile-level-id": "42e01f",
      "x-google-start-bitrate": 1e3
    },
    rtcpFeedback: [{ type: "nack", parameter: "" }, { type: "nack", parameter: "pli" }, { type: "ccm", parameter: "fir" }, { type: "goog-remb", parameter: "" }, { type: "transport-cc", parameter: "" }],
    preferredPayloadType: 105
  }, {
    kind: "video",
    mimeType: "video/rtx",
    preferredPayloadType: 106,
    clockRate: 9e4,
    parameters: { apt: 105 },
    rtcpFeedback: []
  }],
  headerExtensions: [
    {
      kind: "audio",
      uri: "urn:ietf:params:rtp-hdrext:sdes:mid",
      preferredId: 1,
      preferredEncrypt: !1,
      direction: "sendrecv"
    },
    {
      kind: "video",
      uri: "urn:ietf:params:rtp-hdrext:sdes:mid",
      preferredId: 1,
      preferredEncrypt: !1,
      direction: "sendrecv"
    },
    {
      kind: "video",
      uri: "urn:ietf:params:rtp-hdrext:sdes:rtp-stream-id",
      preferredId: 2,
      preferredEncrypt: !1,
      direction: "recvonly"
    },
    {
      kind: "video",
      uri: "urn:ietf:params:rtp-hdrext:sdes:repaired-rtp-stream-id",
      preferredId: 3,
      preferredEncrypt: !1,
      direction: "recvonly"
    },
    {
      kind: "audio",
      uri: "http://www.webrtc.org/experiments/rtp-hdrext/abs-send-time",
      preferredId: 4,
      preferredEncrypt: !1,
      direction: "sendrecv"
    },
    {
      kind: "video",
      uri: "http://www.webrtc.org/experiments/rtp-hdrext/abs-send-time",
      preferredId: 4,
      preferredEncrypt: !1,
      direction: "sendrecv"
    },
    {
      kind: "audio",
      uri: "http://www.ietf.org/id/draft-holmer-rmcat-transport-wide-cc-extensions-01",
      preferredId: 5,
      preferredEncrypt: !1,
      direction: "recvonly"
    },
    {
      kind: "video",
      uri: "http://www.ietf.org/id/draft-holmer-rmcat-transport-wide-cc-extensions-01",
      preferredId: 5,
      preferredEncrypt: !1,
      direction: "sendrecv"
    },
    {
      kind: "video",
      uri: "http://tools.ietf.org/html/draft-ietf-avtext-framemarking-07",
      preferredId: 6,
      preferredEncrypt: !1,
      direction: "sendrecv"
    },
    {
      kind: "video",
      uri: "urn:ietf:params:rtp-hdrext:framemarking",
      preferredId: 7,
      preferredEncrypt: !1,
      direction: "sendrecv"
    },
    {
      kind: "audio",
      uri: "urn:ietf:params:rtp-hdrext:ssrc-audio-level",
      preferredId: 10,
      preferredEncrypt: !1,
      direction: "sendrecv"
    },
    // {
    // eslint-disable-next-line max-len
    //     kind: 'video', uri: 'urn:3gpp:video-orientation', preferredId: 11, preferredEncrypt: false, direction: 'sendrecv',
    // },
    {
      kind: "video",
      uri: "urn:ietf:params:rtp-hdrext:toffset",
      preferredId: 12,
      preferredEncrypt: !1,
      direction: "sendrecv"
    },
    {
      kind: "video",
      uri: "http://www.webrtc.org/experiments/rtp-hdrext/abs-capture-time",
      preferredId: 13,
      preferredEncrypt: !1,
      direction: "sendrecv"
    },
    {
      kind: "audio",
      uri: "http://www.webrtc.org/experiments/rtp-hdrext/abs-capture-time",
      preferredId: 13,
      preferredEncrypt: !1,
      direction: "sendrecv"
    }
  ]
};
var NC = Object.defineProperty, LC = Object.getOwnPropertyDescriptor, ia = (r, e, t, s) => {
  for (var i = s > 1 ? void 0 : s ? LC(e, t) : e, n = r.length - 1, a; n >= 0; n--)
    (a = r[n]) && (i = (s ? a(e, t, i) : a(i)) || i);
  return s && i && NC(e, t, i), i;
};
const ba = class {
  constructor(r, e, t, s, i, n, a, o, d, p, l, u, m, g) {
    h(this, "apiBase");
    h(this, "chatController");
    h(this, "metaController");
    h(this, "participantController");
    h(this, "pluginController");
    h(this, "pollController");
    h(this, "remoteController");
    h(this, "selfController");
    h(this, "recordingController");
    h(this, "spotlightController");
    h(this, "livestreamController");
    h(this, "internalsController");
    h(this, "stageController");
    h(this, "troubleshooterController");
    this.apiBase = r, this.metaController = e, this.selfController = t, this.pluginController = s, this.participantController = i, this.chatController = n, this.pollController = a, this.remoteController = o, this.recordingController = d, this.spotlightController = p, this.livestreamController = u, this.internalsController = l, this.stageController = m, this.troubleshooterController = g;
  }
  static async init(r, e) {
    var cd, dd, ld, ud, pd, hd, md, fd, gd, _d, vd, Td, yd;
    const {
      apiBase: t = "https://api.cluster.dyte.in",
      authToken: s
    } = r, i = {
      chat: !0,
      participant: !0,
      plugin: !0,
      poll: !0,
      self: !0,
      meta: !0,
      permissions: !0,
      theme: !0,
      spotlight: !0,
      tracing: !0,
      devTools: {
        logs: !1
      },
      internals: !0,
      stage: !0,
      ...r == null ? void 0 : r.modules
    };
    y.reset(), ST((cd = r.overrides) != null ? cd : {});
    const n = CR({ authToken: s, baseURL: t });
    n.setHeader("dyte-tracing-id", e), n.setPeerId(e), n.setRoomName(r.roomName);
    const { roomName: a } = r, o = te.isV2AuthToken ? te.meetingId : a, d = new Qu(), p = d.load({
      routerRtpCapabilities: OC
    }), l = n.getRoomNodeData({ roomName: o, peerId: e }), u = te.isV2AuthToken ? void 0 : n.getUserPreset(a), m = await n.getUserDetails(), g = te.isV2AuthToken ? m.participant.organizationId : m.organizationId;
    _.meetingMetadata.userId = te.isV2AuthToken ? m.participant.id : m.id, Qv({
      ...r,
      modules: i,
      apiBase: t,
      organizationId: g
    }), _.meetingMetadata.organizationId = g;
    const T = oC(o);
    await M.identify(
      `${Xo.PEER}_${e}`,
      JSON.parse(JSON.stringify({
        entity: Xo.PEER,
        clientId: g,
        isAnonUser: !g,
        sdkVersion: La,
        meetingHash: T,
        roomName: o,
        ...ae.getDeviceInfo()
      }))
    ), wP();
    const S = M.getValue(
      N.PLUGIN_SOCKET_SERVER
    ), R = n.getPlugins(S);
    f.info("flagsmith::allFlags", { flags: JSON.stringify(M.getAllFlags()) }, !0), Ol.init();
    let D = te.isV2AuthToken ? Ha.default() : xa.default(), I = te.isV2AuthToken ? Ba.default() : qa.default(), re = te.isV2AuthToken ? m.preset.name : void 0;
    if (i.permissions || i.theme) {
      const Tr = await u;
      Tr && (re = Tr.presetName), i.permissions && (D = te.isV2AuthToken ? Ha.fromResponse(
        m.preset.permissions
      ) : xa.fromResponse(
        Tr.permissions
      )), i.theme && (I = te.isV2AuthToken ? Ba.fromResponse(
        m.preset
      ) : qa.fromResponse(Tr.theme), te.isV2AuthToken || I.configFromPermissions(Tr.permissions));
    }
    const {
      roomNodeUrl: ge,
      meetingTitle: Me,
      useHiveMedia: pe
    } = await l;
    await p;
    const st = bp(
      I
    ), rt = M.hasFeature(N.CUSTOM_PING_PONG), gt = [];
    pe && gt.push("HIVE"), rt && gt.push("PING"), wT({
      ...r,
      roomName: o,
      peerId: e,
      meetingTitle: Me,
      roomNodeUrl: ge,
      device: d
    });
    const wt = await ba.createSocketServiceAndRoomNodeClient({
      ...r,
      roomName: o,
      peerId: e,
      meetingTitle: Me,
      roomNodeUrl: ge,
      capabilities: gt,
      shouldInitializeRoomNode: st,
      viewType: I.viewType,
      device: d
    }), Rt = Be();
    let Ct, $s, nn, na, Se, an, Q, L, ke, kt, ni, ys, Hs;
    const aa = new _r(wt), oa = new Eo(wt), Yp = new zP(wt), Zp = new _C(wt), Xp = new vC(wt);
    Ie.socketService = wt, (dd = i.self) == null || dd ? ([Se] = await Promise.all([sn.init(
      wt,
      m,
      D,
      I,
      re
    ), Rt instanceof fe ? Rt.setupTransports() : null]), n.setOrganizationId(Se.self.organizationId)) : Rt instanceof fe && await Rt.setupTransports();
    const eh = M.hasFeature(N.TROUBLESHOOTING);
    if (Se && eh && (Hs = new MC(Se.self)), (ld = i.participant) == null || ld) {
      if (!Se)
        throw new E("The participant module cannot be initialized without the `self` module");
      $s = new gr(
        Se.self
      );
    }
    if ((ud = i.chat) == null || ud) {
      if (!Se)
        throw new E("The chat module cannot be initialized without the `self` module");
      Ct = await ws.init(
        aa,
        Se.self,
        $s.participants,
        gt
      );
    }
    if ((pd = i.plugin) == null || pd) {
      if (!Se)
        throw new E("The plugin module cannot be initialized without the `self` module");
      if (!$s)
        throw new E("The plugin module cannot be initialized without the `participant` module");
      const Tr = await R;
      nn = await Dp.init(
        Tr,
        Yp,
        aa,
        Ct == null ? void 0 : Ct.chat,
        Se.self,
        $s.participants,
        gt
      );
    }
    if ((hd = i.poll) == null || hd) {
      if (!Se)
        throw new E("The poll cannot be initialized without the `self` module");
      na = await Ip.init(
        Se.self,
        oa,
        gt
      );
    }
    if ((md = i.meta) == null || md) {
      if (!Se)
        throw new E("The meta module cannot be initialized without the `self` module");
      an = new Cp(Se.self, wt, Me);
    }
    if ((fd = i.remoteControl) == null || fd) {
      if (!Se)
        throw new E("The remote controller cannot be initialized without the `self` module");
      Q = new _c(
        Se.self,
        $s.participants
      );
    }
    if ((gd = i.recording) == null || gd) {
      if (!Se)
        throw new E("The recording controller cannot be initialized without the `self` module");
      L = new qp(Se.self);
    }
    if ((_d = i.spotlight) == null || _d) {
      if (!Se)
        throw new E("The spotlight controller cannot be initialized without the `self` module");
      ke = new Wp(Se.self);
    }
    if (((vd = i.internals) == null || vd) && (ni = await id.init()), I.viewType === is.Livestream && ((Td = i.livestream) == null || Td)) {
      if (!Se)
        throw new E("The livestream controller cannot be initialized without the `self` module");
      M.hasFeature(N.LIVESTREAM) && (kt = new Kp(
        Se.self,
        Zp
      ));
    }
    if ((yd = i.stage) == null || yd) {
      if (!Se)
        throw new E("The stage client cannot be initialized without the `self` module");
      ys = new zp(
        Xp,
        qb(D),
        Se.self
      );
    }
    return new ba(
      t,
      an,
      Se,
      nn,
      $s,
      Ct,
      na,
      Q,
      L,
      ke,
      ni,
      kt,
      ys,
      Hs
    );
  }
  static async createSocketServiceAndRoomNodeClient(r) {
    const e = ba.createSocketService(r);
    if (!r.shouldInitializeRoomNode)
      return e;
    if (r.capabilities.includes("HIVE")) {
      const s = await e;
      return await ob(
        {
          ...r,
          roomName: r.roomName,
          peerId: r.peerId,
          socket: s
        }
      ), s;
    }
    return (await Promise.all([
      e,
      vp(
        {
          ...r,
          roomName: r.roomName,
          peerId: r.peerId
        }
      )
    ]))[0];
  }
  static async createSocketService(r) {
    var a;
    const {
      peerId: e,
      roomName: t,
      authToken: s,
      capabilities: i
    } = r, n = new ra({
      peerId: e,
      roomName: t,
      authToken: s,
      capabilities: i
    });
    if (cp(r.viewType, i) || ((a = r.overrides) == null ? void 0 : a.chat_socket_server) === "socket-service")
      try {
        await n.connect();
      } catch (o) {
        f.error("[Socket Service] Failed to connect to socket server:", { error: o });
      }
    return n;
  }
  async joinRoom() {
    return this.selfController.joinRoom();
  }
  async leaveRoom(r = "left") {
    return Ol.cleanup(), this.selfController.leaveRoom(r);
  }
};
let rn = ba;
ia([
  _.trace("Controller.joinRoom")
], rn.prototype, "joinRoom", 1);
ia([
  _.trace("Controller.leaveRoom")
], rn.prototype, "leaveRoom", 1);
ia([
  _.trace("Controller.init")
], rn, "init", 1);
ia([
  _.trace("Controller.createSocketServiceAndRoomNodeClient")
], rn, "createSocketServiceAndRoomNodeClient", 1);
ia([
  _.trace("Controller.createSocketService")
], rn, "createSocketService", 1);
var Gn;
class xC extends Ue {
  constructor(t) {
    super();
    b(this, Gn, void 0);
    h(this, "meetings", []);
    h(this, "parentMeeting", null);
    P(this, Gn, t.self);
  }
  get supportsConnectedMeetings() {
    return c(this, Gn).id !== "" && te.isV2AuthToken && M.hasFeature(N.CONNECTED_MEETINGS);
  }
  get isActive() {
    return this.meetings.length !== 0;
  }
  // eslint-disable-next-line class-methods-use-this
  get currentMeetingId() {
    return Ie.currentMeetingId;
  }
  validateConnectedMeetingsAction() {
    if (!this.supportsConnectedMeetings)
      throw new Error(`You are not allowed to perform this action.
            Please connect with Dyte team to move you to V2 APIs & to enable connected meetings.`);
  }
  /**
   * get connected meeting state
   */
  async getConnectedMeetings() {
    return this.validateConnectedMeetingsAction(), await Ie.getConnectedRoomsDump();
  }
  /**
   * create connected meetings
   */
  async createMeetings(t) {
    return this.validateConnectedMeetingsAction(), (await Ie.createConnectedRooms(t)).map((i) => ({
      id: i.id,
      title: i.title
    }));
  }
  /**
   * update meeting title
   */
  async updateMeetings(t) {
    this.validateConnectedMeetingsAction(), await Ie.updateConnectedRooms(
      t.map((s) => ({ meetingId: s.id, title: s.title }))
    );
  }
  /**
   * delete connected meetings
   */
  async deleteMeetings(t) {
    this.validateConnectedMeetingsAction();
    const s = this.meetings.map((n) => t.includes(n.id) && n.participants.length !== 0 ? this.moveParticipants(
      n.id,
      this.parentMeeting.id,
      n.participants.map((a) => a.id)
    ) : Promise.resolve());
    return await Promise.all(s), await Ie.disableConnectedRooms(t);
  }
  /**
   * Trigger event to move participants
   *
   * @param {string} sourceMeetingId - id of source meeting
   * @param {string} destinationMeetingId - id of destination meeting
   * @param {string[]} participantIds - list of id of the participants
   */
  async moveParticipants(t, s, i) {
    this.validateConnectedMeetingsAction();
    const n = /* @__PURE__ */ new Map();
    [
      ...this.parentMeeting.participants,
      ...this.meetings.flatMap((o) => o.participants)
    ].forEach((o) => n.set(
      o.id,
      o
    ));
    const a = await Ie.movePeersBetweenRooms({
      sourceMeetingId: t,
      destinationMeetingId: s,
      participants: i.map((o) => ({ id: o }))
    });
    return a.success && (s === this.parentMeeting.id && (this.parentMeeting.participants = this.parentMeeting.participants.concat(
      i.map((o) => n.get(o))
    )), t === this.parentMeeting.id && (this.parentMeeting.participants = this.parentMeeting.participants.filter(
      (o) => !i.includes(
        o.id
      )
    )), this.meetings = this.meetings.map((o) => {
      if (s === o.id) {
        const d = o.participants.concat(
          i.map((p) => n.get(p))
        );
        return {
          ...o,
          participants: d
        };
      }
      if (t === o.id) {
        const d = o.participants.filter(
          (p) => !i.includes(
            p.id
          )
        );
        return {
          ...o,
          participants: d
        };
      }
      return o;
    })), a;
  }
}
Gn = new WeakMap();
var UC = Object.defineProperty, VC = Object.getOwnPropertyDescriptor, od = (r, e, t, s) => {
  for (var i = s > 1 ? void 0 : s ? VC(e, t) : e, n = r.length - 1, a; n >= 0; n--)
    (a = r[n]) && (i = (s ? a(e, t, i) : a(i)) || i);
  return s && i && UC(e, t, i), i;
}, qr, Gi, qo;
const Ks = (qo = class {
  constructor(r, e) {
    h(this, "connectedMeetings");
    b(this, qr, void 0);
    b(this, Gi, void 0);
    P(this, qr, e), this.connectedMeetings = new xC(r), this.setCurrentMeeting(r);
  }
  static init(r, e) {
    return Ks.instance || (Ks.instance = new Ks(
      r,
      e
    )), Ks.instance.connectedMeetings.supportsConnectedMeetings && (Ks.instance.setupEvents(), r.self.once("roomJoined", () => Ks.instance.getConnectedMeetings())), Ks.instance;
  }
  setCurrentMeeting(r) {
    P(this, Gi, r), Ie.currentMeetingId = r.meta.roomName;
  }
  getConnectedMeetings() {
    this.connectedMeetings.getConnectedMeetings();
  }
  setupEvents() {
    Ie.socketService && (Ie.socketService.on(
      ce.getConnectedRoomsDump,
      this.handleConnectedRoomsDump.bind(this)
    ), Ie.socketService.on(
      ce.transferPeer,
      this.handleTransferPeer.bind(this)
    ), Ie.socketService.on(
      ce.movedPeer,
      this.handleMovedPeer.bind(this)
    ), Ie.socketService.on(
      ce.connectedRoomsUpdated,
      this.handleConnectedRoomsUpdated.bind(this)
    ), Ie.socketService.on(
      ce.connectedRoomsDeleted,
      this.handleConnectedRoomsDeleted.bind(this)
    ));
  }
  // event handlers
  handleTransferPeer(r) {
    const e = Ie.handleTransferPeerRaw(r);
    return this.switchMeeting(e);
  }
  async switchMeeting({ authToken: r, meetingId: e }) {
    if (!this.connectedMeetings.supportsConnectedMeetings)
      throw new Error(`You are not allowed to perform this action.
                Please connect with Dyte team to move you to V2 APIs & to enable connected meetings.`);
    this.connectedMeetings.emit("changingMeeting", e);
    const t = c(this, Gi).self.videoEnabled;
    await c(this, Gi).leaveRoom("connected-meeting"), Ie.socketService = void 0;
    const s = await BC.init({
      authToken: r,
      apiBase: c(this, qr).apiBase,
      defaults: {
        ...c(this, qr).defaults,
        video: t,
        audio: !1
      },
      modules: c(this, qr).modules
    });
    return this.connectedMeetings.emit("meetingChanged", s), this.setCurrentMeeting(s), s;
  }
  handleConnectedRoomsDump(r) {
    const e = Ie.handleConnectedRoomsDumpRaw(
      r
    );
    this.connectedMeetings.meetings = e.meetings.map((t) => ({
      id: t.id,
      title: t.title,
      participants: t.participants || []
    })), this.connectedMeetings.parentMeeting = {
      id: e.parentMeeting.id,
      title: e.parentMeeting.title,
      participants: e.parentMeeting.participants
    }, this.emitStateUpdate();
  }
  // eslint-disable-next-line class-methods-use-this
  handleMovedPeer(r) {
    return Ie.handleMovedPeerRaw(r);
  }
  handleConnectedRoomsUpdated(r) {
    const e = Ie.handleConnectedRoomsUpdatedRaw(r), t = /* @__PURE__ */ new Map();
    this.connectedMeetings.meetings.forEach((s) => {
      t.set(s.id, s);
    }), e.forEach((s) => {
      t.has(s.id) ? t.get(s.id).title = s.title : t.set(s.id, { ...s, participants: [] });
    }), this.connectedMeetings.meetings = Array.from(t.values()), this.emitStateUpdate();
  }
  handleConnectedRoomsDeleted(r) {
    const t = Ie.handleConnectedRoomsDeletedRaw(r).map((s) => s.id);
    this.connectedMeetings.meetings = this.connectedMeetings.meetings.filter(
      (s) => !t.includes(s.id)
    );
  }
  emitStateUpdate() {
    this.connectedMeetings.emit("stateUpdate", {
      meetings: this.connectedMeetings.meetings,
      parentMeeting: this.connectedMeetings.parentMeeting
    });
  }
}, qr = new WeakMap(), Gi = new WeakMap(), h(qo, "instance"), qo);
let So = Ks;
od([
  _.trace("ConnectedMeetingsController.getConnectedMeetings")
], So.prototype, "getConnectedMeetings", 1);
od([
  _.trace("ConnectedMeetingsController.setupEvents")
], So.prototype, "setupEvents", 1);
od([
  _.trace("ConnectedMeetingsController.switchMeeting")
], So.prototype, "switchMeeting", 1);
function FC(r) {
  return (e, t, s) => {
    const i = s.value, n = r ? Ia(i, r) : Ia(i);
    return s.value = (...a) => {
      if (n.cache && n.cache.has(r(...a))) {
        console.warn(`[Dyte] method "${t}" is called twice. This may result in inconsistent behaviors`);
        try {
          f.warn("Memoize::double_invoke", {
            memoize: {
              doubleInvoked: {
                property: t
              }
            }
          });
        } catch (o) {
        }
      }
      return n.apply(this, a);
    }, s;
  };
}
var jC = Object.defineProperty, $C = Object.getOwnPropertyDescriptor, wo = (r, e, t, s) => {
  for (var i = s > 1 ? void 0 : s ? $C(e, t) : e, n = r.length - 1, a; n >= 0; n--)
    (a = r[n]) && (i = (s ? a(e, t, i) : a(i)) || i);
  return s && i && jC(e, t, i), i;
};
const HC = (r) => {
  var e, t, s, i, n;
  return `${(e = r.roomName) != null ? e : ""}-${r.authToken}-${(t = r.apiBase) != null ? t : ""}-${JSON.stringify((s = r.defaults) != null ? s : {})}-${JSON.stringify(
    (i = r.modules) != null ? i : {}
  )}-${JSON.stringify((n = r.overrides) != null ? n : {})}`;
};
var et, Wn, to, Qp, Xl;
let Qr = (Xl = class {
  constructor(e) {
    /**
     * attach the singleton controller to meeting instances
     * +-----------------------------+
     * | ConnectedMeetingsController |
     * +------+--------------+-------+
     *        |              |
     *   +----v---+      +---v----+
     *   |meeting1|      |meeting2|
     *   +--------+      +--------+
     * */
    b(this, to);
    b(this, et, void 0);
    b(this, Wn, void 0);
    P(this, et, e);
  }
  static async init(e) {
    var n, a, o, d, p;
    ae.init();
    const t = so();
    try {
      (a = (n = e.modules) == null ? void 0 : n.tracing) == null || a || (window.__zone_symbol__DISABLE_WRAPPING_UNCAUGHT_PROMISE_REJECTION = !0, window.Zone === void 0 && require("zone.js"));
    } catch (l) {
    }
    _.init(t, (d = (o = e.modules) == null ? void 0 : o.tracing) != null ? d : !0), !navigator.isReactNative && typeof window != "undefined" && (window.addEventListener("error", (l) => {
      var u;
      !((u = l.filename) != null && u.includes("localhost")) && l.lineno !== 0 && f.error("window::error", {
        error: l.error
      }, !0);
    }), window.addEventListener("unhandledrejection", (l) => {
      var u, m, g, T, S, R, D, I;
      f.error("window::unhandledrejection", {
        error: l == null ? void 0 : l.reason,
        /**
         * NOTE(ravindra-dyte):
         * Network calls fail a lot for clients,
         *  tracking more info to see where
         *  */
        networkCall: {
          url: (m = (u = l == null ? void 0 : l.reason) == null ? void 0 : u.config) == null ? void 0 : m.url,
          baseURL: (T = (g = l == null ? void 0 : l.reason) == null ? void 0 : g.config) == null ? void 0 : T.baseURL,
          method: (R = (S = l == null ? void 0 : l.reason) == null ? void 0 : S.config) == null ? void 0 : R.method,
          status: (D = l == null ? void 0 : l.reason) == null ? void 0 : D.status,
          statusText: (I = l == null ? void 0 : l.reason) == null ? void 0 : I.statusText
        }
      }, !0);
    })), ET(e.authToken, e.roomName), _.meetingMetadata.roomName = te.isV2AuthToken ? te.meetingId : e.roomName;
    const s = await rn.init(e, t), i = new Qr(s);
    return ca(p = i, to, Qp).call(p, e), i;
  }
  async joinRoom() {
    return c(this, et).joinRoom();
  }
  async leaveRoom(e) {
    return c(this, et).leaveRoom(e);
  }
  /**
   * The `participants` object consists of 4 maps of participants,
   * `waitlisted`, `joined`, `active`, `pinned`. The maps are indexed by
   * `peerId`s, and the values are the corresponding participant objects.
   */
  get participants() {
    var e;
    return (e = c(this, et).participantController) == null ? void 0 : e.participants;
  }
  /**
   * The `self` object can be used to manipulate audio and video settings,
   * and other configurations for the local participant. This exposes methods
   * to enable and disable media tracks, share the user's screen, etc.
   */
  get self() {
    var e;
    return (e = c(this, et).selfController) == null ? void 0 : e.self;
  }
  /**
   * The `room` object stores information about the current meeting, such
   * as chat messages, polls, room name, etc.
   */
  get meta() {
    var e;
    return (e = c(this, et).metaController) == null ? void 0 : e.meta;
  }
  /**
   * The `plugins` object stores information about the plugins available in
   * the current meeting. It exposes methods to activate and deactivate them.
   */
  get plugins() {
    var e;
    return (e = c(this, et).pluginController) == null ? void 0 : e.plugins;
  }
  /**
   * The chat object stores the chat messages that were sent in the meeting.
   * This includes text messages, images, and files.
   */
  get chat() {
    var e;
    return (e = c(this, et).chatController) == null ? void 0 : e.chat;
  }
  /**
   * The polls object stores the polls that were initiated in the meeting.
   * It exposes methods to create and vote on polls.
   */
  get polls() {
    var e;
    return (e = c(this, et).pollController) == null ? void 0 : e.polls;
  }
  /**
   * The remote object stores the remote control requests for the meeting.
   * It exposes methods to request, accept and end the remote control.
   */
  get remote() {
    var e;
    return (e = c(this, et).remoteController) == null ? void 0 : e.remote;
  }
  /**
   * The connectedMeetings object stores the connected meetings states.
   * It exposes methods to create/read/update/delete methods for connected meetings.
   */
  get connectedMeetings() {
    var e;
    return (e = c(this, Wn)) == null ? void 0 : e.connectedMeetings;
  }
  /*
   * The recording object stores the recording state of the meeting.
   * It exposes methods to start and stop recording.
   */
  get recording() {
    var e;
    return (e = c(this, et).recordingController) == null ? void 0 : e.recording;
  }
  /*
   * The spotlight object hold current spotlight and tab status.
   * It enables tab syncing in this meeting.
   */
  get spotlight() {
    var e;
    return (e = c(this, et).spotlightController) == null ? void 0 : e.spotlight;
  }
  get livestream() {
    var e;
    return (e = c(this, et).livestreamController) == null ? void 0 : e.livestream;
  }
  get stage() {
    var e;
    return (e = c(this, et).stageController) == null ? void 0 : e.stage;
  }
  get troubleshoot() {
    var e;
    return (e = c(this, et).troubleshooterController) == null ? void 0 : e.troubleshooter;
  }
  /**
   * The __internals__ object exposes the internal tools & utilities such as features and logger
   * so that client can utilise the same to build their own feature based UI.
   * DyteLogger (__internals__.logger) can be used to send logs to Dyte's servers
   *  to inform Dyte of issues, if any, proactively.
   */
  get __internals__() {
    var e;
    return (e = c(this, et).internalsController) == null ? void 0 : e.internals;
  }
}, et = new WeakMap(), Wn = new WeakMap(), to = new WeakSet(), Qp = function(e) {
  P(this, Wn, So.init(this, e));
}, Xl);
wo([
  ft((r) => {
    throw new E(r.message, "0002");
  })
], Qr.prototype, "joinRoom", 1);
wo([
  ft((r) => {
    throw new E(r.message, "0003");
  })
], Qr.prototype, "leaveRoom", 1);
wo([
  ft((r) => {
    throw new E(r.message, "0001");
  }),
  FC(HC)
], Qr, "init", 1);
Qr = wo([
  ft((r) => {
    throw new E(r.message, "0000");
  })
], Qr);
const BC = Qr;
export {
  BC as default
};
